/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDate: { input: string; output: string; }
  AWSDateTime: { input: string; output: string; }
  AWSEmail: { input: string; output: string; }
  AWSJSON: { input: any; output: any; }
  AWSTimestamp: { input: number; output: number; }
};

export type A2PBrand = {
  __typename?: 'A2PBrand';
  ID: Scalars['ID']['output'];
  brandRelationship?: Maybe<Scalars['String']['output']>;
  companyCity?: Maybe<Scalars['String']['output']>;
  companyCountry?: Maybe<Scalars['String']['output']>;
  companyEmail?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyPhone?: Maybe<Scalars['String']['output']>;
  companyPostalCode?: Maybe<Scalars['String']['output']>;
  companyState?: Maybe<Scalars['String']['output']>;
  companyStreet?: Maybe<Scalars['String']['output']>;
  companyTaxId?: Maybe<Scalars['String']['output']>;
  externalID?: Maybe<Scalars['String']['output']>;
  vertical?: Maybe<Scalars['String']['output']>;
};

export type A2PCampaign = {
  __typename?: 'A2PCampaign';
  ID: Scalars['ID']['output'];
  brand?: Maybe<A2PBrand>;
  companyID: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  externalID?: Maybe<Scalars['String']['output']>;
  numbers?: Maybe<Array<Scalars['String']['output']>>;
  relatedIssueID?: Maybe<Scalars['ID']['output']>;
  updateMessage?: Maybe<Scalars['String']['output']>;
  updateStatus: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  useCase: Scalars['String']['output'];
  zendeskTicketUrl?: Maybe<Scalars['String']['output']>;
};

export type A2PForm = {
  __typename?: 'A2PForm';
  companyID: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['ID']['output'];
  formFields: Scalars['String']['output'];
  formID: Scalars['ID']['output'];
  formStatus: A2PFormStatus;
  formType: A2PFormType;
  updatedAt: Scalars['String']['output'];
  updatedBy: Scalars['ID']['output'];
  userID: Scalars['ID']['output'];
  zendeskTicketUrl?: Maybe<Scalars['String']['output']>;
};

export enum A2PFormStatus {
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED'
}

export enum A2PFormType {
  AMENDMENT = 'AMENDMENT',
  REGISTRATION = 'REGISTRATION'
}

export type A2PUrlEvidenceOutput = {
  __typename?: 'A2PUrlEvidenceOutput';
  issues: Array<A2PValidationIssue>;
  runId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type A2PValidationIssue = {
  __typename?: 'A2PValidationIssue';
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
  severity: Scalars['String']['output'];
  source: Scalars['String']['output'];
  suggestionSuggestedValue?: Maybe<Scalars['String']['output']>;
};

export type AiAction = {
  __typename?: 'AIAction';
  instructions?: Maybe<Scalars['String']['output']>;
  mcpTools: Array<McpTool>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum AiActionErrorCategory {
  API_ERROR = 'API_ERROR',
  AUTH = 'AUTH',
  NO_DATA = 'NO_DATA',
  TIMEOUT = 'TIMEOUT',
  UNKNOWN = 'UNKNOWN'
}

export type AiActionInput = {
  instructions?: InputMaybe<Scalars['String']['input']>;
  mcpTools: Array<McpToolInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum AiActionStatus {
  FAILURE = 'FAILURE',
  SUCCESS = 'SUCCESS'
}

export type AiAnswerGeneratedCategoryOutput = {
  __typename?: 'AIAnswerGeneratedCategoryOutput';
  categoryId: Scalars['ID']['output'];
  questions: Array<AiAnswerGeneratedQuestionOutput>;
};

export type AiAnswerGeneratedError = {
  __typename?: 'AIAnswerGeneratedError';
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AiAnswerGeneratedQuestionOutput = {
  __typename?: 'AIAnswerGeneratedQuestionOutput';
  binaryAnswer?: Maybe<BinaryAnswerValue>;
  feedback: Scalars['String']['output'];
  questionId: Scalars['ID']['output'];
  questionType: QuestionType;
  ratingAnswer?: Maybe<RatingAnswerValue>;
};

export type AiAnswersGeneratedOutput = {
  __typename?: 'AIAnswersGeneratedOutput';
  data?: Maybe<AiAnswersGeneratedOutputData>;
  error?: Maybe<AiAnswerGeneratedError>;
  transcriptionId: Scalars['ID']['output'];
};

export type AiAnswersGeneratedOutputData = {
  __typename?: 'AIAnswersGeneratedOutputData';
  callId: Scalars['ID']['output'];
  categories: Array<AiAnswerGeneratedCategoryOutput>;
};

export type Account = {
  __typename?: 'Account';
  balance?: Maybe<Scalars['Int']['output']>;
  becameDelinquentAt?: Maybe<Scalars['String']['output']>;
  debitDay?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isDelinquent?: Maybe<Scalars['Boolean']['output']>;
  paymentAttempts?: Maybe<Array<Maybe<PaymentAttempts>>>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  processoutCustomerId?: Maybe<Scalars['String']['output']>;
};

export type AcknowledgeLineConversationResult = GenericException | ReadCurrentUserConversationsResult;

export type AcknowledgeLineConversationsByIdsResult = GenericException | ReadCurrentUserConversationsByIdsResult;

export type Action = {
  __typename?: 'Action';
  ID: Scalars['ID']['output'];
  agentId: Scalars['ID']['output'];
  authMethodId?: Maybe<Scalars['ID']['output']>;
  bodyTemplate?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  dataInputs?: Maybe<Array<DataInput>>;
  dataOutputs?: Maybe<Array<DataOutput>>;
  description?: Maybe<Scalars['String']['output']>;
  headers?: Maybe<Array<ActionHeader>>;
  method: ActionMethod;
  name: Scalars['String']['output'];
  noOp?: Maybe<Scalars['Boolean']['output']>;
  onFailureInstruction?: Maybe<Scalars['String']['output']>;
  onSuccessInstruction?: Maybe<Scalars['String']['output']>;
  prerequisiteAction?: Maybe<Scalars['ID']['output']>;
  runOnConnect?: Maybe<Scalars['Boolean']['output']>;
  staticResponse?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  url: Scalars['String']['output'];
  urlTemplate?: Maybe<Scalars['String']['output']>;
  useRawBody?: Maybe<Scalars['Boolean']['output']>;
  waitForAudioDrain?: Maybe<Scalars['Boolean']['output']>;
};

export type ActionHeader = {
  __typename?: 'ActionHeader';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ActionHeaderInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum ActionMethod {
  DELETE = 'DELETE',
  GET = 'GET',
  PATCH = 'PATCH',
  POST = 'POST',
  PUT = 'PUT'
}

export type ActionOutput = Action | GenericException | ResourceNotFoundException | UserInputException;

export type ActionPreview = {
  __typename?: 'ActionPreview';
  actionName: Scalars['String']['output'];
  bodyTemplate?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expectedOutput?: Maybe<Scalars['String']['output']>;
  functionName: Scalars['String']['output'];
  jsonBody?: Maybe<Scalars['String']['output']>;
  jsonBodyExample?: Maybe<Scalars['String']['output']>;
  parameters: Array<ActionPreviewParameter>;
  sampleInvocation?: Maybe<Scalars['String']['output']>;
};

export type ActionPreviewOutput = ActionPreview | GenericException | ResourceNotFoundException;

export type ActionPreviewParameter = {
  __typename?: 'ActionPreviewParameter';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type ActionsPaginatedOutput = {
  __typename?: 'ActionsPaginatedOutput';
  items: Array<Action>;
  pageInfo?: Maybe<SmartflowsPageInfo>;
};

export type ActivateAiAssistInput = {
  companySettings: Array<ActivationCompanySettingInput>;
  lineSettings: Array<ActivationLineSettingInput>;
};

export type ActivateAiAssistOutput = ActivateAiAssistResult | ActivationCapabilityDisabled | ActivationForbidden | ActivationRequestException | ActivationUnauthenticated | GenericException | UserInputException;

export type ActivateAiAssistResult = {
  __typename?: 'ActivateAiAssistResult';
  companyId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  outcomes: Array<ActivationItemOutcome>;
};

export enum ActivationAddonStatus {
  ACTIVATED = 'ACTIVATED',
  INACTIVE = 'INACTIVE',
  PROVISIONING = 'PROVISIONING',
  TRIAL = 'TRIAL',
  UNAVAILABLE = 'UNAVAILABLE'
}

export type ActivationCapabilityDisabled = Exception & {
  __typename?: 'ActivationCapabilityDisabled';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum ActivationCommunicationLanguageSource {
  INFERRED = 'INFERRED',
  REQUESTED = 'REQUESTED'
}

export type ActivationCompanyContext = {
  __typename?: 'ActivationCompanyContext';
  communicationLanguage: Scalars['String']['output'];
  communicationLanguageSource: ActivationCommunicationLanguageSource;
  companyId: Scalars['ID']['output'];
  companyName: Scalars['String']['output'];
  competitors?: Maybe<Array<Scalars['String']['output']>>;
  description: Scalars['String']['output'];
  domainKeywords: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  productNames: Array<Scalars['String']['output']>;
  suggestedVocabulary: Array<Scalars['String']['output']>;
  vertical?: Maybe<Scalars['String']['output']>;
  websiteUrl: Scalars['String']['output'];
};

export type ActivationCompanyContextInput = {
  communicationLanguage?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  competitors?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  domainKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  productNames?: InputMaybe<Array<Scalars['String']['input']>>;
  suggestedVocabulary?: InputMaybe<Array<Scalars['String']['input']>>;
  vertical?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ActivationCompanyContextNotGenerated = {
  __typename?: 'ActivationCompanyContextNotGenerated';
  companyId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type ActivationCompanyContextNotReady = {
  __typename?: 'ActivationCompanyContextNotReady';
  code: Scalars['String']['output'];
  companyId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type ActivationCompanyContextOutput = ActivationCapabilityDisabled | ActivationCompanyContext | ActivationCompanyContextNotGenerated | ActivationCompanyContextNotReady | ActivationForbidden | ActivationRequestException | ActivationUnauthenticated | GenericException;

export enum ActivationCompanyFeature {
  CONTACT_INSIGHTS = 'CONTACT_INSIGHTS'
}

export type ActivationCompanySettingInput = {
  enabled: Scalars['Boolean']['input'];
  feature: ActivationCompanyFeature;
};

export enum ActivationCompletionStatus {
  BLOCKED = 'BLOCKED',
  COMPLETE = 'COMPLETE',
  INCOMPLETE = 'INCOMPLETE',
  UNAVAILABLE = 'UNAVAILABLE'
}

export type ActivationCurrentSettingsOutput = ActivationCapabilityDisabled | ActivationCurrentSettingsResult | ActivationForbidden | ActivationRequestException | ActivationUnauthenticated | GenericException;

export type ActivationCurrentSettingsResult = {
  __typename?: 'ActivationCurrentSettingsResult';
  companyId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  lines: Array<ActivationLineCurrentSettings>;
  unavailableFeatures: Array<ActivationLineFeature>;
};

export type ActivationEligibleLine = {
  __typename?: 'ActivationEligibleLine';
  eligibility: ActivationLineEligibility;
  id: Scalars['ID']['output'];
  lineId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  reason: ActivationReadinessReasonCode;
  users: Array<ActivationLineUser>;
};

export type ActivationEligibleLinesOutput = ActivationCapabilityDisabled | ActivationEligibleLinesResult | ActivationForbidden | ActivationRequestException | ActivationUnauthenticated | GenericException;

export type ActivationEligibleLinesResult = {
  __typename?: 'ActivationEligibleLinesResult';
  addonStatus: ActivationAddonStatus;
  companyId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  lines: Array<ActivationEligibleLine>;
  reasons: Array<ActivationReadinessReason>;
  sources: ActivationReadinessSources;
};

export enum ActivationFeature {
  CONTACT_INSIGHTS = 'CONTACT_INSIGHTS',
  RECORDING = 'RECORDING',
  TRANSCRIPTION = 'TRANSCRIPTION'
}

export type ActivationForbidden = Exception & {
  __typename?: 'ActivationForbidden';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum ActivationItemErrorCode {
  CAPABILITY_DISABLED = 'CAPABILITY_DISABLED',
  DEPENDENCY_UNAVAILABLE = 'DEPENDENCY_UNAVAILABLE',
  TRANSIENT_DEPENDENCY_FAILURE = 'TRANSIENT_DEPENDENCY_FAILURE'
}

export type ActivationItemOutcome = {
  __typename?: 'ActivationItemOutcome';
  code?: Maybe<ActivationItemErrorCode>;
  feature: ActivationFeature;
  id: Scalars['ID']['output'];
  lineId?: Maybe<Scalars['ID']['output']>;
  status: ActivationItemStatus;
};

export enum ActivationItemStatus {
  APPLIED = 'APPLIED',
  PERMANENT_ERROR = 'PERMANENT_ERROR',
  SKIPPED = 'SKIPPED',
  TRANSIENT_ERROR = 'TRANSIENT_ERROR',
  UNSUPPORTED = 'UNSUPPORTED'
}

export type ActivationLicenseAssignmentOutcome = {
  __typename?: 'ActivationLicenseAssignmentOutcome';
  id: Scalars['ID']['output'];
  status: ActivationLicenseAssignmentStatus;
  userId: Scalars['ID']['output'];
};

export enum ActivationLicenseAssignmentStatus {
  ALREADY_ASSIGNED = 'ALREADY_ASSIGNED',
  ASSIGNED = 'ASSIGNED',
  FAILED = 'FAILED',
  UNASSIGNED = 'UNASSIGNED'
}

export enum ActivationLicenseState {
  ASSIGNABLE = 'ASSIGNABLE',
  ASSIGNED = 'ASSIGNED',
  NOT_APPLICABLE = 'NOT_APPLICABLE'
}

export type ActivationLicenseUser = {
  __typename?: 'ActivationLicenseUser';
  id: Scalars['ID']['output'];
  licenseState: ActivationLicenseState;
  name: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type ActivationLicensesNotApplicable = {
  __typename?: 'ActivationLicensesNotApplicable';
  companyId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type ActivationLicensesNotEntitled = {
  __typename?: 'ActivationLicensesNotEntitled';
  addonStatus: ActivationAddonStatus;
  companyId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type ActivationLineCurrentSettings = {
  __typename?: 'ActivationLineCurrentSettings';
  id: Scalars['ID']['output'];
  lineId: Scalars['ID']['output'];
  settings: Array<ActivationLineFeatureSetting>;
};

export enum ActivationLineEligibility {
  ELIGIBLE = 'ELIGIBLE',
  EXCLUDED = 'EXCLUDED'
}

export enum ActivationLineFeature {
  RECORDING = 'RECORDING',
  TRANSCRIPTION = 'TRANSCRIPTION'
}

export type ActivationLineFeatureSetting = {
  __typename?: 'ActivationLineFeatureSetting';
  availability: ActivationSourceAvailability;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  feature: ActivationLineFeature;
  language?: Maybe<Scalars['String']['output']>;
};

export type ActivationLineSettingInput = {
  enabled: Scalars['Boolean']['input'];
  feature: ActivationLineFeature;
  language?: InputMaybe<Scalars['String']['input']>;
  lineId: Scalars['ID']['input'];
};

export type ActivationLineUser = {
  __typename?: 'ActivationLineUser';
  id: Scalars['ID']['output'];
  licenseState: ActivationLineUserLicenseState;
  name: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export enum ActivationLineUserLicenseState {
  LICENSED = 'LICENSED',
  UNKNOWN = 'UNKNOWN',
  UNLICENSED = 'UNLICENSED'
}

export enum ActivationOverrideSetting {
  RECORDING = 'RECORDING',
  TRANSCRIPTION = 'TRANSCRIPTION',
  TRANSCRIPTION_LANGUAGE = 'TRANSCRIPTION_LANGUAGE'
}

export type ActivationOverrideWarning = {
  __typename?: 'ActivationOverrideWarning';
  comparison: ActivationSourceAvailability;
  currentEnabled?: Maybe<Scalars['Boolean']['output']>;
  currentLanguage?: Maybe<Scalars['String']['output']>;
  lineId: Scalars['ID']['output'];
  proposedEnabled?: Maybe<Scalars['Boolean']['output']>;
  proposedLanguage?: Maybe<Scalars['String']['output']>;
  setting: ActivationOverrideSetting;
};

export type ActivationReadinessInput = {
  proposedLineSettings?: InputMaybe<Array<ActivationLineSettingInput>>;
};

export type ActivationReadinessOutput = ActivationCapabilityDisabled | ActivationForbidden | ActivationReadinessResult | ActivationRequestException | ActivationUnauthenticated | GenericException | UserInputException;

export type ActivationReadinessReason = {
  __typename?: 'ActivationReadinessReason';
  code: ActivationReadinessReasonCode;
  lineId?: Maybe<Scalars['ID']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum ActivationReadinessReasonCode {
  LICENSED_USER_ASSOCIATED = 'LICENSED_USER_ASSOCIATED',
  LICENSE_SOURCE_UNAVAILABLE = 'LICENSE_SOURCE_UNAVAILABLE',
  LINE_HAS_NO_ASSOCIATED_USER = 'LINE_HAS_NO_ASSOCIATED_USER',
  LINE_HAS_NO_LICENSED_USER = 'LINE_HAS_NO_LICENSED_USER',
  LINE_SETTINGS_SOURCE_UNAVAILABLE = 'LINE_SETTINGS_SOURCE_UNAVAILABLE',
  NO_ELIGIBLE_LINE = 'NO_ELIGIBLE_LINE',
  TRIAL_COMPANY_INCLUDES_ALL_LINES = 'TRIAL_COMPANY_INCLUDES_ALL_LINES',
  UNLICENSED_USER_SELECTED = 'UNLICENSED_USER_SELECTED'
}

export type ActivationReadinessResult = {
  __typename?: 'ActivationReadinessResult';
  addonStatus: ActivationAddonStatus;
  companyId: Scalars['ID']['output'];
  overrideWarnings: Array<ActivationOverrideWarning>;
  sources: ActivationReadinessSources;
  stepThreeStatus: ActivationCompletionStatus;
  topics: Array<ActivationTopicReadiness>;
};

export type ActivationReadinessSources = {
  __typename?: 'ActivationReadinessSources';
  addon: ActivationSourceAvailability;
  licenses?: Maybe<ActivationSourceAvailability>;
  lineInventory: ActivationSourceAvailability;
};

export enum ActivationReadinessTopic {
  LICENSES = 'LICENSES',
  LINE_SETTINGS = 'LINE_SETTINGS'
}

export type ActivationRequestException = Exception & {
  __typename?: 'ActivationRequestException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum ActivationSourceAvailability {
  AVAILABLE = 'AVAILABLE',
  UNAVAILABLE = 'UNAVAILABLE'
}

export type ActivationTopicCompletion = {
  __typename?: 'ActivationTopicCompletion';
  status: ActivationTopicCompletionStatus;
  topic: ActivationWizardStep;
};

export enum ActivationTopicCompletionStatus {
  BLOCKED = 'BLOCKED',
  COMPLETE = 'COMPLETE',
  INCOMPLETE = 'INCOMPLETE',
  UNAVAILABLE = 'UNAVAILABLE'
}

export type ActivationTopicReadiness = {
  __typename?: 'ActivationTopicReadiness';
  reasons: Array<ActivationReadinessReason>;
  status: ActivationCompletionStatus;
  topic: ActivationReadinessTopic;
};

export type ActivationUnauthenticated = Exception & {
  __typename?: 'ActivationUnauthenticated';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ActivationUsersAndLicensesOutput = ActivationCapabilityDisabled | ActivationForbidden | ActivationLicensesNotEntitled | ActivationRequestException | ActivationUnauthenticated | ActivationUsersAndLicensesResult | GenericException;

export type ActivationUsersAndLicensesResult = {
  __typename?: 'ActivationUsersAndLicensesResult';
  addonStatus: ActivationAddonStatus;
  companyId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  users: Array<ActivationLicenseUser>;
};

export type ActivationWizardInvalidTransition = Exception & {
  __typename?: 'ActivationWizardInvalidTransition';
  code: Scalars['String']['output'];
  currentStep: ActivationWizardStep;
  message: Scalars['String']['output'];
  requestedStep: ActivationWizardStep;
};

export enum ActivationWizardLifecycleStatus {
  COMPLETED = 'COMPLETED',
  INACTIVE = 'INACTIVE',
  IN_PROGRESS = 'IN_PROGRESS'
}

export type ActivationWizardLockConflict = Exception & {
  __typename?: 'ActivationWizardLockConflict';
  code: Scalars['String']['output'];
  heldByUserId: Scalars['ID']['output'];
  heldUntil: Scalars['AWSDateTime']['output'];
  lastModifiedAt: Scalars['AWSDateTime']['output'];
  message: Scalars['String']['output'];
};

export type ActivationWizardState = {
  __typename?: 'ActivationWizardState';
  companyId: Scalars['ID']['output'];
  currentStep: ActivationWizardStep;
  expiresAt?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt: Scalars['AWSDateTime']['output'];
  lastModifiedBy: Scalars['ID']['output'];
  lockOwnerUserId?: Maybe<Scalars['ID']['output']>;
  status: ActivationWizardLifecycleStatus;
};

export enum ActivationWizardStep {
  ACTIVATION = 'ACTIVATION',
  COMPANY_CONTEXT = 'COMPANY_CONTEXT',
  LICENSES = 'LICENSES',
  LINE_SETTINGS = 'LINE_SETTINGS'
}

export type ActiveChatSession = {
  __typename?: 'ActiveChatSession';
  agentId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  expiresAt: Scalars['String']['output'];
  sessionId: Scalars['ID']['output'];
};

export type ActiveDraftStatus = {
  __typename?: 'ActiveDraftStatus';
  agentId: Scalars['ID']['output'];
  draft?: Maybe<DraftSummary>;
  hasDraft: Scalars['Boolean']['output'];
};

export type ActiveDraftStatusList = {
  __typename?: 'ActiveDraftStatusList';
  items: Array<ActiveDraftStatus>;
};

export type ActiveReverificationCampaignsResponse = {
  __typename?: 'ActiveReverificationCampaignsResponse';
  campaigns: Array<ReverificationCampaign>;
};

export type ActiveSessionContext = {
  __typename?: 'ActiveSessionContext';
  activeCommitments: Array<Scalars['String']['output']>;
  coachingMode: CoachingMode;
  dataSufficiency: DataSufficiency;
  evaluationCount: Scalars['Int']['output'];
  evidenceUsed: Array<EvidenceRef>;
  focusArea?: Maybe<FocusArea>;
  promptVersion: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type ActiveSessionInsights = {
  __typename?: 'ActiveSessionInsights';
  suggestedPrompts: Array<Scalars['String']['output']>;
  weakSkills: Array<WeakSkill>;
};

export type ActiveSubscription = {
  __typename?: 'ActiveSubscription';
  billingPeriodEndsAt: Scalars['String']['output'];
  billingPeriodStartsAt: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  nextInvoiceAt: Scalars['String']['output'];
  paidNumbersCount: Scalars['Int']['output'];
  paidUsersCount: Scalars['Int']['output'];
  plan: Scalars['String']['output'];
  pricePerExtraNumber: Scalars['Int']['output'];
  pricePerExtraUser: Scalars['Int']['output'];
  recurrence: Scalars['String']['output'];
  renewAtPeriodEnd: Scalars['Boolean']['output'];
  updatedAt: Scalars['String']['output'];
};

export type AddBlacklistedNumberMutationInput = {
  blacklistedPhoneNumber: BlacklistedNumberInput;
};

export type AddBridgeIntegrationResponse = {
  __typename?: 'AddBridgeIntegrationResponse';
  id?: Maybe<Scalars['Int']['output']>;
};

export type AddCompanyAcknowledgmentInput = {
  alpha2: Scalars['String']['input'];
  source: CompanyAcknowledgmentSource;
};

export type AddCompanyAcknowledgmentResponse = {
  __typename?: 'AddCompanyAcknowledgmentResponse';
  acknowledgedAt: Scalars['String']['output'];
  acknowledgedBy: Scalars['Int']['output'];
  alpha2: Scalars['String']['output'];
  carrier: Scalars['String']['output'];
  companyId: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  source: CompanyAcknowledgmentSource;
};

export type AddDialerCampaignNumbersErrors = {
  __typename?: 'AddDialerCampaignNumbersErrors';
  duplicate: Array<Scalars['String']['output']>;
  invalid: Array<Scalars['String']['output']>;
};

export type AddDialerCampaignNumbersInput = {
  phoneNumbers: Array<Scalars['String']['input']>;
  skipPhoneFormatValidation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddDialerCampaignNumbersResult = {
  __typename?: 'AddDialerCampaignNumbersResult';
  errors: AddDialerCampaignNumbersErrors;
  success: Array<Scalars['String']['output']>;
};

export type AddHubIntegrationResponse = {
  __typename?: 'AddHubIntegrationResponse';
  integrationId?: Maybe<Scalars['Int']['output']>;
};

export type AddIvrSettingInput = {
  ivrSettingkey: Scalars['String']['input'];
  numberId: Scalars['String']['input'];
  redirectingExternalNumber: Scalars['String']['input'];
  redirectingNumberId?: InputMaybe<Scalars['String']['input']>;
};

export type AddKeywordInput = {
  languages: Array<Scalars['String']['input']>;
  pronunciationHint?: InputMaybe<Scalars['String']['input']>;
  term: Scalars['String']['input'];
  vocabularyId: Scalars['ID']['input'];
};

export type AddKeywordsInput = {
  keywords: Array<AddKeywordInput>;
};

export type AddKeywordsOutput = AddedKeywords | GenericException | ResourceNotFoundException | UserInputException;

export type AddKnowledgeDocumentInput = {
  client: KnowledgeClientInput;
  content?: InputMaybe<Scalars['String']['input']>;
  crawlDepth?: InputMaybe<Scalars['Int']['input']>;
  docType: DocumentType;
  title: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type AddKnowledgeDocumentResult = GenericException | KnowledgeDocument | UserInputException;

export type AddMessageInput = {
  ID: Scalars['ID']['input'];
  agentID?: InputMaybe<Scalars['ID']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  companyID: Scalars['ID']['input'];
  conversationID: Scalars['ID']['input'];
  createdAt: Scalars['String']['input'];
  direction: MessageDirection;
  groupConversationId?: InputMaybe<Scalars['ID']['input']>;
  hasUnsupportedContent?: InputMaybe<Scalars['Boolean']['input']>;
  isMessagingAiActive?: InputMaybe<Scalars['Boolean']['input']>;
  lineID: Scalars['ID']['input'];
  mediaDetails?: InputMaybe<Array<MediaDetailsInput>>;
  status: MessageStatus;
  text: Scalars['String']['input'];
  whatsAppCustomerServiceWindowClosingTime?: InputMaybe<Scalars['String']['input']>;
};

export type AddMessageOutput = {
  __typename?: 'AddMessageOutput';
  error?: Maybe<Error>;
  lineID?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Message>;
};

export type AddMonitoredNumbersInput = {
  numbers: Array<BusinessDraftNumberInput>;
};

export type AddMonitoredNumbersResult = AddMonitoredNumbersSuccess | GenericException | NumberReputationException;

export type AddMonitoredNumbersSuccess = {
  __typename?: 'AddMonitoredNumbersSuccess';
  numbers: Array<MonitoredNumber>;
};

export type AddNextActionInput = {
  callId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
};

export type AddNumberIntegrationInput = {
  integrationIds: Array<Scalars['String']['input']>;
};

export type AddNumberToIntegrationInput = {
  integrationIds: Array<Scalars['String']['input']>;
};

export type AddNumberToIntegrationOutput = {
  __typename?: 'AddNumberToIntegrationOutput';
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type AddOutboundCallerData = {
  __typename?: 'AddOutboundCallerData';
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AddOutboundCallerMutationInput = {
  data: AddOutboundCallerMutationInputData;
};

export type AddOutboundCallerMutationInputData = {
  relationships: AddOutboundCallerMutationInputRelationships;
  type: Scalars['String']['input'];
};

export type AddOutboundCallerMutationInputRelationship = {
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type AddOutboundCallerMutationInputRelationships = {
  user: AddOutboundCallerMutationInputUser;
};

export type AddOutboundCallerMutationInputUser = {
  data: AddOutboundCallerMutationInputRelationship;
};

export type AddOutboundCallerMutationResponse = {
  __typename?: 'AddOutboundCallerMutationResponse';
  data: AddOutboundCallerData;
};

export type AddOutboundCampaignCallOutcomeInput = {
  callID: Scalars['ID']['input'];
  isFinal?: InputMaybe<Scalars['Boolean']['input']>;
  outcomeID?: InputMaybe<Scalars['ID']['input']>;
  predefinedOutcome?: InputMaybe<OutboundCampaignPredefinedCallOutcomeCode>;
};

export type AddOutboundCampaignCallOutcomeOutput = GenericException | OutboundCampaignCallOutcome | ResourceNotFoundException | UnprocessableResourceException | UserInputException;

export type AddOutboundCampaignContactsInput = {
  contactImportID: Scalars['ID']['input'];
  insertionPoint: OutboundCampaignContactInsertionPoint;
};

export type AddOutboundCampaignContactsOutput = GenericException | OutboundCampaignBackgroundJob | OutboundCampaignNotReadyException | ResourceNotFoundException;

export type AddOutboundCampaignQueueItemInput = {
  campaignID: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
  scheduledAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type AddOutboundCampaignQueueItemOutput = GenericException | OutboundCampaignQueueItem | ResourceNotFoundException | UserInputException;

export type AddPaymentCardInput = {
  cardId: Scalars['String']['input'];
};

export type AddWebDispatchGroupDispatchable = {
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type AddWebDispatchGroupInput = {
  dispatchable: AddWebDispatchGroupDispatchable;
  numberId: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
};

export type AddedKeyword = {
  __typename?: 'AddedKeyword';
  id: Scalars['ID']['output'];
};

export type AddedKeywords = {
  __typename?: 'AddedKeywords';
  items: Array<Maybe<AddedKeyword>>;
};

export type AdditionalCost = {
  __typename?: 'AdditionalCost';
  complianceRecoveryFee: CurrencyUsd;
  emergencyRecoveryFee: CurrencyUsd;
};

export type AdditionalCostType = {
  __typename?: 'AdditionalCostType';
  ca: AdditionalCost;
  us: AdditionalCost;
};

export type AdditionalInfo = {
  __typename?: 'AdditionalInfo';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Address = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  line: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type AddressOutput = {
  __typename?: 'AddressOutput';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  editableFields: Array<Scalars['String']['output']>;
  line?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export enum AdherenceTimeGranularity {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK'
}

export enum AdminOauthGrantStatus {
  GRANTED = 'GRANTED',
  NEEDS_RECONSENT = 'NEEDS_RECONSENT',
  NOT_GRANTED = 'NOT_GRANTED',
  REVOKED = 'REVOKED'
}

export type AdminOauthGrantStatusResult = {
  __typename?: 'AdminOauthGrantStatusResult';
  grantKind?: Maybe<Scalars['String']['output']>;
  grantedAt?: Maybe<Scalars['String']['output']>;
  status: AdminOauthGrantStatus;
  tokenExpiresAt?: Maybe<Scalars['String']['output']>;
};

export type AdminOauthGrantUrl = {
  __typename?: 'AdminOauthGrantUrl';
  authorizationUrl: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type AffectedAgent = {
  __typename?: 'AffectedAgent';
  dependencyType: AgentDependencyType;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Agent = {
  __typename?: 'Agent';
  ID: Scalars['ID']['output'];
  authorizedEntities: Array<AuthorizedEntity>;
  businessHours: BusinessHours;
  companyID: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  extension?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isAvailable: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  pictureURL?: Maybe<Scalars['String']['output']>;
  role: AgentRole;
  roles: Array<Role>;
  unconfirmedEmail?: Maybe<Scalars['String']['output']>;
};

export type AgentAddedToLineNotificationInput = {
  agentsAdded: Array<Scalars['ID']['input']>;
  line: Scalars['String']['input'];
  timestamp: Scalars['AWSDateTime']['input'];
};

export type AgentAddedToLineNotificationOutput = {
  __typename?: 'AgentAddedToLineNotificationOutput';
  agentsAdded: Array<Scalars['ID']['output']>;
  line: Line;
  timestamp: Scalars['AWSDateTime']['output'];
};

export type AgentAggregation = {
  __typename?: 'AgentAggregation';
  agent?: Maybe<AgentDetails>;
  agentId: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  duration?: Maybe<DurationAggregation>;
  sentiments?: Maybe<SentimentsAggregation>;
  teammate: PhoneTeammateResolver;
};

export enum AgentArchetype {
  DEVELOPING_AGENT = 'DEVELOPING_AGENT',
  DRIFTING_FROM_GOAL = 'DRIFTING_FROM_GOAL',
  HANDING_OFF_EARLY = 'HANDING_OFF_EARLY',
  NEEDS_IMMEDIATE_ATTENTION = 'NEEDS_IMMEDIATE_ATTENTION',
  QUALIFIER = 'QUALIFIER',
  ROUTER_NEEDS_TUNING = 'ROUTER_NEEDS_TUNING',
  SELF_CONTAINED_AGENT = 'SELF_CONTAINED_AGENT',
  SELF_SERVICE_CHAMPION = 'SELF_SERVICE_CHAMPION',
  SMART_ROUTER = 'SMART_ROUTER',
  SOLID_PERFORMER = 'SOLID_PERFORMER',
  UNCATEGORIZED = 'UNCATEGORIZED'
}

export enum AgentBuildCoverage {
  MODERATE = 'MODERATE',
  STRONG = 'STRONG',
  THIN = 'THIN'
}

export type AgentBuildProgress = {
  __typename?: 'AgentBuildProgress';
  buildId?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['String']['output']>;
  coverage?: Maybe<AgentBuildCoverage>;
  error?: Maybe<Scalars['String']['output']>;
  inScopeDone: Scalars['Int']['output'];
  progressDone: Scalars['Int']['output'];
  progressTotal: Scalars['Int']['output'];
  stage: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['String']['output']>;
  status: AgentBuildStatus;
  suggestedPrompts: Array<Scalars['String']['output']>;
  virtualAgentID: Scalars['ID']['output'];
};

export type AgentBuildProgressOutput = AgentBuildProgress | GenericException | ResourceNotFoundException;

export enum AgentBuildStatus {
  CLASSIFYING = 'CLASSIFYING',
  FAILED = 'FAILED',
  FETCHING = 'FETCHING',
  NO_EVIDENCE = 'NO_EVIDENCE',
  PENDING = 'PENDING',
  READY = 'READY',
  SYNTHESIZING = 'SYNTHESIZING'
}

export type AgentConfiguration = {
  __typename?: 'AgentConfiguration';
  agent?: Maybe<PhoneTeammateResolver>;
  agentId: Scalars['ID']['output'];
  direction?: Maybe<Scalars['String']['output']>;
};

export type AgentConfigurationInput = {
  agentId: Scalars['ID']['input'];
  direction?: InputMaybe<Direction>;
};

export type AgentContextVariables = {
  __typename?: 'AgentContextVariables';
  optional: Array<Scalars['String']['output']>;
  required: Array<Scalars['String']['output']>;
};

export type AgentConversationStatusAllUpdatedInput = {
  agentID: Scalars['ID']['input'];
  initiatingAgentID: Scalars['ID']['input'];
  markAsDone: Scalars['Boolean']['input'];
};

export type AgentConversationsStatusUpdatedInput = {
  agentID: Scalars['ID']['input'];
  conversationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  initiatingAgentID: Scalars['ID']['input'];
  markAsDone: Scalars['Boolean']['input'];
};

export enum AgentDependencyType {
  BOUND_LINE = 'BOUND_LINE',
  ESCALATION_TARGET = 'ESCALATION_TARGET'
}

export type AgentDetails = {
  __typename?: 'AgentDetails';
  ID: Scalars['ID']['output'];
  agentId: Scalars['ID']['output'];
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type AgentDraftConflictException = Exception & {
  __typename?: 'AgentDraftConflictException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type AgentEmailNotification = {
  __typename?: 'AgentEmailNotification';
  ID: Scalars['ID']['output'];
  frequency?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type AgentEvidenceSummary = {
  __typename?: 'AgentEvidenceSummary';
  coverage?: Maybe<AgentBuildCoverage>;
  intents: Array<IntentEvidence>;
  totalCallsUsed: Scalars['Int']['output'];
  virtualAgentID: Scalars['ID']['output'];
};

export type AgentEvidenceSummaryOutput = AgentEvidenceSummary | GenericException | ResourceNotFoundException;

export type AgentExtractOutput = {
  __typename?: 'AgentExtractOutput';
  extractFileUrl?: Maybe<Scalars['String']['output']>;
};

export enum AgentFlag {
  CONTEXT_GUARDRAIL = 'CONTEXT_GUARDRAIL',
  DISABLE_CALLER_CONTEXT = 'DISABLE_CALLER_CONTEXT',
  DISABLE_CALL_CONFIRMATION = 'DISABLE_CALL_CONFIRMATION',
  DISABLE_DATA_CONFIRMATION = 'DISABLE_DATA_CONFIRMATION',
  DISABLE_FILLERS = 'DISABLE_FILLERS',
  DISABLE_HANDOFF_PROTOCOL = 'DISABLE_HANDOFF_PROTOCOL',
  DISABLE_VOICEMAIL_DETECTION = 'DISABLE_VOICEMAIL_DETECTION',
  ENABLE_BACKGROUND_NOISE = 'ENABLE_BACKGROUND_NOISE',
  ENABLE_CALLER_CONTEXT = 'ENABLE_CALLER_CONTEXT',
  INJECT_AIRCALL_CONTEXT = 'INJECT_AIRCALL_CONTEXT',
  KNOWLEDGE_BASE_LOOKUP = 'KNOWLEDGE_BASE_LOOKUP'
}

export type AgentId = {
  __typename?: 'AgentID';
  ID: Scalars['ID']['output'];
};

export type AgentInsights = {
  __typename?: 'AgentInsights';
  archetype: AgentArchetype;
  avgCallDurationSeconds: Scalars['Float']['output'];
  configSuggestions: Array<ConfigSuggestion>;
  dataQuality: InsightsDataQuality;
  delta?: Maybe<InsightsDelta>;
  funnel: InsightsFunnel;
  knowledgeGapSuggestions: Array<KnowledgeGapSuggestion>;
  metrics: InsightsMetrics;
  totalCallsHandled: Scalars['Int']['output'];
  totalCallsWithKnowledgeGaps: Scalars['Int']['output'];
  totalTimeSavedSeconds: Scalars['Float']['output'];
};

export type AgentInsightsJob = {
  __typename?: 'AgentInsightsJob';
  jobId: Scalars['ID']['output'];
  status: InsightsJobStatus;
};

export type AgentInsightsJobOutput = AgentInsightsJob | GenericException | ResourceNotFoundException | UserInputException;

export type AgentInsightsJobResult = {
  __typename?: 'AgentInsightsJobResult';
  createdAt: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['ID']['output'];
  result?: Maybe<AgentInsights>;
  status: InsightsJobStatus;
  updatedAt: Scalars['String']['output'];
};

export type AgentInsightsJobResultOutput = AgentInsightsJobResult | GenericException | ResourceNotFoundException;

export type AgentInsightsOutput = AgentInsights | GenericException | ResourceNotFoundException | UserInputException;

export type AgentKbMapping = {
  __typename?: 'AgentKBMapping';
  agent_id: Scalars['String']['output'];
  agent_type?: Maybe<AgentType>;
  client_type: Scalars['String']['output'];
  created_at: Scalars['AWSDateTime']['output'];
  created_by?: Maybe<Scalars['Int']['output']>;
  kb_id: Scalars['ID']['output'];
  updated_at?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type AgentKbMappingInput = {
  agent_id: Scalars['String']['input'];
  agent_type?: InputMaybe<AgentType>;
  client_type: Scalars['String']['input'];
  kb_id: Scalars['ID']['input'];
};

export type AgentKbMappingUpdateInput = {
  kb_id: Scalars['ID']['input'];
};

export type AgentKbQueryResult = AgentKbResult | GenericException;

export type AgentKbResult = {
  __typename?: 'AgentKBResult';
  kb_id: Scalars['ID']['output'];
};

export type AgentKbWithDetails = {
  __typename?: 'AgentKBWithDetails';
  agent_id: Scalars['String']['output'];
  agent_type?: Maybe<AgentType>;
  client_type: Scalars['String']['output'];
  created_at: Scalars['AWSDateTime']['output'];
  kb_id: Scalars['ID']['output'];
  kb_name: Scalars['String']['output'];
  updated_at: Scalars['AWSDateTime']['output'];
  was_created: Scalars['Boolean']['output'];
};

export type AgentKbMappingResult = AgentKbMapping | GenericException;

export type AgentListenConfig = {
  __typename?: 'AgentListenConfig';
  enabled: Scalars['Boolean']['output'];
  model?: Maybe<SttModel>;
  provider?: Maybe<SttProvider>;
};

export type AgentListenConfigInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  model?: InputMaybe<SttModel>;
  provider?: InputMaybe<SttProvider>;
};

export type AgentOverviewInsightsList = {
  __typename?: 'AgentOverviewInsightsList';
  items: Array<AgentOverviewInsightsRow>;
};

export type AgentOverviewInsightsRow = {
  __typename?: 'AgentOverviewInsightsRow';
  archetype?: Maybe<AgentArchetype>;
  callDirection: CallDirection;
  callVolume?: Maybe<Scalars['Int']['output']>;
  connectRate?: Maybe<Scalars['Float']['output']>;
  virtualAgentID: Scalars['ID']['output'];
};

export type AgentParticipant = {
  __typename?: 'AgentParticipant';
  agent?: Maybe<Agent>;
  agentDetails?: Maybe<AgentDetails>;
  agentID: Scalars['Int']['output'];
  number: Scalars['String']['output'];
  teammate: PhoneTeammateResolver;
};

export type AgentPhoneNumber = {
  __typename?: 'AgentPhoneNumber';
  ID: Scalars['ID']['output'];
  digitConfirmationDisabled: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type AgentPhoneNumberInput = {
  ID?: InputMaybe<Scalars['ID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber: Scalars['String']['input'];
};

export type AgentRecentTagsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type AgentRecentTagsOutput = {
  __typename?: 'AgentRecentTagsOutput';
  agentID: Scalars['ID']['output'];
  tagIds: Array<Scalars['ID']['output']>;
};

export type AgentRemovedFromLineNotificationInput = {
  agentsRemoved: Array<Scalars['ID']['input']>;
  line: Scalars['String']['input'];
  timestamp: Scalars['AWSDateTime']['input'];
};

export type AgentRemovedFromLineNotificationOutput = {
  __typename?: 'AgentRemovedFromLineNotificationOutput';
  agentsRemoved: Array<Scalars['ID']['output']>;
  lineID: Scalars['ID']['output'];
  timestamp: Scalars['AWSDateTime']['output'];
};

export enum AgentRole {
  admin = 'admin',
  agent = 'agent',
  supervisor = 'supervisor'
}

export type AgentSipSetting = {
  __typename?: 'AgentSipSetting';
  ID: Scalars['ID']['output'];
  domain: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  password?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type AgentSpeakConfig = {
  __typename?: 'AgentSpeakConfig';
  enabled: Scalars['Boolean']['output'];
  model?: Maybe<TtsModel>;
  provider?: Maybe<TtsProvider>;
  temperature?: Maybe<Scalars['Float']['output']>;
  voiceId?: Maybe<Scalars['String']['output']>;
};

export type AgentSpeakConfigInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  model?: InputMaybe<TtsModel>;
  provider?: InputMaybe<TtsProvider>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
  voiceId?: InputMaybe<Scalars['String']['input']>;
};

export type AgentSpeaker = {
  __typename?: 'AgentSpeaker';
  agent?: Maybe<Agent>;
  agentDetails?: Maybe<AgentDetails>;
  agentID: Scalars['Int']['output'];
  channel: Scalars['Int']['output'];
  teammate: PhoneTeammateResolver;
};

export enum AgentState {
  ALWAYS_CLOSED = 'ALWAYS_CLOSED',
  ALWAYS_OPENED = 'ALWAYS_OPENED',
  AUTO = 'AUTO'
}

export type AgentTargetResponse = {
  __typename?: 'AgentTargetResponse';
  agentID: Scalars['ID']['output'];
};

export type AgentTemplate = {
  __typename?: 'AgentTemplate';
  ID: Scalars['ID']['output'];
  agentID: Scalars['ID']['output'];
  companyID: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  isFavourite: Scalars['Boolean']['output'];
  medias?: Maybe<Array<Maybe<MediaDetails>>>;
  name?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type AgentThinkConfig = {
  __typename?: 'AgentThinkConfig';
  enabled: Scalars['Boolean']['output'];
  model?: Maybe<LlmModel>;
  provider?: Maybe<LlmProvider>;
};

export type AgentThinkConfigInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  model?: InputMaybe<LlmModel>;
  provider?: InputMaybe<LlmProvider>;
};

export type AgentTracker = {
  __typename?: 'AgentTracker';
  agentId: Scalars['Int']['output'];
};

export enum AgentType {
  AI_KNOWLEDGE_BASE = 'AI_KNOWLEDGE_BASE',
  AI_MESSAGE_AGENT = 'AI_MESSAGE_AGENT',
  AI_VOICE_AGENT = 'AI_VOICE_AGENT',
  VOICE_AGENT = 'VOICE_AGENT'
}

export type AgentV2 = {
  __typename?: 'AgentV2';
  ID: Scalars['ID']['output'];
  activeDialerCampaignID?: Maybe<Scalars['String']['output']>;
  assignedLicenses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  associatedLines?: Maybe<PaginatedLines>;
  authorizedEntities: Array<AuthorizedEntity>;
  authyRegistration?: Maybe<Scalars['String']['output']>;
  businessHours: BusinessHours;
  chameleonHash?: Maybe<Scalars['String']['output']>;
  companyID: Scalars['Int']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currentRingtone?: Maybe<Scalars['String']['output']>;
  customMaxAverageBitrate?: Maybe<Scalars['Int']['output']>;
  customTwilioEdge?: Maybe<Scalars['String']['output']>;
  customTwilioRegion?: Maybe<Scalars['String']['output']>;
  defaultOutPhoneNumberID?: Maybe<Scalars['String']['output']>;
  defaultPrefix?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailNotifications?: Maybe<Array<AgentEmailNotification>>;
  enabledDevices?: Maybe<Scalars['Boolean']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  forceAggressiveIceNomination?: Maybe<Scalars['Boolean']['output']>;
  fullName: Scalars['String']['output'];
  intercomHash?: Maybe<Scalars['String']['output']>;
  isAbleToSendWhatsapp?: Maybe<Scalars['Boolean']['output']>;
  isActive: Scalars['Boolean']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isOnboardedForTeamsInPhoneNumbers?: Maybe<Scalars['Boolean']['output']>;
  isOnboardedOnApp?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  migratedOnAuthenticationManager?: Maybe<Scalars['Boolean']['output']>;
  phoneNumbers?: Maybe<Array<AgentPhoneNumber>>;
  pictureURL?: Maybe<Scalars['String']['output']>;
  ringTimeout?: Maybe<Scalars['Int']['output']>;
  role: AgentRole;
  roles: Array<Role>;
  sipSettings?: Maybe<Array<AgentSipSetting>>;
  state: AgentState;
  teams?: Maybe<Array<Team>>;
  timeZone?: Maybe<Scalars['String']['output']>;
  unavailableUntil?: Maybe<Scalars['String']['output']>;
  unconfirmedEmail?: Maybe<Scalars['String']['output']>;
  useAircallPhoneNumberAsCallerID?: Maybe<Scalars['Boolean']['output']>;
  useAircallPhonenumberAsCallerID?: Maybe<Scalars['Boolean']['output']>;
  useBestMatchCallerID?: Maybe<Scalars['Boolean']['output']>;
  wrapUpTime?: Maybe<Scalars['Int']['output']>;
};


export type AgentV2AssociatedLinesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type AgentV2OutputResolver = AgentV2 | GenericException | ResourceNotFoundException;

export type AgentsAggregation = {
  __typename?: 'AgentsAggregation';
  aggregations: Array<AgentAggregation>;
  otherCount: Scalars['Int']['output'];
};

export type AgentsAggregationScope = {
  duration?: InputMaybe<MetricAggregationScope>;
  sentiments?: InputMaybe<SentimentAggregationScope>;
  size: Scalars['Int']['input'];
};

export type AggregatedCategoriesFilter = {
  callDirection?: InputMaybe<CallDirection>;
  callTags?: InputMaybe<Array<Scalars['ID']['input']>>;
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  from?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  fromCallStartedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  isGeneratedByAI?: InputMaybe<Scalars['Boolean']['input']>;
  numbers?: InputMaybe<Array<Scalars['ID']['input']>>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  toCallStartedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  users?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AggregatedCategoryFilter = {
  callDirections?: InputMaybe<Array<CallDirection>>;
  categoryId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  fromCallStartedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  to?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  toCallStartedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
};

export type AggregatedQuestionFilter = {
  callTags?: InputMaybe<Array<Scalars['ID']['input']>>;
  from?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  fromCallStartedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  numbers?: InputMaybe<Array<Scalars['ID']['input']>>;
  questionId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  toCallStartedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  users?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AggregatedScorecardEvaluationsFilter = {
  callDirections?: InputMaybe<Array<CallDirection>>;
  callTags?: InputMaybe<Array<Scalars['ID']['input']>>;
  from?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  fromCallStartedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  interval?: InputMaybe<TrendIntervalType>;
  isGeneratedByAI?: InputMaybe<Scalars['Boolean']['input']>;
  numbers?: InputMaybe<Array<Scalars['ID']['input']>>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  scoreCardId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  toCallStartedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  users?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AiActionsEnabledCompanies = {
  __typename?: 'AiActionsEnabledCompanies';
  companies: Array<CompanyRef>;
  hubApplicationId: Scalars['String']['output'];
  mode: AiActionsEnabledCompaniesMode;
};

export enum AiActionsEnabledCompaniesMode {
  ALL = 'ALL',
  DISABLED = 'DISABLED',
  RESTRICTED = 'RESTRICTED'
}

export type AircallExtractByIdInput = {
  ID: Scalars['ID']['input'];
};

export type AircallExtractByIdOutput = GenericException | PhoneAircallExtract | ResourceNotFoundException;

export type AircallWorkspaceBooleanOutput = BooleanResult | GenericException | ResourceNotFoundException | UnauthorizedException | UserInputException;

export type AircallWorkspaceConversation = {
  __typename?: 'AircallWorkspaceConversation';
  ID: Scalars['ID']['output'];
  assigned?: Maybe<ConversationAssigned>;
  closedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  engagementToDisplay?: Maybe<EngagementToDisplay>;
  engagements: PaginatedEngagementsOutput;
  escalatedByAimaAt?: Maybe<Scalars['AWSDateTime']['output']>;
  external: PhoneContactResolver;
  externalEntity: ConversationExternalEntity;
  externalNumber: ExternalNumber;
  externalType: AircallWorkspaceConversationExternalTypes;
  isMembershipExpired: Scalars['Boolean']['output'];
  labels: Array<AircallWorkspaceConversationLabels>;
  lastAssignedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lastEngagement?: Maybe<LastEngagementResolver>;
  lastEngagementAt: Scalars['AWSDateTime']['output'];
  lastMessageAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lastMessageEngagement?: Maybe<MessageEngagementResolver>;
  lastSmsMmsAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lastSmsMmsEngagement?: Maybe<MessageEngagementResolver>;
  lastTransitionAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lastWhatsappAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lastWhatsappEngagement?: Maybe<MessageEngagementResolver>;
  line: LineResolver;
  messagingAI?: Maybe<ConversationMessagingAiResolver>;
  messagingAIStoppedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  metadata?: Maybe<ConversationMetadata>;
  status: AircallWorkspaceConversationStatus;
  unreadEngagements: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};


export type AircallWorkspaceConversationEngagementsArgs = {
  input?: InputMaybe<AircallWorkspaceEngagementsInput>;
};

export type AircallWorkspaceConversationByLineIdAndPhoneNumberOutput = AircallWorkspaceConversation | GenericException | UnauthorizedException | UnprocessableResourceException | UserInputException;

export type AircallWorkspaceConversationDeletedNotificationInput = {
  conversationID: Scalars['ID']['input'];
  recipients: Array<Scalars['ID']['input']>;
};

export type AircallWorkspaceConversationDeletedNotificationOutput = {
  __typename?: 'AircallWorkspaceConversationDeletedNotificationOutput';
  conversationID: Scalars['ID']['output'];
  recipients: Array<Scalars['ID']['output']>;
};

export enum AircallWorkspaceConversationExternalTypes {
  GROUP_SMS_MMS = 'GROUP_SMS_MMS',
  PHONE_NUMBER = 'PHONE_NUMBER',
  WHATSAPP_USER = 'WHATSAPP_USER'
}

export type AircallWorkspaceConversationExternalTypesInput = {
  in?: InputMaybe<Array<AircallWorkspaceConversationExternalTypes>>;
};

export enum AircallWorkspaceConversationLabels {
  AIMA_AGENT = 'AIMA_AGENT',
  ARCHIVED_AIMA_AGENT = 'ARCHIVED_AIMA_AGENT',
  ARCHIVED_CALL = 'ARCHIVED_CALL',
  ARCHIVED_MESSAGE = 'ARCHIVED_MESSAGE',
  ARCHIVED_WHATSAPP = 'ARCHIVED_WHATSAPP',
  CALL = 'CALL',
  INBOX = 'INBOX',
  MESSAGE = 'MESSAGE',
  OUTBOUND = 'OUTBOUND',
  WHATSAPP = 'WHATSAPP'
}

export type AircallWorkspaceConversationOutput = AircallWorkspaceConversation | GenericException | ResourceNotFoundException | UnauthorizedException | UnprocessableResourceException | UserInputException;

export type AircallWorkspaceConversationResolver = {
  __typename?: 'AircallWorkspaceConversationResolver';
  entity: AircallWorkspaceConversation;
};

export type AircallWorkspaceConversationResolverInput = {
  __typename?: 'AircallWorkspaceConversationResolverInput';
  companyID: Scalars['ID']['output'];
  conversationID: Scalars['ID']['output'];
};

export enum AircallWorkspaceConversationStatus {
  CLOSED = 'CLOSED',
  OPENED = 'OPENED'
}

export type AircallWorkspaceConversationUpdatedNotificationInput = {
  conversation: Scalars['String']['input'];
  filters?: InputMaybe<ConversationUpdatedMutationFilter>;
  reason: ConversationUpdatedReason;
  recipients: Array<Scalars['ID']['input']>;
  triggeredBy: Scalars['String']['input'];
};

export type AircallWorkspaceConversationUpdatedNotificationOutput = {
  __typename?: 'AircallWorkspaceConversationUpdatedNotificationOutput';
  conversation: AircallWorkspaceConversation;
  filters?: Maybe<ConversationUpdatedSubscriptionFilter>;
  reason: ConversationUpdatedReason;
  recipients: Array<Scalars['ID']['output']>;
  triggeredBy: TriggerSource;
};

export type AircallWorkspaceConversationsCountPerCategory = {
  __typename?: 'AircallWorkspaceConversationsCountPerCategory';
  assignedCount: Scalars['Int']['output'];
  closedCount: Scalars['Int']['output'];
  inboxCount: Scalars['Int']['output'];
  openedCount: Scalars['Int']['output'];
  outboundCount: Scalars['Int']['output'];
  unassignedCount: Scalars['Int']['output'];
  unreadCount: Scalars['Int']['output'];
};

export type AircallWorkspaceConversationsCountPerCategoryFilters = {
  externalNumberOrContactTerm?: InputMaybe<Scalars['String']['input']>;
  externalType?: InputMaybe<AircallWorkspaceConversationExternalTypesInput>;
  lastEngagementAt?: InputMaybe<TimestampFilter>;
  lineIds?: InputMaybe<IdFilter>;
  withGroupSmsMmsConversations?: InputMaybe<Scalars['Boolean']['input']>;
  withWhatsappUsernameConversations?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AircallWorkspaceConversationsCountPerCategoryOutput = AircallWorkspaceConversationsCountPerCategory | GenericException | UserInputException;

export type AircallWorkspaceConversationsFilters = {
  assignedStatus?: InputMaybe<AssignedStatus>;
  externalNumberOrContactTerm?: InputMaybe<Scalars['String']['input']>;
  externalType?: InputMaybe<AircallWorkspaceConversationExternalTypesInput>;
  labels?: InputMaybe<SearchableAircallWorkspaceConversationLabelsInput>;
  lastEngagementAt?: InputMaybe<TimestampFilter>;
  lineIds?: InputMaybe<IdFilter>;
  status?: InputMaybe<SearchableAircallWorkspaceConversationStatusInput>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
  withGroupSmsMmsConversations?: InputMaybe<Scalars['Boolean']['input']>;
  withWhatsappUsernameConversations?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AircallWorkspaceConversationsOutput = GenericException | PaginatedConversations | ResourceNotFoundException | UserInputException;

export type AircallWorkspaceConversationsPageRequest = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<ConversationsSortKey>;
};

export type AircallWorkspaceEngagementCreatedNotificationInput = {
  engagement: Scalars['String']['input'];
  filters?: InputMaybe<EngagementCreatedSubscriptionFilterInput>;
  recipients: Array<Scalars['ID']['input']>;
};

export type AircallWorkspaceEngagementCreatedNotificationOutput = {
  __typename?: 'AircallWorkspaceEngagementCreatedNotificationOutput';
  engagement: Engagement;
  filters?: Maybe<EngagementCreatedSubscriptionFilter>;
  recipients: Array<Scalars['ID']['output']>;
};

export type AircallWorkspaceEngagementNotificationInput = {
  engagement: Scalars['String']['input'];
  recipients: Array<Scalars['ID']['input']>;
};

export type AircallWorkspaceEngagementNotificationOutput = {
  __typename?: 'AircallWorkspaceEngagementNotificationOutput';
  engagement: Engagement;
  recipients: Array<Scalars['ID']['output']>;
};

export type AircallWorkspaceEngagementUpdatedNotificationInput = {
  engagement: Scalars['String']['input'];
  filters?: InputMaybe<EngagementUpdatedMutationFilter>;
  recipients: Array<Scalars['ID']['input']>;
};

export type AircallWorkspaceEngagementUpdatedNotificationOutput = {
  __typename?: 'AircallWorkspaceEngagementUpdatedNotificationOutput';
  engagement: Engagement;
  filters?: Maybe<EngagementUpdatedSubscriptionFilter>;
  recipients: Array<Scalars['ID']['output']>;
};

export type AircallWorkspaceEngagementsInput = {
  pageRequest: AircallWorkspaceEngagementsPageRequest;
};

export type AircallWorkspaceEngagementsPageRequest = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type AircallWorkspaceInboxUpdatedMutationFilterInput = {
  aircallWorkspaceConversationStatus?: InputMaybe<AircallWorkspaceConversationStatus>;
  assignedToUserID?: InputMaybe<Scalars['ID']['input']>;
  conversationType?: InputMaybe<ConversationType>;
  labels?: InputMaybe<Scalars['String']['input']>;
  lastEngagementAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  lineID?: InputMaybe<Array<Scalars['ID']['input']>>;
  reason?: InputMaybe<InboxUpdatedReason>;
};

export type AircallWorkspaceInboxUpdatedNotificationInput = {
  conversation: Scalars['String']['input'];
  engagement: Scalars['String']['input'];
  filters?: InputMaybe<AircallWorkspaceInboxUpdatedMutationFilterInput>;
  reason: InboxUpdatedReason;
  recipients: Array<Scalars['ID']['input']>;
};

export type AircallWorkspaceInboxUpdatedNotificationOutput = {
  __typename?: 'AircallWorkspaceInboxUpdatedNotificationOutput';
  conversation: AircallWorkspaceConversation;
  filters?: Maybe<AircallWorkspaceInboxUpdatedSubscriptionFilter>;
  reason: InboxUpdatedReason;
  recipients: Array<Scalars['ID']['output']>;
};

export type AircallWorkspaceInboxUpdatedSubscriptionFilter = {
  __typename?: 'AircallWorkspaceInboxUpdatedSubscriptionFilter';
  aircallWorkspaceConversationStatus?: Maybe<AircallWorkspaceConversationStatus>;
  assignedToUserID?: Maybe<Scalars['ID']['output']>;
  conversationType?: Maybe<ConversationType>;
  labels?: Maybe<Scalars['String']['output']>;
  lastEngagementAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lineID?: Maybe<Array<Scalars['ID']['output']>>;
  reason?: Maybe<InboxUpdatedReason>;
};

export type AircallWorkspaceInboxUpdatedSubscriptionFilterInput = {
  assignedStatus?: InputMaybe<AssignedStatus>;
  labels?: InputMaybe<SearchableAircallWorkspaceConversationLabelsInput>;
  lastEngagementAt?: InputMaybe<TimestampSubscriptionFilter>;
  lineIds?: InputMaybe<IdFilter>;
  status?: InputMaybe<SearchableAircallWorkspaceConversationStatusInput>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
  withGroupSmsMmsConversations?: InputMaybe<Scalars['Boolean']['input']>;
  withWhatsappUsernameConversations?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AivaActionMapEntry = {
  __typename?: 'AivaActionMapEntry';
  actionId?: Maybe<Scalars['ID']['output']>;
  newToolName?: Maybe<Scalars['String']['output']>;
  oldName?: Maybe<Scalars['String']['output']>;
};

export type AivaActionVerdict = {
  __typename?: 'AivaActionVerdict';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  verdict?: Maybe<Scalars['String']['output']>;
};

export type AivaAgentActions = {
  __typename?: 'AivaAgentActions';
  actions?: Maybe<Array<AivaActionVerdict>>;
  agentId?: Maybe<Scalars['ID']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  verdict?: Maybe<Scalars['String']['output']>;
};

export type AivaAgentConversion = {
  __typename?: 'AivaAgentConversion';
  actionMap?: Maybe<Array<AivaActionMapEntry>>;
  advisories?: Maybe<Array<AivaConversionIssue>>;
  agentId?: Maybe<Scalars['ID']['output']>;
  agentToolAttributes?: Maybe<Array<AivaProposedToolAttribute>>;
  companyId?: Maybe<Scalars['Int']['output']>;
  routes?: Maybe<Array<AivaProposedRoute>>;
  tools?: Maybe<Array<AivaProposedTool>>;
};

export type AivaAgentMigrationDraft = {
  __typename?: 'AivaAgentMigrationDraft';
  actionMap?: Maybe<Array<AivaActionMapEntry>>;
  agentId?: Maybe<Scalars['ID']['output']>;
  baseVersion?: Maybe<Scalars['Int']['output']>;
  draftId?: Maybe<Scalars['ID']['output']>;
  toolIds?: Maybe<Array<Scalars['Int']['output']>>;
};

export type AivaConversionIssue = {
  __typename?: 'AivaConversionIssue';
  actionId?: Maybe<Scalars['ID']['output']>;
  actionName?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
};

export type AivaParamValueSource = {
  __typename?: 'AivaParamValueSource';
  paramName?: Maybe<Scalars['String']['output']>;
  valueSource?: Maybe<Scalars['String']['output']>;
};

export type AivaProposedRoute = {
  __typename?: 'AivaProposedRoute';
  argsMappingJson?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  pathTemplate?: Maybe<Scalars['String']['output']>;
  toolName?: Maybe<Scalars['String']['output']>;
  upstreamUrl?: Maybe<Scalars['String']['output']>;
};

export type AivaProposedTool = {
  __typename?: 'AivaProposedTool';
  description?: Maybe<Scalars['String']['output']>;
  inputSchemaJson?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AivaProposedToolAttribute = {
  __typename?: 'AivaProposedToolAttribute';
  additionalDescription?: Maybe<Scalars['String']['output']>;
  paramValueSources?: Maybe<Array<AivaParamValueSource>>;
  preActionFiller?: Maybe<Scalars['Boolean']['output']>;
  presetArgsJson?: Maybe<Scalars['String']['output']>;
  runOnConnect?: Maybe<Scalars['Boolean']['output']>;
  toolName?: Maybe<Scalars['String']['output']>;
  validationRules?: Maybe<Array<AivaValidationRule>>;
};

export type AivaValidationRule = {
  __typename?: 'AivaValidationRule';
  field?: Maybe<Scalars['String']['output']>;
  matchType?: Maybe<Scalars['String']['output']>;
  onFailure?: Maybe<Scalars['String']['output']>;
};

export type AnalyticsAbsoluteDateRange = {
  fromDate: Scalars['AWSDate']['input'];
  toDate: Scalars['AWSDate']['input'];
};

export enum AnalyticsAutomaticCallbackFailureReason {
  AGENTS_DECLINED = 'AGENTS_DECLINED',
  NO_AGENTS_AVAILABLE = 'NO_AGENTS_AVAILABLE',
  NO_ONE_TO_RING = 'NO_ONE_TO_RING',
  UNKNOWN = 'UNKNOWN'
}

export type AnalyticsCall = {
  __typename?: 'AnalyticsCall';
  aiVoiceAgentTransferBranchName?: Maybe<Scalars['String']['output']>;
  answeredAt?: Maybe<Scalars['AWSDateTime']['output']>;
  automaticCallbackFailureReason?: Maybe<AnalyticsAutomaticCallbackFailureReason>;
  automaticCallbackPendingTimeSeconds?: Maybe<Scalars['Int']['output']>;
  automaticCallbackReferenceCallID?: Maybe<Scalars['ID']['output']>;
  callQuality?: Maybe<Scalars['Int']['output']>;
  customerPhoneNumber?: Maybe<Scalars['String']['output']>;
  direction: AnalyticsCallDirection;
  disconnectedBy?: Maybe<AnalyticsDisconnectedBy>;
  endedAt: Scalars['AWSDateTime']['output'];
  entryLine?: Maybe<AnalyticsLine>;
  fromPhoneNumber?: Maybe<Scalars['String']['output']>;
  hasAiIntervention: Scalars['Boolean']['output'];
  hasAutomaticCallbackReferenceCallLink: Scalars['Boolean']['output'];
  hasCallEscalated: Scalars['Boolean']['output'];
  hasRecording: Scalars['Boolean']['output'];
  hasSubsequentCall: Scalars['Boolean']['output'];
  hasVoicemail: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  inCallTimeSeconds?: Maybe<Scalars['Int']['output']>;
  ivrBranchName?: Maybe<Scalars['String']['output']>;
  ivrWidgetName?: Maybe<Scalars['String']['output']>;
  line?: Maybe<AnalyticsLine>;
  notes?: Maybe<Array<Scalars['String']['output']>>;
  outboundCampaign?: Maybe<AnalyticsOutboundCampaign>;
  outcome: AnalyticsCallOutcome;
  startedAt: Scalars['AWSDateTime']['output'];
  subsequentCallUser?: Maybe<AnalyticsUser>;
  tags?: Maybe<Array<AnalyticsTag>>;
  team?: Maybe<AnalyticsTeam>;
  timeInIvrSeconds?: Maybe<Scalars['Int']['output']>;
  timeToAnswerSeconds?: Maybe<Scalars['Int']['output']>;
  timeWithAiAgentSeconds?: Maybe<Scalars['Int']['output']>;
  toPhoneNumber?: Maybe<Scalars['String']['output']>;
  totalCallTimeSeconds?: Maybe<Scalars['Int']['output']>;
  unansweredReason?: Maybe<AnalyticsUnansweredReason>;
  user?: Maybe<AnalyticsUser>;
  uuid: Scalars['ID']['output'];
  virtualVoiceAgent?: Maybe<AnalyticsVirtualVoiceAgent>;
  waitingTimeSeconds?: Maybe<Scalars['Int']['output']>;
};

export enum AnalyticsCallDirection {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND',
  UNKNOWN = 'UNKNOWN'
}

export enum AnalyticsCallOutcome {
  ABANDONED = 'ABANDONED',
  ANSWERED = 'ANSWERED',
  ANSWERED_BY_AI = 'ANSWERED_BY_AI',
  CONNECTED = 'CONNECTED',
  CONNECTED_AI = 'CONNECTED_AI',
  NOT_CONNECTED = 'NOT_CONNECTED',
  NOT_CONNECTED_AI = 'NOT_CONNECTED_AI',
  OUTSIDE_BUSINESS_HOURS = 'OUTSIDE_BUSINESS_HOURS',
  UNANSWERED = 'UNANSWERED',
  UNKNOWN = 'UNKNOWN'
}

export type AnalyticsCallQualityMetrics = {
  __typename?: 'AnalyticsCallQualityMetrics';
  callUuid: Scalars['String']['output'];
  externalMediaIp?: Maybe<Scalars['String']['output']>;
  mediaRegion?: Maybe<Scalars['String']['output']>;
  sdkFlagsSummary?: Maybe<Scalars['String']['output']>;
  sdkJitterAvg?: Maybe<Scalars['Float']['output']>;
  sdkMosAvg?: Maybe<Scalars['Float']['output']>;
  sdkPacketLossPercentage?: Maybe<Scalars['Float']['output']>;
  sdkRttAvg?: Maybe<Scalars['Float']['output']>;
  startedAt: Scalars['AWSDateTime']['output'];
  user?: Maybe<AnalyticsUser>;
};

export type AnalyticsCallTypeFilter = {
  direction?: InputMaybe<AnalyticsCallDirection>;
  outcomes?: InputMaybe<Array<AnalyticsCallOutcome>>;
  unansweredReasons?: InputMaybe<Array<AnalyticsUnansweredReason>>;
};

export type AnalyticsCallsHistory = {
  __typename?: 'AnalyticsCallsHistory';
  cachedAt: Scalars['AWSDateTime']['output'];
  items: Array<AnalyticsCall>;
  pageInfo: PagingInfo;
};

export type AnalyticsCallsHistoryResult = AnalyticsCallsHistory | GenericException | ResourceNotFoundException | RetryableException;

export type AnalyticsCreatePresetInput = {
  customFields?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  isDefault: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  options?: InputMaybe<Scalars['String']['input']>;
  preferences?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};

export enum AnalyticsDashboardType {
  ANALYTICS = 'ANALYTICS',
  AVAILABILITY = 'AVAILABILITY',
  CALLS_OVERVIEW = 'CALLS_OVERVIEW',
  CALL_LOG = 'CALL_LOG',
  CALL_QUALITY = 'CALL_QUALITY',
  CALL_QUALITY_PRO = 'CALL_QUALITY_PRO',
  GENERAL_PERFORMANCE_OVERVIEW = 'GENERAL_PERFORMANCE_OVERVIEW',
  INBOUND = 'INBOUND',
  INBOUND_ACTIVITY = 'INBOUND_ACTIVITY',
  INBOUND_ACTIVITY_PRO = 'INBOUND_ACTIVITY_PRO',
  INBOUND_CALLS_OVERVIEW = 'INBOUND_CALLS_OVERVIEW',
  MESSAGES_OVERVIEW = 'MESSAGES_OVERVIEW',
  MONITORING = 'MONITORING',
  OUTBOUND_ACTIVITY = 'OUTBOUND_ACTIVITY',
  OUTBOUND_ACTIVITY_PRO = 'OUTBOUND_ACTIVITY_PRO',
  OUTBOUND_CALLS_OVERVIEW = 'OUTBOUND_CALLS_OVERVIEW',
  OVERVIEW = 'OVERVIEW',
  UNANSWERED_INBOUND_CALL = 'UNANSWERED_INBOUND_CALL',
  UNANSWERED_INBOUND_CALL_PRO = 'UNANSWERED_INBOUND_CALL_PRO',
  USERS_ACTIVITY = 'USERS_ACTIVITY',
  USERS_ACTIVITY_PRO = 'USERS_ACTIVITY_PRO',
  VOICE_AI_OVERVIEW = 'VOICE_AI_OVERVIEW'
}

export type AnalyticsDashboardUrl = {
  __typename?: 'AnalyticsDashboardUrl';
  url: Scalars['String']['output'];
};

export type AnalyticsDashboardUrlInput = {
  dashboardType: AnalyticsDashboardType;
  embedDomain: Scalars['String']['input'];
  sdkVersion: Scalars['String']['input'];
};

export enum AnalyticsDateBreakdown {
  DAILY = 'DAILY',
  HOURLY = 'HOURLY',
  MONTHLY = 'MONTHLY',
  NONE = 'NONE',
  WEEKLY = 'WEEKLY'
}

export type AnalyticsDateFilter = {
  absoluteRange?: InputMaybe<AnalyticsAbsoluteDateRange>;
  relative?: InputMaybe<AnalyticsRelativeTime>;
};

export type AnalyticsDeletePresetInput = {
  id: Scalars['ID']['input'];
  slug: Scalars['String']['input'];
};

export type AnalyticsDeletePresetResult = AnalyticsDeletePresetSuccess | GenericException | ResourceNotFoundException | RetryableException;

export type AnalyticsDeletePresetSuccess = {
  __typename?: 'AnalyticsDeletePresetSuccess';
  success: Scalars['Boolean']['output'];
};

export enum AnalyticsDisconnectedBy {
  AGENT = 'AGENT',
  EXTERNAL = 'EXTERNAL',
  SYSTEM = 'SYSTEM'
}

export type AnalyticsDrillDownExtraFilterItem = {
  __typename?: 'AnalyticsDrillDownExtraFilterItem';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AnalyticsDrillDownExtraFilterItemInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type AnalyticsDurationFilter = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type AnalyticsExport = {
  __typename?: 'AnalyticsExport';
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  exportID?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<AnalyticsExportStatus>;
};

export enum AnalyticsExportFormat {
  CSV = 'CSV',
  XLSX = 'XLSX'
}

export type AnalyticsExportMetricsInput = {
  exportOptions?: InputMaybe<AnalyticsExportOptionsInput>;
  filter: AnalyticsFilter;
  multipleValueMetrics?: InputMaybe<Array<AnalyticsExportMetricsMultipleValueMetricsInput>>;
  options?: InputMaybe<AnalyticsMetricOptionsInput>;
  singleValueMetrics?: InputMaybe<Array<AnalyticsExportMetricsSingleValueMetricsInput>>;
};

export type AnalyticsExportMetricsMultipleValueMetricsInput = {
  name: AnalyticsMultipleValueMetricName;
  tileName?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsExportMetricsSingleValueMetricsInput = {
  comparisonOptions?: InputMaybe<AnalyticsMetricPreviousPeriodComparisonOptionsInput>;
  name: AnalyticsSingleValueMetricName;
  tileName?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsExportMultipleValueMetricDrillDownInput = {
  drillDownExtraFilters?: InputMaybe<Array<AnalyticsDrillDownExtraFilterItemInput>>;
  exportOptions?: InputMaybe<AnalyticsExportOptionsInput>;
  filter: AnalyticsFilter;
  metricName: AnalyticsMultipleValueMetricName;
  options?: InputMaybe<AnalyticsMetricOptionsInput>;
};

export type AnalyticsExportOptionsInput = {
  exportName?: InputMaybe<Scalars['String']['input']>;
  format: AnalyticsExportFormat;
};

export type AnalyticsExportResult = AnalyticsExport | GenericException | ResourceNotFoundException | RetryableException;

export type AnalyticsExportSingleValueMetricDrillDownInput = {
  exportOptions?: InputMaybe<AnalyticsExportOptionsInput>;
  filter: AnalyticsFilter;
  metricName: AnalyticsSingleValueMetricName;
  options?: InputMaybe<AnalyticsMetricOptionsInput>;
};

export enum AnalyticsExportStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING'
}

export type AnalyticsExportUpdatedInput = {
  companyID?: InputMaybe<Scalars['ID']['input']>;
  createdAt: Scalars['AWSDateTime']['input'];
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  exportID: Scalars['ID']['input'];
  exportName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<AnalyticsExportFormat>;
  isZipCompressed?: InputMaybe<Scalars['Boolean']['input']>;
  status: AnalyticsExportStatus;
  userID: Scalars['ID']['input'];
};

export type AnalyticsExportUpdatedResult = {
  __typename?: 'AnalyticsExportUpdatedResult';
  createdAt: Scalars['AWSDateTime']['output'];
  downloadUrl?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  exportID: Scalars['ID']['output'];
  exportName?: Maybe<Scalars['String']['output']>;
  format?: Maybe<AnalyticsExportFormat>;
  isZipCompressed?: Maybe<Scalars['Boolean']['output']>;
  status: AnalyticsExportStatus;
  userID: Scalars['ID']['output'];
};

export type AnalyticsFilter = {
  callIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  callTypes?: InputMaybe<Array<AnalyticsCallTypeFilter>>;
  contactNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  customerNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  dateFilter: AnalyticsDateFilter;
  duration?: InputMaybe<AnalyticsDurationFilter>;
  hours?: InputMaybe<AnalyticsHoursFilter>;
  ivrBranches?: InputMaybe<Array<Scalars['String']['input']>>;
  lineIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  messageEventNames?: InputMaybe<Array<AnalyticsMessageEventName>>;
  messageTypes?: InputMaybe<Array<AnalyticsMessageType>>;
  minConnectedDuration?: InputMaybe<Scalars['Int']['input']>;
  nextUserStatuses?: InputMaybe<Array<AnalyticsUserStatus>>;
  outboundCampaignIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  ringAttemptOrigin?: InputMaybe<AnalyticsRingAttemptOrigin>;
  tagIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  teamFilterOption?: InputMaybe<AnalyticsTeamFilterOption>;
  teamIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  timezone: Scalars['String']['input'];
  userIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  userStatuses?: InputMaybe<Array<AnalyticsUserStatus>>;
  virtualVoiceAgentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  withAiIntervention?: InputMaybe<Scalars['Boolean']['input']>;
  withVoicemail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnalyticsFilterInput = {
  filter: AnalyticsSearchFiltersInput;
};

export type AnalyticsFilterResult = AnalyticsSearchFilter | GenericException | ResourceNotFoundException | RetryableException;

export type AnalyticsGetPresetInput = {
  id: Scalars['ID']['input'];
  slug: Scalars['String']['input'];
};

export type AnalyticsHoursFilter = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type AnalyticsLine = {
  __typename?: 'AnalyticsLine';
  countryISOCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
};

export type AnalyticsLineFilter = {
  __typename?: 'AnalyticsLineFilter';
  items: Array<AnalyticsLine>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsLineFilterResult = AnalyticsLineFilter | GenericException | ResourceNotFoundException | RetryableException;

export type AnalyticsListInput = {
  exportOptions?: InputMaybe<AnalyticsExportOptionsInput>;
  filter: AnalyticsFilter;
  options?: InputMaybe<AnalyticsListOptions>;
};

export type AnalyticsListOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AnalyticsSortInput>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsListPresetsInput = {
  slug: Scalars['String']['input'];
};

export type AnalyticsMessage = {
  __typename?: 'AnalyticsMessage';
  aiAgentId?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  customerPhoneNumber?: Maybe<Scalars['String']['output']>;
  customerPhoneNumberCountryISOCode?: Maybe<Scalars['String']['output']>;
  event: AnalyticsMessageEventName;
  eventName: Scalars['String']['output'];
  externalUserDisplayName?: Maybe<Scalars['String']['output']>;
  externalUserId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isMms: Scalars['Boolean']['output'];
  line?: Maybe<AnalyticsLine>;
  segmentCount: Scalars['Int']['output'];
  type: AnalyticsMessageType;
  user?: Maybe<AnalyticsUser>;
  whatsappMessageCategory?: Maybe<Scalars['String']['output']>;
  whatsappMessageType?: Maybe<Scalars['String']['output']>;
};

export enum AnalyticsMessageEventName {
  INBOUND_MESSAGE_RECEIVED = 'INBOUND_MESSAGE_RECEIVED',
  OUTBOUND_MESSAGE_SENT = 'OUTBOUND_MESSAGE_SENT',
  UNKNOWN = 'UNKNOWN'
}

export enum AnalyticsMessageType {
  MMS = 'MMS',
  SMS = 'SMS',
  UNKNOWN = 'UNKNOWN',
  WHATSAPP = 'WHATSAPP'
}

export type AnalyticsMessagesHistory = {
  __typename?: 'AnalyticsMessagesHistory';
  cachedAt: Scalars['AWSDateTime']['output'];
  items: Array<AnalyticsMessage>;
  pageInfo: PagingInfo;
};

export type AnalyticsMessagesHistoryResult = AnalyticsMessagesHistory | GenericException | ResourceNotFoundException | RetryableException;

export type AnalyticsMetricDrillDown = {
  __typename?: 'AnalyticsMetricDrillDown';
  items: Array<AnalyticsMetricDrillDownItem>;
};

export type AnalyticsMetricDrillDownItem = AnalyticsCall | AnalyticsCallQualityMetrics | AnalyticsMessage | AnalyticsRingAttempt | AnalyticsUserEvent;

export type AnalyticsMetricDrillDownResult = AnalyticsMetricDrillDown | GenericException | ResourceNotFoundException | RetryableException;

export type AnalyticsMetricOptionsInput = {
  dateBreakdown: AnalyticsDateBreakdown;
  slaIncludedCallUnansweredReasons?: InputMaybe<Array<AnalyticsUnansweredReason>>;
  slaTimeToAnswerInSeconds: Scalars['Int']['input'];
};

export type AnalyticsMetricPreviousPeriodComparisonOptionsInput = {
  comparisonReturnValueType: AnalyticsMetricValueType;
};

export enum AnalyticsMetricValueType {
  AVERAGE = 'AVERAGE',
  AVERAGE_DURATION_IN_SECONDS = 'AVERAGE_DURATION_IN_SECONDS',
  COUNT = 'COUNT',
  DURATION_IN_SECONDS = 'DURATION_IN_SECONDS',
  PERCENTAGE = 'PERCENTAGE'
}

export type AnalyticsMultipleValueMetric = {
  __typename?: 'AnalyticsMultipleValueMetric';
  cachedAt: Scalars['AWSDateTime']['output'];
  items: Array<AnalyticsMultipleValueMetricItem>;
};

export type AnalyticsMultipleValueMetricDrillDownInput = {
  drillDownExtraFilters?: InputMaybe<Array<AnalyticsDrillDownExtraFilterItemInput>>;
  filter: AnalyticsFilter;
  metricName: AnalyticsMultipleValueMetricName;
  options?: InputMaybe<AnalyticsMetricOptionsInput>;
};

export type AnalyticsMultipleValueMetricInput = {
  filter: AnalyticsFilter;
  metricName: AnalyticsMultipleValueMetricName;
  options?: InputMaybe<AnalyticsMetricOptionsInput>;
};

export type AnalyticsMultipleValueMetricItem = {
  __typename?: 'AnalyticsMultipleValueMetricItem';
  name: Scalars['String']['output'];
  values: Array<AnalyticsMultipleValueMetricItemValue>;
};

export type AnalyticsMultipleValueMetricItemValue = AnalyticsMultipleValueMetricItemValueFloat | AnalyticsMultipleValueMetricItemValueString;

export type AnalyticsMultipleValueMetricItemValueFloat = {
  __typename?: 'AnalyticsMultipleValueMetricItemValueFloat';
  drillDownExtraFilters?: Maybe<Array<AnalyticsDrillDownExtraFilterItem>>;
  key: Scalars['String']['output'];
  numericValue: Scalars['Float']['output'];
  valueType: AnalyticsMetricValueType;
};

export type AnalyticsMultipleValueMetricItemValueString = {
  __typename?: 'AnalyticsMultipleValueMetricItemValueString';
  drillDownExtraFilters?: Maybe<Array<AnalyticsDrillDownExtraFilterItem>>;
  key: Scalars['String']['output'];
  stringValue: Scalars['String']['output'];
};

export enum AnalyticsMultipleValueMetricName {
  CALLS_BREAKDOWN_BY_DATE_AND_TIME = 'CALLS_BREAKDOWN_BY_DATE_AND_TIME',
  CALLS_BREAKDOWN_BY_IVR_BRANCH = 'CALLS_BREAKDOWN_BY_IVR_BRANCH',
  CALLS_BREAKDOWN_BY_NUMBER = 'CALLS_BREAKDOWN_BY_NUMBER',
  CALLS_BREAKDOWN_BY_USER = 'CALLS_BREAKDOWN_BY_USER',
  CALLS_BY_TAGS_TOP_10 = 'CALLS_BY_TAGS_TOP_10',
  CALLS_COUNT_BY_DIRECTION = 'CALLS_COUNT_BY_DIRECTION',
  CALLS_COUNT_BY_TAGS_TOP_10 = 'CALLS_COUNT_BY_TAGS_TOP_10',
  CALLS_COUNT_BY_USER = 'CALLS_COUNT_BY_USER',
  CALLS_COUNT_BY_WEEK_DAY = 'CALLS_COUNT_BY_WEEK_DAY',
  CALLS_COUNT_NOT_PICKED_UP_BY_USER_TOP_10 = 'CALLS_COUNT_NOT_PICKED_UP_BY_USER_TOP_10',
  CALLS_COUNT_PICKED_UP_BY_USER_TOP_10 = 'CALLS_COUNT_PICKED_UP_BY_USER_TOP_10',
  CALLS_COUNT_RINGING_ATTEMPTS_BY_USER = 'CALLS_COUNT_RINGING_ATTEMPTS_BY_USER',
  CALLS_HANDLED_BY_USER = 'CALLS_HANDLED_BY_USER',
  CALLS_INBOUND_ANSWERED_AVERAGE_CALL_TIME = 'CALLS_INBOUND_ANSWERED_AVERAGE_CALL_TIME',
  CALLS_INBOUND_COUNT_BY_OUTCOME = 'CALLS_INBOUND_COUNT_BY_OUTCOME',
  CALLS_INBOUND_COUNT_BY_OUTCOME_AND_HOUR_OF_DAY = 'CALLS_INBOUND_COUNT_BY_OUTCOME_AND_HOUR_OF_DAY',
  CALLS_INBOUND_COUNT_BY_OUTCOME_AND_UNANSWERED_REASON = 'CALLS_INBOUND_COUNT_BY_OUTCOME_AND_UNANSWERED_REASON',
  CALLS_INBOUND_COUNT_BY_UNANSWERED_REASON_AND_SUBSEQUENT_CALL = 'CALLS_INBOUND_COUNT_BY_UNANSWERED_REASON_AND_SUBSEQUENT_CALL',
  CALLS_INBOUND_COUNT_BY_WEEKDAY_AND_HOUR = 'CALLS_INBOUND_COUNT_BY_WEEKDAY_AND_HOUR',
  CALLS_INBOUND_DISTRIBUTION_IN_CALL_TIME = 'CALLS_INBOUND_DISTRIBUTION_IN_CALL_TIME',
  CALLS_INBOUND_DISTRIBUTION_TIME_TO_ANSWER = 'CALLS_INBOUND_DISTRIBUTION_TIME_TO_ANSWER',
  CALLS_INBOUND_EXPLORE_KPI = 'CALLS_INBOUND_EXPLORE_KPI',
  CALLS_INBOUND_IN_CALL_TIME_BY_USER = 'CALLS_INBOUND_IN_CALL_TIME_BY_USER',
  CALLS_INBOUND_METRICS_BY_ENTRY_NUMBER = 'CALLS_INBOUND_METRICS_BY_ENTRY_NUMBER',
  CALLS_INBOUND_METRICS_BY_FINAL_NUMBER = 'CALLS_INBOUND_METRICS_BY_FINAL_NUMBER',
  CALLS_INBOUND_METRICS_BY_INTENT_TRANSFER_BRANCH = 'CALLS_INBOUND_METRICS_BY_INTENT_TRANSFER_BRANCH',
  CALLS_INBOUND_METRICS_BY_IVR_BRANCH = 'CALLS_INBOUND_METRICS_BY_IVR_BRANCH',
  CALLS_INBOUND_METRICS_BY_TAG = 'CALLS_INBOUND_METRICS_BY_TAG',
  CALLS_INBOUND_OVER_TIME = 'CALLS_INBOUND_OVER_TIME',
  CALLS_INBOUND_PERCENTAGE_BY_OUTCOME_AND_UNANSWERED_REASON = 'CALLS_INBOUND_PERCENTAGE_BY_OUTCOME_AND_UNANSWERED_REASON',
  CALLS_INBOUND_TIME_TO_ANSWER_AND_SLA_EVOLUTION = 'CALLS_INBOUND_TIME_TO_ANSWER_AND_SLA_EVOLUTION',
  CALLS_INBOUND_UNANSWERED_BY_WEEKDAY_AND_HOUR = 'CALLS_INBOUND_UNANSWERED_BY_WEEKDAY_AND_HOUR',
  CALLS_INBOUND_UNANSWERED_COUNT_BY_UNIQUE_CALLER = 'CALLS_INBOUND_UNANSWERED_COUNT_BY_UNIQUE_CALLER',
  CALLS_INBOUND_UNANSWERED_EVOLUTION = 'CALLS_INBOUND_UNANSWERED_EVOLUTION',
  CALLS_INBOUND_UNIQUE_CALLERS_EVOLUTION = 'CALLS_INBOUND_UNIQUE_CALLERS_EVOLUTION',
  CALLS_OUTBOUND_CAMPAIGN_ATTEMPTS_BEFORE_PICKUP_BY_OUTCOME = 'CALLS_OUTBOUND_CAMPAIGN_ATTEMPTS_BEFORE_PICKUP_BY_OUTCOME',
  CALLS_OUTBOUND_CAMPAIGN_CONTACTS_COUNT_BY_OUTCOME = 'CALLS_OUTBOUND_CAMPAIGN_CONTACTS_COUNT_BY_OUTCOME',
  CALLS_OUTBOUND_CAMPAIGN_DISTRIBUTION_PICKED_UP_ATTEMPT = 'CALLS_OUTBOUND_CAMPAIGN_DISTRIBUTION_PICKED_UP_ATTEMPT',
  CALLS_OUTBOUND_CONNECTED_COUNT_BY_USER_TOP_10 = 'CALLS_OUTBOUND_CONNECTED_COUNT_BY_USER_TOP_10',
  CALLS_OUTBOUND_CONNECTED_METRICS_BY_TAG = 'CALLS_OUTBOUND_CONNECTED_METRICS_BY_TAG',
  CALLS_OUTBOUND_CONNECTED_PERCENTAGE_BY_WEEKDAY_AND_HOUR = 'CALLS_OUTBOUND_CONNECTED_PERCENTAGE_BY_WEEKDAY_AND_HOUR',
  CALLS_OUTBOUND_COUNT_BY_OUTCOME = 'CALLS_OUTBOUND_COUNT_BY_OUTCOME',
  CALLS_OUTBOUND_COUNT_BY_WEEKDAY_AND_HOUR = 'CALLS_OUTBOUND_COUNT_BY_WEEKDAY_AND_HOUR',
  CALLS_OUTBOUND_IN_CALL_TIME_BY_USER = 'CALLS_OUTBOUND_IN_CALL_TIME_BY_USER',
  CALLS_OUTBOUND_METRICS_BY_AI_VOICE_AGENT = 'CALLS_OUTBOUND_METRICS_BY_AI_VOICE_AGENT',
  CALLS_OUTBOUND_METRICS_BY_CONTACT = 'CALLS_OUTBOUND_METRICS_BY_CONTACT',
  CALLS_OUTBOUND_METRICS_BY_NUMBER = 'CALLS_OUTBOUND_METRICS_BY_NUMBER',
  CALLS_OUTBOUND_METRICS_BY_NUMBER_BASIC = 'CALLS_OUTBOUND_METRICS_BY_NUMBER_BASIC',
  CALLS_OUTBOUND_METRICS_BY_USER = 'CALLS_OUTBOUND_METRICS_BY_USER',
  CALLS_OUTBOUND_OVER_TIME = 'CALLS_OUTBOUND_OVER_TIME',
  CALLS_VOLUME_AND_TIME_BY_USER = 'CALLS_VOLUME_AND_TIME_BY_USER',
  CALL_QUALITY_BY_IP = 'CALL_QUALITY_BY_IP',
  CALL_QUALITY_BY_IP_AND_USER = 'CALL_QUALITY_BY_IP_AND_USER',
  CALL_QUALITY_JITTER_PERCENTAGE = 'CALL_QUALITY_JITTER_PERCENTAGE',
  CALL_QUALITY_LATENCY_PERCENTAGE = 'CALL_QUALITY_LATENCY_PERCENTAGE',
  CALL_QUALITY_PACKET_LOSS_PERCENTAGE = 'CALL_QUALITY_PACKET_LOSS_PERCENTAGE',
  CALL_QUALITY_SUMMARY = 'CALL_QUALITY_SUMMARY',
  CALL_QUALITY_SUMMARY_OVER_TIME = 'CALL_QUALITY_SUMMARY_OVER_TIME',
  MESSAGES_COUNT_BY_DIRECTION_AND_TYPE = 'MESSAGES_COUNT_BY_DIRECTION_AND_TYPE',
  MESSAGES_WHATSAPP_OUTBOUND_COUNT_BY_TYPE_COUNTRY_AND_TEMPLATE = 'MESSAGES_WHATSAPP_OUTBOUND_COUNT_BY_TYPE_COUNTRY_AND_TEMPLATE',
  USER_AVAILABILITY_AFTER_CALL_WORK_TIME_BY_USER = 'USER_AVAILABILITY_AFTER_CALL_WORK_TIME_BY_USER',
  USER_AVAILABILITY_OVERVIEW_LAST_WEEK = 'USER_AVAILABILITY_OVERVIEW_LAST_WEEK',
  USER_AVAILABILITY_TIME_IN_STATUS = 'USER_AVAILABILITY_TIME_IN_STATUS',
  USER_AVAILABILITY_TIME_IN_STATUS_PERCENTAGE = 'USER_AVAILABILITY_TIME_IN_STATUS_PERCENTAGE',
  USER_AVAILABILITY_TIME_IN_STATUS_PERCENTAGE_BY_USER = 'USER_AVAILABILITY_TIME_IN_STATUS_PERCENTAGE_BY_USER',
  USER_AVAILABILITY_WORK_TIME_BY_USER = 'USER_AVAILABILITY_WORK_TIME_BY_USER'
}

export type AnalyticsMultipleValueMetricResult = AnalyticsMultipleValueMetric | GenericException | ResourceNotFoundException | RetryableException;

export type AnalyticsOutboundCampaign = {
  __typename?: 'AnalyticsOutboundCampaign';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AnalyticsOutboundCampaignFilter = {
  __typename?: 'AnalyticsOutboundCampaignFilter';
  items: Array<AnalyticsOutboundCampaign>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsOutboundCampaignFilterResult = AnalyticsOutboundCampaignFilter | GenericException | ResourceNotFoundException | RetryableException;

export type AnalyticsPreset = {
  __typename?: 'AnalyticsPreset';
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  customFields?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  source: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  userId: Scalars['String']['output'];
};

export type AnalyticsPresetList = {
  __typename?: 'AnalyticsPresetList';
  items: Array<AnalyticsPreset>;
};

export type AnalyticsPresetListResult = AnalyticsPresetList | GenericException | ResourceNotFoundException | RetryableException;

export type AnalyticsPresetResult = AnalyticsPreset | GenericException | ResourceNotFoundException | RetryableException;

export enum AnalyticsRelativeTime {
  LAST_MONTH = 'LAST_MONTH',
  LAST_WEEK = 'LAST_WEEK',
  THIS_MONTH = 'THIS_MONTH',
  THIS_WEEK = 'THIS_WEEK',
  THIS_YEAR = 'THIS_YEAR',
  TODAY = 'TODAY',
  YESTERDAY = 'YESTERDAY'
}

export enum AnalyticsReportName {
  CALLS_HISTORY = 'CALLS_HISTORY',
  USER_ACTIVITY_AVAILABILITY_BREAKDOWN = 'USER_ACTIVITY_AVAILABILITY_BREAKDOWN',
  USER_ACTIVITY_AVERAGE_AFTER_CALL_WORK_TIME_PER_USER = 'USER_ACTIVITY_AVERAGE_AFTER_CALL_WORK_TIME_PER_USER',
  USER_ACTIVITY_AVERAGE_INBOUND_IN_CALL_TIME_PER_USER = 'USER_ACTIVITY_AVERAGE_INBOUND_IN_CALL_TIME_PER_USER',
  USER_ACTIVITY_AVERAGE_OUTBOUND_IN_CALL_TIME_PER_USER = 'USER_ACTIVITY_AVERAGE_OUTBOUND_IN_CALL_TIME_PER_USER',
  USER_ACTIVITY_CALLS_HANDLED = 'USER_ACTIVITY_CALLS_HANDLED',
  USER_ACTIVITY_CALL_VOLUME_AND_TIME = 'USER_ACTIVITY_CALL_VOLUME_AND_TIME',
  USER_ACTIVITY_PERCENTAGE_OF_TIME_IN_EACH_STATUS = 'USER_ACTIVITY_PERCENTAGE_OF_TIME_IN_EACH_STATUS',
  USER_ACTIVITY_RINGING_ATTEMPTS = 'USER_ACTIVITY_RINGING_ATTEMPTS',
  USER_ACTIVITY_RINGING_ATTEMPTS_PER_USER = 'USER_ACTIVITY_RINGING_ATTEMPTS_PER_USER',
  USER_ACTIVITY_WORK_TIME_AND_AVAILABILITY = 'USER_ACTIVITY_WORK_TIME_AND_AVAILABILITY',
  USER_STATUS_HISTORY = 'USER_STATUS_HISTORY'
}

export type AnalyticsRingAttempt = {
  __typename?: 'AnalyticsRingAttempt';
  callAnsweredAt?: Maybe<Scalars['AWSDateTime']['output']>;
  callCustomerPhoneNumber?: Maybe<Scalars['String']['output']>;
  callDirection: AnalyticsCallDirection;
  callHasSubsequentCall: Scalars['Boolean']['output'];
  callHasVoicemail: Scalars['Boolean']['output'];
  callId?: Maybe<Scalars['ID']['output']>;
  callIsAnswered: Scalars['Boolean']['output'];
  callUnansweredReason?: Maybe<AnalyticsUnansweredReason>;
  callUuid: Scalars['String']['output'];
  eventCreatedAt: Scalars['AWSDateTime']['output'];
  eventOutcome: AnalyticsRingAttemptOutcome;
  eventOutcomeReason?: Maybe<AnalyticsRingAttemptOutcomeReason>;
  line?: Maybe<AnalyticsLine>;
  ringOrigin?: Maybe<AnalyticsRingAttemptRingOrigin>;
  user?: Maybe<AnalyticsUser>;
};

export enum AnalyticsRingAttemptOrigin {
  ALL = 'ALL',
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL'
}

export enum AnalyticsRingAttemptOutcome {
  NOT_PICKED_UP = 'NOT_PICKED_UP',
  PICKED_UP = 'PICKED_UP'
}

export enum AnalyticsRingAttemptOutcomeReason {
  AGENT_DECLINED = 'AGENT_DECLINED',
  ANOTHER_AGENT_ANSWERED = 'ANOTHER_AGENT_ANSWERED',
  AUTOMATIC_CALLBACK = 'AUTOMATIC_CALLBACK',
  CALLER_HUNG_UP = 'CALLER_HUNG_UP',
  CALL_TRANSFERRED = 'CALL_TRANSFERRED',
  EXTENSION_DIALED = 'EXTENSION_DIALED',
  TIMED_OUT = 'TIMED_OUT'
}

export enum AnalyticsRingAttemptRingOrigin {
  ANONYMOUS = 'ANONYMOUS',
  AUTOMATIC_CALLBACK = 'AUTOMATIC_CALLBACK',
  CONFERENCE = 'CONFERENCE',
  INBOUND = 'INBOUND',
  TRANSFER = 'TRANSFER',
  WARM_TRANSFER = 'WARM_TRANSFER'
}

export type AnalyticsSearchFilter = {
  __typename?: 'AnalyticsSearchFilter';
  items: Array<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsSearchFiltersInput = {
  searchIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsSharePresetInput = {
  id: Scalars['ID']['input'];
  slug: Scalars['String']['input'];
  targetUserId: Scalars['ID']['input'];
};

export type AnalyticsSingleValueMetric = {
  __typename?: 'AnalyticsSingleValueMetric';
  cachedAt: Scalars['AWSDateTime']['output'];
  previousPeriodDifferenceValue?: Maybe<Scalars['Float']['output']>;
  previousPeriodDifferenceValueType?: Maybe<AnalyticsMetricValueType>;
  value: Scalars['Float']['output'];
  valueType: AnalyticsMetricValueType;
};

export type AnalyticsSingleValueMetricDrillDownInput = {
  filter: AnalyticsFilter;
  metricName: AnalyticsSingleValueMetricName;
  options?: InputMaybe<AnalyticsMetricOptionsInput>;
};

export type AnalyticsSingleValueMetricInput = {
  comparisonOptions?: InputMaybe<AnalyticsMetricPreviousPeriodComparisonOptionsInput>;
  filter: AnalyticsFilter;
  metricName: AnalyticsSingleValueMetricName;
  options?: InputMaybe<AnalyticsMetricOptionsInput>;
};

export enum AnalyticsSingleValueMetricName {
  CALLS_COUNT = 'CALLS_COUNT',
  CALLS_INBOUND_ANSWERED_BY_AI_VOICE_AGENT_COUNT = 'CALLS_INBOUND_ANSWERED_BY_AI_VOICE_AGENT_COUNT',
  CALLS_INBOUND_ANSWERED_BY_AI_VOICE_AGENT_PERCENTAGE = 'CALLS_INBOUND_ANSWERED_BY_AI_VOICE_AGENT_PERCENTAGE',
  CALLS_INBOUND_ANSWERED_COUNT = 'CALLS_INBOUND_ANSWERED_COUNT',
  CALLS_INBOUND_ANSWERED_PERCENTAGE = 'CALLS_INBOUND_ANSWERED_PERCENTAGE',
  CALLS_INBOUND_ANSWERED_PER_UNIQUE_CALLER_AVERAGE = 'CALLS_INBOUND_ANSWERED_PER_UNIQUE_CALLER_AVERAGE',
  CALLS_INBOUND_ANSWERED_SLA_COUNT = 'CALLS_INBOUND_ANSWERED_SLA_COUNT',
  CALLS_INBOUND_ANSWERED_SLA_PERCENTAGE = 'CALLS_INBOUND_ANSWERED_SLA_PERCENTAGE',
  CALLS_INBOUND_CALLBACK_PENDING_TIME_AVERAGE = 'CALLS_INBOUND_CALLBACK_PENDING_TIME_AVERAGE',
  CALLS_INBOUND_CALLBACK_REQUEST_NOT_CALLED_BACK_COUNT = 'CALLS_INBOUND_CALLBACK_REQUEST_NOT_CALLED_BACK_COUNT',
  CALLS_INBOUND_CALLBACK_REQUEST_NOT_CALLED_BACK_PERCENTAGE = 'CALLS_INBOUND_CALLBACK_REQUEST_NOT_CALLED_BACK_PERCENTAGE',
  CALLS_INBOUND_COUNT = 'CALLS_INBOUND_COUNT',
  CALLS_INBOUND_IN_CALL_TIME_AVERAGE = 'CALLS_INBOUND_IN_CALL_TIME_AVERAGE',
  CALLS_INBOUND_IN_CALL_TIME_WITH_AI_VOICE_AGENT_AVERAGE = 'CALLS_INBOUND_IN_CALL_TIME_WITH_AI_VOICE_AGENT_AVERAGE',
  CALLS_INBOUND_MISSED_PERCENTAGE = 'CALLS_INBOUND_MISSED_PERCENTAGE',
  CALLS_INBOUND_TIME_TO_ANSWER_AVERAGE = 'CALLS_INBOUND_TIME_TO_ANSWER_AVERAGE',
  CALLS_INBOUND_UNANSWERED_COUNT = 'CALLS_INBOUND_UNANSWERED_COUNT',
  CALLS_INBOUND_UNANSWERED_NO_SUBSEQUENT_CALL_COUNT = 'CALLS_INBOUND_UNANSWERED_NO_SUBSEQUENT_CALL_COUNT',
  CALLS_INBOUND_UNANSWERED_NO_SUBSEQUENT_CALL_PERCENTAGE = 'CALLS_INBOUND_UNANSWERED_NO_SUBSEQUENT_CALL_PERCENTAGE',
  CALLS_INBOUND_UNANSWERED_PERCENTAGE = 'CALLS_INBOUND_UNANSWERED_PERCENTAGE',
  CALLS_INBOUND_UNANSWERED_UNIQUE_CALLERS_COUNT = 'CALLS_INBOUND_UNANSWERED_UNIQUE_CALLERS_COUNT',
  CALLS_INBOUND_UNANSWERED_UNIQUE_CALLERS_PERCENTAGE = 'CALLS_INBOUND_UNANSWERED_UNIQUE_CALLERS_PERCENTAGE',
  CALLS_INBOUND_UNANSWERED_WAIT_TIME_AVERAGE = 'CALLS_INBOUND_UNANSWERED_WAIT_TIME_AVERAGE',
  CALLS_INBOUND_UNIQUE_CALLERS_COUNT = 'CALLS_INBOUND_UNIQUE_CALLERS_COUNT',
  CALLS_INBOUND_WAIT_TIME_AVERAGE = 'CALLS_INBOUND_WAIT_TIME_AVERAGE',
  CALLS_INBOUND_WITH_AI_VOICE_AGENT_COUNT = 'CALLS_INBOUND_WITH_AI_VOICE_AGENT_COUNT',
  CALLS_INBOUND_WITH_AI_VOICE_AGENT_PERCENTAGE = 'CALLS_INBOUND_WITH_AI_VOICE_AGENT_PERCENTAGE',
  CALLS_IN_CALL_TIME_AVERAGE = 'CALLS_IN_CALL_TIME_AVERAGE',
  CALLS_OUTBOUND_CAMPAIGN_ATTEMPTS_BEFORE_PICKUP_AVERAGE = 'CALLS_OUTBOUND_CAMPAIGN_ATTEMPTS_BEFORE_PICKUP_AVERAGE',
  CALLS_OUTBOUND_CONNECTED_COUNT = 'CALLS_OUTBOUND_CONNECTED_COUNT',
  CALLS_OUTBOUND_CONNECTED_IN_CALL_TIME_TOTAL = 'CALLS_OUTBOUND_CONNECTED_IN_CALL_TIME_TOTAL',
  CALLS_OUTBOUND_CONNECTED_PERCENTAGE = 'CALLS_OUTBOUND_CONNECTED_PERCENTAGE',
  CALLS_OUTBOUND_COUNT = 'CALLS_OUTBOUND_COUNT',
  CALLS_OUTBOUND_IN_CALL_TIME_AVERAGE = 'CALLS_OUTBOUND_IN_CALL_TIME_AVERAGE',
  CALLS_OUTBOUND_IN_CALL_TIME_WITH_AI_VOICE_AGENT_AVERAGE = 'CALLS_OUTBOUND_IN_CALL_TIME_WITH_AI_VOICE_AGENT_AVERAGE',
  CALLS_OUTBOUND_PICKED_UP_IN_CALL_TIME_AVERAGE = 'CALLS_OUTBOUND_PICKED_UP_IN_CALL_TIME_AVERAGE',
  CALLS_OUTBOUND_PICKED_UP_IN_CALL_TIME_TOTAL = 'CALLS_OUTBOUND_PICKED_UP_IN_CALL_TIME_TOTAL',
  CALLS_OUTBOUND_PICKED_UP_PERCENTAGE = 'CALLS_OUTBOUND_PICKED_UP_PERCENTAGE',
  CALLS_OUTBOUND_WITH_AI_VOICE_AGENT_COUNT = 'CALLS_OUTBOUND_WITH_AI_VOICE_AGENT_COUNT',
  CALLS_OUTBOUND_WITH_AI_VOICE_AGENT_PERCENTAGE = 'CALLS_OUTBOUND_WITH_AI_VOICE_AGENT_PERCENTAGE',
  CALLS_UNTAGGED_PERCENTAGE = 'CALLS_UNTAGGED_PERCENTAGE',
  MESSAGES_MMS_COUNT = 'MESSAGES_MMS_COUNT',
  MESSAGES_MMS_INBOUND_COUNT = 'MESSAGES_MMS_INBOUND_COUNT',
  MESSAGES_MMS_OUTBOUND_COUNT = 'MESSAGES_MMS_OUTBOUND_COUNT',
  MESSAGES_SMS_COUNT = 'MESSAGES_SMS_COUNT',
  MESSAGES_SMS_INBOUND_COUNT = 'MESSAGES_SMS_INBOUND_COUNT',
  MESSAGES_SMS_INBOUND_SEGMENTS_COUNT = 'MESSAGES_SMS_INBOUND_SEGMENTS_COUNT',
  MESSAGES_SMS_OUTBOUND_COUNT = 'MESSAGES_SMS_OUTBOUND_COUNT',
  MESSAGES_SMS_OUTBOUND_SEGMENTS_COUNT = 'MESSAGES_SMS_OUTBOUND_SEGMENTS_COUNT',
  MESSAGES_SMS_OUTBOUND_WITH_AI_MESSAGING_AGENT_COUNT = 'MESSAGES_SMS_OUTBOUND_WITH_AI_MESSAGING_AGENT_COUNT',
  MESSAGES_SMS_SEGMENTS_COUNT = 'MESSAGES_SMS_SEGMENTS_COUNT',
  MESSAGES_WHATSAPP_COUNT = 'MESSAGES_WHATSAPP_COUNT',
  MESSAGES_WHATSAPP_INBOUND_COUNT = 'MESSAGES_WHATSAPP_INBOUND_COUNT',
  MESSAGES_WHATSAPP_OUTBOUND_COUNT = 'MESSAGES_WHATSAPP_OUTBOUND_COUNT',
  MESSAGES_WHATSAPP_OUTBOUND_WITH_AI_MESSAGING_AGENT_COUNT = 'MESSAGES_WHATSAPP_OUTBOUND_WITH_AI_MESSAGING_AGENT_COUNT',
  USER_AVAILABILITY_TIME_AFTER_CALL_WORK_AVERAGE = 'USER_AVAILABILITY_TIME_AFTER_CALL_WORK_AVERAGE',
  USER_AVAILABILITY_TIME_AVAILABLE_PERCENTAGE = 'USER_AVAILABILITY_TIME_AVAILABLE_PERCENTAGE',
  USER_AVAILABILITY_TIME_BUSY_PERCENTAGE = 'USER_AVAILABILITY_TIME_BUSY_PERCENTAGE',
  USER_AVAILABILITY_TIME_UNAVAILABLE_PERCENTAGE = 'USER_AVAILABILITY_TIME_UNAVAILABLE_PERCENTAGE'
}

export type AnalyticsSingleValueMetricResult = AnalyticsSingleValueMetric | GenericException | ResourceNotFoundException | RetryableException;

export enum AnalyticsSortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type AnalyticsSortInput = {
  field: Scalars['String']['input'];
  order: AnalyticsSortDirection;
};

export type AnalyticsTag = {
  __typename?: 'AnalyticsTag';
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type AnalyticsTagFilter = {
  __typename?: 'AnalyticsTagFilter';
  items: Array<AnalyticsTag>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsTagFilterResult = AnalyticsTagFilter | GenericException | ResourceNotFoundException | RetryableException;

export type AnalyticsTeam = {
  __typename?: 'AnalyticsTeam';
  id: Scalars['ID']['output'];
  imageName?: Maybe<Scalars['String']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type AnalyticsTeamFilter = {
  __typename?: 'AnalyticsTeamFilter';
  items: Array<AnalyticsTeam>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum AnalyticsTeamFilterOption {
  CALLS_ROUTED_TO_TEAM = 'CALLS_ROUTED_TO_TEAM',
  USERS_BELONG_TO_TEAM = 'USERS_BELONG_TO_TEAM'
}

export type AnalyticsTeamFilterResult = AnalyticsTeamFilter | GenericException | ResourceNotFoundException | RetryableException;

export enum AnalyticsUnansweredReason {
  ABANDONED_BEFORE_10_SECONDS = 'ABANDONED_BEFORE_10_SECONDS',
  ABANDONED_DURING_WELCOME_MESSAGE = 'ABANDONED_DURING_WELCOME_MESSAGE',
  ABANDONED_IN_IVR = 'ABANDONED_IN_IVR',
  ALL_AGENTS_UNAVAILABLE = 'ALL_AGENTS_UNAVAILABLE',
  CALLBACK_REQUEST = 'CALLBACK_REQUEST',
  OUTSIDE_BUSINESS_HOURS = 'OUTSIDE_BUSINESS_HOURS',
  USERS_DID_NOT_ANSWER = 'USERS_DID_NOT_ANSWER'
}

export type AnalyticsUpdatePresetInput = {
  customFields?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDefault: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  options?: InputMaybe<Scalars['String']['input']>;
  preferences?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};

export type AnalyticsUser = {
  __typename?: 'AnalyticsUser';
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
};

export type AnalyticsUserEvent = {
  __typename?: 'AnalyticsUserEvent';
  createdAt: Scalars['AWSDateTime']['output'];
  duration: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  pickupTime: Scalars['Int']['output'];
  status: AnalyticsUserEventStatusName;
  user?: Maybe<AnalyticsUser>;
};

export enum AnalyticsUserEventStatusName {
  AVAILABLE = 'AVAILABLE',
  BUSY = 'BUSY',
  UNAVAILABLE = 'UNAVAILABLE'
}

export type AnalyticsUserFilter = {
  __typename?: 'AnalyticsUserFilter';
  items: Array<AnalyticsUser>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsUserFilterResult = AnalyticsUserFilter | GenericException | ResourceNotFoundException | RetryableException;

export enum AnalyticsUserStatus {
  AFTER_CALL_WORK = 'AFTER_CALL_WORK',
  AVAILABLE = 'AVAILABLE',
  DOING_BACK_OFFICE = 'DOING_BACK_OFFICE',
  DO_NOT_DISTURB = 'DO_NOT_DISTURB',
  IN_CALL = 'IN_CALL',
  IN_TRAINING = 'IN_TRAINING',
  OFFLINE = 'OFFLINE',
  ON_A_BREAK = 'ON_A_BREAK',
  ON_MOBILE = 'ON_MOBILE',
  OTHER = 'OTHER',
  OUT_FOR_LUNCH = 'OUT_FOR_LUNCH',
  RINGING = 'RINGING',
  STATE_UNSPECIFIED = 'STATE_UNSPECIFIED'
}

export type AnalyticsUserStatusHistory = {
  __typename?: 'AnalyticsUserStatusHistory';
  cachedAt: Scalars['AWSDateTime']['output'];
  items: Array<AnalyticsUserStatusHistoryEntry>;
  pageInfo: PagingInfo;
};

export type AnalyticsUserStatusHistoryEntry = {
  __typename?: 'AnalyticsUserStatusHistoryEntry';
  id: Scalars['ID']['output'];
  nextStatus?: Maybe<AnalyticsUserStatus>;
  status: AnalyticsUserStatus;
  statusEndedAtTime?: Maybe<Scalars['AWSDateTime']['output']>;
  statusStartedAtTime: Scalars['AWSDateTime']['output'];
  timeInStatus: Scalars['String']['output'];
  timeInStatusSeconds: Scalars['Int']['output'];
  user: AnalyticsUser;
};

export type AnalyticsUserStatusHistoryResult = AnalyticsUserStatusHistory | GenericException | ResourceNotFoundException | RetryableException;

export type AnalyticsVirtualVoiceAgent = {
  __typename?: 'AnalyticsVirtualVoiceAgent';
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type AnalyticsVirtualVoiceAgentFilter = {
  __typename?: 'AnalyticsVirtualVoiceAgentFilter';
  items: Array<AnalyticsVirtualVoiceAgent>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsVirtualVoiceAgentFilterResult = AnalyticsVirtualVoiceAgentFilter | GenericException | ResourceNotFoundException | RetryableException;

export type ApiKey = {
  __typename?: 'ApiKey';
  apiId: Scalars['String']['output'];
  apiSecret?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ApiKeyConfig = {
  __typename?: 'ApiKeyConfig';
  keyName: Scalars['String']['output'];
  keyValueConfigured: Scalars['Boolean']['output'];
  location: ApiKeyLocation;
};

export type ApiKeyConfigInput = {
  keyName: Scalars['String']['input'];
  keyValue: Scalars['String']['input'];
  location?: InputMaybe<ApiKeyLocation>;
};

export enum ApiKeyLocation {
  header = 'header',
  query = 'query'
}

export type AppDownloadUrls = {
  __typename?: 'AppDownloadUrls';
  name?: Maybe<Scalars['String']['output']>;
  urlMac?: Maybe<Scalars['String']['output']>;
  urlMacPkg?: Maybe<Scalars['String']['output']>;
  urlWin?: Maybe<Scalars['String']['output']>;
  urlWinMsi?: Maybe<Scalars['String']['output']>;
};

export type AppIcon = {
  __typename?: 'AppIcon';
  png?: Maybe<Scalars['String']['output']>;
  svg?: Maybe<Scalars['String']['output']>;
};

export enum AppType {
  AIRCALL_PHONE = 'AIRCALL_PHONE',
  AIRCALL_WORKSPACE = 'AIRCALL_WORKSPACE'
}

export type AppVersion = {
  __typename?: 'AppVersion';
  becomesObsoleteAt?: Maybe<Scalars['String']['output']>;
  minOSVersion?: Maybe<Scalars['String']['output']>;
  status: AppVersionStatus;
};

export enum AppVersionStatus {
  deprecated = 'deprecated',
  obsolete = 'obsolete',
  ok = 'ok',
  os_deprecated = 'os_deprecated'
}

export type Application = {
  __typename?: 'Application';
  ai_actions_enabled_companies?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  auth_type?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Array<Maybe<Categories>>>;
  comingSoon: Scalars['Boolean']['output'];
  creation_date?: Maybe<Scalars['String']['output']>;
  developer?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  mcp_url?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  owner?: Maybe<Scalars['String']['output']>;
  partner_bearer_token_configured?: Maybe<Scalars['Boolean']['output']>;
  partner_oauth_app_id?: Maybe<Scalars['String']['output']>;
  partner_oauth_client_id?: Maybe<Scalars['String']['output']>;
  partner_oauth_client_secret_configured?: Maybe<Scalars['Boolean']['output']>;
  partner_oauth_grant_type?: Maybe<Scalars['String']['output']>;
  partner_oauth_install_url?: Maybe<Scalars['String']['output']>;
  partner_oauth_redirect_uri?: Maybe<Scalars['String']['output']>;
  partner_oauth_refresh_token_url?: Maybe<Scalars['String']['output']>;
  partner_oauth_scopes?: Maybe<Scalars['String']['output']>;
  partner_oauth_token_url?: Maybe<Scalars['String']['output']>;
  publication_status?: Maybe<Scalars['String']['output']>;
  secret_expiration?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  subtitle?: Maybe<Subtitle>;
  url_type?: Maybe<Scalars['String']['output']>;
};

export type ApplicationAuthHeader = {
  __typename?: 'ApplicationAuthHeader';
  appliesToDispatch: Scalars['Boolean']['output'];
  hubApplicationId: Scalars['String']['output'];
  inheritedCredentialHeader?: Maybe<Scalars['String']['output']>;
};

export type ApplicationSetup = {
  __typename?: 'ApplicationSetup';
  events?: Maybe<EventEntry>;
  fields?: Maybe<Array<Scalars['String']['output']>>;
  urlFormat?: Maybe<Scalars['String']['output']>;
};

export type ArchiveOutboundCampaignOutput = GenericException | OutboundCampaign | ResourceNotFoundException | UnprocessableResourceException;

export type ArgAssertionInput = {
  arg: Scalars['String']['input'];
  expected?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleSelectionInput = {
  article_id: Scalars['String']['input'];
  article_name?: InputMaybe<Scalars['String']['input']>;
};

export type AssignActivationLicensesInput = {
  userIds: Array<Scalars['ID']['input']>;
};

export type AssignActivationLicensesOutput = ActivationCapabilityDisabled | ActivationForbidden | ActivationLicensesNotApplicable | ActivationRequestException | ActivationUnauthenticated | AssignActivationLicensesResult | GenericException | UserInputException;

export type AssignActivationLicensesResult = {
  __typename?: 'AssignActivationLicensesResult';
  companyId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  outcomes: Array<ActivationLicenseAssignmentOutcome>;
};

export type AssignCustomSummaryConfigurationInput = {
  configurations: Array<CustomSummaryConfigurationInput>;
};

export type AssignCustomSummaryConfigurationOutput = AssignCustomSummaryConfigurationResult | CustomSummaryException | GenericException | InsufficientLicenseException | UserInputException;

export type AssignCustomSummaryConfigurationResult = {
  __typename?: 'AssignCustomSummaryConfigurationResult';
  isSuccess: Scalars['Boolean']['output'];
};

export type AssignEngagement = Engagement & {
  __typename?: 'AssignEngagement';
  ID: Scalars['ID']['output'];
  assignedTo: PhoneTeammateResolver;
  author: PhoneTeammateResolver;
  createdAt: Scalars['AWSDateTime']['output'];
};

export type AssignEsimInput = {
  agentId?: InputMaybe<Scalars['Int']['input']>;
  esimLicense: Scalars['String']['input'];
  numberUUID: Scalars['String']['input'];
};

export type AssignEsimResponse = {
  __typename?: 'AssignEsimResponse';
  esimLicense: Scalars['String']['output'];
  numberUUID: Scalars['String']['output'];
};

export type AssignLicensesInput = {
  autoAssign?: InputMaybe<Scalars['Boolean']['input']>;
  licenseName: Scalars['String']['input'];
  users: Array<LicenseUserInput>;
};

export type AssignLicensesOutput = {
  __typename?: 'AssignLicensesOutput';
  error?: Maybe<Error>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AssignOutboundCampaignTeamsInput = {
  teamIDs: Array<Scalars['ID']['input']>;
};

export type AssignOutboundCampaignTeamsOutput = GenericException | OutboundCampaign | OutboundCampaignTeamConnection | ResourceNotFoundException | UnprocessableResourceException | UserInputException;

export type AssignOutboundCampaignUsersInput = {
  userIDs: Array<Scalars['ID']['input']>;
};

export type AssignOutboundCampaignUsersOutput = GenericException | OutboundCampaign | OutboundCampaignUserConnection | ResourceNotFoundException | UnprocessableResourceException | UserInputException;

export type AssignPlaybookSettingsInput = {
  allowPlaybookSwitching?: InputMaybe<Scalars['Boolean']['input']>;
  lineId: Scalars['ID']['input'];
  playbookId: Scalars['ID']['input'];
};

export type AssignPlaybookSettingsOutput = AssignPlaybookSettingsResult | GenericException | InsufficientLicenseException | UserInputException;

export type AssignPlaybookSettingsResult = {
  __typename?: 'AssignPlaybookSettingsResult';
  isSuccess: Scalars['Boolean']['output'];
};

export type AssignRolesToUserInput = {
  authorizedEntities?: InputMaybe<Array<AuthorizedEntityInput>>;
  roleIds: Array<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type AssignRolesToUserOutput = {
  __typename?: 'AssignRolesToUserOutput';
  authorizedEntities?: Maybe<Array<AuthorizedEntity>>;
  roleIds: Array<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type AssignedNumber = {
  __typename?: 'AssignedNumber';
  esimLicense: Scalars['String']['output'];
  numberUUID: Scalars['String']['output'];
};

export enum AssignedStatus {
  ASSIGNED_TO_ME = 'ASSIGNED_TO_ME',
  UNASSIGNED = 'UNASSIGNED'
}

export type AttachLongTailSourceInputInput = {
  contentUri?: InputMaybe<Scalars['String']['input']>;
  inlineContent?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  registrationSessionId: Scalars['ID']['input'];
  sourceKind: LongTailSourceKind;
};

export type AttachLongTailSourceInputOutput = GenericException | LongTailSessionAlreadyRegisteredException | LongTailSourceInput | RegistrationSessionNotFoundException | SecretDetectedException | UnsupportedSourceKindException | UserInputException;

export enum AudioType {
  CONFERENCE = 'CONFERENCE',
  VOICEMAIL = 'VOICEMAIL'
}

export type AuthMethod = {
  __typename?: 'AuthMethod';
  ID: Scalars['ID']['output'];
  actionCount: Scalars['Int']['output'];
  apiKey?: Maybe<ApiKeyConfig>;
  authType: AuthMethodType;
  baseUrl?: Maybe<Scalars['String']['output']>;
  basicAuth?: Maybe<BasicAuthConfig>;
  bearerToken?: Maybe<BearerTokenConfig>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  lastUsedAt?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  oauth?: Maybe<OAuthConfig>;
  resourceOwnerPassword?: Maybe<ResourceOwnerPasswordConfig>;
  serviceName?: Maybe<Scalars['String']['output']>;
  status: AuthMethodStatus;
  updatedAt: Scalars['String']['output'];
  usageCount: Scalars['Int']['output'];
};

export type AuthMethodOutput = AuthMethod | GenericException | ResourceNotFoundException | UserInputException;

export enum AuthMethodStatus {
  ACTIVE = 'ACTIVE',
  ERROR = 'ERROR',
  INACTIVE = 'INACTIVE'
}

export enum AuthMethodType {
  API_KEY = 'API_KEY',
  BASIC_AUTH = 'BASIC_AUTH',
  BEARER_TOKEN = 'BEARER_TOKEN',
  OAUTH = 'OAUTH',
  RESOURCE_OWNER_PASSWORD = 'RESOURCE_OWNER_PASSWORD'
}

export type AuthMethodsPaginatedOutput = {
  __typename?: 'AuthMethodsPaginatedOutput';
  items: Array<AuthMethod>;
  pageInfo?: Maybe<SmartflowsPageInfo>;
};

export type Authorizations = PresenceChannel | PrivateChannel | PrivateEncryptedChannel | PublicChannel;

export type AuthorizeApplicationInput = {
  clientId: Scalars['String']['input'];
  numberIds: Array<Scalars['String']['input']>;
  redirectUri: Scalars['String']['input'];
  responseType: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  v2?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AuthorizeApplicationMutationInput = {
  clientId: Scalars['String']['input'];
  numberIds: Array<Scalars['String']['input']>;
  redirectUri: Scalars['String']['input'];
  responseType: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorizeApplicationOutput = {
  __typename?: 'AuthorizeApplicationOutput';
  redirectUri: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type AuthorizeApplicationResponse = {
  __typename?: 'AuthorizeApplicationResponse';
  redirectUri: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type AuthorizeChannelsInput = {
  channelPayloads: Array<ChannelPayload>;
  cluster?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorizeChannelsOutput = {
  __typename?: 'AuthorizeChannelsOutput';
  authorizations: Array<Authorizations>;
};

export type AuthorizeZendeskQueryResponse = {
  __typename?: 'AuthorizeZendeskQueryResponse';
  redirectTo: Scalars['String']['output'];
};

export type AuthorizedApplication = {
  __typename?: 'AuthorizedApplication';
  clientId: Scalars['String']['output'];
  logo: Scalars['String']['output'];
  name: Scalars['String']['output'];
  redirectUri: Scalars['String']['output'];
  responseType: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  source: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
};

export type AuthorizedEntity = {
  __typename?: 'AuthorizedEntity';
  entityIds: Array<Scalars['ID']['output']>;
  entityType: AuthorizedEntityType;
};

export type AuthorizedEntityInput = {
  entityIds: Array<Scalars['ID']['input']>;
  entityType: AuthorizedEntityType;
};

export enum AuthorizedEntityType {
  NUMBER = 'NUMBER',
  TEAM = 'TEAM',
  USER = 'USER'
}

export type AutocompleteItem = {
  __typename?: 'AutocompleteItem';
  highlighted: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AutocompleteResult = {
  __typename?: 'AutocompleteResult';
  items: Array<Maybe<AutocompleteItem>>;
  total: Scalars['Int']['output'];
};

export type Automation = {
  __typename?: 'Automation';
  ID: Scalars['ID']['output'];
  companyId: Scalars['ID']['output'];
  config: AutomationConfig;
  createdAt: Scalars['AWSDateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  filters: AutomationFilters;
  name: Scalars['String']['output'];
  scoreCardId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type AutomationConfig = {
  __typename?: 'AutomationConfig';
  targetAgent?: Maybe<TargetAgentOption>;
};

export type AutomationConfigInput = {
  targetAgent?: InputMaybe<TargetAgentOption>;
};

export type AutomationFilters = {
  __typename?: 'AutomationFilters';
  callDirections?: Maybe<Array<CallDirection>>;
  durationRange?: Maybe<DurationRange>;
  numbers?: Maybe<Array<Scalars['ID']['output']>>;
  schedules?: Maybe<Array<Scalars['String']['output']>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tagsLogic?: Maybe<TagsLogic>;
  users?: Maybe<Array<Scalars['ID']['output']>>;
};

export type AutomationFiltersInput = {
  callDirections?: InputMaybe<Array<CallDirection>>;
  durationRange?: InputMaybe<DurationRangeInput>;
  numbers?: InputMaybe<Array<Scalars['ID']['input']>>;
  schedules?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tagsLogic?: InputMaybe<TagsLogic>;
  users?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum Availability {
  ALWAYS_CLOSED = 'ALWAYS_CLOSED',
  ALWAYS_OPENED = 'ALWAYS_OPENED',
  CUSTOM = 'CUSTOM'
}

export type AvailabilityInput = {
  preference?: InputMaybe<AvailabilityPreference>;
};

export enum AvailabilityPreference {
  ALWAYS_CLOSED = 'ALWAYS_CLOSED',
  ALWAYS_OPENED = 'ALWAYS_OPENED',
  AUTO = 'AUTO',
  DOING_BACK_OFFICE = 'DOING_BACK_OFFICE',
  IN_TRAINING = 'IN_TRAINING',
  ON_A_BREAK = 'ON_A_BREAK',
  OTHER = 'OTHER',
  OUT_FOR_LUNCH = 'OUT_FOR_LUNCH'
}

export type AvailabilitySlot = {
  __typename?: 'AvailabilitySlot';
  days: Array<DayOfWeek>;
  from: Scalars['Int']['output'];
  to: Scalars['Int']['output'];
};

export type AvailabilitySlotInput = {
  days: Array<DayOfWeek>;
  from: Scalars['Int']['input'];
  to: Scalars['Int']['input'];
};

export enum AvailabilityStatus {
  AFTER_CALL_WORK = 'AFTER_CALL_WORK',
  AVAILABLE = 'AVAILABLE',
  DOING_BACK_OFFICE = 'DOING_BACK_OFFICE',
  DO_NOT_DISTURB = 'DO_NOT_DISTURB',
  IN_CALL = 'IN_CALL',
  IN_TRAINING = 'IN_TRAINING',
  OFFLINE = 'OFFLINE',
  ON_A_BREAK = 'ON_A_BREAK',
  ON_MOBILE = 'ON_MOBILE',
  OTHER = 'OTHER',
  OUT_FOR_LUNCH = 'OUT_FOR_LUNCH',
  RINGING = 'RINGING'
}

export type AvailableCoreKbIntegration = {
  __typename?: 'AvailableCoreKBIntegration';
  application_id: Scalars['String']['output'];
  icon_url?: Maybe<Scalars['String']['output']>;
  integration_id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  subtitle: Scalars['String']['output'];
};

export type AvailableCoreKbIntegrationArticle = {
  __typename?: 'AvailableCoreKBIntegrationArticle';
  article_id: Scalars['String']['output'];
  article_name: Scalars['String']['output'];
  clean_char_count?: Maybe<Scalars['Int']['output']>;
  raw_char_count?: Maybe<Scalars['Int']['output']>;
};

export type AvailableCoreKbIntegrationArticleList = {
  __typename?: 'AvailableCoreKBIntegrationArticleList';
  articles: Array<AvailableCoreKbIntegrationArticle>;
  status: Scalars['String']['output'];
};

export type AvailableCoreKbIntegrationArticlesResult = AvailableCoreKbIntegrationArticleList | GenericException;

export type AvailableCoreKbIntegrationList = {
  __typename?: 'AvailableCoreKBIntegrationList';
  integrations: Array<AvailableCoreKbIntegration>;
};

export type AvailableCoreKbIntegrationsResult = AvailableCoreKbIntegrationList | GenericException;

export type AvailableExtensions = {
  __typename?: 'AvailableExtensions';
  extensions: Array<Scalars['String']['output']>;
};

export type AvailableLicensesResponse = {
  __typename?: 'AvailableLicensesResponse';
  assignedNumbers: Array<AssignedNumber>;
  hasSpainSubscriber?: Maybe<Scalars['Boolean']['output']>;
  licenses: Array<EsimLicenseDetail>;
};

export type AvailableOutboundEligibilityItem = {
  __typename?: 'AvailableOutboundEligibilityItem';
  allowedPrefixes?: Maybe<Array<Scalars['String']['output']>>;
  authority?: Maybe<Scalars['String']['output']>;
  eligible: Scalars['Boolean']['output'];
  line: LineResolver;
  link?: Maybe<Scalars['String']['output']>;
  phoneType: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  regulation?: Maybe<Scalars['String']['output']>;
};

export enum BackendPhoneCallType {
  ALL_MISSED = 'ALL_MISSED',
  ASSIGNED = 'ASSIGNED',
  MADE = 'MADE',
  MISSED = 'MISSED',
  OUTBOUND_CAMPAIGN = 'OUTBOUND_CAMPAIGN',
  QUEUE_CALLBACK = 'QUEUE_CALLBACK',
  TAKEN = 'TAKEN',
  VOICEMAIL = 'VOICEMAIL',
  VOICE_VIRTUAL_AGENT = 'VOICE_VIRTUAL_AGENT'
}

export type Banner = {
  __typename?: 'Banner';
  key: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type BannerInput = {
  key: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type BaseCustomSummaryConfiguration = {
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy?: Maybe<PhoneTeammateResolver>;
  id: Scalars['ID']['output'];
  line?: Maybe<LineResolver>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<PhoneTeammateResolver>;
};

export type BaseMessage = {
  ID: Scalars['ID']['output'];
  agent?: Maybe<PhoneTeammateResolver>;
  agentId?: Maybe<Scalars['String']['output']>;
  channel: MessageChannel;
  createdAt: Scalars['AWSDateTime']['output'];
  direction: BaseMessageDirection;
  externalConversationID: Scalars['ID']['output'];
  hasUnsupportedContent: Scalars['Boolean']['output'];
  mediaDetails: Array<BaseMessageMediaDetails>;
  parent?: Maybe<MessageResolver>;
  status: BaseMessageStatus;
  text: Scalars['String']['output'];
  undeliveredReason?: Maybe<BaseMessageUndeliveredReason>;
};

export enum BaseMessageDirection {
  RECEIVED = 'RECEIVED',
  SENT = 'SENT'
}

export type BaseMessageMediaDetails = {
  __typename?: 'BaseMessageMediaDetails';
  fileName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum BaseMessageStatus {
  DELIVERED = 'DELIVERED',
  NOT_SENT = 'NOT_SENT',
  PENDING = 'PENDING',
  READ = 'READ',
  RECEIVED = 'RECEIVED',
  SENT = 'SENT',
  UNDELIVERED = 'UNDELIVERED',
  UNKNOWN = 'UNKNOWN'
}

export enum BaseMessageUndeliveredReason {
  A2P10DLC_DAILYMESSAGE_CAP_REACHED = 'A2P10DLC_DAILYMESSAGE_CAP_REACHED',
  A2P_DAILY_MESSAGES_CAP_REACHED = 'A2P_DAILY_MESSAGES_CAP_REACHED',
  AGENT_LICENCE_NOT_ASSIGNED = 'AGENT_LICENCE_NOT_ASSIGNED',
  CANNOT_ACCESS_LINK = 'CANNOT_ACCESS_LINK',
  CANNOT_ACCESS_MEDIA_FILE = 'CANNOT_ACCESS_MEDIA_FILE',
  CANNOT_GENERATE_SIGNED_URL = 'CANNOT_GENERATE_SIGNED_URL',
  CARRIER_UNKNOWN_ERROR = 'CARRIER_UNKNOWN_ERROR',
  CARRIER_UNREACHABLE = 'CARRIER_UNREACHABLE',
  CHANNEL_DID_NOT_ACCEPT_CONTENT = 'CHANNEL_DID_NOT_ACCEPT_CONTENT',
  CHANNEL_POLICY_VIOLATION = 'CHANNEL_POLICY_VIOLATION',
  CONTENT_SIZE_EXCEEDS_CARRIER_LIMIT = 'CONTENT_SIZE_EXCEEDS_CARRIER_LIMIT',
  DAILY_LIMIT_EXCEEDED = 'DAILY_LIMIT_EXCEEDED',
  DELIVERY_RECEIPT_EXPIRED = 'DELIVERY_RECEIPT_EXPIRED',
  DESTINATION_MISSING_CREDIT = 'DESTINATION_MISSING_CREDIT',
  DESTINATION_REJECTED_HANDSET = 'DESTINATION_REJECTED_HANDSET',
  DESTINATION_REJECTED_MESSAGE = 'DESTINATION_REJECTED_MESSAGE',
  DOWNSTREAM_CARRIER_ERROR = 'DOWNSTREAM_CARRIER_ERROR',
  EXTERNAL_NUMBER_UNKNOWN = 'EXTERNAL_NUMBER_UNKNOWN',
  EXTERNAL_NUMBER_UNREACHABLE = 'EXTERNAL_NUMBER_UNREACHABLE',
  FILE_SIZE_EXCEEDS_CARRIER_LIMIT = 'FILE_SIZE_EXCEEDS_CARRIER_LIMIT',
  FREEFORM_OUTSIDE_ALLOWED_WINDOW = 'FREEFORM_OUTSIDE_ALLOWED_WINDOW',
  FROM_NUMBER_NOT_MMS_ENABLED = 'FROM_NUMBER_NOT_MMS_ENABLED',
  INVALID_CONTENT_TYPE = 'INVALID_CONTENT_TYPE',
  INVALID_EXTERNAL_NUMBER = 'INVALID_EXTERNAL_NUMBER',
  INVALID_TEMPLATE_CONTENT_VARIABLES = 'INVALID_TEMPLATE_CONTENT_VARIABLES',
  INVALID_TEMPLATE_STATUS = 'INVALID_TEMPLATE_STATUS',
  INVALID_WHATSAPP_RECIPIENT = 'INVALID_WHATSAPP_RECIPIENT',
  MEDIA_FAILED_TO_DOWNLOAD = 'MEDIA_FAILED_TO_DOWNLOAD',
  MEDIA_FILTERED = 'MEDIA_FILTERED',
  MESSAGE_BLOCKED = 'MESSAGE_BLOCKED',
  MESSAGE_FILTERED = 'MESSAGE_FILTERED',
  META_CHOOSE_NOT_TO_DELIVER_MARKETING_MESSAGE = 'META_CHOOSE_NOT_TO_DELIVER_MARKETING_MESSAGE',
  META_CHOOSE_NOT_TO_DELIVER_TEMPLATE = 'META_CHOOSE_NOT_TO_DELIVER_TEMPLATE',
  MMS_INVALID_CONTENT_TYPE = 'MMS_INVALID_CONTENT_TYPE',
  MMS_NOT_SUPPORTED_BY_RECEIVING_NUMBER = 'MMS_NOT_SUPPORTED_BY_RECEIVING_NUMBER',
  NOT_A_VALID_NUMBER = 'NOT_A_VALID_NUMBER',
  NUMBER_HEALTH_BLOCKED = 'NUMBER_HEALTH_BLOCKED',
  NUMBER_NOT_REGISTERED = 'NUMBER_NOT_REGISTERED',
  NUMBER_NOT_VERIFIED = 'NUMBER_NOT_VERIFIED',
  OPTED_OUT_RECIPIENT = 'OPTED_OUT_RECIPIENT',
  ORIGINATOR_MISSING_CREDIT = 'ORIGINATOR_MISSING_CREDIT',
  PENDING_NUMBER_REGISTRATION = 'PENDING_NUMBER_REGISTRATION',
  RATE_LIMIT_EXCEEDED = 'RATE_LIMIT_EXCEEDED',
  SENDER_NOT_PROVISIONED_ON_CARRIER = 'SENDER_NOT_PROVISIONED_ON_CARRIER',
  SUB_STATUS_UNSPECIFIED = 'SUB_STATUS_UNSPECIFIED',
  TEMPLATE_DISABLED = 'TEMPLATE_DISABLED',
  TEMPLATE_NOT_FOUND = 'TEMPLATE_NOT_FOUND',
  TEMPLATE_SUSPENDED = 'TEMPLATE_SUSPENDED',
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
  UNSUPPORTED_NUMBER = 'UNSUPPORTED_NUMBER',
  UNSUPPORTED_REGION = 'UNSUPPORTED_REGION',
  WHATSAPP_ACCOUNT_LOCKED = 'WHATSAPP_ACCOUNT_LOCKED',
  WHATSAPP_PLATFORM_RESTRICTION = 'WHATSAPP_PLATFORM_RESTRICTION',
  WHATSAPP_SENDER_NOT_APPROVED = 'WHATSAPP_SENDER_NOT_APPROVED'
}

export type BasicAuthConfig = {
  __typename?: 'BasicAuthConfig';
  passwordConfigured: Scalars['Boolean']['output'];
  username: Scalars['String']['output'];
};

export type BasicAuthConfigInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type BasicCall = {
  __typename?: 'BasicCall';
  answeredAt?: Maybe<Scalars['String']['output']>;
  audio?: Maybe<CallAudio>;
  automaticCallbackCallId?: Maybe<Scalars['ID']['output']>;
  automaticCallbackMissedReason?: Maybe<Scalars['String']['output']>;
  automaticCallbackState?: Maybe<Scalars['String']['output']>;
  callId: Scalars['ID']['output'];
  callUuid: Scalars['String']['output'];
  callbackRequestTimestamp?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  direction?: Maybe<CallDirection>;
  durationInSecond?: Maybe<Scalars['Int']['output']>;
  from?: Maybe<CallParticipant>;
  lineId?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Array<Maybe<Note>>>;
  state?: Maybe<CallState>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  tagsAndNotes?: Maybe<TagsAndNotes>;
  to?: Maybe<CallParticipant>;
  transcription?: Maybe<Transcription>;
  type?: Maybe<CallType>;
};

export type BearerTokenConfig = {
  __typename?: 'BearerTokenConfig';
  headerName: Scalars['String']['output'];
  prefix: Scalars['String']['output'];
  tokenConfigured: Scalars['Boolean']['output'];
};

export type BearerTokenConfigInput = {
  headerName?: InputMaybe<Scalars['String']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export enum BestMatchType {
  AREA_CODE = 'AREA_CODE',
  COUNTRY = 'COUNTRY',
  DEFAULT = 'DEFAULT',
  NEIGHBOURING_STATE = 'NEIGHBOURING_STATE',
  RANDOM = 'RANDOM',
  STATE = 'STATE'
}

export type Beta = {
  __typename?: 'Beta';
  ID: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  isEnabled: Scalars['Boolean']['output'];
  joinedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  joinedBy?: Maybe<PhoneTeammateResolver>;
  status: BetaStatus;
};

export type BetaJoinedOutput = Beta | GenericException | ResourceNotFoundException | UserInputException;

export enum BetaStatus {
  closed = 'closed',
  open = 'open'
}

export type BilledUsage = {
  __typename?: 'BilledUsage';
  count: Scalars['Int']['output'];
  minutesUsed: Scalars['Int']['output'];
  periodEnd: Scalars['String']['output'];
  periodStart: Scalars['String']['output'];
};

export type BinaryAnswer = {
  __typename?: 'BinaryAnswer';
  answerGuide?: Maybe<Scalars['String']['output']>;
  binaryValue: BinaryAnswerValue;
  points: Scalars['Float']['output'];
};

export type BinaryAnswerCount = {
  __typename?: 'BinaryAnswerCount';
  binaryAnswer: BinaryAnswerValue;
  count: Scalars['Int']['output'];
};

export enum BinaryAnswerValue {
  NO = 'NO',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  YES = 'YES'
}

export type BinaryEvaluationQuestion = {
  __typename?: 'BinaryEvaluationQuestion';
  ID: Scalars['ID']['output'];
  binaryAnswer?: Maybe<BinaryAnswerValue>;
  feedback?: Maybe<Scalars['String']['output']>;
  predefinedAIQuestionId?: Maybe<Scalars['ID']['output']>;
  questionAiEnabled: Scalars['Boolean']['output'];
  questionOrder: Scalars['Int']['output'];
  questionPossibleAnswers: Array<BinaryAnswer>;
  questionStrictness?: Maybe<Scalars['Int']['output']>;
  questionText: Scalars['String']['output'];
  score: Score;
  scoreCardQuestionId?: Maybe<Scalars['ID']['output']>;
};

export type BlacklistedNumber = {
  __typename?: 'BlacklistedNumber';
  id: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type BlacklistedNumberInput = {
  phoneNumber: Scalars['String']['input'];
};

export type BlacklistedNumbers = {
  __typename?: 'BlacklistedNumbers';
  blacklistedPhoneNumbers: Array<BlacklistedNumber>;
  meta: MetaV3;
};

export type BlacklistedPhone = {
  __typename?: 'BlacklistedPhone';
  ID: Scalars['ID']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type BlacklistedPhonesResponse = {
  __typename?: 'BlacklistedPhonesResponse';
  blacklistedPhones: Array<BlacklistedPhone>;
  meta: PaginationMeta;
};

export type Board = {
  __typename?: 'Board';
  columns: Array<BoardColumn>;
  itemTerminology: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type BoardColumn = {
  __typename?: 'BoardColumn';
  id: Scalars['String']['output'];
  settings_str?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type BoardDetails = {
  __typename?: 'BoardDetails';
  data: BoardDetailsData;
};

export type BoardDetailsData = {
  __typename?: 'BoardDetailsData';
  boards: Array<Board>;
};

export type Boards = {
  __typename?: 'Boards';
  id: Scalars['String']['output'];
  itemTerminology: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type BoardsWithPagination = {
  __typename?: 'BoardsWithPagination';
  data: BoardsWithPaginationData;
};

export type BoardsWithPaginationData = {
  __typename?: 'BoardsWithPaginationData';
  boards: Array<Boards>;
};

export type BooleanResult = {
  __typename?: 'BooleanResult';
  result: Scalars['Boolean']['output'];
};

export type BooleanValue = {
  __typename?: 'BooleanValue';
  value: Scalars['Boolean']['output'];
};

export type BranchOutChildEngagement = Engagement & {
  __typename?: 'BranchOutChildEngagement';
  ID: Scalars['ID']['output'];
  author: PhoneTeammateResolver;
  createdAt: Scalars['AWSDateTime']['output'];
  line: LineResolver;
  parentConversationID: Scalars['ID']['output'];
  target: BranchOutEngagementTarget;
};

export type BranchOutEngagement = Engagement & {
  __typename?: 'BranchOutEngagement';
  ID: Scalars['ID']['output'];
  author: PhoneTeammateResolver;
  createdAt: Scalars['AWSDateTime']['output'];
  line: LineResolver;
  newConversationID: Scalars['ID']['output'];
  target: BranchOutEngagementTarget;
};

export type BranchOutEngagementTarget = {
  __typename?: 'BranchOutEngagementTarget';
  conversationID: Scalars['ID']['output'];
  line: LineResolver;
  lineID: Scalars['ID']['output'];
};

export type Brand = {
  __typename?: 'Brand';
  approvedAt?: Maybe<Scalars['String']['output']>;
  brandId: Scalars['ID']['output'];
  business: BrandBusiness;
  callingProfiles?: Maybe<Array<BrandCallingProfile>>;
  country: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  documents?: Maybe<Array<BrandDocument>>;
  legalName: Scalars['String']['output'];
  loaEnvelope?: Maybe<LoaEnvelopeSummary>;
  logo?: Maybe<BrandLogoResponse>;
  metrics?: Maybe<BrandMetrics>;
  numberCount: Scalars['Int']['output'];
  pendingCustomer?: Maybe<Scalars['Boolean']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  status: BrandStatus;
  submittedAt: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  zendeskTicketLink?: Maybe<Scalars['String']['output']>;
};

export type BrandAddress = {
  __typename?: 'BrandAddress';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  street2?: Maybe<Scalars['String']['output']>;
  street3?: Maybe<Scalars['String']['output']>;
};

export type BrandAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  street3?: InputMaybe<Scalars['String']['input']>;
};

export type BrandAddressPartial = {
  __typename?: 'BrandAddressPartial';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  street3?: Maybe<Scalars['String']['output']>;
};

export type BrandBusiness = {
  __typename?: 'BrandBusiness';
  address: BrandAddress;
  contact: BrandContact;
  dba?: Maybe<Scalars['String']['output']>;
  employeeCountRange: EmployeeCountRange;
  industry: Industry;
  legalName: Scalars['String']['output'];
  taxId?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type BrandBusinessInput = {
  address?: InputMaybe<BrandAddressInput>;
  contact?: InputMaybe<BrandContactInput>;
  dba?: InputMaybe<Scalars['String']['input']>;
  employeeCountRange?: InputMaybe<EmployeeCountRange>;
  industry?: InputMaybe<Industry>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type BrandBusinessPartial = {
  __typename?: 'BrandBusinessPartial';
  address?: Maybe<BrandAddressPartial>;
  contact?: Maybe<BrandContactPartial>;
  dba?: Maybe<Scalars['String']['output']>;
  employeeCountRange?: Maybe<EmployeeCountRange>;
  industry?: Maybe<Industry>;
  legalName?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type BrandCallingProfile = {
  __typename?: 'BrandCallingProfile';
  approvedAt?: Maybe<Scalars['String']['output']>;
  callPurposeCode: CallPurposeCode;
  callingProfileId: Scalars['ID']['output'];
  expectedCallVolume: ExpectedCallVolume;
  metrics?: Maybe<BrandMetrics>;
  name: Scalars['String']['output'];
  numberCount: Scalars['Int']['output'];
  numbers: Array<BrandNumber>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  status: BrandStatus;
};

export type BrandContact = {
  __typename?: 'BrandContact';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type BrandContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type BrandContactPartial = {
  __typename?: 'BrandContactPartial';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type BrandDocument = {
  __typename?: 'BrandDocument';
  documentUuid: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  mimeType: BrandDocumentMimeType;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  sizeBytes: Scalars['Int']['output'];
  status: BrandDocumentStatus;
  type: BrandDocumentType;
  uploadedAt: Scalars['String']['output'];
};

export type BrandDocumentDownloadUrl = {
  __typename?: 'BrandDocumentDownloadUrl';
  documentUuid: Scalars['ID']['output'];
  downloadUrl: Scalars['String']['output'];
  expiresAt: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type BrandDocumentInput = {
  documentUuid: Scalars['ID']['input'];
  mimeType: BrandDocumentMimeType;
  name: Scalars['String']['input'];
  sizeBytes: Scalars['Int']['input'];
  type: BrandDocumentType;
};

export enum BrandDocumentMimeType {
  APPLICATION_PDF = 'APPLICATION_PDF',
  IMAGE_JPEG = 'IMAGE_JPEG',
  IMAGE_PNG = 'IMAGE_PNG'
}

export enum BrandDocumentStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export enum BrandDocumentType {
  BRAND_REGISTRATION_PROOF = 'BRAND_REGISTRATION_PROOF',
  BRAND_RIGHTS = 'BRAND_RIGHTS',
  PROOF_OF_IDENTITY = 'PROOF_OF_IDENTITY'
}

export type BrandDocumentUploadUrl = {
  __typename?: 'BrandDocumentUploadUrl';
  documentUuid: Scalars['ID']['output'];
  expiresAt: Scalars['String']['output'];
  key: Scalars['String']['output'];
  type: BrandDocumentType;
  uploadUrl: Scalars['String']['output'];
};

export type BrandDraft = {
  __typename?: 'BrandDraft';
  business?: Maybe<BrandBusinessPartial>;
  callingProfiles?: Maybe<Array<CallingProfilePartial>>;
  country: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  documents?: Maybe<Array<BrandDocument>>;
  draftId: Scalars['ID']['output'];
  loaEnvelope?: Maybe<LoaEnvelopeSummary>;
  logo?: Maybe<BrandDraftLogoPartial>;
  updatedAt: Scalars['String']['output'];
};

export type BrandDraftFieldIssue = {
  __typename?: 'BrandDraftFieldIssue';
  issueCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type BrandDraftList = {
  __typename?: 'BrandDraftList';
  items: Array<BrandDraftListItem>;
};

export type BrandDraftListItem = {
  __typename?: 'BrandDraftListItem';
  business?: Maybe<BrandBusinessPartial>;
  callingProfileCount: Scalars['Int']['output'];
  callingProfiles?: Maybe<Array<CallingProfilePartial>>;
  country: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  documents?: Maybe<Array<BrandDocument>>;
  draftId: Scalars['ID']['output'];
  legalName?: Maybe<Scalars['String']['output']>;
  loaEnvelope?: Maybe<LoaEnvelopeSummary>;
  logo?: Maybe<BrandDraftLogoPartial>;
  metrics?: Maybe<BrandMetrics>;
  numberCount: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export type BrandDraftListResult = BrandDraftList | BrandedCallingException | GenericException;

export type BrandDraftLogoInput = {
  uuid: Scalars['ID']['input'];
};

export type BrandDraftLogoPartial = {
  __typename?: 'BrandDraftLogoPartial';
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type BrandDraftLogoRenderUrl = {
  __typename?: 'BrandDraftLogoRenderUrl';
  expiresAt: Scalars['String']['output'];
  renderUrl: Scalars['String']['output'];
};

export type BrandDraftLogoResponse = {
  __typename?: 'BrandDraftLogoResponse';
  expiresAt: Scalars['String']['output'];
  key: Scalars['String']['output'];
  logoUuid: Scalars['ID']['output'];
  renderUrl: Scalars['String']['output'];
};

export type BrandDraftNumber = {
  __typename?: 'BrandDraftNumber';
  e164: Scalars['String']['output'];
  lineId?: Maybe<Scalars['ID']['output']>;
};

export type BrandDraftNumberInput = {
  e164: Scalars['String']['input'];
  lineId?: InputMaybe<Scalars['ID']['input']>;
};

export type BrandDraftResult = BrandDraft | BrandedCallingException | GenericException;

export type BrandListResponse = {
  __typename?: 'BrandListResponse';
  items: Array<Brand>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BrandLogoInput = {
  uuid: Scalars['ID']['input'];
};

export type BrandLogoResponse = {
  __typename?: 'BrandLogoResponse';
  originalImageUrl?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  renderedImageUrl?: Maybe<Scalars['String']['output']>;
  status: BrandLogoStatus;
  updatedAt: Scalars['String']['output'];
  uploadedAt: Scalars['String']['output'];
};

export enum BrandLogoStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export type BrandMetrics = {
  __typename?: 'BrandMetrics';
  pickupRate: Scalars['Float']['output'];
  totalAnsweredBrandedCalls: Scalars['Int']['output'];
  totalBrandedCalls: Scalars['Int']['output'];
};

export type BrandNumber = {
  __typename?: 'BrandNumber';
  activeSince?: Maybe<Scalars['String']['output']>;
  e164: Scalars['String']['output'];
  line?: Maybe<Line>;
  lineId: Scalars['ID']['output'];
  metrics?: Maybe<BrandMetrics>;
  numberId: Scalars['ID']['output'];
  propagatingUntil?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  status: NumberEnrollmentStatus;
};

export enum BrandStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export type BrandSubmission = {
  __typename?: 'BrandSubmission';
  brandId: Scalars['ID']['output'];
  status: BrandStatus;
  submittedAt: Scalars['String']['output'];
};

export type BrandedCallingCountry = {
  __typename?: 'BrandedCallingCountry';
  code: Scalars['String']['output'];
};

export type BrandedCallingException = Exception & {
  __typename?: 'BrandedCallingException';
  code: Scalars['String']['output'];
  details?: Maybe<Scalars['String']['output']>;
  fieldIssues?: Maybe<Array<BrandDraftFieldIssue>>;
  message: Scalars['String']['output'];
  statusCode: Scalars['Int']['output'];
};

export type BrandedCallingSupportedCountriesResponse = {
  __typename?: 'BrandedCallingSupportedCountriesResponse';
  items: Array<BrandedCallingCountry>;
};

export type BrandedCallingSupportedCountriesResult = BrandedCallingException | BrandedCallingSupportedCountriesResponse | GenericException;

export type BridgeApplication = {
  __typename?: 'BridgeApplication';
  feature?: Maybe<Scalars['String']['output']>;
  friendlyName: Scalars['String']['output'];
  helpLink?: Maybe<Scalars['String']['output']>;
  img: Scalars['String']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  setup: ApplicationSetup;
};

export type BridgeIntegrationConfigurations = {
  __typename?: 'BridgeIntegrationConfigurations';
  assignments: Array<Maybe<Scalars['String']['output']>>;
  numbers: Array<BridgeIntegrationNumber>;
  settings: BridgeIntegrationSettings;
  workflows: BridgeIntegrationWorkflows;
};

export type BridgeIntegrationNumber = {
  __typename?: 'BridgeIntegrationNumber';
  countryIso: Scalars['String']['output'];
  formattedNumber: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
};

export type BridgeIntegrationSettings = {
  __typename?: 'BridgeIntegrationSettings';
  availability: Scalars['Boolean']['output'];
  callLogReceptor?: Maybe<Scalars['String']['output']>;
  customName?: Maybe<Scalars['String']['output']>;
  displayHistory: Scalars['Boolean']['output'];
  merge: Scalars['Boolean']['output'];
  sendContactExtracts?: Maybe<Scalars['Boolean']['output']>;
};

export type BridgeIntegrationWorkflows = {
  __typename?: 'BridgeIntegrationWorkflows';
  inboundAnswered?: Maybe<Scalars['String']['output']>;
  inboundUnanswered?: Maybe<Scalars['String']['output']>;
  inboundUnansweredVoicemail?: Maybe<Scalars['String']['output']>;
  outboundAnswered?: Maybe<Scalars['String']['output']>;
  outboundUnanswered?: Maybe<Scalars['String']['output']>;
};

export type BulkCloseAircallWorkspaceConversationsNotificationInput = {
  closedConversationIDs: Array<Scalars['ID']['input']>;
  recipients: Array<Scalars['ID']['input']>;
  triggeredByAgentID: Scalars['ID']['input'];
};

export type BulkCloseAircallWorkspaceConversationsNotificationOutput = {
  __typename?: 'BulkCloseAircallWorkspaceConversationsNotificationOutput';
  closedConversationIDs: Array<Scalars['ID']['output']>;
  recipients: Array<Scalars['ID']['output']>;
  triggeredByAgentID: Scalars['ID']['output'];
};

export type BulkCreateAircallExtractFieldMapping = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers: Array<Scalars['String']['input']>;
};

export type BulkCreateAircallExtractInput = {
  base64File: Scalars['String']['input'];
  e164CountryCode: Scalars['String']['input'];
  fieldMapping: BulkCreateAircallExtractFieldMapping;
  isoCountryCode: Scalars['String']['input'];
};

export type BulkCreateAircallExtractOutput = BulkCreateAircallExtractResult | GenericException;

export type BulkCreateAircallExtractResult = {
  __typename?: 'BulkCreateAircallExtractResult';
  errorCount: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  failedContacts?: Maybe<Array<Maybe<FailedContact>>>;
  successCount: Scalars['Int']['output'];
};

export type BulkDeleteDialerCampaignNumbersInput = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  campaignID: Scalars['ID']['input'];
  phoneNumberIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type BulkDeleteDialerCampaignNumbersOutput = {
  __typename?: 'BulkDeleteDialerCampaignNumbersOutput';
  success: Scalars['Boolean']['output'];
};

export type BulkDocumentUploadResponse = {
  __typename?: 'BulkDocumentUploadResponse';
  results: Array<DocumentUploadResult>;
};

export type BulkDocumentUploadResult = BulkDocumentUploadResponse | GenericException;

export type BulkReopenAircallWorkspaceConversationsNotificationInput = {
  recipients: Array<Scalars['ID']['input']>;
  reopenedConversationIDs: Array<Scalars['ID']['input']>;
  triggeredByAgentID: Scalars['String']['input'];
};

export type BulkReopenAircallWorkspaceConversationsNotificationOutput = {
  __typename?: 'BulkReopenAircallWorkspaceConversationsNotificationOutput';
  recipients: Array<Scalars['ID']['output']>;
  reopenedConversationIDs: Array<Scalars['ID']['output']>;
  triggeredByAgentID: Scalars['String']['output'];
};

export type BulkSubscribeFeaturesInput = {
  licenses: Array<BulkSubscribeLicenseItemInput>;
};

export type BulkSubscribeFeaturesOutput = {
  __typename?: 'BulkSubscribeFeaturesOutput';
  results: Array<BulkSubscribeResultItem>;
  success: Scalars['Boolean']['output'];
};

export type BulkSubscribeLicenseItemInput = {
  name: Scalars['String']['input'];
  numberOfLicenses: Scalars['Int']['input'];
};

export type BulkSubscribeResultItem = {
  __typename?: 'BulkSubscribeResultItem';
  error?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export enum BulkUserError {
  CSV_FORMAT_VALIDATION_ERROR = 'CSV_FORMAT_VALIDATION_ERROR',
  CSV_VALIDATION_ERROR = 'CSV_VALIDATION_ERROR',
  USERS_VALIDATION_ERROR = 'USERS_VALIDATION_ERROR'
}

export type BusinessDraft = {
  __typename?: 'BusinessDraft';
  business?: Maybe<BusinessDraftBusinessPartial>;
  createdAt: Scalars['String']['output'];
  draftId: Scalars['ID']['output'];
  numbers?: Maybe<Array<BusinessDraftNumber>>;
  updatedAt: Scalars['String']['output'];
};

export type BusinessDraftAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessDraftAddressPartial = {
  __typename?: 'BusinessDraftAddressPartial';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type BusinessDraftBusinessInput = {
  address?: InputMaybe<BusinessDraftAddressInput>;
  authorized?: InputMaybe<Scalars['Boolean']['input']>;
  businessVerificationDocument?: InputMaybe<BusinessDraftDocumentInput>;
  contact?: InputMaybe<BusinessDraftContactInput>;
  dunsNumber?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<NumberReputationIndustry>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<NumberReputationEmployeeCount>;
  primaryName?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessDraftBusinessPartial = {
  __typename?: 'BusinessDraftBusinessPartial';
  address?: Maybe<BusinessDraftAddressPartial>;
  authorized?: Maybe<Scalars['Boolean']['output']>;
  businessVerificationDocument?: Maybe<BusinessDraftDocument>;
  contact?: Maybe<BusinessDraftContactPartial>;
  dunsNumber?: Maybe<Scalars['String']['output']>;
  industry?: Maybe<NumberReputationIndustry>;
  legalName?: Maybe<Scalars['String']['output']>;
  numberOfEmployees?: Maybe<NumberReputationEmployeeCount>;
  primaryName?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type BusinessDraftContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessDraftContactPartial = {
  __typename?: 'BusinessDraftContactPartial';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type BusinessDraftDocument = {
  __typename?: 'BusinessDraftDocument';
  documentUuid: Scalars['ID']['output'];
  feature: Scalars['String']['output'];
  key: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  sizeBytes: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type BusinessDraftDocumentInput = {
  documentUuid: Scalars['ID']['input'];
  feature: Scalars['String']['input'];
  key: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sizeBytes: Scalars['Int']['input'];
};

export type BusinessDraftFieldIssue = {
  __typename?: 'BusinessDraftFieldIssue';
  issueCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
  path: Array<Scalars['String']['output']>;
};

export type BusinessDraftList = {
  __typename?: 'BusinessDraftList';
  items: Array<BusinessDraft>;
};

export type BusinessDraftListResult = BusinessDraftList | GenericException | NumberReputationException;

export type BusinessDraftNumber = {
  __typename?: 'BusinessDraftNumber';
  e164: Scalars['String']['output'];
  lineId?: Maybe<Scalars['ID']['output']>;
};

export type BusinessDraftNumberInput = {
  e164: Scalars['String']['input'];
};

export type BusinessDraftResult = BusinessDraft | GenericException | NumberReputationException;

export type BusinessHours = {
  __typename?: 'BusinessHours';
  availability: Availability;
  slots: Array<AvailabilitySlot>;
  timezone: Scalars['String']['output'];
};

export type BusinessHoursInput = {
  availability?: InputMaybe<Availability>;
  slots?: InputMaybe<Array<AvailabilitySlotInput>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessInfo = {
  __typename?: 'BusinessInfo';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BusinessRegistration = {
  __typename?: 'BusinessRegistration';
  business?: Maybe<BusinessRegistrationDetails>;
  businessId: Scalars['ID']['output'];
  provider: Scalars['String']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  reputationSummary: NumberReputationSummary;
  status: BusinessRegistrationStatus;
  submittedAt: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type BusinessRegistrationAddress = {
  __typename?: 'BusinessRegistrationAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type BusinessRegistrationContact = {
  __typename?: 'BusinessRegistrationContact';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type BusinessRegistrationDetails = {
  __typename?: 'BusinessRegistrationDetails';
  address?: Maybe<BusinessRegistrationAddress>;
  authorized?: Maybe<Scalars['Boolean']['output']>;
  businessVerificationDocument?: Maybe<BusinessDraftDocument>;
  contact?: Maybe<BusinessRegistrationContact>;
  dunsNumber?: Maybe<Scalars['String']['output']>;
  industry?: Maybe<NumberReputationIndustry>;
  legalName?: Maybe<Scalars['String']['output']>;
  numberOfEmployees?: Maybe<NumberReputationEmployeeCount>;
  primaryName?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type BusinessRegistrationList = {
  __typename?: 'BusinessRegistrationList';
  items: Array<BusinessRegistration>;
};

export type BusinessRegistrationListResult = BusinessRegistrationList | GenericException | NumberReputationException;

export type BusinessRegistrationMetricsResult = GenericException | NumberReputationException | NumberReputationSummary;

export enum BusinessRegistrationStatus {
  PENDING = 'PENDING',
  PENDING_AIRCALL_VETTING = 'PENDING_AIRCALL_VETTING',
  REJECTED = 'REJECTED',
  VERIFIED = 'VERIFIED'
}

export enum BusinessVerificationStatus {
  expired = 'expired',
  failed = 'failed',
  ineligible = 'ineligible',
  not_verified = 'not_verified',
  pending = 'pending',
  pending_need_more_info = 'pending_need_more_info',
  pending_submission = 'pending_submission',
  rejected = 'rejected',
  revoked = 'revoked',
  verified = 'verified'
}

export type CalendarCreateInput = {
  exceptions: CalendarExceptionInput;
  title: Scalars['String']['input'];
};

export type CalendarExceptionDatesInput = {
  fromDate: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
};

export type CalendarExceptionDatesOutput = {
  __typename?: 'CalendarExceptionDatesOutput';
  fromDate: Scalars['String']['output'];
  toDate: Scalars['String']['output'];
};

export type CalendarExceptionInput = {
  nextDates: Array<CalendarExceptionDatesInput>;
  pastDates: Array<CalendarExceptionDatesInput>;
};

export type CalendarExceptionOutput = {
  __typename?: 'CalendarExceptionOutput';
  nextDates: Array<CalendarExceptionDatesOutput>;
  pastDates: Array<CalendarExceptionDatesOutput>;
};

export type CalendarExceptionOutputObject = CalendarExceptionOutput;

export type CalendarOutput = {
  __typename?: 'CalendarOutput';
  calendarID: Scalars['ID']['output'];
  companyID: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  exceptions: CalendarExceptionOutputObject;
  lineIds: Array<Scalars['Int']['output']>;
  receivedAt: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type CalendarOutputV2 = CalendarOutput | CalendarTitleAlreadyExistsException | ConflictException | GenericException | ResourceNotFoundException;

export type CalendarTitleAlreadyExistsException = Exception & {
  __typename?: 'CalendarTitleAlreadyExistsException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type CalendarUpdateInput = {
  exceptions: CalendarExceptionInput;
  title: Scalars['String']['input'];
  updatedAt: Scalars['String']['input'];
};

export type Call = BasicCall;

export type CallAudio = {
  __typename?: 'CallAudio';
  url?: Maybe<Scalars['String']['output']>;
};

export type CallAudioResult = CallAudio | GenericException | InsufficientPermissionException;

export type CallConversation = {
  __typename?: 'CallConversation';
  agents: Array<Maybe<ConversationAgent>>;
  callId: Scalars['Float']['output'];
  contacts: Array<Maybe<ConversationContact>>;
  durationInSeconds: Scalars['Int']['output'];
  hasTranscription?: Maybe<Scalars['Boolean']['output']>;
  line?: Maybe<Line>;
  lineId: Scalars['Int']['output'];
  predictedCsatScore?: Maybe<Scalars['Float']['output']>;
  sentiment?: Maybe<SentimentScope>;
  startTime: Scalars['String']['output'];
  tags?: Maybe<Array<Maybe<ConversationTag>>>;
  topics?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  trackers?: Maybe<Array<Maybe<ConversationTracker>>>;
  transcription?: Maybe<Transcription>;
  transcriptionScope?: Maybe<TranscriptionScope>;
  type: Scalars['String']['output'];
  virtualAgents: Array<Maybe<ConversationVirtualAgent>>;
};

export type CallConversationAggregations = {
  __typename?: 'CallConversationAggregations';
  items: Array<CallConversationAggregationsItem>;
};

export type CallConversationAggregationsItem = AgentsAggregation | DurationAggregation | LinesAggregation | PredictedCsatAggregation | SentimentsAggregation | StartTimesAggregation | TopicsAggregation | TrackersAggregation;

export type CallConversationAggregationsScope = {
  agents?: InputMaybe<AgentsAggregationScope>;
  duration?: InputMaybe<MetricAggregationScope>;
  includeItems?: InputMaybe<Scalars['Boolean']['input']>;
  lines?: InputMaybe<LinesAggregationScope>;
  predictedCsat?: InputMaybe<MetricAggregationScope>;
  sentiments?: InputMaybe<SentimentAggregationScope>;
  startTime?: InputMaybe<DateHistogramAggregationScope>;
  topics?: InputMaybe<TopicsAggregationScope>;
  trackers?: InputMaybe<TrackersAggregationScope>;
};

export type CallConversationSort = {
  direction?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Scalars['String']['input']>;
};

export type CallDialerCampaignNumberInput = {
  campaignID: Scalars['ID']['input'];
  numberID: Scalars['ID']['input'];
};

export type CallDialerCampaignNumberOutput = {
  __typename?: 'CallDialerCampaignNumberOutput';
  success: Scalars['Boolean']['output'];
};

export enum CallDirection {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND'
}

export type CallEngagement = Engagement & {
  __typename?: 'CallEngagement';
  ID: Scalars['ID']['output'];
  author: EngagementAuthor;
  authorV2?: Maybe<EngagementAuthorV2>;
  call: PhoneCallResolver;
  conversation: AircallWorkspaceConversationResolver;
  createdAt: Scalars['AWSDateTime']['output'];
  externalNumber: Scalars['String']['output'];
};

export type CallEngagementOutput = CallEngagement | GenericException | ResourceNotFoundException;

export type CallEngagementsCountPerCategory = {
  __typename?: 'CallEngagementsCountPerCategory';
  callback: Scalars['Int']['output'];
  followUp: Scalars['Int']['output'];
  missedCalls: Scalars['Int']['output'];
  totalCalls: Scalars['Int']['output'];
  voicemails: Scalars['Int']['output'];
};

export type CallEngagementsCountPerCategoryOutput = CallEngagementsCountPerCategory | GenericException | UserInputException;

export type CallEngagementsFilters = {
  callType?: InputMaybe<Array<BackendPhoneCallType>>;
  campaignIDs?: InputMaybe<IdFilter>;
  externalNumberOrContactTerm?: InputMaybe<StringFilter>;
  fromDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  lineIDs?: InputMaybe<IdFilter>;
  outcomeIDs?: InputMaybe<IdFilter>;
  status?: InputMaybe<AircallWorkspaceConversationStatus>;
  tagsIDs?: InputMaybe<IdFilter>;
  teammateIDs?: InputMaybe<IdFilter>;
  toDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type CallParticipant = AgentParticipant | ExternalParticipant;

export enum CallPurposeCode {
  APPOINTMENT_REMINDER = 'APPOINTMENT_REMINDER',
  CUSTOMER_SUPPORT = 'CUSTOMER_SUPPORT',
  DELIVERY = 'DELIVERY',
  SALES = 'SALES',
  SURVEY = 'SURVEY'
}

export type CallScoringSettings = {
  __typename?: 'CallScoringSettings';
  agentEvaluationVisible: Scalars['Boolean']['output'];
  companyId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
};

export enum CallState {
  ANSWERED = 'ANSWERED',
  CALLEE_HANGED_UP = 'CALLEE_HANGED_UP',
  CALLER_ALREADY_HANGED_UP = 'CALLER_ALREADY_HANGED_UP',
  CALL_ANSWERED = 'CALL_ANSWERED',
  CALL_ANSWERED_BY_HUMAN = 'CALL_ANSWERED_BY_HUMAN',
  CALL_BACK_LATER = 'CALL_BACK_LATER',
  CANCELED = 'CANCELED',
  CANCELLED = 'CANCELLED',
  DONE = 'DONE',
  GREETING = 'GREETING',
  HANGUP_REQUEST = 'HANGUP_REQUEST',
  INITIAL = 'INITIAL',
  IN_COMMUNICATION = 'IN_COMMUNICATION',
  IN_TRANSFER = 'IN_TRANSFER',
  NEXT_REDIRECTION_USER = 'NEXT_REDIRECTION_USER',
  NOT_USED = 'NOT_USED',
  RECORDED_MESSAGE = 'RECORDED_MESSAGE',
  REDIRECTION_DONE = 'REDIRECTION_DONE',
  UNKNOWN = 'UNKNOWN',
  VOICEMAIL = 'VOICEMAIL',
  WAITING_DIAL_ACTION = 'WAITING_DIAL_ACTION'
}

export type CallTaggingSettings = {
  __typename?: 'CallTaggingSettings';
  enabled: Scalars['Boolean']['output'];
  guidance: Scalars['String']['output'];
  line?: Maybe<LineResolver>;
  lineId: Scalars['ID']['output'];
};

export type CallTimelineEvent = IncomingCallAssignedToAgentEvent | IncomingCallCallbackRequestedEvent | IncomingCallCallerHungUpEvent | IncomingCallEndedEvent | IncomingCallExtensionDialedEvent | IncomingCallIvrBranchSelectedEvent | IncomingCallInputIvrUserInputEvent | IncomingCallMissedEvent | IncomingCallRedirectedToExternalPhoneNumberEvent | IncomingCallRedirectedToInternalLineEvent | IncomingCallRungToAgentEndedEvent | IncomingCallRungToAgentEvent | IncomingCallRungToDeviceEndedEvent | IncomingCallRungToDeviceEvent | IncomingCallStartedEvent | IncomingCallTargetEnqueuedEndedEvent | IncomingCallTargetEnqueuedEvent | IncomingCallVoicemailReadyEvent | IncomingCallVoicemailRecordedEvent | VoiceVirtualAgentAiActionEvent | VoiceVirtualAgentEndedEvent | VoiceVirtualAgentEscalatedEvent | VoiceVirtualAgentStartedEvent | VoiceVirtualAgentSummaryEvent;

export type CallTimelineFailure = {
  __typename?: 'CallTimelineFailure';
  callSid: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type CallTranscription = {
  __typename?: 'CallTranscription';
  callId: Scalars['Float']['output'];
  callUuid: Scalars['String']['output'];
  content?: Maybe<TranscriptionContent>;
  createdAt?: Maybe<Scalars['String']['output']>;
  durationInSeconds: Scalars['Int']['output'];
  insights?: Maybe<TranscriptionInsights>;
  mode: TranscriptionMode;
  status: Scalars['String']['output'];
  transcriptionId: Scalars['ID']['output'];
  type: Scalars['String']['output'];
  wordsCount?: Maybe<Scalars['Int']['output']>;
};

export type CallTranscriptionSettings = {
  __typename?: 'CallTranscriptionSettings';
  isEnabled: Scalars['Boolean']['output'];
  reason?: Maybe<TranscriptionSettingsReason>;
};

export type CallTranscriptionSettingsData = {
  isEnabled: Scalars['Boolean']['input'];
};

export enum CallType {
  ANSWERED = 'ANSWERED',
  CALLED = 'CALLED',
  MISSED = 'MISSED',
  UNKNOWN = 'UNKNOWN',
  VOICEMAIL = 'VOICEMAIL'
}

export type CallbackRequestMessageInput = {
  kind: Scalars['String']['input'];
  language?: InputMaybe<SayCallbackRequestMessageLanguage>;
  message?: InputMaybe<Scalars['String']['input']>;
  messageType: Scalars['String']['input'];
  previewURL?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  voice?: InputMaybe<SayCallbackRequestMessageVoice>;
};

export type CallbackRequestMessageOutput = {
  __typename?: 'CallbackRequestMessageOutput';
  kind: Scalars['String']['output'];
  language?: Maybe<SayCallbackRequestMessageLanguageOutput>;
  message?: Maybe<Scalars['String']['output']>;
  messageType: Scalars['String']['output'];
  previewURL?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  voice?: Maybe<SayCallbackRequestMessageVoiceOutput>;
};

export type CallerPersonaInput = {
  background: Scalars['String']['input'];
  emotionalState: Scalars['String']['input'];
  infoToProvide?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  speakingStyle: Scalars['String']['input'];
};

export type CallingProfile = {
  __typename?: 'CallingProfile';
  callPurposeCode: CallPurposeCode;
  callingProfileId: Scalars['ID']['output'];
  expectedCallVolume: ExpectedCallVolume;
  name: Scalars['String']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
};

export type CallingProfileDetails = {
  __typename?: 'CallingProfileDetails';
  approvedAt?: Maybe<Scalars['String']['output']>;
  brandId: Scalars['ID']['output'];
  callPurposeCode: CallPurposeCode;
  callingProfileId: Scalars['ID']['output'];
  country: Scalars['String']['output'];
  expectedCallVolume: ExpectedCallVolume;
  name: Scalars['String']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  status: BrandStatus;
  submittedAt: Scalars['String']['output'];
};

export type CallingProfileInput = {
  callPurposeCode?: InputMaybe<CallPurposeCode>;
  expectedCallVolume?: InputMaybe<ExpectedCallVolume>;
  name?: InputMaybe<Scalars['String']['input']>;
  numbers?: InputMaybe<Array<BrandDraftNumberInput>>;
  shortName?: InputMaybe<Scalars['String']['input']>;
};

export type CallingProfilePartial = {
  __typename?: 'CallingProfilePartial';
  callPurposeCode?: Maybe<CallPurposeCode>;
  expectedCallVolume?: Maybe<ExpectedCallVolume>;
  name?: Maybe<Scalars['String']['output']>;
  numbers?: Maybe<Array<BrandDraftNumber>>;
  shortName?: Maybe<Scalars['String']['output']>;
};

export type CampaignCreationInput = {
  brandId: Scalars['String']['input'];
  campaignIds: Array<Scalars['String']['input']>;
};

export type CampaignNumberAssociationInput = {
  campaignId: Scalars['String']['input'];
  phoneNumbers: Array<Scalars['String']['input']>;
};

export type CampaignNumberDeletionInput = {
  campaignId: Scalars['String']['input'];
  phoneNumbers: Array<Scalars['String']['input']>;
};

export type CampaignUseCase = {
  __typename?: 'CampaignUseCase';
  classification: Scalars['String']['output'];
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  maxSubUsecases: Scalars['Int']['output'];
  minSubUsecases: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  validSubUsecase: Scalars['Boolean']['output'];
};

export type CancelPortingRequestInput = {
  portingRequestUUID: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type CancelPortingRequestResponse = {
  __typename?: 'CancelPortingRequestResponse';
  message: Scalars['String']['output'];
  portingRequestUUID: Scalars['String']['output'];
  portingStatus: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CancelSimulationOutput = ConflictException | GenericException | ResourceNotFoundException | SimulationJob;

export type CancelSubscriptionInput = {
  cancellationComments?: InputMaybe<Scalars['String']['input']>;
  cancellationDate: Scalars['String']['input'];
  primaryChurnReason: Scalars['String']['input'];
  secondaryChurnReason?: InputMaybe<Scalars['String']['input']>;
};

export type CancelSubscriptionOutput = {
  __typename?: 'CancelSubscriptionOutput';
  error?: Maybe<Error>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Card = {
  __typename?: 'Card';
  brand?: Maybe<Scalars['String']['output']>;
  expMonth?: Maybe<Scalars['Int']['output']>;
  expYear?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CardDetails = {
  __typename?: 'CardDetails';
  brand: Scalars['String']['output'];
  expMonth: Scalars['Int']['output'];
  expYear: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  last4: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CarrierStatus = {
  __typename?: 'CarrierStatus';
  carrier: Scalars['String']['output'];
  status: NumberEnrollmentStatus;
};

export type CarrierStatusDetails = {
  __typename?: 'CarrierStatusDetails';
  carrier?: Maybe<Scalars['String']['output']>;
  carrierStatus?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorDescription?: Maybe<Scalars['String']['output']>;
  focDate?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
};

export type Categories = {
  __typename?: 'Categories';
  created_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type CategoryScore = {
  __typename?: 'CategoryScore';
  categoryId: Scalars['ID']['output'];
  categoryName: Scalars['String']['output'];
  score?: Maybe<Scalars['Float']['output']>;
};

export type ChangeEsimDeviceInput = {
  agentId?: InputMaybe<Scalars['Int']['input']>;
  numberUUID: Scalars['String']['input'];
};

export type ChangeEsimDeviceResponse = {
  __typename?: 'ChangeEsimDeviceResponse';
  numberUUID: Scalars['String']['output'];
};

export type ChangeEsimLicenseInput = {
  esimLicense: Scalars['String']['input'];
  numberUUID: Scalars['String']['input'];
};

export type ChangeEsimLicenseResponse = {
  __typename?: 'ChangeEsimLicenseResponse';
  esimLicense: Scalars['String']['output'];
  numberUUID: Scalars['String']['output'];
};

export type ChangePasswordRequestMutationInput = {
  email: Scalars['String']['input'];
};

export enum Channel {
  WHATSAPP = 'WHATSAPP'
}

export type ChannelPayload = {
  channelName: Scalars['String']['input'];
  socketId: Scalars['String']['input'];
};

export type ChatMessageReply = {
  __typename?: 'ChatMessageReply';
  ended: Scalars['Boolean']['output'];
  reply: Scalars['String']['output'];
  toolCalls: Array<ChatToolCall>;
};

export type ChatSession = {
  __typename?: 'ChatSession';
  greeting: Scalars['String']['output'];
  sessionId: Scalars['ID']['output'];
};

export type ChatToolCall = {
  __typename?: 'ChatToolCall';
  args: Scalars['String']['output'];
  category: Scalars['String']['output'];
  name: Scalars['String']['output'];
  result?: Maybe<Scalars['String']['output']>;
};

export type CheckAppVersionError = {
  __typename?: 'CheckAppVersionError';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CheckAppVersionOutput = {
  __typename?: 'CheckAppVersionOutput';
  error?: Maybe<CheckAppVersionError>;
  version?: Maybe<AppVersion>;
};

export type CheckAvailableOutboundEligibilityResponse = {
  __typename?: 'CheckAvailableOutboundEligibilityResponse';
  items: Array<AvailableOutboundEligibilityItem>;
};

export type CheckCarrierNumberVerificationInput = {
  code: Scalars['String']['input'];
  e164: Scalars['String']['input'];
};

export type CheckCarrierNumberVerificationResponse = {
  __typename?: 'CheckCarrierNumberVerificationResponse';
  hasEsim?: Maybe<Scalars['Boolean']['output']>;
  status: Scalars['String']['output'];
  verifiedAt?: Maybe<Scalars['String']['output']>;
};

export type CheckOutboundEligibilityInput = {
  e164s: Array<Scalars['String']['input']>;
};

export type CheckOutboundEligibilityOutput = GenericException | OutboundEligibilityResultList | UserInputException;

export type CheckOutboundEligibilityResponse = {
  __typename?: 'CheckOutboundEligibilityResponse';
  results: Array<OutboundEligibilityResult>;
};

export type CleanOutboundCampaignContactImportRowsOutput = GenericException | OutboundCampaignContactImportCleaned | ResourceNotFoundException;

export type ClearStudioConversationInput = {
  applicationId: Scalars['String']['input'];
};

export type ClearStudioConversationOutput = GenericException | StudioConversation | UserInputException;

export type ClientActionInsights = {
  __typename?: 'ClientActionInsights';
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  createdBy?: Maybe<PhoneTeammateResolver>;
  overviewItems?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  recommendedNextActions?: Maybe<Scalars['String']['output']>;
  streamUrl: Scalars['String']['output'];
};

export type ClientActionInsightsInput = {
  phoneNumber: Scalars['String']['input'];
};

export type ClientActionInsightsOutput = ClientActionInsights | GenericException | UserInputException;

export type ClientActionInsightsSettings = {
  __typename?: 'ClientActionInsightsSettings';
  enabled: Scalars['Boolean']['output'];
};

export type ClientActionInsightsSettingsInput = {
  enabled: Scalars['Boolean']['input'];
};

export type ClientActionInsightsSettingsOutput = ClientActionInsightsSettings | GenericException | InsufficientLicenseException | UserInputException;

export enum ClientContext {
  DASHBOARD = 'DASHBOARD',
  WORKSPACE = 'WORKSPACE'
}

export enum ClientType {
  AI_ASSIST = 'AI_ASSIST',
  MESSAGING_AGENT = 'MESSAGING_AGENT',
  VOICE_AGENT = 'VOICE_AGENT'
}

export type ClientTypesResponse = {
  __typename?: 'ClientTypesResponse';
  client_types: Array<Scalars['String']['output']>;
};

export type ClientTypesResult = ClientTypesResponse | GenericException;

export type CloneVirtualAgentInput = {
  ID: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum CoachingMode {
  ONBOARDING = 'ONBOARDING',
  STANDARD = 'STANDARD'
}

export type CoachingResponse = {
  __typename?: 'CoachingResponse';
  activeCommitments: Array<Scalars['String']['output']>;
  coachingMode: CoachingMode;
  dataSufficiency: DataSufficiency;
  evaluationCount: Scalars['Int']['output'];
  evidenceUsed: Array<EvidenceRef>;
  fallbackReason?: Maybe<Scalars['String']['output']>;
  focusArea?: Maybe<FocusArea>;
  isFallback: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  promptVersion: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
};

export type CoachingSession = {
  __typename?: 'CoachingSession';
  endedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  messageCount: Scalars['Int']['output'];
  startedAt: Scalars['String']['output'];
  status: CoachingSessionStatus;
  summary?: Maybe<Scalars['String']['output']>;
};

export enum CoachingSessionStatus {
  ABANDONED = 'ABANDONED',
  ACTIVE = 'ACTIVE',
  ENDED = 'ENDED'
}

export type CollectionApplication = {
  __typename?: 'CollectionApplication';
  application_type?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Array<Maybe<Categories>>>;
  coming_soon?: Maybe<Scalars['Boolean']['output']>;
  creation_date?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Description>;
  developer?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  install_uri?: Maybe<Scalars['String']['output']>;
  learn_more_uri?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  owner?: Maybe<Scalars['String']['output']>;
  publication_status?: Maybe<Scalars['String']['output']>;
  secret_expiration?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Subtitle>;
  tray_solution_id?: Maybe<Scalars['String']['output']>;
};

export type CollectionDetails = {
  __typename?: 'CollectionDetails';
  applications?: Maybe<Array<CollectionApplication>>;
  created_at: Scalars['String']['output'];
  description: Description;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  updated_at: Scalars['String']['output'];
  visibility: Scalars['Boolean']['output'];
};

export type Collections = {
  __typename?: 'Collections';
  applications?: Maybe<Array<CollectionApplication>>;
  created_at: Scalars['String']['output'];
  description: Description;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  updated_at: Scalars['String']['output'];
  visibility: Scalars['Boolean']['output'];
};

export type Company = {
  __typename?: 'Company';
  ID: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  featuresAllowed: CompanyFeaturesAllowed;
  isActive: Scalars['Boolean']['output'];
  isOnboarded: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  lastTimePlanChanged?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  optOutAiSafety: Scalars['Boolean']['output'];
  optOutTroubleshootingInProduct: Scalars['Boolean']['output'];
  plan: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  reseller?: Maybe<Reseller>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  tierLevel: Scalars['String']['output'];
  trial?: Maybe<CompanyTrial>;
  website?: Maybe<Scalars['String']['output']>;
};

export type CompanyAcknowledgment = {
  __typename?: 'CompanyAcknowledgment';
  acknowledged: Scalars['Boolean']['output'];
  acknowledgedAt?: Maybe<Scalars['String']['output']>;
  acknowledgedBy?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<CompanyAcknowledgmentSource>;
};

export enum CompanyAcknowledgmentSource {
  dashboard = 'dashboard',
  self_service_purchase = 'self_service_purchase'
}

export type CompanyAddon = {
  __typename?: 'CompanyAddon';
  config?: Maybe<CompanyAddonConfig>;
  isSubscriptionInProgress?: Maybe<Scalars['Boolean']['output']>;
  licenseStats?: Maybe<LicenseStats>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  trials?: Maybe<Array<Maybe<CompanyAddonTrial>>>;
};

export type CompanyAddonConfig = {
  __typename?: 'CompanyAddonConfig';
  bundles?: Maybe<Array<Maybe<CompanyFeatureBundle>>>;
  price?: Maybe<CompanyFeaturePrice>;
  trialDurationDays?: Maybe<Scalars['Int']['output']>;
};

export type CompanyAddonTrial = {
  __typename?: 'CompanyAddonTrial';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  remainingDays?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type CompanyBillingDetailsOutput = {
  __typename?: 'CompanyBillingDetailsOutput';
  ID: Scalars['ID']['output'];
  accountOwnerEmail?: Maybe<Scalars['String']['output']>;
  additionalCost: AdditionalCostType;
  becameDelinquentAt?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<AddressOutput>;
  countrySupportedByGCL?: Maybe<Scalars['Boolean']['output']>;
  customerAgeInDays?: Maybe<Scalars['Int']['output']>;
  directDebitDetails?: Maybe<CompanyDirectDebitDetails>;
  directDebitProvider?: Maybe<Scalars['String']['output']>;
  invoiceEmails: Array<Scalars['String']['output']>;
  isDelinquent?: Maybe<Scalars['Boolean']['output']>;
  isFraudulent?: Maybe<Scalars['Boolean']['output']>;
  msa?: Maybe<Scalars['Boolean']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<CompanyDetailsBillingPlanTypes>;
  processoutId: Scalars['String']['output'];
  seatsSegmentation?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<SubscriptionInfo>;
  subscriptionSummary?: Maybe<SubscriptionInfo>;
};


export type CompanyBillingDetailsOutputSubscriptionArgs = {
  includeCalculatedProperties?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CompanyBillingDetailsOutputSubscriptionSummaryArgs = {
  includeCalculatedProperties?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyContext = {
  __typename?: 'CompanyContext';
  ID: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Scalars['String']['output']>;
  status: CompanyContextStatus;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export enum CompanyContextStatus {
  OFF = 'OFF',
  ON = 'ON'
}

export enum CompanyDetailsBillingPlanTypes {
  custom_enterprise = 'custom_enterprise',
  custom_partner_essentials = 'custom_partner_essentials',
  custom_partner_premium = 'custom_partner_premium',
  custom_partner_professional = 'custom_partner_professional',
  custom_premium = 'custom_premium',
  enterprise_august_2016 = 'enterprise_august_2016',
  enterprise_custom_nov_2017 = 'enterprise_custom_nov_2017',
  enterprise_june_2015 = 'enterprise_june_2015',
  enterprise_march_2017 = 'enterprise_march_2017',
  enterprise_sept_2015 = 'enterprise_sept_2015',
  essentials_custom_august_2018 = 'essentials_custom_august_2018',
  essentials_july_2018 = 'essentials_july_2018',
  essentials_july_2020 = 'essentials_july_2020',
  friend = 'friend',
  partner = 'partner',
  plan = 'plan',
  premium_august_2016 = 'premium_august_2016',
  premium_custom_nov_2017 = 'premium_custom_nov_2017',
  premium_june_2015 = 'premium_june_2015',
  premium_march_2017 = 'premium_march_2017',
  premium_sept_2015 = 'premium_sept_2015',
  pro = 'pro',
  pro_oct_2014 = 'pro_oct_2014',
  professional_custom_august_2018 = 'professional_custom_august_2018',
  professional_july_2018 = 'professional_july_2018',
  professional_july_2020 = 'professional_july_2020',
  starter = 'starter',
  starter_august_2016 = 'starter_august_2016',
  starter_june_2015 = 'starter_june_2015',
  starter_sept_2015 = 'starter_sept_2015',
  trial = 'trial',
  trial_partner = 'trial_partner',
  trial_transition = 'trial_transition'
}

export type CompanyDirectDebitDetails = {
  __typename?: 'CompanyDirectDebitDetails';
  bankAccountNumber: Scalars['String']['output'];
  bankName?: Maybe<Scalars['String']['output']>;
  gclCustomerId: Scalars['String']['output'];
  mandateId: Scalars['String']['output'];
  mandateStatus: Scalars['String']['output'];
  nextAction?: Maybe<StripeNextAction>;
  paymentMethodType?: Maybe<Scalars['String']['output']>;
  paymentProvider?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
};

export type CompanyDocument = {
  __typename?: 'CompanyDocument';
  clean_pii: Scalars['Boolean']['output'];
  content_type?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['AWSDateTime']['output'];
  doc_id: Scalars['ID']['output'];
  error_message?: Maybe<Scalars['String']['output']>;
  has_error: Scalars['Boolean']['output'];
  is_crawl_root: Scalars['Boolean']['output'];
  kb_id: Scalars['ID']['output'];
  kb_name: Scalars['String']['output'];
  source_character_count?: Maybe<Scalars['Int']['output']>;
  source_language?: Maybe<Scalars['String']['output']>;
  source_type?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['AWSDateTime']['output'];
  url: Scalars['String']['output'];
};

export type CompanyDocumentsResponse = {
  __typename?: 'CompanyDocumentsResponse';
  documents: Array<CompanyDocument>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CompanyDocumentsResult = CompanyDocumentsResponse | GenericException;

export type CompanyFeatureBundle = {
  __typename?: 'CompanyFeatureBundle';
  price?: Maybe<CompanyFeaturePrice>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type CompanyFeaturePrice = {
  __typename?: 'CompanyFeaturePrice';
  aud?: Maybe<Scalars['Float']['output']>;
  eur?: Maybe<Scalars['Float']['output']>;
  gbp?: Maybe<Scalars['Float']['output']>;
  usd?: Maybe<Scalars['Float']['output']>;
};

export type CompanyFeatures = {
  __typename?: 'CompanyFeatures';
  allow10NumbersInTrial: Scalars['Boolean']['output'];
  isAdvancedAnalyticsAllowed: Scalars['Boolean']['output'];
  isCompanyAccountAllowed: Scalars['Boolean']['output'];
  isLiveFeedAllowed: Scalars['Boolean']['output'];
  isMandatoryTaggingAllowed: Scalars['Boolean']['output'];
  isQueueCallbackAllowed: Scalars['Boolean']['output'];
  isSipSettingsAllowed: Scalars['Boolean']['output'];
  isSupportLinksAllowed: Scalars['Boolean']['output'];
  isTeamsAdvancedAllowed: Scalars['Boolean']['output'];
};

export type CompanyFeaturesAllowed = {
  __typename?: 'CompanyFeaturesAllowed';
  allow10NumbersInTrial: Scalars['Boolean']['output'];
  isBridgeSalesforceAdvancedAllowed: Scalars['Boolean']['output'];
  isCompanyAccountAllowed: Scalars['Boolean']['output'];
  isMandatoryTaggingAllowed: Scalars['Boolean']['output'];
  isQueueCallbackAllowed: Scalars['Boolean']['output'];
  isSalesforceIntegrationAllowed: Scalars['Boolean']['output'];
  isSipSettingsAllowed: Scalars['Boolean']['output'];
  isSupportLinksAllowed: Scalars['Boolean']['output'];
  isTeamsAdvancedAllowed: Scalars['Boolean']['output'];
};

export type CompanyFeaturesOutput = {
  __typename?: 'CompanyFeaturesOutput';
  addons?: Maybe<Array<Maybe<CompanyAddon>>>;
  id: Scalars['ID']['output'];
};

export type CompanyIntegration = {
  __typename?: 'CompanyIntegration';
  attributes: RestIntegration;
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CompanyIntegrations = {
  __typename?: 'CompanyIntegrations';
  data: Array<CompanyIntegration>;
};

export type CompanyKbMappingsOutput = CompanyKbMappingsResponse | GenericException;

export type CompanyKbMappingsResponse = {
  __typename?: 'CompanyKBMappingsResponse';
  mappings: Array<CustomerKbMapping>;
};

export type CompanyKnowledgeBasesResponse = {
  __typename?: 'CompanyKnowledgeBasesResponse';
  mappings: Array<KnowledgeBaseMapping>;
};

export type CompanyPlan = {
  __typename?: 'CompanyPlan';
  features: CompanyPlanFeatures;
  name: Scalars['String']['output'];
};

export type CompanyPlanFeatures = {
  __typename?: 'CompanyPlanFeatures';
  featureLevel: StripePlanFeatureLevel;
  featuresIncluded: Array<Maybe<Scalars['String']['output']>>;
  level: Scalars['Int']['output'];
  nbLinesIncluded: Scalars['Int']['output'];
  nbLinesMax: Scalars['Int']['output'];
  nbTeamsMax: Scalars['Int']['output'];
  nbUsersIncluded: Scalars['Int']['output'];
  nbUsersMax: Scalars['Int']['output'];
  pricePerNumber: RestCurrencies;
  pricePerUser: CompanyPlanPricePerUser;
};

export type CompanyPlanPricePerUser = {
  __typename?: 'CompanyPlanPricePerUser';
  annually: RestCurrencies;
  monthly: RestCurrencies;
  quarterly: RestCurrencies;
};

export type CompanyPromotion = {
  __typename?: 'CompanyPromotion';
  balanceUnits?: Maybe<Scalars['Int']['output']>;
  companyId: Scalars['ID']['output'];
  consumedUnits: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  offeredUnits?: Maybe<Scalars['Int']['output']>;
  product: PromotionProduct;
  promoName: Scalars['String']['output'];
  status: PromotionStatus;
  unlimited: Scalars['Boolean']['output'];
};

export type CompanyRef = {
  __typename?: 'CompanyRef';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type CompanyRelationships = {
  __typename?: 'CompanyRelationships';
  reseller: CompanyReseller;
};

export type CompanyReseller = {
  __typename?: 'CompanyReseller';
  data?: Maybe<CompanyResellerData>;
};

export type CompanyResellerData = {
  __typename?: 'CompanyResellerData';
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CompanySettings = {
  __typename?: 'CompanySettings';
  plans: Array<CompanyPlan>;
};

export type CompanyTrial = {
  __typename?: 'CompanyTrial';
  callTotalSeconds?: Maybe<Scalars['Int']['output']>;
  hasTrialCallLimits: Scalars['Boolean']['output'];
  trialEnd: Scalars['String']['output'];
  trialStart?: Maybe<Scalars['String']['output']>;
};

export enum CompletionType {
  ACTION = 'ACTION',
  DISMISSAL = 'DISMISSAL'
}

export type ConferenceParticipant = PhoneContactResolver | PhoneTeammateResolver;

export type ConferencePhoneCall = PhoneCall & {
  __typename?: 'ConferencePhoneCall';
  ID: Scalars['ID']['output'];
  archivedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  assigned?: Maybe<PhoneCallAssigned>;
  callUuid: Scalars['String']['output'];
  callee: PhoneCallCallee;
  caller: PhoneCallCaller;
  createdAt: Scalars['AWSDateTime']['output'];
  direction: PhoneCallDirection;
  duration: Scalars['Int']['output'];
  internalTags: Array<PhoneCallTag>;
  line: LineResolver;
  notes: Array<PhoneCallNote>;
  outboundCampaignAttempt?: Maybe<OutboundCampaignAttemptResolver>;
  participants: Array<ConferenceParticipant>;
  proxiedAudioUrl?: Maybe<Scalars['String']['output']>;
  proxiedRecordingUrl?: Maybe<Scalars['String']['output']>;
  recordingDurationMs?: Maybe<Scalars['Int']['output']>;
  status: PhoneCallStatus;
  tags: Array<PhoneCallTag>;
  teammate?: Maybe<PhoneTeammateResolver>;
  timeline?: Maybe<PhoneCallTimelineResolver>;
  transcription?: Maybe<TranscriptionResolver>;
  type: PhoneCallType;
  voiceAgents?: Maybe<Array<VoiceAgentParticipant>>;
};

export type ConfigEvaluation = {
  __typename?: 'ConfigEvaluation';
  createdAt: Scalars['String']['output'];
  durationMs?: Maybe<Scalars['Int']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  evaluationId: Scalars['ID']['output'];
  evaluationScore?: Maybe<Scalars['Float']['output']>;
  includeSystemInstructions: Scalars['Boolean']['output'];
  redFlags?: Maybe<Array<Finding>>;
  status: EvaluationStatus;
  suggestions?: Maybe<Array<Finding>>;
  updatedAt: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
  virtualAgentID: Scalars['ID']['output'];
  warnings?: Maybe<Array<Finding>>;
};

export type ConfigEvaluationJob = {
  __typename?: 'ConfigEvaluationJob';
  evaluationId: Scalars['ID']['output'];
  status: EvaluationStatus;
};

export type ConfigEvaluationJobOutput = ConfigEvaluationJob | GenericException | ResourceNotFoundException;

export type ConfigEvaluationOutput = ConfigEvaluationResponse | GenericException | ResourceNotFoundException;

export type ConfigEvaluationResponse = {
  __typename?: 'ConfigEvaluationResponse';
  durationMs: Scalars['Int']['output'];
  evaluationScore: Scalars['Float']['output'];
  redFlags: Array<Finding>;
  suggestions: Array<Finding>;
  warnings: Array<Finding>;
};

export type ConfigEvaluationResultOutput = ConfigEvaluation | GenericException | ResourceNotFoundException;

export type ConfigOverride = {
  __typename?: 'ConfigOverride';
  agentListen?: Maybe<AgentListenConfig>;
  agentSpeak?: Maybe<AgentSpeakConfig>;
  agentThink?: Maybe<AgentThinkConfig>;
  ivrPrompt?: Maybe<Scalars['String']['output']>;
  limits?: Maybe<LimitsConfig>;
  stsType?: Maybe<StsType>;
};

export type ConfigOverrideInput = {
  agentListen?: InputMaybe<AgentListenConfigInput>;
  agentSpeak?: InputMaybe<AgentSpeakConfigInput>;
  agentThink?: InputMaybe<AgentThinkConfigInput>;
  ivrPrompt?: InputMaybe<Scalars['String']['input']>;
  limits?: InputMaybe<LimitsConfigInput>;
  stsType?: InputMaybe<StsType>;
};

export type ConfigSuggestion = {
  __typename?: 'ConfigSuggestion';
  action: Scalars['String']['output'];
  callsAffected: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  issue: Scalars['String']['output'];
  projectedImpact?: Maybe<ConfigSuggestionProjectedImpact>;
  section: Scalars['String']['output'];
  suggestionId: Scalars['String']['output'];
};

export type ConfigSuggestionProjectedImpact = {
  __typename?: 'ConfigSuggestionProjectedImpact';
  autonomousResolutionRateDelta: Scalars['Float']['output'];
  escalationRateDelta: Scalars['Float']['output'];
  fixableEscalated: Scalars['Int']['output'];
  fixableNotResolved: Scalars['Int']['output'];
  goalCompletionRateDelta: Scalars['Float']['output'];
  projectedAutonomousResolutionRate: Scalars['Float']['output'];
  projectedEscalationRate: Scalars['Float']['output'];
  projectedGoalCompletionRate: Scalars['Float']['output'];
};

export type ConfirmVerdictOutput = GenericException | ResourceNotFoundException | ScenarioResult | UserInputException;

export type ConflictException = Exception & {
  __typename?: 'ConflictException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  resource?: Maybe<Scalars['String']['output']>;
};

export type ConnectPlaneCapabilitiesOutput = ConnectPlaneCapabilitiesResponse | GenericException | ResourceNotFoundException;

export type ConnectPlaneCapabilitiesResponse = {
  __typename?: 'ConnectPlaneCapabilitiesResponse';
  capabilities: Array<ConnectPlaneCapabilityResponse>;
};

export type ConnectPlaneCapabilitiesV2Output = ConnectPlaneCapabilitiesV2Response | GenericException | UserInputException;

export type ConnectPlaneCapabilitiesV2Response = {
  __typename?: 'ConnectPlaneCapabilitiesV2Response';
  capabilities: Array<ConnectPlaneCapabilityV2Response>;
};

export type ConnectPlaneCapabilityResponse = {
  __typename?: 'ConnectPlaneCapabilityResponse';
  authStatus: McpAuthStatus;
  icon: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  integrationId: Scalars['ID']['output'];
  integrationName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tools: Array<ConnectPlaneToolResponse>;
};

export type ConnectPlaneCapabilityToolOutput = ConnectPlaneToolDetailResponse | GenericException | ResourceNotFoundException | UserInputException;

export type ConnectPlaneCapabilityV2Response = {
  __typename?: 'ConnectPlaneCapabilityV2Response';
  authStatus: McpAuthStatus;
  authType?: Maybe<Scalars['String']['output']>;
  credentialStatus?: Maybe<CredentialStatus>;
  iconUrl: Scalars['String']['output'];
  integrationId: Scalars['ID']['output'];
  integrationName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tools: Array<ConnectPlaneToolSummary>;
};

export type ConnectPlaneMcpConfigInput = {
  agentType: AgentType;
  applicationId: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
  integrationName: Scalars['String']['input'];
  tools: Array<ConnectPlaneMcpToolInput>;
  version: Scalars['Int']['input'];
};

export type ConnectPlaneMcpConfigListOutput = ConnectPlaneMcpConfigResponseList | GenericException | ResourceNotFoundException | UserInputException;

export type ConnectPlaneMcpConfigOutput = ConflictException | ConnectPlaneMcpConfigResponse | GenericException | ResourceNotFoundException | UserInputException;

export type ConnectPlaneMcpConfigResponse = {
  __typename?: 'ConnectPlaneMCPConfigResponse';
  active: Scalars['Boolean']['output'];
  agentType: AgentType;
  applicationId: Scalars['ID']['output'];
  companyId: Scalars['ID']['output'];
  credentialStatus?: Maybe<CredentialStatus>;
  integrationId: Scalars['ID']['output'];
  integrationName: Scalars['String']['output'];
  settings?: Maybe<Scalars['String']['output']>;
  tools: Array<ConnectPlaneMcpToolResponse>;
  version: Scalars['Int']['output'];
};

export type ConnectPlaneMcpConfigResponseList = {
  __typename?: 'ConnectPlaneMCPConfigResponseList';
  configs: Array<ConnectPlaneMcpConfigResponse>;
};

export type ConnectPlaneMcpToolInput = {
  id: Scalars['ID']['input'];
  isAuthorized: Scalars['Boolean']['input'];
  outputSchema?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['Int']['input'];
};

export type ConnectPlaneMcpToolOutput = ConflictException | ConnectPlaneMcpToolResponse | GenericException | ResourceNotFoundException | UserInputException;

export type ConnectPlaneMcpToolResponse = {
  __typename?: 'ConnectPlaneMCPToolResponse';
  annotations?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inputSchema: Scalars['String']['output'];
  isAuthorized: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  outputSchema?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type ConnectPlaneToolDetailResponse = {
  __typename?: 'ConnectPlaneToolDetailResponse';
  annotations?: Maybe<Scalars['String']['output']>;
  inputSchema: Scalars['String']['output'];
  name: Scalars['String']['output'];
  outputSchema?: Maybe<Scalars['String']['output']>;
};

export type ConnectPlaneToolResponse = {
  __typename?: 'ConnectPlaneToolResponse';
  annotations?: Maybe<Scalars['String']['output']>;
  callerAuthAttributes: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  inputSchema: Scalars['String']['output'];
  name: Scalars['String']['output'];
  outputSchema?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  versionHash: Scalars['String']['output'];
};

export type ConnectPlaneToolSummary = {
  __typename?: 'ConnectPlaneToolSummary';
  annotations?: Maybe<Scalars['String']['output']>;
  callerAuthAttributes: Array<Scalars['String']['output']>;
  dependencies: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  title: Scalars['String']['output'];
  versionHash: Scalars['String']['output'];
};

export type Contact = {
  __typename?: 'Contact';
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  emails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  extracts?: Maybe<Array<Maybe<ContactExtract>>>;
  fullName?: Maybe<Scalars['String']['output']>;
  information?: Maybe<Scalars['String']['output']>;
  ownerID: Scalars['Int']['output'];
  phoneNumber: Scalars['String']['output'];
  pictureURL?: Maybe<Scalars['String']['output']>;
  secondaryPhoneNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  shortName: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ContactByPhoneNumberInput = {
  phoneNumber: Scalars['String']['input'];
};

export type ContactByPhoneNumberOutput = GenericException | PhoneContact | ResourceNotFoundException | UserInputException;

export type ContactByPhoneNumberResult = {
  __typename?: 'ContactByPhoneNumberResult';
  phoneContact?: Maybe<PhoneContact>;
};

export type ContactExtract = {
  __typename?: 'ContactExtract';
  ID: Scalars['ID']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  emails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  externalID?: Maybe<Scalars['String']['output']>;
  externalLink?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  information?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  ownerID: Scalars['Int']['output'];
  phoneNumber: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  secondaryPhoneNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sourceAppID: Scalars['String']['output'];
  sourceAppLogo?: Maybe<ContactExtractSourceAppLogo>;
  sourceAppName?: Maybe<Scalars['String']['output']>;
  sourceID: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type ContactExtractSourceAppLogo = {
  __typename?: 'ContactExtractSourceAppLogo';
  png?: Maybe<Scalars['String']['output']>;
  svg?: Maybe<Scalars['String']['output']>;
};

export type ContactFields = {
  __typename?: 'ContactFields';
  companyName?: Maybe<Scalars['String']['output']>;
  emails: Array<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumbers: Array<Scalars['String']['output']>;
};

export type ContactImage = {
  __typename?: 'ContactImage';
  url: Scalars['String']['output'];
};

export type ContactsByPhoneNumbersInput = {
  phoneNumbers: Array<Scalars['String']['input']>;
};

export type ContactsByPhoneNumbersOutput = ContactsByPhoneNumbersResult | GenericException | UserInputException;

export type ContactsByPhoneNumbersResult = {
  __typename?: 'ContactsByPhoneNumbersResult';
  contacts: Array<PhoneContact>;
  items: Array<Maybe<PhoneContact>>;
};

export type ContactsPaginationInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type ContactsSearchResult = {
  __typename?: 'ContactsSearchResult';
  contact?: Maybe<Contact>;
  searchQuery?: Maybe<Scalars['String']['output']>;
};

export type Contract = {
  __typename?: 'Contract';
  ID?: Maybe<Scalars['Int']['output']>;
  account?: Maybe<Scalars['Int']['output']>;
  clmRecordSync?: Maybe<RecordSync>;
  countries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  createdTime?: Maybe<Scalars['AWSDateTime']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  downloadEndpoint?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  languageDirection?: Maybe<Scalars['String']['output']>;
  latestVersion?: Maybe<Scalars['String']['output']>;
  locales?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  private?: Maybe<Scalars['Boolean']['output']>;
  protected?: Maybe<Scalars['Boolean']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  publishedBy?: Maybe<Scalars['Int']['output']>;
  publishedTime?: Maybe<Scalars['AWSDateTime']['output']>;
  publishedVersion?: Maybe<Scalars['String']['output']>;
  shared?: Maybe<Scalars['Boolean']['output']>;
  site?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
  updatedTime?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type Conversation = {
  __typename?: 'Conversation';
  ID: Scalars['ID']['output'];
  agent?: Maybe<MessagingAgent>;
  company: Company;
  createdAt: Scalars['String']['output'];
  externalLine: ExternalLine;
  lastMessage?: Maybe<LastMessage>;
  line: Line;
  listMessages: MessageConnection;
  markAsDone: Scalars['Boolean']['output'];
  status: ConversationStatus;
  unreadMessagesCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['String']['output'];
};


export type ConversationListMessagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['ID']['input']>;
};

export type ConversationAgent = {
  __typename?: 'ConversationAgent';
  agent?: Maybe<Agent>;
  agentDetails?: Maybe<AgentDetails>;
  agentId: Scalars['Int']['output'];
  teammate: PhoneTeammateResolver;
};

export type ConversationAssigned = {
  __typename?: 'ConversationAssigned';
  at: Scalars['AWSDateTime']['output'];
  by?: Maybe<PhoneTeammateResolver>;
  to: PhoneTeammateResolver;
};

export type ConversationClosedEngagement = Engagement & {
  __typename?: 'ConversationClosedEngagement';
  ID: Scalars['ID']['output'];
  author: ConversationClosedEngagementAuthor;
  createdAt: Scalars['AWSDateTime']['output'];
};

export type ConversationClosedEngagementAuthor = MessagingAiAgentResolver | PhoneTeammateResolver | SystemEntity;

export type ConversationConnection = {
  __typename?: 'ConversationConnection';
  conversations: Array<Conversation>;
  pageInfo: PageInfo;
  unreadConversationsCount: Scalars['Int']['output'];
};

export type ConversationContact = {
  __typename?: 'ConversationContact';
  contact?: Maybe<Contact>;
  external: PhoneContactResolver;
  phoneNumber: Scalars['String']['output'];
};

export type ConversationExternalEntity = GroupConversationResolver | PhoneContactResolver | WhatsappUserResolver;

export type ConversationInput = {
  ID: Scalars['ID']['input'];
  agentID?: InputMaybe<Scalars['ID']['input']>;
  companyID: Scalars['ID']['input'];
  createdAt: Scalars['String']['input'];
  externalLine: ExternalLineInput;
  lineID: Scalars['ID']['input'];
  status: ConversationStatus;
  unreadMessagesCount?: InputMaybe<Scalars['Int']['input']>;
  updatedAt: Scalars['String']['input'];
};

export type ConversationMessagingAiResolver = {
  __typename?: 'ConversationMessagingAIResolver';
  agent: MessagingAiAgent;
  agentSummary?: Maybe<MessagingAiAgentSummary>;
};

export type ConversationMetadata = {
  __typename?: 'ConversationMetadata';
  whatsapp?: Maybe<WhatsappMetadata>;
};

export type ConversationReadInput = {
  agentID: Scalars['ID']['input'];
  companyID: Scalars['ID']['input'];
  externalNumber: Scalars['String']['input'];
  lineID: Scalars['ID']['input'];
};

export type ConversationReopenedEngagement = Engagement & {
  __typename?: 'ConversationReopenedEngagement';
  ID: Scalars['ID']['output'];
  author: ConversationReopenedEngagementAuthor;
  createdAt: Scalars['AWSDateTime']['output'];
};

export type ConversationReopenedEngagementAuthor = PhoneTeammateResolver | SystemEntity;

export enum ConversationStatus {
  archived = 'archived',
  opened = 'opened'
}

export type ConversationTag = {
  __typename?: 'ConversationTag';
  name?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<PhoneCallTagResolver>;
};

export type ConversationTracker = {
  __typename?: 'ConversationTracker';
  tracker?: Maybe<Tracker>;
  trackerId: Scalars['Int']['output'];
};

export enum ConversationType {
  GroupSmsMmsConversation = 'GroupSmsMmsConversation',
  OneToOneConversation = 'OneToOneConversation',
  WhatsappUserConversation = 'WhatsappUserConversation'
}

export type ConversationUnreadInput = {
  agentID: Scalars['ID']['input'];
  companyID: Scalars['ID']['input'];
  externalNumber: Scalars['String']['input'];
  lineID: Scalars['ID']['input'];
};

export type ConversationUpdatedMutationFilter = {
  conversationID?: InputMaybe<Scalars['ID']['input']>;
  conversationType?: InputMaybe<ConversationType>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export enum ConversationUpdatedReason {
  AIMA_DEESCALATED = 'AIMA_DEESCALATED',
  AIMA_ESCALATED = 'AIMA_ESCALATED',
  AIMA_STATE_CHANGED = 'AIMA_STATE_CHANGED',
  ASSIGNEE_CHANGED = 'ASSIGNEE_CHANGED',
  CLOSED = 'CLOSED',
  OPENED = 'OPENED',
  UNASSIGNED = 'UNASSIGNED',
  WHATSAPP_WINDOW_CLOSING_TIME_CHANGED = 'WHATSAPP_WINDOW_CLOSING_TIME_CHANGED'
}

export type ConversationUpdatedSubscriptionFilter = {
  __typename?: 'ConversationUpdatedSubscriptionFilter';
  conversationID?: Maybe<Scalars['ID']['output']>;
  conversationType?: Maybe<ConversationType>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type ConversationUpdatedSubscriptionFilterInput = {
  conversationID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<TimestampSubscriptionFilter>;
  withGroupSmsMmsConversations?: InputMaybe<Scalars['Boolean']['input']>;
  withWhatsappUsernameConversations?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationVirtualAgent = {
  __typename?: 'ConversationVirtualAgent';
  virtualAgent?: Maybe<VirtualAgentResolver>;
};

export type ConversationWatcher = {
  __typename?: 'ConversationWatcher';
  avatar?: Maybe<Scalars['String']['output']>;
  userID?: Maybe<Scalars['ID']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type ConversationsAllReadInput = {
  agentID: Scalars['ID']['input'];
};

export enum ConversationsSortKey {
  ESCALATED_FIRST = 'ESCALATED_FIRST',
  LAST_ENGAGEMENT = 'LAST_ENGAGEMENT'
}

export type ConvertAivaAgentActionsInput = {
  agentId: Scalars['ID']['input'];
  companyId: Scalars['Int']['input'];
};

export type ConvertAivaAgentActionsOutput = AivaAgentConversion | GenericException | ResourceNotFoundException | UserInputException;

export type CoreKbBriefInfo = {
  __typename?: 'CoreKBBriefInfo';
  current_status: Scalars['String']['output'];
  kb_id: Scalars['ID']['output'];
  kb_name: Scalars['String']['output'];
};

export type CoreKbBulkEnableRagInput = {
  dry_run?: InputMaybe<Scalars['Boolean']['input']>;
  kb_ids: Array<Scalars['ID']['input']>;
};

export type CoreKbBulkEnableRagResult = {
  __typename?: 'CoreKBBulkEnableRAGResult';
  dry_run: Scalars['Boolean']['output'];
  kb_ids?: Maybe<Array<Scalars['ID']['output']>>;
  kb_list?: Maybe<Array<CoreKbBriefInfo>>;
  kbs_affected: Scalars['Int']['output'];
  kbs_enabled?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CoreKbBulkEnableRagResultUnion = CoreKbBulkEnableRagResult | GenericException;

export type CoreKbChildDocument = {
  __typename?: 'CoreKBChildDocument';
  content_type?: Maybe<Scalars['String']['output']>;
  crawl_depth?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['AWSDateTime']['output'];
  error_message?: Maybe<Scalars['String']['output']>;
  has_error: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  link_text?: Maybe<Scalars['String']['output']>;
  parent_url?: Maybe<Scalars['String']['output']>;
  source_full_path: Scalars['String']['output'];
  status: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['AWSDateTime']['output'];
};

export type CoreKbChildDocumentsResponse = {
  __typename?: 'CoreKBChildDocumentsResponse';
  children: Array<CoreKbChildDocument>;
  crawl_root_id: Scalars['ID']['output'];
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CoreKbChildDocumentsResult = CoreKbChildDocumentsResponse | GenericException;

export type CoreKbCompanyRagSettingsInput = {
  rag_enabled: Scalars['Boolean']['input'];
  rag_enabled_by_default: Scalars['Boolean']['input'];
};

export type CoreKbCompanyRagSettingsResult = {
  __typename?: 'CoreKBCompanyRAGSettingsResult';
  company_updated: Scalars['Boolean']['output'];
  kbs_affected: Scalars['Int']['output'];
  kbs_status_changed: Scalars['Int']['output'];
  kbs_with_rag_enabled: Scalars['Int']['output'];
  reprocessing_triggered: Array<CoreKbReprocessingResult>;
  success: Scalars['Boolean']['output'];
};

export type CoreKbCompanyRagSettingsResultUnion = CoreKbCompanyRagSettingsResult | GenericException;

export type CoreKbCrawlRootDocument = {
  __typename?: 'CoreKBCrawlRootDocument';
  child_count: Scalars['Int']['output'];
  content_type?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['AWSDateTime']['output'];
  error_message?: Maybe<Scalars['String']['output']>;
  has_error: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  source_full_path: Scalars['String']['output'];
  source_type?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['AWSDateTime']['output'];
};

export type CoreKbCrawlRootsResponse = {
  __typename?: 'CoreKBCrawlRootsResponse';
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  roots: Array<CoreKbCrawlRootDocument>;
  total: Scalars['Int']['output'];
};

export type CoreKbCrawlRootsResult = CoreKbCrawlRootsResponse | GenericException;

export type CoreKbIntegration = {
  __typename?: 'CoreKBIntegration';
  application_id: Scalars['String']['output'];
  auto_refresh_enabled: Scalars['Boolean']['output'];
  company_id: Scalars['Int']['output'];
  created_at?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['Int']['output'];
  integration_id: Scalars['String']['output'];
  last_refreshed_at?: Maybe<Scalars['AWSDateTime']['output']>;
  next_refresh_at?: Maybe<Scalars['AWSDateTime']['output']>;
  provider: Scalars['String']['output'];
  provider_account_label: Scalars['String']['output'];
  refresh_period_hours?: Maybe<Scalars['Int']['output']>;
  refresh_status: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type CoreKbIntegrationArticle = {
  __typename?: 'CoreKBIntegrationArticle';
  external_article_id: Scalars['String']['output'];
  fetch_status: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type CoreKbIntegrationList = {
  __typename?: 'CoreKBIntegrationList';
  integrations: Array<CoreKbIntegration>;
};

export type CoreKbIntegrationListResult = CoreKbIntegrationList | GenericException;

export type CoreKbIntegrationResult = CoreKbIntegration | GenericException;

export type CoreKbIntegrationSubscription = {
  __typename?: 'CoreKBIntegrationSubscription';
  article_count: Scalars['Int']['output'];
  company_integration_id: Scalars['Int']['output'];
  crawl_document_id: Scalars['Int']['output'];
  created_at: Scalars['AWSDateTime']['output'];
  selected_articles?: Maybe<Array<CoreKbIntegrationArticle>>;
  source_full_path: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type CoreKbIntegrationSubscriptionList = {
  __typename?: 'CoreKBIntegrationSubscriptionList';
  subscriptions: Array<CoreKbIntegrationSubscription>;
};

export type CoreKbIntegrationSubscriptionListResult = CoreKbIntegrationSubscriptionList | GenericException;

export type CoreKbIntegrationSubscriptionResult = CoreKbIntegrationSubscription | GenericException;

export type CoreKbIntegrationSyncResult = CoreKbIntegrationSyncStatus | GenericException;

export type CoreKbIntegrationSyncStatus = {
  __typename?: 'CoreKBIntegrationSyncStatus';
  company_integration_id: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type CoreKbKnowledgeChunk = {
  __typename?: 'CoreKBKnowledgeChunk';
  content: Scalars['String']['output'];
  id: Scalars['String']['output'];
  metadata?: Maybe<CoreKbKnowledgeChunkMetadata>;
  score: Scalars['Float']['output'];
};

export type CoreKbKnowledgeChunkMetadata = {
  __typename?: 'CoreKBKnowledgeChunkMetadata';
  chunk_id: Scalars['String']['output'];
  company_id: Scalars['Int']['output'];
  content: Scalars['String']['output'];
  created_at: Scalars['AWSDateTime']['output'];
  document_id: Scalars['Int']['output'];
  embedding_model: Scalars['String']['output'];
  kb_id: Scalars['String']['output'];
};

export type CoreKbKnowledgeExtractionInput = {
  client_type: Scalars['String']['input'];
  k?: InputMaybe<Scalars['Int']['input']>;
  kb_id: Scalars['String']['input'];
  query: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
};

export type CoreKbKnowledgeExtractionResult = {
  __typename?: 'CoreKBKnowledgeExtractionResult';
  chunks: Array<CoreKbKnowledgeChunk>;
  kb_id: Scalars['String']['output'];
  query: Scalars['String']['output'];
  reranked: Scalars['Boolean']['output'];
  total_found: Scalars['Int']['output'];
};

export type CoreKbKnowledgeExtractionResultUnion = CoreKbKnowledgeExtractionResult | GenericException;

export type CoreKbragDocumentProgress = {
  __typename?: 'CoreKBRAGDocumentProgress';
  chunks_generated?: Maybe<Scalars['Int']['output']>;
  document_id: Scalars['ID']['output'];
  processing_completed_at?: Maybe<Scalars['AWSDateTime']['output']>;
  processing_started_at?: Maybe<Scalars['AWSDateTime']['output']>;
  status: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type CoreKbragOverrideResult = {
  __typename?: 'CoreKBRAGOverrideResult';
  effective_rag_enabled: Scalars['Boolean']['output'];
  kb_id: Scalars['ID']['output'];
  rag_enabled_override?: Maybe<Scalars['Boolean']['output']>;
  rag_status_changed: Scalars['Boolean']['output'];
  reprocessing_result?: Maybe<CoreKbReprocessingResult>;
  reprocessing_triggered: Scalars['Boolean']['output'];
  status_description: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CoreKbragOverrideResultUnion = CoreKbragOverrideResult | GenericException;

export enum CoreKbragProcessingStatus {
  DISABLED = 'DISABLED',
  ERROR = 'ERROR',
  PROCESSING = 'PROCESSING',
  READY = 'READY'
}

export type CoreKbragProgress = {
  __typename?: 'CoreKBRAGProgress';
  documents: Array<CoreKbragDocumentProgress>;
  kb_id: Scalars['ID']['output'];
  rag_enabled: Scalars['Boolean']['output'];
  summary: CoreKbragProgressSummary;
};

export type CoreKbragProgressResult = CoreKbragProgress | GenericException;

export type CoreKbragProgressSummary = {
  __typename?: 'CoreKBRAGProgressSummary';
  failed: Scalars['Int']['output'];
  percent_complete: Scalars['Int']['output'];
  processed: Scalars['Int']['output'];
  processing: Scalars['Int']['output'];
  total_documents: Scalars['Int']['output'];
};

export type CoreKbragStatus = {
  __typename?: 'CoreKBRAGStatus';
  documents_pending: Scalars['Int']['output'];
  documents_processed: Scalars['Int']['output'];
  documents_total: Scalars['Int']['output'];
  embedding_model?: Maybe<Scalars['String']['output']>;
  kb_id: Scalars['ID']['output'];
  pinecone_namespace?: Maybe<Scalars['String']['output']>;
  rag_enabled_for_kb: Scalars['Boolean']['output'];
  rag_globally_enabled: Scalars['Boolean']['output'];
  rag_processing_status: CoreKbragProcessingStatus;
  status_description: Scalars['String']['output'];
};

export type CoreKbragStatusResult = CoreKbragStatus | GenericException;

export type CoreKbReprocessingResult = {
  __typename?: 'CoreKBReprocessingResult';
  document_ids: Array<Scalars['ID']['output']>;
  documents_queued: Scalars['Int']['output'];
  kb_id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
};

export type CoreKbUsage = {
  __typename?: 'CoreKBUsage';
  document_count: Scalars['Int']['output'];
  kb_id: Scalars['ID']['output'];
  max_clean_chars?: Maybe<Scalars['Int']['output']>;
  total_clean_chars?: Maybe<Scalars['Int']['output']>;
};

export type CoreKbUsageResult = CoreKbUsage | GenericException;

export type CountCallConversations = {
  __typename?: 'CountCallConversations';
  count: Scalars['Int']['output'];
};

export type Country = {
  __typename?: 'Country';
  ID: Scalars['ID']['output'];
  alpha2: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nameTranslations?: Maybe<NameTranslations>;
  numberTypes: Array<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type CountryCurrency = {
  __typename?: 'CountryCurrency';
  countryCode: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  secondaryCurrency?: Maybe<Scalars['String']['output']>;
};

export type CpPlan = {
  __typename?: 'CpPlan';
  basePrice?: Maybe<PlanPricePerUser>;
  featureLevel: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nbLinesIncluded: Scalars['Int']['output'];
  nbLinesOfferedForFree?: Maybe<Scalars['Int']['output']>;
  nbUsersIncluded: Scalars['Int']['output'];
  nbUsersOfferedForFree?: Maybe<Scalars['Int']['output']>;
  pricePerNumber: Currencies;
  pricePerUser: PlanPricePerUser;
};

export type CrawlDocument = {
  __typename?: 'CrawlDocument';
  cleanPii: Scalars['Boolean']['output'];
  companyId?: Maybe<Scalars['Int']['output']>;
  crawlDepth?: Maybe<Scalars['Int']['output']>;
  crawlRootId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  credentialsId?: Maybe<Scalars['Int']['output']>;
  documentFormatId: Scalars['Int']['output'];
  documentTypeId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  linkText?: Maybe<Scalars['String']['output']>;
  md5Sum?: Maybe<Scalars['String']['output']>;
  metadataUi?: Maybe<DocumentMetadataUi>;
  originalDocumentId?: Maybe<Scalars['Int']['output']>;
  ownerId?: Maybe<Scalars['Int']['output']>;
  parentUrl?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  sha1Sum?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  source: DocumentSource;
  sourceEncoding?: Maybe<Scalars['String']['output']>;
  sourceFullPath: Scalars['String']['output'];
  status: DocumentStatus;
  targetFullPath?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type CrawlDocumentCreateInput = {
  cleanPii?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  crawlDepth?: InputMaybe<Scalars['Int']['input']>;
  crawlRootId?: InputMaybe<Scalars['Int']['input']>;
  credentialsId?: InputMaybe<Scalars['Int']['input']>;
  documentFormatId: Scalars['Int']['input'];
  documentMetadata?: InputMaybe<Scalars['String']['input']>;
  documentTypeId: Scalars['Int']['input'];
  heading?: InputMaybe<Scalars['String']['input']>;
  isLatest?: InputMaybe<Scalars['Boolean']['input']>;
  kbId?: InputMaybe<Scalars['Int']['input']>;
  kbName?: InputMaybe<Scalars['String']['input']>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  md5Sum?: InputMaybe<Scalars['String']['input']>;
  metadataUi?: InputMaybe<DocumentMetadataUiInput>;
  originalDocumentId?: InputMaybe<Scalars['Int']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  parentUrl?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  sha1Sum?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  source: DocumentSource;
  sourceEncoding?: InputMaybe<Scalars['String']['input']>;
  sourceFullPath: Scalars['String']['input'];
  status: DocumentStatus;
  targetFullPath?: InputMaybe<Scalars['String']['input']>;
  textContent?: InputMaybe<Scalars['String']['input']>;
};

export type CrawlDocumentListOutput = CrawlDocumentListResponse | GenericException;

export type CrawlDocumentListResponse = {
  __typename?: 'CrawlDocumentListResponse';
  documents: Array<CrawlDocument>;
  page: Scalars['Int']['output'];
  pageInfo?: Maybe<KnowledgeBasePageInfo>;
  perPage: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CrawlDocumentOutput = CrawlDocument | GenericException;

export enum CrawlDocumentSortField {
  createdAt = 'createdAt',
  id = 'id',
  sourceFullPath = 'sourceFullPath',
  status = 'status',
  updatedAt = 'updatedAt'
}

export type CrawlDocumentUpdateInput = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  crawlDepth?: InputMaybe<Scalars['Int']['input']>;
  crawlRootId?: InputMaybe<Scalars['Int']['input']>;
  credentialsId?: InputMaybe<Scalars['Int']['input']>;
  documentFormatId?: InputMaybe<Scalars['Int']['input']>;
  documentMetadata?: InputMaybe<Scalars['String']['input']>;
  documentTypeId?: InputMaybe<Scalars['Int']['input']>;
  isLatest?: InputMaybe<Scalars['Boolean']['input']>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  md5Sum?: InputMaybe<Scalars['String']['input']>;
  originalDocumentId?: InputMaybe<Scalars['Int']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  parentUrl?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  sha1Sum?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<DocumentSource>;
  sourceEncoding?: InputMaybe<Scalars['String']['input']>;
  sourceFullPath?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DocumentStatus>;
  targetFullPath?: InputMaybe<Scalars['String']['input']>;
};

export type CrawlRootCreateInput = {
  cleanPii?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  credentialsId?: InputMaybe<Scalars['Int']['input']>;
  documentFormatId: Scalars['Int']['input'];
  documentTypeId: Scalars['Int']['input'];
  kbId?: InputMaybe<Scalars['Int']['input']>;
  maxDepth?: InputMaybe<Scalars['Int']['input']>;
  originalDocumentId?: InputMaybe<Scalars['Int']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  sourceFullPath: Scalars['String']['input'];
};

export type CreateActionInput = {
  agentId: Scalars['ID']['input'];
  authMethodId?: InputMaybe<Scalars['ID']['input']>;
  bodyTemplate?: InputMaybe<Scalars['String']['input']>;
  dataInputs?: InputMaybe<Array<DataInputInput>>;
  dataOutputs?: InputMaybe<Array<DataOutputInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  headers?: InputMaybe<Array<ActionHeaderInput>>;
  method: ActionMethod;
  name: Scalars['String']['input'];
  noOp?: InputMaybe<Scalars['Boolean']['input']>;
  onFailureInstruction?: InputMaybe<Scalars['String']['input']>;
  onSuccessInstruction?: InputMaybe<Scalars['String']['input']>;
  prerequisiteAction?: InputMaybe<Scalars['ID']['input']>;
  runOnConnect?: InputMaybe<Scalars['Boolean']['input']>;
  staticResponse?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
  urlTemplate?: InputMaybe<Scalars['String']['input']>;
  useRawBody?: InputMaybe<Scalars['Boolean']['input']>;
  waitForAudioDrain?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateAgentTemplateInput = {
  isFavourite?: InputMaybe<Scalars['Boolean']['input']>;
  mediaKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAgentTemplateResult = AgentTemplate | GenericException;

export type CreateAircallExtractInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  emails: Array<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  mainPhoneNumber: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  secondaryPhoneNumbers: Array<Scalars['String']['input']>;
};

export type CreateAivaAgentMigrationDraftInput = {
  agentId: Scalars['ID']['input'];
  companyId: Scalars['Int']['input'];
  hubApplicationId: Scalars['String']['input'];
  idempotencyKey: Scalars['String']['input'];
};

export type CreateAivaAgentMigrationDraftOutput = AivaAgentMigrationDraft | ConflictException | GenericException | ResourceNotFoundException | UserInputException;

export type CreateAuthMethodInput = {
  apiKey?: InputMaybe<ApiKeyConfigInput>;
  authType: AuthMethodType;
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  basicAuth?: InputMaybe<BasicAuthConfigInput>;
  bearerToken?: InputMaybe<BearerTokenConfigInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  oauth?: InputMaybe<OAuthConfigInput>;
  resourceOwnerPassword?: InputMaybe<ResourceOwnerPasswordConfigInput>;
  serviceName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAutomationInput = {
  config?: InputMaybe<AutomationConfigInput>;
  enabled: Scalars['Boolean']['input'];
  filters: AutomationFiltersInput;
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  scoreCardId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateAutomationOutput = Automation | GenericException | InsufficientLicenseException | ResourceNotFoundException | UserInputException;

export type CreateBlacklistedPhoneInput = {
  phoneNumber: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBlacklistedPhoneOutput = BlacklistedPhone | GenericException | UserInputException;

export type CreateBrandDocumentUploadUrlInput = {
  mimeType: BrandDocumentMimeType;
  sizeBytes: Scalars['Int']['input'];
  type: BrandDocumentType;
};

export type CreateBrandDocumentUploadUrlResult = BrandDocumentUploadUrl | BrandedCallingException | GenericException;

export type CreateBrandDraftInput = {
  business?: InputMaybe<BrandBusinessInput>;
  callingProfiles?: InputMaybe<Array<CallingProfileInput>>;
  country: Scalars['String']['input'];
  documents?: InputMaybe<Array<BrandDocumentInput>>;
  logo?: InputMaybe<BrandDraftLogoInput>;
};

export type CreateBridgeIntegrationData = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  authorType?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBridgeIntegrationInputCredentials = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['String']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  instanceUrl?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  secret?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBridgeIntegrationMutationInput = {
  credentials: CreateBridgeIntegrationInputCredentials;
  data?: InputMaybe<CreateBridgeIntegrationData>;
  numberIds: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
};

export type CreateBusinessDraftInput = {
  business?: InputMaybe<BusinessDraftBusinessInput>;
  numbers?: InputMaybe<Array<BusinessDraftNumberInput>>;
};

export type CreateBusinessRegistrationBusinessInput = {
  address: BusinessDraftAddressInput;
  authorized: Scalars['Boolean']['input'];
  businessVerificationDocument?: InputMaybe<BusinessDraftDocumentInput>;
  contact: CreateBusinessRegistrationContactInput;
  dunsNumber?: InputMaybe<Scalars['String']['input']>;
  industry: NumberReputationIndustry;
  legalName: Scalars['String']['input'];
  numberOfEmployees: NumberReputationEmployeeCount;
  primaryName: Scalars['String']['input'];
  taxId?: InputMaybe<Scalars['String']['input']>;
  website: Scalars['String']['input'];
};

export type CreateBusinessRegistrationContactInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateBusinessRegistrationInput = {
  business: CreateBusinessRegistrationBusinessInput;
  numbers: Array<BusinessDraftNumberInput>;
};

export type CreateBusinessRegistrationResult = BusinessRegistration | GenericException | NumberReputationException;

export type CreateCallingProfileInput = {
  callPurposeCode: CallPurposeCode;
  expectedCallVolume: ExpectedCallVolume;
  name: Scalars['String']['input'];
  numbers?: InputMaybe<Array<Scalars['String']['input']>>;
  shortName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCallingProfileResult = BrandedCallingException | CallingProfileDetails | GenericException;

export type CreateCompanyPromotionInput = {
  product: PromotionProduct;
  promoName: Scalars['String']['input'];
};

export type CreateCompanyPromotionOutput = {
  __typename?: 'CreateCompanyPromotionOutput';
  companyId: Scalars['ID']['output'];
  consumedUnits: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  offeredUnits?: Maybe<Scalars['Int']['output']>;
  product: PromotionProduct;
  promoName: Scalars['String']['output'];
};

export type CreateConversationInput = {
  ID: Scalars['ID']['input'];
  agentID?: InputMaybe<Scalars['ID']['input']>;
  companyID: Scalars['ID']['input'];
  createdAt: Scalars['String']['input'];
  externalNumber: Scalars['String']['input'];
  groupConversationId?: InputMaybe<Scalars['ID']['input']>;
  lineID: Scalars['ID']['input'];
};

export type CreateConversationOutput = {
  __typename?: 'CreateConversationOutput';
  conversation?: Maybe<Conversation>;
  error?: Maybe<Error>;
  lineID: Scalars['ID']['output'];
};

export type CreateCoreKbIntegrationInput = {
  application_id: Scalars['String']['input'];
  auto_refresh_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  integration_id: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  provider_account_label: Scalars['String']['input'];
  refresh_period_hours?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateCoreKbIntegrationSubscriptionInput = {
  application_id: Scalars['String']['input'];
  auto_refresh_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  integration_id: Scalars['String']['input'];
  kb_id: Scalars['ID']['input'];
  provider: Scalars['String']['input'];
  provider_account_label: Scalars['String']['input'];
  refresh_period_hours?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateCreditCardAccountOutput = {
  __typename?: 'CreateCreditCardAccountOutput';
  companyBillingDetails?: Maybe<CompanyBillingDetailsOutput>;
};

export type CreateDocumentUploadUrlInput = {
  feature: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  sizeBytes: Scalars['Int']['input'];
};

export type CreateDocumentUploadUrlResult = BrandedCallingException | DocumentUploadUrl | GenericException;

export type CreateEmergencyAddressInput = {
  address: EmergencyAddressInput;
  agentID: Scalars['ID']['input'];
  callbackNumber: Scalars['String']['input'];
  callerName: Scalars['String']['input'];
  preferredLanguage: Scalars['String']['input'];
};

export type CreateEvalScenarioInput = {
  agentType?: InputMaybe<EvalAgentType>;
  expectedTool?: InputMaybe<Scalars['String']['input']>;
  expectedTools?: InputMaybe<Array<ExpectedToolInput>>;
  prompt: Scalars['String']['input'];
};

export type CreateEvaluationCategory = {
  categoryName: Scalars['String']['input'];
  categoryOrder: Scalars['Int']['input'];
  questions: Array<CreateEvaluationQuestion>;
  scoreCardCategoryId: Scalars['ID']['input'];
};

export type CreateEvaluationInput = {
  callUuid: Scalars['String']['input'];
  categories: Array<CreateEvaluationCategory>;
  feedback: Scalars['String']['input'];
  revieweeUserId: Scalars['ID']['input'];
  scoreCardDescription?: InputMaybe<Scalars['String']['input']>;
  scoreCardId: Scalars['ID']['input'];
  scoreCardLanguage: Scalars['String']['input'];
  scoreCardName: Scalars['String']['input'];
};

export type CreateEvaluationQuestion = {
  binaryAnswer?: InputMaybe<BinaryAnswerValue>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  predefinedAIQuestionId?: InputMaybe<Scalars['ID']['input']>;
  questionAiEnabled: Scalars['Boolean']['input'];
  questionOrder: Scalars['Int']['input'];
  questionPossibleBinaryAnswers?: InputMaybe<Array<QuestionBinaryAnswer>>;
  questionPossibleRatingAnswers?: InputMaybe<Array<QuestionRatingAnswer>>;
  questionStrictness?: InputMaybe<Scalars['Int']['input']>;
  questionText: Scalars['String']['input'];
  questionTotalPoints: Scalars['Int']['input'];
  ratingAnswer?: InputMaybe<RatingAnswerValue>;
  scoreCardQuestionId: Scalars['ID']['input'];
};

export type CreateExtractOutput = GenericException | PhoneAircallExtract | UserInputException;

export type CreateKeywordTrackerInput = {
  agentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  direction?: InputMaybe<CallDirection>;
  excludeQueryTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  lineIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  queryTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  speakerType?: InputMaybe<SpeakerTrackerType>;
  title: Scalars['String']['input'];
};

export type CreateKeywordTrackerOutput = CreatedKeywordTracker | GenericException | InsufficientLicenseException | InvalidTrackerName | TrackerKeywordLimitExceeded | TrackerLimitExceeded;

export type CreateLineAsyncItemInput = {
  assignedUserId?: InputMaybe<Scalars['Int']['input']>;
  capabilities: Array<Scalars['String']['input']>;
  esimLicense?: InputMaybe<Scalars['String']['input']>;
  isIvr?: InputMaybe<Scalars['Boolean']['input']>;
  ivrParentId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  phoneType: Scalars['String']['input'];
  regionId: Scalars['String']['input'];
};

export type CreateLineInput = {
  assignedUserId?: InputMaybe<Scalars['Int']['input']>;
  capabilities?: InputMaybe<Array<Scalars['String']['input']>>;
  esimLicense?: InputMaybe<Scalars['String']['input']>;
  isIvr?: InputMaybe<Scalars['Boolean']['input']>;
  ivrParentId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  phoneType?: InputMaybe<Scalars['String']['input']>;
  regionId: Scalars['String']['input'];
};

export type CreateLineTranscriptionSettingsOutput = {
  __typename?: 'CreateLineTranscriptionSettingsOutput';
  settings: LineTranscriptionSettings;
};

export type CreateLinesAsyncInput = {
  lines: Array<CreateLineAsyncItemInput>;
};

export type CreateLinesAsyncOutput = {
  __typename?: 'CreateLinesAsyncOutput';
  purchaseJobId: Scalars['String']['output'];
};

export type CreateLoaEnvelopeInput = {
  brandDraftUuid?: InputMaybe<Scalars['String']['input']>;
  brandRegistrationUuid?: InputMaybe<Scalars['String']['input']>;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  signerEmail?: InputMaybe<Scalars['String']['input']>;
  signerName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLoaEnvelopeResult = BrandedCallingException | GenericException | LoaEnvelope;

export type CreateLongTailRegistrationSessionInput = {
  hubApplicationId: Scalars['String']['input'];
};

export type CreateLongTailRegistrationSessionOutput = ConflictException | GenericException | HubApplicationNotFoundException | LongTailRegistrationSession | UserInputException;

export type CreateMessagingAiAgentResult = GenericException | MessagingAiAgent | UserInputException;

export type CreateOnboardingInput = {
  steps?: InputMaybe<Array<StepInput>>;
};

export type CreateOnboardingOutput = GenericException | Onboarding | UserInputException;

export type CreateOrUpdateA2PFormInput = {
  companyID: Scalars['ID']['input'];
  complianceAssistantAppliedFields?: InputMaybe<Array<Scalars['String']['input']>>;
  complianceAssistantUsed?: InputMaybe<Scalars['Boolean']['input']>;
  formFields: Scalars['String']['input'];
  formID?: InputMaybe<Scalars['ID']['input']>;
  formStatus?: InputMaybe<A2PFormStatus>;
  formType?: InputMaybe<A2PFormType>;
  userID: Scalars['ID']['input'];
};

export type CreateOrUpdateA2PFormOutput = {
  __typename?: 'CreateOrUpdateA2PFormOutput';
  formID: Scalars['ID']['output'];
};

export type CreateOrUpdateA2PFormResult = CreateOrUpdateA2PFormOutput | GenericException;

export type CreateOutboundCampaignInput = {
  agentType?: InputMaybe<OutboundCampaignAgentType>;
  aivaAgentId?: InputMaybe<Scalars['ID']['input']>;
  assignedTeamIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  assignedUserIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  callAttempts?: InputMaybe<Scalars['Int']['input']>;
  callerIdNumbers?: InputMaybe<Array<OutboundCampaignCallerIdNumberInput>>;
  callerIdStrategy: OutboundCampaignCallerIdStrategy;
  campaignOutcomeTime?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalRingingTimeout?: InputMaybe<Scalars['Int']['input']>;
  localPresence: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  outcomeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  retryInterval?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOutboundCampaignOutcomeInput = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateOutboundCampaignOutcomeOutput = GenericException | OutboundCampaignOutcome | OutboundCampaignOutcomeAlreadyExistsException | OutboundCampaignReservedOutcomeNameException | ResourceNotFoundException | UserInputException;

export type CreateOutboundCampaignOutput = GenericException | OutboundCampaign | ResourceNotFoundException | UserInputException;

export type CreatePrerecordedMessageInput = {
  durationInSeconds: Scalars['Float']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreatePrerecordedMessageOutput = GenericException | MaximumConfirmedPrerecordedMessagesReachedException | PrerecordedMessage | ResourceNotFoundException | UserInputException;

export type CreateSamlConfigurationInput = {
  enforced: Scalars['Boolean']['input'];
  jitEnabled: Scalars['Boolean']['input'];
  metadataUrl: Scalars['String']['input'];
  providerName: Scalars['String']['input'];
  signoutEnabled: Scalars['Boolean']['input'];
};

export type CreateScenarioInput = {
  configJson: Scalars['String']['input'];
  name: Scalars['String']['input'];
  successCriteria?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateScenarioOutput = GenericException | ResourceNotFoundException | Scenario | UserInputException;

export type CreateSipSettingInput = {
  agentID: Scalars['ID']['input'];
  domain?: InputMaybe<Scalars['String']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  type: SipSettingType;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSlackIntegrationMutationInput = {
  dashboard_url: Scalars['String']['input'];
  install_params: RestSlackIntegrationInstallParams;
};

export type CreateSlackIntegrationMutationResponse = {
  __typename?: 'CreateSlackIntegrationMutationResponse';
  authorizeUri: Scalars['String']['output'];
};

export type CreateSupervisionData = {
  __typename?: 'CreateSupervisionData';
  supervision: Supervision;
};

export type CreateSupervisionOutput = CreateSupervisionData | GenericException | ResourceNotFoundException | UserInputException;

export type CreateTagInput = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateTasksOutput = CreateTasksSuccess | GenericException | UserInputException;

export type CreateTasksSuccess = {
  __typename?: 'CreateTasksSuccess';
  items: Array<TaskState>;
};

export type CreateTeamInput = {
  agentsIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  imageName: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateTeammateInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  extension: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
};

export type CreateTeammateOutput = GenericException | PhoneTeammate | UserInputException;

export type CreateTemplateInput = {
  template: TemplateRequest;
  type: TemplateType;
  wabaId: Scalars['String']['input'];
};

export type CreateTemplateOutput = {
  __typename?: 'CreateTemplateOutput';
  ID: Scalars['Int']['output'];
  category: TemplateCategory;
  language: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: TemplateStatus;
  type: TemplateType;
};

export type CreateTemplateResult = CreateTemplateOutput | GenericException;

export type CreateTrayIntegrationInput = {
  solutionInstanceId: Scalars['String']['input'];
};

export type CreateTrayIntegrationOutput = {
  __typename?: 'CreateTrayIntegrationOutput';
  applicationId: Scalars['ID']['output'];
};

export type CreateVirtualAgentInput = {
  aiActions?: InputMaybe<Array<AiActionInput>>;
  callDirection?: InputMaybe<CallDirection>;
  capabilities?: InputMaybe<VirtualAgentCapabilitiesInput>;
  configOverride?: InputMaybe<ConfigOverrideInput>;
  customPrompt?: InputMaybe<Scalars['String']['input']>;
  customVoiceId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabledFlags?: InputMaybe<Array<AgentFlag>>;
  extractionTask?: InputMaybe<ExtractionTaskInput>;
  farewellMessage?: InputMaybe<Scalars['String']['input']>;
  greetingMessage?: InputMaybe<Scalars['String']['input']>;
  knowledgeBase?: InputMaybe<VirtualAgentKnowledgeInput>;
  outboundConfig?: InputMaybe<OutboundConfigInput>;
  personality: VirtualAgentPersonalityInput;
  vogentAgentId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVirtualAgentTrialSessionInput = {
  callDirection?: InputMaybe<CallDirection>;
  draftId?: InputMaybe<Scalars['ID']['input']>;
  outboundCompliance?: InputMaybe<OutboundComplianceInput>;
  outboundContext?: InputMaybe<Scalars['String']['input']>;
  virtualAgentId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateVirtualAgentTrialSessionOutput = GenericException | VirtualAgentTrialSession;

export type CreateVirtualAgentUsageAlertInput = {
  billingEmailEnabled: Scalars['Boolean']['input'];
  thresholdPercentages: Array<Scalars['Int']['input']>;
  usageLimitMinutes: Scalars['Int']['input'];
  userEmailEnabled: Scalars['Boolean']['input'];
};

export type CreateVirtualAgentWithBuilderInput = {
  instructions: Scalars['String']['input'];
  useCallHistory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateWebhookInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  customName?: InputMaybe<Scalars['String']['input']>;
  events: Array<InputMaybe<Scalars['String']['input']>>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type CreateWebhookInputWe = {
  activatedAt?: InputMaybe<Scalars['String']['input']>;
  allowedRetries?: InputMaybe<Scalars['Int']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  customName?: InputMaybe<Scalars['String']['input']>;
  events: Array<InputMaybe<Scalars['String']['input']>>;
  source?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type CreateWebhookMutationInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  customName?: InputMaybe<Scalars['String']['input']>;
  events: Array<InputMaybe<Scalars['String']['input']>>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type CreatedKeywordTracker = {
  __typename?: 'CreatedKeywordTracker';
  tracker: Tracker;
};

export type CredentialInput = {
  headerName?: InputMaybe<Scalars['String']['input']>;
  scheme: CredentialScheme;
  value: Scalars['String']['input'];
};

export enum CredentialScheme {
  ApiKey = 'ApiKey',
  Bearer = 'Bearer',
  CustomHeader = 'CustomHeader'
}

export enum CredentialStatus {
  NOT_SET = 'NOT_SET',
  SET = 'SET'
}

export enum Crm {
  HUBSPOT = 'HUBSPOT',
  OTHER = 'OTHER',
  PIPEDRIVE = 'PIPEDRIVE',
  SALESFORCE = 'SALESFORCE',
  ZENDESK = 'ZENDESK'
}

export type CrmContactList = {
  __typename?: 'CrmContactList';
  contactsCount: Scalars['Int']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CrmContactListConnection = {
  __typename?: 'CrmContactListConnection';
  hasMore: Scalars['Boolean']['output'];
  lists: Array<CrmContactList>;
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CrmNotSupportedException = Exception & {
  __typename?: 'CrmNotSupportedException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type CsatSettings = {
  __typename?: 'CsatSettings';
  isEnabled: Scalars['Boolean']['output'];
};

export type CsatSettingsData = {
  isEnabled: Scalars['Boolean']['input'];
};

export type Currencies = {
  __typename?: 'Currencies';
  aud: Scalars['Int']['output'];
  eur: Scalars['Int']['output'];
  gbp: Scalars['Int']['output'];
  usd: Scalars['Int']['output'];
};

export type CurrencyUsd = {
  __typename?: 'CurrencyUSD';
  usd: Scalars['Int']['output'];
};

export type CustomFieldsValues = {
  __typename?: 'CustomFieldsValues';
  id: Scalars['ID']['output'];
  selected?: Maybe<Scalars['Boolean']['output']>;
  translatedLabel: Scalars['String']['output'];
};

export type CustomOutcomeTagsOutcomeValues = {
  __typename?: 'CustomOutcomeTagsOutcomeValues';
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  selected?: Maybe<Scalars['Boolean']['output']>;
  translatedLabel?: Maybe<Scalars['String']['output']>;
};

export type CustomPlaybook = {
  __typename?: 'CustomPlaybook';
  adherence?: Maybe<PlaybookAdherence>;
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy?: Maybe<PhoneTeammateResolver>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isEditable: Scalars['Boolean']['output'];
  language: PlaybookLanguage;
  name: Scalars['String']['output'];
  topics: Array<TopicEntry>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<PhoneTeammateResolver>;
};


export type CustomPlaybookAdherenceArgs = {
  filters?: InputMaybe<PlaybookAdherenceFiltersInput>;
};

export enum CustomPlaybookResponseType {
  BOOLEAN = 'BOOLEAN',
  TEXT = 'TEXT'
}

export type CustomSummary = {
  __typename?: 'CustomSummary';
  associatedConfigurations: Array<CustomSummaryConfigurationLink>;
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy?: Maybe<PhoneTeammateResolver>;
  id: Scalars['ID']['output'];
  language: CustomSummaryLanguage;
  name: Scalars['String']['output'];
  templates: Array<SummaryTemplateEntry>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<PhoneTeammateResolver>;
};

export type CustomSummaryConfiguration = BaseCustomSummaryConfiguration & {
  __typename?: 'CustomSummaryConfiguration';
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy?: Maybe<PhoneTeammateResolver>;
  customSummary?: Maybe<CustomSummary>;
  id: Scalars['ID']['output'];
  line?: Maybe<LineResolver>;
  transcriptionEngine: CustomSummaryTranscriptionEngine;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<PhoneTeammateResolver>;
};

export type CustomSummaryConfigurationInput = {
  customSummaryId: Scalars['ID']['input'];
  lineId: Scalars['ID']['input'];
  transcriptionEngine?: InputMaybe<CustomSummaryTranscriptionEngine>;
};

export type CustomSummaryConfigurationLink = BaseCustomSummaryConfiguration & {
  __typename?: 'CustomSummaryConfigurationLink';
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy?: Maybe<PhoneTeammateResolver>;
  id: Scalars['ID']['output'];
  line?: Maybe<LineResolver>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<PhoneTeammateResolver>;
};

export type CustomSummaryException = Exception & {
  __typename?: 'CustomSummaryException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum CustomSummaryLanguage {
  BG = 'BG',
  CA = 'CA',
  CS = 'CS',
  DA = 'DA',
  DE = 'DE',
  EL = 'EL',
  EN = 'EN',
  ES = 'ES',
  FI = 'FI',
  FR = 'FR',
  HE = 'HE',
  HI = 'HI',
  HR = 'HR',
  HU = 'HU',
  IT = 'IT',
  JA = 'JA',
  KO = 'KO',
  MS = 'MS',
  NL = 'NL',
  NO = 'NO',
  PL = 'PL',
  PT = 'PT',
  RO = 'RO',
  RU = 'RU',
  SK = 'SK',
  SV = 'SV',
  TA = 'TA',
  TL = 'TL',
  TR = 'TR',
  UK = 'UK',
  VI = 'VI',
  ZH = 'ZH'
}

export type CustomSummaryResult = {
  __typename?: 'CustomSummaryResult';
  callId: Scalars['ID']['output'];
  callUuid: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  customSummary: CustomSummary;
  customSummaryName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  language: CustomSummaryLanguage;
  line: LineResolver;
  templateResults: Array<SummaryTemplateResult>;
};

export enum CustomSummaryTranscriptionEngine {
  ASYNC = 'ASYNC',
  REALTIME = 'REALTIME'
}

export type CustomerKbMapping = {
  __typename?: 'CustomerKBMapping';
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  customerRegion: Scalars['String']['output'];
  documentCount: Scalars['Int']['output'];
  embeddingModel: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  kbId: Scalars['Int']['output'];
  kbName: Scalars['String']['output'];
  language: Scalars['String']['output'];
  pineconeIndex: Scalars['String']['output'];
  pineconeNamespace: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type CustomerKbMappingCreateInput = {
  embeddingModel?: InputMaybe<Scalars['String']['input']>;
  kbName: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerKbMappingOutput = CustomerKbMapping | GenericException;

export type CustomersUtterances = {
  __typename?: 'CustomersUtterances';
  callId: Scalars['Float']['output'];
  utterances?: Maybe<Array<Maybe<UtteranceSentiment>>>;
};

export type DataInput = {
  __typename?: 'DataInput';
  defaultValue?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  extractionPrompt?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parentRequired?: Maybe<Scalars['Boolean']['output']>;
  phoneConfig?: Maybe<PhoneNumberConfig>;
  required: Scalars['Boolean']['output'];
  type: DataInputType;
  validationConfig?: Maybe<ParameterValidationConfig>;
  validationErrorMessage?: Maybe<Scalars['String']['output']>;
  validationPattern?: Maybe<Scalars['String']['output']>;
  valueSource?: Maybe<Scalars['String']['output']>;
};

export type DataInputInput = {
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extractionPrompt?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  phoneConfig?: InputMaybe<PhoneNumberConfigInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  type: DataInputType;
  validationConfig?: InputMaybe<ParameterValidationConfigInput>;
  validationErrorMessage?: InputMaybe<Scalars['String']['input']>;
  validationPattern?: InputMaybe<Scalars['String']['input']>;
  valueSource?: InputMaybe<Scalars['String']['input']>;
};

export enum DataInputType {
  ARRAY = 'ARRAY',
  BOOLEAN = 'BOOLEAN',
  DATE_ISO_8601 = 'DATE_ISO_8601',
  DATE_UNIX_TIMESTAMP_MS = 'DATE_UNIX_TIMESTAMP_MS',
  DATE_UNIX_TIMESTAMP_S = 'DATE_UNIX_TIMESTAMP_S',
  INTEGER = 'INTEGER',
  NULL = 'NULL',
  NUMBER = 'NUMBER',
  OBJECT = 'OBJECT',
  PHONE_NUMBER = 'PHONE_NUMBER',
  STRING = 'STRING'
}

export type DataOutput = {
  __typename?: 'DataOutput';
  description?: Maybe<Scalars['String']['output']>;
  fallbackValue?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<Maybe<OutputField>>>;
  format?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  responseFieldMapping?: Maybe<Scalars['String']['output']>;
  type: DataOutputType;
  valueMapping?: Maybe<Scalars['String']['output']>;
};

export type DataOutputInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  fallbackValue?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<OutputFieldInput>>>;
  format?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  responseFieldMapping?: InputMaybe<Scalars['String']['input']>;
  type: DataOutputType;
  valueMapping?: InputMaybe<Scalars['String']['input']>;
};

export enum DataOutputType {
  ARRAY = 'ARRAY',
  BOOLEAN = 'BOOLEAN',
  DATE = 'DATE',
  DATETIME = 'DATETIME',
  INTEGER = 'INTEGER',
  NULL = 'NULL',
  NUMBER = 'NUMBER',
  OBJECT = 'OBJECT',
  PHONE_NUMBER = 'PHONE_NUMBER',
  STRING = 'STRING',
  TIME = 'TIME'
}

export enum DataSufficiency {
  LIMITED = 'LIMITED',
  MODERATE = 'MODERATE',
  NONE = 'NONE',
  SUFFICIENT = 'SUFFICIENT'
}

export type DateHistogramAggregationScope = {
  interval: Scalars['String']['input'];
  sentiments?: InputMaybe<SentimentAggregationScope>;
  trackers?: InputMaybe<TrackersAggregationScope>;
};

export enum DayOfWeek {
  FRIDAY = 'FRIDAY',
  MONDAY = 'MONDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
  THURSDAY = 'THURSDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY'
}

export type DeactivateWhatsAppNumberInput = {
  numberUUID: Scalars['String']['input'];
};

export type DeactivateWhatsAppNumberResponse = {
  __typename?: 'DeactivateWhatsAppNumberResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DefaultOwner = {
  __typename?: 'DefaultOwner';
  translatedLabel: Scalars['String']['output'];
  value: DefaultOwnerValue;
};

export type DefaultOwnerValue = {
  __typename?: 'DefaultOwnerValue';
  id: Scalars['String']['output'];
  translatedLabel: Scalars['String']['output'];
};

export type DeleteA2PFormOutput = {
  __typename?: 'DeleteA2PFormOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteA2PFormResult = DeleteA2PFormOutput | GenericException;

export type DeleteActionOutput = DeletedAction | GenericException | ResourceNotFoundException;

export type DeleteAgentInput = {
  ID: Scalars['ID']['input'];
};

export type DeleteAgentOutput = {
  __typename?: 'DeleteAgentOutput';
  ID: Scalars['ID']['output'];
};

export type DeleteApiKeyOutput = {
  __typename?: 'DeleteApiKeyOutput';
  apiId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type DeleteAudioInput = {
  audioType: AudioType;
  callId: Scalars['ID']['input'];
};

export type DeleteAudioOutput = {
  __typename?: 'DeleteAudioOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteAudioResult = DeleteAudioOutput | GenericException | InsufficientPermissionException;

export type DeleteAuthMethodOutput = DeletedAuthMethod | GenericException | ResourceNotFoundException;

export type DeleteAutomation = {
  __typename?: 'DeleteAutomation';
  ID: Scalars['ID']['output'];
};

export type DeleteAutomationOutput = DeleteAutomation | GenericException | InsufficientLicenseException | ResourceNotFoundException | UserInputException;

export type DeleteBlacklistedPhoneOutput = DeletedBlacklistedPhone | GenericException | ResourceNotFoundException;

export type DeleteBrandDocumentResult = BrandedCallingException | DeleteBrandDocumentSuccess | GenericException;

export type DeleteBrandDocumentSuccess = {
  __typename?: 'DeleteBrandDocumentSuccess';
  success: Scalars['Boolean']['output'];
};

export type DeleteBrandDraftResult = BrandedCallingException | DeleteBrandDraftSuccess | GenericException;

export type DeleteBrandDraftSuccess = {
  __typename?: 'DeleteBrandDraftSuccess';
  success: Scalars['Boolean']['output'];
};

export type DeleteBrandResult = BrandedCallingException | DeleteBrandSuccess | GenericException;

export type DeleteBrandSuccess = {
  __typename?: 'DeleteBrandSuccess';
  success: Scalars['Boolean']['output'];
};

export type DeleteBusinessDraftResult = DeleteBusinessDraftSuccess | GenericException | NumberReputationException;

export type DeleteBusinessDraftSuccess = {
  __typename?: 'DeleteBusinessDraftSuccess';
  success: Scalars['Boolean']['output'];
};

export type DeleteBusinessRegistrationResult = DeleteBusinessRegistrationSuccess | GenericException | NumberReputationException;

export type DeleteBusinessRegistrationSuccess = {
  __typename?: 'DeleteBusinessRegistrationSuccess';
  success: Scalars['Boolean']['output'];
};

export type DeleteCalendarOutput = {
  __typename?: 'DeleteCalendarOutput';
  calendarID: Scalars['ID']['output'];
};

export type DeleteCalendarOutputV2 = DeleteCalendarOutput | GenericException | ResourceNotFoundException;

export type DeleteCallingProfileResult = BrandedCallingException | DeleteCallingProfileSuccess | GenericException;

export type DeleteCallingProfileSuccess = {
  __typename?: 'DeleteCallingProfileSuccess';
  success: Scalars['Boolean']['output'];
};

export type DeleteCompanyContextOutput = DeleteCompanyContextSuccess | GenericException;

export type DeleteCompanyContextSuccess = {
  __typename?: 'DeleteCompanyContextSuccess';
  success: Scalars['Boolean']['output'];
};

export type DeleteCompanyKbMappingOutput = DeleteCompanyKbMappingResponse | GenericException;

export type DeleteCompanyKbMappingResponse = {
  __typename?: 'DeleteCompanyKBMappingResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteCrawlDocumentOutput = DeleteCrawlDocumentResponse | GenericException;

export type DeleteCrawlDocumentResponse = {
  __typename?: 'DeleteCrawlDocumentResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteCustomPlaybookInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCustomPlaybookOutput = DeleteCustomPlaybookResult | GenericException | InsufficientLicenseException | PlaybookException | UserInputException;

export type DeleteCustomPlaybookResult = {
  __typename?: 'DeleteCustomPlaybookResult';
  isSuccess: Scalars['Boolean']['output'];
};

export type DeleteCustomSummaryInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCustomSummaryOutput = CustomSummaryException | DeleteCustomSummaryResult | GenericException | InsufficientLicenseException | UserInputException;

export type DeleteCustomSummaryResult = {
  __typename?: 'DeleteCustomSummaryResult';
  isSuccess: Scalars['Boolean']['output'];
};

export type DeleteDocumentResult = BrandedCallingException | DeleteDocumentSuccess | GenericException;

export type DeleteDocumentSuccess = {
  __typename?: 'DeleteDocumentSuccess';
  success: Scalars['Boolean']['output'];
};

export type DeleteEmergencyAddressInput = {
  agentID: Scalars['ID']['input'];
  emergencyAddressID: Scalars['ID']['input'];
};

export type DeleteEmergencyAddressOutput = {
  __typename?: 'DeleteEmergencyAddressOutput';
  emergencyAddressID: Scalars['ID']['output'];
};

export type DeleteEvalPersonaOutput = ConflictException | DeleteEvalPersonaResult | GenericException | ResourceNotFoundException | UserInputException;

export type DeleteEvalPersonaResult = {
  __typename?: 'DeleteEvalPersonaResult';
  deleted: Scalars['Boolean']['output'];
};

export type DeleteEvaluation = {
  __typename?: 'DeleteEvaluation';
  ID: Scalars['ID']['output'];
};

export type DeleteEvaluationOutput = DeleteEvaluation | GenericException | ResourceNotFoundException | UserInputException;

export type DeleteExternalNumberOutput = {
  __typename?: 'DeleteExternalNumberOutput';
  ID: Scalars['ID']['output'];
};

export type DeleteGsmDeviceInput = {
  deviceId: Scalars['String']['input'];
};

export type DeleteGsmDeviceOutput = DeletedGsmDevice | GenericException | ResourceNotFoundException;

export type DeleteIntegrationOutput = {
  __typename?: 'DeleteIntegrationOutput';
  id: Scalars['String']['output'];
};

export type DeleteKeywordTrackerOutput = DeletedTracker | GenericException | InsufficientLicenseException;

export type DeleteKeywordsInput = {
  keywordIds: Array<Scalars['ID']['input']>;
};

export type DeleteKeywordsOutput = DeletedKeywords | GenericException | UserInputException;

export type DeleteKnowledgeBaseOutput = DeletedKnowledgeBase | GenericException;

export type DeleteLineOutput = {
  __typename?: 'DeleteLineOutput';
  lineId: Scalars['ID']['output'];
};

export type DeleteMessagingAiAgentResult = DeleteMessagingAiAgentSuccess | GenericException | ResourceNotFoundException | UserInputException;

export type DeleteMessagingAiAgentSuccess = {
  __typename?: 'DeleteMessagingAIAgentSuccess';
  id: Scalars['ID']['output'];
};

export type DeleteNextActionInput = {
  ID: Scalars['ID']['input'];
};

export type DeleteOutboundCampaignOutcomeOutput = GenericException | OutboundCampaignOutcomeDeletePayload | ResourceNotFoundException;

export type DeleteOutboundCampaignOutput = GenericException | OutboundCampaignDeletePayload | ResourceNotFoundException | UnprocessableResourceException;

export type DeletePrerecordedMessageInput = {
  ID: Scalars['ID']['input'];
};

export type DeletePrerecordedMessageOutput = DeletedPrerecordedMessage | GenericException | ResourceNotFoundException | UserInputException;

export type DeleteReferenceSecretApiOutput = {
  __typename?: 'DeleteReferenceSecretAPIOutput';
  lineID: Scalars['ID']['output'];
};

export type DeleteSamlConfigurationOutput = {
  __typename?: 'DeleteSamlConfigurationOutput';
  companyID: Scalars['ID']['output'];
};

export type DeleteScenarioOutput = DeleteScenarioResult | GenericException | ResourceNotFoundException | UserInputException;

export type DeleteScenarioResult = {
  __typename?: 'DeleteScenarioResult';
  deleted: Scalars['Boolean']['output'];
};

export type DeleteScoreCard = {
  __typename?: 'DeleteScoreCard';
  ID: Scalars['ID']['output'];
};

export type DeleteScoreCardOutput = DeleteScoreCard | GenericException | InsufficientLicenseException | ResourceNotFoundException | UserInputException;

export type DeleteSipSettingInput = {
  ID: Scalars['ID']['input'];
  agentID: Scalars['ID']['input'];
};

export type DeleteSipSettingOutput = {
  __typename?: 'DeleteSipSettingOutput';
  ID: Scalars['ID']['output'];
};

export type DeleteSummaryTemplateInput = {
  id: Scalars['ID']['input'];
};

export type DeleteSummaryTemplateOutput = CustomSummaryException | DeleteSummaryTemplateResult | GenericException | InsufficientLicenseException | UserInputException;

export type DeleteSummaryTemplateResult = {
  __typename?: 'DeleteSummaryTemplateResult';
  isSuccess: Scalars['Boolean']['output'];
};

export type DeleteSupervisionOutput = DeletedSupervision | GenericException | ResourceNotFoundException;

export type DeleteTagInput = {
  id: Scalars['ID']['input'];
};

export type DeleteTagOutput = {
  __typename?: 'DeleteTagOutput';
  id: Scalars['ID']['output'];
};

export type DeleteTeamInput = {
  ID: Scalars['ID']['input'];
};

export type DeleteTeammateInput = {
  ID: Scalars['ID']['input'];
};

export type DeleteTeammateOutput = DeleteTeammateResult | GenericException | ResourceNotFoundException;

export type DeleteTeammateResult = {
  __typename?: 'DeleteTeammateResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteTemplateOutput = {
  __typename?: 'DeleteTemplateOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteTemplateResult = DeleteTemplateOutput | GenericException;

export type DeleteTopicInput = {
  id: Scalars['ID']['input'];
};

export type DeleteTopicOutput = DeleteTopicResult | GenericException | InsufficientLicenseException | PlaybookException | UserInputException;

export type DeleteTopicResult = {
  __typename?: 'DeleteTopicResult';
  isSuccess: Scalars['Boolean']['output'];
};

export type DeleteTrackerInput = {
  trackerId: Scalars['Int']['input'];
};

export type DeleteTrackerOutput = {
  __typename?: 'DeleteTrackerOutput';
  trackerId: Scalars['Int']['output'];
};

export type DeleteVirtualAgentInput = {
  ID: Scalars['ID']['input'];
};

export type DeleteVirtualAgentOutput = DeletedVirtualAgent | GenericException;

export type DeleteWhatsappSubaccountInput = {
  deleteAllSenders: Scalars['Boolean']['input'];
};

export type DeleteWhatsappSubaccountResponse = {
  __typename?: 'DeleteWhatsappSubaccountResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeletedAction = {
  __typename?: 'DeletedAction';
  ID: Scalars['ID']['output'];
};

export type DeletedAuthMethod = {
  __typename?: 'DeletedAuthMethod';
  ID: Scalars['ID']['output'];
};

export type DeletedBlacklistedPhone = {
  __typename?: 'DeletedBlacklistedPhone';
  ID: Scalars['ID']['output'];
};

export type DeletedGsmDevice = {
  __typename?: 'DeletedGSMDevice';
  deviceId: Scalars['String']['output'];
};

export type DeletedKeyword = {
  __typename?: 'DeletedKeyword';
  id: Scalars['ID']['output'];
};

export type DeletedKeywords = {
  __typename?: 'DeletedKeywords';
  items: Array<DeletedKeyword>;
};

export type DeletedKnowledgeBase = {
  __typename?: 'DeletedKnowledgeBase';
  kbId?: Maybe<Scalars['Int']['output']>;
};

export type DeletedPrerecordedMessage = {
  __typename?: 'DeletedPrerecordedMessage';
  ID: Scalars['String']['output'];
};

export type DeletedScenario = {
  __typename?: 'DeletedScenario';
  scenarioId: Scalars['ID']['output'];
};

export type DeletedScenarioOutput = DeletedScenario | GenericException | ResourceNotFoundException;

export type DeletedSupervision = {
  __typename?: 'DeletedSupervision';
  ID: Scalars['ID']['output'];
};

export type DeletedTracker = {
  __typename?: 'DeletedTracker';
  trackerId: Scalars['Int']['output'];
};

export type DeletedVirtualAgent = {
  __typename?: 'DeletedVirtualAgent';
  ID: Scalars['ID']['output'];
};

export type DeliveryReceipt = {
  __typename?: 'DeliveryReceipt';
  deliveryStatus: BaseMessageStatus;
  externalParticipant: PhoneContactResolver;
  undeliveredReason?: Maybe<BaseMessageUndeliveredReason>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type Description = {
  __typename?: 'Description';
  en: Scalars['String']['output'];
  fr?: Maybe<Scalars['String']['output']>;
};

export enum DesktopState {
  locked = 'locked',
  sleeping = 'sleeping'
}

export enum DevicePlatform {
  android = 'android',
  ios = 'ios'
}

export type DiagnosticsToken = {
  __typename?: 'DiagnosticsToken';
  token: Scalars['String']['output'];
};

export type DialAgentInput = {
  agentID: Scalars['ID']['input'];
  skipPhoneFormatValidation?: InputMaybe<Scalars['Boolean']['input']>;
  to: Scalars['String']['input'];
};

export type DialAgentOutput = {
  __typename?: 'DialAgentOutput';
  success: Scalars['Boolean']['output'];
};

export type DialerCampaign = {
  __typename?: 'DialerCampaign';
  agentID: Scalars['ID']['output'];
  campaignID: Scalars['ID']['output'];
  lineID?: Maybe<Scalars['ID']['output']>;
  meta: DialerCampaignMeta;
  phoneNumbersToCallPaginated: Array<DialerCampaignPhoneNumber>;
  phoneNumbersToCallTotal: Scalars['Int']['output'];
};

export type DialerCampaignMeta = {
  __typename?: 'DialerCampaignMeta';
  currentPage: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  perPage: Scalars['Int']['output'];
  previousPage?: Maybe<Scalars['Int']['output']>;
};

export type DialerCampaignNumbers = {
  __typename?: 'DialerCampaignNumbers';
  count: Scalars['Int']['output'];
  phoneNumbers: Array<DialerCampaignPhoneNumber>;
};

export type DialerCampaignPhoneNumber = {
  __typename?: 'DialerCampaignPhoneNumber';
  ID: Scalars['ID']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type DirectDebitBillingRequestFlowOutput = {
  __typename?: 'DirectDebitBillingRequestFlowOutput';
  ID: Scalars['ID']['output'];
  billingRequestFlow?: Maybe<Scalars['String']['output']>;
};

export enum Direction {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND'
}

export type DiscardVirtualAgentDraftInput = {
  agentId: Scalars['ID']['input'];
};

export type DiscardVirtualAgentDraftOutput = DiscardedVirtualAgentDraft | GenericException | ResourceNotFoundException | UserInputException;

export type DiscardedVirtualAgentDraft = {
  __typename?: 'DiscardedVirtualAgentDraft';
  agentId: Scalars['ID']['output'];
};

export type DiscoveryResponse = {
  __typename?: 'DiscoveryResponse';
  result: Scalars['String']['output'];
};

export type DismissNotificationInput = {
  notificationId: Scalars['ID']['input'];
};

export type DismissNotificationOutput = {
  __typename?: 'DismissNotificationOutput';
  success: Scalars['Boolean']['output'];
};

export type DismissNotificationResult = DismissNotificationOutput | GenericException | ResourceNotFoundException;

export type DispatchGroup = {
  __typename?: 'DispatchGroup';
  dispatchable: Dispatchable;
  id: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  queuingTimeout: Scalars['Int']['output'];
  redirectionStrategy: Scalars['String']['output'];
};

export type Dispatchable = Team | User;

export enum DispatchingStrategy {
  LONGEST_IDLE = 'LONGEST_IDLE',
  RANDOM = 'RANDOM',
  SIMULTANEOUS = 'SIMULTANEOUS'
}

export type DocSummary = {
  __typename?: 'DocSummary';
  crawlRootId?: Maybe<Scalars['Int']['output']>;
  docId: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type Document = {
  __typename?: 'Document';
  clean_pii?: Maybe<Scalars['Boolean']['output']>;
  content_length?: Maybe<Scalars['Int']['output']>;
  content_preview?: Maybe<Scalars['String']['output']>;
  content_type: Scalars['String']['output'];
  copyright?: Maybe<Scalars['String']['output']>;
  crawl_depth?: Maybe<Scalars['Int']['output']>;
  crawl_root_id?: Maybe<Scalars['ID']['output']>;
  created_at: Scalars['AWSDateTime']['output'];
  doc_id: Scalars['ID']['output'];
  error_message?: Maybe<Scalars['String']['output']>;
  full_text_content?: Maybe<Scalars['String']['output']>;
  has_error?: Maybe<Scalars['Boolean']['output']>;
  is_crawl_root?: Maybe<Scalars['Boolean']['output']>;
  kb_id: Scalars['ID']['output'];
  source_character_count?: Maybe<Scalars['Int']['output']>;
  source_language?: Maybe<Scalars['String']['output']>;
  source_type?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  topic?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['AWSDateTime']['output']>;
  url: Scalars['String']['output'];
};

export type DocumentCreationResult = Document | GenericException;

export type DocumentDownloadUrl = {
  __typename?: 'DocumentDownloadUrl';
  documentUuid: Scalars['ID']['output'];
  downloadUrl: Scalars['String']['output'];
  expiresAt: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type DocumentFormat = {
  __typename?: 'DocumentFormat';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type DocumentFormatsOutput = DocumentFormatsResponse | GenericException;

export type DocumentFormatsResponse = {
  __typename?: 'DocumentFormatsResponse';
  formats: Array<DocumentFormat>;
};

export type DocumentInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  crawl_depth?: InputMaybe<Scalars['Int']['input']>;
  doc_type: DocumentTypeEnum;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentListResponse = {
  __typename?: 'DocumentListResponse';
  documents: Array<Document>;
};

export type DocumentMetadataUi = {
  __typename?: 'DocumentMetadataUi';
  cleanPii: Scalars['Boolean']['output'];
  hasError: Scalars['Boolean']['output'];
  isCrawlRoot: Scalars['Boolean']['output'];
  sourceType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type DocumentMetadataUiInput = {
  cleanPii?: InputMaybe<Scalars['Boolean']['input']>;
  hasError?: InputMaybe<Scalars['Boolean']['input']>;
  isCrawlRoot?: InputMaybe<Scalars['Boolean']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentOutput = {
  __typename?: 'DocumentOutput';
  filename: Scalars['String']['output'];
  format?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type DocumentResult = Document | GenericException;

export enum DocumentSource {
  INGESTION = 'INGESTION',
  REINGESTION = 'REINGESTION',
  UPLOAD = 'UPLOAD'
}

export enum DocumentStatus {
  CHUNK_GENERATION = 'CHUNK_GENERATION',
  CLEANING = 'CLEANING',
  DOWNLOADING = 'DOWNLOADING',
  EMBEDDING = 'EMBEDDING',
  EMBEDDING_FAILED = 'EMBEDDING_FAILED',
  ERROR = 'ERROR',
  FINISHED = 'FINISHED',
  INGESTION_FAILED = 'INGESTION_FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  NEW = 'NEW',
  PENDING_INGESTION = 'PENDING_INGESTION',
  PROCESSED = 'PROCESSED',
  RETRYING = 'RETRYING',
  UNSUPPORTED = 'UNSUPPORTED',
  WRITING_TO_KB = 'WRITING_TO_KB',
  WRITING_TO_KB_FAILED = 'WRITING_TO_KB_FAILED'
}

export type DocumentSummary = {
  __typename?: 'DocumentSummary';
  crawl_depth?: Maybe<Scalars['Int']['output']>;
  crawl_root_id?: Maybe<Scalars['ID']['output']>;
  doc_id: Scalars['ID']['output'];
  doc_type?: Maybe<Scalars['String']['output']>;
  page_count?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export enum DocumentType {
  TEXT_INPUT = 'TEXT_INPUT',
  URL = 'URL'
}

export enum DocumentTypeEnum {
  TEXT_INPUT = 'TEXT_INPUT',
  URL = 'URL'
}

export type DocumentUpdateInput = {
  text_content?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentUploadResult = {
  __typename?: 'DocumentUploadResult';
  doc_response?: Maybe<Document>;
  error?: Maybe<Scalars['String']['output']>;
  input_identifier?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DocumentUploadRules = {
  __typename?: 'DocumentUploadRules';
  allowedMimeTypes: Array<Scalars['String']['output']>;
  maxSizeBytes: Scalars['Int']['output'];
};

export type DocumentUploadUrl = {
  __typename?: 'DocumentUploadUrl';
  documentUuid: Scalars['ID']['output'];
  expiresAt: Scalars['String']['output'];
  feature: Scalars['String']['output'];
  key: Scalars['String']['output'];
  rules: DocumentUploadRules;
  uploadUrl: Scalars['String']['output'];
};

export type DocumentUsageItem = {
  __typename?: 'DocumentUsageItem';
  doc_id: Scalars['ID']['output'];
  usage: Scalars['Float']['output'];
};

export type DocumentsResult = DocumentListResponse | GenericException;

export type DownloadPortingLoaInput = {
  portingRequestUUID: Scalars['String']['input'];
};

export type DownloadPortingLoaResponse = {
  __typename?: 'DownloadPortingLoaResponse';
  contentType: Scalars['String']['output'];
  documentContent: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type DraftBatchInput = {
  numbers: Array<PortingNumberInput>;
  phoneType: Scalars['String']['input'];
};

export type DraftSummary = {
  __typename?: 'DraftSummary';
  description?: Maybe<Scalars['String']['output']>;
  draftId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DummyExternalResolverOutput = {
  __typename?: 'DummyExternalResolverOutput';
  contacts: Array<PhoneContactResolver>;
  singleContact: PhoneContactResolver;
};

export type DuplicateOutboundCampaignInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  selection: OutboundCampaignDuplicationSelectionInput;
};

export type DuplicateOutboundCampaignOutput = GenericException | OutboundCampaignDuplicationResult | ResourceNotFoundException | UserInputException;

export type DuplicatePlaybookInput = {
  id: Scalars['ID']['input'];
};

export type DuplicatePlaybookOutput = CustomPlaybook | GenericException | InsufficientLicenseException | PlaybookException | UserInputException;

export type DurationAggregation = {
  __typename?: 'DurationAggregation';
  avg?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  sum?: Maybe<Scalars['Float']['output']>;
};

export type DurationRange = {
  __typename?: 'DurationRange';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

export type DurationRangeInput = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export type DynamicClientConfig = {
  __typename?: 'DynamicClientConfig';
  clientId: Scalars['ID']['output'];
  clientName: Scalars['String']['output'];
  clientSecretExpiresAt?: Maybe<Scalars['Int']['output']>;
  grantTypes: Array<Scalars['String']['output']>;
  redirectUris: Array<Scalars['String']['output']>;
  registrationClientUri?: Maybe<Scalars['String']['output']>;
  responseTypes?: Maybe<Array<Scalars['String']['output']>>;
  scope?: Maybe<Scalars['String']['output']>;
  tokenEndpointAuthMethod?: Maybe<Scalars['String']['output']>;
};

export type DynamicClientInput = {
  applicationId: Scalars['ID']['input'];
  clientName: Scalars['String']['input'];
  companyId: Scalars['Int']['input'];
  grantTypes: Array<Scalars['String']['input']>;
  redirectUris: Array<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  tokenEndpointAuthMethod: Scalars['String']['input'];
};

export type EditUrlDocumentInput = {
  title?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type EmailNotification = {
  __typename?: 'EmailNotification';
  defaultFrequency?: Maybe<Scalars['String']['output']>;
  frequencies?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
};

export type EmailNotificationFrequencyInput = {
  frequency: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type EmailNotificationInput = {
  frequency?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type EmergencyAddress = {
  __typename?: 'EmergencyAddress';
  address: EmergencyAddressDetail;
  callbackNumber?: Maybe<Scalars['String']['output']>;
  callerName?: Maybe<Scalars['String']['output']>;
  emergencyAddressID: Scalars['ID']['output'];
  preferredLanguage?: Maybe<Scalars['String']['output']>;
  problems?: Maybe<Array<EmergencyAddressProblem>>;
};

export type EmergencyAddressDetail = {
  __typename?: 'EmergencyAddressDetail';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  endpointID?: Maybe<Scalars['String']['output']>;
  locationID?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  status: EmergencyAddressStatus;
  zip?: Maybe<Scalars['String']['output']>;
};

export type EmergencyAddressInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  stateCode: Scalars['String']['input'];
  termsConditions: Scalars['Boolean']['input'];
  zip: Scalars['String']['input'];
};

export type EmergencyAddressProblem = {
  __typename?: 'EmergencyAddressProblem';
  details?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum EmergencyAddressStatus {
  ADJUSTED_COMPLETE = 'ADJUSTED_COMPLETE',
  ADJUSTED_PARTIAL = 'ADJUSTED_PARTIAL',
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
  INACTIVE = 'INACTIVE',
  PARTIAL = 'PARTIAL',
  PROCESSING = 'PROCESSING',
  RECEIVED = 'RECEIVED'
}

export enum EmergencyCountryCode {
  AT = 'AT',
  AU = 'AU',
  BR = 'BR',
  CA = 'CA',
  DE = 'DE',
  ES = 'ES',
  FR = 'FR',
  GB = 'GB',
  IE = 'IE',
  NO = 'NO',
  SI = 'SI',
  US = 'US'
}

export type EmergencyNumberCountry = {
  __typename?: 'EmergencyNumberCountry';
  countryCode: EmergencyCountryCode;
  numbers: Array<Scalars['String']['output']>;
  silentNumbers: Array<Scalars['String']['output']>;
};

export enum EmployeeCountRange {
  BETWEEN_1_AND_10 = 'BETWEEN_1_AND_10',
  BETWEEN_11_AND_50 = 'BETWEEN_11_AND_50',
  BETWEEN_51_AND_200 = 'BETWEEN_51_AND_200',
  BETWEEN_201_AND_500 = 'BETWEEN_201_AND_500',
  BETWEEN_501_AND_1000 = 'BETWEEN_501_AND_1000',
  BETWEEN_1001_AND_5000 = 'BETWEEN_1001_AND_5000',
  BETWEEN_5001_AND_10000 = 'BETWEEN_5001_AND_10000',
  MORE_THAN_10000 = 'MORE_THAN_10000'
}

export type EnableDisableFeatureInput = {
  featureName: Scalars['String']['input'];
  isDisabled: Scalars['Boolean']['input'];
};

export type EnableDisableFeatureOutput = {
  __typename?: 'EnableDisableFeatureOutput';
  error?: Maybe<Error>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type EnableIntegrationMutationInput = {
  solutionInstanceId: Scalars['String']['input'];
};

export type EnableIntegrationResponse = {
  __typename?: 'EnableIntegrationResponse';
  integrationId?: Maybe<Scalars['Int']['output']>;
};

export type EnableTrialFeatureInput = {
  name: Scalars['String']['input'];
};

export type EnableTrialFeatureOutput = {
  __typename?: 'EnableTrialFeatureOutput';
  enabledFeatureTrial?: Maybe<CompanyAddonTrial>;
  error?: Maybe<Error>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type EndChatSessionOutput = EndedChatSession | GenericException | ResourceNotFoundException;

export type EndCoachingSessionResult = CoachingSession | GenericException | ResourceNotFoundException;

export type EndedChatSession = {
  __typename?: 'EndedChatSession';
  sessionId: Scalars['ID']['output'];
};

export type Engagement = {
  ID: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
};

export type EngagementAuthor = PhoneContactResolver | PhoneTeammateResolver | SystemEntity;

export type EngagementAuthorV2 = MessagingAiAgentResolver | PhoneContactResolver | PhoneTeammateResolver | SystemEntity | VirtualAgentResolver;

export type EngagementConnection = {
  __typename?: 'EngagementConnection';
  edges: Array<EngagementEdge>;
  pageInfo: RelayPageInfo;
};

export type EngagementConnectionOutput = EngagementConnection | GenericException | ResourceNotFoundException | UserInputException;

export type EngagementCreatedSubscriptionFilter = {
  __typename?: 'EngagementCreatedSubscriptionFilter';
  conversationID: Scalars['ID']['output'];
};

export type EngagementCreatedSubscriptionFilterInput = {
  conversationID: Scalars['ID']['input'];
};

export type EngagementEdge = {
  __typename?: 'EngagementEdge';
  cursor: Scalars['String']['output'];
  node: Engagement;
};

export enum EngagementResourceType {
  EXTERNAL_CALL = 'EXTERNAL_CALL',
  EXTERNAL_MESSAGE = 'EXTERNAL_MESSAGE',
  EXTERNAL_WHATSAPP = 'EXTERNAL_WHATSAPP'
}

export type EngagementToDisplay = CallEngagement | MessageEngagement;

export type EngagementUpdatedMutationFilter = {
  conversationID: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type EngagementUpdatedSubscriptionFilter = {
  __typename?: 'EngagementUpdatedSubscriptionFilter';
  conversationID: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type EngagementUpdatedSubscriptionFilterInput = {
  conversationID: Scalars['ID']['input'];
  createdAt?: InputMaybe<TimestampSubscriptionFilter>;
};

export type EnqueuedAgentTarget = Target & {
  __typename?: 'EnqueuedAgentTarget';
  id: Scalars['ID']['output'];
  ringingTimeout?: Maybe<Scalars['Int']['output']>;
  skipWhenBusy?: Maybe<Scalars['Boolean']['output']>;
  type: TargetType;
};

export type EnqueuedTarget = EnqueuedAgentTarget | EnqueuedTeamTarget;

export type EnqueuedTeamTarget = Target & {
  __typename?: 'EnqueuedTeamTarget';
  agentTargets: Array<EnqueuedAgentTarget>;
  dispatchStrategy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ringingTimeout?: Maybe<Scalars['Int']['output']>;
  skipWhenBusy?: Maybe<Scalars['Boolean']['output']>;
  type: TargetType;
};

export type EnrollInHubspotSequenceInput = {
  callID: Scalars['ID']['input'];
  contactId?: InputMaybe<Scalars['String']['input']>;
  sequenceId: Scalars['String']['input'];
};

export type EnrollInHubspotSequenceOutput = {
  __typename?: 'EnrollInHubspotSequenceOutput';
  enrollmentId: Scalars['ID']['output'];
};

export type EnrollNumbersInput = {
  numbers: Array<Scalars['String']['input']>;
};

export type EnrollNumbersResult = BrandedCallingException | EnrollNumbersSuccess | GenericException;

export type EnrollNumbersSuccess = {
  __typename?: 'EnrollNumbersSuccess';
  enrolled: Array<EnrolledNumber>;
};

export type EnrolledMonitoredNumber = {
  __typename?: 'EnrolledMonitoredNumber';
  businessId: Scalars['ID']['output'];
  e164: Scalars['String']['output'];
  lineId: Scalars['ID']['output'];
  numberId: Scalars['ID']['output'];
  reputationData?: Maybe<NumberReputationData>;
  reputationLabel?: Maybe<NumberReputationLabel>;
  status: MonitoredNumberStatus;
};

export type EnrolledNumber = {
  __typename?: 'EnrolledNumber';
  activeSince?: Maybe<Scalars['String']['output']>;
  carrierStatuses: Array<CarrierStatus>;
  e164: Scalars['String']['output'];
  enrollmentId: Scalars['ID']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  status: NumberEnrollmentStatus;
  submittedAt: Scalars['String']['output'];
};

export enum EntityType {
  agent = 'agent',
  calendar = 'calendar',
  line = 'line',
  team = 'team',
  virtualAgent = 'virtualAgent'
}

export type Entry = {
  __typename?: 'Entry';
  C: Scalars['Float']['output'];
  E: Scalars['Float']['output'];
  S: Scalars['Float']['output'];
  W: Scalars['String']['output'];
};

export type Errable = {
  message: Scalars['String']['output'];
};

export type Error = {
  __typename?: 'Error';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum EscalationDependentEntityType {
  NUMBER = 'NUMBER',
  TEAM = 'TEAM',
  USER = 'USER'
}

export type EscalationDependents = {
  __typename?: 'EscalationDependents';
  affectedAgents: Array<AffectedAgent>;
};

export type EscalationDependentsOutput = EscalationDependents | GenericException;

export type EsimLicenseDetail = {
  __typename?: 'EsimLicenseDetail';
  assignedLicenses: Scalars['Int']['output'];
  availableLicenses: Scalars['Int']['output'];
  license: Scalars['String']['output'];
  totalLicenses: Scalars['Int']['output'];
};

export enum EvalAgentType {
  AIMA = 'AIMA',
  AIVA = 'AIVA',
  BOTH = 'BOTH'
}

export type EvalPersona = {
  __typename?: 'EvalPersona';
  applicationId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  persona: Scalars['String']['output'];
  personaId: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
};

export type EvalPersonaList = {
  __typename?: 'EvalPersonaList';
  personas: Array<EvalPersona>;
};

export type EvalRun = {
  __typename?: 'EvalRun';
  applicationId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  errorPayload?: Maybe<Scalars['String']['output']>;
  iterationsSpent: Scalars['Int']['output'];
  personaId: Scalars['String']['output'];
  results: Array<ScenarioResult>;
  runBudget?: Maybe<Scalars['String']['output']>;
  runId: Scalars['ID']['output'];
  state: EvalRunState;
  updatedAt: Scalars['String']['output'];
};

export enum EvalRunState {
  AWAITING_MANUAL_AIVA = 'AWAITING_MANUAL_AIVA',
  AWAITING_VERDICT_CONFIRM = 'AWAITING_VERDICT_CONFIRM',
  FAILED = 'FAILED',
  FINALIZED = 'FINALIZED',
  INCOMPLETE = 'INCOMPLETE',
  RUNNING = 'RUNNING',
  SCENARIOS_READY = 'SCENARIOS_READY'
}

export type EvalRunSummary = {
  __typename?: 'EvalRunSummary';
  createdAt: Scalars['String']['output'];
  runId: Scalars['ID']['output'];
  scenarioCount: Scalars['Int']['output'];
  state: EvalRunState;
  updatedAt: Scalars['String']['output'];
};

export type EvalRunSummaryList = {
  __typename?: 'EvalRunSummaryList';
  runs: Array<EvalRunSummary>;
};

export enum EvalVerdict {
  FAIL = 'FAIL',
  PASS = 'PASS'
}

export type Evaluation = {
  __typename?: 'Evaluation';
  ID: Scalars['ID']['output'];
  callConversation?: Maybe<CallConversation>;
  callId: Scalars['ID']['output'];
  callTags: Array<Scalars['ID']['output']>;
  categories: Array<EvaluationCategory>;
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  isGeneratedByAI: Scalars['Boolean']['output'];
  reviewedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  reviewee?: Maybe<AgentDetails>;
  revieweeTeammate: PhoneTeammateResolver;
  revieweeUserId: Scalars['ID']['output'];
  reviewer?: Maybe<AgentDetails>;
  reviewerTeammate?: Maybe<PhoneTeammateResolver>;
  reviewerUserId: Scalars['ID']['output'];
  score: Score;
  scoreCardDescription: Scalars['String']['output'];
  scoreCardId: Scalars['ID']['output'];
  scoreCardLanguage: Scalars['String']['output'];
  scoreCardName: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
};

export type EvaluationBinaryQuestionAnswerCountResult = {
  __typename?: 'EvaluationBinaryQuestionAnswerCountResult';
  binaryAnswerCounts?: Maybe<Array<BinaryAnswerCount>>;
};

export type EvaluationCallsCountResult = {
  __typename?: 'EvaluationCallsCountResult';
  count: Scalars['Int']['output'];
};

export type EvaluationCategoriesNormalizedScoreAvgResult = {
  __typename?: 'EvaluationCategoriesNormalizedScoreAvgResult';
  categories: Array<EvaluationCategoryNormalizedScoreAvg>;
};

export type EvaluationCategory = {
  __typename?: 'EvaluationCategory';
  ID: Scalars['ID']['output'];
  categoryName: Scalars['String']['output'];
  categoryOrder: Scalars['Int']['output'];
  questions: Array<EvaluationQuestion>;
  scoreCardCategoryId: Scalars['ID']['output'];
};

export type EvaluationCategoryNormalizedScoreAvg = {
  __typename?: 'EvaluationCategoryNormalizedScoreAvg';
  avg?: Maybe<Scalars['Float']['output']>;
  categoryId: Scalars['ID']['output'];
};

export type EvaluationNormalizedScoreAvgResult = {
  __typename?: 'EvaluationNormalizedScoreAvgResult';
  avg?: Maybe<Scalars['Float']['output']>;
};

export type EvaluationOutput = Evaluation | GenericException | ResourceNotFoundException | UserInputException;

export type EvaluationQuestion = BinaryEvaluationQuestion | RatingEvaluationQuestion;

export type EvaluationQuestionAnswerCountResult = {
  __typename?: 'EvaluationQuestionAnswerCountResult';
  binaryAnswerCounts?: Maybe<Array<BinaryAnswerCount>>;
  ratingAnswerCounts?: Maybe<Array<RatingAnswerCount>>;
};

export type EvaluationRatingQuestionAnswerCountResult = {
  __typename?: 'EvaluationRatingQuestionAnswerCountResult';
  ratingAnswerCounts?: Maybe<Array<RatingAnswerCount>>;
};

export enum EvaluationStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING'
}

export type EvaluationUsersCountResult = {
  __typename?: 'EvaluationUsersCountResult';
  count: Scalars['Int']['output'];
};

export type EventEntry = {
  __typename?: 'EventEntry';
  call?: Maybe<Array<Scalars['String']['output']>>;
  contact?: Maybe<Array<Scalars['String']['output']>>;
  number?: Maybe<Array<Scalars['String']['output']>>;
  user?: Maybe<Array<Scalars['String']['output']>>;
};

export type EvidenceRef = {
  __typename?: 'EvidenceRef';
  callId: Scalars['ID']['output'];
  criterion: Scalars['String']['output'];
  date: Scalars['String']['output'];
};

export type Exception = {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum ExcludeFilter {
  TRANSCRIPTION_SCOPE = 'TRANSCRIPTION_SCOPE'
}

export type ExistingTrackerAggregation = {
  __typename?: 'ExistingTrackerAggregation';
  count: Scalars['Int']['output'];
  tracker?: Maybe<Tracker>;
  trackerId: Scalars['Int']['output'];
};

export enum ExpectedCallVolume {
  OVER_1M = 'OVER_1M',
  UNKNOWN = 'UNKNOWN',
  UP_TO_1K = 'UP_TO_1K',
  UP_TO_1M = 'UP_TO_1M',
  UP_TO_5K = 'UP_TO_5K',
  UP_TO_10K = 'UP_TO_10K',
  UP_TO_25K = 'UP_TO_25K',
  UP_TO_50K = 'UP_TO_50K',
  UP_TO_100 = 'UP_TO_100',
  UP_TO_100K = 'UP_TO_100K',
  UP_TO_250K = 'UP_TO_250K',
  UP_TO_500 = 'UP_TO_500',
  UP_TO_500K = 'UP_TO_500K'
}

export type ExpectedToolInput = {
  argAssertions?: InputMaybe<Array<ArgAssertionInput>>;
  expectedTool: Scalars['String']['input'];
  groundedArgs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ExportOutboundCampaignContactImportRowsOutput = GenericException | OutboundCampaignContactImportExportUrl | ResourceNotFoundException;

export type ExportVirtualAgentOutput = GenericException | ResourceNotFoundException | UnauthorizedException | VirtualAgentExport;

export type ExtendMandatoryTaggingInput = {
  twilioCallSid?: InputMaybe<Scalars['String']['input']>;
};

export type ExtendMandatoryTaggingOutput = {
  __typename?: 'ExtendMandatoryTaggingOutput';
  success: Scalars['Boolean']['output'];
};

export type ExternalEntity = ExternalNumber | PhoneContact;

export type ExternalLine = {
  __typename?: 'ExternalLine';
  companyID?: Maybe<Scalars['ID']['output']>;
  contact?: Maybe<Contact>;
  external: PhoneContactResolver;
  phoneNumber: Scalars['String']['output'];
};

export type ExternalLineInput = {
  companyID?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber: Scalars['String']['input'];
};

export type ExternalNumber = {
  __typename?: 'ExternalNumber';
  phoneNumber: Scalars['String']['output'];
  source?: Maybe<ExternalNumberSource>;
};

export enum ExternalNumberSource {
  ANONYMOUS = 'ANONYMOUS',
  INTERCOM = 'INTERCOM'
}

export type ExternalParticipant = {
  __typename?: 'ExternalParticipant';
  contact?: Maybe<Contact>;
  external: PhoneContactResolver;
  number: Scalars['String']['output'];
};

export type ExternalSpeaker = {
  __typename?: 'ExternalSpeaker';
  channel: Scalars['Int']['output'];
  contact?: Maybe<Contact>;
  external: PhoneContactResolver;
  number: Scalars['String']['output'];
};

export type ExtractionTask = {
  __typename?: 'ExtractionTask';
  questions: Array<QuestionExtraction>;
};

export type ExtractionTaskInput = {
  questions?: InputMaybe<Array<QuestionExtractionInput>>;
};

export type FailedContact = {
  __typename?: 'FailedContact';
  fields: ContactFields;
  reason: Scalars['String']['output'];
  row: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type FeatureOutput = {
  __typename?: 'FeatureOutput';
  enable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type FeatureRequest = {
  __typename?: 'FeatureRequest';
  recordTime: Scalars['Float']['output'];
  userId: Scalars['String']['output'];
};

export type FeatureRequestDetails = {
  __typename?: 'FeatureRequestDetails';
  name: Scalars['String']['output'];
  requestedByCurrentUser: Scalars['Boolean']['output'];
  requests: Array<FeatureRequest>;
  totalRequests: Scalars['Int']['output'];
};

export type FeedbackResult = {
  __typename?: 'FeedbackResult';
  ID: Scalars['String']['output'];
  feedback?: Maybe<FeedbackType>;
};

export enum FeedbackType {
  thumbs_down = 'thumbs_down',
  thumbs_up = 'thumbs_up'
}

export type FieldException = InvalidEnumException | InvalidStringException | InvalidTypeException | TooBigException | TooSmallException;

export type FieldInput = {
  fieldId: Scalars['Int']['input'];
  fieldName?: InputMaybe<Scalars['String']['input']>;
  fieldType: FieldType;
  fieldValue: Scalars['String']['input'];
};

export enum FieldType {
  date = 'date',
  document = 'document',
  enum = 'enum',
  phone = 'phone',
  string = 'string',
  text = 'text'
}

export type FileInput = {
  data: Scalars['String']['input'];
  fieldId: Scalars['Int']['input'];
  filename: Scalars['String']['input'];
};

export type FindActiveDraftOutput = GenericException | VirtualAgentDraft;

export type FindActiveDraftsForAgentsOutput = ActiveDraftStatusList | GenericException | UserInputException;

export type Finding = {
  __typename?: 'Finding';
  affectedFields: Array<Scalars['String']['output']>;
  detail: Scalars['String']['output'];
  issue: Scalars['String']['output'];
  recommendation: Scalars['String']['output'];
};

export enum FirstPaymentStatus {
  done = 'done',
  fail = 'fail',
  new = 'new',
  pending = 'pending'
}

export type FlowConcurrentModificationException = Exception & {
  __typename?: 'FlowConcurrentModificationException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type FlowConfigurationInput = {
  draftReferenceNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  flowDefinition: Scalars['String']['input'];
  flowWarnings?: InputMaybe<Scalars['String']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isPersonalLine?: InputMaybe<Scalars['Boolean']['input']>;
  lastEditedAt?: InputMaybe<Scalars['String']['input']>;
};

export type FlowConfigurationOutput = {
  __typename?: 'FlowConfigurationOutput';
  createdAt?: Maybe<Scalars['String']['output']>;
  draftReferenceNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  flowDefinition: Scalars['String']['output'];
  flowWarnings?: Maybe<Scalars['String']['output']>;
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  isPersonalLine?: Maybe<Scalars['Boolean']['output']>;
  lastEditedAt: Scalars['String']['output'];
  lineID: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type FlowConfigurationOutputV2 = FlowConcurrentModificationException | FlowConfigurationOutput | GenericException | InvalidFlowDefinitionException | MaxFlowSizeReachedException | PersonalLineRevertException;

export type FocusArea = {
  __typename?: 'FocusArea';
  label: Scalars['String']['output'];
  skill: Scalars['String']['output'];
};

export type Forbidden = {
  __typename?: 'Forbidden';
  message: Scalars['String']['output'];
};

export type ForgotPasswordMutationInput = {
  email: Scalars['String']['input'];
};

export type FunctionType = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GetRequestTargetRequestConfiguration = {
  auth: RequestTargetAuth;
  headers: Array<RequestTargetHeader>;
  url: Scalars['String']['input'];
};

export type GsmDevice = {
  __typename?: 'GSMDevice';
  cellularModeActive: Scalars['Boolean']['output'];
  deviceId: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type GsmDeviceVerified = {
  __typename?: 'GSMDeviceVerified';
  success: Scalars['Boolean']['output'];
};

export enum GsmVerificationChannel {
  call = 'call',
  sms = 'sms'
}

export type GenerateAiAnswerCategoryInput = {
  categoryId: Scalars['ID']['input'];
  questions: Array<GenerateAiAnswerQuestionInput>;
};

export type GenerateAiAnswerQuestionInput = {
  predefinedAIQuestionId?: InputMaybe<Scalars['ID']['input']>;
  questionId: Scalars['ID']['input'];
  questionPossibleBinaryAnswers?: InputMaybe<Array<QuestionBinaryAnswer>>;
  questionPossibleRatingAnswers?: InputMaybe<Array<QuestionRatingAnswer>>;
  questionStrictness?: InputMaybe<Scalars['Int']['input']>;
  questionText: Scalars['String']['input'];
  questionType: QuestionType;
};

export type GenerateAiAnswersInput = {
  callId: Scalars['ID']['input'];
  categories: Array<GenerateAiAnswerCategoryInput>;
  language: Scalars['String']['input'];
  transcriptionId: Scalars['ID']['input'];
};

export type GenerateActivationCompanyContextInput = {
  language?: InputMaybe<Scalars['String']['input']>;
  websiteUrl: Scalars['String']['input'];
};

export type GenerateActivationCompanyContextOutput = ActivationCapabilityDisabled | ActivationCompanyContext | ActivationForbidden | ActivationRequestException | ActivationUnauthenticated | GenericException | UserInputException;

export type GenerateAdminMcpOauthGrantUrlOutput = AdminOauthGrantUrl | GenericException | ResourceNotFoundException | UserInputException;

export type GenerateMessagingMediaUrlsInput = {
  channel?: InputMaybe<Channel>;
  lineID: Scalars['ID']['input'];
  metadata: Array<MetadataMediaUrls>;
};

export type GenerateMessagingMediaUrlsOutput = {
  __typename?: 'GenerateMessagingMediaUrlsOutput';
  error?: Maybe<Error>;
  presignedMediaUrlDetails?: Maybe<Array<PresignedMediaUrls>>;
};

export type GenerateMessagingMediaWhatsappUrlsResult = GenerateMessagingWhatsappMediaUrlsOutput | GenericException;

export type GenerateMessagingWhatsappMediaUrlsOutput = {
  __typename?: 'GenerateMessagingWhatsappMediaUrlsOutput';
  presignedMediaUrlDetails?: Maybe<Array<PresignedMediaUrls>>;
};

export type GenerateMondayWebhookUrlOutput = {
  __typename?: 'GenerateMondayWebhookUrlOutput';
  webhookUrl: Scalars['String']['output'];
};

export type GenerateOAuthAuthorizationUrlOutput = GenericException | OAuthUrlResponse | ResourceNotFoundException | UserInputException;

export type GeneratePortingLoaInput = {
  isEmbedded: Scalars['Boolean']['input'];
  portingRequestUUID: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
  signerEmail: Scalars['String']['input'];
  signerName: Scalars['String']['input'];
};

export type GeneratePortingLoaResponse = {
  __typename?: 'GeneratePortingLoaResponse';
  envelopeId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  signingUrl?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type GeneratePrerecordedMessageUrlInput = {
  fileName: Scalars['String']['input'];
  fileSizeInBytes: Scalars['Int']['input'];
  mimeType: Scalars['String']['input'];
};

export type GeneratePrerecordedMessageUrlOutput = GenericException | MaximumConfirmedPrerecordedMessagesReachedException | PrerecordedMessageUrl | UserInputException;

export type GenerateProcessoutTokenOutput = {
  __typename?: 'GenerateProcessoutTokenOutput';
  error?: Maybe<Error>;
  token?: Maybe<Scalars['String']['output']>;
};

export type GenerateSmsAutomationWebhookUrlOutput = {
  __typename?: 'GenerateSMSAutomationWebhookUrlOutput';
  webhookUrl: Scalars['String']['output'];
};

export type GenerateScenariosOutput = GeneratedScenarios | GenericException | RateLimitExceededException | ResourceNotFoundException;

export type GenerateTtsMessageInput = {
  language: Scalars['String']['input'];
  message: Scalars['String']['input'];
  skipFallback?: InputMaybe<Scalars['Boolean']['input']>;
  voice: Scalars['String']['input'];
};

export type GenerateTtsMessageOutput = GenericException | TtsGenerationInProgressException | TtsMessageCreateOutput | UserInputException;

export type GenerateWhatsappHeaderMediaUrlInput = {
  metadata: Array<MetadataMediaUrls>;
};

export type GeneratedScenarios = {
  __typename?: 'GeneratedScenarios';
  scenariosJson: Scalars['String']['output'];
};

export type GenerationFailedException = Exception & {
  __typename?: 'GenerationFailedException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  upstreamStatusCode?: Maybe<Scalars['Int']['output']>;
};

export type GenericException = Exception & {
  __typename?: 'GenericException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type GetA2PCampaignsByCompanyIdOutput = {
  __typename?: 'GetA2PCampaignsByCompanyIdOutput';
  campaigns: Array<A2PCampaign>;
};

export type GetA2PCampaignsByCompanyIdResult = GenericException | GetA2PCampaignsByCompanyIdOutput;

export type GetA2PFormAttachmentUploadUrlInput = {
  fileName: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
};

export type GetA2PFormAttachmentUploadUrlResult = GenericException | PresignedMediaUrls;

export type GetA2PFormResult = A2PForm | GenericException;

export type GetA2PFormsOutput = {
  __typename?: 'GetA2PFormsOutput';
  forms: Array<A2PForm>;
};

export type GetA2PFormsResult = GenericException | GetA2PFormsOutput;

export type GetA2PUrlEvidenceResult = A2PUrlEvidenceOutput | GenericException;

export type GetActivePlaybookInput = {
  callUuid: Scalars['String']['input'];
};

export type GetActivePlaybookOutput = CustomPlaybook | GenericException | PlaybookException | UserInputException;

export type GetAdminMcpOauthGrantStatusOutput = AdminOauthGrantStatusResult | GenericException | ResourceNotFoundException;

export type GetAgentChatFeedbackOutput = FeedbackResult | GenericException | ResourceNotFoundException | UserInputException;

export type GetAiActionsEnabledCompaniesOutput = AiActionsEnabledCompanies | GenericException | ResourceNotFoundException | UserInputException;

export type GetAivaAgentActionsOutput = AivaAgentActions | GenericException | ResourceNotFoundException | UserInputException;

export type GetAivaAgentMigrationDraftOutput = AivaAgentMigrationDraft | ConflictException | GenericException | ResourceNotFoundException | UserInputException;

export type GetApplicationInstallUriOutput = {
  __typename?: 'GetApplicationInstallUriOutput';
  installUri: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

export type GetAutocompleteResult = AutocompleteResult | GenericException | UserInputException;

export type GetAutomationsFilter = {
  ID?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type GetAutomationsResult = GenericException | InsufficientLicenseException | PaginatedAutomations | UserInputException;

export type GetBestMatchInput = {
  availableE164s?: InputMaybe<Array<Scalars['String']['input']>>;
  companyId: Scalars['String']['input'];
  defaultE164: Scalars['String']['input'];
  toNumber: Scalars['String']['input'];
};

export type GetBestMatchResponse = {
  __typename?: 'GetBestMatchResponse';
  isDefault: Scalars['Boolean']['output'];
  lineId?: Maybe<Scalars['Int']['output']>;
  matchType: BestMatchType;
  reason: Scalars['String']['output'];
  selectedE164: Scalars['String']['output'];
};

export type GetBetasInput = {
  status?: InputMaybe<BetaStatus>;
};

export type GetBetasOutput = GenericException | GetBetasResult | UserInputException;

export type GetBetasResult = {
  __typename?: 'GetBetasResult';
  items: Array<Beta>;
};

export type GetBrandDocumentDownloadUrlResult = BrandDocumentDownloadUrl | BrandedCallingException | GenericException;

export type GetBrandDraftLogoResult = BrandDraftLogoRenderUrl | BrandedCallingException | GenericException;

export type GetBrandResult = Brand | BrandedCallingException | GenericException;

export type GetBulkCallTimelinesOutput = GenericException | GetListCallTimelinesOutput;

export type GetBulkCallTimelinesOutputV2 = GenericException | GetListCallTimelinesOutputV2;

export type GetCallConfigurationOutput = {
  __typename?: 'GetCallConfigurationOutput';
  bitrate?: Maybe<Scalars['String']['output']>;
};

export type GetCallScoringSettingsResult = CallScoringSettings | GenericException;

export type GetCallTaggingSettingsInput = {
  lineId: Scalars['ID']['input'];
};

export type GetCallTaggingSettingsOutput = CallTaggingSettings | GenericException | UserInputException;

export type GetCallTimelineOutput = {
  __typename?: 'GetCallTimelineOutput';
  agentIds: Array<Scalars['Int']['output']>;
  callSid: Scalars['String']['output'];
  calleePhoneNumber: Scalars['String']['output'];
  callerPhoneNumber: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  events: Scalars['String']['output'];
  lineIds: Array<Scalars['Int']['output']>;
  teamIds: Array<Scalars['Int']['output']>;
  voiceVirtualAgentIds: Array<Scalars['String']['output']>;
};

export type GetCallTimelineOutputV2 = GenericException | GetTypedCallTimelineOutputV2;

export type GetCardDetailsOutput = {
  __typename?: 'GetCardDetailsOutput';
  card?: Maybe<CardDetails>;
  source: Scalars['String']['output'];
};

export type GetCertificationsOutput = GenericException | ResourceNotFoundException | ToolCertStatusList;

export type GetChatSessionOutput = ActiveChatSession | GenericException | ResourceNotFoundException;

export type GetCoachingSessionOutput = {
  __typename?: 'GetCoachingSessionOutput';
  context?: Maybe<ActiveSessionContext>;
  insights?: Maybe<ActiveSessionInsights>;
  session: CoachingSession;
};

export type GetCoachingSessionResult = GenericException | GetCoachingSessionOutput | ResourceNotFoundException;

export type GetCompanyNumbersCountInput = {
  companyID: Scalars['ID']['input'];
};

export type GetCompanyNumbersCountOutput = {
  __typename?: 'GetCompanyNumbersCountOutput';
  companyID: Scalars['ID']['output'];
  count: Scalars['Int']['output'];
  error?: Maybe<Error>;
};

export type GetCompanyQuestionnairesOutput = GenericException | GetCompanyQuestionnairesResponse | UserInputException;

export type GetCompanyQuestionnairesResponse = {
  __typename?: 'GetCompanyQuestionnairesResponse';
  questionnaires: Array<Maybe<Questionnaire>>;
};

export type GetCompanyRiskScoreData = {
  __typename?: 'GetCompanyRiskScoreData';
  risk: Scalars['Int']['output'];
};

export type GetCompanyRiskScoreOutput = {
  __typename?: 'GetCompanyRiskScoreOutput';
  data?: Maybe<GetCompanyRiskScoreData>;
  error?: Maybe<Error>;
};

export type GetCompanyUsersCountInput = {
  companyID: Scalars['ID']['input'];
};

export type GetCompanyUsersCountOutput = {
  __typename?: 'GetCompanyUsersCountOutput';
  companyID: Scalars['ID']['output'];
  count: Scalars['Int']['output'];
  error?: Maybe<Error>;
};

export type GetConnectPlaneApplicationAuthHeaderOutput = ApplicationAuthHeader | GenericException | ResourceNotFoundException | UserInputException;

export type GetConnectPlaneToolAvailabilityOutput = GenericException | ResourceNotFoundException | ToolAvailabilityDetails | UserInputException;

export type GetCountCallConversationsResult = CountCallConversations | GenericException;

export type GetCustomPlaybooksInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<PlaybookLanguage>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type GetCustomPlaybooksOutput = GenericException | GetCustomPlaybooksResult | UserInputException;

export type GetCustomPlaybooksResult = {
  __typename?: 'GetCustomPlaybooksResult';
  items: Array<CustomPlaybook>;
  pageInfo: PagingInfo;
};

export type GetCustomSummariesInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<CustomSummaryLanguage>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type GetCustomSummariesOutput = GenericException | GetCustomSummariesResult | UserInputException;

export type GetCustomSummariesResult = {
  __typename?: 'GetCustomSummariesResult';
  items: Array<CustomSummary>;
  pageInfo: PagingInfo;
};

export type GetCustomSummaryConfigurationsInput = {
  lineId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetCustomSummaryConfigurationsOutput = GenericException | GetCustomSummaryConfigurationsResult | UserInputException;

export type GetCustomSummaryConfigurationsResult = {
  __typename?: 'GetCustomSummaryConfigurationsResult';
  items: Array<CustomSummaryConfiguration>;
  pageInfo: PagingInfo;
};

export type GetCustomSummaryResultsInput = {
  callId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetCustomSummaryResultsOutput = GenericException | GetCustomSummaryResultsResult | UserInputException;

export type GetCustomSummaryResultsResult = {
  __typename?: 'GetCustomSummaryResultsResult';
  items: Array<CustomSummaryResult>;
  pageInfo: PagingInfo;
};

export type GetDocumentDownloadUrlResult = BrandedCallingException | DocumentDownloadUrl | GenericException;

export type GetEvalPersonasOutput = EvalPersonaList | GenericException | ResourceNotFoundException;

export type GetEvalRunOutput = EvalRun | GenericException | ResourceNotFoundException;

export type GetEvaluationCallsCountResult = EvaluationCallsCountResult | GenericException | UserInputException;

export type GetEvaluationCategoriesNormalizedScoreAvgResult = EvaluationCategoriesNormalizedScoreAvgResult | GenericException | UserInputException;

export type GetEvaluationNormalizedScoreAvgResult = EvaluationNormalizedScoreAvgResult | GenericException | UserInputException;

export type GetEvaluationQuestionAnswerCountsResult = EvaluationBinaryQuestionAnswerCountResult | EvaluationQuestionAnswerCountResult | EvaluationRatingQuestionAnswerCountResult | GenericException | UserInputException;

export type GetEvaluationUsersCountResult = EvaluationUsersCountResult | GenericException | UserInputException;

export type GetEvaluationsFilter = {
  ID?: InputMaybe<Scalars['ID']['input']>;
  callDirections?: InputMaybe<Array<CallDirection>>;
  callId?: InputMaybe<Scalars['ID']['input']>;
  callTags?: InputMaybe<Array<Scalars['ID']['input']>>;
  from?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  fromCallStartedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  isGeneratedByAI?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  lineIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  maxNormalizedScore?: InputMaybe<Scalars['Int']['input']>;
  minNormalizedScore?: InputMaybe<Scalars['Int']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  revieweeUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  scoreCardId?: InputMaybe<Scalars['ID']['input']>;
  scoreCardQuestionId?: InputMaybe<Scalars['ID']['input']>;
  to?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  toCallStartedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type GetEvaluationsResult = GenericException | PaginatedEvaluations | UserInputException;

export type GetFirstPaymentStatusOutput = {
  __typename?: 'GetFirstPaymentStatusOutput';
  status?: Maybe<FirstPaymentStatus>;
  transactions: Array<Transaction>;
};

export type GetHubSpotHelpDeskConnectedLines = {
  __typename?: 'GetHubSpotHelpDeskConnectedLines';
  callActiveStatus: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  smsActiveStatus: Scalars['String']['output'];
  whatsAppActiveStatus?: Maybe<Scalars['String']['output']>;
};

export type GetHubSpotHelpDeskConnectedLinesOutput = {
  __typename?: 'GetHubSpotHelpDeskConnectedLinesOutput';
  message: Scalars['String']['output'];
  result: Array<GetHubSpotHelpDeskConnectedLines>;
};

export type GetHubspotIntegrationsSmsLinesOutput = {
  __typename?: 'GetHubspotIntegrationsSmsLinesOutput';
  smsLines: Array<HubspotIntegrationSmsLine>;
};

export type GetHubspotSearchContextOutput = {
  __typename?: 'GetHubspotSearchContextOutput';
  callId: Scalars['String']['output'];
  companies: Array<HubspotSearchCompany>;
  contacts: Array<HubspotSearchContact>;
  deals: Array<HubspotSearchDeal>;
  engagementId?: Maybe<Scalars['String']['output']>;
  hubspotSequencesEligible: Scalars['Boolean']['output'];
  integrationId?: Maybe<Scalars['String']['output']>;
  loggedCompanyIds: Array<Scalars['String']['output']>;
  loggedContactId?: Maybe<Scalars['String']['output']>;
  loggedDealIds: Array<Scalars['String']['output']>;
  loggedTicketIds: Array<Scalars['String']['output']>;
  portalId: Scalars['String']['output'];
  selectCallOutcome?: Maybe<Scalars['String']['output']>;
  selectedCallType?: Maybe<Scalars['String']['output']>;
  tickets: Array<HubspotSearchTicket>;
};

export type GetInsightCardsOutput = {
  __typename?: 'GetInsightCardsOutput';
  callId: Scalars['String']['output'];
  contents: Array<InsightCardGroup>;
};

export type GetInvoice = {
  __typename?: 'GetInvoice';
  base64: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type GetInvoiceUsageReportOutput = {
  __typename?: 'GetInvoiceUsageReportOutput';
  error?: Maybe<Error>;
  signedUrl?: Maybe<Scalars['String']['output']>;
};

export type GetInvoices = {
  __typename?: 'GetInvoices';
  invoices: Array<Invoice>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type GetKeywordsInput = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  vocabularyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GetKeywordsOutput = GenericException | Keywords | ResourceNotFoundException | UserInputException;

export type GetKycStatusData = {
  __typename?: 'GetKycStatusData';
  accountVerificationStatus: Scalars['String']['output'];
  automatedOnboardingKycStatus: Scalars['String']['output'];
  enableKyc: Scalars['Boolean']['output'];
  kycMaxAttemptsAllowed: Scalars['Int']['output'];
  lastError?: Maybe<KycError>;
  sdrVerificationStatus: Scalars['String']['output'];
  totalAttempts: Scalars['Int']['output'];
};

export type GetKycStatusOutput = {
  __typename?: 'GetKycStatusOutput';
  data?: Maybe<GetKycStatusData>;
  error?: Maybe<Error>;
};

export type GetLatestLongTailProposalOutput = GenericException | LongTailProposal | ResourceNotFoundException | UserInputException;

export type GetLatestLongTailSourceInputOutput = GenericException | LongTailSourceInput | ResourceNotFoundException | UserInputException;

export type GetLineByEntityInput = {
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  type: EntityType;
};

export type GetListCallTimelinesOutput = {
  __typename?: 'GetListCallTimelinesOutput';
  fail: Array<CallTimelineFailure>;
  success: Array<GetCallTimelineOutput>;
};

export type GetListCallTimelinesOutputV2 = {
  __typename?: 'GetListCallTimelinesOutputV2';
  fail: Array<CallTimelineFailure>;
  success: Array<GetTypedCallTimelineOutputV2>;
};

export type GetLoaEnvelopeResult = BrandedCallingException | GenericException | LoaEnvelope;

export type GetLongTailGenerationJobOutput = GenericException | LongTailGenerationJob | ResourceNotFoundException | UserInputException;

export type GetLongTailProposalOutput = GenericException | LongTailProposal | ResourceNotFoundException | UserInputException;

export type GetLongTailRegistrationSessionOutput = GenericException | LongTailRegistrationSession | ResourceNotFoundException;

export type GetLongTailSourceInputOutput = GenericException | LongTailSourceInput | ResourceNotFoundException | UserInputException;

export type GetNotificationsInput = {
  locale: Scalars['String']['input'];
  placement: Placement;
  platform: NotificationsPlatform;
  product: Product;
};

export type GetNotificationsOutput = {
  __typename?: 'GetNotificationsOutput';
  count: Scalars['Int']['output'];
  notifications: Array<Notification>;
};

export type GetNumberByUuidInput = {
  numberUUID: Scalars['String']['input'];
};

export type GetNumberRegistrationStatusOutput = {
  __typename?: 'GetNumberRegistrationStatusOutput';
  error?: Maybe<Error>;
  numberRegistration?: Maybe<NumberRegistration>;
};

export type GetNumberResponse = {
  __typename?: 'GetNumberResponse';
  activatedAt?: Maybe<Scalars['String']['output']>;
  activationState: Scalars['String']['output'];
  areaCode?: Maybe<Scalars['String']['output']>;
  bundleSid?: Maybe<Scalars['String']['output']>;
  carrierName?: Maybe<Scalars['String']['output']>;
  carrierUUID?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  countryUUID?: Maybe<Scalars['String']['output']>;
  e164?: Maybe<Scalars['String']['output']>;
  emergencyIdentityUUID?: Maybe<Scalars['String']['output']>;
  emergencyState: Scalars['String']['output'];
  identityUUID?: Maybe<Scalars['String']['output']>;
  isBlocked: Scalars['Boolean']['output'];
  isPorted: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberLength?: Maybe<Scalars['Int']['output']>;
  numberRangeName?: Maybe<Scalars['String']['output']>;
  numberRangeUUID?: Maybe<Scalars['String']['output']>;
  numberUUID: Scalars['String']['output'];
  origin?: Maybe<Scalars['String']['output']>;
  portaDonorRio?: Maybe<Scalars['String']['output']>;
  portabilityState?: Maybe<Scalars['String']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
  regionUUID?: Maybe<Scalars['String']['output']>;
  stockState?: Maybe<Scalars['String']['output']>;
  trialState?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  verificationState: Scalars['String']['output'];
  vipState?: Maybe<Scalars['String']['output']>;
};

export type GetOnboardingInput = {
  platform?: InputMaybe<Platform>;
};

export type GetOnboardingOutput = GenericException | Onboarding;

export type GetOrCreateKbForAgentInput = {
  agent_id: Scalars['String']['input'];
  agent_type?: InputMaybe<AgentType>;
  client_type: Scalars['String']['input'];
  company_name?: InputMaybe<Scalars['String']['input']>;
  kb_name: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};

export type GetOrCreateKbForAgentResult = AgentKbWithDetails | GenericException;

export type GetPlaybookResultsInput = {
  callId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetPlaybookResultsOutput = GenericException | GetPlaybookResultsResult | UserInputException;

export type GetPlaybookResultsResult = {
  __typename?: 'GetPlaybookResultsResult';
  items: Array<PlaybookResult>;
};

export type GetPlaybookSettingsInput = {
  language?: InputMaybe<PlaybookLanguage>;
  lineId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetPlaybookSettingsOutput = GenericException | GetPlaybookSettingsResult | UserInputException;

export type GetPlaybookSettingsResult = {
  __typename?: 'GetPlaybookSettingsResult';
  items: Array<PlaybookSettings>;
};

export type GetPortingDocumentDownloadUrlData = {
  __typename?: 'GetPortingDocumentDownloadUrlData';
  contentType: Scalars['String']['output'];
  downloadUrl: Scalars['String']['output'];
  expiresIn: Scalars['Int']['output'];
  fieldRefId: Scalars['Int']['output'];
  fileName: Scalars['String']['output'];
};

export type GetPortingDocumentDownloadUrlInput = {
  fieldRefId: Scalars['Int']['input'];
  portingRequestUUID: Scalars['String']['input'];
};

export type GetPortingDocumentDownloadUrlResponse = {
  __typename?: 'GetPortingDocumentDownloadUrlResponse';
  data: GetPortingDocumentDownloadUrlData;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type GetPortingFieldsInput = {
  portingRequestUUID: Scalars['String']['input'];
  subsectionName: Scalars['String']['input'];
};

export type GetPortingRequestInput = {
  portingRequestUUID: Scalars['String']['input'];
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GetPortingRequestResponse = {
  __typename?: 'GetPortingRequestResponse';
  aircallHandlesLoaGeneration: Scalars['Boolean']['output'];
  canSubmit: Scalars['Boolean']['output'];
  carrierStatusDetails?: Maybe<CarrierStatusDetails>;
  country: PortingRequestCountry;
  createdAt: Scalars['String']['output'];
  events: Array<PortingRequestEvent>;
  externalIdentifiers: Array<PortingRequestExternalIdentifier>;
  fieldValues: Array<PortingFieldValueGroup>;
  focDate?: Maybe<Scalars['String']['output']>;
  isE2E: Scalars['Boolean']['output'];
  isRange: Scalars['Boolean']['output'];
  loa?: Maybe<PortingRequestLoa>;
  losingCarrier: Scalars['String']['output'];
  missingRequirements?: Maybe<Array<Scalars['String']['output']>>;
  numbers: Array<PortingRequestNumberDetail>;
  phoneType?: Maybe<Scalars['String']['output']>;
  portingRequestUUID: Scalars['String']['output'];
  preferredPortingDate?: Maybe<Scalars['String']['output']>;
  rejectionCategory?: Maybe<Scalars['String']['output']>;
  rejectionDetails?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  winningCarrier?: Maybe<PortingRequestCarrier>;
  zendeskTicketUrl?: Maybe<Scalars['String']['output']>;
};

export type GetPredefinedAiQuestionsFilter = {
  language: Scalars['String']['input'];
};

export type GetPredefinedAiQuestionsResult = GenericException | PredefinedAiCategories | UserInputException;

export type GetPredefinedSummaryTemplatesInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<CustomSummaryLanguage>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SummaryTemplateType>;
};

export type GetPredefinedSummaryTemplatesOutput = GenericException | GetPredefinedSummaryTemplatesResult | UserInputException;

export type GetPredefinedSummaryTemplatesResult = {
  __typename?: 'GetPredefinedSummaryTemplatesResult';
  items: Array<PredefinedSummaryTemplate>;
  pageInfo: PagingInfo;
};

export type GetPresignedMediaUrlInput = {
  key: Scalars['String']['input'];
};

export type GetPresignedMediaUrlOutput = {
  __typename?: 'GetPresignedMediaUrlOutput';
  url: Scalars['String']['output'];
};

export type GetPresignedMediaUrlResult = GenericException | GetPresignedMediaUrlOutput;

export type GetProfileResult = GenericException | ProfileResponse | ResourceNotFoundException;

export type GetSfOmnichannelApiKeyOutput = {
  __typename?: 'GetSFOmnichannelApiKeyOutput';
  apiKey: Scalars['String']['output'];
};

export type GetScenariosOutput = GenericException | ResourceNotFoundException | ScenarioList;

export type GetScoreCardsFilter = {
  ID?: InputMaybe<Scalars['ID']['input']>;
  hasEvaluations?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type GetScoreCardsResult = GenericException | InsufficientLicenseException | PaginatedScoreCards | UserInputException;

export type GetScorecardTemplatesFilter = {
  language: Scalars['String']['input'];
};

export type GetScorecardTemplatesResult = GenericException | ScorecardTemplates | UserInputException;

export type GetStudioConversationOutput = GenericException | ResourceNotFoundException | StudioConversation;

export type GetStudioTurnOutput = GenericException | ResourceNotFoundException | StudioTurn;

export type GetSupervisionData = {
  __typename?: 'GetSupervisionData';
  supervision: Supervision;
};

export type GetSupervisionOutput = GenericException | GetSupervisionData | ResourceNotFoundException;

export type GetTeamsFilterInput = {
  ID?: InputMaybe<GetTeamsSearchableIntInput>;
};

export type GetTeamsOutput = {
  __typename?: 'GetTeamsOutput';
  items?: Maybe<Array<Team>>;
  nextToken?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  previousToken?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GetTeamsSearchableIntInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
};

export type GetTemplateByIdResponse = {
  __typename?: 'GetTemplateByIdResponse';
  template: Template;
};

export type GetTemplateByIdResult = GenericException | GetTemplateByIdResponse;

export type GetTermsOutput = GenericException | GetTermsResult | ResourceNotFoundException;

export type GetTermsResult = {
  __typename?: 'GetTermsResult';
  acceptedAt: Scalars['AWSDateTime']['output'];
  acceptedBy: PhoneTeammateResolver;
};

export type GetTimezoneByPhoneNumberOutput = {
  __typename?: 'GetTimezoneByPhoneNumberOutput';
  timezone?: Maybe<Scalars['String']['output']>;
};

export type GetTopicsInput = {
  isEditable?: InputMaybe<Scalars['Boolean']['input']>;
  language: PlaybookLanguage;
};

export type GetTopicsOutput = GenericException | GetTopicsResult | UserInputException;

export type GetTopicsResult = {
  __typename?: 'GetTopicsResult';
  items: Array<Topic>;
};

export type GetTrackData = {
  __typename?: 'GetTrackData';
  track: Track;
};

export type GetTrackOutput = GenericException | GetTrackData | ResourceNotFoundException;

export type GetTrackUploadUrlInput = {
  name: Scalars['String']['input'];
  numberId: Scalars['ID']['input'];
};

export type GetTrackUploadUrlOutput = GenericException | ResourceNotFoundException | TrackUploadUrl | UserInputException;

export type GetTrackerBackfillStatusResult = GenericException | InsufficientLicenseException | TrackerBackfillStatus;

export type GetTrackersResult = GenericException | InsufficientLicenseException | PaginatedTrackers;

export type GetTrialWelcomeWizardOutput = GenericException | GetTrialWelcomeWizardResponse | UserInputException;

export type GetTrialWelcomeWizardResponse = {
  __typename?: 'GetTrialWelcomeWizardResponse';
  trialWelcomeWizard?: Maybe<TrialWelcomeWizard>;
};

export type GetTypedCallTimelineOutputV2 = {
  __typename?: 'GetTypedCallTimelineOutputV2';
  agentIds: Array<Scalars['Int']['output']>;
  callSid: Scalars['String']['output'];
  calleePhoneNumber: Scalars['String']['output'];
  callerPhoneNumber: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  events: Array<CallTimelineEvent>;
  lineIds: Array<Scalars['Int']['output']>;
  teamIds: Array<Scalars['Int']['output']>;
  voiceVirtualAgentIds: Array<Scalars['String']['output']>;
};

export type GoogleSignInEligibility = {
  __typename?: 'GoogleSignInEligibility';
  isEligible: Scalars['Boolean']['output'];
  reasons?: Maybe<Array<Scalars['String']['output']>>;
};

export type GradeApplicationOutput = GenericException | GradeMcpServerResult | ResourceNotFoundException | UnauthorizedException;

export type GradeMcpServerInput = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  mcpUrl: Scalars['String']['input'];
  signRequest?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GradeMcpServerOutput = GenericException | GradeMcpServerResult | UnauthorizedException | UserInputException;

export type GradeMcpServerResult = {
  __typename?: 'GradeMcpServerResult';
  grades: Array<ToolGrade>;
  serverUrl: Scalars['String']['output'];
  storedCatalogJson?: Maybe<Scalars['String']['output']>;
  summary: GradeSummary;
  toolCount: Scalars['Int']['output'];
};

export type GradeSummary = {
  __typename?: 'GradeSummary';
  fail: Scalars['Int']['output'];
  needsWork: Scalars['Int']['output'];
  pass: Scalars['Int']['output'];
};

export type GradeToolInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  examplesJson?: InputMaybe<Scalars['String']['input']>;
  inputSchemaJson?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GradeToolOutput = GenericException | ToolGrade;

export type GroupConversation = {
  __typename?: 'GroupConversation';
  ID: Scalars['ID']['output'];
  createdBy: GroupConversationAuthor;
  displayName?: Maybe<Scalars['String']['output']>;
  externalParticipants: Array<PhoneContactResolver>;
};

export type GroupConversationAuthor = PhoneContactResolver | PhoneTeammateResolver;

export type GroupConversationResolver = {
  __typename?: 'GroupConversationResolver';
  entity: GroupConversation;
  input: GroupConversationResolverInput;
};

export type GroupConversationResolverInput = {
  __typename?: 'GroupConversationResolverInput';
  ID: Scalars['ID']['output'];
  companyID: Scalars['String']['output'];
};

export type GroupCreatedEngagement = Engagement & {
  __typename?: 'GroupCreatedEngagement';
  ID: Scalars['ID']['output'];
  author: GroupConversationAuthor;
  createdAt: Scalars['AWSDateTime']['output'];
};

export type GroupMessageId = {
  __typename?: 'GroupMessageId';
  messageId: Scalars['ID']['output'];
};

export enum GroupMessageStatus {
  DELIVERED = 'DELIVERED',
  FAILED = 'FAILED',
  NOT_SENT = 'NOT_SENT',
  PARTIALLY_DELIVERED = 'PARTIALLY_DELIVERED',
  PARTIALLY_UNDELIVERED = 'PARTIALLY_UNDELIVERED',
  PENDING = 'PENDING',
  READ = 'READ',
  RECEIVED = 'RECEIVED',
  SENT = 'SENT',
  UNDELIVERED = 'UNDELIVERED',
  UNKNOWN = 'UNKNOWN'
}

export type GroupSmsMmsMessage = BaseMessage & {
  __typename?: 'GroupSmsMmsMessage';
  ID: Scalars['ID']['output'];
  agent?: Maybe<PhoneTeammateResolver>;
  agentId?: Maybe<Scalars['String']['output']>;
  channel: MessageChannel;
  createdAt: Scalars['AWSDateTime']['output'];
  deliveryReceipts: Array<DeliveryReceipt>;
  direction: BaseMessageDirection;
  externalConversationID: Scalars['ID']['output'];
  groupMessageStatus: GroupMessageStatus;
  hasUnsupportedContent: Scalars['Boolean']['output'];
  mediaDetails: Array<BaseMessageMediaDetails>;
  parent?: Maybe<MessageResolver>;
  status: BaseMessageStatus;
  text: Scalars['String']['output'];
  undeliveredReason?: Maybe<BaseMessageUndeliveredReason>;
};

export type HealthStatus = {
  __typename?: 'HealthStatus';
  canSendMessage?: Maybe<SendMessageStatus>;
  entities?: Maybe<Array<Maybe<PhoneNumberEntity>>>;
};

export type HubApplication = {
  __typename?: 'HubApplication';
  comingSoon: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

export type HubApplicationDescription = {
  __typename?: 'HubApplicationDescription';
  en?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
};

export type HubApplicationInstallData = {
  __typename?: 'HubApplicationInstallData';
  comingSoon: Scalars['Boolean']['output'];
  deleted: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  descriptions?: Maybe<HubApplicationDescription>;
  id: Scalars['Int']['output'];
  installUri?: Maybe<Scalars['String']['output']>;
  learnMoreUri?: Maybe<Scalars['String']['output']>;
  logo: Scalars['String']['output'];
  name: Scalars['String']['output'];
  source: Scalars['String']['output'];
  subtitle: Scalars['String']['output'];
  traySolutionId: Scalars['String']['output'];
};

export type HubApplicationNotFoundException = Exception & {
  __typename?: 'HubApplicationNotFoundException';
  code: Scalars['String']['output'];
  hubApplicationId: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type HubIntegrationInstallInformation = {
  __typename?: 'HubIntegrationInstallInformation';
  comingSoon: Scalars['Boolean']['output'];
  deleted: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  installUri: Scalars['String']['output'];
  learnMoreUri: Scalars['String']['output'];
  logo: Scalars['String']['output'];
  name: Scalars['String']['output'];
  source: Scalars['String']['output'];
  subtitle: Scalars['String']['output'];
  traySolutionId: Scalars['String']['output'];
};

export type HubSpotConnectSmsNumbersInput = {
  accountName: Scalars['String']['input'];
  accountToken: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  deliveryIdentifier: Scalars['String']['input'];
  integrationId: Scalars['Int']['input'];
  numberId: Scalars['Int']['input'];
};

export type HubSpotConnectSmsNumbersOutput = {
  __typename?: 'HubSpotConnectSmsNumbersOutput';
  message: Scalars['String']['output'];
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type HubSpotHelpDeskConnectedLinesInput = {
  integrationId: Scalars['Int']['input'];
};

export type HubspotCallDataOutput = {
  __typename?: 'HubspotCallDataOutput';
  action: Scalars['String']['output'];
  data: Scalars['String']['output'];
};

export type HubspotCallDisposition = {
  __typename?: 'HubspotCallDisposition';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type HubspotCallOptionsOutput = {
  __typename?: 'HubspotCallOptionsOutput';
  callTypes: Array<HubspotCallType>;
  dispositions: Array<HubspotCallDisposition>;
};

export type HubspotCallPropertiesOutput = {
  __typename?: 'HubspotCallPropertiesOutput';
  agentOverrideActivityType?: Maybe<Scalars['String']['output']>;
  agentOverrideDisposition?: Maybe<Scalars['String']['output']>;
};

export type HubspotCallType = {
  __typename?: 'HubspotCallType';
  name: Scalars['String']['output'];
};

export type HubspotEngagementAssociationChange = {
  newObjectId?: InputMaybe<Scalars['String']['input']>;
  objectType: HubspotEngagementAssociationObjectType;
  previousObjectId?: InputMaybe<Scalars['String']['input']>;
};

export enum HubspotEngagementAssociationObjectType {
  COMPANY = 'COMPANY',
  CONTACT = 'CONTACT',
  DEAL = 'DEAL',
  TICKET = 'TICKET'
}

export type HubspotEngagementAssociationResult = {
  __typename?: 'HubspotEngagementAssociationResult';
  associatedObjectId: Scalars['String']['output'];
  objectType: HubspotEngagementAssociationObjectType;
  success: Scalars['Boolean']['output'];
};

export type HubspotIntegrationSmsLine = {
  __typename?: 'HubspotIntegrationSmsLine';
  id: Scalars['String']['output'];
  integrationId: Scalars['Int']['output'];
  isCallingChannelEnabled?: Maybe<Scalars['String']['output']>;
  isSmsChannelEnabled?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  numberId: Scalars['Int']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type HubspotIntegrationSmsLineInput = {
  portalId: Scalars['String']['input'];
};

export type HubspotSearchCompany = {
  __typename?: 'HubspotSearchCompany';
  contactIds: Array<Scalars['String']['output']>;
  dealIds: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  ticketIds: Array<Scalars['String']['output']>;
};

export type HubspotSearchContact = {
  __typename?: 'HubspotSearchContact';
  companyIds: Array<Scalars['String']['output']>;
  dealIds: Array<Scalars['String']['output']>;
  deals: Array<HubspotSearchDeal>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  ticketIds: Array<Scalars['String']['output']>;
  tickets: Array<HubspotSearchTicket>;
};

export type HubspotSearchDeal = {
  __typename?: 'HubspotSearchDeal';
  amount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
};

export type HubspotSearchTicket = {
  __typename?: 'HubspotSearchTicket';
  id: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type HubspotSequence = {
  __typename?: 'HubspotSequence';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type HubspotSequencesEligibilityOutput = {
  __typename?: 'HubspotSequencesEligibilityOutput';
  hasAutomationScope: Scalars['Boolean']['output'];
};

export type HubspotSequencesOutput = {
  __typename?: 'HubspotSequencesOutput';
  sequences: Array<HubspotSequence>;
};

export type IdFilter = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type IdentityOutput = {
  __typename?: 'IdentityOutput';
  companyId?: Maybe<Scalars['String']['output']>;
  identityType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rejectionReasons?: Maybe<Scalars['String']['output']>;
  verificationStatus?: Maybe<Scalars['String']['output']>;
};

export enum IdentityType {
  business = 'business',
  individual = 'individual'
}

export type ImportVirtualAgentInput = {
  agentData: Scalars['String']['input'];
};

export enum InboxUpdatedReason {
  CALL_INBOUND = 'CALL_INBOUND',
  CALL_INBOUND_MISSED = 'CALL_INBOUND_MISSED',
  CALL_INBOUND_UPDATED = 'CALL_INBOUND_UPDATED',
  CALL_OUTBOUND = 'CALL_OUTBOUND',
  CALL_OUTBOUND_UPDATED = 'CALL_OUTBOUND_UPDATED',
  MESSAGE_RECEIVED = 'MESSAGE_RECEIVED',
  MESSAGE_SENT = 'MESSAGE_SENT',
  MESSAGE_STATUS_CHANGED = 'MESSAGE_STATUS_CHANGED',
  WHATSAPP_RECEIVED = 'WHATSAPP_RECEIVED',
  WHATSAPP_SENT = 'WHATSAPP_SENT',
  WHATSAPP_STATUS_CHANGED = 'WHATSAPP_STATUS_CHANGED'
}

export type IncomingCallAssignedToAgentEvent = IncomingCallEvent & {
  __typename?: 'IncomingCallAssignedToAgentEvent';
  agentId: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  lineId: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
};

export type IncomingCallCallbackRequestedEvent = IncomingCallEvent & {
  __typename?: 'IncomingCallCallbackRequestedEvent';
  kind: Scalars['String']['output'];
  lineId: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
};

export type IncomingCallCallerHungUpEvent = IncomingCallEvent & {
  __typename?: 'IncomingCallCallerHungUpEvent';
  kind: Scalars['String']['output'];
  lineId: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
};

export type IncomingCallEndedEvent = IncomingCallEvent & {
  __typename?: 'IncomingCallEndedEvent';
  kind: Scalars['String']['output'];
  lineId: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
};

export type IncomingCallEvent = {
  kind: Scalars['String']['output'];
  lineId: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
};

export type IncomingCallExtensionDialedEvent = IncomingCallEvent & {
  __typename?: 'IncomingCallExtensionDialedEvent';
  agentId: Scalars['ID']['output'];
  extensionCode: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  lineId: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
};

export type IncomingCallIvrBranchSelectedEvent = IncomingCallEvent & {
  __typename?: 'IncomingCallIVRBranchSelectedEvent';
  branchName: Scalars['String']['output'];
  digits: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  lineId: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
  stepId: Scalars['String']['output'];
  stepTitle: Scalars['String']['output'];
};

export type IncomingCallInputIvrUserInputEvent = IncomingCallEvent & {
  __typename?: 'IncomingCallInputIVRUserInputEvent';
  branchName: Scalars['String']['output'];
  digits: Scalars['String']['output'];
  isSensitive: Scalars['Boolean']['output'];
  isValid: Scalars['Boolean']['output'];
  kind: Scalars['String']['output'];
  lineId: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
  stepEndedAt: Scalars['String']['output'];
  stepId: Scalars['String']['output'];
  stepStartedAt: Scalars['String']['output'];
  stepTitle: Scalars['String']['output'];
};

export type IncomingCallMissedEvent = IncomingCallEvent & {
  __typename?: 'IncomingCallMissedEvent';
  kind: Scalars['String']['output'];
  lineId: Scalars['ID']['output'];
  missedReason: Scalars['String']['output'];
  missedReasonV2?: Maybe<Scalars['String']['output']>;
  occurredAt: Scalars['String']['output'];
};

export type IncomingCallRedirectedToExternalPhoneNumberEvent = IncomingCallEvent & {
  __typename?: 'IncomingCallRedirectedToExternalPhoneNumberEvent';
  kind: Scalars['String']['output'];
  lineId: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
  redirectedToPhoneNumber: Scalars['String']['output'];
};

export type IncomingCallRedirectedToInternalLineEvent = IncomingCallEvent & {
  __typename?: 'IncomingCallRedirectedToInternalLineEvent';
  kind: Scalars['String']['output'];
  lineId: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
  redirectedFromLineId: Scalars['ID']['output'];
  redirectedToLineId: Scalars['ID']['output'];
};

export type IncomingCallRungToAgentEndedEvent = IncomingCallEvent & {
  __typename?: 'IncomingCallRungToAgentEndedEvent';
  kind: Scalars['String']['output'];
  lineId: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
  parentEnqueueTargetId: Scalars['String']['output'];
  parentRingToAgentId: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  target: EnqueuedAgentTarget;
};

export type IncomingCallRungToAgentEvent = IncomingCallEvent & {
  __typename?: 'IncomingCallRungToAgentEvent';
  kind: Scalars['String']['output'];
  lineId: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
  parentEnqueueTargetId: Scalars['String']['output'];
  parentRingToAgentId: Scalars['String']['output'];
  target: EnqueuedAgentTarget;
};

export type IncomingCallRungToDeviceEndedEvent = IncomingCallEvent & {
  __typename?: 'IncomingCallRungToDeviceEndedEvent';
  deviceId: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  lineId: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
  parentEnqueueTargetId: Scalars['String']['output'];
  parentRingToAgentId: Scalars['String']['output'];
  parentRingToDeviceId: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type IncomingCallRungToDeviceEvent = IncomingCallEvent & {
  __typename?: 'IncomingCallRungToDeviceEvent';
  deviceId: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  lineId: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
  parentEnqueueTargetId: Scalars['String']['output'];
  parentRingToAgentId: Scalars['String']['output'];
  parentRingToDeviceId: Scalars['String']['output'];
};

export type IncomingCallStartedEvent = IncomingCallEvent & {
  __typename?: 'IncomingCallStartedEvent';
  bringYourOwnCarrier: Scalars['Boolean']['output'];
  kind: Scalars['String']['output'];
  lineId: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
};

export type IncomingCallTargetEnqueuedEndedEvent = IncomingCallEvent & {
  __typename?: 'IncomingCallTargetEnqueuedEndedEvent';
  kind: Scalars['String']['output'];
  lineId: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
  parentEnqueueTargetId: Scalars['String']['output'];
  queueingTimeout: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
};

export type IncomingCallTargetEnqueuedEvent = IncomingCallEvent & {
  __typename?: 'IncomingCallTargetEnqueuedEvent';
  enqueuedTarget: EnqueuedTarget;
  kind: Scalars['String']['output'];
  lineId: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
  parentEnqueueTargetId: Scalars['String']['output'];
  queueingTimeout: Scalars['Int']['output'];
};

export type IncomingCallVoicemailReadyEvent = IncomingCallEvent & {
  __typename?: 'IncomingCallVoicemailReadyEvent';
  duration: Scalars['Int']['output'];
  kind: Scalars['String']['output'];
  lineId: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type IncomingCallVoicemailRecordedEvent = IncomingCallEvent & {
  __typename?: 'IncomingCallVoicemailRecordedEvent';
  kind: Scalars['String']['output'];
  lineId: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
};

export enum Industry {
  AUTOMOTIVE = 'AUTOMOTIVE',
  BUSINESS_SERVICES = 'BUSINESS_SERVICES',
  DELIVERY_SHIPPING = 'DELIVERY_SHIPPING',
  EDUCATION = 'EDUCATION',
  FINANCIAL = 'FINANCIAL',
  GOVERNMENT = 'GOVERNMENT',
  HEALTH_CARE = 'HEALTH_CARE',
  HOSPITALITY_ENTERTAINMENT = 'HOSPITALITY_ENTERTAINMENT',
  INSURANCE = 'INSURANCE',
  LEGAL = 'LEGAL',
  MANUFACTURING = 'MANUFACTURING',
  NON_PROFIT = 'NON_PROFIT',
  OTHER_BUSINESSES = 'OTHER_BUSINESSES',
  PERSONAL_SERVICES = 'PERSONAL_SERVICES',
  PUBLIC_SERVICE = 'PUBLIC_SERVICE',
  REAL_ESTATE = 'REAL_ESTATE',
  RELIGIOUS = 'RELIGIOUS',
  RESTAURANT_FOOD_SERVICES = 'RESTAURANT_FOOD_SERVICES',
  RETAIL = 'RETAIL',
  TECHNOLOGY = 'TECHNOLOGY',
  TELECOMMUNICATIONS = 'TELECOMMUNICATIONS',
  TRADE_CONTRACTORS = 'TRADE_CONTRACTORS',
  TRAVEL = 'TRAVEL',
  UTILITIES = 'UTILITIES',
  VETERINARY_SERVICES = 'VETERINARY_SERVICES'
}

export type InitialMessage = {
  __typename?: 'InitialMessage';
  content: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

export type InsightCard = {
  __typename?: 'InsightCard';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type: InsightCardType;
  userId?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<InsightCardUserValue>;
};

export type InsightCardGroup = {
  __typename?: 'InsightCardGroup';
  appIcon?: Maybe<AppIcon>;
  appId?: Maybe<Scalars['String']['output']>;
  appName?: Maybe<Scalars['String']['output']>;
  items: Array<InsightCard>;
  title?: Maybe<InsightCardTitle>;
};

export type InsightCardTitle = {
  __typename?: 'InsightCardTitle';
  link?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum InsightCardType {
  shortText = 'shortText',
  title = 'title',
  user = 'user'
}

export type InsightCardUserValue = {
  __typename?: 'InsightCardUserValue';
  contactId?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isAvailable?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
};

export type InsightsDataQuality = {
  __typename?: 'InsightsDataQuality';
  evaluatedCount: Scalars['Int']['output'];
  nullEscalatedCount: Scalars['Int']['output'];
  sampleSize: Scalars['Int']['output'];
  totalCallsHandled: Scalars['Int']['output'];
};

export type InsightsDelta = {
  __typename?: 'InsightsDelta';
  autonomousResolutionRate: Scalars['Float']['output'];
  escalationRate: Scalars['Float']['output'];
  goalCompletionRate: Scalars['Float']['output'];
};

export type InsightsFunnel = {
  __typename?: 'InsightsFunnel';
  aiAgentOnly: Scalars['Int']['output'];
  automatedResolved: Scalars['Int']['output'];
  escalatedToHuman: Scalars['Int']['output'];
  totalCalls: Scalars['Int']['output'];
  unresolved: Scalars['Int']['output'];
};

export enum InsightsJobStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING'
}

export type InsightsMetrics = {
  __typename?: 'InsightsMetrics';
  autonomousResolutionCount: Scalars['Int']['output'];
  autonomousResolutionRate: Scalars['Float']['output'];
  escalatedCount: Scalars['Int']['output'];
  escalationRate: Scalars['Float']['output'];
  goalCompletionCount: Scalars['Int']['output'];
  goalCompletionRate: Scalars['Float']['output'];
  n: Scalars['Int']['output'];
};

export type InstallApplication = {
  __typename?: 'InstallApplication';
  animation?: Maybe<Scalars['String']['output']>;
  displayTestButton?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  integrationId?: Maybe<Scalars['Int']['output']>;
  learnMoreUri?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type InstallCustomAiAppOutput = {
  __typename?: 'InstallCustomAiAppOutput';
  installUri: Scalars['String']['output'];
};

export type InstallRedirect = {
  __typename?: 'InstallRedirect';
  redirectUrl: Scalars['String']['output'];
};

export type InsufficientLicenseException = Exception & {
  __typename?: 'InsufficientLicenseException';
  code: Scalars['String']['output'];
  licenseName: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type InsufficientPermissionException = Exception & {
  __typename?: 'InsufficientPermissionException';
  access: PermissionAccess;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  resource: Scalars['String']['output'];
};

export enum IntakePresetType {
  EMAIL = 'EMAIL',
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME'
}

export type Integration = {
  __typename?: 'Integration';
  active: Scalars['Boolean']['output'];
  application?: Maybe<Application>;
  applicationId?: Maybe<Scalars['ID']['output']>;
  customName?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo: Scalars['String']['output'];
  migrationMetadata?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nameUnderscored?: Maybe<Scalars['String']['output']>;
  numberIds?: Maybe<Array<Scalars['Int']['output']>>;
  numbersConnected?: Maybe<Scalars['Int']['output']>;
  serviceName: Scalars['String']['output'];
};

export type IntegrationAllConnectedLines = {
  __typename?: 'IntegrationAllConnectedLines';
  connectedLines?: Maybe<Array<Scalars['Int']['output']>>;
  id: Scalars['ID']['output'];
  integrationType: IntegrationType;
};

export type IntegrationConnectedLines = {
  __typename?: 'IntegrationConnectedLines';
  connectedLines: Array<Line>;
  id: Scalars['ID']['output'];
  integrationType: IntegrationType;
  pagination: IntegrationConnectedLinesPagination;
};

export type IntegrationConnectedLinesPagination = {
  __typename?: 'IntegrationConnectedLinesPagination';
  limit?: Maybe<Scalars['Int']['output']>;
  page: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type IntegrationInstallUri = {
  __typename?: 'IntegrationInstallUri';
  current?: Maybe<IntegrationInstallUriCurrent>;
};

export type IntegrationInstallUriCurrent = {
  __typename?: 'IntegrationInstallUriCurrent';
  installUri: Scalars['String']['output'];
};

export type IntegrationSettings = {
  __typename?: 'IntegrationSettings';
  aivaStatus?: Maybe<Scalars['String']['output']>;
  banner?: Maybe<Banner>;
  hideConnectedNumbers?: Maybe<Scalars['Boolean']['output']>;
  isAivaEnabled?: Maybe<Scalars['Boolean']['output']>;
  localesNamespace?: Maybe<Scalars['String']['output']>;
  providerMetadata?: Maybe<ProviderMetadata>;
  scopes?: Maybe<Scalars['String']['output']>;
  sections: Array<Section>;
};

export type IntegrationSettingsCustomFields = {
  __typename?: 'IntegrationSettingsCustomFields';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  values: Array<Maybe<CustomFieldsValues>>;
};

export type IntegrationSettingsCustomOutcomeEntity = {
  __typename?: 'IntegrationSettingsCustomOutcomeEntity';
  fields?: Maybe<Array<Maybe<IntegrationSettingsCustomOutcomeFieldsEntity>>>;
  key?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<IntegrationSettingsCustomOutcomeValueEntity>>>;
};

export type IntegrationSettingsCustomOutcomeFieldsEntity = {
  __typename?: 'IntegrationSettingsCustomOutcomeFieldsEntity';
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<CustomOutcomeTagsOutcomeValues>>>;
};

export type IntegrationSettingsCustomOutcomeValueEntity = {
  __typename?: 'IntegrationSettingsCustomOutcomeValueEntity';
  columnId?: Maybe<Scalars['String']['output']>;
  columnName?: Maybe<Scalars['String']['output']>;
  columnValue?: Maybe<Scalars['String']['output']>;
  outcomeId?: Maybe<Scalars['String']['output']>;
  tagId?: Maybe<Scalars['Int']['output']>;
  tagName?: Maybe<Scalars['String']['output']>;
};

export type IntegrationSettingsCustomValues = {
  __typename?: 'IntegrationSettingsCustomValues';
  outcomeIds?: Maybe<Scalars['String']['output']>;
  ruleType?: Maybe<Scalars['String']['output']>;
};

export enum IntegrationType {
  BRIDGE = 'BRIDGE',
  HUB = 'HUB'
}

export type IntentEvidence = {
  __typename?: 'IntentEvidence';
  callCount: Scalars['Int']['output'];
  confidence: Scalars['Float']['output'];
  displayQuestion: Scalars['String']['output'];
  name: Scalars['String']['output'];
  samplePhrases: Array<Scalars['String']['output']>;
};

export type InvalidEnumException = Exception & {
  __typename?: 'InvalidEnumException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  options: Array<Scalars['String']['output']>;
  path: Scalars['String']['output'];
};

export type InvalidFlowDefinitionException = Exception & {
  __typename?: 'InvalidFlowDefinitionException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type InvalidPropertyMappingException = Exception & {
  __typename?: 'InvalidPropertyMappingException';
  code: Scalars['String']['output'];
  invalidProperties: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvalidScoreCardName = Exception & {
  __typename?: 'InvalidScoreCardName';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type InvalidSessionStateException = Exception & {
  __typename?: 'InvalidSessionStateException';
  code: Scalars['String']['output'];
  currentStatus: Scalars['String']['output'];
  message: Scalars['String']['output'];
  registrationSessionId: Scalars['ID']['output'];
  requiredStatus: Scalars['String']['output'];
};

export type InvalidStringException = Exception & {
  __typename?: 'InvalidStringException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  path: Scalars['String']['output'];
  validation: Scalars['String']['output'];
};

export type InvalidTrackerName = Exception & {
  __typename?: 'InvalidTrackerName';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type InvalidTypeException = Exception & {
  __typename?: 'InvalidTypeException';
  code: Scalars['String']['output'];
  expected: Scalars['String']['output'];
  message: Scalars['String']['output'];
  path: Scalars['String']['output'];
  received: Scalars['String']['output'];
};

export type InvalidateAppSyncCacheInput = {
  fieldName: Scalars['String']['input'];
  keyValuePair: Scalars['String']['input'];
  typeName: Scalars['String']['input'];
};

export type InvalidateAppSyncCacheOutput = {
  __typename?: 'InvalidateAppSyncCacheOutput';
  success: Scalars['Boolean']['output'];
};

export type InviteUserInput = {
  authorizedEntities?: InputMaybe<Array<AuthorizedEntityInput>>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  roles?: InputMaybe<Array<RoleInput>>;
};

export type Invoice = {
  __typename?: 'Invoice';
  createdDate?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  duedate?: Maybe<Scalars['String']['output']>;
  grossAmount?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  netAmount?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  taxAmount?: Maybe<Scalars['String']['output']>;
  trandate?: Maybe<Scalars['String']['output']>;
  type: TransactionType;
};

export type Invoices = {
  __typename?: 'Invoices';
  billingType: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  hasDocument: Scalars['Boolean']['output'];
  hasExtraMinDetails: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  locked: Scalars['Boolean']['output'];
  meta: Meta;
  netsuiteInvoiceId?: Maybe<Scalars['Int']['output']>;
  periodEnd: Scalars['String']['output'];
  periodStart: Scalars['String']['output'];
  plan: Scalars['String']['output'];
  subscriptionId: Scalars['Int']['output'];
  taxRate: Scalars['Int']['output'];
  totalTaxExcl: Scalars['Int']['output'];
  totalTaxIncl: Scalars['Int']['output'];
};

export enum ItemValidationValue {
  NO = 'NO',
  YES = 'YES'
}

export type IvrSetting = {
  __typename?: 'IvrSetting';
  id: Scalars['Int']['output'];
  key?: Maybe<Scalars['String']['output']>;
  numberId: Scalars['Int']['output'];
  redirectingExternalNumber: Scalars['String']['output'];
  redirectingNumberId?: Maybe<Scalars['Int']['output']>;
  rootId?: Maybe<Scalars['Int']['output']>;
};

export type IvrSettingInput = {
  ivrSetting?: InputMaybe<IvrSettingInputFields>;
};

export type IvrSettingInputFields = {
  key: Scalars['String']['input'];
  redirectingExternalNumber: Scalars['String']['input'];
  redirectingNumberId?: InputMaybe<Scalars['String']['input']>;
};

export type IvrSettingResponse = {
  __typename?: 'IvrSettingResponse';
  id: Scalars['Int']['output'];
  key?: Maybe<Scalars['String']['output']>;
  numberId: Scalars['Int']['output'];
  redirectingExternalNumber: Scalars['String']['output'];
  redirectingNumberId?: Maybe<Scalars['Int']['output']>;
};

export type IvrSettingRest = {
  __typename?: 'IvrSettingRest';
  branchType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  redirectingExternalNumber?: Maybe<Scalars['String']['output']>;
  redirectingNumber?: Maybe<Number>;
};

export type IvrSettingsOutput = {
  __typename?: 'IvrSettingsOutput';
  ivrSettings: Array<IvrSetting>;
};

export type KbContradictionReport = {
  __typename?: 'KBContradictionReport';
  analyzed_at?: Maybe<Scalars['AWSDateTime']['output']>;
  analyzed_document_count: Scalars['Int']['output'];
  contradiction_count: Scalars['Int']['output'];
  has_contradictions: Scalars['Boolean']['output'];
  kb_id: Scalars['ID']['output'];
  report?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type KbContradictionReportResult = GenericException | KbContradictionReport;

export type KbDetailsOutput = GenericException | KbDetailsResponse;

export type KbDetailsResponse = {
  __typename?: 'KBDetailsResponse';
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  customerRegion: Scalars['String']['output'];
  docCount: Scalars['Int']['output'];
  documents: Array<DocSummary>;
  embeddingModel: Scalars['String']['output'];
  kbId: Scalars['Int']['output'];
  language: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pineconeIndex: Scalars['String']['output'];
  pineconeNamespace: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type KbDocumentsOutput = GenericException | KbDocumentsResponse;

export type KbDocumentsResponse = {
  __typename?: 'KBDocumentsResponse';
  documents: Array<CrawlDocument>;
};

export type KbDocumentsUsageResponse = {
  __typename?: 'KBDocumentsUsageResponse';
  documents: Array<DocumentUsageItem>;
  kb_id: Scalars['ID']['output'];
  max_clean_chars: Scalars['Int']['output'];
};

export type KbDocumentsUsageResult = GenericException | KbDocumentsUsageResponse;

export type KbMetrics = {
  __typename?: 'KBMetrics';
  createdAt: Scalars['String']['output'];
  documentCount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  kbMappingId: Scalars['Int']['output'];
  lastUpdatedAt: Scalars['String']['output'];
  totalSizeBytes?: Maybe<Scalars['Int']['output']>;
  totalTokens: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export type KbMetricsOutput = GenericException | KbMetrics;

export type KbRawText = {
  __typename?: 'KBRawText';
  char_count: Scalars['Int']['output'];
  kb_id: Scalars['ID']['output'];
  raw_text: Scalars['String']['output'];
};

export type KbRawTextResult = GenericException | KbRawText;

export type KbSummary = {
  __typename?: 'KBSummary';
  char_count: Scalars['Int']['output'];
  kb_id: Scalars['ID']['output'];
  summary: Scalars['String']['output'];
};

export type KbSummaryResult = GenericException | KbSummary;

export type Keyword = {
  __typename?: 'Keyword';
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  languages: Array<Scalars['String']['output']>;
  pronunciationHint?: Maybe<Scalars['String']['output']>;
  term: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  vocabulary: Vocabulary;
};

export type KeywordTrackerFilter = {
  __typename?: 'KeywordTrackerFilter';
  agents?: Maybe<Array<AgentTracker>>;
  direction?: Maybe<CallDirection>;
  excludeQueryTerms?: Maybe<Array<Scalars['String']['output']>>;
  lines?: Maybe<Array<LineTracker>>;
  queryTerms?: Maybe<Array<Scalars['String']['output']>>;
  speakerType?: Maybe<SpeakerTrackerType>;
};

export type Keywords = {
  __typename?: 'Keywords';
  items: Array<Maybe<Keyword>>;
};

export type KnowledgeBase = {
  __typename?: 'KnowledgeBase';
  client_type?: Maybe<Scalars['String']['output']>;
  company_id: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['AWSDateTime']['output'];
  customerRegion: Scalars['String']['output'];
  doc_count: Scalars['Int']['output'];
  kbId?: Maybe<Scalars['Int']['output']>;
  kbName: Scalars['String']['output'];
  kb_id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  summary_status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type KnowledgeBaseCreateInput = {
  name: Scalars['String']['input'];
};

export type KnowledgeBaseDetails = {
  __typename?: 'KnowledgeBaseDetails';
  company_id: Scalars['String']['output'];
  created_at: Scalars['AWSDateTime']['output'];
  customer_region: Scalars['String']['output'];
  doc_count: Scalars['Int']['output'];
  documents: Array<DocumentSummary>;
  embedding_model: Scalars['String']['output'];
  kb_id: Scalars['ID']['output'];
  language: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pinecone_index: Scalars['String']['output'];
  pinecone_namespace: Scalars['String']['output'];
  status: Scalars['String']['output'];
  summary_status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type KnowledgeBaseDetailsResult = GenericException | KnowledgeBaseDetails;

export type KnowledgeBaseListResponse = {
  __typename?: 'KnowledgeBaseListResponse';
  knowledgeBases: Array<KnowledgeBase>;
};

export type KnowledgeBaseMapping = {
  __typename?: 'KnowledgeBaseMapping';
  companyId: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  customerRegion: Scalars['String']['output'];
  documentCount: Scalars['Int']['output'];
  embeddingModel: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kbId: Scalars['ID']['output'];
  kbName: Scalars['String']['output'];
  language: Scalars['String']['output'];
  pineconeIndex: Scalars['String']['output'];
  pineconeNamespace: Scalars['String']['output'];
  status: Scalars['String']['output'];
  summary_status?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type KnowledgeBaseOutput = GenericException | KnowledgeBase | UserInputException;

export type KnowledgeBasePageInfo = {
  __typename?: 'KnowledgeBasePageInfo';
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type KnowledgeBaseResult = GenericException | KnowledgeBase;

export type KnowledgeBasesResult = GenericException | KnowledgeBaseListResponse;

export type KnowledgeChunk = {
  __typename?: 'KnowledgeChunk';
  content: Scalars['String']['output'];
  id: Scalars['String']['output'];
  metadata?: Maybe<Scalars['String']['output']>;
  score: Scalars['Float']['output'];
};

export type KnowledgeClientInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  type: ClientType;
};

export type KnowledgeDocument = {
  __typename?: 'KnowledgeDocument';
  agentId?: Maybe<Scalars['String']['output']>;
  clientType: ClientType;
  crawlDepth?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  docId: Scalars['ID']['output'];
  kbId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type KnowledgeGapSuggestion = {
  __typename?: 'KnowledgeGapSuggestion';
  callsAffected: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  suggestionId: Scalars['String']['output'];
  topic: Scalars['String']['output'];
  unresolvedQuestions: Array<UnresolvedQuestion>;
};

export type KnowledgeRequestInput = {
  k?: InputMaybe<Scalars['Int']['input']>;
  kbId: Scalars['String']['input'];
  query: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
};

export type KnowledgeResponse = {
  __typename?: 'KnowledgeResponse';
  chunks: Array<KnowledgeChunk>;
  kbId: Scalars['String']['output'];
  query: Scalars['String']['output'];
  reranked: Scalars['Boolean']['output'];
  totalFound: Scalars['Int']['output'];
};

export type KnowledgeResponseOutput = GenericException | KnowledgeResponse;

export type KnowledgeSource = {
  __typename?: 'KnowledgeSource';
  agent_id?: Maybe<Scalars['String']['output']>;
  character_count?: Maybe<Scalars['Int']['output']>;
  child_page_count?: Maybe<Scalars['Int']['output']>;
  client_type?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['AWSDateTime']['output'];
  has_error: Scalars['Boolean']['output'];
  is_crawl_root: Scalars['Boolean']['output'];
  kb_id: Scalars['ID']['output'];
  kb_name: Scalars['String']['output'];
  messaging_ai_agent?: Maybe<MessagingAiAgentResolver>;
  name?: Maybe<Scalars['String']['output']>;
  source_id: Scalars['ID']['output'];
  source_type?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updated_at: Scalars['AWSDateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  virtual_agent?: Maybe<VirtualAgentResolver>;
};

export type KnowledgeSourcesResponse = {
  __typename?: 'KnowledgeSourcesResponse';
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  sources: Array<KnowledgeSource>;
  total: Scalars['Int']['output'];
};

export type KnowledgeSourcesResult = GenericException | KnowledgeSourcesResponse;

export type KnowledgeStatsOutput = GenericException | KnowledgeStatsResponse;

export type KnowledgeStatsResponse = {
  __typename?: 'KnowledgeStatsResponse';
  stats: Scalars['String']['output'];
};

export type KycError = {
  __typename?: 'KycError';
  code?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type KycVerificationSessionData = {
  __typename?: 'KycVerificationSessionData';
  clientSecret?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['ID']['output'];
  sessionId: Scalars['String']['output'];
};

export type KycVerificationSessionInput = {
  companyId: Scalars['ID']['input'];
  selfieConsentProvided?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};

export type KycVerificationSessionOutput = {
  __typename?: 'KycVerificationSessionOutput';
  data?: Maybe<KycVerificationSessionData>;
  error?: Maybe<Error>;
};

export enum LlmModel {
  BEDROCK_GPT_5_4 = 'BEDROCK_GPT_5_4',
  BEDROCK_GPT_5_6_LUNA = 'BEDROCK_GPT_5_6_LUNA',
  BEDROCK_GPT_5_6_TERRA = 'BEDROCK_GPT_5_6_TERRA',
  GPT_4_MINI = 'GPT_4_MINI',
  GPT_5_1 = 'GPT_5_1',
  GPT_5_4 = 'GPT_5_4',
  GPT_5_4_MINI = 'GPT_5_4_MINI',
  GPT_5_5 = 'GPT_5_5',
  GPT_5_6_LUNA = 'GPT_5_6_LUNA',
  GPT_5_6_TERRA = 'GPT_5_6_TERRA'
}

export enum LlmProvider {
  AZURE = 'AZURE',
  BEDROCK_MANTLE = 'BEDROCK_MANTLE',
  OPENAI = 'OPENAI'
}

export type LlmUnavailableException = Exception & {
  __typename?: 'LLMUnavailableException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  openUntil?: Maybe<Scalars['String']['output']>;
};

export type LanguageSettings = {
  __typename?: 'LanguageSettings';
  defaultLanguage: Scalars['String']['output'];
  languageCode: Scalars['String']['output'];
  supportedLanguages: Array<Maybe<Scalars['String']['output']>>;
};

export type LastEngagement = CallEngagement | MessageEngagement;

export type LastEngagementResolver = {
  __typename?: 'LastEngagementResolver';
  entity?: Maybe<LastEngagement>;
};

export type LastEngagementResolverInput = {
  __typename?: 'LastEngagementResolverInput';
  companyID: Scalars['ID']['output'];
  conversationID: Scalars['ID']['output'];
  timestamp?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type LastMessage = {
  __typename?: 'LastMessage';
  ID: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  direction: MessageDirection;
  hasUnsupportedContent?: Maybe<Scalars['Boolean']['output']>;
  mediaDetails?: Maybe<Array<MediaDetails>>;
  status: MessageStatus;
  text: Scalars['String']['output'];
};

export type LaunchOutboundCampaignOutput = GenericException | OutboundCampaign | OutboundCampaignNotReadyException | ResourceNotFoundException;

export type LegacyDispatchGroupInput = {
  id: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type LicenseStats = {
  __typename?: 'LicenseStats';
  accessLevel: Scalars['String']['output'];
  assignedLicenses: Scalars['Int']['output'];
  availableLicenses: Scalars['Int']['output'];
  includedInPlan?: Maybe<Scalars['Boolean']['output']>;
  totalLicenses: Scalars['Int']['output'];
};

export type LicenseUserInput = {
  userId: Scalars['String']['input'];
};

export enum LimitTypeError {
  day = 'day',
  hour = 'hour',
  month = 'month'
}

export type LimitsConfig = {
  __typename?: 'LimitsConfig';
  raiseIntakeQuestionsCap?: Maybe<Scalars['Boolean']['output']>;
  raiseTransferBranchesCap?: Maybe<Scalars['Boolean']['output']>;
};

export type LimitsConfigInput = {
  raiseIntakeQuestionsCap?: InputMaybe<Scalars['Boolean']['input']>;
  raiseTransferBranchesCap?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Line = {
  __typename?: 'Line';
  ID: Scalars['ID']['output'];
  activationState?: Maybe<Scalars['String']['output']>;
  agentsCounter?: Maybe<Scalars['Int']['output']>;
  allowInboundRecordingActions?: Maybe<Scalars['Boolean']['output']>;
  allowOutboundRecordingActions?: Maybe<Scalars['Boolean']['output']>;
  allowRealtimeTranscription?: Maybe<Scalars['Boolean']['output']>;
  brandedCallingStatus?: Maybe<LineBrandedCallingStatus>;
  businessHours?: Maybe<BusinessHours>;
  capabilities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  companyID: Scalars['ID']['output'];
  companyId?: Maybe<Scalars['String']['output']>;
  countryISOCode: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  dispatchGroups?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
  esim?: Maybe<LineEsim>;
  flowEditorEnabled?: Maybe<Scalars['Boolean']['output']>;
  groupMessagingEnabled?: Maybe<Scalars['Boolean']['output']>;
  groupMmsConfiguration?: Maybe<MmsConfiguration>;
  id?: Maybe<Scalars['String']['output']>;
  inboundRecordingActivated?: Maybe<Scalars['Boolean']['output']>;
  isDirectLine?: Maybe<Scalars['Boolean']['output']>;
  isIVR: Scalars['Boolean']['output'];
  isOpen?: Maybe<Scalars['Boolean']['output']>;
  ivr?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  liveRecordingActivated?: Maybe<Scalars['Boolean']['output']>;
  mandatoryTaggingActivated?: Maybe<Scalars['Boolean']['output']>;
  mmsConfiguration?: Maybe<MmsConfiguration>;
  musicOnHold?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  newPurchasingFlowEnabled?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  numberFormatted?: Maybe<Scalars['String']['output']>;
  numberReputation?: Maybe<EnrolledMonitoredNumber>;
  numberUUID?: Maybe<Scalars['String']['output']>;
  open?: Maybe<Scalars['Boolean']['output']>;
  outboundRecordingActivated?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber: Scalars['String']['output'];
  phoneNumberFormatted?: Maybe<Scalars['String']['output']>;
  phoneType?: Maybe<Scalars['String']['output']>;
  primaryAssignee?: Maybe<LinePrimaryAssignee>;
  provider?: Maybe<Scalars['String']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  smsEnabled?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<LineState>;
  supervisions?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
  timezone?: Maybe<Scalars['String']['output']>;
  verificationState?: Maybe<LineVerificationState>;
  voiceAgents?: Maybe<VoiceAgents>;
  waitingMusic?: Maybe<Scalars['String']['output']>;
  whatsappConfiguration?: Maybe<WhatsAppConfiguration>;
};

export type LineAggregation = {
  __typename?: 'LineAggregation';
  count: Scalars['Int']['output'];
  duration?: Maybe<DurationAggregation>;
  line?: Maybe<Line>;
  lineId: Scalars['Int']['output'];
  sentiments?: Maybe<SentimentsAggregation>;
};

export type LineBrandedCallingStatus = {
  __typename?: 'LineBrandedCallingStatus';
  branded: Scalars['Boolean']['output'];
  withLogo: Scalars['Boolean']['output'];
};

export type LineConfiguration = {
  __typename?: 'LineConfiguration';
  line?: Maybe<LineResolver>;
  lineId: Scalars['ID']['output'];
};

export type LineEntityOutput = {
  __typename?: 'LineEntityOutput';
  ID?: Maybe<Scalars['String']['output']>;
  allowInboundRecordingActions?: Maybe<Scalars['Boolean']['output']>;
  allowOutboundRecordingActions?: Maybe<Scalars['Boolean']['output']>;
  allowRealtimeTranscription?: Maybe<Scalars['Boolean']['output']>;
  companyId: Scalars['String']['output'];
  countryISOCode: Scalars['String']['output'];
  flowEditorEnabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  inboundRecordingActivated?: Maybe<Scalars['Boolean']['output']>;
  ivr: Scalars['Boolean']['output'];
  language?: Maybe<Scalars['String']['output']>;
  mandatoryTaggingActivated?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  numberFormatted: Scalars['String']['output'];
  numberUUID?: Maybe<Scalars['String']['output']>;
  open: Scalars['Boolean']['output'];
  outboundRecordingActivated?: Maybe<Scalars['Boolean']['output']>;
  timezone: Scalars['String']['output'];
  waitingMusic: Scalars['String']['output'];
};

export type LineEsim = {
  __typename?: 'LineEsim';
  hasCarrierLine: Scalars['Boolean']['output'];
  hasEsimCapability: Scalars['Boolean']['output'];
  state: LineEsimState;
};

export enum LineEsimState {
  ACTIVE = 'ACTIVE',
  NONE = 'NONE',
  SUSPENDED = 'SUSPENDED'
}

export type LineExtractOutput = {
  __typename?: 'LineExtractOutput';
  extractFileUrl: Scalars['String']['output'];
};

export type LineIdBrandedCallingStatus = {
  __typename?: 'LineIdBrandedCallingStatus';
  branded: Scalars['Boolean']['output'];
  lineId: Scalars['ID']['output'];
  withLogo: Scalars['Boolean']['output'];
};

export type LineInfo = {
  __typename?: 'LineInfo';
  countryCode: Scalars['String']['output'];
  languageCode: Scalars['String']['output'];
  lineID: Scalars['ID']['output'];
  lineName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type LineInfoOutput = GenericException | LineInfoPaginatedOutput;

export type LineInfoPaginatedOutput = {
  __typename?: 'LineInfoPaginatedOutput';
  items: Array<LineInfo>;
  pageInfo: SmartflowsPageInfo;
};

export type LinePrimaryAssignee = {
  __typename?: 'LinePrimaryAssignee';
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  pictureURL?: Maybe<Scalars['String']['output']>;
};

export type LineResolver = {
  __typename?: 'LineResolver';
  entity: Line;
};

export type LineResolverInput = {
  __typename?: 'LineResolverInput';
  companyID: Scalars['ID']['output'];
  lineID: Scalars['String']['output'];
};

export type LineSettingsArgs = {
  automaticCallbackEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  automaticCallbackRetries?: InputMaybe<Scalars['Int']['input']>;
  callWaitingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  callWaitingPlayAudioNotification?: InputMaybe<Scalars['Boolean']['input']>;
  callbackRequestEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  callbackRequestMessage?: InputMaybe<CallbackRequestMessageInput>;
  lastEditedAt?: InputMaybe<Scalars['String']['input']>;
  outboundComplianceMessage?: InputMaybe<OutboundComplianceMessageInput>;
  outboundComplianceMessageEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Boolean']['input']>;
  respectQueueingTime?: InputMaybe<Scalars['Boolean']['input']>;
  stopRecordingOnExternalTransfer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LineSettingsOutput = {
  __typename?: 'LineSettingsOutput';
  automaticCallbackEnabled?: Maybe<Scalars['Boolean']['output']>;
  automaticCallbackRetries?: Maybe<Scalars['Int']['output']>;
  callWaitingEnabled?: Maybe<Scalars['Boolean']['output']>;
  callWaitingPlayAudioNotification?: Maybe<Scalars['Boolean']['output']>;
  callbackRequestEnabled?: Maybe<Scalars['Boolean']['output']>;
  callbackRequestMessage?: Maybe<CallbackRequestMessageOutput>;
  lastEditedAt: Scalars['String']['output'];
  lineID: Scalars['ID']['output'];
  outboundComplianceMessage?: Maybe<OutboundComplianceMessageOutput>;
  outboundComplianceMessageEnabled?: Maybe<Scalars['Boolean']['output']>;
  priority?: Maybe<Scalars['Boolean']['output']>;
  respectQueueingTime?: Maybe<Scalars['Boolean']['output']>;
  stopRecordingOnExternalTransfer?: Maybe<Scalars['Boolean']['output']>;
};

export enum LineState {
  ALWAYS_CLOSED = 'ALWAYS_CLOSED',
  ALWAYS_OPENED = 'ALWAYS_OPENED',
  AUTO = 'AUTO'
}

export enum LineStatus {
  ACTION_NEEDED = 'ACTION_NEEDED',
  ALWAYS_CLOSED = 'ALWAYS_CLOSED',
  ALWAYS_OPENED = 'ALWAYS_OPENED',
  CLOSED = 'CLOSED',
  OPENED = 'OPENED'
}

export type LineTargetResponse = {
  __typename?: 'LineTargetResponse';
  lineID: Scalars['ID']['output'];
};

export type LineTracker = {
  __typename?: 'LineTracker';
  lineId: Scalars['Int']['output'];
};

export type LineTranscriptionSettings = {
  __typename?: 'LineTranscriptionSettings';
  calls?: Maybe<CallTranscriptionSettings>;
  companyId: Scalars['Int']['output'];
  csat?: Maybe<CsatSettings>;
  lineId: Scalars['Int']['output'];
  lineLanguage: Scalars['String']['output'];
  redaction?: Maybe<RedactionSettings>;
  secondaryLanguages?: Maybe<Array<Scalars['String']['output']>>;
  voicemails?: Maybe<VoicemailTranscriptionSettings>;
};

export type LineUpdatedNotificationInput = {
  line: Scalars['String']['input'];
  recipients: Array<Scalars['ID']['input']>;
  timestamp: Scalars['AWSDateTime']['input'];
};

export type LineUpdatedNotificationOutput = {
  __typename?: 'LineUpdatedNotificationOutput';
  line: Line;
  recipients: Array<Scalars['ID']['output']>;
  timestamp: Scalars['AWSDateTime']['output'];
};

export enum LineVerificationState {
  MISSING_INFORMATION = 'MISSING_INFORMATION',
  NOTREQUIRED = 'NOTREQUIRED',
  NOT_REQUIRED = 'NOT_REQUIRED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  VERIFIED = 'VERIFIED'
}

export type LinesAggregation = {
  __typename?: 'LinesAggregation';
  aggregations: Array<LineAggregation>;
  otherCount: Scalars['Int']['output'];
};

export type LinesAggregationScope = {
  duration?: InputMaybe<MetricAggregationScope>;
  sentiments?: InputMaybe<SentimentAggregationScope>;
  size: Scalars['Int']['input'];
};

export type LinesInfoResolver = {
  __typename?: 'LinesInfoResolver';
  entities?: Maybe<Array<LineInfo>>;
};

export type LinesInfoResolverInput = {
  __typename?: 'LinesInfoResolverInput';
  id: Scalars['ID']['output'];
  type: EntityType;
};

export type LinkTagsToCallInput = {
  callId: Scalars['ID']['input'];
  fromMandatoryTagging?: InputMaybe<Scalars['Boolean']['input']>;
  tagIds: Array<Scalars['Int']['input']>;
};

export type ListActionsOutput = ActionsPaginatedOutput | GenericException;

export type ListAgentOverviewInsightsOutput = AgentOverviewInsightsList | GenericException | UserInputException;

export type ListAgentTemplateResult = GenericException | ListAgentTemplatesResponse;

export type ListAgentTemplateV2Result = GenericException | ListAgentTemplatesV2Response;

export type ListAgentTemplatesInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortKey?: InputMaybe<ListTemplatesSortKey>;
  sortOrder?: InputMaybe<SortDirection>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type ListAgentTemplatesOutput = GenericException | VirtualAgentTemplateList;

export type ListAgentTemplatesResponse = {
  __typename?: 'ListAgentTemplatesResponse';
  pageInfo?: Maybe<PageInfo>;
  templates: Array<AgentTemplate>;
};

export type ListAgentTemplatesV2Response = {
  __typename?: 'ListAgentTemplatesV2Response';
  pageInfo?: Maybe<TemplateResponsePageInfo>;
  templates: Array<AgentTemplate>;
};

export type ListAuthMethodsOutput = AuthMethodsPaginatedOutput | GenericException;

export type ListBrandsInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type ListBrandsResult = BrandListResponse | BrandedCallingException | GenericException;

export type ListCalendarsOutput = {
  __typename?: 'ListCalendarsOutput';
  items: Array<CalendarOutput>;
  pageInfo: SmartflowsPageInfo;
};

export type ListCalendarsOutputV2 = GenericException | ListCalendarsOutput;

export type ListCampaignUseCasesInput = {
  validSubUsecase?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ListCampaignUseCasesResponse = {
  __typename?: 'ListCampaignUseCasesResponse';
  useCases: Array<CampaignUseCase>;
};

export type ListCampaignUseCasesResult = GenericException | ListCampaignUseCasesResponse;

export type ListCoachingSessionsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ListCoachingSessionsOutput = {
  __typename?: 'ListCoachingSessionsOutput';
  sessions: Array<CoachingSession>;
};

export type ListCoachingSessionsResult = GenericException | ListCoachingSessionsOutput | ResourceNotFoundException;

export type ListCompanyOutboundCampaignOutcomesOutput = GenericException | OutboundCampaignOutcomeConnection | UserInputException;

export type ListCrmContactListsOutput = CrmContactListConnection | CrmNotSupportedException | GenericException | InsufficientPermissionException | InvalidPropertyMappingException | ResourceNotFoundException;

export type ListEvalRunsOutput = EvalRunSummaryList | GenericException | ResourceNotFoundException;

export type ListGsmDevicesData = {
  __typename?: 'ListGSMDevicesData';
  gsmDevices: Array<GsmDevice>;
};

export type ListGsmDevicesOutput = GenericException | ListGsmDevicesData;

export type ListLoaEnvelopesInput = {
  brandDraftUuid?: InputMaybe<Scalars['String']['input']>;
  brandRegistrationUuid?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<LoaEnvelopeStatus>;
};

export type ListLoaEnvelopesResult = BrandedCallingException | GenericException | LoaEnvelopeList;

export type ListLongTailProposalsOutput = GenericException | LongTailProposalList | ResourceNotFoundException | UserInputException;

export type ListOutboundCampaignCallOutcomesOutput = GenericException | OutboundCampaignCallOutcomeConnection | ResourceNotFoundException | UserInputException;

export type ListOutboundCampaignContactsOutput = GenericException | OutboundCampaignContactConnection | ResourceNotFoundException;

export type ListOutboundCampaignLinesOutput = GenericException | OutboundCampaignLineConnection | ResourceNotFoundException | UserInputException;

export type ListOutboundCampaignQueueItemsOutput = GenericException | OutboundCampaignQueueItemConnection | ResourceNotFoundException | UserInputException;

export type ListOutboundCampaignUsersOutput = GenericException | OutboundCampaignUserConnection | ResourceNotFoundException | UserInputException;

export type ListOutboundCampaignsOutput = GenericException | OutboundCampaignConnection | UserInputException;

export type ListPortingRequestsInput = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  countryId?: InputMaybe<Scalars['Int']['input']>;
  createdAtFrom?: InputMaybe<Scalars['String']['input']>;
  createdAtTo?: InputMaybe<Scalars['String']['input']>;
  isRange?: InputMaybe<Scalars['Boolean']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  phoneType?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredPortingDateFrom?: InputMaybe<Scalars['String']['input']>;
  preferredPortingDateTo?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  winningCarrierId?: InputMaybe<Scalars['Int']['input']>;
};

export type ListPortingRequestsResponse = {
  __typename?: 'ListPortingRequestsResponse';
  pageNumber: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  results: Array<PortingRequestListItem>;
  resultsCount: Scalars['Int']['output'];
};

export type ListSessionMessagesOutput = {
  __typename?: 'ListSessionMessagesOutput';
  messages: Array<SessionMessage>;
};

export type ListSessionMessagesResult = GenericException | ListSessionMessagesOutput | ResourceNotFoundException;

export type ListSupervisionsData = {
  __typename?: 'ListSupervisionsData';
  supervisions: Array<Supervision>;
};

export type ListSupervisionsOutput = GenericException | ListSupervisionsData | ResourceNotFoundException;

export type ListTemplatesInput = {
  category?: InputMaybe<TemplateCategory>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SearchableSortDirection>;
  sortKey?: InputMaybe<ListTemplatesSortKey>;
  status?: InputMaybe<TemplateStatus>;
  supportedTypes?: InputMaybe<Array<TemplateType>>;
  token?: InputMaybe<Scalars['String']['input']>;
  wabaId: Scalars['ID']['input'];
};

export type ListTemplatesResponse = {
  __typename?: 'ListTemplatesResponse';
  pageInfo?: Maybe<PageInfo>;
  templates?: Maybe<Array<Template>>;
};

export type ListTemplatesResult = GenericException | ListTemplatesResponse;

export enum ListTemplatesSortKey {
  isFavourite = 'isFavourite',
  updatedAt = 'updatedAt'
}

export type ListTracksData = {
  __typename?: 'ListTracksData';
  tracks: Array<Track>;
};

export type ListTracksOutput = GenericException | ListTracksData | ResourceNotFoundException;

export type ListVirtualAgentsOutput = GenericException | VirtualAgentPaginatedOutput;

export type ListVoicesOutput = GenericException | VoiceList;

export type ListWhatsAppTemplatesInput = {
  category?: InputMaybe<Array<TemplateCategory>>;
  language?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SearchableSortDirection>;
  sortKey?: InputMaybe<ListTemplatesSortKey>;
  status?: InputMaybe<TemplateStatus>;
  supportedTypes?: InputMaybe<Array<TemplateType>>;
  token?: InputMaybe<Scalars['String']['input']>;
  wabaId: Scalars['ID']['input'];
};

export type ListWhatsAppTemplatesResponse = {
  __typename?: 'ListWhatsAppTemplatesResponse';
  pageInfo?: Maybe<TemplateResponsePageInfo>;
  templates?: Maybe<Array<Template>>;
};

export type ListWhatsAppTemplatesResult = GenericException | ListWhatsAppTemplatesResponse;

export type LiveMonitoringAiVoiceAgent = {
  __typename?: 'LiveMonitoringAiVoiceAgent';
  id: Scalars['ID']['output'];
};

export type LiveMonitoringAutomaticCallback = {
  __typename?: 'LiveMonitoringAutomaticCallback';
  disconnectedBy?: Maybe<LiveMonitoringAutomaticCallbackDisconnectedBy>;
  executedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  missedReason?: Maybe<LiveMonitoringAutomaticCallbackMissedReason>;
  pendingAt?: Maybe<Scalars['AWSDateTime']['output']>;
  referenceCallID?: Maybe<Scalars['ID']['output']>;
  referenceWebID?: Maybe<Scalars['Float']['output']>;
};

export enum LiveMonitoringAutomaticCallbackDisconnectedBy {
  CALLEE = 'CALLEE',
  CALLER = 'CALLER'
}

export enum LiveMonitoringAutomaticCallbackMissedReason {
  AGENT_DID_NOT_ANSWER = 'AGENT_DID_NOT_ANSWER',
  NO_AVAILABLE_AGENT = 'NO_AVAILABLE_AGENT',
  UNABLE_TO_CONTINUE = 'UNABLE_TO_CONTINUE',
  UNKNOWN = 'UNKNOWN',
  UNSPECIFIED = 'UNSPECIFIED'
}

export type LiveMonitoringCall = {
  __typename?: 'LiveMonitoringCall';
  aiVoiceAgents: Array<LiveMonitoringAiVoiceAgent>;
  answeredAt?: Maybe<Scalars['AWSDateTime']['output']>;
  automaticCallback?: Maybe<LiveMonitoringAutomaticCallback>;
  campaign?: Maybe<LiveMonitoringCampaign>;
  contacts: Array<LiveMonitoringContact>;
  direction: LiveMonitoringCallDirection;
  endedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  externalUsers: Array<LiveMonitoringContact>;
  hasAiIntervention: Scalars['Boolean']['output'];
  hasCallEscalated: Scalars['Boolean']['output'];
  hasCallTimeline: Scalars['Boolean']['output'];
  hasRecording: Scalars['Boolean']['output'];
  hasVoicemail: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  inCallDurationInSeconds?: Maybe<Scalars['Int']['output']>;
  ivrBranchName?: Maybe<Scalars['String']['output']>;
  ivrStepTitle?: Maybe<Scalars['String']['output']>;
  line: LiveMonitoringLine;
  startedAt: Scalars['AWSDateTime']['output'];
  status: LiveMonitoringCallStatus;
  statusUpdatedAt: Scalars['AWSDateTime']['output'];
  synchronizedCommunicationID?: Maybe<Scalars['String']['output']>;
  teams: Array<LiveMonitoringTeam>;
  updatedAt: Scalars['AWSDateTime']['output'];
  users: Array<LiveMonitoringUser>;
  waitingAt?: Maybe<Scalars['AWSDateTime']['output']>;
  waitingTimeDurationInSeconds?: Maybe<Scalars['Int']['output']>;
  webID?: Maybe<Scalars['Float']['output']>;
};

export enum LiveMonitoringCallDirection {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND'
}

export type LiveMonitoringCallFilterInput = {
  callDirection?: InputMaybe<LiveMonitoringCallDirection>;
  callStatus?: InputMaybe<Array<LiveMonitoringCallStatus>>;
  exclude?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LiveMonitoringCallMetrics = {
  __typename?: 'LiveMonitoringCallMetrics';
  common: LiveMonitoringCommonTopMetrics;
  commonMetrics: LiveMonitoringCommonTopMetricsResult;
  waiting: LiveMonitoringWaitingTopMetrics;
  waitingMetrics: LiveMonitoringWaitingTopMetricsResult;
};

export enum LiveMonitoringCallStatus {
  ANSWERED = 'ANSWERED',
  IN_CALL = 'IN_CALL',
  IN_CALL_AI_VOICE_AGENT = 'IN_CALL_AI_VOICE_AGENT',
  IN_IVR = 'IN_IVR',
  IN_QUEUE = 'IN_QUEUE',
  RINGING = 'RINGING',
  UNANSWERED = 'UNANSWERED',
  UNANSWERED_ABANDONED_BEFORE_10_SECONDS = 'UNANSWERED_ABANDONED_BEFORE_10_SECONDS',
  UNANSWERED_ABANDONED_DURING_WELCOME_MESSAGE = 'UNANSWERED_ABANDONED_DURING_WELCOME_MESSAGE',
  UNANSWERED_ABANDONED_IN_IVR = 'UNANSWERED_ABANDONED_IN_IVR',
  UNANSWERED_ALL_AGENTS_UNAVAILABLE = 'UNANSWERED_ALL_AGENTS_UNAVAILABLE',
  UNANSWERED_CALLBACK_REQUEST = 'UNANSWERED_CALLBACK_REQUEST',
  UNANSWERED_OUTSIDE_BUSINESS_HOURS = 'UNANSWERED_OUTSIDE_BUSINESS_HOURS',
  UNANSWERED_USERS_DID_NOT_ANSWER = 'UNANSWERED_USERS_DID_NOT_ANSWER'
}

export type LiveMonitoringCallsList = {
  __typename?: 'LiveMonitoringCallsList';
  items: Array<LiveMonitoringCall>;
  pageInfo: PagingInfo;
};

export type LiveMonitoringCallsListResult = GenericException | LiveMonitoringCallsList | RetryableException;

export type LiveMonitoringCampaign = {
  __typename?: 'LiveMonitoringCampaign';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type LiveMonitoringCampaignsInput = {
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type LiveMonitoringCampaignsList = {
  __typename?: 'LiveMonitoringCampaignsList';
  items: Array<LiveMonitoringCampaign>;
  total: Scalars['Int']['output'];
};

export type LiveMonitoringCampaignsListResult = GenericException | LiveMonitoringCampaignsList | RetryableException;

export type LiveMonitoringCommonTopMetrics = {
  __typename?: 'LiveMonitoringCommonTopMetrics';
  aiVoiceAgentHandledCalls: Scalars['Int']['output'];
  aiVoiceAgentHandledCallsPercentage: Scalars['Float']['output'];
  answeredCalls: Scalars['Int']['output'];
  avgTimeToAnswer: Scalars['Int']['output'];
  inboundCalls: Scalars['Int']['output'];
  outboundCalls: Scalars['Int']['output'];
  serviceLevelAgreement: Scalars['Float']['output'];
  totalCalls: Scalars['Int']['output'];
  unansweredCalls: Scalars['Int']['output'];
  unansweredCallsPercentage: Scalars['Float']['output'];
};

export type LiveMonitoringCommonTopMetricsResult = GenericException | LiveMonitoringCommonTopMetrics | RetryableException;

export type LiveMonitoringContact = {
  __typename?: 'LiveMonitoringContact';
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type LiveMonitoringCurrentUserMetrics = {
  __typename?: 'LiveMonitoringCurrentUserMetrics';
  inboundCalls: Scalars['Int']['output'];
  outboundCalls: Scalars['Int']['output'];
};

export type LiveMonitoringCurrentUserMetricsResult = GenericException | LiveMonitoringCurrentUserMetrics | RetryableException;

export type LiveMonitoringFilterInput = {
  callIds?: InputMaybe<Array<LiveMonitoringUpdatedCallIdFilterInput>>;
  calls?: InputMaybe<Array<LiveMonitoringCallFilterInput>>;
  campaigns?: InputMaybe<Array<Scalars['ID']['input']>>;
  focusOption?: InputMaybe<LiveMonitoringFocusOption>;
  lines?: InputMaybe<Array<Scalars['ID']['input']>>;
  teamFilterOption?: InputMaybe<LiveMonitoringTeamFilterOption>;
  teams?: InputMaybe<Array<Scalars['ID']['input']>>;
  timeRange: LiveMonitoringTimeRange;
  timezone?: InputMaybe<Scalars['String']['input']>;
  userStatus?: InputMaybe<Array<LiveMonitoringUserStatus>>;
  users?: InputMaybe<Array<Scalars['ID']['input']>>;
  withAiIntervention?: InputMaybe<Scalars['Boolean']['input']>;
  withVoicemail?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LiveMonitoringFocusOption {
  ALL = 'ALL',
  INBOUND = 'INBOUND'
}

export type LiveMonitoringLine = {
  __typename?: 'LiveMonitoringLine';
  countryISOCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metrics?: Maybe<LiveMonitoringLineMetrics>;
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type LiveMonitoringLineMetrics = {
  __typename?: 'LiveMonitoringLineMetrics';
  answeredCalls: Scalars['Int']['output'];
  avgTimeToAnswer: Scalars['Int']['output'];
  callsWaiting: Scalars['Int']['output'];
  inboundCalls: Scalars['Int']['output'];
  outboundCalls: Scalars['Int']['output'];
  serviceLevelAgreement: Scalars['Float']['output'];
  unansweredCalls: Scalars['Int']['output'];
  unansweredCallsPercentage: Scalars['Float']['output'];
};

export type LiveMonitoringLinesList = {
  __typename?: 'LiveMonitoringLinesList';
  items: Array<LiveMonitoringLine>;
  pageInfo: PagingInfo;
};

export type LiveMonitoringLinesListResult = GenericException | LiveMonitoringLinesList | RetryableException;

export type LiveMonitoringListInput = {
  filter: LiveMonitoringFilterInput;
  pages?: InputMaybe<LiveMonitoringListPages>;
  slaIncludedCallStatus?: InputMaybe<Array<LiveMonitoringCallStatus>>;
  slaTimeToAnswerInSeconds?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LiveMonitoringSortInput>>;
  token?: InputMaybe<Scalars['String']['input']>;
  unansweredIncludedCallStatus?: InputMaybe<Array<LiveMonitoringCallStatus>>;
};

export enum LiveMonitoringListPages {
  CURRENT = 'CURRENT',
  FROM_FIRST = 'FROM_FIRST'
}

export type LiveMonitoringMetricInput = {
  filter: LiveMonitoringFilterInput;
  slaIncludedCallStatus?: InputMaybe<Array<LiveMonitoringCallStatus>>;
  slaTimeToAnswerInSeconds?: InputMaybe<Scalars['Int']['input']>;
  unansweredIncludedCallStatus?: InputMaybe<Array<LiveMonitoringCallStatus>>;
};

export type LiveMonitoringMetrics = {
  __typename?: 'LiveMonitoringMetrics';
  answeredCalls: Scalars['Int']['output'];
  availableUsers: Scalars['Int']['output'];
  avgTimeToAnswer: Scalars['Int']['output'];
  callsWaiting: Scalars['Int']['output'];
  inboundCalls: Scalars['Int']['output'];
  longestWaiting: Scalars['Int']['output'];
  longestWaitingCallId: Scalars['ID']['output'];
  outboundCalls: Scalars['Int']['output'];
  serviceLevelAgreement: Scalars['Float']['output'];
  totalCalls: Scalars['Int']['output'];
  unansweredCalls: Scalars['Int']['output'];
  unansweredCallsPercentage: Scalars['Float']['output'];
};

export type LiveMonitoringMetricsResult = GenericException | LiveMonitoringMetrics;

export type LiveMonitoringSlaThreshold = {
  __typename?: 'LiveMonitoringSlaThreshold';
  good: Scalars['Float']['output'];
  medium: Scalars['Float']['output'];
};

export type LiveMonitoringSlaThresholdInput = {
  good: Scalars['Float']['input'];
  medium: Scalars['Float']['input'];
};

export enum LiveMonitoringSortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type LiveMonitoringSortInput = {
  column: Scalars['String']['input'];
  direction: LiveMonitoringSortDirection;
};

export type LiveMonitoringTeam = {
  __typename?: 'LiveMonitoringTeam';
  id: Scalars['ID']['output'];
  imageName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export enum LiveMonitoringTeamFilterOption {
  CALLS_ROUTED_TO_TEAM = 'CALLS_ROUTED_TO_TEAM',
  USERS_BELONG_TO_TEAM = 'USERS_BELONG_TO_TEAM'
}

export type LiveMonitoringTimeFilterInput = {
  timeRange?: InputMaybe<LiveMonitoringTimeRange>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export enum LiveMonitoringTimeRange {
  LAST_24HOURS = 'LAST_24HOURS',
  LAST_HOUR = 'LAST_HOUR',
  TODAY = 'TODAY'
}

export type LiveMonitoringTopMetricsResult = GenericException | LiveMonitoringCallMetrics;

export type LiveMonitoringUpdatedCallIdFilterInput = {
  id: Scalars['ID']['input'];
  timestamp?: InputMaybe<Scalars['Float']['input']>;
};

export type LiveMonitoringUser = {
  __typename?: 'LiveMonitoringUser';
  availability?: Maybe<LiveMonitoringUserAvailability>;
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  latestCall?: Maybe<LiveMonitoringCall>;
  metrics?: Maybe<LiveMonitoringUserMetrics>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
};

export type LiveMonitoringUserAvailabilities = {
  __typename?: 'LiveMonitoringUserAvailabilities';
  users: Array<LiveMonitoringUser>;
};

export type LiveMonitoringUserAvailabilitiesResult = GenericException | LiveMonitoringUserAvailabilities | RetryableException;

export type LiveMonitoringUserAvailability = {
  __typename?: 'LiveMonitoringUserAvailability';
  status: LiveMonitoringUserStatus;
  timestamp: Scalars['Float']['output'];
};

export type LiveMonitoringUserAvailabilityStatuses = {
  __typename?: 'LiveMonitoringUserAvailabilityStatuses';
  users: Array<LiveMonitoringUserAvailability>;
};

export type LiveMonitoringUserMetrics = {
  __typename?: 'LiveMonitoringUserMetrics';
  answeredCalls: Scalars['Int']['output'];
  notPickedUp: Scalars['Int']['output'];
  outboundCalls: Scalars['Int']['output'];
  pickedUp: Scalars['Int']['output'];
};

export type LiveMonitoringUserPreferences = {
  __typename?: 'LiveMonitoringUserPreferences';
  customPreferences?: Maybe<Scalars['String']['output']>;
  filter?: Maybe<LiveMonitoringUserPreferencesFilter>;
  slaIncludedCallStatus?: Maybe<Array<LiveMonitoringCallStatus>>;
  slaThreshold?: Maybe<LiveMonitoringSlaThreshold>;
  slaTimeToAnswerInSeconds?: Maybe<Scalars['Int']['output']>;
  unansweredIncludedCallStatus?: Maybe<Array<LiveMonitoringCallStatus>>;
};

export type LiveMonitoringUserPreferencesCallFilter = {
  __typename?: 'LiveMonitoringUserPreferencesCallFilter';
  callDirection?: Maybe<LiveMonitoringCallDirection>;
  callStatus?: Maybe<Array<LiveMonitoringCallStatus>>;
};

export type LiveMonitoringUserPreferencesFilter = {
  __typename?: 'LiveMonitoringUserPreferencesFilter';
  calls?: Maybe<Array<LiveMonitoringUserPreferencesCallFilter>>;
  campaigns?: Maybe<Array<Scalars['ID']['output']>>;
  focusOption: LiveMonitoringFocusOption;
  lines?: Maybe<Array<Scalars['ID']['output']>>;
  teamFilterOption?: Maybe<LiveMonitoringTeamFilterOption>;
  teams?: Maybe<Array<Scalars['ID']['output']>>;
  timeRange: LiveMonitoringTimeRange;
  userStatus?: Maybe<Array<LiveMonitoringUserStatus>>;
  users?: Maybe<Array<Scalars['ID']['output']>>;
  withAiIntervention?: Maybe<Scalars['Boolean']['output']>;
  withVoicemail?: Maybe<Scalars['Boolean']['output']>;
};

export type LiveMonitoringUserPreferencesFilterInput = {
  calls?: InputMaybe<Array<LiveMonitoringCallFilterInput>>;
  campaigns?: InputMaybe<Array<Scalars['ID']['input']>>;
  focusOption: LiveMonitoringFocusOption;
  lines?: InputMaybe<Array<Scalars['ID']['input']>>;
  teamFilterOption?: InputMaybe<LiveMonitoringTeamFilterOption>;
  teams?: InputMaybe<Array<Scalars['ID']['input']>>;
  timeRange: LiveMonitoringTimeRange;
  userStatus?: InputMaybe<Array<LiveMonitoringUserStatus>>;
  users?: InputMaybe<Array<Scalars['ID']['input']>>;
  withAiIntervention?: InputMaybe<Scalars['Boolean']['input']>;
  withVoicemail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LiveMonitoringUserPreferencesInput = {
  customPreferences?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LiveMonitoringUserPreferencesFilterInput>;
  slaIncludedCallStatus?: InputMaybe<Array<LiveMonitoringCallStatus>>;
  slaThreshold: LiveMonitoringSlaThresholdInput;
  slaTimeToAnswerInSeconds: Scalars['Int']['input'];
  unansweredIncludedCallStatus?: InputMaybe<Array<LiveMonitoringCallStatus>>;
};

export type LiveMonitoringUserPreferencesResult = GenericException | LiveMonitoringUserPreferences;

export enum LiveMonitoringUserStatus {
  AFTER_CALL_WORK = 'AFTER_CALL_WORK',
  AVAILABLE = 'AVAILABLE',
  DOING_BACK_OFFICE = 'DOING_BACK_OFFICE',
  DO_NOT_DISTURB = 'DO_NOT_DISTURB',
  IN_CALL = 'IN_CALL',
  IN_TRAINING = 'IN_TRAINING',
  OFFLINE = 'OFFLINE',
  ON_A_BREAK = 'ON_A_BREAK',
  ON_MOBILE = 'ON_MOBILE',
  OTHER = 'OTHER',
  OUT_FOR_LUNCH = 'OUT_FOR_LUNCH',
  RINGING = 'RINGING'
}

export type LiveMonitoringUsersList = {
  __typename?: 'LiveMonitoringUsersList';
  items: Array<LiveMonitoringUser>;
  pageInfo: PagingInfo;
};

export type LiveMonitoringUsersListResult = GenericException | LiveMonitoringUsersList | RetryableException;

export type LiveMonitoringWaitingTopMetrics = {
  __typename?: 'LiveMonitoringWaitingTopMetrics';
  callsWaiting: Scalars['Int']['output'];
  longestWaiting: Scalars['Int']['output'];
  longestWaitingCallId: Scalars['ID']['output'];
};

export type LiveMonitoringWaitingTopMetricsResult = GenericException | LiveMonitoringWaitingTopMetrics | RetryableException;

export type LoaEnvelope = {
  __typename?: 'LoaEnvelope';
  brandDraftId?: Maybe<Scalars['String']['output']>;
  brandRegistrationId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  embeddedSigningUrl?: Maybe<Scalars['String']['output']>;
  envelopeId?: Maybe<Scalars['String']['output']>;
  expiredAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  loaTemplateId: Scalars['String']['output'];
  metadata: Scalars['String']['output'];
  signedAt?: Maybe<Scalars['String']['output']>;
  signerEmail?: Maybe<Scalars['String']['output']>;
  signerName?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  voidedAt?: Maybe<Scalars['String']['output']>;
};

export type LoaEnvelopeList = {
  __typename?: 'LoaEnvelopeList';
  pageNumber: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  results: Array<LoaEnvelope>;
  resultsCount: Scalars['Int']['output'];
};

export enum LoaEnvelopeStatus {
  created = 'created',
  declined = 'declined',
  delivered = 'delivered',
  expired = 'expired',
  sent = 'sent',
  signed = 'signed',
  signing_in_progress = 'signing_in_progress',
  voided = 'voided'
}

export type LoaEnvelopeSummary = {
  __typename?: 'LoaEnvelopeSummary';
  createdAt: Scalars['String']['output'];
  envelopeId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  signedAt?: Maybe<Scalars['String']['output']>;
  signerEmail?: Maybe<Scalars['String']['output']>;
  signerName?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type LongTailApplicationNotFoundException = Exception & {
  __typename?: 'LongTailApplicationNotFoundException';
  code: Scalars['String']['output'];
  hubApplicationId: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type LongTailGenerationJob = {
  __typename?: 'LongTailGenerationJob';
  errorPayload?: Maybe<Scalars['String']['output']>;
  failedAt?: Maybe<Scalars['String']['output']>;
  generationJobId: Scalars['ID']['output'];
  generationMode: LongTailGenerationMode;
  modelName: Scalars['String']['output'];
  modelProvider: Scalars['String']['output'];
  promptHash: Scalars['String']['output'];
  proposalId?: Maybe<Scalars['String']['output']>;
  registrationSessionId: Scalars['ID']['output'];
  startedAt?: Maybe<Scalars['String']['output']>;
  status: LongTailGenerationJobStatus;
  succeededAt?: Maybe<Scalars['String']['output']>;
  timeoutSeconds: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum LongTailGenerationJobStatus {
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
  SUCCEEDED = 'SUCCEEDED',
  TIMEOUT = 'TIMEOUT'
}

export enum LongTailGenerationMode {
  ASSIST = 'ASSIST',
  DETERMINISTIC = 'DETERMINISTIC'
}

export type LongTailInvalidProposalStateException = Exception & {
  __typename?: 'LongTailInvalidProposalStateException';
  code: Scalars['String']['output'];
  currentStatus: Scalars['String']['output'];
  message: Scalars['String']['output'];
  proposalId: Scalars['ID']['output'];
  registrationSessionId: Scalars['ID']['output'];
  requiredStatus: Scalars['String']['output'];
};

export type LongTailProposal = {
  __typename?: 'LongTailProposal';
  createdAt: Scalars['String']['output'];
  generationJobId: Scalars['ID']['output'];
  modelName: Scalars['String']['output'];
  modelProvider: Scalars['String']['output'];
  promptHash: Scalars['String']['output'];
  promptVersion: Scalars['String']['output'];
  proposalId: Scalars['ID']['output'];
  registrationSessionId: Scalars['ID']['output'];
  reviewFindings: Scalars['String']['output'];
  riskTier: LongTailRiskTier;
  sourcePointerTrail: Scalars['String']['output'];
  toolDefinitions: Scalars['String']['output'];
};

export type LongTailProposalList = {
  __typename?: 'LongTailProposalList';
  proposalCount: Scalars['Int']['output'];
  proposals: Array<LongTailProposal>;
};

export type LongTailProposalNotFoundException = Exception & {
  __typename?: 'LongTailProposalNotFoundException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  proposalId: Scalars['ID']['output'];
};

export type LongTailProvision = {
  __typename?: 'LongTailProvision';
  applicationId: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  hubApplicationId: Scalars['String']['output'];
  provisions: Array<LongTailProvisionEntry>;
  requestKey: Scalars['String']['output'];
};

export type LongTailProvisionEntry = {
  __typename?: 'LongTailProvisionEntry';
  createdAt: Scalars['String']['output'];
  integrationId: Scalars['ID']['output'];
  partnerDomain?: Maybe<Scalars['String']['output']>;
  toolCount: Scalars['Int']['output'];
  toolsAuthorized: Scalars['Int']['output'];
  toolsDeauthorized: Scalars['Int']['output'];
  toolsExcluded?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type LongTailRegistration = {
  __typename?: 'LongTailRegistration';
  applicationId: Scalars['Int']['output'];
  applicationName: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  hubApplicationId: Scalars['String']['output'];
  proposalId: Scalars['ID']['output'];
  registrationId: Scalars['ID']['output'];
  reprovisionRequired: Scalars['Boolean']['output'];
  requestKey: Scalars['String']['output'];
  toolCount: Scalars['Int']['output'];
};

export type LongTailRegistrationSession = {
  __typename?: 'LongTailRegistrationSession';
  actorUserId: Scalars['String']['output'];
  hubApplicationId: Scalars['String']['output'];
  registrationSessionId: Scalars['ID']['output'];
  status: LongTailRegistrationSessionStatus;
  updatedAt: Scalars['String']['output'];
};

export enum LongTailRegistrationSessionStatus {
  CREATED = 'CREATED',
  GENERATING = 'GENERATING',
  GENERATION_FAILED = 'GENERATION_FAILED',
  PROPOSAL_READY = 'PROPOSAL_READY',
  REGISTERED = 'REGISTERED',
  SOURCE_ATTACHED = 'SOURCE_ATTACHED'
}

export enum LongTailRiskTier {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM'
}

export type LongTailSessionAlreadyRegisteredException = Exception & {
  __typename?: 'LongTailSessionAlreadyRegisteredException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  registrationSessionId: Scalars['ID']['output'];
};

export type LongTailSourceInput = {
  __typename?: 'LongTailSourceInput';
  contentUri?: Maybe<Scalars['String']['output']>;
  inlineContent?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  registrationSessionId: Scalars['ID']['output'];
  sourceInputId: Scalars['ID']['output'];
  sourceKind: LongTailSourceKind;
  updatedAt: Scalars['String']['output'];
};

export enum LongTailSourceKind {
  MANUAL_TOOL_DEFINITION = 'MANUAL_TOOL_DEFINITION',
  MCP_SERVER = 'MCP_SERVER',
  OPENAPI = 'OPENAPI'
}

export type LookupContactsFilters = {
  query?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type LookupContactsInput = {
  filters?: InputMaybe<LookupContactsFilters>;
  pageRequest: PageRequest;
};

export type LookupContactsOutput = GenericException | LookupContactsResult | UserInputException;

export type LookupContactsResult = {
  __typename?: 'LookupContactsResult';
  items: Array<PhoneContact>;
  pageInfo: PageInfo;
};

export type LookupEnrolledNumbersResult = GenericException | LookupEnrolledNumbersSuccess | NumberReputationException;

export type LookupEnrolledNumbersSuccess = {
  __typename?: 'LookupEnrolledNumbersSuccess';
  numbers: Array<EnrolledMonitoredNumber>;
};

export type LookupTeammatesFilters = {
  query?: InputMaybe<Scalars['String']['input']>;
};

export type LookupTeammatesInput = {
  filters?: InputMaybe<LookupTeammatesFilters>;
  pageRequest: PageRequest;
};

export type LookupTeammatesOutput = GenericException | LookupTeammatesResult | UserInputException;

export type LookupTeammatesResult = {
  __typename?: 'LookupTeammatesResult';
  items: Array<PhoneTeammate>;
  pageInfo: PageInfo;
};

export enum McpAuthStatus {
  ENABLED = 'ENABLED',
  NOT_INSTALLED = 'NOT_INSTALLED',
  REFRESH_TOKEN_INVALID = 'REFRESH_TOKEN_INVALID'
}

export type McpConfigOutput = GenericException | McpConfigResponse | ResourceNotFoundException | UserInputException;

export type McpConfigResponse = {
  __typename?: 'MCPConfigResponse';
  applicationId: Scalars['ID']['output'];
  applicationName: Scalars['String']['output'];
  authStatus: McpAuthStatus;
  authStrategy?: Maybe<Scalars['String']['output']>;
  authType?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['Int']['output'];
  grantedScopes: Array<Scalars['String']['output']>;
  mcpUrl?: Maybe<Scalars['String']['output']>;
  partnerWorkspaceId?: Maybe<Scalars['String']['output']>;
  reauthorizationUrl?: Maybe<Scalars['String']['output']>;
  tools: Array<McpToolSummary>;
};

export type McpTool = {
  __typename?: 'MCPTool';
  additionalDescription?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  iconUrl?: Maybe<Scalars['String']['output']>;
  inputSchema: Scalars['String']['output'];
  outputSchema?: Maybe<Scalars['String']['output']>;
  paramValueSources?: Maybe<Array<ParamValueSource>>;
  presetArgs?: Maybe<Array<PresetArg>>;
  runOnConnect?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  toolName: Scalars['String']['output'];
  validationRules?: Maybe<Array<ValidationRule>>;
  versionHash?: Maybe<Scalars['String']['output']>;
};

export type McpToolInput = {
  additionalDescription?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  inputSchema: Scalars['String']['input'];
  outputSchema?: InputMaybe<Scalars['String']['input']>;
  paramValueSources?: InputMaybe<Array<ParamValueSourceInput>>;
  presetArgs?: InputMaybe<Array<PresetArgInput>>;
  runOnConnect?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  toolName: Scalars['String']['input'];
  validationRules?: InputMaybe<Array<ValidationRuleInput>>;
  versionHash?: InputMaybe<Scalars['String']['input']>;
};

export type McpToolSummary = {
  __typename?: 'MCPToolSummary';
  canEnable: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  missingScopes: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  requiredScopes: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type MmsConfiguration = {
  __typename?: 'MMSConfiguration';
  maxNumberOfFiles: Scalars['Int']['output'];
  mediaTypes: Array<MmsMediaType>;
  totalSizeLimit: Scalars['Int']['output'];
};

export type MmsMediaType = {
  __typename?: 'MMSMediaType';
  extension: Array<Scalars['String']['output']>;
  maxSize: Scalars['Int']['output'];
  mimeType: Scalars['String']['output'];
};

export type MapUrlInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search_query?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type MapUrlResponse = {
  __typename?: 'MapURLResponse';
  limit: Scalars['Int']['output'];
  links: Array<SitemapLink>;
  total: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type MapUrlResult = GenericException | MapUrlResponse;

export enum MatchType {
  EXACT_MATCH = 'EXACT_MATCH',
  PARTIAL_MATCH = 'PARTIAL_MATCH'
}

export type MatrixUsersEvaluationsFilter = {
  callTags?: InputMaybe<Array<Scalars['ID']['input']>>;
  from?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  fromCallStartedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maxNormalizedScore?: InputMaybe<Scalars['Int']['input']>;
  minNormalizedScore?: InputMaybe<Scalars['Int']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  scoreCardId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  toCallStartedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MatrixUsersEvaluationsResult = GenericException | PaginatedUsersEvaluated | UserInputException;

export type MaxFlowSizeReachedException = Exception & {
  __typename?: 'MaxFlowSizeReachedException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type MaxTeamsAssignedException = Exception & {
  __typename?: 'MaxTeamsAssignedException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  resource?: Maybe<Scalars['String']['output']>;
};

export type MaximumConfirmedPrerecordedMessagesReachedException = Exception & {
  __typename?: 'MaximumConfirmedPrerecordedMessagesReachedException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type MediaDetails = {
  __typename?: 'MediaDetails';
  fileName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type MediaDetailsInput = {
  fileName: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type MediaTypeConfiguration = {
  __typename?: 'MediaTypeConfiguration';
  extension: Array<Scalars['String']['output']>;
  maxSize: Scalars['Int']['output'];
  mimeType: Scalars['String']['output'];
};

export type MergeWarmTransferCallOutput = GenericException | NoTransferInProgressException | TransferAlreadyInProgressException | TransferCallHasEndedException | TransferCallNotFoundException | TransferFailedException | WarmTransferCall;

export type Message = {
  __typename?: 'Message';
  ID: Scalars['ID']['output'];
  agent?: Maybe<MessagingAgent>;
  channel?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<Conversation>;
  createdAt: Scalars['String']['output'];
  direction: MessageDirection;
  groupConversationId?: Maybe<Scalars['ID']['output']>;
  hasUnsupportedContent?: Maybe<Scalars['Boolean']['output']>;
  mediaDetails?: Maybe<Array<MediaDetails>>;
  status: MessageStatus;
  text?: Maybe<Scalars['String']['output']>;
  undeliveredReason?: Maybe<MessageUndeliveredReason>;
};

export enum MessageChannel {
  SMS_MMS = 'SMS_MMS',
  WHATSAPP = 'WHATSAPP'
}

export type MessageConnection = {
  __typename?: 'MessageConnection';
  messages: Array<Message>;
  pageInfo: PageInfo;
};

export type MessageConversationsCountPerCategory = {
  __typename?: 'MessageConversationsCountPerCategory';
  aimaCount: Scalars['Int']['output'];
  assignedCount: Scalars['Int']['output'];
  messageCount: Scalars['Int']['output'];
  whatsappCount: Scalars['Int']['output'];
};

export type MessageConversationsCountPerCategoryOutput = GenericException | MessageConversationsCountPerCategory | UserInputException;

export enum MessageDirection {
  received = 'received',
  sent = 'sent'
}

export type MessageEngagement = Engagement & {
  __typename?: 'MessageEngagement';
  ID: Scalars['ID']['output'];
  author: EngagementAuthor;
  authorV2?: Maybe<EngagementAuthorV2>;
  conversation: AircallWorkspaceConversationResolver;
  createdAt: Scalars['AWSDateTime']['output'];
  externalNumber: Scalars['String']['output'];
  message: MessageResolver;
};

export type MessageEngagementResolver = {
  __typename?: 'MessageEngagementResolver';
  entity?: Maybe<MessageEngagement>;
};

export type MessageEngagementResolverInput = {
  __typename?: 'MessageEngagementResolverInput';
  companyID: Scalars['ID']['output'];
  conversationID: Scalars['ID']['output'];
  resourceType: MessageEngagementResourceType;
  timestamp?: Maybe<Scalars['AWSDateTime']['output']>;
};

export enum MessageEngagementResourceType {
  ANY = 'ANY',
  SMS_MMS = 'SMS_MMS',
  WHATSAPP = 'WHATSAPP'
}

export type MessageInput = {
  ID: Scalars['ID']['input'];
  agentID?: InputMaybe<Scalars['ID']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  conversationID: Scalars['ID']['input'];
  createdAt: Scalars['String']['input'];
  direction: MessageDirection;
  groupConversationId?: InputMaybe<Scalars['ID']['input']>;
  hasUnsupportedContent: Scalars['Boolean']['input'];
  mediaDetails?: InputMaybe<Array<MediaDetailsInput>>;
  status: MessageStatus;
  text?: InputMaybe<Scalars['String']['input']>;
  undeliveredReason?: InputMaybe<MessageUndeliveredReason>;
  whatsAppCustomerServiceWindowClosingTime?: InputMaybe<Scalars['String']['input']>;
};

export type MessageResolver = {
  __typename?: 'MessageResolver';
  entity: BaseMessage;
};

export type MessageResolverInput = {
  __typename?: 'MessageResolverInput';
  companyID: Scalars['String']['output'];
  messageID: Scalars['ID']['output'];
};

export enum MessageStatus {
  delivered = 'delivered',
  not_sent = 'not_sent',
  pending = 'pending',
  read = 'read',
  received = 'received',
  sent = 'sent',
  undelivered = 'undelivered'
}

export enum MessageUndeliveredReason {
  a2p10dlc_dailymessage_cap_reached = 'a2p10dlc_dailymessage_cap_reached',
  a2p_daily_messages_cap_reached = 'a2p_daily_messages_cap_reached',
  agent_licence_not_assigned = 'agent_licence_not_assigned',
  cannot_access_link = 'cannot_access_link',
  cannot_access_media_file = 'cannot_access_media_file',
  cannot_generate_signed_url = 'cannot_generate_signed_url',
  carrier_unknown_error = 'carrier_unknown_error',
  carrier_unreachable = 'carrier_unreachable',
  channel_did_not_accept_content = 'channel_did_not_accept_content',
  channel_policy_violation = 'channel_policy_violation',
  content_size_exceeds_carrier_limit = 'content_size_exceeds_carrier_limit',
  daily_limit_exceeded = 'daily_limit_exceeded',
  delivery_receipt_expired = 'delivery_receipt_expired',
  destination_missing_credit = 'destination_missing_credit',
  destination_rejected_handset = 'destination_rejected_handset',
  destination_rejected_message = 'destination_rejected_message',
  downstream_carrier_error = 'downstream_carrier_error',
  external_number_unknown = 'external_number_unknown',
  external_number_unreachable = 'external_number_unreachable',
  file_size_exceeds_carrier_limit = 'file_size_exceeds_carrier_limit',
  freeform_outside_allowed_window = 'freeform_outside_allowed_window',
  from_number_not_mms_enabled = 'from_number_not_mms_enabled',
  invalid_content_type = 'invalid_content_type',
  invalid_external_number = 'invalid_external_number',
  invalid_template_status = 'invalid_template_status',
  invalid_whatsapp_recipient = 'invalid_whatsapp_recipient',
  media_failed_to_download = 'media_failed_to_download',
  media_filtered = 'media_filtered',
  message_blocked = 'message_blocked',
  message_filtered = 'message_filtered',
  meta_choose_not_to_deliver_marketing_message = 'meta_choose_not_to_deliver_marketing_message',
  meta_choose_not_to_deliver_template = 'meta_choose_not_to_deliver_template',
  mms_invalid_content_type = 'mms_invalid_content_type',
  mms_not_supported_by_receiving_number = 'mms_not_supported_by_receiving_number',
  not_a_valid_number = 'not_a_valid_number',
  number_health_blocked = 'number_health_blocked',
  number_not_registered = 'number_not_registered',
  number_not_verified = 'number_not_verified',
  opted_out_recipient = 'opted_out_recipient',
  originator_missing_credit = 'originator_missing_credit',
  pending_number_registration = 'pending_number_registration',
  rate_limit_exceeded = 'rate_limit_exceeded',
  sender_not_provisioned_on_carrier = 'sender_not_provisioned_on_carrier',
  sub_status_unspecified = 'sub_status_unspecified',
  template_disabled = 'template_disabled',
  template_not_found = 'template_not_found',
  template_suspended = 'template_suspended',
  too_many_requests = 'too_many_requests',
  unsupported_number = 'unsupported_number',
  unsupported_region = 'unsupported_region',
  whatsapp_account_locked = 'whatsapp_account_locked',
  whatsapp_platform_restriction = 'whatsapp_platform_restriction',
  whatsapp_sender_not_approved = 'whatsapp_sender_not_approved'
}

export type MessagingAiAgent = {
  __typename?: 'MessagingAIAgent';
  ID: Scalars['ID']['output'];
  actions: Array<MessagingAiAgentAction>;
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  draft?: Maybe<MessagingAiDraftMeta>;
  isActive: Scalars['Boolean']['output'];
  knowledgeBaseId?: Maybe<Scalars['String']['output']>;
  lineSchedules: Array<MessagingAiAgentLineSchedule>;
  lines: Array<LineResolver>;
  name: Scalars['String']['output'];
  tools: Array<MessagingAiAgentToolItem>;
  updatedAt: Scalars['AWSDateTime']['output'];
  variables?: Maybe<MessagingAiAgentVariables>;
};

export type MessagingAiAgentAction = {
  __typename?: 'MessagingAIAgentAction';
  actionName: Scalars['String']['output'];
  additionalInstructions?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  validationRule?: Maybe<MessagingAiValidationRule>;
};

export type MessagingAiAgentActionInput = {
  actionName: Scalars['String']['input'];
  additionalInstructions?: InputMaybe<Scalars['String']['input']>;
  validationRule?: InputMaybe<MessagingAiValidationRuleInput>;
};

export type MessagingAiAgentEscalationRequested = Engagement & {
  __typename?: 'MessagingAIAgentEscalationRequested';
  ID: Scalars['ID']['output'];
  agent: MessagingAiAgentResolver;
  createdAt: Scalars['AWSDateTime']['output'];
};

export type MessagingAiAgentEscalationResolved = Engagement & {
  __typename?: 'MessagingAIAgentEscalationResolved';
  ID: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
};

export type MessagingAiAgentLineSchedule = {
  __typename?: 'MessagingAIAgentLineSchedule';
  enableWorkingHours: Scalars['Boolean']['output'];
  lineId: Scalars['Int']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  workingHours?: Maybe<Array<MessagingAiWorkingHoursSlot>>;
};

export type MessagingAiAgentListItem = {
  __typename?: 'MessagingAIAgentListItem';
  ID: Scalars['ID']['output'];
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  isActive: Scalars['Boolean']['output'];
  knowledgeBaseId?: Maybe<Scalars['String']['output']>;
  lines: Array<LineResolver>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  variables?: Maybe<MessagingAiAgentVariables>;
};

export enum MessagingAiAgentOrderBy {
  isActive = 'isActive',
  name = 'name'
}

export type MessagingAiAgentResolver = {
  __typename?: 'MessagingAIAgentResolver';
  entity: MessagingAiAgentResolverOutput;
};

export type MessagingAiAgentResolverInput = {
  __typename?: 'MessagingAIAgentResolverInput';
  ID: Scalars['ID']['output'];
  companyID: Scalars['ID']['output'];
};

export type MessagingAiAgentResolverOutput = MessagingAiAgent | ResourceNotFoundException;

export type MessagingAiAgentStarted = Engagement & {
  __typename?: 'MessagingAIAgentStarted';
  ID: Scalars['ID']['output'];
  agent: MessagingAiAgentResolver;
  createdAt: Scalars['AWSDateTime']['output'];
};

export type MessagingAiAgentStopped = Engagement & {
  __typename?: 'MessagingAIAgentStopped';
  ID: Scalars['ID']['output'];
  agent: MessagingAiAgentResolver;
  author: MessagingAiAgentStoppedAuthor;
  createdAt: Scalars['AWSDateTime']['output'];
  stoppedReason?: Maybe<MessagingAiAgentStoppedReason>;
};

export type MessagingAiAgentStoppedAuthor = PhoneTeammateResolver | SystemEntity;

export enum MessagingAiAgentStoppedReason {
  ESCALATION_REQUESTED = 'ESCALATION_REQUESTED',
  LINE_OFF = 'LINE_OFF',
  MANUALLY_DISABLED = 'MANUALLY_DISABLED'
}

export type MessagingAiAgentSummary = {
  __typename?: 'MessagingAIAgentSummary';
  ID: Scalars['ID']['output'];
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  isActive: Scalars['Boolean']['output'];
  lineSchedules: Array<MessagingAiAgentLineSchedule>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type MessagingAiAgentToolItem = {
  __typename?: 'MessagingAIAgentToolItem';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parameterSchema: Scalars['AWSJSON']['output'];
  toolDefinitionId: Scalars['ID']['output'];
  variables: Scalars['AWSJSON']['output'];
};

export type MessagingAiAgentToolVariablesInput = {
  agentToolId: Scalars['ID']['input'];
  variables: MessagingAiToolVariablesInput;
};

export type MessagingAiAgentVariables = {
  __typename?: 'MessagingAIAgentVariables';
  accepted_languages?: Maybe<Array<Scalars['String']['output']>>;
  actions_guidelines?: Maybe<Scalars['String']['output']>;
  agent_profile?: Maybe<Scalars['String']['output']>;
  company_description?: Maybe<Scalars['String']['output']>;
  company_name?: Maybe<Scalars['String']['output']>;
  conversational_guidelines?: Maybe<Scalars['String']['output']>;
  customer_info?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  fallback_language?: Maybe<Scalars['String']['output']>;
  farewell?: Maybe<Scalars['String']['output']>;
  greeting?: Maybe<Scalars['String']['output']>;
  max_length?: Maybe<Scalars['String']['output']>;
  persona?: Maybe<Scalars['String']['output']>;
  target_length?: Maybe<Scalars['String']['output']>;
  transfer_rules?: Maybe<Scalars['String']['output']>;
};

export type MessagingAiAgentVariablesInput = {
  accepted_languages?: InputMaybe<Array<Scalars['String']['input']>>;
  actions_guidelines?: InputMaybe<Scalars['String']['input']>;
  agent_profile?: InputMaybe<Scalars['String']['input']>;
  company_description?: InputMaybe<Scalars['String']['input']>;
  company_name?: InputMaybe<Scalars['String']['input']>;
  conversational_guidelines?: InputMaybe<Scalars['String']['input']>;
  customer_info?: InputMaybe<Scalars['String']['input']>;
  customer_name?: InputMaybe<Scalars['String']['input']>;
  fallback_language?: InputMaybe<Scalars['String']['input']>;
  farewell?: InputMaybe<Scalars['String']['input']>;
  greeting?: InputMaybe<Scalars['String']['input']>;
  max_length?: InputMaybe<Scalars['String']['input']>;
  persona?: InputMaybe<Scalars['String']['input']>;
  target_length?: InputMaybe<Scalars['String']['input']>;
  transfer_rules?: InputMaybe<Scalars['String']['input']>;
};

export type MessagingAiAgentsConnection = {
  __typename?: 'MessagingAIAgentsConnection';
  items: Array<MessagingAiAgentListItem>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type MessagingAiConversationStopStatus = {
  __typename?: 'MessagingAIConversationStopStatus';
  actor?: Maybe<MessagingAiStopActor>;
  isStopped: Scalars['Boolean']['output'];
  stoppedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type MessagingAiCreateAgentInput = {
  name: Scalars['String']['input'];
  variables?: InputMaybe<MessagingAiAgentVariablesInput>;
};

export enum MessagingAiDayOfWeek {
  FRIDAY = 'FRIDAY',
  MONDAY = 'MONDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
  THURSDAY = 'THURSDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY'
}

export type MessagingAiDiscardAgentDraftResult = GenericException | MessagingAiDiscardAgentDraftSuccess | ResourceNotFoundException;

export type MessagingAiDiscardAgentDraftSuccess = {
  __typename?: 'MessagingAIDiscardAgentDraftSuccess';
  agentId: Scalars['ID']['output'];
};

export type MessagingAiDraftActionInput = {
  actionName: Scalars['String']['input'];
  additionalInstructions?: InputMaybe<Scalars['String']['input']>;
  validationRule?: InputMaybe<MessagingAiValidationRuleInput>;
};

export type MessagingAiDraftConfigInput = {
  actions?: InputMaybe<Array<MessagingAiDraftActionInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  escalationMode?: InputMaybe<MessagingAiEscalationMode>;
  knowledgeBaseId?: InputMaybe<Scalars['String']['input']>;
  llmModelVersion?: InputMaybe<Scalars['String']['input']>;
  maxTokens?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
  tools?: InputMaybe<Array<MessagingAiDraftToolInput>>;
  variables?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type MessagingAiDraftMeta = {
  __typename?: 'MessagingAIDraftMeta';
  createdAt: Scalars['AWSDateTime']['output'];
  draftId: Scalars['ID']['output'];
  lastEditedBy?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  version: Scalars['Int']['output'];
};

export type MessagingAiDraftToolInput = {
  agentToolId: Scalars['ID']['input'];
  variables: MessagingAiToolVariablesInput;
};

export enum MessagingAiEscalationMode {
  ESCALATION = 'ESCALATION',
  ESCALATION_AFTER_INTAKE = 'ESCALATION_AFTER_INTAKE'
}

export type MessagingAiLineAllocatedHours = {
  __typename?: 'MessagingAILineAllocatedHours';
  agents: Array<MessagingAiLineAllocatedHoursAgent>;
  completeThreadBeforeSwitch: Scalars['Boolean']['output'];
  lineId: Scalars['Int']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
};

export type MessagingAiLineAllocatedHoursAgent = {
  __typename?: 'MessagingAILineAllocatedHoursAgent';
  agentId: Scalars['ID']['output'];
  alwaysOn: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  workingHours?: Maybe<Array<MessagingAiWorkingHoursSlot>>;
};

export type MessagingAiLineInput = {
  enableWorkingHours?: InputMaybe<Scalars['Boolean']['input']>;
  isActive: Scalars['Boolean']['input'];
  lineId: Scalars['Int']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  workingHours?: InputMaybe<Array<MessagingAiWorkingHoursSlotInput>>;
};

export enum MessagingAiMatchType {
  EXACT_MATCH = 'EXACT_MATCH',
  PARTIAL_MATCH = 'PARTIAL_MATCH'
}

export type MessagingAiMediaAttachmentInput = {
  key: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
};

export type MessagingAiMediaUploadMetadataInput = {
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  mimeType: Scalars['String']['input'];
};

export enum MessagingAiPlaygroundChannel {
  SMS = 'SMS',
  WHATSAPP = 'WHATSAPP'
}

export type MessagingAiPlaygroundChatInput = {
  agentId: Scalars['ID']['input'];
  channel?: InputMaybe<MessagingAiPlaygroundChannel>;
  draftId?: InputMaybe<Scalars['ID']['input']>;
  media?: InputMaybe<Array<MessagingAiMediaAttachmentInput>>;
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
};

export type MessagingAiPlaygroundChatResponse = {
  __typename?: 'MessagingAIPlaygroundChatResponse';
  isEscalated: Scalars['Boolean']['output'];
  isFallback: Scalars['Boolean']['output'];
  mediaHandoffReason?: Maybe<Scalars['String']['output']>;
  reply: Scalars['String']['output'];
  sessionId: Scalars['ID']['output'];
  threadBoundaryReason?: Maybe<Scalars['String']['output']>;
  toolCalls: Array<MessagingAiPlaygroundToolCall>;
  usage: MessagingAiPlaygroundUsage;
};

export type MessagingAiPlaygroundChatResult = GenericException | MessagingAiPlaygroundChatResponse | ResourceNotFoundException | UserInputException;

export type MessagingAiPlaygroundDeleteSessionResult = GenericException | MessagingAiPlaygroundDeleteSessionSuccess | ResourceNotFoundException;

export type MessagingAiPlaygroundDeleteSessionSuccess = {
  __typename?: 'MessagingAIPlaygroundDeleteSessionSuccess';
  sessionId: Scalars['ID']['output'];
};

export type MessagingAiPlaygroundMessage = {
  __typename?: 'MessagingAIPlaygroundMessage';
  direction: MessagingAiPlaygroundMessageDirection;
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export enum MessagingAiPlaygroundMessageDirection {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND'
}

export type MessagingAiPlaygroundToolCall = {
  __typename?: 'MessagingAIPlaygroundToolCall';
  name: Scalars['String']['output'];
  status: MessagingAiPlaygroundToolCallStatus;
  step: Scalars['Int']['output'];
};

export enum MessagingAiPlaygroundToolCallStatus {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS'
}

export type MessagingAiPlaygroundUsage = {
  __typename?: 'MessagingAIPlaygroundUsage';
  completionTokens: Scalars['Int']['output'];
  promptTokens: Scalars['Int']['output'];
};

export type MessagingAiPresignMediaUploadInput = {
  agentId: Scalars['ID']['input'];
  metadata: Array<MessagingAiMediaUploadMetadataInput>;
};

export type MessagingAiPresignMediaUploadResult = GenericException | MessagingAiPresignMediaUploadSuccess | ResourceNotFoundException | UserInputException;

export type MessagingAiPresignMediaUploadSuccess = {
  __typename?: 'MessagingAIPresignMediaUploadSuccess';
  presignedMediaUrlDetails: Array<MessagingAiPresignedMediaUrlDetails>;
};

export type MessagingAiPresignedMediaUrlDetails = {
  __typename?: 'MessagingAIPresignedMediaUrlDetails';
  expiry: Scalars['String']['output'];
  fields: Array<MessagingAiPresignedUploadField>;
  fileName: Scalars['String']['output'];
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type MessagingAiPresignedUploadField = {
  __typename?: 'MessagingAIPresignedUploadField';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type MessagingAiPublishAgentDraftResult = GenericException | MessagingAiAgent | ResourceNotFoundException;

export type MessagingAiSaveAgentDraftResult = AgentDraftConflictException | GenericException | MessagingAiAgent | ResourceNotFoundException | UserInputException;

export type MessagingAiSaveDraftInput = {
  config: MessagingAiDraftConfigInput;
  draftId?: InputMaybe<Scalars['ID']['input']>;
  lastEditedBy?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type MessagingAiSessionCount = {
  __typename?: 'MessagingAISessionCount';
  count: Scalars['Int']['output'];
};

export type MessagingAiSetConversationEscalationResult = GenericException | MessagingAiSetConversationEscalationSuccess | ResourceNotFoundException;

export type MessagingAiSetConversationEscalationSuccess = {
  __typename?: 'MessagingAISetConversationEscalationSuccess';
  companyId: Scalars['Int']['output'];
  externalId: Scalars['String']['output'];
  isEscalated: Scalars['Boolean']['output'];
  lineId: Scalars['Int']['output'];
};

export type MessagingAiSetConversationStoppedResult = GenericException | MessagingAiSetConversationStoppedSuccess | ResourceNotFoundException;

export type MessagingAiSetConversationStoppedSuccess = {
  __typename?: 'MessagingAISetConversationStoppedSuccess';
  companyId: Scalars['Int']['output'];
  externalId: Scalars['String']['output'];
  isStopped: Scalars['Boolean']['output'];
  lineId: Scalars['Int']['output'];
};

export type MessagingAiSetEscalationModeInput = {
  mode: MessagingAiEscalationMode;
  variables: MessagingAiToolVariablesInput;
};

export type MessagingAiSetIntakesUpfrontInput = {
  collectUpfront: Scalars['Boolean']['input'];
};

export enum MessagingAiSortOrder {
  asc = 'asc',
  desc = 'desc'
}

export enum MessagingAiStopActor {
  MESSAGING_AI_AGENT = 'MESSAGING_AI_AGENT',
  USER = 'USER'
}

export type MessagingAiToolVariableFieldInput = {
  description: Scalars['String']['input'];
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MessagingAiToolVariablesInput = {
  collectUpfront?: InputMaybe<Scalars['Boolean']['input']>;
  fields: Array<MessagingAiToolVariableFieldInput>;
};

export type MessagingAiUpdateAgentInput = {
  actions?: InputMaybe<Array<MessagingAiAgentActionInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  knowledgeBaseId?: InputMaybe<Scalars['String']['input']>;
  lines?: InputMaybe<Array<MessagingAiLineInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  tools?: InputMaybe<Array<MessagingAiAgentToolVariablesInput>>;
  variables?: InputMaybe<MessagingAiAgentVariablesInput>;
};

export type MessagingAiValidationRule = {
  __typename?: 'MessagingAIValidationRule';
  expected?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  matchType?: Maybe<MessagingAiMatchType>;
};

export type MessagingAiValidationRuleInput = {
  expected: Scalars['String']['input'];
  field: Scalars['String']['input'];
  matchType?: InputMaybe<MessagingAiMatchType>;
};

export type MessagingAiWorkingHoursSlot = {
  __typename?: 'MessagingAIWorkingHoursSlot';
  day: MessagingAiDayOfWeek;
  end: Scalars['String']['output'];
  start: Scalars['String']['output'];
};

export type MessagingAiWorkingHoursSlotInput = {
  day: MessagingAiDayOfWeek;
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export type MessagingAgent = {
  __typename?: 'MessagingAgent';
  ID: Scalars['ID']['output'];
  fullName: Scalars['String']['output'];
};

export type Meta = {
  __typename?: 'Meta';
  addressCity?: Maybe<Scalars['String']['output']>;
  addressCountry?: Maybe<Scalars['String']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressState?: Maybe<Scalars['String']['output']>;
  addressZip?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
};

export type MetaV3 = {
  __typename?: 'MetaV3';
  currentPage: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  perPage: Scalars['Int']['output'];
  previousPage?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type MetadataKeyValuePair = MetadataKeyValuePairBoolean;

export type MetadataKeyValuePairBoolean = {
  __typename?: 'MetadataKeyValuePairBoolean';
  key: MetadataTypeBoolean;
  value: Scalars['Boolean']['output'];
};

export type MetadataMediaUrls = {
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  mimeType: Scalars['String']['input'];
};

export enum MetadataTypeBoolean {
  SHOWN_CONFETTI_ON_DASHBOARD = 'SHOWN_CONFETTI_ON_DASHBOARD',
  SHOWN_CONFETTI_ON_PHONE = 'SHOWN_CONFETTI_ON_PHONE'
}

export type MetricAggregationScope = {
  avg?: InputMaybe<Scalars['Boolean']['input']>;
  max?: InputMaybe<Scalars['Boolean']['input']>;
  min?: InputMaybe<Scalars['Boolean']['input']>;
  sum?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MigrateIntegrationOutput = {
  __typename?: 'MigrateIntegrationOutput';
  redirectUri: Scalars['String']['output'];
};

export type MissedCallTicketOwner = {
  __typename?: 'MissedCallTicketOwner';
  key: Scalars['String']['output'];
  settings: Array<SettingsField>;
  subtitle?: Maybe<Scalars['String']['output']>;
  subtitleIcon?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MissedInboundPhoneCall = PhoneCall & {
  __typename?: 'MissedInboundPhoneCall';
  ID: Scalars['ID']['output'];
  archivedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  assigned?: Maybe<PhoneCallAssigned>;
  automaticCallbackRequest?: Maybe<PhoneCallAutomaticCallbackRequest>;
  callUuid: Scalars['String']['output'];
  caller: PhoneContactResolver;
  createdAt: Scalars['AWSDateTime']['output'];
  direction: PhoneCallDirection;
  duration: Scalars['Int']['output'];
  external: PhoneContactResolver;
  internalTags: Array<PhoneCallTag>;
  line: LineResolver;
  missedReason: PhoneCallMissedReason;
  notes: Array<PhoneCallNote>;
  outboundCampaignAttempt?: Maybe<OutboundCampaignAttemptResolver>;
  proxiedAudioUrl?: Maybe<Scalars['String']['output']>;
  proxiedVoicemailUrl?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<PhoneCallMissedReason>;
  recordingDurationMs?: Maybe<Scalars['Int']['output']>;
  status: PhoneCallStatus;
  tags: Array<PhoneCallTag>;
  timeline?: Maybe<PhoneCallTimelineResolver>;
  transcription?: Maybe<TranscriptionResolver>;
  type: PhoneCallType;
  voiceAgents?: Maybe<Array<VoiceAgentParticipant>>;
};

export type MissingTrackerAggregation = {
  __typename?: 'MissingTrackerAggregation';
  count: Scalars['Int']['output'];
};

export enum ModelAttributeTypes {
  _null = '_null',
  binary = 'binary',
  binarySet = 'binarySet',
  bool = 'bool',
  list = 'list',
  map = 'map',
  number = 'number',
  numberSet = 'numberSet',
  string = 'string',
  stringSet = 'stringSet'
}

export type ModelBooleanInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
  attributeType?: InputMaybe<ModelAttributeTypes>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ModelCountryFilterInput = {
  locale?: InputMaybe<ModelLocaleInput>;
  resellerId?: InputMaybe<Scalars['String']['input']>;
};

export type ModelFloatInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
  attributeType?: InputMaybe<ModelAttributeTypes>;
  between?: InputMaybe<Array<Scalars['Float']['input']>>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  ge?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  le?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
};

export type ModelIdInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
  attributeType?: InputMaybe<ModelAttributeTypes>;
  beginsWith?: InputMaybe<Scalars['ID']['input']>;
  between?: InputMaybe<Array<Scalars['ID']['input']>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  ge?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  le?: InputMaybe<Scalars['ID']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  size?: InputMaybe<ModelSizeInput>;
};

export type ModelIntInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
  attributeType?: InputMaybe<ModelAttributeTypes>;
  between?: InputMaybe<Array<Scalars['Int']['input']>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
};

export type ModelLocaleInput = {
  eq: Scalars['String']['input'];
};

export type ModelSizeInput = {
  between?: InputMaybe<Array<Scalars['Int']['input']>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
};

export enum ModelSortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type ModelStringInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
  attributeType?: InputMaybe<ModelAttributeTypes>;
  beginsWith?: InputMaybe<Scalars['String']['input']>;
  between?: InputMaybe<Array<Scalars['String']['input']>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  ge?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  le?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<ModelSizeInput>;
};

export type MonitoredNumber = {
  __typename?: 'MonitoredNumber';
  e164: Scalars['String']['output'];
  line?: Maybe<Line>;
  lineId: Scalars['ID']['output'];
  numberId: Scalars['ID']['output'];
  reputationData?: Maybe<NumberReputationData>;
  reputationLabel?: Maybe<NumberReputationLabel>;
  status: MonitoredNumberStatus;
};

export enum MonitoredNumberStatus {
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  VERIFIED = 'VERIFIED'
}

export type MonitoredNumbersFilter = {
  reputationLabel?: InputMaybe<NumberReputationLabel>;
  status?: InputMaybe<MonitoredNumberStatus>;
};

export type MonitoredNumbersList = {
  __typename?: 'MonitoredNumbersList';
  numbers: Array<MonitoredNumber>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type MonitoredNumbersListResult = GenericException | MonitoredNumbersList | NumberReputationException;

export enum MultiMatchQueryType {
  best_fields = 'best_fields',
  bool_prefix = 'bool_prefix',
  cross_fields = 'cross_fields',
  most_fields = 'most_fields',
  phrase = 'phrase',
  phrase_prefix = 'phrase_prefix'
}

export type Mutation = {
  __typename?: 'Mutation';
  a2pBandwidthCampaignNumberAssociation: A2pBandwidthCampaignNumberAssociationResult;
  a2pBandwidthCampaignNumberDeletion: A2pBandwidthCampaignNumberDeletionResult;
  a2pBulkCampaignCreation: A2pBulkCampaignCreationResult;
  activateAiAssist: ActivateAiAssistOutput;
  addBlacklistedNumber?: Maybe<BlacklistedNumber>;
  addBridgeIntegrations?: Maybe<Array<Maybe<AddBridgeIntegrationResponse>>>;
  addCompanyAcknowledgment: AddCompanyAcknowledgmentResponse;
  addCoreKBDocument?: Maybe<DocumentCreationResult>;
  addCoreKBDocuments?: Maybe<BulkDocumentUploadResult>;
  addDialerCampaignNumbers: AddDialerCampaignNumbersResult;
  addDispatchGroup: DispatchGroup;
  addExternalNumber: AgentPhoneNumber;
  addHubIntegrations?: Maybe<Array<Maybe<AddHubIntegrationResponse>>>;
  addIntegrationConnectedLines: MutationIntegrationConnectedLinesOutput;
  addIvrSetting: IvrSetting;
  addIvrSettingRest: IvrSettingResponse;
  addKeywords: AddKeywordsOutput;
  addKnowledgeDocument: AddKnowledgeDocumentResult;
  addMessage: AddMessageOutput;
  addMonitoredNumbers: AddMonitoredNumbersResult;
  addNextAction: NextActionAddedOutput;
  addNumberToIntegration: AddNumberToIntegrationOutput;
  addOutboundCaller: AddOutboundCallerMutationResponse;
  addOutboundCampaignCallOutcome: AddOutboundCampaignCallOutcomeOutput;
  addOutboundCampaignContacts: AddOutboundCampaignContactsOutput;
  addPaymentCard: UserCriticalAction;
  addWebDispatchGroup?: Maybe<WebDispatchGroup>;
  analyticsCreatePreset: AnalyticsPresetResult;
  analyticsDeletePreset: AnalyticsDeletePresetResult;
  analyticsExportCallsHistory: AnalyticsExportResult;
  analyticsExportMetrics: AnalyticsExportResult;
  analyticsExportMultipleValueMetricDrillDown: AnalyticsExportResult;
  analyticsExportSingleValueMetricDrillDown: AnalyticsExportResult;
  analyticsExportUserStatusHistory: AnalyticsExportResult;
  analyticsSharePreset: AnalyticsPresetResult;
  analyticsUpdatePreset: AnalyticsPresetResult;
  archiveOutboundCampaign: ArchiveOutboundCampaignOutput;
  assignActivationLicenses: AssignActivationLicensesOutput;
  assignAircallWorkspaceConversation: AircallWorkspaceConversationOutput;
  assignCustomSummaryConfiguration: AssignCustomSummaryConfigurationOutput;
  assignEsim: AssignEsimResponse;
  assignLicenses: AssignLicensesOutput;
  assignOutboundCampaignTeams: AssignOutboundCampaignTeamsOutput;
  assignOutboundCampaignUsers: AssignOutboundCampaignUsersOutput;
  assignPlaybookSettings: AssignPlaybookSettingsOutput;
  assignRolesToUser?: Maybe<AssignRolesToUserOutput>;
  attachLongTailSourceInput: AttachLongTailSourceInputOutput;
  authorizeApplication: AuthorizeApplicationOutput;
  authorizeApplicationMutation: AuthorizeApplicationResponse;
  authorizeChannels: AuthorizeChannelsOutput;
  branchOutAgentWorkspaceConversation: AircallWorkspaceConversationOutput;
  bulkCloseAircallWorkspaceConversations: AircallWorkspaceBooleanOutput;
  bulkCreateAircallExtract: BulkCreateAircallExtractOutput;
  bulkDeleteDialerCampaignNumbers: BulkDeleteDialerCampaignNumbersOutput;
  bulkEnableCoreKBRAG: CoreKbBulkEnableRagResultUnion;
  bulkReadAircallWorkspaceConversations: AircallWorkspaceBooleanOutput;
  bulkReopenAircallWorkspaceConversations: AircallWorkspaceBooleanOutput;
  bulkSubscribeFeatures: BulkSubscribeFeaturesOutput;
  bulkUnreadAircallWorkspaceConversations: AircallWorkspaceBooleanOutput;
  callDialerCampaignNumber: CallDialerCampaignNumberOutput;
  cancelPortingRequest: CancelPortingRequestResponse;
  cancelSimulation: CancelSimulationOutput;
  cancelSubscription: CancelSubscriptionOutput;
  changeEsimDevice: ChangeEsimDeviceResponse;
  changeEsimLicense: ChangeEsimLicenseResponse;
  changePasswordRequest?: Maybe<Void>;
  checkCarrierNumberVerification: CheckCarrierNumberVerificationResponse;
  cleanOutboundCampaignContactImportRows: CleanOutboundCampaignContactImportRowsOutput;
  clearStudioConversation: ClearStudioConversationOutput;
  cloneVirtualAgent: VirtualAgentOutput;
  closeAircallWorkspaceConversation: AircallWorkspaceConversationOutput;
  closeAircallWorkspaceConversationByCallID: AircallWorkspaceConversationOutput;
  completeTask: TaskState;
  configurePersonalLineForEsim?: Maybe<FlowConfigurationOutputV2>;
  confirmVerdict: ConfirmVerdictOutput;
  convertAivaAgentActions: ConvertAivaAgentActionsOutput;
  copySecretsByReference?: Maybe<SecretApiOutput>;
  copySecretsFromLine?: Maybe<SecretApiOutput>;
  createAction: ActionOutput;
  createAgentKBMapping: AgentKbMappingResult;
  createAgentTemplate: CreateAgentTemplateResult;
  createAircallExtract: CreateExtractOutput;
  createAivaAgentMigrationDraft: CreateAivaAgentMigrationDraftOutput;
  createAutomation: CreateAutomationOutput;
  createBlacklistedPhone: CreateBlacklistedPhoneOutput;
  createBrandDocumentUploadUrl: CreateBrandDocumentUploadUrlResult;
  createBrandDraft: BrandDraftResult;
  createBusinessDraft: BusinessDraftResult;
  createBusinessRegistration: CreateBusinessRegistrationResult;
  createCalendar: CalendarOutput;
  createCalendarV2: CalendarOutputV2;
  createCallingProfile: CreateCallingProfileResult;
  createCompanyKBMapping: CustomerKbMappingOutput;
  createCompanyPromotion: CreateCompanyPromotionOutput;
  createConversation: CreateConversationOutput;
  createCoreKB?: Maybe<KnowledgeBase>;
  createCoreKBIntegration?: Maybe<CoreKbIntegrationResult>;
  createCoreKBIntegrationSubscription?: Maybe<CoreKbIntegrationSubscriptionResult>;
  createCoreKBWithDocs?: Maybe<KnowledgeBase>;
  createCrawlDocument: CrawlDocumentOutput;
  createCrawlRoot: CrawlDocumentOutput;
  createCreditCardAccount?: Maybe<CreateCreditCardAccountOutput>;
  createDocumentUploadUrl: CreateDocumentUploadUrlResult;
  createEmergencyAddress: EmergencyAddress;
  createEvalScenario: CreateScenarioOutput;
  createEvaluation: EvaluationOutput;
  createGroupConversation: AircallWorkspaceConversationOutput;
  createIdentity: IdentityOutput;
  createKeywordTracker: CreateKeywordTrackerOutput;
  createKnowledgeBase: KnowledgeBaseOutput;
  createKycVerificationSession?: Maybe<KycVerificationSessionOutput>;
  createLine: Line;
  createLineTranscriptionSettings: CreateLineTranscriptionSettingsOutput;
  createLinesAsync: CreateLinesAsyncOutput;
  createLoaEnvelope: CreateLoaEnvelopeResult;
  createLongTailRegistrationSession: CreateLongTailRegistrationSessionOutput;
  createMessagingAIAgent: CreateMessagingAiAgentResult;
  createNote: NoteBase;
  createOnboarding?: Maybe<CreateOnboardingOutput>;
  createOrUpdateA2PForm: CreateOrUpdateA2PFormResult;
  createOutboundCampaign: CreateOutboundCampaignOutput;
  createOutboundCampaignOutcome: CreateOutboundCampaignOutcomeOutput;
  createPrerecordedMessage: CreatePrerecordedMessageOutput;
  createRestBridgeIntegration: RestIntegration;
  createRestSlackIntegration: CreateSlackIntegrationMutationResponse;
  createRestWebhook: RestWebhook;
  createSIPDevice: UserSipSettings;
  createSamlConfiguration: SamlConfiguration;
  createScenario: SavedScenarioOutput;
  createSipSetting: AgentSipSetting;
  createStripeDirectDebitSetup: StripeDirectDebitSetupOutput;
  createSupervision: CreateSupervisionOutput;
  createTag: Tag;
  createTasks?: Maybe<CreateTasksOutput>;
  createTeam: Team;
  createTemplate: CreateTemplateResult;
  createTrayIntegration: CreateTrayIntegrationOutput;
  createVirtualAgent: VirtualAgentOutput;
  createVirtualAgentTrialSession: CreateVirtualAgentTrialSessionOutput;
  createVirtualAgentUsageAlert: VirtualAgentUsageAlertOutput;
  createVirtualAgentWithBuilder: VirtualAgentOutput;
  createVoiceVirtualAgentAuthMethod: AuthMethodOutput;
  createWebhook: Webhook;
  deactivateWhatsAppNumber: DeactivateWhatsAppNumberResponse;
  deleteA2PForm: DeleteA2PFormResult;
  deleteAction: DeleteActionOutput;
  deleteAgent: DeleteAgentOutput;
  deleteAgentKBMapping?: Maybe<Scalars['Boolean']['output']>;
  deleteAgentTemplate: DeleteTemplateResult;
  deleteApiKey: DeleteApiKeyOutput;
  deleteAudio: DeleteAudioResult;
  deleteAutomation: DeleteAutomationOutput;
  deleteBlacklistedNumber: Void;
  deleteBlacklistedPhone: DeleteBlacklistedPhoneOutput;
  deleteBrand: DeleteBrandResult;
  deleteBrandDocument: DeleteBrandDocumentResult;
  deleteBrandDraft: DeleteBrandDraftResult;
  deleteBusinessDraft: DeleteBusinessDraftResult;
  deleteBusinessRegistration: DeleteBusinessRegistrationResult;
  deleteCalendar: DeleteCalendarOutput;
  deleteCalendarV2: DeleteCalendarOutputV2;
  deleteCallingProfile: DeleteCallingProfileResult;
  deleteCompanyContext: DeleteCompanyContextOutput;
  deleteCompanyKBMapping: DeleteCompanyKbMappingOutput;
  deleteContact: MutationDeleteContactOutput;
  deleteCoreKB?: Maybe<Scalars['Boolean']['output']>;
  deleteCoreKBDocument?: Maybe<Scalars['Boolean']['output']>;
  deleteCoreKBIntegration?: Maybe<Scalars['Boolean']['output']>;
  deleteCoreKBIntegrationSubscription?: Maybe<Scalars['Boolean']['output']>;
  deleteCrawlDocument: DeleteCrawlDocumentOutput;
  deleteCustomSummary: DeleteCustomSummaryOutput;
  deleteDispatchGroupREST?: Maybe<Void>;
  deleteDocument: DeleteDocumentResult;
  deleteEmergencyAddress: DeleteEmergencyAddressOutput;
  deleteEvalPersona: DeleteEvalPersonaOutput;
  deleteEvalScenario: DeleteScenarioOutput;
  deleteEvaluation: DeleteEvaluationOutput;
  deleteExternalNumber: DeleteExternalNumberOutput;
  deleteGSMDevice: DeleteGsmDeviceOutput;
  deleteIVRSetting?: Maybe<Void>;
  deleteIntegration: DeleteIntegrationOutput;
  deleteKeywordTracker: DeleteKeywordTrackerOutput;
  deleteKeywords: DeleteKeywordsOutput;
  deleteKnowledgeBase: DeleteKnowledgeBaseOutput;
  deleteLine: DeleteLineOutput;
  deleteMessagingAIAgent: DeleteMessagingAiAgentResult;
  deleteNextAction: NextActionDeletedOutput;
  deleteNote: NoteDeleted;
  deleteNumber: Number;
  deleteOutboundCaller: Void;
  deleteOutboundCampaign: DeleteOutboundCampaignOutput;
  deleteOutboundCampaignOutcome: DeleteOutboundCampaignOutcomeOutput;
  deletePlaybook: DeleteCustomPlaybookOutput;
  deletePrerecordedMessage: DeletePrerecordedMessageOutput;
  deleteRealtimeQuestionAnsweringCard: RealtimeQuestionAnsweringCardDeleteOutput;
  deleteSamlConfiguration: DeleteSamlConfigurationOutput;
  deleteScenario: DeletedScenarioOutput;
  deleteScoreCard: DeleteScoreCardOutput;
  deleteSecretByReference?: Maybe<DeleteReferenceSecretApiOutput>;
  deleteSipDevice?: Maybe<Void>;
  deleteSipSetting: DeleteSipSettingOutput;
  deleteSummaryTemplate: DeleteSummaryTemplateOutput;
  deleteSupervision: DeleteSupervisionOutput;
  deleteTag: DeleteTagOutput;
  deleteTeam: Team;
  deleteTemplate: DeleteTemplateResult;
  deleteTopic: DeleteTopicOutput;
  deleteTracker: DeleteTrackerOutput;
  deleteVirtualAgent: DeleteVirtualAgentOutput;
  deleteVoiceVirtualAgentAuthMethod: DeleteAuthMethodOutput;
  deleteWhatsappSubaccount: DeleteWhatsappSubaccountResponse;
  dialAgent: DialAgentOutput;
  disableEmailNotification: AgentEmailNotification;
  discardVirtualAgentDraft: DiscardVirtualAgentDraftOutput;
  dismissNotification: DismissNotificationResult;
  duplicateOutboundCampaign: DuplicateOutboundCampaignOutput;
  duplicatePlaybook: DuplicatePlaybookOutput;
  editCoreKBDocumentURL?: Maybe<DocumentResult>;
  enableDisableFeature: EnableDisableFeatureOutput;
  enableEmailNotification: AgentEmailNotification;
  enableIntegration: EnableIntegrationResponse;
  enableTrialFeature: EnableTrialFeatureOutput;
  endChatSession: EndChatSessionOutput;
  endCoachingSession: EndCoachingSessionResult;
  enrollInHubspotSequence: EnrollInHubspotSequenceOutput;
  enrollNumbers: EnrollNumbersResult;
  exportOutboundCampaignContactImportRows: ExportOutboundCampaignContactImportRowsOutput;
  exportVirtualAgent: ExportVirtualAgentOutput;
  extendMandatoryTagging: ExtendMandatoryTaggingOutput;
  forgotPassword?: Maybe<Void>;
  generateAIAnswers: Scalars['Boolean']['output'];
  generateActivationCompanyContext: GenerateActivationCompanyContextOutput;
  generateAdminMcpOauthGrantUrl: GenerateAdminMcpOauthGrantUrlOutput;
  generateAgentsExtract: AgentExtractOutput;
  generateApiKey: ApiKey;
  generateLinesExtract: LineExtractOutput;
  generateMessagingMediaUrls: GenerateMessagingMediaUrlsOutput;
  generateMessagingWhatsappMediaUrls: GenerateMessagingMediaWhatsappUrlsResult;
  generateMondayWebhookUrl: GenerateMondayWebhookUrlOutput;
  generateOAuthAuthorizationUrl: GenerateOAuthAuthorizationUrlOutput;
  generatePortingLoa: GeneratePortingLoaResponse;
  generatePrerecordedMessageUrl: GeneratePrerecordedMessageUrlOutput;
  generateSMSAutomationWebhookUrl: GenerateSmsAutomationWebhookUrlOutput;
  generateTeamsExtract: TeamExtractOutput;
  generateTtsMessage: GenerateTtsMessageOutput;
  generateUserAppActivityReport: UserAppActivityReportOutput;
  generateWhatsappHeaderMediaUrl: GenerateMessagingMediaWhatsappUrlsResult;
  getOrCreateKBForAgent: GetOrCreateKbForAgentResult;
  getTrackUploadUrl: GetTrackUploadUrlOutput;
  gradeApplication: GradeApplicationOutput;
  gradeMcpServer: GradeMcpServerOutput;
  gradeTool: GradeToolOutput;
  importVirtualAgent: VirtualAgentOutput;
  installCustomAiApp: InstallCustomAiAppOutput;
  invalidateAppSyncCache: InvalidateAppSyncCacheOutput;
  inviteMultipleUsers: UploadBulkUsersResult;
  inviteUser: AgentV2;
  joinBeta: BetaJoinedOutput;
  launchOutboundCampaign: LaunchOutboundCampaignOutput;
  linkTagsToCall?: Maybe<Array<Maybe<Tag>>>;
  liveMonitoringSetUserPreferences: LiveMonitoringUserPreferencesResult;
  markAircallWorkspaceConversationAsRead: AircallWorkspaceBooleanOutput;
  markAircallWorkspaceConversationAsUnread: AircallWorkspaceBooleanOutput;
  mergeWarmTransferCall: MergeWarmTransferCallOutput;
  messagingAIDiscardAgentDraft: MessagingAiDiscardAgentDraftResult;
  messagingAIPlaygroundChat: MessagingAiPlaygroundChatResult;
  messagingAIPlaygroundDeleteSession: MessagingAiPlaygroundDeleteSessionResult;
  messagingAIPresignMediaUpload: MessagingAiPresignMediaUploadResult;
  messagingAIPublishAgentDraft: MessagingAiPublishAgentDraftResult;
  messagingAISaveAgentDraft: MessagingAiSaveAgentDraftResult;
  messagingAISetConversationEscalation: MessagingAiSetConversationEscalationResult;
  messagingAISetConversationStopped: MessagingAiSetConversationStoppedResult;
  migrateIntegration: MigrateIntegrationOutput;
  migrateLineToSmartflows?: Maybe<FlowConfigurationOutput>;
  muteReputationNotifications: ReputationNotificationStatusResult;
  notify: NotifyOutput;
  notifyAgentAddedToLine: AgentAddedToLineNotificationOutput;
  notifyAgentConversationStatusAllUpdated: NotifyAgentConversationStatusAllUpdatedResult;
  notifyAgentConversationsStatusUpdated: NotifyAgentConversationsStatusUpdatedResult;
  notifyAgentRemovedFromLine: AgentRemovedFromLineNotificationOutput;
  notifyAircallWorkspaceConversationDeleted: AircallWorkspaceConversationDeletedNotificationOutput;
  notifyAircallWorkspaceConversationUpdated: AircallWorkspaceConversationUpdatedNotificationOutput;
  notifyAircallWorkspaceEngagementCreated: AircallWorkspaceEngagementCreatedNotificationOutput;
  notifyAircallWorkspaceEngagementUpdated: AircallWorkspaceEngagementUpdatedNotificationOutput;
  notifyAircallWorkspaceInboxUpdated: AircallWorkspaceInboxUpdatedNotificationOutput;
  notifyAircallWorkspaceUnreadConversationsCounterUpdated: UnreadConversationsCounterUpdatedOutput;
  notifyAnalyticsExportUpdated: AnalyticsExportUpdatedResult;
  notifyBulkCloseAircallWorkspaceConversations: BulkCloseAircallWorkspaceConversationsNotificationOutput;
  notifyBulkReopenAircallWorkspaceConversations: BulkReopenAircallWorkspaceConversationsNotificationOutput;
  notifyConversationCreated: NotifyConversationCreatedOutput;
  notifyConversationsAllRead: NotifyConversationsAllReadResult;
  notifyLineUpdated: LineUpdatedNotificationOutput;
  notifyMessageAdded: NotifyMessageAddedOutput;
  notifyMessageStatusUpdated: NotifyMessageStatusUpdatedOutput;
  notifyMessagingAIAgentUpdated: MessagingAiAgent;
  notifyOutboundCampaignAgentSessionQueueIdle?: Maybe<OutboundCampaignAgentSessionQueueIdleNotification>;
  notifyOutboundCampaignCallDispatched?: Maybe<OutboundCampaignCallDispatchedNotification>;
  notifyOutboundCampaignCallOutcomeAdded?: Maybe<OutboundCampaignCallOutcomeNotification>;
  notifyOutboundCampaignChanged?: Maybe<OutboundCampaignNotification>;
  notifyOutboundCampaignCompanyUnavailable?: Maybe<OutboundCampaignCompanyUnavailableNotification>;
  notifyOutboundCampaignNextCallQueued?: Maybe<OutboundCampaignNextCallQueuedNotification>;
  notifyOutboundCampaignQueueItemChanged?: Maybe<OutboundCampaignQueueItemNotification>;
  notifyOutboundCampaignUserDispatchFailed?: Maybe<OutboundCampaignUserDispatchFailedNotification>;
  notifyOutboundCampaignUserReadyChanged?: Maybe<OutboundCampaignUserReadyNotification>;
  notifyOutboundCampaignUserStatusChanged?: Maybe<OutboundCampaignUserStatusNotification>;
  onAIAnswersGenerated?: Maybe<AiAnswersGeneratedOutput>;
  onQuestionQualityHelperGenerated?: Maybe<QuestionQualityHelperGeneratedOutput>;
  outboundCampaignAddQueueItem: AddOutboundCampaignQueueItemOutput;
  outboundCampaignRemoveQueueItem: RemoveOutboundCampaignQueueItemOutput;
  outboundCampaignReorderQueueItem: ReorderOutboundCampaignQueueItemOutput;
  outboundCampaignScheduleQueueItem: ScheduleOutboundCampaignQueueItemOutput;
  pauseOutboundCampaign: PauseOutboundCampaignOutput;
  pauseOutboundCampaignSession: PauseOutboundCampaignSessionOutput;
  placeholderMutation: Scalars['String']['output'];
  planSubscribe: PlanSubscribeOutput;
  planUpgrade: PlanUpgradeOutput;
  provisionApplication: ProvisionApplicationOutput;
  provisionLongTailApplication: ProvisionLongTailApplicationOutput;
  publishScoreCard: ScoreCardOutput;
  publishVirtualAgentDraft: PublishVirtualAgentDraftOutput;
  purchaseLicenses: PurchaseLicensesOutput;
  questionQualityHelper: Scalars['Boolean']['output'];
  reactivateWebhook: ReactivateWebhookOutput;
  readConversation: ReadConversationOutput;
  readCurrentUserConversations: ReadCurrentUserConversationsResult;
  readCurrentUserConversationsByIds: AcknowledgeLineConversationsByIdsResult;
  reconcileEsim: ReconcileEsimResponse;
  recordActionResource: RecordActionResourceOutput;
  recoverPassword: RecoverPasswordOutput;
  refreshContactExtracts: MutationRefreshContactExtractsOutput;
  refreshCoreKB?: Maybe<KnowledgeBaseResult>;
  refreshCoreKBDocument?: Maybe<DocumentResult>;
  refreshCoreKBIntegration?: Maybe<CoreKbIntegrationSyncResult>;
  regenerateSFOmnichannelApiKey: RegenerateSfOmnichannelApiKeyOutput;
  registerLongTailApplication: RegisterLongTailApplicationOutput;
  registerPushDevice: RegisterPushDeviceOutput;
  registerWhatsAppNumber: RegisterWhatsAppNumberResponse;
  rejectDispatch: RejectDispatchOutput;
  releaseActivationWizard: ReleaseActivationWizardOutput;
  relinkCoreKBDocument?: Maybe<RelinkCoreKbDocumentUnionResult>;
  removeBrandLogo: RemoveBrandLogoResult;
  removeErrorDocuments?: Maybe<RemoveErrorDocumentsUnionResult>;
  removeIntegrationConnectedLines: MutationIntegrationConnectedLinesOutput;
  removeLicenses: RemoveLicensesOutput;
  removeMonitoredNumbers: RemoveMonitoredNumbersResult;
  removeNumberConnectedIntegrationBridge?: Maybe<Void>;
  removeNumberConnectedIntegrationHub?: Maybe<Void>;
  removeNumberFromIntegration: RemoveNumberFromIntegrationOutput;
  removeOutboundCampaignContactImportRows: RemoveOutboundCampaignContactImportRowsOutput;
  removeOutboundCampaignTeams: RemoveOutboundCampaignTeamOutput;
  removeOutboundCampaignUsers: RemoveOutboundCampaignUserOutput;
  renameCoreKB?: Maybe<KnowledgeBaseDetailsResult>;
  renameCoreKBDocument?: Maybe<DocumentResult>;
  reopenAircallWorkspaceConversation: AircallWorkspaceConversationOutput;
  requestFeature: RequestFeatureOutput;
  requestOutboundCampaignContactImportFromCrm: RequestOutboundCampaignContactImportFromCrmOutput;
  requestOutboundCampaignContactImportUpload: RequestOutboundCampaignContactImportUploadOutput;
  requestTarget?: Maybe<RequestTargetOutput>;
  requestVerificationGSMDevice: RequestVerificationGsmDeviceResult;
  resendCriticalAction: UserCriticalAction;
  resendEmailInvitation: ResendEmailInvitationOutput;
  resendEvent: ResendEventOutput;
  resetPassword?: Maybe<ResetPasswordMutationResponse>;
  restoreLicenses: RestoreLicensesOutput;
  resubmitBrandDocument: ResubmitBrandDocumentResult;
  resumeOutboundCampaign: ResumeOutboundCampaignOutput;
  revokeAdminMcpOauthGrant: RevokeAdminMcpOauthGrantOutput;
  saveActivationCompanyContext: SaveActivationCompanyContextOutput;
  saveCallConfiguration: SaveCallConfigurationOutput;
  saveCompanyContext: SaveCompanyContextOutput;
  saveCustomSummary: SaveCustomSummaryOutput;
  saveCustomSummaryResult: SaveCustomSummaryResultOutput;
  saveDraftScoreCard: ScoreCardOutput;
  saveNetworkDiagnostic: SaveNetworkDiagnosticOutput;
  savePlaybook: SaveCustomPlaybookOutput;
  savePlaybookResult: SavePlaybookResultOutput;
  savePortingFields: SavePortingFieldsResponse;
  saveRealtimeQuestionAnsweringCard: RealtimeQuestionAnsweringCardOutput;
  saveSummaryDiscoveryTemplate: SaveSummaryDiscoveryTemplateOutput;
  saveSummaryOptionsTemplate: SaveSummaryOptionsTemplateOutput;
  saveSummaryValidationTemplate: SaveSummaryValidationTemplateOutput;
  saveTopic: SaveTopicOutput;
  saveVirtualAgentDraft: SaveVirtualAgentDraftOutput;
  scheduleGsmCall: ScheduleGsmCallOutput;
  sendChatMessage: SendChatMessageOutput;
  sendCoachingMessage: SendCoachingMessageResult;
  sendConfirmationEmail: Void;
  sendGroupMessage: SendMessageV2Result;
  sendMessage: SendMessageOutput;
  sendMessageV2: SendMessageV2Result;
  sendPauseResumeVoiceCallTrans: SendPauseResumeVoiceCallTransOutput;
  setActivePlaybook?: Maybe<SetActivePlaybookOutput>;
  setConnectPlaneApplicationAuthHeader: SetConnectPlaneApplicationAuthHeaderOutput;
  setConnectPlaneToolAvailability: SetConnectPlaneToolAvailabilityOutput;
  setConnectPlaneToolCompanies: SetConnectPlaneToolCompaniesOutput;
  setDesktopState: SetDesktopStateOutput;
  setFlowToLine?: Maybe<FlowConfigurationOutput>;
  setFlowToLineV2?: Maybe<FlowConfigurationOutputV2>;
  setIntegrationStaticCredential: SetIntegrationStaticCredentialOutput;
  setLineSettings?: Maybe<LineSettingsOutput>;
  setMessagingAIAgentEscalationMode: SetMessagingAiAgentEscalationModeResult;
  setMessagingAIAgentIntakesUpfront: SetMessagingAiAgentIntakesUpfrontResult;
  setMetadata?: Maybe<SetMetadataOutput>;
  setNotificationsConfiguration: NotificationsConfiguration;
  setRealtimeQuestionAnsweringAssignment: RealtimeQuestionAnsweringSetAssignmentOutput;
  shareCoreKBDocument?: Maybe<ShareCoreKbDocumentUnionResult>;
  skipTask: TaskState;
  skipWrapUp: SkipWrapUpOutput;
  startActivationWizard: StartActivationWizardOutput;
  startAgentInsightsJob: AgentInsightsJobOutput;
  startCarrierNumberVerification: StartCarrierNumberVerificationResponse;
  startChatSession: StartChatSessionOutput;
  startCoachingSession: StartCoachingSessionResult;
  startEvalRun: StartEvalRunOutput;
  startEvaluateConfigurationJob: ConfigEvaluationJobOutput;
  startLongTailGenerationJob: StartLongTailGenerationJobOutput;
  startOutboundCampaignSession: StartOutboundCampaignSessionOutput;
  startSimulation: SimulationJobOutput;
  startStudioConversation: StartStudioConversationOutput;
  startStudioTurn: StartStudioTurnOutput;
  stopWarmTransferCall: StopWarmTransferCallOutput;
  submitAgentChatFeedback: SubmitAgentChatFeedbackOutput;
  submitBrand: SubmitBrandResult;
  submitQuestionnaire: SubmitQuestionnaireOutput;
  submitSuggestionFeedback: SubmitSuggestionFeedbackResult;
  submitTrialWelcomeWizard: SubmitTrialWelcomeWizardOutput;
  subscribeFeature: SubscribeFeatureOutput;
  subscribeToContacts: MutationSubscribeToContactsOutput;
  subscriptionDiscount: SubscriptionDiscountOutput;
  syncPortingLoaStatus: SyncPortingLoaStatusResponse;
  testAction: TestActionOutput;
  testConnectPlaneTool: TestConnectPlaneToolOutput;
  testVoiceVirtualAgentAuthMethod: TestAuthMethodOutput;
  textToSpeechPreview: TextToSpeechPreview;
  toggleSipDeviceActivationState: UserSipSettings;
  toggleSipSetting: AgentSipSetting;
  toggleVirtualAgentActivation: VirtualAgentActivationStatusOutput;
  triggerAgentDeclinedWebhook: TriggerAgentDeclinedWebhookOutput;
  triggerInstallTestCall: InstallRedirect;
  unassignAircallWorkspaceConversation: AircallWorkspaceConversationOutput;
  unassignCustomSummaryConfiguration: UnassignCustomSummaryConfigurationOutput;
  unassignEsim: UnassignEsimResponse;
  unassignLicenses: UnassignLicensesOutput;
  unassignPlaybookSettings: UnassignPlaybookSettingsOutput;
  unenrollNumbers: UnenrollNumbersResult;
  unmuteReputationNotifications: ReputationNotificationStatusResult;
  unreadConversation: UnreadConversationOutput;
  unreadCurrentUserConversationsByIds: UnreadCurrentUserConversationsByIdsResult;
  unregisterPushDevice: RegisterPushDeviceOutput;
  updateAction: ActionOutput;
  updateActivationWizardStep: UpdateActivationWizardStepOutput;
  updateAgent: AgentV2;
  updateAgentKBMapping: AgentKbMappingResult;
  updateAgentTemplate: UpdateAgentTemplateResult;
  updateAircallExtract: UpdateAircallExtractOutput;
  updateAircallWorkspaceGroupConversationName: AircallWorkspaceConversationOutput;
  updateApiKey: UpdateApiKeyOutput;
  updateAutomation: UpdateAutomationOutput;
  updateBillingDetails: UpdateBillingDetailsOutput;
  updateBrandDraft: BrandDraftResult;
  updateBusinessDraft: BusinessDraftResult;
  updateBusinessRegistration: UpdateBusinessRegistrationResult;
  updateCalendar: CalendarOutput;
  updateCalendarV2: CalendarOutputV2;
  updateCallScoringSettings: UpdateCallScoringSettingsResult;
  updateCallTaggingSettings: UpdateCallTaggingSettingsOutput;
  updateCallingProfile: UpdateCallingProfileResult;
  updateClientActionInsightsSettings: ClientActionInsightsSettingsOutput;
  updateCompany: Company;
  updateCompanyTranscriptionSettings: UpdateCompanyTranscriptionSettingsOutput;
  updateConnectPlaneMCPConfig: ConnectPlaneMcpConfigOutput;
  updateConnectPlaneMCPToolSchema: ConnectPlaneMcpToolOutput;
  updateConversationsStatus: UpdateConversationsStatusResult;
  updateCoreKBClientType: UpdateKbClientTypeResultUnion;
  updateCoreKBCompanyRAGSettings: CoreKbCompanyRagSettingsResultUnion;
  updateCoreKBDocument?: Maybe<DocumentResult>;
  updateCoreKBIntegration?: Maybe<CoreKbIntegrationResult>;
  updateCoreKBIntegrationSubscription?: Maybe<CoreKbIntegrationSubscriptionResult>;
  updateCoreKBRAGOverride: CoreKbragOverrideResultUnion;
  updateCrawlDocument: CrawlDocumentOutput;
  updateCurrentUserConversationsStatus: UpdateCurrentUserConversationsStatusResult;
  updateDispatchGroup: DispatchGroup;
  updateDynamicClientConfiguration: UpdateDynamicClientConfigurationOutput;
  updateEmail: UserCriticalAction;
  updateEmailNotificationFrequency: AgentEmailNotification;
  updateEmergencyAddress: EmergencyAddress;
  updateEvalScenario: UpdateScenarioOutput;
  updateEvaluation: EvaluationOutput;
  updateGSMDevice: UpdateGsmDeviceOutput;
  updateHubspotCallProperties: UpdateHubspotCallPropertiesOutput;
  updateHubspotChannelConnection: HubSpotConnectSmsNumbersOutput;
  updateHubspotEngagementAssociations: UpdateHubspotEngagementAssociationsOutput;
  updateIntegration: Integration;
  updateIntegrationScope: UpdateIntegrationScopeOutput;
  updateIntegrationSettings: IntegrationSettings;
  updateIvrSetting: IvrSetting;
  updateIvrSettingRest: IvrSettingResponse;
  updateLine: Line;
  updateLineBusinessHours?: Maybe<BusinessHours>;
  updateLineTranscriptionSettings: UpdateLineTranscriptionSettingsOutput;
  updateLoaEnvelopeStatus: UpdateLoaEnvelopeStatusResult;
  updateMessageStatus: UpdateMessageStatusOutput;
  updateMessagingAIAgent: UpdateMessagingAiAgentResult;
  updateNextAction: NextActionUpdatedOutput;
  updateNote: NoteBase;
  updateNumber: Number;
  updateOnboardingStep?: Maybe<UpdateOnboardingStepOutput>;
  updateOutboundCampaign: UpdateOutboundCampaignOutput;
  updateOutboundCampaignContactImportRow: UpdateOutboundCampaignContactImportRowOutput;
  updateOutboundCampaignOutcome: UpdateOutboundCampaignOutcomeOutput;
  updatePrerecordedMessage: UpdatePrerecordedMessageOutput;
  updatePrivilegedUsers: SignInStrategy;
  updateProfile: UpdateProfileResult;
  updateScenario: SavedScenarioOutput;
  updateSecretsByLineId?: Maybe<SecretApiOutput>;
  updateSignInStrategy: SignInStrategy;
  updateTag: Tag;
  updateTeam: Team;
  updateTracker: UpdatedTrackerOutput;
  updateTtsMessage: TtsMessage;
  updateUnreadMessages: UpdateUnreadMessagesOutput;
  updateUserPassword?: Maybe<Void>;
  updateVirtualAgent: VirtualAgentOutput;
  updateVirtualAgentUsageAlert: VirtualAgentUsageAlertOutput;
  updateVoiceVirtualAgentAuthMethod: AuthMethodOutput;
  updateWebhook: Webhook;
  updateWhatsAppTemplateFavourites: UpdateWhatsAppTemplateFavouritesResult;
  upgradePlan: UpgradePlanOutput;
  uploadBrandDraftLogo: UploadBrandDraftLogoResult;
  uploadBrandLogo: UploadBrandLogoResult;
  uploadContactImage: ContactImage;
  uploadDocument?: Maybe<DocumentOutput>;
  uploadPortingDocument: UploadPortingDocumentResponse;
  uploadProfileImage: ProfileImage;
  upsertEvalPersona: UpsertEvalPersonaOutput;
  upsertPortingRequest: UpsertPortingRequestResponse;
  validateA2PForm: ValidateA2PFormResult;
  validateNumbersPortability: ValidateNumbersPortabilityResponse;
  verifyGSMDevice: VerifyGsmDeviceOutput;
  warmTransferCall: WarmTransferCallOutput;
};


export type MutationA2pBandwidthCampaignNumberAssociationArgs = {
  input: CampaignNumberAssociationInput;
};


export type MutationA2pBandwidthCampaignNumberDeletionArgs = {
  input: CampaignNumberDeletionInput;
};


export type MutationA2pBulkCampaignCreationArgs = {
  input: CampaignCreationInput;
};


export type MutationActivateAiAssistArgs = {
  input: ActivateAiAssistInput;
};


export type MutationAddBlacklistedNumberArgs = {
  input: AddBlacklistedNumberMutationInput;
};


export type MutationAddBridgeIntegrationsArgs = {
  companyId: Scalars['Int']['input'];
  input?: InputMaybe<AddNumberIntegrationInput>;
  numberId: Scalars['Int']['input'];
};


export type MutationAddCompanyAcknowledgmentArgs = {
  input: AddCompanyAcknowledgmentInput;
};


export type MutationAddCoreKbDocumentArgs = {
  doc_input: DocumentInput;
  kb_id: Scalars['ID']['input'];
};


export type MutationAddCoreKbDocumentsArgs = {
  doc_inputs: Array<DocumentInput>;
  kb_id: Scalars['ID']['input'];
};


export type MutationAddDialerCampaignNumbersArgs = {
  input: AddDialerCampaignNumbersInput;
};


export type MutationAddDispatchGroupArgs = {
  input: UpdateDispatchGroupInput;
  numberId: Scalars['String']['input'];
};


export type MutationAddExternalNumberArgs = {
  agentID: Scalars['ID']['input'];
  input: AgentPhoneNumberInput;
};


export type MutationAddHubIntegrationsArgs = {
  companyId: Scalars['Int']['input'];
  input?: InputMaybe<AddNumberIntegrationInput>;
  numberId: Scalars['Int']['input'];
};


export type MutationAddIntegrationConnectedLinesArgs = {
  integrationID: Scalars['ID']['input'];
  integrationType: IntegrationType;
  lineIDs: Array<Scalars['Int']['input']>;
};


export type MutationAddIvrSettingArgs = {
  input: AddIvrSettingInput;
};


export type MutationAddIvrSettingRestArgs = {
  input: IvrSettingInput;
  numberId: Scalars['String']['input'];
};


export type MutationAddKeywordsArgs = {
  input: AddKeywordsInput;
};


export type MutationAddKnowledgeDocumentArgs = {
  input: AddKnowledgeDocumentInput;
};


export type MutationAddMessageArgs = {
  input: AddMessageInput;
};


export type MutationAddMonitoredNumbersArgs = {
  businessId: Scalars['ID']['input'];
  input: AddMonitoredNumbersInput;
};


export type MutationAddNextActionArgs = {
  input: AddNextActionInput;
};


export type MutationAddNumberToIntegrationArgs = {
  input: AddNumberToIntegrationInput;
  numberId: Scalars['Int']['input'];
};


export type MutationAddOutboundCallerArgs = {
  input: AddOutboundCallerMutationInput;
  numberId: Scalars['String']['input'];
};


export type MutationAddOutboundCampaignCallOutcomeArgs = {
  input: AddOutboundCampaignCallOutcomeInput;
};


export type MutationAddOutboundCampaignContactsArgs = {
  campaignID: Scalars['ID']['input'];
  input: AddOutboundCampaignContactsInput;
};


export type MutationAddPaymentCardArgs = {
  input: AddPaymentCardInput;
};


export type MutationAddWebDispatchGroupArgs = {
  input: AddWebDispatchGroupInput;
};


export type MutationAnalyticsCreatePresetArgs = {
  input: AnalyticsCreatePresetInput;
};


export type MutationAnalyticsDeletePresetArgs = {
  input: AnalyticsDeletePresetInput;
};


export type MutationAnalyticsExportCallsHistoryArgs = {
  input: AnalyticsListInput;
};


export type MutationAnalyticsExportMetricsArgs = {
  input: AnalyticsExportMetricsInput;
};


export type MutationAnalyticsExportMultipleValueMetricDrillDownArgs = {
  input: AnalyticsExportMultipleValueMetricDrillDownInput;
};


export type MutationAnalyticsExportSingleValueMetricDrillDownArgs = {
  input: AnalyticsExportSingleValueMetricDrillDownInput;
};


export type MutationAnalyticsExportUserStatusHistoryArgs = {
  input: AnalyticsListInput;
};


export type MutationAnalyticsSharePresetArgs = {
  input: AnalyticsSharePresetInput;
};


export type MutationAnalyticsUpdatePresetArgs = {
  input: AnalyticsUpdatePresetInput;
};


export type MutationArchiveOutboundCampaignArgs = {
  campaignID: Scalars['ID']['input'];
};


export type MutationAssignActivationLicensesArgs = {
  input: AssignActivationLicensesInput;
};


export type MutationAssignAircallWorkspaceConversationArgs = {
  ID: Scalars['ID']['input'];
  agentID: Scalars['ID']['input'];
};


export type MutationAssignCustomSummaryConfigurationArgs = {
  input: AssignCustomSummaryConfigurationInput;
};


export type MutationAssignEsimArgs = {
  input: AssignEsimInput;
};


export type MutationAssignLicensesArgs = {
  input: AssignLicensesInput;
};


export type MutationAssignOutboundCampaignTeamsArgs = {
  campaignID: Scalars['ID']['input'];
  input: AssignOutboundCampaignTeamsInput;
};


export type MutationAssignOutboundCampaignUsersArgs = {
  campaignID: Scalars['ID']['input'];
  input: AssignOutboundCampaignUsersInput;
};


export type MutationAssignPlaybookSettingsArgs = {
  input: AssignPlaybookSettingsInput;
};


export type MutationAssignRolesToUserArgs = {
  input: AssignRolesToUserInput;
};


export type MutationAttachLongTailSourceInputArgs = {
  input: AttachLongTailSourceInputInput;
};


export type MutationAuthorizeApplicationArgs = {
  input: AuthorizeApplicationInput;
};


export type MutationAuthorizeApplicationMutationArgs = {
  input: AuthorizeApplicationMutationInput;
};


export type MutationAuthorizeChannelsArgs = {
  input: AuthorizeChannelsInput;
};


export type MutationBranchOutAgentWorkspaceConversationArgs = {
  ID: Scalars['ID']['input'];
  lineID: Scalars['ID']['input'];
};


export type MutationBulkCloseAircallWorkspaceConversationsArgs = {
  IDs: Array<Scalars['ID']['input']>;
};


export type MutationBulkCreateAircallExtractArgs = {
  input: BulkCreateAircallExtractInput;
};


export type MutationBulkDeleteDialerCampaignNumbersArgs = {
  input: BulkDeleteDialerCampaignNumbersInput;
};


export type MutationBulkEnableCoreKbragArgs = {
  company_id: Scalars['Int']['input'];
  input: CoreKbBulkEnableRagInput;
};


export type MutationBulkReadAircallWorkspaceConversationsArgs = {
  IDs: Array<Scalars['ID']['input']>;
};


export type MutationBulkReopenAircallWorkspaceConversationsArgs = {
  IDs: Array<Scalars['ID']['input']>;
};


export type MutationBulkSubscribeFeaturesArgs = {
  input: BulkSubscribeFeaturesInput;
};


export type MutationBulkUnreadAircallWorkspaceConversationsArgs = {
  IDs: Array<Scalars['ID']['input']>;
};


export type MutationCallDialerCampaignNumberArgs = {
  input: CallDialerCampaignNumberInput;
};


export type MutationCancelPortingRequestArgs = {
  input: CancelPortingRequestInput;
};


export type MutationCancelSimulationArgs = {
  runId: Scalars['ID']['input'];
  virtualAgentID: Scalars['ID']['input'];
};


export type MutationCancelSubscriptionArgs = {
  input: CancelSubscriptionInput;
};


export type MutationChangeEsimDeviceArgs = {
  input: ChangeEsimDeviceInput;
};


export type MutationChangeEsimLicenseArgs = {
  input: ChangeEsimLicenseInput;
};


export type MutationChangePasswordRequestArgs = {
  input: ChangePasswordRequestMutationInput;
};


export type MutationCheckCarrierNumberVerificationArgs = {
  input: CheckCarrierNumberVerificationInput;
};


export type MutationCleanOutboundCampaignContactImportRowsArgs = {
  contactImportID: Scalars['ID']['input'];
};


export type MutationClearStudioConversationArgs = {
  input: ClearStudioConversationInput;
};


export type MutationCloneVirtualAgentArgs = {
  input: CloneVirtualAgentInput;
};


export type MutationCloseAircallWorkspaceConversationArgs = {
  ID: Scalars['ID']['input'];
};


export type MutationCloseAircallWorkspaceConversationByCallIdArgs = {
  callID: Scalars['ID']['input'];
};


export type MutationCompleteTaskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConfigurePersonalLineForEsimArgs = {
  assignedUserId: Scalars['Int']['input'];
  lineID: Scalars['ID']['input'];
};


export type MutationConfirmVerdictArgs = {
  applicationId: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  scenarioResultId: Scalars['String']['input'];
  verdict: EvalVerdict;
};


export type MutationConvertAivaAgentActionsArgs = {
  input: ConvertAivaAgentActionsInput;
};


export type MutationCopySecretsByReferenceArgs = {
  lineID: Scalars['ID']['input'];
  referencesToCopy: Scalars['String']['input'];
};


export type MutationCopySecretsFromLineArgs = {
  lineID: Scalars['ID']['input'];
  secrets: Scalars['String']['input'];
  sourceLineID: Scalars['ID']['input'];
};


export type MutationCreateActionArgs = {
  input: CreateActionInput;
};


export type MutationCreateAgentKbMappingArgs = {
  mapping_input: AgentKbMappingInput;
};


export type MutationCreateAgentTemplateArgs = {
  input: CreateAgentTemplateInput;
};


export type MutationCreateAircallExtractArgs = {
  input: CreateAircallExtractInput;
};


export type MutationCreateAivaAgentMigrationDraftArgs = {
  input: CreateAivaAgentMigrationDraftInput;
};


export type MutationCreateAutomationArgs = {
  input: CreateAutomationInput;
};


export type MutationCreateBlacklistedPhoneArgs = {
  input: CreateBlacklistedPhoneInput;
};


export type MutationCreateBrandDocumentUploadUrlArgs = {
  input: CreateBrandDocumentUploadUrlInput;
};


export type MutationCreateBrandDraftArgs = {
  input: CreateBrandDraftInput;
};


export type MutationCreateBusinessDraftArgs = {
  input: CreateBusinessDraftInput;
};


export type MutationCreateBusinessRegistrationArgs = {
  input: CreateBusinessRegistrationInput;
};


export type MutationCreateCalendarArgs = {
  calendar: CalendarCreateInput;
};


export type MutationCreateCalendarV2Args = {
  calendar: CalendarCreateInput;
};


export type MutationCreateCallingProfileArgs = {
  brandId: Scalars['ID']['input'];
  input: CreateCallingProfileInput;
};


export type MutationCreateCompanyKbMappingArgs = {
  input: CustomerKbMappingCreateInput;
};


export type MutationCreateCompanyPromotionArgs = {
  input: CreateCompanyPromotionInput;
};


export type MutationCreateConversationArgs = {
  input: CreateConversationInput;
};


export type MutationCreateCoreKbArgs = {
  company_name?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCoreKbIntegrationArgs = {
  input: CreateCoreKbIntegrationInput;
};


export type MutationCreateCoreKbIntegrationSubscriptionArgs = {
  input: CreateCoreKbIntegrationSubscriptionInput;
};


export type MutationCreateCoreKbWithDocsArgs = {
  company_name?: InputMaybe<Scalars['String']['input']>;
  doc_inputs: Array<DocumentInput>;
  name: Scalars['String']['input'];
};


export type MutationCreateCrawlDocumentArgs = {
  input: CrawlDocumentCreateInput;
};


export type MutationCreateCrawlRootArgs = {
  input: CrawlRootCreateInput;
};


export type MutationCreateDocumentUploadUrlArgs = {
  input: CreateDocumentUploadUrlInput;
};


export type MutationCreateEmergencyAddressArgs = {
  input: CreateEmergencyAddressInput;
};


export type MutationCreateEvalScenarioArgs = {
  input: CreateEvalScenarioInput;
  personaId: Scalars['String']['input'];
};


export type MutationCreateEvaluationArgs = {
  input: CreateEvaluationInput;
};


export type MutationCreateGroupConversationArgs = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  externalParticipants: Array<Scalars['String']['input']>;
  ownerLineID: Scalars['ID']['input'];
};


export type MutationCreateIdentityArgs = {
  input: Array<RequirementInput>;
  isReusableProofOfAddress?: InputMaybe<Scalars['Boolean']['input']>;
  numberUUID?: InputMaybe<Scalars['String']['input']>;
  regionId?: InputMaybe<Scalars['Int']['input']>;
  requirementUUID?: InputMaybe<Scalars['String']['input']>;
  reverificationCampaignUUID?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<IdentityType>;
};


export type MutationCreateKeywordTrackerArgs = {
  input: CreateKeywordTrackerInput;
};


export type MutationCreateKnowledgeBaseArgs = {
  input: KnowledgeBaseCreateInput;
};


export type MutationCreateKycVerificationSessionArgs = {
  input: KycVerificationSessionInput;
};


export type MutationCreateLineArgs = {
  input: CreateLineInput;
};


export type MutationCreateLineTranscriptionSettingsArgs = {
  lineId: Scalars['Int']['input'];
  lineLanguage?: InputMaybe<Scalars['String']['input']>;
  secondaryLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationCreateLinesAsyncArgs = {
  input: CreateLinesAsyncInput;
};


export type MutationCreateLoaEnvelopeArgs = {
  input: CreateLoaEnvelopeInput;
};


export type MutationCreateLongTailRegistrationSessionArgs = {
  input: CreateLongTailRegistrationSessionInput;
};


export type MutationCreateMessagingAiAgentArgs = {
  input: MessagingAiCreateAgentInput;
};


export type MutationCreateNoteArgs = {
  callId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
};


export type MutationCreateOnboardingArgs = {
  onboarding: CreateOnboardingInput;
  platform?: InputMaybe<Platform>;
};


export type MutationCreateOrUpdateA2PFormArgs = {
  input: CreateOrUpdateA2PFormInput;
};


export type MutationCreateOutboundCampaignArgs = {
  input: CreateOutboundCampaignInput;
};


export type MutationCreateOutboundCampaignOutcomeArgs = {
  input: CreateOutboundCampaignOutcomeInput;
};


export type MutationCreatePrerecordedMessageArgs = {
  input: CreatePrerecordedMessageInput;
};


export type MutationCreateRestBridgeIntegrationArgs = {
  input: CreateBridgeIntegrationMutationInput;
};


export type MutationCreateRestSlackIntegrationArgs = {
  input: CreateSlackIntegrationMutationInput;
};


export type MutationCreateRestWebhookArgs = {
  input: CreateWebhookMutationInput;
};


export type MutationCreateSipDeviceArgs = {
  input?: InputMaybe<NewSipSettingInput>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateSamlConfigurationArgs = {
  input: CreateSamlConfigurationInput;
};


export type MutationCreateScenarioArgs = {
  input: CreateScenarioInput;
  virtualAgentID: Scalars['ID']['input'];
};


export type MutationCreateSipSettingArgs = {
  input: CreateSipSettingInput;
};


export type MutationCreateSupervisionArgs = {
  numberId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


export type MutationCreateTasksArgs = {
  category: TaskCategory;
  platform?: InputMaybe<Platform>;
};


export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};


export type MutationCreateTemplateArgs = {
  input: CreateTemplateInput;
};


export type MutationCreateTrayIntegrationArgs = {
  applicationId: Scalars['String']['input'];
  input: CreateTrayIntegrationInput;
};


export type MutationCreateVirtualAgentArgs = {
  input: CreateVirtualAgentInput;
};


export type MutationCreateVirtualAgentTrialSessionArgs = {
  input?: InputMaybe<CreateVirtualAgentTrialSessionInput>;
};


export type MutationCreateVirtualAgentUsageAlertArgs = {
  input: CreateVirtualAgentUsageAlertInput;
};


export type MutationCreateVirtualAgentWithBuilderArgs = {
  input: CreateVirtualAgentWithBuilderInput;
};


export type MutationCreateVoiceVirtualAgentAuthMethodArgs = {
  input: CreateAuthMethodInput;
};


export type MutationCreateWebhookArgs = {
  input: CreateWebhookInput;
};


export type MutationDeactivateWhatsAppNumberArgs = {
  input: DeactivateWhatsAppNumberInput;
};


export type MutationDeleteA2PFormArgs = {
  formID: Scalars['ID']['input'];
};


export type MutationDeleteActionArgs = {
  actionId: Scalars['ID']['input'];
};


export type MutationDeleteAgentArgs = {
  input: DeleteAgentInput;
};


export type MutationDeleteAgentKbMappingArgs = {
  agent_id: Scalars['String']['input'];
  agent_type?: InputMaybe<AgentType>;
  client_type: Scalars['String']['input'];
};


export type MutationDeleteAgentTemplateArgs = {
  agentTemplateID: Scalars['ID']['input'];
};


export type MutationDeleteApiKeyArgs = {
  apiId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteAudioArgs = {
  input: DeleteAudioInput;
};


export type MutationDeleteAutomationArgs = {
  automationId: Scalars['ID']['input'];
};


export type MutationDeleteBlacklistedNumberArgs = {
  numberId: Scalars['String']['input'];
};


export type MutationDeleteBlacklistedPhoneArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBrandArgs = {
  brandId: Scalars['ID']['input'];
  hardDelete?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeleteBrandDocumentArgs = {
  documentUuid: Scalars['ID']['input'];
};


export type MutationDeleteBrandDraftArgs = {
  draftId: Scalars['ID']['input'];
};


export type MutationDeleteBusinessDraftArgs = {
  draftId: Scalars['ID']['input'];
};


export type MutationDeleteBusinessRegistrationArgs = {
  businessId: Scalars['ID']['input'];
};


export type MutationDeleteCalendarArgs = {
  calendarID: Scalars['ID']['input'];
};


export type MutationDeleteCalendarV2Args = {
  calendarID: Scalars['ID']['input'];
};


export type MutationDeleteCallingProfileArgs = {
  brandId: Scalars['ID']['input'];
  callingProfileId: Scalars['ID']['input'];
};


export type MutationDeleteCompanyKbMappingArgs = {
  kbMappingId: Scalars['Int']['input'];
};


export type MutationDeleteContactArgs = {
  input: MutationDeleteContactInput;
};


export type MutationDeleteCoreKbArgs = {
  kb_id: Scalars['ID']['input'];
};


export type MutationDeleteCoreKbDocumentArgs = {
  doc_id: Scalars['ID']['input'];
  kb_id: Scalars['ID']['input'];
};


export type MutationDeleteCoreKbIntegrationArgs = {
  company_integration_id: Scalars['ID']['input'];
};


export type MutationDeleteCoreKbIntegrationSubscriptionArgs = {
  crawl_document_id: Scalars['ID']['input'];
  kb_id: Scalars['ID']['input'];
};


export type MutationDeleteCrawlDocumentArgs = {
  documentId: Scalars['Int']['input'];
};


export type MutationDeleteCustomSummaryArgs = {
  input: DeleteCustomSummaryInput;
};


export type MutationDeleteDispatchGroupRestArgs = {
  dispatchGroupId: Scalars['String']['input'];
  numberId: Scalars['String']['input'];
};


export type MutationDeleteDocumentArgs = {
  documentUuid: Scalars['ID']['input'];
  feature: Scalars['String']['input'];
};


export type MutationDeleteEmergencyAddressArgs = {
  input: DeleteEmergencyAddressInput;
};


export type MutationDeleteEvalPersonaArgs = {
  personaId: Scalars['String']['input'];
};


export type MutationDeleteEvalScenarioArgs = {
  scenarioId: Scalars['String']['input'];
};


export type MutationDeleteEvaluationArgs = {
  callID: Scalars['ID']['input'];
};


export type MutationDeleteExternalNumberArgs = {
  ID: Scalars['ID']['input'];
  agentID: Scalars['ID']['input'];
};


export type MutationDeleteGsmDeviceArgs = {
  input: DeleteGsmDeviceInput;
};


export type MutationDeleteIvrSettingArgs = {
  ivrSettingId: Scalars['String']['input'];
  numberId: Scalars['String']['input'];
};


export type MutationDeleteIntegrationArgs = {
  integrationID: Scalars['ID']['input'];
  integrationType: Scalars['String']['input'];
};


export type MutationDeleteKeywordTrackerArgs = {
  input: DeleteTrackerInput;
};


export type MutationDeleteKeywordsArgs = {
  input: DeleteKeywordsInput;
};


export type MutationDeleteKnowledgeBaseArgs = {
  kbId: Scalars['Int']['input'];
};


export type MutationDeleteLineArgs = {
  ID: Scalars['ID']['input'];
};


export type MutationDeleteMessagingAiAgentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteNextActionArgs = {
  input: DeleteNextActionInput;
};


export type MutationDeleteNoteArgs = {
  noteId: Scalars['ID']['input'];
};


export type MutationDeleteNumberArgs = {
  numberId: Scalars['String']['input'];
};


export type MutationDeleteOutboundCallerArgs = {
  numberId: Scalars['String']['input'];
  supervisionId: Scalars['String']['input'];
};


export type MutationDeleteOutboundCampaignArgs = {
  ID: Scalars['ID']['input'];
};


export type MutationDeleteOutboundCampaignOutcomeArgs = {
  ID: Scalars['ID']['input'];
};


export type MutationDeletePlaybookArgs = {
  input: DeleteCustomPlaybookInput;
};


export type MutationDeletePrerecordedMessageArgs = {
  input: DeletePrerecordedMessageInput;
};


export type MutationDeleteRealtimeQuestionAnsweringCardArgs = {
  cardId: Scalars['ID']['input'];
};


export type MutationDeleteScenarioArgs = {
  scenarioId: Scalars['ID']['input'];
  virtualAgentID: Scalars['ID']['input'];
};


export type MutationDeleteScoreCardArgs = {
  scoreCardID: Scalars['ID']['input'];
};


export type MutationDeleteSecretByReferenceArgs = {
  lineID: Scalars['ID']['input'];
  reference: Scalars['String']['input'];
};


export type MutationDeleteSipDeviceArgs = {
  sipId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationDeleteSipSettingArgs = {
  input: DeleteSipSettingInput;
};


export type MutationDeleteSummaryTemplateArgs = {
  input: DeleteSummaryTemplateInput;
};


export type MutationDeleteSupervisionArgs = {
  ID: Scalars['ID']['input'];
  numberId: Scalars['ID']['input'];
};


export type MutationDeleteTagArgs = {
  input: DeleteTagInput;
};


export type MutationDeleteTeamArgs = {
  input: DeleteTeamInput;
};


export type MutationDeleteTemplateArgs = {
  templateID: Scalars['ID']['input'];
};


export type MutationDeleteTopicArgs = {
  input: DeleteTopicInput;
};


export type MutationDeleteTrackerArgs = {
  input: DeleteTrackerInput;
};


export type MutationDeleteVirtualAgentArgs = {
  input: DeleteVirtualAgentInput;
};


export type MutationDeleteVoiceVirtualAgentAuthMethodArgs = {
  authMethodId: Scalars['ID']['input'];
};


export type MutationDeleteWhatsappSubaccountArgs = {
  input: DeleteWhatsappSubaccountInput;
};


export type MutationDialAgentArgs = {
  input: DialAgentInput;
};


export type MutationDisableEmailNotificationArgs = {
  ID: Scalars['ID']['input'];
  agentID: Scalars['ID']['input'];
  input: EmailNotificationInput;
};


export type MutationDiscardVirtualAgentDraftArgs = {
  input: DiscardVirtualAgentDraftInput;
};


export type MutationDismissNotificationArgs = {
  input: DismissNotificationInput;
};


export type MutationDuplicateOutboundCampaignArgs = {
  campaignID: Scalars['ID']['input'];
  input: DuplicateOutboundCampaignInput;
};


export type MutationDuplicatePlaybookArgs = {
  input: DuplicatePlaybookInput;
};


export type MutationEditCoreKbDocumentUrlArgs = {
  doc_id: Scalars['ID']['input'];
  edit_input: EditUrlDocumentInput;
  kb_id: Scalars['ID']['input'];
};


export type MutationEnableDisableFeatureArgs = {
  input: EnableDisableFeatureInput;
};


export type MutationEnableEmailNotificationArgs = {
  agentID: Scalars['ID']['input'];
  input: EmailNotificationInput;
};


export type MutationEnableIntegrationArgs = {
  applicationId: Scalars['String']['input'];
  input: EnableIntegrationMutationInput;
};


export type MutationEnableTrialFeatureArgs = {
  input: EnableTrialFeatureInput;
};


export type MutationEndChatSessionArgs = {
  sessionId: Scalars['ID']['input'];
  virtualAgentID: Scalars['ID']['input'];
};


export type MutationEndCoachingSessionArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationEnrollInHubspotSequenceArgs = {
  input: EnrollInHubspotSequenceInput;
};


export type MutationEnrollNumbersArgs = {
  brandId: Scalars['ID']['input'];
  callingProfileId: Scalars['ID']['input'];
  input: EnrollNumbersInput;
};


export type MutationExportOutboundCampaignContactImportRowsArgs = {
  contactImportID: Scalars['ID']['input'];
};


export type MutationExportVirtualAgentArgs = {
  agentId: Scalars['ID']['input'];
};


export type MutationExtendMandatoryTaggingArgs = {
  input: ExtendMandatoryTaggingInput;
};


export type MutationForgotPasswordArgs = {
  input: ForgotPasswordMutationInput;
};


export type MutationGenerateAiAnswersArgs = {
  input: GenerateAiAnswersInput;
};


export type MutationGenerateActivationCompanyContextArgs = {
  input: GenerateActivationCompanyContextInput;
};


export type MutationGenerateAdminMcpOauthGrantUrlArgs = {
  hubApplicationId: Scalars['ID']['input'];
};


export type MutationGenerateMessagingMediaUrlsArgs = {
  input: GenerateMessagingMediaUrlsInput;
};


export type MutationGenerateMessagingWhatsappMediaUrlsArgs = {
  input: GenerateMessagingMediaUrlsInput;
};


export type MutationGenerateMondayWebhookUrlArgs = {
  integrationID: Scalars['ID']['input'];
};


export type MutationGenerateOAuthAuthorizationUrlArgs = {
  applicationId: Scalars['ID']['input'];
  companyId: Scalars['Int']['input'];
  integrationId?: InputMaybe<Scalars['ID']['input']>;
  redirectUri: Scalars['String']['input'];
};


export type MutationGeneratePortingLoaArgs = {
  input: GeneratePortingLoaInput;
};


export type MutationGeneratePrerecordedMessageUrlArgs = {
  input: GeneratePrerecordedMessageUrlInput;
};


export type MutationGenerateSmsAutomationWebhookUrlArgs = {
  integrationID: Scalars['ID']['input'];
};


export type MutationGenerateTtsMessageArgs = {
  input: GenerateTtsMessageInput;
};


export type MutationGenerateWhatsappHeaderMediaUrlArgs = {
  input: GenerateWhatsappHeaderMediaUrlInput;
};


export type MutationGetOrCreateKbForAgentArgs = {
  input: GetOrCreateKbForAgentInput;
};


export type MutationGetTrackUploadUrlArgs = {
  input: GetTrackUploadUrlInput;
};


export type MutationGradeApplicationArgs = {
  applicationId: Scalars['String']['input'];
};


export type MutationGradeMcpServerArgs = {
  input: GradeMcpServerInput;
};


export type MutationGradeToolArgs = {
  input: GradeToolInput;
};


export type MutationImportVirtualAgentArgs = {
  input: ImportVirtualAgentInput;
};


export type MutationInstallCustomAiAppArgs = {
  applicationID: Scalars['ID']['input'];
};


export type MutationInvalidateAppSyncCacheArgs = {
  input: Array<InvalidateAppSyncCacheInput>;
};


export type MutationInviteMultipleUsersArgs = {
  input: UploadBulkUsersInput;
};


export type MutationInviteUserArgs = {
  input: InviteUserInput;
};


export type MutationJoinBetaArgs = {
  name: Scalars['ID']['input'];
};


export type MutationLaunchOutboundCampaignArgs = {
  campaignID: Scalars['ID']['input'];
};


export type MutationLinkTagsToCallArgs = {
  input: LinkTagsToCallInput;
};


export type MutationLiveMonitoringSetUserPreferencesArgs = {
  input: LiveMonitoringUserPreferencesInput;
};


export type MutationMarkAircallWorkspaceConversationAsReadArgs = {
  ID: Scalars['ID']['input'];
};


export type MutationMarkAircallWorkspaceConversationAsUnreadArgs = {
  ID: Scalars['ID']['input'];
};


export type MutationMergeWarmTransferCallArgs = {
  callSid: Scalars['String']['input'];
  externalSid: Scalars['String']['input'];
};


export type MutationMessagingAiDiscardAgentDraftArgs = {
  agentId: Scalars['ID']['input'];
};


export type MutationMessagingAiPlaygroundChatArgs = {
  input: MessagingAiPlaygroundChatInput;
};


export type MutationMessagingAiPlaygroundDeleteSessionArgs = {
  sessionId: Scalars['ID']['input'];
};


export type MutationMessagingAiPresignMediaUploadArgs = {
  input: MessagingAiPresignMediaUploadInput;
};


export type MutationMessagingAiPublishAgentDraftArgs = {
  agentId: Scalars['ID']['input'];
};


export type MutationMessagingAiSaveAgentDraftArgs = {
  agentId: Scalars['ID']['input'];
  input: MessagingAiSaveDraftInput;
};


export type MutationMessagingAiSetConversationEscalationArgs = {
  companyId: Scalars['Int']['input'];
  externalId: Scalars['String']['input'];
  isEscalated: Scalars['Boolean']['input'];
  lineId: Scalars['Int']['input'];
};


export type MutationMessagingAiSetConversationStoppedArgs = {
  companyId: Scalars['Int']['input'];
  externalId: Scalars['String']['input'];
  isStopped: Scalars['Boolean']['input'];
  lineId: Scalars['Int']['input'];
};


export type MutationMigrateIntegrationArgs = {
  applicationName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  migrationMetadata?: InputMaybe<Scalars['String']['input']>;
  serviceType: Scalars['Int']['input'];
};


export type MutationMigrateLineToSmartflowsArgs = {
  flowConfiguration: FlowConfigurationInput;
  legacyDispatchGroups: Array<InputMaybe<LegacyDispatchGroupInput>>;
  lineID: Scalars['ID']['input'];
};


export type MutationNotifyArgs = {
  input: NotifyInput;
};


export type MutationNotifyAgentAddedToLineArgs = {
  input: AgentAddedToLineNotificationInput;
};


export type MutationNotifyAgentConversationStatusAllUpdatedArgs = {
  agentID: Scalars['ID']['input'];
  initiatingAgentID: Scalars['ID']['input'];
  markAsDone: Scalars['Boolean']['input'];
};


export type MutationNotifyAgentConversationsStatusUpdatedArgs = {
  agentID: Scalars['ID']['input'];
  conversationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  initiatingAgentID: Scalars['ID']['input'];
  markAsDone: Scalars['Boolean']['input'];
};


export type MutationNotifyAgentRemovedFromLineArgs = {
  input: AgentRemovedFromLineNotificationInput;
};


export type MutationNotifyAircallWorkspaceConversationDeletedArgs = {
  input: AircallWorkspaceConversationDeletedNotificationInput;
};


export type MutationNotifyAircallWorkspaceConversationUpdatedArgs = {
  input: AircallWorkspaceConversationUpdatedNotificationInput;
};


export type MutationNotifyAircallWorkspaceEngagementCreatedArgs = {
  input: AircallWorkspaceEngagementCreatedNotificationInput;
};


export type MutationNotifyAircallWorkspaceEngagementUpdatedArgs = {
  input: AircallWorkspaceEngagementUpdatedNotificationInput;
};


export type MutationNotifyAircallWorkspaceInboxUpdatedArgs = {
  input: AircallWorkspaceInboxUpdatedNotificationInput;
};


export type MutationNotifyAircallWorkspaceUnreadConversationsCounterUpdatedArgs = {
  input: UnreadConversationsCounterUpdatedInput;
};


export type MutationNotifyAnalyticsExportUpdatedArgs = {
  input: AnalyticsExportUpdatedInput;
};


export type MutationNotifyBulkCloseAircallWorkspaceConversationsArgs = {
  input: BulkCloseAircallWorkspaceConversationsNotificationInput;
};


export type MutationNotifyBulkReopenAircallWorkspaceConversationsArgs = {
  input: BulkReopenAircallWorkspaceConversationsNotificationInput;
};


export type MutationNotifyConversationCreatedArgs = {
  agentID?: InputMaybe<Scalars['ID']['input']>;
  conversation: ConversationInput;
  recipients?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationNotifyConversationsAllReadArgs = {
  agentID: Scalars['ID']['input'];
};


export type MutationNotifyLineUpdatedArgs = {
  input: LineUpdatedNotificationInput;
};


export type MutationNotifyMessageAddedArgs = {
  agentID?: InputMaybe<Scalars['ID']['input']>;
  message: MessageInput;
  recipients?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationNotifyMessageStatusUpdatedArgs = {
  agentID?: InputMaybe<Scalars['ID']['input']>;
  message: MessageInput;
  recipients?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationNotifyMessagingAiAgentUpdatedArgs = {
  agentId: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
};


export type MutationNotifyOutboundCampaignAgentSessionQueueIdleArgs = {
  input: NotifyOutboundCampaignAgentSessionQueueIdleInput;
};


export type MutationNotifyOutboundCampaignCallDispatchedArgs = {
  input: NotifyOutboundCampaignCallDispatchedInput;
};


export type MutationNotifyOutboundCampaignCallOutcomeAddedArgs = {
  input: NotifyOutboundCampaignCallOutcomeAddedInput;
};


export type MutationNotifyOutboundCampaignChangedArgs = {
  input: NotifyOutboundCampaignChangedInput;
};


export type MutationNotifyOutboundCampaignCompanyUnavailableArgs = {
  input: NotifyOutboundCampaignCompanyUnavailableInput;
};


export type MutationNotifyOutboundCampaignNextCallQueuedArgs = {
  input: NotifyOutboundCampaignNextCallQueuedInput;
};


export type MutationNotifyOutboundCampaignQueueItemChangedArgs = {
  input: NotifyOutboundCampaignQueueItemChangedInput;
};


export type MutationNotifyOutboundCampaignUserDispatchFailedArgs = {
  input: NotifyOutboundCampaignUserDispatchFailedInput;
};


export type MutationNotifyOutboundCampaignUserReadyChangedArgs = {
  input: NotifyOutboundCampaignUserReadyChangedInput;
};


export type MutationNotifyOutboundCampaignUserStatusChangedArgs = {
  input: NotifyOutboundCampaignUserStatusChangedInput;
};


export type MutationOnAiAnswersGeneratedArgs = {
  data?: InputMaybe<OnAiAnswersGeneratedOutputDataInput>;
  error?: InputMaybe<OnAiAnswerGeneratedErrorInput>;
  transcriptionId: Scalars['ID']['input'];
};


export type MutationOnQuestionQualityHelperGeneratedArgs = {
  data?: InputMaybe<OnQuestionQualityHelperGeneratedOutputDataInput>;
  error?: InputMaybe<OnQuestionQualityHelperGeneratedErrorInput>;
  id: Scalars['ID']['input'];
};


export type MutationOutboundCampaignAddQueueItemArgs = {
  input: AddOutboundCampaignQueueItemInput;
};


export type MutationOutboundCampaignRemoveQueueItemArgs = {
  queueItemID: Scalars['ID']['input'];
};


export type MutationOutboundCampaignReorderQueueItemArgs = {
  input: ReorderOutboundCampaignQueueItemInput;
};


export type MutationOutboundCampaignScheduleQueueItemArgs = {
  input: ScheduleOutboundCampaignQueueItemInput;
};


export type MutationPauseOutboundCampaignArgs = {
  campaignID: Scalars['ID']['input'];
};


export type MutationPauseOutboundCampaignSessionArgs = {
  campaignID: Scalars['ID']['input'];
};


export type MutationPlanSubscribeArgs = {
  input: PlanSubscribeInput;
};


export type MutationPlanUpgradeArgs = {
  input: PlanUpgradeInput;
};


export type MutationProvisionApplicationArgs = {
  applicationId: Scalars['String']['input'];
};


export type MutationProvisionLongTailApplicationArgs = {
  input: ProvisionLongTailApplicationInput;
};


export type MutationPublishScoreCardArgs = {
  input: SaveScoreCardInput;
};


export type MutationPublishVirtualAgentDraftArgs = {
  input: PublishVirtualAgentDraftInput;
};


export type MutationPurchaseLicensesArgs = {
  input: PurchaseLicensesInput;
};


export type MutationQuestionQualityHelperArgs = {
  input: QuestionQualityHelperInput;
};


export type MutationReactivateWebhookArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReadConversationArgs = {
  input: ReadConversationInput;
};


export type MutationReadCurrentUserConversationsByIdsArgs = {
  input: ReadCurrentUserConversationsByIdsInput;
};


export type MutationReconcileEsimArgs = {
  input: ReconcileEsimInput;
};


export type MutationRecordActionResourceArgs = {
  input: RecordActionResourceInput;
};


export type MutationRecoverPasswordArgs = {
  input: RecoverPasswordInput;
};


export type MutationRefreshContactExtractsArgs = {
  input: MutationRefreshExtractsInput;
};


export type MutationRefreshCoreKbArgs = {
  kb_id: Scalars['ID']['input'];
};


export type MutationRefreshCoreKbDocumentArgs = {
  doc_id: Scalars['ID']['input'];
  kb_id: Scalars['ID']['input'];
};


export type MutationRefreshCoreKbIntegrationArgs = {
  company_integration_id: Scalars['ID']['input'];
};


export type MutationRegenerateSfOmnichannelApiKeyArgs = {
  integrationID: Scalars['ID']['input'];
};


export type MutationRegisterLongTailApplicationArgs = {
  input: RegisterLongTailApplicationInput;
};


export type MutationRegisterPushDeviceArgs = {
  input: RegisterPushDeviceInput;
};


export type MutationRegisterWhatsAppNumberArgs = {
  input: RegisterWhatsAppNumberInput;
};


export type MutationRejectDispatchArgs = {
  callSid: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRelinkCoreKbDocumentArgs = {
  doc_id: Scalars['ID']['input'];
  relink_input: RelinkCoreKbDocumentInput;
};


export type MutationRemoveBrandLogoArgs = {
  brandId: Scalars['ID']['input'];
};


export type MutationRemoveErrorDocumentsArgs = {
  kb_id: Scalars['ID']['input'];
};


export type MutationRemoveIntegrationConnectedLinesArgs = {
  integrationID: Scalars['ID']['input'];
  integrationType: IntegrationType;
  lineIDs: Array<Scalars['Int']['input']>;
};


export type MutationRemoveLicensesArgs = {
  input: RemoveLicensesInput;
};


export type MutationRemoveMonitoredNumbersArgs = {
  businessId: Scalars['ID']['input'];
  input: RemoveMonitoredNumbersInput;
};


export type MutationRemoveNumberConnectedIntegrationBridgeArgs = {
  companyId: Scalars['Int']['input'];
  input: RemoveConnectedIntegrationInput;
  numberId: Scalars['Int']['input'];
};


export type MutationRemoveNumberConnectedIntegrationHubArgs = {
  companyId: Scalars['Int']['input'];
  input: RemoveConnectedIntegrationInput;
  numberId: Scalars['Int']['input'];
};


export type MutationRemoveNumberFromIntegrationArgs = {
  input: RemoveNumberFromIntegrationInput;
  numberId: Scalars['Int']['input'];
};


export type MutationRemoveOutboundCampaignContactImportRowsArgs = {
  contactImportID: Scalars['ID']['input'];
  status: OutboundCampaignContactImportRowStatus;
};


export type MutationRemoveOutboundCampaignTeamsArgs = {
  campaignID: Scalars['ID']['input'];
  input: RemoveOutboundCampaignTeamsInput;
};


export type MutationRemoveOutboundCampaignUsersArgs = {
  campaignID: Scalars['ID']['input'];
  input: RemoveOutboundCampaignUsersInput;
};


export type MutationRenameCoreKbArgs = {
  kb_id: Scalars['ID']['input'];
  rename_input: RenameKbInput;
};


export type MutationRenameCoreKbDocumentArgs = {
  doc_id: Scalars['ID']['input'];
  kb_id: Scalars['ID']['input'];
  rename_input: RenameDocumentInput;
};


export type MutationReopenAircallWorkspaceConversationArgs = {
  ID: Scalars['ID']['input'];
};


export type MutationRequestFeatureArgs = {
  input: RequestFeatureInput;
};


export type MutationRequestOutboundCampaignContactImportFromCrmArgs = {
  input: RequestOutboundCampaignContactImportFromCrmInput;
};


export type MutationRequestOutboundCampaignContactImportUploadArgs = {
  input: RequestOutboundCampaignContactImportUploadInput;
};


export type MutationRequestTargetArgs = {
  lineID: Scalars['ID']['input'];
  requestTarget: RequestTargetInput;
};


export type MutationRequestVerificationGsmDeviceArgs = {
  input: RequestVerificationGsmDeviceInput;
};


export type MutationResendCriticalActionArgs = {
  input: ResendCriticalActionInput;
};


export type MutationResendEmailInvitationArgs = {
  input: ResendEmailInvitationInput;
};


export type MutationResendEventArgs = {
  input: ResendEventInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordMutationInput;
};


export type MutationRestoreLicensesArgs = {
  input: RestoreLicensesInput;
};


export type MutationResubmitBrandDocumentArgs = {
  brandId: Scalars['ID']['input'];
  documentUuid: Scalars['ID']['input'];
  input: ResubmitBrandDocumentInput;
};


export type MutationResumeOutboundCampaignArgs = {
  campaignID: Scalars['ID']['input'];
};


export type MutationRevokeAdminMcpOauthGrantArgs = {
  hubApplicationId: Scalars['ID']['input'];
};


export type MutationSaveActivationCompanyContextArgs = {
  input: SaveActivationCompanyContextInput;
};


export type MutationSaveCallConfigurationArgs = {
  input: SaveCallConfigurationInput;
};


export type MutationSaveCompanyContextArgs = {
  input: SaveCompanyContextInput;
};


export type MutationSaveCustomSummaryArgs = {
  input: SaveCustomSummaryInput;
};


export type MutationSaveCustomSummaryResultArgs = {
  input: SaveCustomSummaryResultInput;
};


export type MutationSaveDraftScoreCardArgs = {
  input: SaveScoreCardInput;
};


export type MutationSaveNetworkDiagnosticArgs = {
  input: SaveNetworkDiagnosticInput;
};


export type MutationSavePlaybookArgs = {
  input: SaveCustomPlaybookInput;
};


export type MutationSavePlaybookResultArgs = {
  input: SavePlaybookResultInput;
};


export type MutationSavePortingFieldsArgs = {
  input: SavePortingFieldsInput;
};


export type MutationSaveRealtimeQuestionAnsweringCardArgs = {
  input: RealtimeQuestionAnsweringCardInput;
};


export type MutationSaveSummaryDiscoveryTemplateArgs = {
  input: SaveSummaryDiscoveryTemplateInput;
};


export type MutationSaveSummaryOptionsTemplateArgs = {
  input: SaveSummaryOptionsTemplateInput;
};


export type MutationSaveSummaryValidationTemplateArgs = {
  input: SaveSummaryValidationTemplateInput;
};


export type MutationSaveTopicArgs = {
  input: SaveTopicInput;
};


export type MutationSaveVirtualAgentDraftArgs = {
  input: SaveVirtualAgentDraftInput;
};


export type MutationScheduleGsmCallArgs = {
  input: ScheduleGsmCallInput;
};


export type MutationSendChatMessageArgs = {
  message: Scalars['String']['input'];
  sessionId: Scalars['ID']['input'];
  virtualAgentID: Scalars['ID']['input'];
};


export type MutationSendCoachingMessageArgs = {
  input: SendCoachingMessageInput;
};


export type MutationSendConfirmationEmailArgs = {
  bodyBuilder?: InputMaybe<FunctionType>;
  userId: Scalars['Int']['input'];
};


export type MutationSendGroupMessageArgs = {
  input: SendGroupMessageInput;
};


export type MutationSendMessageArgs = {
  input: SendMessageInput;
};


export type MutationSendMessageV2Args = {
  input: SendMessageV2Input;
};


export type MutationSendPauseResumeVoiceCallTransArgs = {
  input: SendPauseResumeVoiceCallTransInput;
};


export type MutationSetActivePlaybookArgs = {
  input: SetActivePlaybookInput;
};


export type MutationSetConnectPlaneApplicationAuthHeaderArgs = {
  input: SetConnectPlaneApplicationAuthHeaderInput;
};


export type MutationSetConnectPlaneToolAvailabilityArgs = {
  input: SetConnectPlaneToolAvailabilityInput;
};


export type MutationSetConnectPlaneToolCompaniesArgs = {
  input: SetConnectPlaneToolCompaniesInput;
};


export type MutationSetDesktopStateArgs = {
  input: SetDesktopStateInput;
};


export type MutationSetFlowToLineArgs = {
  flowConfiguration: FlowConfigurationInput;
  lineID: Scalars['ID']['input'];
};


export type MutationSetFlowToLineV2Args = {
  flowConfiguration: FlowConfigurationInput;
  lineID: Scalars['ID']['input'];
};


export type MutationSetIntegrationStaticCredentialArgs = {
  hubApplicationId: Scalars['ID']['input'];
  input: CredentialInput;
  integrationId: Scalars['ID']['input'];
};


export type MutationSetLineSettingsArgs = {
  lineID: Scalars['ID']['input'];
  lineSettings: LineSettingsArgs;
};


export type MutationSetMessagingAiAgentEscalationModeArgs = {
  agentId: Scalars['ID']['input'];
  input: MessagingAiSetEscalationModeInput;
};


export type MutationSetMessagingAiAgentIntakesUpfrontArgs = {
  agentId: Scalars['ID']['input'];
  input: MessagingAiSetIntakesUpfrontInput;
};


export type MutationSetMetadataArgs = {
  metadataInput: SetMetaDataInput;
  platform?: InputMaybe<Platform>;
};


export type MutationSetNotificationsConfigurationArgs = {
  input: SetNotificationsConfigurationInput;
};


export type MutationSetRealtimeQuestionAnsweringAssignmentArgs = {
  input: RealtimeQuestionAnsweringSetAssignmentInput;
};


export type MutationShareCoreKbDocumentArgs = {
  doc_id: Scalars['ID']['input'];
  share_input: ShareCoreKbDocumentInput;
};


export type MutationSkipTaskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSkipWrapUpArgs = {
  input: SkipWrapUpInput;
};


export type MutationStartAgentInsightsJobArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  virtualAgentID: Scalars['ID']['input'];
};


export type MutationStartCarrierNumberVerificationArgs = {
  input: StartCarrierNumberVerificationInput;
};


export type MutationStartChatSessionArgs = {
  aircallNumber?: InputMaybe<Scalars['String']['input']>;
  callId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  useRealActions?: InputMaybe<Scalars['Boolean']['input']>;
  virtualAgentID: Scalars['ID']['input'];
};


export type MutationStartCoachingSessionArgs = {
  input?: InputMaybe<StartCoachingSessionInput>;
};


export type MutationStartEvalRunArgs = {
  personaId: Scalars['String']['input'];
};


export type MutationStartEvaluateConfigurationJobArgs = {
  includeSystemInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  virtualAgentID: Scalars['ID']['input'];
};


export type MutationStartLongTailGenerationJobArgs = {
  input: StartLongTailGenerationJobInput;
};


export type MutationStartOutboundCampaignSessionArgs = {
  campaignID: Scalars['ID']['input'];
};


export type MutationStartSimulationArgs = {
  input: StartSimulationInput;
  virtualAgentID: Scalars['ID']['input'];
};


export type MutationStartStudioConversationArgs = {
  input: StartStudioConversationInput;
};


export type MutationStartStudioTurnArgs = {
  input: StartStudioTurnInput;
};


export type MutationStopWarmTransferCallArgs = {
  callSid: Scalars['String']['input'];
  externalSid: Scalars['String']['input'];
};


export type MutationSubmitAgentChatFeedbackArgs = {
  input: SubmitAgentChatFeedbackInput;
};


export type MutationSubmitBrandArgs = {
  input: SubmitBrandInput;
};


export type MutationSubmitQuestionnaireArgs = {
  input: SubmitQuestionnaireInput;
};


export type MutationSubmitSuggestionFeedbackArgs = {
  input: SubmitSuggestionFeedbackInput;
};


export type MutationSubmitTrialWelcomeWizardArgs = {
  input: SubmitTrialWelcomeWizardInput;
};


export type MutationSubscribeFeatureArgs = {
  input: SubscribeFeatureInput;
};


export type MutationSubscribeToContactsArgs = {
  input: MutationSubscribeToContactsInput;
};


export type MutationSubscriptionDiscountArgs = {
  input: SubscriptionDiscountInput;
};


export type MutationSyncPortingLoaStatusArgs = {
  input: SyncPortingLoaStatusInput;
};


export type MutationTestActionArgs = {
  actionId: Scalars['ID']['input'];
  testInputs?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTestConnectPlaneToolArgs = {
  input: TestConnectPlaneToolInput;
};


export type MutationTestVoiceVirtualAgentAuthMethodArgs = {
  authMethodId: Scalars['ID']['input'];
  testUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTextToSpeechPreviewArgs = {
  input: TextToSpeechPreviewInput;
  numberId: Scalars['String']['input'];
  ttsId: Scalars['String']['input'];
};


export type MutationToggleSipDeviceActivationStateArgs = {
  input: ToggleSipDeviceActivationStateInput;
  sipId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationToggleSipSettingArgs = {
  input: ToggleSipSettingInput;
};


export type MutationToggleVirtualAgentActivationArgs = {
  input: ToggleVirtualAgentActivationInput;
};


export type MutationTriggerAgentDeclinedWebhookArgs = {
  input: TriggerAgentDeclinedWebhook;
};


export type MutationTriggerInstallTestCallArgs = {
  state: Scalars['String']['input'];
};


export type MutationUnassignAircallWorkspaceConversationArgs = {
  ID: Scalars['ID']['input'];
};


export type MutationUnassignCustomSummaryConfigurationArgs = {
  input: UnassignCustomSummaryConfigurationInput;
};


export type MutationUnassignEsimArgs = {
  input: UnassignEsimInput;
};


export type MutationUnassignLicensesArgs = {
  input: UnassignLicensesInput;
};


export type MutationUnassignPlaybookSettingsArgs = {
  input: UnassignPlaybookSettingsInput;
};


export type MutationUnenrollNumbersArgs = {
  brandId: Scalars['ID']['input'];
  callingProfileId: Scalars['ID']['input'];
  input: UnenrollNumbersInput;
};


export type MutationUnreadConversationArgs = {
  input: UnreadConversationInput;
};


export type MutationUnreadCurrentUserConversationsByIdsArgs = {
  input: UnreadCurrentUserConversationsByIdsInput;
};


export type MutationUnregisterPushDeviceArgs = {
  input: RegisterPushDeviceInput;
};


export type MutationUpdateActionArgs = {
  input: UpdateActionInput;
};


export type MutationUpdateActivationWizardStepArgs = {
  input: UpdateActivationWizardStepInput;
};


export type MutationUpdateAgentArgs = {
  input: UpdateAgentInput;
};


export type MutationUpdateAgentKbMappingArgs = {
  agent_id: Scalars['String']['input'];
  agent_type?: InputMaybe<AgentType>;
  client_type: Scalars['String']['input'];
  update_input: AgentKbMappingUpdateInput;
};


export type MutationUpdateAgentTemplateArgs = {
  input: UpdateAgentTemplateInput;
};


export type MutationUpdateAircallExtractArgs = {
  input: UpdateAircallExtractInput;
};


export type MutationUpdateAircallWorkspaceGroupConversationNameArgs = {
  conversationID: Scalars['ID']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateApiKeyArgs = {
  apiId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};


export type MutationUpdateAutomationArgs = {
  input: UpdateAutomationInput;
};


export type MutationUpdateBillingDetailsArgs = {
  input: UpdateBillingDetailsInput;
};


export type MutationUpdateBrandDraftArgs = {
  draftId: Scalars['ID']['input'];
  input: UpdateBrandDraftInput;
};


export type MutationUpdateBusinessDraftArgs = {
  draftId: Scalars['ID']['input'];
  input: UpdateBusinessDraftInput;
};


export type MutationUpdateBusinessRegistrationArgs = {
  businessId: Scalars['ID']['input'];
  input: UpdateBusinessRegistrationInput;
};


export type MutationUpdateCalendarArgs = {
  calendar: CalendarUpdateInput;
  calendarID: Scalars['ID']['input'];
};


export type MutationUpdateCalendarV2Args = {
  calendar: CalendarUpdateInput;
  calendarID: Scalars['ID']['input'];
};


export type MutationUpdateCallScoringSettingsArgs = {
  input: UpdateCallScoringSettingsInput;
};


export type MutationUpdateCallTaggingSettingsArgs = {
  input: UpdateCallTaggingSettingsInput;
};


export type MutationUpdateCallingProfileArgs = {
  brandId: Scalars['ID']['input'];
  callingProfileId: Scalars['ID']['input'];
  input: UpdateCallingProfileInput;
};


export type MutationUpdateClientActionInsightsSettingsArgs = {
  input?: InputMaybe<ClientActionInsightsSettingsInput>;
};


export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInput;
};


export type MutationUpdateCompanyTranscriptionSettingsArgs = {
  input: UpdateCompanyTranscriptionSettingsInput;
};


export type MutationUpdateConnectPlaneMcpConfigArgs = {
  input: ConnectPlaneMcpConfigInput;
};


export type MutationUpdateConnectPlaneMcpToolSchemaArgs = {
  input: UpdateConnectPlaneMcpToolSchemaInput;
};


export type MutationUpdateConversationsStatusArgs = {
  input: UpdateConversationsStatusInput;
};


export type MutationUpdateCoreKbClientTypeArgs = {
  kb_id: Scalars['ID']['input'];
  update_input: UpdateKbClientTypeInput;
};


export type MutationUpdateCoreKbCompanyRagSettingsArgs = {
  company_id: Scalars['Int']['input'];
  settings: CoreKbCompanyRagSettingsInput;
};


export type MutationUpdateCoreKbDocumentArgs = {
  doc_id: Scalars['ID']['input'];
  kb_id: Scalars['ID']['input'];
  update_input: DocumentUpdateInput;
};


export type MutationUpdateCoreKbIntegrationArgs = {
  company_integration_id: Scalars['ID']['input'];
  input: UpdateCoreKbIntegrationInput;
};


export type MutationUpdateCoreKbIntegrationSubscriptionArgs = {
  articles: Array<ArticleSelectionInput>;
  crawl_document_id: Scalars['ID']['input'];
  kb_id: Scalars['ID']['input'];
};


export type MutationUpdateCoreKbragOverrideArgs = {
  company_id: Scalars['Int']['input'];
  kb_id: Scalars['ID']['input'];
  rag_enabled_override?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateCrawlDocumentArgs = {
  documentId: Scalars['Int']['input'];
  input: CrawlDocumentUpdateInput;
};


export type MutationUpdateCurrentUserConversationsStatusArgs = {
  input: UpdateCurrentUserConversationsStatusInput;
};


export type MutationUpdateDispatchGroupArgs = {
  dispatchGroupId: Scalars['String']['input'];
  input: UpdateDispatchGroupInput;
  numberId: Scalars['String']['input'];
};


export type MutationUpdateDynamicClientConfigurationArgs = {
  clientId: Scalars['String']['input'];
  input: DynamicClientInput;
};


export type MutationUpdateEmailArgs = {
  input: UpdateEmailInput;
};


export type MutationUpdateEmailNotificationFrequencyArgs = {
  ID: Scalars['ID']['input'];
  agentID: Scalars['ID']['input'];
  input: EmailNotificationFrequencyInput;
};


export type MutationUpdateEmergencyAddressArgs = {
  input: UpdateEmergencyAddressInput;
};


export type MutationUpdateEvalScenarioArgs = {
  input: UpdateEvalScenarioInput;
  scenarioId: Scalars['String']['input'];
};


export type MutationUpdateEvaluationArgs = {
  input: UpdateEvaluationInput;
};


export type MutationUpdateGsmDeviceArgs = {
  input: UpdateGsmDeviceInput;
};


export type MutationUpdateHubspotCallPropertiesArgs = {
  input: UpdateHubspotCallPropertiesInput;
};


export type MutationUpdateHubspotChannelConnectionArgs = {
  input: HubSpotConnectSmsNumbersInput;
};


export type MutationUpdateHubspotEngagementAssociationsArgs = {
  input: UpdateHubspotEngagementAssociationsInput;
};


export type MutationUpdateIntegrationArgs = {
  id: Scalars['ID']['input'];
  integrationType: Scalars['String']['input'];
  payload: UpdateIntegrationPayload;
};


export type MutationUpdateIntegrationScopeArgs = {
  applicationName?: InputMaybe<Scalars['String']['input']>;
  integrationID: Scalars['ID']['input'];
  redirectUri: Scalars['String']['input'];
  scope: Scalars['String']['input'];
};


export type MutationUpdateIntegrationSettingsArgs = {
  applicationName?: InputMaybe<Scalars['String']['input']>;
  integrationID: Scalars['ID']['input'];
  integrationType: Scalars['String']['input'];
  section: SectionInput;
};


export type MutationUpdateIvrSettingArgs = {
  input: UpdateIvrSettingInput;
};


export type MutationUpdateIvrSettingRestArgs = {
  input: IvrSettingInput;
  ivrSettingId: Scalars['String']['input'];
  numberId: Scalars['String']['input'];
};


export type MutationUpdateLineArgs = {
  input: UpdateLineInput;
};


export type MutationUpdateLineBusinessHoursArgs = {
  businessHours: BusinessHoursInput;
  lineID: Scalars['ID']['input'];
};


export type MutationUpdateLineTranscriptionSettingsArgs = {
  input: UpdateLineTranscriptionSettingsInput;
};


export type MutationUpdateLoaEnvelopeStatusArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLoaEnvelopeStatusInput;
};


export type MutationUpdateMessageStatusArgs = {
  input: UpdateMessageStatusInput;
};


export type MutationUpdateMessagingAiAgentArgs = {
  id: Scalars['ID']['input'];
  input: MessagingAiUpdateAgentInput;
};


export type MutationUpdateNextActionArgs = {
  input: UpdateNextActionInput;
};


export type MutationUpdateNoteArgs = {
  content: Scalars['String']['input'];
  noteId: Scalars['ID']['input'];
};


export type MutationUpdateNumberArgs = {
  input: UpdateNumberInput;
  numberId: Scalars['Int']['input'];
};


export type MutationUpdateOnboardingStepArgs = {
  onboardingStep: UpdateOnboardingStepInput;
  platform?: InputMaybe<Platform>;
};


export type MutationUpdateOutboundCampaignArgs = {
  ID: Scalars['ID']['input'];
  input: UpdateOutboundCampaignInput;
};


export type MutationUpdateOutboundCampaignContactImportRowArgs = {
  ID: Scalars['ID']['input'];
  input: OutboundCampaignContactImportRowInput;
};


export type MutationUpdateOutboundCampaignOutcomeArgs = {
  ID: Scalars['ID']['input'];
  input: UpdateOutboundCampaignOutcomeInput;
};


export type MutationUpdatePrerecordedMessageArgs = {
  input: UpdatePrerecordedMessageInput;
};


export type MutationUpdatePrivilegedUsersArgs = {
  input: UpdatePrivilegedUsersInput;
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationUpdateScenarioArgs = {
  input: UpdateScenarioInput;
  scenarioId: Scalars['ID']['input'];
  virtualAgentID: Scalars['ID']['input'];
};


export type MutationUpdateSecretsByLineIdArgs = {
  lineID: Scalars['ID']['input'];
  secrets: Scalars['String']['input'];
};


export type MutationUpdateSignInStrategyArgs = {
  input: UpdateSignInStrategyInput;
};


export type MutationUpdateTagArgs = {
  input: UpdateTagInput;
};


export type MutationUpdateTeamArgs = {
  input: UpdateTeamInput;
};


export type MutationUpdateTrackerArgs = {
  input: UpdateTrackerInput;
};


export type MutationUpdateTtsMessageArgs = {
  input: UpdateTextToSpeechInput;
  numberId?: InputMaybe<Scalars['String']['input']>;
  ttsId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUnreadMessagesArgs = {
  input: UpdateUnreadMessagesInput;
};


export type MutationUpdateUserPasswordArgs = {
  input?: InputMaybe<UpdateUserPasswordMutationInput>;
};


export type MutationUpdateVirtualAgentArgs = {
  input: UpdateVirtualAgentInput;
};


export type MutationUpdateVirtualAgentUsageAlertArgs = {
  input: UpdateVirtualAgentUsageAlertInput;
};


export type MutationUpdateVoiceVirtualAgentAuthMethodArgs = {
  input: UpdateAuthMethodInput;
};


export type MutationUpdateWebhookArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWebhookInput;
};


export type MutationUpdateWhatsAppTemplateFavouritesArgs = {
  input: UpdateWhatsAppTemplateFavouritesInput;
};


export type MutationUpgradePlanArgs = {
  input: UpgradePlanInput;
};


export type MutationUploadBrandDraftLogoArgs = {
  input: UploadBrandDraftLogoInput;
};


export type MutationUploadBrandLogoArgs = {
  brandId: Scalars['ID']['input'];
  input: UploadBrandLogoInput;
};


export type MutationUploadContactImageArgs = {
  input: UploadContactImageInput;
};


export type MutationUploadDocumentArgs = {
  input: FileInput;
};


export type MutationUploadPortingDocumentArgs = {
  input: UploadPortingDocumentInput;
};


export type MutationUploadProfileImageArgs = {
  input: UploadProfileImageInput;
};


export type MutationUpsertEvalPersonaArgs = {
  applicationId: Scalars['String']['input'];
  input: UpsertEvalPersonaInput;
};


export type MutationUpsertPortingRequestArgs = {
  input: UpsertPortingRequestInput;
};


export type MutationValidateA2PFormArgs = {
  input: ValidateA2PFormInput;
};


export type MutationValidateNumbersPortabilityArgs = {
  input: ValidateNumbersPortabilityInput;
};


export type MutationVerifyGsmDeviceArgs = {
  input: VerifyGsmDeviceInput;
};


export type MutationWarmTransferCallArgs = {
  callSid: Scalars['String']['input'];
  input: WarmTransferInput;
};

export type MutationDeleteContactInput = {
  phoneNumber: Scalars['String']['input'];
};

export type MutationDeleteContactOutput = {
  __typename?: 'MutationDeleteContactOutput';
  success: Scalars['Boolean']['output'];
};

export type MutationIntegrationConnectedLinesOutput = {
  __typename?: 'MutationIntegrationConnectedLinesOutput';
  id: Scalars['Int']['output'];
};

export type MutationRefreshContactExtractsOutput = {
  __typename?: 'MutationRefreshContactExtractsOutput';
  success: Scalars['Boolean']['output'];
};

export type MutationRefreshExtractsInput = {
  phoneNumber: Scalars['String']['input'];
  sourceID?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSubscribeToContactsInput = {
  phoneNumbers: Array<Scalars['String']['input']>;
};

export type MutationSubscribeToContactsOutput = {
  __typename?: 'MutationSubscribeToContactsOutput';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type MutiMatchQueryInput = {
  query: Scalars['String']['input'];
  type?: InputMaybe<MultiMatchQueryType>;
};

export type NameTranslations = {
  __typename?: 'NameTranslations';
  en: Scalars['String']['output'];
  fr: Scalars['String']['output'];
};

export enum NegativeFeedbackReason {
  ALREADY_COVERED = 'ALREADY_COVERED',
  HANDLED_BY_HUMANS_INTENTIONALLY = 'HANDLED_BY_HUMANS_INTENTIONALLY',
  NOT_A_PRIORITY = 'NOT_A_PRIORITY',
  NOT_RELEVANT_TO_BUSINESS = 'NOT_RELEVANT_TO_BUSINESS',
  TOO_VAGUE_TO_ACT_ON = 'TOO_VAGUE_TO_ACT_ON'
}

export enum NetworkProtocolType {
  TCP = 'TCP',
  UDP = 'UDP'
}

export enum NetworkType {
  bluetooth = 'bluetooth',
  cellular = 'cellular',
  ethernet = 'ethernet',
  unknown = 'unknown',
  vpn = 'vpn',
  wifi = 'wifi',
  wimax = 'wimax'
}

export type NewSipSettingInput = {
  sipSetting: SipSettingInput;
};

export type NextAction = {
  __typename?: 'NextAction';
  ID: Scalars['ID']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  createdByTeammate?: Maybe<PhoneTeammateResolver>;
  generatedByAI: Scalars['Boolean']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
  updatedByTeammate?: Maybe<PhoneTeammateResolver>;
};

export type NextActionAdded = {
  __typename?: 'NextActionAdded';
  nextAction: NextAction;
};

export type NextActionAddedOutput = GenericException | NextActionAdded | UserInputException;

export type NextActionDeleted = {
  __typename?: 'NextActionDeleted';
  ID: Scalars['ID']['output'];
};

export type NextActionDeletedOutput = GenericException | NextActionDeleted;

export type NextActionUpdated = {
  __typename?: 'NextActionUpdated';
  nextAction: NextAction;
};

export type NextActionUpdatedOutput = GenericException | NextActionUpdated | UserInputException;

export type NextActionsInsights = {
  __typename?: 'NextActionsInsights';
  ID: Scalars['ID']['output'];
  actions: Array<Maybe<NextAction>>;
  callId: Scalars['Float']['output'];
  callUuid?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
};

export type NextQuestion = {
  __typename?: 'NextQuestion';
  question: Scalars['String']['output'];
};

export type NextQuestionInput = {
  question: Scalars['String']['input'];
};

export type NoSourceInputsAttachedException = Exception & {
  __typename?: 'NoSourceInputsAttachedException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  registrationSessionId: Scalars['ID']['output'];
};

export type NoTransferInProgressException = Exception & {
  __typename?: 'NoTransferInProgressException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type Note = {
  __typename?: 'Note';
  callId: Scalars['Float']['output'];
  companyId: Scalars['Int']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  userId: Scalars['Int']['output'];
};

export type NoteAgentDetail = {
  __typename?: 'NoteAgentDetail';
  callId: Scalars['Float']['output'];
  companyId: Scalars['Int']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type NoteBase = {
  __typename?: 'NoteBase';
  callId: Scalars['Float']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  userId: Scalars['Int']['output'];
};

export type NoteDeleted = {
  __typename?: 'NoteDeleted';
  id: Scalars['ID']['output'];
};

export type Notification = {
  __typename?: 'Notification';
  createdAt: Scalars['AWSDateTime']['output'];
  creativeUrl?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  enableDismiss: Scalars['Boolean']['output'];
  header: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  primaryCtaStyle?: Maybe<Scalars['String']['output']>;
  primaryCtaText?: Maybe<Scalars['String']['output']>;
  primaryCtaUrl?: Maybe<Scalars['String']['output']>;
  secondaryCtaStyle?: Maybe<Scalars['String']['output']>;
  secondaryCtaText?: Maybe<Scalars['String']['output']>;
  secondaryCtaUrl?: Maybe<Scalars['String']['output']>;
  tertiaryCtaStyle?: Maybe<Scalars['String']['output']>;
  tertiaryCtaText?: Maybe<Scalars['String']['output']>;
  tertiaryCtaUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type NotificationsConfiguration = {
  __typename?: 'NotificationsConfiguration';
  appKey: Scalars['String']['output'];
  cluster: Scalars['String']['output'];
};

export enum NotificationsPlatform {
  MOBILE = 'MOBILE',
  WEB = 'WEB'
}

export type NotifyAgentConversationStatusAllUpdatedOutput = {
  __typename?: 'NotifyAgentConversationStatusAllUpdatedOutput';
  agentID?: Maybe<Scalars['ID']['output']>;
  initiatingAgentID?: Maybe<Scalars['ID']['output']>;
  markAsDone?: Maybe<Scalars['Boolean']['output']>;
};

export type NotifyAgentConversationStatusAllUpdatedResult = GenericException | NotifyAgentConversationStatusAllUpdatedOutput;

export type NotifyAgentConversationsStatusUpdatedOutput = {
  __typename?: 'NotifyAgentConversationsStatusUpdatedOutput';
  agentID?: Maybe<Scalars['ID']['output']>;
  conversationIDs?: Maybe<Array<Scalars['ID']['output']>>;
  initiatingAgentID?: Maybe<Scalars['ID']['output']>;
  markAsDone?: Maybe<Scalars['Boolean']['output']>;
};

export type NotifyAgentConversationsStatusUpdatedResult = GenericException | NotifyAgentConversationsStatusUpdatedOutput;

export type NotifyConversationCreatedOutput = {
  __typename?: 'NotifyConversationCreatedOutput';
  agentID?: Maybe<Scalars['ID']['output']>;
  conversation?: Maybe<Conversation>;
  error?: Maybe<Error>;
  recipients?: Maybe<Array<Scalars['ID']['output']>>;
};

export type NotifyConversationsAllReadOutput = {
  __typename?: 'NotifyConversationsAllReadOutput';
  agentID: Scalars['ID']['output'];
};

export type NotifyConversationsAllReadResult = GenericException | NotifyConversationsAllReadOutput;

export type NotifyInput = {
  addMessage?: InputMaybe<AddMessageInput>;
  agentConversationStatusAllUpdated?: InputMaybe<AgentConversationStatusAllUpdatedInput>;
  agentConversationsStatusUpdated?: InputMaybe<AgentConversationsStatusUpdatedInput>;
  conversationRead?: InputMaybe<ConversationReadInput>;
  conversationUnread?: InputMaybe<ConversationUnreadInput>;
  conversationsAllRead?: InputMaybe<ConversationsAllReadInput>;
  createConversation?: InputMaybe<CreateConversationInput>;
  type: NotifyType;
  updateMessageStatus?: InputMaybe<UpdateMessageStatusInput>;
};

export type NotifyMessageAddedOutput = {
  __typename?: 'NotifyMessageAddedOutput';
  agentID?: Maybe<Scalars['ID']['output']>;
  error?: Maybe<Error>;
  message?: Maybe<Message>;
  recipients?: Maybe<Array<Scalars['ID']['output']>>;
};

export type NotifyMessageStatusUpdatedOutput = {
  __typename?: 'NotifyMessageStatusUpdatedOutput';
  agentID?: Maybe<Scalars['ID']['output']>;
  error?: Maybe<Error>;
  message?: Maybe<Message>;
  recipients?: Maybe<Array<Scalars['ID']['output']>>;
};

export type NotifyOutboundCampaignAgentSessionQueueIdleInput = {
  campaignID: Scalars['ID']['input'];
  companyID: Scalars['ID']['input'];
  occurredAt: Scalars['AWSDateTime']['input'];
  recipients: Array<Scalars['ID']['input']>;
  userID: Scalars['ID']['input'];
};

export type NotifyOutboundCampaignCallDispatchedInput = {
  attemptNumber: Scalars['Int']['input'];
  callSid: Scalars['String']['input'];
  campaignID: Scalars['ID']['input'];
  companyID: Scalars['ID']['input'];
  lineID: Scalars['ID']['input'];
  occurredAt: Scalars['AWSDateTime']['input'];
  phoneNumber: Scalars['String']['input'];
  recipients: Array<Scalars['ID']['input']>;
};

export type NotifyOutboundCampaignCallOutcomeAddedInput = {
  attemptID: Scalars['ID']['input'];
  campaignID: Scalars['ID']['input'];
  companyID: Scalars['ID']['input'];
  occurredAt: Scalars['AWSDateTime']['input'];
  recipients: Array<Scalars['ID']['input']>;
};

export type NotifyOutboundCampaignChangedInput = {
  campaignID: Scalars['ID']['input'];
  changedFields: Array<Scalars['String']['input']>;
  companyID: Scalars['ID']['input'];
  occurredAt: Scalars['AWSDateTime']['input'];
  reason: OutboundCampaignChangeReason;
  recipients: Array<Scalars['ID']['input']>;
};

export type NotifyOutboundCampaignCompanyUnavailableInput = {
  agentSessionID: Scalars['ID']['input'];
  attemptID: Scalars['ID']['input'];
  campaignID: Scalars['ID']['input'];
  companyID: Scalars['ID']['input'];
  occurredAt: Scalars['AWSDateTime']['input'];
  reason: OutboundCampaignCompanyUnavailableReason;
  recipients: Array<Scalars['ID']['input']>;
};

export type NotifyOutboundCampaignNextCallQueuedInput = {
  campaignID: Scalars['ID']['input'];
  companyID: Scalars['ID']['input'];
  lineID: Scalars['ID']['input'];
  occurredAt: Scalars['AWSDateTime']['input'];
  phoneNumber: Scalars['String']['input'];
  recipients: Array<Scalars['ID']['input']>;
};

export type NotifyOutboundCampaignQueueItemChangedInput = {
  attemptCount?: InputMaybe<Scalars['Int']['input']>;
  campaignID: Scalars['ID']['input'];
  companyID: Scalars['ID']['input'];
  lastAttemptAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  lastAttemptID?: InputMaybe<Scalars['ID']['input']>;
  lastOutcome?: InputMaybe<Scalars['String']['input']>;
  maxAttempts?: InputMaybe<Scalars['Int']['input']>;
  nextAttemptAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  occurredAt: Scalars['AWSDateTime']['input'];
  position?: InputMaybe<Scalars['String']['input']>;
  queueItemID?: InputMaybe<Scalars['ID']['input']>;
  reason: OutboundCampaignQueueItemChangeReason;
  recipients: Array<Scalars['ID']['input']>;
  state?: InputMaybe<OutboundCampaignQueueItemDisplayState>;
};

export type NotifyOutboundCampaignUserDispatchFailedInput = {
  campaignID: Scalars['ID']['input'];
  companyID: Scalars['ID']['input'];
  occurredAt: Scalars['AWSDateTime']['input'];
  reason: OutboundCampaignDispatchFailureReason;
  recipients: Array<Scalars['ID']['input']>;
  userID: Scalars['ID']['input'];
};

export type NotifyOutboundCampaignUserReadyChangedInput = {
  campaignID: Scalars['ID']['input'];
  companyID: Scalars['ID']['input'];
  occurredAt: Scalars['AWSDateTime']['input'];
  reason: OutboundCampaignUserReadyReason;
  recipients: Array<Scalars['ID']['input']>;
  userID: Scalars['ID']['input'];
};

export type NotifyOutboundCampaignUserStatusChangedInput = {
  campaignID: Scalars['ID']['input'];
  companyID: Scalars['ID']['input'];
  newStatus: OutboundCampaignUserStatus;
  occurredAt: Scalars['AWSDateTime']['input'];
  recipients: Array<Scalars['ID']['input']>;
  userID: Scalars['ID']['input'];
};

export type NotifyOutput = {
  __typename?: 'NotifyOutput';
  error?: Maybe<Error>;
  status?: Maybe<NotifyStatus>;
};

export enum NotifyStatus {
  DELIVERED = 'DELIVERED',
  ERROR_WHILE_DELIVERING = 'ERROR_WHILE_DELIVERING',
  FEATURE_DISABLED = 'FEATURE_DISABLED'
}

export enum NotifyType {
  ADD_MESSAGE = 'ADD_MESSAGE',
  AGENT_CONVERSATIONS_STATUS_UPDATED = 'AGENT_CONVERSATIONS_STATUS_UPDATED',
  AGENT_CONVERSATION_STATUS_ALL_UPDATED = 'AGENT_CONVERSATION_STATUS_ALL_UPDATED',
  CONVERSATIONS_ALL_READ = 'CONVERSATIONS_ALL_READ',
  CONVERSATION_READ = 'CONVERSATION_READ',
  CONVERSATION_UNREAD = 'CONVERSATION_UNREAD',
  CREATE_CONVERSATION = 'CREATE_CONVERSATION',
  UPDATE_MESSAGE_STATUS = 'UPDATE_MESSAGE_STATUS'
}

export type Number = {
  __typename?: 'Number';
  activationState: Scalars['String']['output'];
  afterHoursMessage: Scalars['String']['output'];
  afterHoursVoicemail: Scalars['Boolean']['output'];
  allowInboundRecordingActions?: Maybe<Scalars['Boolean']['output']>;
  allowOutboundRecordingActions?: Maybe<Scalars['Boolean']['output']>;
  closedMessage: Scalars['String']['output'];
  closedMessageEnabled: Scalars['Boolean']['output'];
  dispatchGroups: Array<DispatchGroup>;
  flowEditorEnabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  inboundRecordingActivated?: Maybe<Scalars['Boolean']['output']>;
  iso3166Alpha2: Scalars['String']['output'];
  ivr: Scalars['Boolean']['output'];
  ivrMessage: Scalars['String']['output'];
  ivrSettings: Array<IvrSettingRest>;
  mandatoryTaggingActivated?: Maybe<Scalars['Boolean']['output']>;
  missedCallMessage: Scalars['String']['output'];
  missedCallVoicemail: Scalars['Boolean']['output'];
  musicOnHold: Scalars['String']['output'];
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  numberFormatted: Scalars['String']['output'];
  numberUuid?: Maybe<Scalars['String']['output']>;
  open: Scalars['Boolean']['output'];
  outboundRecordingActivated?: Maybe<Scalars['Boolean']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  queueCallbackActivated?: Maybe<Scalars['Boolean']['output']>;
  replayIvrMessage: Scalars['Boolean']['output'];
  respectQueueingTime?: Maybe<Scalars['Boolean']['output']>;
  ringingTone: Scalars['String']['output'];
  smsEnabled: Scalars['Boolean']['output'];
  state: LineState;
  supervisions: Array<Maybe<SupervisionItem>>;
  ttsMessages: Array<TtsMessage>;
  verificationState?: Maybe<Scalars['String']['output']>;
  waitingMusic: Scalars['String']['output'];
  waitingMusicEnabled: Scalars['Boolean']['output'];
  welcomeMessage: Scalars['String']['output'];
  welcomeMessageContent: Scalars['String']['output'];
  welcomeMessageEnabled: Scalars['Boolean']['output'];
  welcomeMessageLocked: Scalars['Boolean']['output'];
};

export enum NumberEnrollmentStatus {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export type NumberPurchaseEligibility = {
  __typename?: 'NumberPurchaseEligibility';
  reason?: Maybe<Scalars['String']['output']>;
  restricted: Scalars['Boolean']['output'];
};

export type NumberRegion = {
  __typename?: 'NumberRegion';
  areaCode?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  parentRegionUUID?: Maybe<Scalars['String']['output']>;
  phoneType?: Maybe<Scalars['String']['output']>;
  rateCenter?: Maybe<Scalars['String']['output']>;
  regionUUID?: Maybe<Scalars['String']['output']>;
};

export type NumberRegistration = {
  __typename?: 'NumberRegistration';
  status: NumberRegistrationStatus;
  updatedAt: Scalars['String']['output'];
};

export enum NumberRegistrationStatus {
  approved = 'approved',
  awaiting_approval = 'awaiting_approval',
  not_registered = 'not_registered',
  rejected = 'rejected'
}

export type NumberReputationData = {
  __typename?: 'NumberReputationData';
  desirabilityMetric?: Maybe<Scalars['String']['output']>;
  engagementMetric?: Maybe<Scalars['String']['output']>;
  fetchedAt?: Maybe<Scalars['String']['output']>;
  flagCategory?: Maybe<Scalars['String']['output']>;
  flagStatus?: Maybe<Scalars['String']['output']>;
  maturityMetric?: Maybe<Scalars['String']['output']>;
  reactionMetric?: Maybe<Scalars['String']['output']>;
};

export enum NumberReputationEmployeeCount {
  BETWEEN_1_AND_10 = 'BETWEEN_1_AND_10',
  BETWEEN_11_AND_50 = 'BETWEEN_11_AND_50',
  BETWEEN_51_AND_200 = 'BETWEEN_51_AND_200',
  BETWEEN_201_AND_500 = 'BETWEEN_201_AND_500',
  BETWEEN_501_AND_2000 = 'BETWEEN_501_AND_2000',
  BETWEEN_2001_AND_10000 = 'BETWEEN_2001_AND_10000',
  MORE_THAN_10001 = 'MORE_THAN_10001'
}

export type NumberReputationException = Exception & {
  __typename?: 'NumberReputationException';
  code: Scalars['String']['output'];
  details?: Maybe<Scalars['String']['output']>;
  fieldIssues?: Maybe<Array<BusinessDraftFieldIssue>>;
  message: Scalars['String']['output'];
  statusCode: Scalars['Int']['output'];
};

export enum NumberReputationIndustry {
  ACCOUNTING_OR_FINANCE = 'ACCOUNTING_OR_FINANCE',
  BILLING_AND_COLLECTIONS = 'BILLING_AND_COLLECTIONS',
  BUSINESS_SERVICES = 'BUSINESS_SERVICES',
  CHARITY_OR_FUNDRAISING = 'CHARITY_OR_FUNDRAISING',
  COMMUNICATIONS = 'COMMUNICATIONS',
  CUSTOMER_SERVICE = 'CUSTOMER_SERVICE',
  DELIVERY_OR_SHIPPING = 'DELIVERY_OR_SHIPPING',
  EDUCATION = 'EDUCATION',
  FINANCIAL_SERVICES = 'FINANCIAL_SERVICES',
  GOVERNMENT_OR_PUBLIC_SERVICES = 'GOVERNMENT_OR_PUBLIC_SERVICES',
  HEALTHCARE_OR_PHARMACY = 'HEALTHCARE_OR_PHARMACY',
  INSURANCE = 'INSURANCE',
  LEGAL_SERVICES = 'LEGAL_SERVICES',
  NOTIFICATIONS_OR_SCHEDULING = 'NOTIFICATIONS_OR_SCHEDULING',
  OTHER = 'OTHER',
  REAL_ESTATE = 'REAL_ESTATE',
  RETAIL = 'RETAIL',
  SALES = 'SALES',
  SOFTWARE_OR_TECHNOLOGY_OR_MEDIA = 'SOFTWARE_OR_TECHNOLOGY_OR_MEDIA',
  SURVEYS_AND_MARKET_RESEARCH = 'SURVEYS_AND_MARKET_RESEARCH',
  TRAVEL_OR_HOSPITALITY = 'TRAVEL_OR_HOSPITALITY'
}

export enum NumberReputationLabel {
  FLAGGED = 'FLAGGED',
  HEALTHY = 'HEALTHY',
  HIGH_RISK = 'HIGH_RISK',
  LOW_RISK = 'LOW_RISK'
}

export type NumberReputationSummary = {
  __typename?: 'NumberReputationSummary';
  flagged: Scalars['Int']['output'];
  healthy: Scalars['Int']['output'];
  highRisk: Scalars['Int']['output'];
  lowRisk: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type NumbersLimitReached = {
  __typename?: 'NumbersLimitReached';
  isNumbersLimitReached: Scalars['Boolean']['output'];
};

export type OAuthConfig = {
  __typename?: 'OAuthConfig';
  clientId: Scalars['String']['output'];
  clientSecretConfigured: Scalars['Boolean']['output'];
  grantType?: Maybe<Scalars['String']['output']>;
  hasStoredTokens: Scalars['Boolean']['output'];
  loginUrl: Scalars['String']['output'];
  redirectUri?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  tokenEndpoint: Scalars['String']['output'];
};

export type OAuthConfigInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  grantType?: InputMaybe<Scalars['String']['input']>;
  loginUrl: Scalars['String']['input'];
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  tokenEndpoint: Scalars['String']['input'];
};

export type OAuthUrlResponse = {
  __typename?: 'OAuthUrlResponse';
  authSessionId: Scalars['String']['output'];
  authorizationUrl: Scalars['String']['output'];
};

export type OauthCodeQueryResponse = {
  __typename?: 'OauthCodeQueryResponse';
  redirectTo: Scalars['String']['output'];
};

export type OfflineReason = {
  __typename?: 'OfflineReason';
  code?: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  errorKey?: Maybe<Scalars['String']['output']>;
  solution: Scalars['String']['output'];
};

export type OnAiAnswerGeneratedErrorInput = {
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type OnAiAnswersGeneratedCategoryInput = {
  categoryId: Scalars['ID']['input'];
  questions: Array<OnAiAnswersGeneratedQuestionInput>;
};

export type OnAiAnswersGeneratedOutputDataInput = {
  callId: Scalars['ID']['input'];
  categories: Array<OnAiAnswersGeneratedCategoryInput>;
};

export type OnAiAnswersGeneratedQuestionInput = {
  binaryAnswer?: InputMaybe<BinaryAnswerValue>;
  feedback: Scalars['String']['input'];
  questionId: Scalars['ID']['input'];
  questionType: QuestionType;
  ratingAnswer?: InputMaybe<RatingAnswerValue>;
};

export type OnQuestionQualityHelperGeneratedErrorInput = {
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type OnQuestionQualityHelperGeneratedOutputDataInput = {
  isAcceptable: Scalars['Boolean']['input'];
  language: Scalars['String']['input'];
  question: Scalars['String']['input'];
  rephrasedQuestion: Scalars['String']['input'];
};

export type Onboarding = {
  __typename?: 'Onboarding';
  createdAt: Scalars['AWSDateTime']['output'];
  crm?: Maybe<Crm>;
  cta: Scalars['String']['output'];
  ctaButtonTitle: Scalars['String']['output'];
  ctaButtonUrl: Scalars['String']['output'];
  metadata: Array<MetadataKeyValuePair>;
  steps: Array<Step>;
  title: Scalars['String']['output'];
};

export type Option = {
  __typename?: 'Option';
  id?: Maybe<Scalars['Int']['output']>;
  label: Scalars['String']['output'];
  labelLocaliseKey: Scalars['String']['output'];
};

export type OptionItem = {
  __typename?: 'OptionItem';
  description?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type OptionsItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type OptionsResponse = {
  __typename?: 'OptionsResponse';
  options: Array<OptionItem>;
};

export type OutboundAgentInsights = {
  __typename?: 'OutboundAgentInsights';
  avgCallDurationSeconds: Scalars['Float']['output'];
  completedCalls: Scalars['Int']['output'];
  connectRate: Scalars['Float']['output'];
  delta?: Maybe<OutboundInsightsDelta>;
  humanAnsweredCount: Scalars['Int']['output'];
  humanAnsweredRate: Scalars['Float']['output'];
  noAnswerCount: Scalars['Int']['output'];
  noAnswerRate: Scalars['Float']['output'];
  otherCount: Scalars['Int']['output'];
  otherRate: Scalars['Float']['output'];
  totalCallDurationSeconds: Scalars['Float']['output'];
  totalCalls: Scalars['Int']['output'];
  voicemailCount: Scalars['Int']['output'];
  voicemailRate: Scalars['Float']['output'];
};

export type OutboundAgentInsightsOutput = GenericException | OutboundAgentInsights | ResourceNotFoundException | UserInputException;

export enum OutboundCallOutcome {
  ESCALATED = 'ESCALATED',
  HUMAN_ANSWERED = 'HUMAN_ANSWERED',
  MACHINE_ANSWERED = 'MACHINE_ANSWERED',
  NO_ANSWER = 'NO_ANSWER',
  VOICEMAIL = 'VOICEMAIL'
}

export type OutboundCampaign = {
  __typename?: 'OutboundCampaign';
  ID: Scalars['ID']['output'];
  agentType: OutboundCampaignAgentType;
  aivaAgentId?: Maybe<Scalars['ID']['output']>;
  assigneesCount: Scalars['Int']['output'];
  assignment: OutboundCampaignAssignment;
  callerIdStrategy: OutboundCampaignCallerIdStrategy;
  campaignOutcomeTime: Scalars['Int']['output'];
  companyID: Scalars['ID']['output'];
  contactsCount: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  creator: PhoneTeammateResolver;
  description?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  externalRingingTimeout: Scalars['Int']['output'];
  lines: Array<LineResolver>;
  localPresence: Scalars['Boolean']['output'];
  maxCallAttempts: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  outcomes: Array<OutboundCampaignOutcome>;
  retryInterval: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  stats: OutboundCampaignStats;
  status: OutboundCampaignStatus;
  updatedAt: Scalars['String']['output'];
};

export type OutboundCampaignAgentNotAvailableException = Exception & {
  __typename?: 'OutboundCampaignAgentNotAvailableException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type OutboundCampaignAgentSessionQueueIdleNotification = {
  __typename?: 'OutboundCampaignAgentSessionQueueIdleNotification';
  campaignID: Scalars['ID']['output'];
  companyID: Scalars['ID']['output'];
  occurredAt: Scalars['AWSDateTime']['output'];
  recipients: Array<Scalars['ID']['output']>;
  userID: Scalars['ID']['output'];
};

export enum OutboundCampaignAgentType {
  AIVA = 'AIVA',
  HUMAN = 'HUMAN'
}

export type OutboundCampaignAssignment = {
  __typename?: 'OutboundCampaignAssignment';
  directAgents: Array<PhoneTeammateResolver>;
  teams: Array<TeamResolver>;
};

export type OutboundCampaignAttempt = {
  __typename?: 'OutboundCampaignAttempt';
  ID: Scalars['ID']['output'];
  attemptNumber: Scalars['Int']['output'];
  call?: Maybe<PhoneCallResolver>;
  campaign: OutboundCampaignEntityResolver;
  outcome: OutboundCampaignOutcomeResolver;
};

export type OutboundCampaignAttemptResolver = {
  __typename?: 'OutboundCampaignAttemptResolver';
  entity?: Maybe<OutboundCampaignAttempt>;
};

export type OutboundCampaignAttemptResolverInput = {
  __typename?: 'OutboundCampaignAttemptResolverInput';
  callID: Scalars['ID']['output'];
  companyID: Scalars['ID']['output'];
};

export type OutboundCampaignAvailabilityEstimate = {
  __typename?: 'OutboundCampaignAvailabilityEstimate';
  nextAvailableAt?: Maybe<Scalars['AWSDateTime']['output']>;
  status: OutboundCampaignAvailabilityStatus;
};

export type OutboundCampaignAvailabilityEstimateOutput = GenericException | OutboundCampaignAvailabilityEstimate | ResourceNotFoundException;

export enum OutboundCampaignAvailabilityStatus {
  AVAILABLE_NOW = 'AVAILABLE_NOW',
  WAITING_FOR_ATTEMPT_INTERVAL = 'WAITING_FOR_ATTEMPT_INTERVAL',
  WAITING_FOR_CONTACTS = 'WAITING_FOR_CONTACTS',
  WAITING_FOR_IN_FLIGHT_ATTEMPT = 'WAITING_FOR_IN_FLIGHT_ATTEMPT'
}

export type OutboundCampaignBackgroundJob = {
  __typename?: 'OutboundCampaignBackgroundJob';
  ID: Scalars['ID']['output'];
  completedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  startedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  status: OutboundCampaignBackgroundJobStatus;
  type: OutboundCampaignBackgroundJobType;
};

export type OutboundCampaignBackgroundJobOutput = GenericException | OutboundCampaignBackgroundJob | ResourceNotFoundException;

export enum OutboundCampaignBackgroundJobStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING'
}

export enum OutboundCampaignBackgroundJobType {
  CAMPAIGN_DUPLICATION = 'CAMPAIGN_DUPLICATION',
  CONTACT_IMPORT_PROCESSING = 'CONTACT_IMPORT_PROCESSING',
  CONTACT_PROMOTION = 'CONTACT_PROMOTION'
}

export type OutboundCampaignCallDispatchedNotification = {
  __typename?: 'OutboundCampaignCallDispatchedNotification';
  attemptNumber: Scalars['Int']['output'];
  callSid: Scalars['String']['output'];
  campaign: OutboundCampaignEntityResolver;
  campaignContact: OutboundCampaignContactResolver;
  companyID: Scalars['ID']['output'];
  line: LineResolver;
  occurredAt: Scalars['AWSDateTime']['output'];
  recipients: Array<Scalars['ID']['output']>;
};

export type OutboundCampaignCallOutcome = {
  __typename?: 'OutboundCampaignCallOutcome';
  ID: Scalars['ID']['output'];
  attemptNumber: Scalars['Int']['output'];
  call?: Maybe<PhoneCallResolver>;
  campaignContact: OutboundCampaignContactResolver;
  campaignID: Scalars['ID']['output'];
  maxAttempts: Scalars['Int']['output'];
  outcome: OutboundCampaignCallOutcomeValue;
};

export type OutboundCampaignCallOutcomeConnection = {
  __typename?: 'OutboundCampaignCallOutcomeConnection';
  edges: Array<OutboundCampaignCallOutcomeEdge>;
  pageInfo: OutboundCampaignsPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OutboundCampaignCallOutcomeEdge = {
  __typename?: 'OutboundCampaignCallOutcomeEdge';
  cursor: Scalars['String']['output'];
  node: OutboundCampaignCallOutcome;
};

export type OutboundCampaignCallOutcomeNotification = {
  __typename?: 'OutboundCampaignCallOutcomeNotification';
  attemptID: Scalars['ID']['output'];
  callOutcome: OutboundCampaignCallOutcomeResolver;
  campaignID: Scalars['ID']['output'];
  companyID: Scalars['ID']['output'];
  occurredAt: Scalars['AWSDateTime']['output'];
  recipients: Array<Scalars['ID']['output']>;
};

export type OutboundCampaignCallOutcomeResolver = {
  __typename?: 'OutboundCampaignCallOutcomeResolver';
  entity: OutboundCampaignCallOutcome;
};

export type OutboundCampaignCallOutcomeResolverInput = {
  __typename?: 'OutboundCampaignCallOutcomeResolverInput';
  attemptID: Scalars['ID']['output'];
  campaignID: Scalars['ID']['output'];
  companyID: Scalars['ID']['output'];
};

export type OutboundCampaignCallOutcomeValue = OutboundCampaignOutcome | OutboundCampaignPredefinedCallOutcome;

export type OutboundCampaignCallerIdNumberInput = {
  ID: Scalars['Int']['input'];
  phoneNumber: Scalars['String']['input'];
};

export enum OutboundCampaignCallerIdStrategy {
  AGENT_NUMBER_POOL = 'AGENT_NUMBER_POOL',
  SPECIFIC_NUMBER_POOL = 'SPECIFIC_NUMBER_POOL'
}

export enum OutboundCampaignChangeReason {
  ARCHIVED = 'ARCHIVED',
  ATTEMPT_INTERVAL_ELAPSED = 'ATTEMPT_INTERVAL_ELAPSED',
  COMPLETED = 'COMPLETED',
  CONTACTS_ADDED = 'CONTACTS_ADDED',
  CREATED = 'CREATED',
  DELETED = 'DELETED',
  LAUNCHED = 'LAUNCHED',
  PAUSED = 'PAUSED',
  PROGRESS_CHANGED = 'PROGRESS_CHANGED',
  RESUMED = 'RESUMED',
  UPDATED = 'UPDATED'
}

export type OutboundCampaignCompanyUnavailableNotification = {
  __typename?: 'OutboundCampaignCompanyUnavailableNotification';
  agentSessionID: Scalars['ID']['output'];
  attemptID: Scalars['ID']['output'];
  campaignID: Scalars['ID']['output'];
  companyID: Scalars['ID']['output'];
  occurredAt: Scalars['AWSDateTime']['output'];
  reason: OutboundCampaignCompanyUnavailableReason;
  recipients: Array<Scalars['ID']['output']>;
};

export enum OutboundCampaignCompanyUnavailableReason {
  COMMUNICATION_LIMIT_REACHED = 'COMMUNICATION_LIMIT_REACHED',
  COMPANY_INACTIVE = 'COMPANY_INACTIVE',
  EXPENSE_LIMIT_REACHED = 'EXPENSE_LIMIT_REACHED',
  PRECHECK_UNREACHABLE = 'PRECHECK_UNREACHABLE'
}

export type OutboundCampaignConnection = {
  __typename?: 'OutboundCampaignConnection';
  edges: Array<OutboundCampaignEdge>;
  pageInfo: OutboundCampaignsPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OutboundCampaignContact = {
  __typename?: 'OutboundCampaignContact';
  ID: Scalars['ID']['output'];
  attempts: Array<OutboundCampaignAttempt>;
  campaignID: Scalars['ID']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
};

export type OutboundCampaignContactConnection = {
  __typename?: 'OutboundCampaignContactConnection';
  edges: Array<OutboundCampaignContactEdge>;
  pageInfo: OutboundCampaignsPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OutboundCampaignContactEdge = {
  __typename?: 'OutboundCampaignContactEdge';
  cursor: Scalars['String']['output'];
  node: OutboundCampaignContact;
};

export type OutboundCampaignContactExternal = OutboundCampaignContactResolver;

export type OutboundCampaignContactImport = {
  __typename?: 'OutboundCampaignContactImport';
  ID: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  duplicateCount: Scalars['Int']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  invalidCount: Scalars['Int']['output'];
  items: OutboundCampaignContactImportRowConnection;
  source: OutboundCampaignContactImportSource;
  totalCount: Scalars['Int']['output'];
  validCount: Scalars['Int']['output'];
};


export type OutboundCampaignContactImportItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OutboundCampaignContactImportRowFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type OutboundCampaignContactImportCleaned = {
  __typename?: 'OutboundCampaignContactImportCleaned';
  removedCount: Scalars['Int']['output'];
  validCount: Scalars['Int']['output'];
};

export type OutboundCampaignContactImportExportUrl = {
  __typename?: 'OutboundCampaignContactImportExportUrl';
  downloadUrl: Scalars['String']['output'];
  expiresAt: Scalars['AWSDateTime']['output'];
};

export type OutboundCampaignContactImportFromCrmRequested = {
  __typename?: 'OutboundCampaignContactImportFromCrmRequested';
  contactImportID: Scalars['ID']['output'];
  jobID: Scalars['ID']['output'];
};

export type OutboundCampaignContactImportOutput = GenericException | OutboundCampaignContactImport | ResourceNotFoundException;

export type OutboundCampaignContactImportRow = {
  __typename?: 'OutboundCampaignContactImportRow';
  ID: Scalars['ID']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  issues: Array<FieldException>;
  lastName?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  rowIndex: Scalars['Int']['output'];
  status: OutboundCampaignContactImportRowStatus;
};

export type OutboundCampaignContactImportRowConnection = {
  __typename?: 'OutboundCampaignContactImportRowConnection';
  edges: Array<OutboundCampaignContactImportRowEdge>;
  pageInfo: OutboundCampaignContactImportRowPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OutboundCampaignContactImportRowEdge = {
  __typename?: 'OutboundCampaignContactImportRowEdge';
  cursor: Scalars['String']['output'];
  node: OutboundCampaignContactImportRow;
};

export type OutboundCampaignContactImportRowFilterInput = {
  status?: InputMaybe<OutboundCampaignContactImportRowStatus>;
};

export type OutboundCampaignContactImportRowInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};

export type OutboundCampaignContactImportRowPageInfo = {
  __typename?: 'OutboundCampaignContactImportRowPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export enum OutboundCampaignContactImportRowStatus {
  DUPLICATE = 'DUPLICATE',
  INVALID = 'INVALID',
  VALID = 'VALID'
}

export type OutboundCampaignContactImportRowsRemoved = {
  __typename?: 'OutboundCampaignContactImportRowsRemoved';
  removedCount: Scalars['Int']['output'];
};

export enum OutboundCampaignContactImportSource {
  CRM = 'CRM',
  CSV = 'CSV'
}

export type OutboundCampaignContactImportUploadUrl = {
  __typename?: 'OutboundCampaignContactImportUploadUrl';
  contactImportID: Scalars['ID']['output'];
  expiresAt: Scalars['AWSDateTime']['output'];
  fields: Array<OutboundCampaignPresignedUrlField>;
  jobID: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export enum OutboundCampaignContactInsertionPoint {
  BOTTOM = 'BOTTOM',
  TOP = 'TOP'
}

export type OutboundCampaignContactOutput = GenericException | OutboundCampaignContact | ResourceNotFoundException;

export type OutboundCampaignContactResolver = {
  __typename?: 'OutboundCampaignContactResolver';
  entity: OutboundCampaignContact;
};

export type OutboundCampaignContactResolverInput = {
  __typename?: 'OutboundCampaignContactResolverInput';
  campaignID: Scalars['ID']['output'];
  companyID: Scalars['ID']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type OutboundCampaignCreatedByFilterInput = {
  in: Array<Scalars['Int']['input']>;
};

export type OutboundCampaignCurrentUserRelevantStatus = {
  __typename?: 'OutboundCampaignCurrentUserRelevantStatus';
  campaign: OutboundCampaignEntityResolver;
  campaignID: Scalars['ID']['output'];
  status: OutboundCampaignUserStatus;
};

export type OutboundCampaignDeletePayload = {
  __typename?: 'OutboundCampaignDeletePayload';
  success: Scalars['Boolean']['output'];
};

export enum OutboundCampaignDispatchFailureReason {
  NO_ELIGIBLE_NUMBERS = 'NO_ELIGIBLE_NUMBERS',
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR'
}

export type OutboundCampaignDuplicationBucket = {
  __typename?: 'OutboundCampaignDuplicationBucket';
  count: Scalars['Int']['output'];
  outcome?: Maybe<OutboundCampaignCallOutcomeValue>;
};

export type OutboundCampaignDuplicationPreview = {
  __typename?: 'OutboundCampaignDuplicationPreview';
  buckets: Array<OutboundCampaignDuplicationBucket>;
  totalContacts: Scalars['Int']['output'];
};

export type OutboundCampaignDuplicationPreviewOutput = GenericException | OutboundCampaignDuplicationPreview | ResourceNotFoundException;

export type OutboundCampaignDuplicationResult = {
  __typename?: 'OutboundCampaignDuplicationResult';
  campaign: OutboundCampaign;
  job: OutboundCampaignBackgroundJob;
};

export type OutboundCampaignDuplicationSelectionInput = {
  includeQueued: Scalars['Boolean']['input'];
  outcomeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  predefinedOutcomes?: InputMaybe<Array<OutboundCampaignPredefinedCallOutcomeCode>>;
};

export type OutboundCampaignEdge = {
  __typename?: 'OutboundCampaignEdge';
  cursor: Scalars['String']['output'];
  node: OutboundCampaign;
};

export type OutboundCampaignEdgeResolver = {
  __typename?: 'OutboundCampaignEdgeResolver';
  entity: OutboundCampaignEdge;
};

export type OutboundCampaignEdgeResolverInput = {
  __typename?: 'OutboundCampaignEdgeResolverInput';
  campaignID: Scalars['ID']['output'];
  companyID: Scalars['ID']['output'];
};

export type OutboundCampaignEntityResolver = {
  __typename?: 'OutboundCampaignEntityResolver';
  entity: OutboundCampaign;
};

export type OutboundCampaignEntityResolverInput = {
  __typename?: 'OutboundCampaignEntityResolverInput';
  campaignID: Scalars['ID']['output'];
  companyID: Scalars['ID']['output'];
};

export type OutboundCampaignFieldMappingInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};

export type OutboundCampaignLineConnection = {
  __typename?: 'OutboundCampaignLineConnection';
  edges: Array<OutboundCampaignLineEdge>;
  pageInfo: OutboundCampaignsPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OutboundCampaignLineEdge = {
  __typename?: 'OutboundCampaignLineEdge';
  cursor: Scalars['String']['output'];
  node: LineResolver;
};

export type OutboundCampaignNextCallQueuedNotification = {
  __typename?: 'OutboundCampaignNextCallQueuedNotification';
  campaign: OutboundCampaignEntityResolver;
  campaignContact: OutboundCampaignContactResolver;
  companyID: Scalars['ID']['output'];
  line: LineResolver;
  occurredAt: Scalars['AWSDateTime']['output'];
  recipients: Array<Scalars['ID']['output']>;
};

export type OutboundCampaignNotReadyException = Exception & {
  __typename?: 'OutboundCampaignNotReadyException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type OutboundCampaignNotification = {
  __typename?: 'OutboundCampaignNotification';
  campaign: OutboundCampaignEdgeResolver;
  campaignID: Scalars['ID']['output'];
  companyID: Scalars['ID']['output'];
  occurredAt: Scalars['AWSDateTime']['output'];
  reason: OutboundCampaignChangeReason;
  recipients: Array<Scalars['ID']['output']>;
};

export type OutboundCampaignOutcome = {
  __typename?: 'OutboundCampaignOutcome';
  ID: Scalars['ID']['output'];
  color?: Maybe<Scalars['String']['output']>;
  creator: PhoneTeammateResolver;
  name: Scalars['String']['output'];
};

export type OutboundCampaignOutcomeAlreadyExistsException = Exception & {
  __typename?: 'OutboundCampaignOutcomeAlreadyExistsException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type OutboundCampaignOutcomeConnection = {
  __typename?: 'OutboundCampaignOutcomeConnection';
  edges: Array<OutboundCampaignOutcomeEdge>;
  pageInfo: OutboundCampaignsPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OutboundCampaignOutcomeDeletePayload = {
  __typename?: 'OutboundCampaignOutcomeDeletePayload';
  success: Scalars['Boolean']['output'];
};

export type OutboundCampaignOutcomeEdge = {
  __typename?: 'OutboundCampaignOutcomeEdge';
  cursor: Scalars['String']['output'];
  node: OutboundCampaignOutcome;
};

export type OutboundCampaignOutcomeInput = {
  __typename?: 'OutboundCampaignOutcomeInput';
  attemptID: Scalars['ID']['output'];
  companyID: Scalars['ID']['output'];
};

export type OutboundCampaignOutcomeOutput = GenericException | OutboundCampaignOutcome | ResourceNotFoundException;

export type OutboundCampaignOutcomeResolver = {
  __typename?: 'OutboundCampaignOutcomeResolver';
  entity?: Maybe<OutboundCampaignCallOutcomeValue>;
};

export type OutboundCampaignOutput = GenericException | OutboundCampaign | ResourceNotFoundException;

export type OutboundCampaignPredefinedCallOutcome = {
  __typename?: 'OutboundCampaignPredefinedCallOutcome';
  code: OutboundCampaignPredefinedCallOutcomeCode;
};

export enum OutboundCampaignPredefinedCallOutcomeCode {
  BLOCKED = 'BLOCKED',
  CALL_INTERRUPTED = 'CALL_INTERRUPTED',
  DO_NOT_CALL = 'DO_NOT_CALL',
  ESCALATED = 'ESCALATED',
  FOLLOWUP = 'FOLLOWUP',
  HUMAN_ANSWERED = 'HUMAN_ANSWERED',
  INVALID = 'INVALID',
  MACHINE_ANSWERED = 'MACHINE_ANSWERED',
  NO_ANSWER = 'NO_ANSWER',
  UNANSWERED = 'UNANSWERED',
  UNSPECIFIED = 'UNSPECIFIED',
  VOICEMAIL = 'VOICEMAIL',
  VOICEMAIL_DROPPED = 'VOICEMAIL_DROPPED',
  VOIDED = 'VOIDED',
  WRONG_NUMBER = 'WRONG_NUMBER'
}

export type OutboundCampaignPresignedUrlField = {
  __typename?: 'OutboundCampaignPresignedUrlField';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type OutboundCampaignQueueItem = {
  __typename?: 'OutboundCampaignQueueItem';
  ID: Scalars['ID']['output'];
  attemptCount: Scalars['Int']['output'];
  campaignContact: OutboundCampaignContactExternal;
  campaignID: Scalars['ID']['output'];
  companyID: Scalars['Int']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  lastAttemptAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lastOutcome?: Maybe<Scalars['String']['output']>;
  lastOutcomeValue?: Maybe<OutboundCampaignOutcomeResolver>;
  maxAttempts: Scalars['Int']['output'];
  nextAttemptAt?: Maybe<Scalars['AWSDateTime']['output']>;
  phoneNumber: Scalars['String']['output'];
  position: Scalars['String']['output'];
  scheduledAt?: Maybe<Scalars['AWSDateTime']['output']>;
  state: OutboundCampaignQueueItemDisplayState;
  updatedAt: Scalars['AWSDateTime']['output'];
  version: Scalars['AWSDateTime']['output'];
};

export enum OutboundCampaignQueueItemChangeReason {
  ADDED = 'ADDED',
  DISPATCHED = 'DISPATCHED',
  REMOVED = 'REMOVED',
  REORDERED = 'REORDERED',
  REQUEUED = 'REQUEUED'
}

export type OutboundCampaignQueueItemConnection = {
  __typename?: 'OutboundCampaignQueueItemConnection';
  edges: Array<OutboundCampaignQueueItemEdge>;
  pageInfo: OutboundCampaignsPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OutboundCampaignQueueItemDeletePayload = {
  __typename?: 'OutboundCampaignQueueItemDeletePayload';
  success: Scalars['Boolean']['output'];
};

export enum OutboundCampaignQueueItemDisplayState {
  CLOSED = 'CLOSED',
  IN_FLIGHT = 'IN_FLIGHT',
  WAITING_FIRST = 'WAITING_FIRST',
  WAITING_RETRY_ELIGIBLE = 'WAITING_RETRY_ELIGIBLE',
  WAITING_RETRY_PENDING = 'WAITING_RETRY_PENDING'
}

export type OutboundCampaignQueueItemEdge = {
  __typename?: 'OutboundCampaignQueueItemEdge';
  cursor: Scalars['String']['output'];
  node: OutboundCampaignQueueItem;
};

export enum OutboundCampaignQueueItemMoveDirection {
  BOTTOM = 'BOTTOM',
  DOWN = 'DOWN',
  TOP = 'TOP',
  UP = 'UP'
}

export type OutboundCampaignQueueItemNotification = {
  __typename?: 'OutboundCampaignQueueItemNotification';
  attemptCount?: Maybe<Scalars['Int']['output']>;
  campaignID: Scalars['ID']['output'];
  companyID: Scalars['ID']['output'];
  lastAttemptAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lastOutcome?: Maybe<Scalars['String']['output']>;
  lastOutcomeValue?: Maybe<OutboundCampaignOutcomeResolver>;
  maxAttempts?: Maybe<Scalars['Int']['output']>;
  nextAttemptAt?: Maybe<Scalars['AWSDateTime']['output']>;
  occurredAt: Scalars['AWSDateTime']['output'];
  position?: Maybe<Scalars['String']['output']>;
  queueItemID?: Maybe<Scalars['ID']['output']>;
  reason: OutboundCampaignQueueItemChangeReason;
  recipients: Array<Scalars['ID']['output']>;
  state?: Maybe<OutboundCampaignQueueItemDisplayState>;
};

export type OutboundCampaignReservedOutcomeNameException = Exception & {
  __typename?: 'OutboundCampaignReservedOutcomeNameException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type OutboundCampaignStats = {
  __typename?: 'OutboundCampaignStats';
  activeAt?: Maybe<Scalars['AWSDateTime']['output']>;
  activeCallsCount: Scalars['Int']['output'];
  activeTimeSeconds: Scalars['Int']['output'];
  averageCallDuration?: Maybe<Scalars['Int']['output']>;
  completedPercentage: Scalars['Float']['output'];
  connectedContacts: Scalars['Int']['output'];
  totalContacts: Scalars['Int']['output'];
};

export enum OutboundCampaignStatus {
  ARCHIVED = 'ARCHIVED',
  COMPLETED = 'COMPLETED',
  DRAFT = 'DRAFT',
  IN_PROGRESS = 'IN_PROGRESS',
  PAUSED = 'PAUSED'
}

export type OutboundCampaignStatusFilterInput = {
  in: Array<OutboundCampaignStatus>;
};

export type OutboundCampaignTeamConnection = {
  __typename?: 'OutboundCampaignTeamConnection';
  edges: Array<OutboundCampaignTeamEdge>;
  pageInfo: OutboundCampaignsPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OutboundCampaignTeamDeletePayload = {
  __typename?: 'OutboundCampaignTeamDeletePayload';
  success: Scalars['Boolean']['output'];
};

export type OutboundCampaignTeamEdge = {
  __typename?: 'OutboundCampaignTeamEdge';
  cursor: Scalars['String']['output'];
  node: TeamResolver;
};

export type OutboundCampaignUser = {
  __typename?: 'OutboundCampaignUser';
  ID: Scalars['ID']['output'];
  campaignID: Scalars['ID']['output'];
  status: OutboundCampaignUserStatus;
  teammate: PhoneTeammateResolver;
};

export type OutboundCampaignUserConnection = {
  __typename?: 'OutboundCampaignUserConnection';
  edges: Array<OutboundCampaignUserEdge>;
  pageInfo: OutboundCampaignsPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OutboundCampaignUserDeletePayload = {
  __typename?: 'OutboundCampaignUserDeletePayload';
  success: Scalars['Boolean']['output'];
};

export type OutboundCampaignUserDispatchFailedNotification = {
  __typename?: 'OutboundCampaignUserDispatchFailedNotification';
  campaignID: Scalars['ID']['output'];
  companyID: Scalars['ID']['output'];
  occurredAt: Scalars['AWSDateTime']['output'];
  reason: OutboundCampaignDispatchFailureReason;
  recipients: Array<Scalars['ID']['output']>;
  userID: Scalars['ID']['output'];
};

export type OutboundCampaignUserEdge = {
  __typename?: 'OutboundCampaignUserEdge';
  cursor: Scalars['String']['output'];
  node: OutboundCampaignUser;
};

export type OutboundCampaignUserReadyNotification = {
  __typename?: 'OutboundCampaignUserReadyNotification';
  campaignID: Scalars['ID']['output'];
  companyID: Scalars['ID']['output'];
  occurredAt: Scalars['AWSDateTime']['output'];
  reason: OutboundCampaignUserReadyReason;
  recipients: Array<Scalars['ID']['output']>;
  userID: Scalars['ID']['output'];
};

export enum OutboundCampaignUserReadyReason {
  RESUME_AVAILABLE = 'RESUME_AVAILABLE'
}

export enum OutboundCampaignUserStatus {
  ACTIVE = 'ACTIVE',
  ENDED = 'ENDED',
  NOT_STARTED = 'NOT_STARTED',
  PAUSED = 'PAUSED',
  STARTING = 'STARTING',
  UNASSIGNED = 'UNASSIGNED'
}

export type OutboundCampaignUserStatusNotification = {
  __typename?: 'OutboundCampaignUserStatusNotification';
  campaignID: Scalars['ID']['output'];
  companyID: Scalars['ID']['output'];
  newStatus: OutboundCampaignUserStatus;
  occurredAt: Scalars['AWSDateTime']['output'];
  recipients: Array<Scalars['ID']['output']>;
  userID: Scalars['ID']['output'];
};

export type OutboundCampaignsFieldMapping = {
  __typename?: 'OutboundCampaignsFieldMapping';
  companyName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  note: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type OutboundCampaignsFilterInput = {
  createdBy?: InputMaybe<OutboundCampaignCreatedByFilterInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OutboundCampaignStatusFilterInput>;
};

export type OutboundCampaignsPageInfo = {
  __typename?: 'OutboundCampaignsPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export enum OutboundCampaignsScope {
  ACCESSIBLE = 'ACCESSIBLE',
  ASSIGNED = 'ASSIGNED'
}

export type OutboundComplianceInput = {
  outboundComplianceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  outboundComplianceMessage?: InputMaybe<Scalars['String']['input']>;
};

export type OutboundComplianceMessageInput = {
  kind: Scalars['String']['input'];
  language?: InputMaybe<SayOutboundComplianceMessageLanguage>;
  message?: InputMaybe<Scalars['String']['input']>;
  messageType: Scalars['String']['input'];
  previewURL?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  voice?: InputMaybe<SayOutboundComplianceMessageVoice>;
};

export type OutboundComplianceMessageOutput = {
  __typename?: 'OutboundComplianceMessageOutput';
  kind: Scalars['String']['output'];
  language?: Maybe<SayOutboundComplianceMessageLanguageOutput>;
  message?: Maybe<Scalars['String']['output']>;
  messageType: Scalars['String']['output'];
  previewURL?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  voice?: Maybe<SayOutboundComplianceMessageVoiceOutput>;
};

export type OutboundConfig = {
  __typename?: 'OutboundConfig';
  fromNumber?: Maybe<Scalars['String']['output']>;
  lineId?: Maybe<Scalars['Int']['output']>;
  outboundMessage?: Maybe<Scalars['String']['output']>;
  voicemailAction?: Maybe<VoicemailAction>;
  voicemailMessage?: Maybe<Scalars['String']['output']>;
};

export type OutboundConfigInput = {
  fromNumber?: InputMaybe<Scalars['String']['input']>;
  lineId?: InputMaybe<Scalars['Int']['input']>;
  outboundMessage?: InputMaybe<Scalars['String']['input']>;
  voicemailAction?: InputMaybe<VoicemailAction>;
  voicemailMessage?: InputMaybe<Scalars['String']['input']>;
};

export type OutboundEligibilityResult = {
  __typename?: 'OutboundEligibilityResult';
  allowedPrefixes?: Maybe<Array<Scalars['String']['output']>>;
  authority?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  e164: Scalars['String']['output'];
  eligible: Scalars['Boolean']['output'];
  link?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  phoneType: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  regulation?: Maybe<Scalars['String']['output']>;
};

export type OutboundEligibilityResultList = {
  __typename?: 'OutboundEligibilityResultList';
  results: Array<OutboundEligibilityResult>;
};

export type OutboundEscalationTarget = {
  __typename?: 'OutboundEscalationTarget';
  externalPhoneNumber?: Maybe<Scalars['String']['output']>;
  teamId?: Maybe<Scalars['Int']['output']>;
  type: OutboundEscalationTargetType;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type OutboundEscalationTargetInput = {
  externalPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['Int']['input']>;
  type: OutboundEscalationTargetType;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export enum OutboundEscalationTargetType {
  EXTERNAL = 'EXTERNAL',
  TEAM = 'TEAM',
  USER = 'USER'
}

export type OutboundEvent = {
  __typename?: 'OutboundEvent';
  agentId: Scalars['ID']['output'];
  callOutcome?: Maybe<OutboundCallOutcome>;
  callSid?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['String']['output']>;
  contactPhone: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  escalated?: Maybe<Scalars['Boolean']['output']>;
  escalationInitiatedAt?: Maybe<Scalars['String']['output']>;
  escalationTarget?: Maybe<OutboundEscalationTarget>;
  handoffContext?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  idempotencyKey: Scalars['String']['output'];
  status: OutboundEventStatus;
};

export type OutboundEventConnection = {
  __typename?: 'OutboundEventConnection';
  cursor?: Maybe<Scalars['String']['output']>;
  items: Array<OutboundEvent>;
};

export type OutboundEventOutput = GenericException | OutboundEvent | ResourceNotFoundException;

export enum OutboundEventStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  INITIATED = 'INITIATED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export type OutboundEventsOutput = GenericException | OutboundEventConnection | ResourceNotFoundException;

export type OutboundInsightsDelta = {
  __typename?: 'OutboundInsightsDelta';
  connectRate: Scalars['Float']['output'];
  humanAnsweredRate: Scalars['Float']['output'];
  noAnswerRate: Scalars['Float']['output'];
  otherRate: Scalars['Float']['output'];
  voicemailRate: Scalars['Float']['output'];
};

export type OutputField = {
  __typename?: 'OutputField';
  format?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type: DataOutputType;
  valueMapping?: Maybe<Scalars['String']['output']>;
};

export type OutputFieldInput = {
  format?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: DataOutputType;
  valueMapping?: InputMaybe<Scalars['String']['input']>;
};

export type OverallSentiment = {
  __typename?: 'OverallSentiment';
  createdAt: Scalars['String']['output'];
  type: SentimentType;
  value: SentimentValue;
};

export type PostRequestTargetRequestConfiguration = {
  auth: RequestTargetAuth;
  body: Scalars['String']['input'];
  headers: Array<RequestTargetHeader>;
  url: Scalars['String']['input'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  currentToken?: Maybe<Scalars['ID']['output']>;
  nextToken?: Maybe<Scalars['ID']['output']>;
};

export type PageRequest = {
  limit: Scalars['Int']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type PaginatedAutomations = {
  __typename?: 'PaginatedAutomations';
  items: Array<Automation>;
  pageInfo: PagingInfo;
};

export type PaginatedCallConversations = {
  __typename?: 'PaginatedCallConversations';
  aggregations?: Maybe<CallConversationAggregations>;
  items: Array<CallConversation>;
  pageInfo: PagingInfo;
};

export type PaginatedCallEngagements = {
  __typename?: 'PaginatedCallEngagements';
  items: Array<CallEngagement>;
  pageInfo: PageInfo;
};

export type PaginatedConversations = {
  __typename?: 'PaginatedConversations';
  items: Array<AircallWorkspaceConversation>;
  pageInfo: PageInfo;
};

export type PaginatedEngagements = {
  __typename?: 'PaginatedEngagements';
  items: Array<Engagement>;
  pageInfo: PageInfo;
};

export type PaginatedEngagementsOutput = PaginatedEngagements | UserInputException;

export type PaginatedEvaluations = {
  __typename?: 'PaginatedEvaluations';
  items: Array<Evaluation>;
  pageInfo: PagingInfo;
};

export type PaginatedLines = {
  __typename?: 'PaginatedLines';
  items: Array<Line>;
  pageInfo: PagingInfo;
};

export type PaginatedScoreCards = {
  __typename?: 'PaginatedScoreCards';
  items: Array<ScoreCard>;
  pageInfo: PagingInfo;
};

export type PaginatedSearchCallEngagementsOutput = GenericException | PaginatedCallEngagements | UserInputException;

export type PaginatedTrackers = {
  __typename?: 'PaginatedTrackers';
  items: Array<Tracker>;
};

export type PaginatedTranscriptions = {
  __typename?: 'PaginatedTranscriptions';
  items: Array<Transcription>;
  pageInfo: PagingInfo;
};

export type PaginatedUsersEvaluated = {
  __typename?: 'PaginatedUsersEvaluated';
  items: Array<UserEvaluated>;
  pageInfo: PagingInfo;
};

export type PaginationMeta = {
  __typename?: 'PaginationMeta';
  currentPage: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  perPage: Scalars['Int']['output'];
  previousPage?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type PagingInfo = {
  __typename?: 'PagingInfo';
  currentToken: Scalars['ID']['output'];
  limit: Scalars['Int']['output'];
  nextToken?: Maybe<Scalars['ID']['output']>;
  previousToken?: Maybe<Scalars['ID']['output']>;
  total: Scalars['Int']['output'];
};

export type ParamValueSource = {
  __typename?: 'ParamValueSource';
  paramName: Scalars['String']['output'];
  valueSource: Scalars['String']['output'];
};

export type ParamValueSourceInput = {
  paramName: Scalars['String']['input'];
  valueSource: Scalars['String']['input'];
};

export enum ParameterFormat {
  NAMED = 'NAMED',
  POSITIONAL = 'POSITIONAL'
}

export type ParameterValidationConfig = {
  __typename?: 'ParameterValidationConfig';
  validationType?: Maybe<Scalars['String']['output']>;
};

export type ParameterValidationConfigInput = {
  validationType?: InputMaybe<Scalars['String']['input']>;
};

export type PauseOutboundCampaignOutput = GenericException | OutboundCampaign | ResourceNotFoundException;

export type PauseOutboundCampaignSessionOutput = GenericException | OutboundCampaignUser | ResourceNotFoundException;

export type PaymentAttempts = {
  __typename?: 'PaymentAttempts';
  amount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export enum PermissionAccess {
  create = 'create',
  delete = 'delete',
  read = 'read',
  update = 'update'
}

export type PersonalLineRevertException = Exception & {
  __typename?: 'PersonalLineRevertException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type PhoneAircallExtract = {
  __typename?: 'PhoneAircallExtract';
  ID: Scalars['ID']['output'];
  UUID: Scalars['ID']['output'];
  avatar?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  emails: Array<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  mainPhoneNumber: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  secondaryPhoneNumbers: Array<Scalars['String']['output']>;
};

export type PhoneCall = {
  ID: Scalars['ID']['output'];
  archivedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  assigned?: Maybe<PhoneCallAssigned>;
  callUuid: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  direction: PhoneCallDirection;
  duration: Scalars['Int']['output'];
  internalTags: Array<PhoneCallTag>;
  line: LineResolver;
  notes: Array<PhoneCallNote>;
  outboundCampaignAttempt?: Maybe<OutboundCampaignAttemptResolver>;
  proxiedAudioUrl?: Maybe<Scalars['String']['output']>;
  recordingDurationMs?: Maybe<Scalars['Int']['output']>;
  status: PhoneCallStatus;
  tags: Array<PhoneCallTag>;
  timeline?: Maybe<PhoneCallTimelineResolver>;
  transcription?: Maybe<TranscriptionResolver>;
  type: PhoneCallType;
  voiceAgents?: Maybe<Array<VoiceAgentParticipant>>;
};

export type PhoneCallAssigned = {
  __typename?: 'PhoneCallAssigned';
  at: Scalars['AWSDateTime']['output'];
  by: PhoneTeammateResolver;
  to: PhoneTeammateResolver;
};

export enum PhoneCallAutomaticCallbackMissedReason {
  AGENT_DID_NOT_ANSWER = 'AGENT_DID_NOT_ANSWER',
  NO_AVAILABLE_AGENT = 'NO_AVAILABLE_AGENT',
  UNABLE_TO_CONTINUE = 'UNABLE_TO_CONTINUE'
}

export type PhoneCallAutomaticCallbackRequest = {
  __typename?: 'PhoneCallAutomaticCallbackRequest';
  missedReason?: Maybe<PhoneCallAutomaticCallbackMissedReason>;
  state: PhoneCallAutomaticCallbackState;
};

export enum PhoneCallAutomaticCallbackState {
  DONE = 'DONE',
  IN_PROGRESS = 'IN_PROGRESS'
}

export type PhoneCallCallee = PhoneContactResolver | PhoneTeammateResolver;

export type PhoneCallCaller = PhoneContactResolver | PhoneTeammateResolver;

export enum PhoneCallDirection {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND'
}

export enum PhoneCallMissedReason {
  ABANDONED_IN_CLASSIC = 'ABANDONED_IN_CLASSIC',
  ABANDONED_IN_IVR = 'ABANDONED_IN_IVR',
  AGENTS_DID_NOT_ANSWER = 'AGENTS_DID_NOT_ANSWER',
  NO_AVAILABLE_AGENT = 'NO_AVAILABLE_AGENT',
  OUT_OF_OPENING_HOURS = 'OUT_OF_OPENING_HOURS',
  SHORT_ABANDONED = 'SHORT_ABANDONED'
}

export type PhoneCallNote = {
  __typename?: 'PhoneCallNote';
  ID: Scalars['ID']['output'];
  author: PhoneCallNoteAuthor;
  content: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
};

export type PhoneCallNoteAuthor = PhoneTeammateResolver | SystemEntity;

export type PhoneCallOutput = ConferencePhoneCall | GenericException | MissedInboundPhoneCall | RegularPhoneCall | ResourceNotFoundException | TransferredPhoneCall;

export type PhoneCallResolver = {
  __typename?: 'PhoneCallResolver';
  entity: PhoneCall;
  input: PhoneCallResolverInput;
};

export type PhoneCallResolverInput = {
  __typename?: 'PhoneCallResolverInput';
  callID: Scalars['ID']['output'];
  companyID: Scalars['String']['output'];
};

export enum PhoneCallStatus {
  ENDED = 'ENDED',
  IN_PROGRESS = 'IN_PROGRESS'
}

export type PhoneCallTag = {
  __typename?: 'PhoneCallTag';
  ID: Scalars['ID']['output'];
  color: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type PhoneCallTagResolver = {
  __typename?: 'PhoneCallTagResolver';
  entity?: Maybe<PhoneCallTag>;
};

export type PhoneCallTagResolverInput = {
  __typename?: 'PhoneCallTagResolverInput';
  ID: Scalars['ID']['output'];
  companyID: Scalars['ID']['output'];
};

export type PhoneCallTimeline = {
  __typename?: 'PhoneCallTimeline';
  callSid: Scalars['ID']['output'];
  events: Array<CallTimelineEvent>;
  lastSelectedBranch?: Maybe<IncomingCallIvrBranchSelectedEvent>;
};

export type PhoneCallTimelineResolver = {
  __typename?: 'PhoneCallTimelineResolver';
  entity?: Maybe<PhoneCallTimeline>;
};

export type PhoneCallTimelineResolverInput = {
  __typename?: 'PhoneCallTimelineResolverInput';
  callSid: Scalars['ID']['output'];
  companyID: Scalars['ID']['output'];
};

export type PhoneCallTransferred = {
  __typename?: 'PhoneCallTransferred';
  by: PhoneTeammateResolver;
  to: Transferee;
};

export enum PhoneCallType {
  CONFERENCE = 'CONFERENCE',
  EXTERNAL_TRANSFER = 'EXTERNAL_TRANSFER',
  INBOUND_ANSWERED = 'INBOUND_ANSWERED',
  INBOUND_CALLBACK_REQUEST = 'INBOUND_CALLBACK_REQUEST',
  INBOUND_CALLED_BACK = 'INBOUND_CALLED_BACK',
  INBOUND_EXTERNAL_REDIRECTION_ANSWERED = 'INBOUND_EXTERNAL_REDIRECTION_ANSWERED',
  INBOUND_MISSED = 'INBOUND_MISSED',
  INBOUND_MISSED_VOICEMAIL = 'INBOUND_MISSED_VOICEMAIL',
  INTERNAL_TRANSFER = 'INTERNAL_TRANSFER',
  OUTBOUND_ANSWERED = 'OUTBOUND_ANSWERED',
  OUTBOUND_FOLLOW_UP = 'OUTBOUND_FOLLOW_UP',
  OUTBOUND_MISSED = 'OUTBOUND_MISSED',
  OUTBOUND_VOICEMAIL_DROPPED = 'OUTBOUND_VOICEMAIL_DROPPED'
}

export type PhoneContact = {
  __typename?: 'PhoneContact';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  emails: Array<Scalars['String']['output']>;
  extracts: Array<PhoneExtract>;
  fullName: Scalars['String']['output'];
  mainPhoneNumber: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  secondaryPhoneNumbers: Array<Scalars['String']['output']>;
};

export type PhoneContactResolver = {
  __typename?: 'PhoneContactResolver';
  entity: ExternalEntity;
  input: PhoneContactResolverInputByPhoneNumber;
};

export type PhoneContactResolverInputByPhoneNumber = {
  __typename?: 'PhoneContactResolverInputByPhoneNumber';
  companyID: Scalars['ID']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type PhoneExtract = {
  __typename?: 'PhoneExtract';
  ID: Scalars['ID']['output'];
  UUID: Scalars['ID']['output'];
  externalID: Scalars['String']['output'];
  externalLink: Scalars['String']['output'];
  extractId?: Maybe<Scalars['String']['output']>;
  sourceAppID: Scalars['String']['output'];
  sourceAppLogo?: Maybe<SourceAppLogoObject>;
  sourceAppName?: Maybe<Scalars['String']['output']>;
  sourceId: Scalars['String']['output'];
};

export type PhoneNumberConfig = {
  __typename?: 'PhoneNumberConfig';
  defaultRegion: Scalars['String']['output'];
  forceFormat?: Maybe<Scalars['String']['output']>;
};

export type PhoneNumberConfigInput = {
  defaultRegion?: InputMaybe<Scalars['String']['input']>;
  forceFormat?: InputMaybe<Scalars['String']['input']>;
};

export type PhoneNumberData = {
  __typename?: 'PhoneNumberData';
  additionalInfo?: Maybe<Array<Maybe<AdditionalInfo>>>;
  codeVerificationStatus?: Maybe<Scalars['String']['output']>;
  healthStatus?: Maybe<HealthStatus>;
  id: Scalars['ID']['output'];
  messagingLimitTier?: Maybe<Scalars['String']['output']>;
  nameStatus?: Maybe<Scalars['String']['output']>;
  newNameStatus?: Maybe<Scalars['String']['output']>;
  offlineReasons?: Maybe<Array<Maybe<OfflineReason>>>;
  qualityRating?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  throughput?: Maybe<Throughput>;
};

export type PhoneNumberEntity = {
  __typename?: 'PhoneNumberEntity';
  additionalInfo?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  canSendMessage: SendMessageStatus;
  entityType: Scalars['String']['output'];
  errors?: Maybe<Array<Maybe<PhoneNumberError>>>;
  id: Scalars['ID']['output'];
};

export type PhoneNumberError = {
  __typename?: 'PhoneNumberError';
  errorCode: Scalars['Int']['output'];
  errorDescription: Scalars['String']['output'];
  possibleSolution: Scalars['String']['output'];
};

export type PhoneNumberTargetResponse = {
  __typename?: 'PhoneNumberTargetResponse';
  phoneNumber: Scalars['String']['output'];
};

export type PhoneTeammate = {
  __typename?: 'PhoneTeammate';
  ID: Scalars['ID']['output'];
  availabilityStatus: AvailabilityStatus;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  email: Scalars['String']['output'];
  extension?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
};

export type PhoneTeammateResolver = {
  __typename?: 'PhoneTeammateResolver';
  entity: PhoneTeammateResolverOutput;
  input: PhoneTeammateResolverInput;
};

export type PhoneTeammateResolverInput = {
  __typename?: 'PhoneTeammateResolverInput';
  ID: Scalars['ID']['output'];
  companyID: Scalars['ID']['output'];
};

export type PhoneTeammateResolverOutput = PhoneTeammate | ResourceNotFoundException;

export enum Placement {
  DASHBOARD_HOMEPAGE = 'DASHBOARD_HOMEPAGE'
}

export type Plan = {
  __typename?: 'Plan';
  features: PlanFeatures;
  name: Scalars['String']['output'];
};

export enum PlanCurrency {
  aud = 'aud',
  eur = 'eur',
  gbp = 'gbp',
  usd = 'usd'
}

export type PlanFeatures = {
  __typename?: 'PlanFeatures';
  featureLevel: Scalars['String']['output'];
  featuresIncluded?: Maybe<Array<Scalars['String']['output']>>;
  nbLinesIncluded: Scalars['Int']['output'];
  nbLinesMax: Scalars['Int']['output'];
  nbTeamsMax: Scalars['Int']['output'];
  nbUsersIncluded: Scalars['Int']['output'];
  nbUsersMax: Scalars['Int']['output'];
  pricePerNumber: Currencies;
  pricePerUser: PlanPricePerUser;
};

export type PlanPricePerUser = {
  __typename?: 'PlanPricePerUser';
  annually: Currencies;
  monthly: Currencies;
};

export enum PlanRecurrence {
  annually = 'annually',
  fixed_annually = 'fixed_annually',
  monthly = 'monthly',
  quarterly = 'quarterly'
}

export type PlanSubscribeInput = {
  currency: PlanCurrency;
  numberOfLinceses?: InputMaybe<Scalars['Int']['input']>;
  numberOfLines?: InputMaybe<Scalars['Int']['input']>;
  plan: Scalars['String']['input'];
  recurrence: PlanRecurrence;
  stripeRadarSessionId?: InputMaybe<Scalars['String']['input']>;
};

export type PlanSubscribeOutput = {
  __typename?: 'PlanSubscribeOutput';
  error?: Maybe<Error>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PlanUpgradeInput = {
  plan: Scalars['String']['input'];
};

export type PlanUpgradeOutput = {
  __typename?: 'PlanUpgradeOutput';
  error?: Maybe<Error>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum Platform {
  DASHBOARD = 'DASHBOARD',
  PHONE = 'PHONE',
  WORKSPACE = 'WORKSPACE'
}

export type PlaybookAdherence = {
  __typename?: 'PlaybookAdherence';
  agentsCount: Scalars['Int']['output'];
  agentsCountTrend?: Maybe<TrendDirection>;
  averageScore?: Maybe<Scalars['Float']['output']>;
  byAgent: PlaybookAdherenceAgentsResult;
  byCall: PlaybookAdherenceCallsResult;
  byTopic: Array<PlaybookTopicAdherence>;
  callsCount: Scalars['Int']['output'];
  callsCountTrend?: Maybe<TrendDirection>;
  overTime: Array<PlaybookAdherenceTimePoint>;
};


export type PlaybookAdherenceByAgentArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PlaybookAdherenceAgentSort>;
  sortDirection?: InputMaybe<SortDirection>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type PlaybookAdherenceByCallArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PlaybookAdherenceCallSort>;
  sortDirection?: InputMaybe<SortDirection>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type PlaybookAdherenceOverTimeArgs = {
  granularity?: InputMaybe<AdherenceTimeGranularity>;
};

export type PlaybookAdherenceAgentRow = {
  __typename?: 'PlaybookAdherenceAgentRow';
  agent?: Maybe<PhoneTeammateResolver>;
  agentId: Scalars['ID']['output'];
  averageScore?: Maybe<Scalars['Float']['output']>;
  byTopic: Array<PlaybookTopicAdherence>;
  callsCount: Scalars['Int']['output'];
};

export enum PlaybookAdherenceAgentSort {
  ADHERENCE = 'ADHERENCE',
  AGENT = 'AGENT',
  CALLS_COUNT = 'CALLS_COUNT'
}

export type PlaybookAdherenceAgentsResult = {
  __typename?: 'PlaybookAdherenceAgentsResult';
  items: Array<PlaybookAdherenceAgentRow>;
  pageInfo: PagingInfo;
};

export type PlaybookAdherenceCallRow = {
  __typename?: 'PlaybookAdherenceCallRow';
  adherenceScore?: Maybe<Scalars['Float']['output']>;
  agent?: Maybe<PhoneTeammateResolver>;
  agentId: Scalars['ID']['output'];
  callId: Scalars['ID']['output'];
  callUuid: Scalars['ID']['output'];
  contactId?: Maybe<Scalars['ID']['output']>;
  direction?: Maybe<Direction>;
  duration?: Maybe<Scalars['Int']['output']>;
  line?: Maybe<LineResolver>;
  lineId: Scalars['ID']['output'];
  phoneCall?: Maybe<PhoneCallResolver>;
  startedAt: Scalars['AWSDateTime']['output'];
};

export enum PlaybookAdherenceCallSort {
  ADHERENCE = 'ADHERENCE',
  AGENT = 'AGENT',
  STARTED_AT = 'STARTED_AT'
}

export type PlaybookAdherenceCallsResult = {
  __typename?: 'PlaybookAdherenceCallsResult';
  items: Array<PlaybookAdherenceCallRow>;
  pageInfo: PagingInfo;
};

export type PlaybookAdherenceFiltersInput = {
  agentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateFrom?: InputMaybe<Scalars['AWSDateTime']['input']>;
  dateTo?: InputMaybe<Scalars['AWSDateTime']['input']>;
  directions?: InputMaybe<Array<Direction>>;
  lineIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  maxAdherenceScore?: InputMaybe<Scalars['Float']['input']>;
  minAdherenceScore?: InputMaybe<Scalars['Float']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PlaybookAdherenceResolverInput = {
  __typename?: 'PlaybookAdherenceResolverInput';
  accessDenied?: Maybe<Scalars['Boolean']['output']>;
  agentIds?: Maybe<Array<Scalars['ID']['output']>>;
  dateFrom?: Maybe<Scalars['AWSDateTime']['output']>;
  dateTo?: Maybe<Scalars['AWSDateTime']['output']>;
  directions?: Maybe<Array<Direction>>;
  lineIds?: Maybe<Array<Scalars['ID']['output']>>;
  maxAdherenceScore?: Maybe<Scalars['Float']['output']>;
  minAdherenceScore?: Maybe<Scalars['Float']['output']>;
  playbookId: Scalars['ID']['output'];
  tagIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export type PlaybookAdherenceTimePoint = {
  __typename?: 'PlaybookAdherenceTimePoint';
  averageScore?: Maybe<Scalars['Float']['output']>;
  callsCount: Scalars['Int']['output'];
  from: Scalars['AWSDateTime']['output'];
  to: Scalars['AWSDateTime']['output'];
};

export enum PlaybookConfigurationType {
  AGENT = 'AGENT',
  LINE = 'LINE'
}

export type PlaybookException = Exception & {
  __typename?: 'PlaybookException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum PlaybookLanguage {
  BG = 'BG',
  CA = 'CA',
  CS = 'CS',
  DA = 'DA',
  DE = 'DE',
  EL = 'EL',
  EN = 'EN',
  ES = 'ES',
  FI = 'FI',
  FR = 'FR',
  HE = 'HE',
  HI = 'HI',
  HR = 'HR',
  HU = 'HU',
  IT = 'IT',
  JA = 'JA',
  KO = 'KO',
  MS = 'MS',
  NL = 'NL',
  NO = 'NO',
  PL = 'PL',
  PT = 'PT',
  RO = 'RO',
  RU = 'RU',
  SK = 'SK',
  SV = 'SV',
  TA = 'TA',
  TH = 'TH',
  TL = 'TL',
  TR = 'TR',
  UK = 'UK',
  VI = 'VI',
  ZH = 'ZH'
}

export type PlaybookResult = {
  __typename?: 'PlaybookResult';
  adherenceScore?: Maybe<Scalars['Float']['output']>;
  callId: Scalars['ID']['output'];
  callUuid: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  language: PlaybookLanguage;
  name: Scalars['String']['output'];
  topicResults: Array<TopicResult>;
};

export type PlaybookResultEntities = {
  __typename?: 'PlaybookResultEntities';
  items: Array<PlaybookResultResolver>;
};

export type PlaybookResultResolver = {
  __typename?: 'PlaybookResultResolver';
  entity?: Maybe<PlaybookResult>;
};

export type PlaybookResultResolverInput = {
  __typename?: 'PlaybookResultResolverInput';
  callId: Scalars['ID']['output'];
};

export type PlaybookResultsInput = {
  callIds: Array<Scalars['ID']['input']>;
};

export type PlaybookResultsOutput = GenericException | PlaybookResultEntities | UserInputException;

export type PlaybookSettings = {
  __typename?: 'PlaybookSettings';
  allowPlaybookSwitching: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  line?: Maybe<LineResolver>;
  lineId: Scalars['ID']['output'];
  playbook: CustomPlaybook;
};

export type PlaybookTopicAdherence = {
  __typename?: 'PlaybookTopicAdherence';
  averageScore?: Maybe<Scalars['Float']['output']>;
  callsCount: Scalars['Int']['output'];
  topicId: Scalars['ID']['output'];
  topicName: Scalars['String']['output'];
};

export type PortabilityBatch = {
  __typename?: 'PortabilityBatch';
  numberDetails?: Maybe<Array<PortabilityNumberDetail>>;
  numbers: Array<Scalars['String']['output']>;
  phoneType: Scalars['String']['output'];
  winningCarrier: PortabilityCarrier;
};

export type PortabilityCarrier = {
  __typename?: 'PortabilityCarrier';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type PortabilityException = {
  __typename?: 'PortabilityException';
  code?: Maybe<Scalars['String']['output']>;
  e164: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type PortabilityNumberDetail = {
  __typename?: 'PortabilityNumberDetail';
  e164: Scalars['String']['output'];
  rio?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PortingEnumItem = {
  __typename?: 'PortingEnumItem';
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  labelLocaliseKey: Scalars['String']['output'];
};

export type PortingField = {
  __typename?: 'PortingField';
  active: Scalars['Boolean']['output'];
  descriptionLocaliseKey?: Maybe<Scalars['String']['output']>;
  enumItems: Array<PortingEnumItem>;
  fieldRefId: Scalars['Int']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  labelLocaliseKey: Scalars['String']['output'];
  mandatory: Scalars['Boolean']['output'];
  placeholderLocaliseKey?: Maybe<Scalars['String']['output']>;
  readOnly: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type PortingFieldSimplified = {
  __typename?: 'PortingFieldSimplified';
  descriptionLocaliseKey?: Maybe<Scalars['String']['output']>;
  fieldRefId: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  labelLocaliseKey: Scalars['String']['output'];
  mandatory: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type PortingFieldValueGroup = {
  __typename?: 'PortingFieldValueGroup';
  fields: Array<PortingFieldSimplified>;
  subsection: Scalars['String']['output'];
};

export type PortingFieldsResponse = {
  __typename?: 'PortingFieldsResponse';
  fields: Array<PortingField>;
  subsection: Scalars['String']['output'];
  subsectionLocaliseKey: Scalars['String']['output'];
};

export type PortingNumber = {
  __typename?: 'PortingNumber';
  e164: Scalars['String']['output'];
  metadata?: Maybe<PortingNumberMetadata>;
  pin?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type PortingNumberInput = {
  e164: Scalars['String']['input'];
  metadata?: InputMaybe<PortingNumberMetadataInput>;
  pin?: InputMaybe<Scalars['String']['input']>;
};

export type PortingNumberMetadata = {
  __typename?: 'PortingNumberMetadata';
  rio?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PortingNumberMetadataInput = {
  rio?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PortingRequestCarrier = {
  __typename?: 'PortingRequestCarrier';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type PortingRequestCountry = {
  __typename?: 'PortingRequestCountry';
  alpha2: Scalars['String']['output'];
  alpha3: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type PortingRequestEvent = {
  __typename?: 'PortingRequestEvent';
  createdAt: Scalars['String']['output'];
  eventData: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type PortingRequestExternalIdentifier = {
  __typename?: 'PortingRequestExternalIdentifier';
  externalId?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type PortingRequestListItem = {
  __typename?: 'PortingRequestListItem';
  canSubmit: Scalars['Boolean']['output'];
  companyId: Scalars['Int']['output'];
  countryId: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  focDate?: Maybe<Scalars['String']['output']>;
  isE2E: Scalars['Boolean']['output'];
  isRange: Scalars['Boolean']['output'];
  losingCarrier: Scalars['String']['output'];
  missingRequirements?: Maybe<Array<Scalars['String']['output']>>;
  numbersCount: Scalars['Int']['output'];
  phoneType?: Maybe<Scalars['String']['output']>;
  portingRequestUUID: Scalars['String']['output'];
  preferredPortingDate?: Maybe<Scalars['String']['output']>;
  rejectionCategory?: Maybe<Scalars['String']['output']>;
  rejectionDetails?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  winningCarrierId?: Maybe<Scalars['Int']['output']>;
  winningCarrierName?: Maybe<Scalars['String']['output']>;
  zendeskTicketUrl?: Maybe<Scalars['String']['output']>;
};

export type PortingRequestLoa = {
  __typename?: 'PortingRequestLoa';
  embeddedSigningUrl?: Maybe<Scalars['String']['output']>;
  envelopeId?: Maybe<Scalars['String']['output']>;
  loaSigned: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  signedAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
};

export type PortingRequestNumberDetail = {
  __typename?: 'PortingRequestNumberDetail';
  e164: Scalars['String']['output'];
  metadata?: Maybe<PortingNumberMetadata>;
  securityPin?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type PortingSupportedCountriesResponse = {
  __typename?: 'PortingSupportedCountriesResponse';
  results: Array<PortingSupportedCountry>;
};

export type PortingSupportedCountry = {
  __typename?: 'PortingSupportedCountry';
  country: PortingSupportedCountryInfo;
  phoneTypes: Array<Scalars['String']['output']>;
};

export type PortingSupportedCountryInfo = {
  __typename?: 'PortingSupportedCountryInfo';
  alpha2: Scalars['String']['output'];
  alpha3: Scalars['String']['output'];
  code: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export enum PositiveFeedbackReason {
  ALREADY_ACTING_ON_THIS = 'ALREADY_ACTING_ON_THIS',
  CLEAR_AND_ACTIONABLE = 'CLEAR_AND_ACTIONABLE',
  HIGH_IMPACT_FOR_CUSTOMERS = 'HIGH_IMPACT_FOR_CUSTOMERS',
  IDENTIFIED_GAP_WE_MISSED = 'IDENTIFIED_GAP_WE_MISSED',
  VALIDATES_OUR_SUSPICION = 'VALIDATES_OUR_SUSPICION'
}

export type PredefinedAiBinaryAnswer = {
  __typename?: 'PredefinedAIBinaryAnswer';
  answerGuide: Scalars['String']['output'];
  binaryAnswerValue: BinaryAnswerValue;
};

export type PredefinedAiCategories = {
  __typename?: 'PredefinedAICategories';
  items: Array<PredefinedAiCategory>;
};

export type PredefinedAiCategory = {
  __typename?: 'PredefinedAICategory';
  name: Scalars['String']['output'];
  questions: Array<PredefinedAiQuestion>;
};

export type PredefinedAiQuestion = PredefinedBinaryAiQuestion | PredefinedRatingAiQuestion;

export type PredefinedAiRatingAnswer = {
  __typename?: 'PredefinedAIRatingAnswer';
  answerGuide: Scalars['String']['output'];
  ratingAnswerValue: RatingAnswerValue;
};

export type PredefinedBinaryAiQuestion = {
  __typename?: 'PredefinedBinaryAIQuestion';
  possibleAnswers: Array<PredefinedAiBinaryAnswer>;
  predefinedAIQuestionId: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type PredefinedRatingAiQuestion = {
  __typename?: 'PredefinedRatingAIQuestion';
  possibleAnswers: Array<PredefinedAiRatingAnswer>;
  predefinedAIQuestionId: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type PredefinedSummaryTemplate = {
  __typename?: 'PredefinedSummaryTemplate';
  category: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  language: CustomSummaryLanguage;
  name: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
  response?: Maybe<ResponseOptions>;
  type: SummaryTemplateType;
};

export type PredictedCsat = {
  __typename?: 'PredictedCsat';
  computedAt: Scalars['AWSDateTime']['output'];
  drivers: Array<PredictedCsatDriver>;
  score: Scalars['Int']['output'];
};

export type PredictedCsatAggregation = {
  __typename?: 'PredictedCsatAggregation';
  avg?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  sum?: Maybe<Scalars['Float']['output']>;
};

export type PredictedCsatDriver = {
  __typename?: 'PredictedCsatDriver';
  label: Scalars['String']['output'];
  polarity: PredictedCsatDriverPolarity;
  utteranceIndices: Array<Scalars['Int']['output']>;
};

export enum PredictedCsatDriverPolarity {
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE'
}

export type PredictedCsatScopeFilter = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type PrerecordedMessage = {
  __typename?: 'PrerecordedMessage';
  ID: Scalars['String']['output'];
  durationInSeconds: Scalars['Float']['output'];
  fileUrl: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type PrerecordedMessageByCallSidOutput = GenericException | PrerecordedMessage | ResourceNotFoundException | UserInputException;

export type PrerecordedMessageFieldOutput = {
  __typename?: 'PrerecordedMessageFieldOutput';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PrerecordedMessageUrl = {
  __typename?: 'PrerecordedMessageUrl';
  expiry: Scalars['Int']['output'];
  fields: Array<PrerecordedMessageFieldOutput>;
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PresenceChannel = {
  __typename?: 'PresenceChannel';
  authPayload?: Maybe<PresenceChannelAuthPayload>;
  authorized: Scalars['Boolean']['output'];
};

export type PresenceChannelAuthPayload = {
  __typename?: 'PresenceChannelAuthPayload';
  auth: Scalars['String']['output'];
  channel_data: Scalars['String']['output'];
};

export type PresetArg = {
  __typename?: 'PresetArg';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PresetArgInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type PresignedMediaUrls = {
  __typename?: 'PresignedMediaUrls';
  expiry: Scalars['Int']['output'];
  fields: Array<Maybe<PresignedUrlFields>>;
  fileName: Scalars['String']['output'];
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PresignedUrlFields = {
  __typename?: 'PresignedUrlFields';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PrivateChannel = {
  __typename?: 'PrivateChannel';
  authPayload?: Maybe<PrivateChannelAuthPayload>;
  authorized: Scalars['Boolean']['output'];
};

export type PrivateChannelAuthPayload = {
  __typename?: 'PrivateChannelAuthPayload';
  auth: Scalars['String']['output'];
};

export type PrivateEncryptedChannel = {
  __typename?: 'PrivateEncryptedChannel';
  authorized: Scalars['Boolean']['output'];
};

export enum Product {
  DASHBOARD = 'DASHBOARD',
  WORKSPACE = 'WORKSPACE'
}

export type ProfileImage = {
  __typename?: 'ProfileImage';
  url: Scalars['String']['output'];
};

export type ProfileImageEntity = {
  ID: Scalars['ID']['input'];
  domain: ProfileImageEntityDomain;
};

export enum ProfileImageEntityDomain {
  COMPANIES = 'COMPANIES',
  USERS = 'USERS'
}

export type ProfileResponse = {
  __typename?: 'ProfileResponse';
  coachingLanguage?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  language?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  supportedCoachingLanguages: Array<SupportedLanguage>;
  timeZone?: Maybe<Scalars['String']['output']>;
};

export enum PromotionProduct {
  MESSAGING_AGENT = 'MESSAGING_AGENT',
  VOICE_AGENT = 'VOICE_AGENT'
}

export enum PromotionStatus {
  ACTIVE = 'ACTIVE',
  EXHAUSTED = 'EXHAUSTED',
  EXPIRED = 'EXPIRED'
}

export type ProviderMetadata = {
  __typename?: 'ProviderMetadata';
  environment: Scalars['String']['output'];
  instanceUrl: Scalars['String']['output'];
};

export type ProvisionApplicationOutput = GenericException | ProvisioningResult | ResourceNotFoundException;

export type ProvisionLongTailApplicationInput = {
  companyId: Scalars['Int']['input'];
  hubApplicationId: Scalars['String']['input'];
  integrationId?: InputMaybe<Scalars['ID']['input']>;
  partnerDomain?: InputMaybe<Scalars['String']['input']>;
  requestKey: Scalars['String']['input'];
};

export type ProvisionLongTailApplicationOutput = GenericException | LongTailApplicationNotFoundException | LongTailProvision | UserInputException;

export type ProvisioningResult = {
  __typename?: 'ProvisioningResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  toolCount?: Maybe<Scalars['Int']['output']>;
};

export type PublicChannel = {
  __typename?: 'PublicChannel';
  authorized: Scalars['Boolean']['output'];
};

export type PublishCustomSummaryResult = {
  __typename?: 'PublishCustomSummaryResult';
  id: Scalars['ID']['output'];
};

export type PublishCustomSummaryResultInput = {
  id: Scalars['ID']['input'];
};

export type PublishCustomSummaryResultOutput = CustomSummaryException | GenericException | InsufficientLicenseException | PublishCustomSummaryResult | UserInputException;

export type PublishVirtualAgentDraftInput = {
  agentId: Scalars['ID']['input'];
};

export type PublishVirtualAgentDraftOutput = ConflictException | GenericException | ResourceNotFoundException | UserInputException | VirtualAgent;

export type PurchaseLicensesInput = {
  licenseName: Scalars['String']['input'];
  numberOfLicenses: Scalars['Int']['input'];
};

export type PurchaseLicensesOutput = {
  __typename?: 'PurchaseLicensesOutput';
  error?: Maybe<Error>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Query = {
  __typename?: 'Query';
  _service?: Maybe<Scalars['String']['output']>;
  activationCompanyContext: ActivationCompanyContextOutput;
  activationCurrentSettings: ActivationCurrentSettingsOutput;
  activationEligibleLines: ActivationEligibleLinesOutput;
  activationReadiness: ActivationReadinessOutput;
  activationUsersAndLicenses: ActivationUsersAndLicensesOutput;
  aircallExtractById: AircallExtractByIdOutput;
  aircallWorkspaceConversationByCallID: AircallWorkspaceConversationOutput;
  aircallWorkspaceConversationByLineIdAndPhoneNumber: AircallWorkspaceConversationByLineIdAndPhoneNumberOutput;
  aircallWorkspaceConversationsCountPerCategory: AircallWorkspaceConversationsCountPerCategoryOutput;
  altFindVirtualAgentById: VirtualAgentOutput;
  analyticsCallsHistory: AnalyticsCallsHistoryResult;
  analyticsContactFilter: AnalyticsFilterResult;
  analyticsCustomerNumberFilter: AnalyticsFilterResult;
  analyticsGetPreset: AnalyticsPresetResult;
  analyticsIvrBranchFilter: AnalyticsFilterResult;
  analyticsLineFilter: AnalyticsLineFilterResult;
  analyticsListPresets: AnalyticsPresetListResult;
  analyticsMessagesHistory: AnalyticsMessagesHistoryResult;
  analyticsMultipleValueMetric: AnalyticsMultipleValueMetricResult;
  analyticsMultipleValueMetricDrillDown: AnalyticsMetricDrillDownResult;
  analyticsOutboundCampaignFilter: AnalyticsOutboundCampaignFilterResult;
  analyticsSingleValueMetric: AnalyticsSingleValueMetricResult;
  analyticsSingleValueMetricDrillDown: AnalyticsMetricDrillDownResult;
  analyticsTagFilter: AnalyticsTagFilterResult;
  analyticsTeamFilter: AnalyticsTeamFilterResult;
  analyticsUserFilter: AnalyticsUserFilterResult;
  analyticsUserPendingExport: AnalyticsExportResult;
  analyticsUserStatusHistory: AnalyticsUserStatusHistoryResult;
  analyticsVirtualVoiceAgentFilter: AnalyticsVirtualVoiceAgentFilterResult;
  authorizeZendesk: AuthorizeZendeskQueryResponse;
  blacklistedNumbers: BlacklistedNumbers;
  bridgeApplications: Array<BridgeApplication>;
  bulkCheckOutboundEligibility: CheckOutboundEligibilityResponse;
  callEngagementsCountPerCategory: CallEngagementsCountPerCategoryOutput;
  checkAppVersion?: Maybe<CheckAppVersionOutput>;
  checkAvailableOutboundEligibility: CheckAvailableOutboundEligibilityResponse;
  checkCriticalAction: UserCriticalAction;
  checkGoogleSignInEligibility: GoogleSignInEligibility;
  checkNumberLimit?: Maybe<NumbersLimitReached>;
  checkNumberPurchaseEligibility: NumberPurchaseEligibility;
  checkOutboundEligibility: CheckOutboundEligibilityOutput;
  checkRequirements: Requirements;
  clientActionInsights: ClientActionInsightsOutput;
  clientActionInsightsSettings: ClientActionInsightsSettingsOutput;
  companyBillingSummary?: Maybe<CompanyBillingDetailsOutput>;
  companyFeature: FeatureOutput;
  companyFeatures?: Maybe<CompanyFeaturesOutput>;
  companyIntegrations: CompanyIntegrations;
  companyPromotions: Array<CompanyPromotion>;
  companySettings: CompanySettings;
  contactByPhoneNumber: ContactByPhoneNumberOutput;
  contactsByPhoneNumbers: ContactsByPhoneNumbersOutput;
  countriesAndCurrencies: Array<CountryCurrency>;
  cpPlans: Array<CpPlan>;
  currentCompanyBilling: RestCompanyBilling;
  downloadPortingLoa: DownloadPortingLoaResponse;
  engagementsByConversationId: EngagementConnectionOutput;
  escalationDependents: EscalationDependentsOutput;
  evaluateConfiguration: ConfigEvaluationOutput;
  extractCoreKBKnowledge: CoreKbKnowledgeExtractionResultUnion;
  extractKnowledge: KnowledgeResponseOutput;
  fetchAllBoardsPaginated: Array<BoardsWithPagination>;
  fetchBoardDetails: Array<BoardDetails>;
  fetchUsersOfGroup: Array<ZendeskUser>;
  findActiveDraft?: Maybe<FindActiveDraftOutput>;
  findActiveDraftsForAgents: FindActiveDraftsForAgentsOutput;
  findCalendarById?: Maybe<CalendarOutput>;
  findCalendarByIdV2: CalendarOutputV2;
  findVirtualAgentById: VirtualAgentOutput;
  generateProcessoutToken: GenerateProcessoutTokenOutput;
  generateSimulationScenarios: GenerateScenariosOutput;
  getA2PCampaignsByCompanyId: GetA2PCampaignsByCompanyIdResult;
  getA2PForm: GetA2PFormResult;
  getA2PFormAttachmentUploadUrl: GetA2PFormAttachmentUploadUrlResult;
  getA2PForms: GetA2PFormsResult;
  getA2PUrlEvidence: GetA2PUrlEvidenceResult;
  getAction: ActionOutput;
  getActivePlaybook?: Maybe<GetActivePlaybookOutput>;
  getActiveReverificationCampaigns: ActiveReverificationCampaignsResponse;
  getAdminMcpOauthGrantStatus: GetAdminMcpOauthGrantStatusOutput;
  getAgent: Agent;
  getAgentBuildProgress: AgentBuildProgressOutput;
  getAgentChatFeedback: GetAgentChatFeedbackOutput;
  getAgentEvidenceSummary: AgentEvidenceSummaryOutput;
  getAgentInsights: AgentInsightsOutput;
  getAgentInsightsJob: AgentInsightsJobResultOutput;
  getAgentKBMapping: AgentKbMappingResult;
  getAgentRecentTags: AgentRecentTagsOutput;
  getAgentV2: AgentV2;
  getAgentsForDocumentInKB: Array<AgentKbMappingResult>;
  getAiActionsEnabledCompanies: GetAiActionsEnabledCompaniesOutput;
  getAircallWorkspaceConversation: AircallWorkspaceConversationOutput;
  getAircallWorkspaceConversations: AircallWorkspaceConversationsOutput;
  getAivaAgentActions: GetAivaAgentActionsOutput;
  getAivaAgentMigrationDraft: GetAivaAgentMigrationDraftOutput;
  getAllAgentUsersOfKB: Array<AgentKbMappingResult>;
  getAllPlans: Array<Plan>;
  getAllRoles: Array<Role>;
  getAnalyticsDashboardUrl: AnalyticsDashboardUrl;
  getApiKeys?: Maybe<Array<ApiKey>>;
  getApplicationInstallUri: GetApplicationInstallUriOutput;
  getApplications: Array<Application>;
  getAudio?: Maybe<CallAudioResult>;
  getAuthorizedApplication: AuthorizedApplication;
  getAutocompleteTopics?: Maybe<GetAutocompleteResult>;
  getAutomations: GetAutomationsResult;
  getAvailableExtensions: AvailableExtensions;
  getAvailableLicenses: AvailableLicensesResponse;
  getAvailableRolesForAgent: Array<Role>;
  getBestMatch: GetBestMatchResponse;
  getBetas: GetBetasOutput;
  getBrand: GetBrandResult;
  getBrandDocumentDownloadUrl: GetBrandDocumentDownloadUrlResult;
  getBrandDraft: BrandDraftResult;
  getBrandDraftLogo: GetBrandDraftLogoResult;
  getBulkCallTimelinesByCallSids: GetBulkCallTimelinesOutput;
  getBulkCallTimelinesByCallSidsV2: GetBulkCallTimelinesOutputV2;
  getBusinessRegistrationMetrics: BusinessRegistrationMetricsResult;
  getCall?: Maybe<Call>;
  getCallConfiguration: GetCallConfigurationOutput;
  getCallConversations?: Maybe<PaginatedCallConversations>;
  getCallScoringSettings: GetCallScoringSettingsResult;
  getCallTaggingSettings: GetCallTaggingSettingsOutput;
  getCallTimelineByCallSid?: Maybe<GetCallTimelineOutput>;
  getCallTimelineByCallSidV2?: Maybe<GetCallTimelineOutputV2>;
  getCardDetails?: Maybe<GetCardDetailsOutput>;
  getCategories: Array<Categories>;
  getCertifications: GetCertificationsOutput;
  getChatSession: GetChatSessionOutput;
  getCoachingSession: GetCoachingSessionResult;
  getCollectionDetails: CollectionDetails;
  getCollections: Array<Collections>;
  getCompany: Company;
  getCompanyAcknowledgment: CompanyAcknowledgment;
  getCompanyBillingDetails?: Maybe<CompanyBillingDetailsOutput>;
  getCompanyContext?: Maybe<CompanyContext>;
  getCompanyNumbersCount: GetCompanyNumbersCountOutput;
  getCompanyQuestionnaires: GetCompanyQuestionnairesOutput;
  getCompanyRiskScore?: Maybe<GetCompanyRiskScoreOutput>;
  getCompanyUsersCount: GetCompanyUsersCountOutput;
  getConfigEvaluation: ConfigEvaluationResultOutput;
  getConnectPlaneApplicationAuthHeader: GetConnectPlaneApplicationAuthHeaderOutput;
  getConnectPlaneCapabilities: ConnectPlaneCapabilitiesOutput;
  getConnectPlaneCapabilitiesV2: ConnectPlaneCapabilitiesV2Output;
  getConnectPlaneCapabilityTool: ConnectPlaneCapabilityToolOutput;
  getConnectPlaneMCPConfig: ConnectPlaneMcpConfigListOutput;
  getConnectPlaneMCPTool: ConnectPlaneMcpToolOutput;
  getConnectPlaneToolAvailability: GetConnectPlaneToolAvailabilityOutput;
  getConversation?: Maybe<Conversation>;
  getConversationByLineAndExternal?: Maybe<Conversation>;
  getCoreKBContradictions: KbContradictionReportResult;
  getCoreKBDetails: KnowledgeBaseDetailsResult;
  getCoreKBDocumentDetails: DocumentResult;
  getCoreKBDocumentsUsage: KbDocumentsUsageResult;
  getCoreKBIntegration?: Maybe<CoreKbIntegrationResult>;
  getCoreKBIntegrationSubscription?: Maybe<CoreKbIntegrationSubscriptionResult>;
  getCoreKBRAGProgress: CoreKbragProgressResult;
  getCoreKBRAGStatus: CoreKbragStatusResult;
  getCoreKBRaw: KbRawTextResult;
  getCoreKBSummary: KbSummaryResult;
  getCoreKBUsage: CoreKbUsageResult;
  getCountCallConversations?: Maybe<GetCountCallConversationsResult>;
  getCountryISOCodesForCompany: Array<Scalars['String']['output']>;
  getCrawlDocument: CrawlDocumentOutput;
  getCustomSummaries: GetCustomSummariesOutput;
  getCustomSummaryConfigurations: GetCustomSummaryConfigurationsOutput;
  getCustomSummaryResults: GetCustomSummaryResultsOutput;
  getDiagnosticsToken: DiagnosticsToken;
  getDialerCampaign?: Maybe<DialerCampaign>;
  getDialerCampaignNumbers: DialerCampaignNumbers;
  getDirectDebitBillingRequestFlow?: Maybe<DirectDebitBillingRequestFlowOutput>;
  getDocumentDownloadUrl: GetDocumentDownloadUrlResult;
  getEmailNotifications?: Maybe<Array<EmailNotification>>;
  getEmergencyAddress: Array<EmergencyAddress>;
  getEmergencyNumbers: Array<EmergencyNumberCountry>;
  getEvalPersonas: GetEvalPersonasOutput;
  getEvalRun: GetEvalRunOutput;
  getEvaluationCallsCount: GetEvaluationCallsCountResult;
  getEvaluationCategoriesNormalizedScoreAvg: GetEvaluationCategoriesNormalizedScoreAvgResult;
  getEvaluationNormalizedScoreAvg: GetEvaluationNormalizedScoreAvgResult;
  getEvaluationQuestionAnswerCounts: GetEvaluationQuestionAnswerCountsResult;
  getEvaluationUsersCount: GetEvaluationUsersCountResult;
  getEvaluations: GetEvaluationsResult;
  getFeatureFlags: Array<FeatureFlag>;
  getFirstPaymentStatus?: Maybe<GetFirstPaymentStatusOutput>;
  getFlowByLineID?: Maybe<FlowConfigurationOutput>;
  getHsHelpdeskLines: GetHubSpotHelpDeskConnectedLinesOutput;
  getHubApplicationInstallData: HubApplicationInstallData;
  getHubIntegrationInstallInformation: HubIntegrationInstallInformation;
  getHubspotCallData: HubspotCallDataOutput;
  getHubspotCallOptions: HubspotCallOptionsOutput;
  getHubspotCallProperties: HubspotCallPropertiesOutput;
  getHubspotIntegrationsSmsLines: GetHubspotIntegrationsSmsLinesOutput;
  getHubspotSearchContext: GetHubspotSearchContextOutput;
  getHubspotSequences: HubspotSequencesOutput;
  getHubspotSequencesEligibility: HubspotSequencesEligibilityOutput;
  getInsightCards: GetInsightCardsOutput;
  getIntegration: Integration;
  getIntegrationAllConnectedLines: IntegrationAllConnectedLines;
  getIntegrationConnectedLines: IntegrationConnectedLines;
  getIntegrationSettings: IntegrationSettings;
  getIntegrations: Array<Integration>;
  getInvoice: GetInvoice;
  getInvoiceUsageReport: GetInvoiceUsageReportOutput;
  getInvoices: GetInvoices;
  getIvrSettingsByNumberID: IvrSettingsOutput;
  getKBDetails: KbDetailsOutput;
  getKBForAgent: AgentKbQueryResult;
  getKeywords: GetKeywordsOutput;
  getKnowledgeBaseByClientType: KnowledgeBaseOutput;
  getKnowledgeStats: KnowledgeStatsOutput;
  getKycStatus?: Maybe<GetKycStatusOutput>;
  getLatestAppDownloadUrls?: Maybe<AppDownloadUrls>;
  getLatestLongTailProposal: GetLatestLongTailProposalOutput;
  getLatestLongTailSourceInput: GetLatestLongTailSourceInputOutput;
  getLine?: Maybe<Line>;
  getLineBusinessHours?: Maybe<BusinessHours>;
  getLineByUUID?: Maybe<Line>;
  getLineSettings?: Maybe<LineSettingsOutput>;
  getLineTranscriptionsSettings?: Maybe<LineTranscriptionSettings>;
  getLinesBrandedCallingStatus: Array<LineIdBrandedCallingStatus>;
  getLinesByEntity?: Maybe<LineInfoOutput>;
  getLoaEnvelope: GetLoaEnvelopeResult;
  getLocalisedContracts: Array<Contract>;
  getLongTailGenerationJob: GetLongTailGenerationJobOutput;
  getLongTailProposal: GetLongTailProposalOutput;
  getLongTailRegistrationSession: GetLongTailRegistrationSessionOutput;
  getLongTailSourceInput: GetLongTailSourceInputOutput;
  getMCPConfig: McpConfigOutput;
  getNotifications?: Maybe<GetNotificationsOutput>;
  getNotificationsConfiguration: NotificationsConfiguration;
  getNumberByUUID: GetNumberResponse;
  getNumberRegistrationStatus?: Maybe<GetNumberRegistrationStatusOutput>;
  getOnboarding: GetOnboardingOutput;
  getOutboundAgentInsights: OutboundAgentInsightsOutput;
  getPlaybookResults: GetPlaybookResultsOutput;
  getPlaybookSettings: GetPlaybookSettingsOutput;
  getPlaybooks: GetCustomPlaybooksOutput;
  getPortingDocumentDownloadUrl: GetPortingDocumentDownloadUrlResponse;
  getPortingFields: PortingFieldsResponse;
  getPortingRequest: GetPortingRequestResponse;
  getPortingSupportedCountries: PortingSupportedCountriesResponse;
  getPredefinedAIQuestions: GetPredefinedAiQuestionsResult;
  getPredefinedSummaryTemplates: GetPredefinedSummaryTemplatesOutput;
  getPresignedMediaUrl: GetPresignedMediaUrlResult;
  getProfile: GetProfileResult;
  getRegion: Region;
  getRegionFromE164: NumberRegion;
  getReputationNotificationStatus: ReputationNotificationStatusResult;
  getRequirement?: Maybe<Array<Maybe<RequirementEntity>>>;
  getResellerData: ResellerResponse;
  getRestAuthorizedApplication: RestAuthorizedApplication;
  getRingtones: Array<Ringtone>;
  getSFOmnichannelApiKey: GetSfOmnichannelApiKeyOutput;
  getSalesforceVoiceEligibility: SalesforceVoiceEligibilityResult;
  getSamlConfiguration?: Maybe<SamlConfiguration>;
  getScenario: SavedScenarioOutput;
  getScenarios: GetScenariosOutput;
  getScorecardTemplates: GetScorecardTemplatesResult;
  getScorecards: GetScoreCardsResult;
  getScvIntegrationSettings: Array<ScvIntegrationSettings>;
  getSettingsSchemaValues: Array<SettingSchema>;
  getSignInStrategy: SignInStrategy;
  getSignupInformation: SignupInformation;
  getSimulationRun: SimulationRunOutput;
  getStudioConversation: GetStudioConversationOutput;
  getStudioTurn: GetStudioTurnOutput;
  getSupervision: GetSupervisionOutput;
  getTagsAndNotes?: Maybe<TagsAndNotes>;
  getTeam: Team;
  getTeams: GetTeamsOutput;
  getTemplateById: GetTemplateByIdResult;
  getTerms: GetTermsOutput;
  getTimezoneByPhoneNumber: GetTimezoneByPhoneNumberOutput;
  getTopics: GetTopicsOutput;
  getTrack: GetTrackOutput;
  getTrackerBackfillStatus?: Maybe<GetTrackerBackfillStatusResult>;
  getTrackers?: Maybe<GetTrackersResult>;
  getTranscriptionSettings?: Maybe<TranscriptionSettings>;
  getTranscriptions?: Maybe<PaginatedTranscriptions>;
  getTrendEvaluationCallsCount: TrendResult;
  getTrendEvaluationNormalizedScoreAvg: TrendResult;
  getTrendEvaluationUsersCount: TrendResult;
  getTrialWelcomeWizard: GetTrialWelcomeWizardOutput;
  getUnreadAircallWorkspaceConversationsCount: UnreadAircallWorkspaceConversationsCountOutput;
  getUnreadConversationsCounter?: Maybe<UnreadConversationsCounter>;
  getUsersEvaluationsMatrix: MatrixUsersEvaluationsResult;
  getVirtualAgentActivationStatus: VirtualAgentActivationStatusOutput;
  getVirtualAgentUsage: VirtualAgentUsageOutput;
  getVirtualAgentUsageAlert: VirtualAgentUsageAlertOutput;
  getVoiceVirtualAgentAuthMethod: AuthMethodOutput;
  getWebDispatchGroupsByNumberID: WebDispatchGroupsOutput;
  getWebhook: Webhook;
  getWebhookConfigurations: Array<WebhookConfiguration>;
  getWebhooks: Array<Webhook>;
  getWhatsappLicenseStatus: WhatsappLicenseStatusResponse;
  getWhatsappRegistrationStatus: WhatsappRegistrationStatus;
  hubApplications: Array<HubApplication>;
  installApplication: InstallApplication;
  integrationInstallUri: IntegrationInstallUri;
  integrationsToUpdate: CompanyIntegrations;
  isFeatureFlagEnabled?: Maybe<FeatureFlag>;
  listAgentActions: ListActionsOutput;
  listAgentOverviewInsights: ListAgentOverviewInsightsOutput;
  listAgentTemplates: ListAgentTemplatesOutput;
  listAgentTemplatesV2: ListAgentTemplateV2Result;
  listAllCompanyDocuments: CompanyDocumentsResult;
  listAvailableCoreKBIntegrationArticles?: Maybe<AvailableCoreKbIntegrationArticlesResult>;
  listAvailableCoreKBIntegrations?: Maybe<AvailableCoreKbIntegrationsResult>;
  listBlacklistedPhones: BlacklistedPhonesResponse;
  listBrandDrafts: BrandDraftListResult;
  listBrandedCallingCountries: BrandedCallingSupportedCountriesResult;
  listBrands: ListBrandsResult;
  listBusinessDrafts: BusinessDraftListResult;
  listBusinessRegistrationNumbers: MonitoredNumbersListResult;
  listBusinessRegistrations: BusinessRegistrationListResult;
  listCalendars: ListCalendarsOutput;
  listCalendarsV2: ListCalendarsOutputV2;
  listCampaignUseCases: ListCampaignUseCasesResult;
  listClientTypes: ClientTypesResult;
  listCoachingSessions: ListCoachingSessionsResult;
  listCompanyKBMappings: CompanyKbMappingsOutput;
  listCompanyKnowledgeSources: KnowledgeSourcesResult;
  listCompanyOutboundCampaignOutcomes: ListCompanyOutboundCampaignOutcomesOutput;
  listConversations?: Maybe<ConversationConnection>;
  listCoreKBDocuments: DocumentsResult;
  listCoreKBIntegrationSubscriptions?: Maybe<CoreKbIntegrationSubscriptionListResult>;
  listCoreKBIntegrations?: Maybe<CoreKbIntegrationListResult>;
  listCoreKBs: KnowledgeBasesResult;
  listCountries: Array<Country>;
  listCrawlDocuments: CrawlDocumentListOutput;
  listCrawlRoots: CrawlDocumentListOutput;
  listCrmContactLists: ListCrmContactListsOutput;
  listDocumentFormats: DocumentFormatsOutput;
  listEvalRuns: ListEvalRunsOutput;
  listGSMDevices: ListGsmDevicesOutput;
  listGeneratedRealtimeQuestionAnsweringCards: RealtimeQuestionAnsweringGeneratedCardListOutput;
  listKBCrawlRoots: CoreKbCrawlRootsResult;
  listLoaEnvelopes: ListLoaEnvelopesResult;
  listLongTailProposals: ListLongTailProposalsOutput;
  listOutboundCampaignCallOutcomes: ListOutboundCampaignCallOutcomesOutput;
  listOutboundCampaignContacts: ListOutboundCampaignContactsOutput;
  listOutboundCampaignLines: ListOutboundCampaignLinesOutput;
  listOutboundCampaignQueueItems: ListOutboundCampaignQueueItemsOutput;
  listOutboundCampaignUsers: ListOutboundCampaignUsersOutput;
  listOutboundCampaigns: ListOutboundCampaignsOutput;
  listPortingRequests: ListPortingRequestsResponse;
  listRealtimeQuestionAnsweringCards: RealtimeQuestionAnsweringCardListOutput;
  listRealtimeQuestionAnsweringCategories: RealtimeQuestionAnsweringCategoryListOutput;
  listRegions: Regions;
  listRootChildren: CoreKbChildDocumentsResult;
  listScenarios: SavedScenarioListOutput;
  listSessionMessages: ListSessionMessagesResult;
  listSimulationRuns: SimulationRunListOutput;
  listSupervisions: ListSupervisionsOutput;
  listTemplates: ListTemplatesResult;
  listTracks: ListTracksOutput;
  listTracksv1: Tracks;
  listVirtualAgents: ListVirtualAgentsOutput;
  listVoiceVirtualAgentActionsByAuthMethod: ListActionsOutput;
  listVoiceVirtualAgentAuthMethods: ListAuthMethodsOutput;
  listVoices: ListVoicesOutput;
  listWhatsAppTemplates: ListWhatsAppTemplatesResult;
  liveMonitoringCalls: LiveMonitoringCallsListResult;
  liveMonitoringCampaigns: LiveMonitoringCampaignsListResult;
  liveMonitoringCurrentUserKPIs: LiveMonitoringCurrentUserMetricsResult;
  liveMonitoringLines: LiveMonitoringLinesListResult;
  liveMonitoringTopKPIs: LiveMonitoringMetricsResult;
  liveMonitoringTopMetrics: LiveMonitoringTopMetricsResult;
  liveMonitoringUserAvailabilities: LiveMonitoringUserAvailabilitiesResult;
  liveMonitoringUserPreferences: LiveMonitoringUserPreferencesResult;
  liveMonitoringUsers: LiveMonitoringUsersListResult;
  lookupContacts: LookupContactsOutput;
  lookupEnrolledNumbers: LookupEnrolledNumbersResult;
  lookupTeammates: LookupTeammatesOutput;
  mapURL: MapUrlResult;
  messageConversationsCountPerCategory: MessageConversationsCountPerCategoryOutput;
  messagingAIAgent?: Maybe<MessagingAiAgent>;
  messagingAIAgentUsedLines: Array<Scalars['Int']['output']>;
  messagingAIAgents: MessagingAiAgentsConnection;
  messagingAIConversationStopStatus: MessagingAiConversationStopStatus;
  messagingAIIsConversationEscalated: Scalars['Boolean']['output'];
  messagingAILineAllocatedHours: MessagingAiLineAllocatedHours;
  messagingAIPlaygroundMessages: Array<MessagingAiPlaygroundMessage>;
  messagingAISessionCount: MessagingAiSessionCount;
  numberDetail: Number;
  numberIntegrations: CompanyIntegrations;
  numberSupervision: Number;
  oauthCode: OauthCodeQueryResponse;
  oauthCodeV2?: Maybe<Void>;
  outboundCampaign: OutboundCampaignOutput;
  outboundCampaignAvailabilityEstimate: OutboundCampaignAvailabilityEstimateOutput;
  outboundCampaignBackgroundJob: OutboundCampaignBackgroundJobOutput;
  outboundCampaignContact: OutboundCampaignContactOutput;
  outboundCampaignContactImport: OutboundCampaignContactImportOutput;
  outboundCampaignCurrentUserRelevantStatus?: Maybe<OutboundCampaignCurrentUserRelevantStatus>;
  outboundCampaignDuplicationPreview: OutboundCampaignDuplicationPreviewOutput;
  outboundCampaignOutcome: OutboundCampaignOutcomeOutput;
  outboundCampaignsFieldMapping: OutboundCampaignsFieldMapping;
  outboundEventByCallSid: OutboundEventOutput;
  outboundEvents: OutboundEventsOutput;
  phoneCall: PhoneCallOutput;
  playbookResults: PlaybookResultsOutput;
  prerecordedMessageByCallSid: PrerecordedMessageByCallSidOutput;
  prerecordedMessages: Array<PrerecordedMessage>;
  previewAction: ActionPreviewOutput;
  realtimeQuestionAnsweringConfiguration: RealtimeQuestionAnsweringConfigurationOutput;
  requestedFeatures: RequestedFeaturesOutput;
  resendUserInvitationEmail?: Maybe<Void>;
  searchAgents?: Maybe<SearchableAgentsConnection>;
  searchAircallWorkspaceGroupConversations: AircallWorkspaceConversationsOutput;
  searchAuthorizedLines?: Maybe<SearchableLinesConnection>;
  searchAuthorizedTeams?: Maybe<SearchableTeamsConnection>;
  searchAuthorizedUsers?: Maybe<SearchableAgentsConnection>;
  searchCallEngagements: PaginatedSearchCallEngagementsOutput;
  searchDefaultOwners: Array<DefaultOwner>;
  searchLines?: Maybe<SearchableLinesConnection>;
  searchNumbers?: Maybe<SearchableNumbersConnection>;
  searchTeams?: Maybe<SearchableTeamsConnection>;
  searchUsers?: Maybe<SearchableUsersConnection>;
  signupInformation: SignupInformationOutput;
  tasks: Array<TaskState>;
  teammateById: TeammateByIdOutput;
  teammatesByIds: TeammatesByIdsOutput;
  textToSpeechOptions: TtsOptions;
  ttsMessagesVoices: TtsMessagesVoicesOutput;
  uploadAudioFile: UploadAudioFilePayload;
  userLicenses?: Maybe<UserLicensesOutput>;
  userNumbers: UserNumbers;
  webhooks: Array<RestWebhook>;
  wizardStatus: WizardStatusOutput;
};


export type QueryActivationReadinessArgs = {
  input: ActivationReadinessInput;
};


export type QueryAircallExtractByIdArgs = {
  input: AircallExtractByIdInput;
};


export type QueryAircallWorkspaceConversationByCallIdArgs = {
  callID: Scalars['ID']['input'];
};


export type QueryAircallWorkspaceConversationByLineIdAndPhoneNumberArgs = {
  lineID: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
  resourceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAircallWorkspaceConversationsCountPerCategoryArgs = {
  filters?: InputMaybe<AircallWorkspaceConversationsCountPerCategoryFilters>;
};


export type QueryAltFindVirtualAgentByIdArgs = {
  virtualAgentID: Scalars['ID']['input'];
};


export type QueryAnalyticsCallsHistoryArgs = {
  input: AnalyticsListInput;
};


export type QueryAnalyticsContactFilterArgs = {
  input: AnalyticsFilterInput;
};


export type QueryAnalyticsCustomerNumberFilterArgs = {
  input: AnalyticsFilterInput;
};


export type QueryAnalyticsGetPresetArgs = {
  input: AnalyticsGetPresetInput;
};


export type QueryAnalyticsIvrBranchFilterArgs = {
  input: AnalyticsFilterInput;
};


export type QueryAnalyticsLineFilterArgs = {
  input: AnalyticsFilterInput;
};


export type QueryAnalyticsListPresetsArgs = {
  input: AnalyticsListPresetsInput;
};


export type QueryAnalyticsMessagesHistoryArgs = {
  input: AnalyticsListInput;
};


export type QueryAnalyticsMultipleValueMetricArgs = {
  input: AnalyticsMultipleValueMetricInput;
};


export type QueryAnalyticsMultipleValueMetricDrillDownArgs = {
  input: AnalyticsMultipleValueMetricDrillDownInput;
};


export type QueryAnalyticsOutboundCampaignFilterArgs = {
  input: AnalyticsFilterInput;
};


export type QueryAnalyticsSingleValueMetricArgs = {
  input: AnalyticsSingleValueMetricInput;
};


export type QueryAnalyticsSingleValueMetricDrillDownArgs = {
  input: AnalyticsSingleValueMetricDrillDownInput;
};


export type QueryAnalyticsTagFilterArgs = {
  input: AnalyticsFilterInput;
};


export type QueryAnalyticsTeamFilterArgs = {
  input: AnalyticsFilterInput;
};


export type QueryAnalyticsUserFilterArgs = {
  input: AnalyticsFilterInput;
};


export type QueryAnalyticsUserStatusHistoryArgs = {
  input: AnalyticsListInput;
};


export type QueryAnalyticsVirtualVoiceAgentFilterArgs = {
  input: AnalyticsFilterInput;
};


export type QueryAuthorizeZendeskArgs = {
  returnTo?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBlacklistedNumbersArgs = {
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBulkCheckOutboundEligibilityArgs = {
  input: CheckOutboundEligibilityInput;
};


export type QueryCallEngagementsCountPerCategoryArgs = {
  filters?: InputMaybe<CallEngagementsFilters>;
};


export type QueryCheckAppVersionArgs = {
  currentOSVersion?: InputMaybe<Scalars['String']['input']>;
  currentVersion: Scalars['String']['input'];
  platform: Scalars['String']['input'];
};


export type QueryCheckCriticalActionArgs = {
  action: Scalars['String']['input'];
  agentID: Scalars['ID']['input'];
  email: Scalars['String']['input'];
};


export type QueryCheckNumberPurchaseEligibilityArgs = {
  countryAlpha2: Scalars['String']['input'];
  numberType: Scalars['String']['input'];
};


export type QueryCheckOutboundEligibilityArgs = {
  phoneNumbers: Array<Scalars['String']['input']>;
};


export type QueryCheckRequirementsArgs = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  regionId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryClientActionInsightsArgs = {
  input?: InputMaybe<ClientActionInsightsInput>;
};


export type QueryCompanyFeatureArgs = {
  featureName: Scalars['String']['input'];
};


export type QueryCompanyFeaturesArgs = {
  includeLicenseStats?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCompanyPromotionsArgs = {
  excludeExpired?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryContactByPhoneNumberArgs = {
  input: ContactByPhoneNumberInput;
};


export type QueryContactsByPhoneNumbersArgs = {
  input: ContactsByPhoneNumbersInput;
};


export type QueryDownloadPortingLoaArgs = {
  input: DownloadPortingLoaInput;
};


export type QueryEngagementsByConversationIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  conversationId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEscalationDependentsArgs = {
  entityId: Scalars['Int']['input'];
  entityType: EscalationDependentEntityType;
};


export type QueryEvaluateConfigurationArgs = {
  includeSystemInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  virtualAgentID: Scalars['ID']['input'];
};


export type QueryExtractCoreKbKnowledgeArgs = {
  input: CoreKbKnowledgeExtractionInput;
};


export type QueryExtractKnowledgeArgs = {
  input: KnowledgeRequestInput;
};


export type QueryFetchAllBoardsPaginatedArgs = {
  integrationID: Scalars['ID']['input'];
  limit: Scalars['String']['input'];
  page: Scalars['String']['input'];
};


export type QueryFetchBoardDetailsArgs = {
  boardId: Scalars['String']['input'];
  integrationID: Scalars['ID']['input'];
};


export type QueryFetchUsersOfGroupArgs = {
  groupId: Scalars['String']['input'];
  integrationID: Scalars['ID']['input'];
};


export type QueryFindActiveDraftArgs = {
  agentId: Scalars['ID']['input'];
};


export type QueryFindActiveDraftsForAgentsArgs = {
  agentIds: Array<Scalars['ID']['input']>;
};


export type QueryFindCalendarByIdArgs = {
  calendarID: Scalars['ID']['input'];
};


export type QueryFindCalendarByIdV2Args = {
  calendarID: Scalars['ID']['input'];
};


export type QueryFindVirtualAgentByIdArgs = {
  virtualAgentID: Scalars['ID']['input'];
};


export type QueryGenerateSimulationScenariosArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  virtualAgentID: Scalars['ID']['input'];
};


export type QueryGetA2PFormArgs = {
  formID: Scalars['ID']['input'];
};


export type QueryGetA2PFormAttachmentUploadUrlArgs = {
  input: GetA2PFormAttachmentUploadUrlInput;
};


export type QueryGetA2PUrlEvidenceArgs = {
  runId: Scalars['ID']['input'];
};


export type QueryGetActionArgs = {
  actionId: Scalars['ID']['input'];
};


export type QueryGetActivePlaybookArgs = {
  input: GetActivePlaybookInput;
};


export type QueryGetAdminMcpOauthGrantStatusArgs = {
  hubApplicationId: Scalars['String']['input'];
};


export type QueryGetAgentArgs = {
  ID: Scalars['ID']['input'];
};


export type QueryGetAgentBuildProgressArgs = {
  virtualAgentID: Scalars['ID']['input'];
};


export type QueryGetAgentChatFeedbackArgs = {
  ID: Scalars['String']['input'];
};


export type QueryGetAgentEvidenceSummaryArgs = {
  virtualAgentID: Scalars['ID']['input'];
};


export type QueryGetAgentInsightsArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  virtualAgentID: Scalars['ID']['input'];
};


export type QueryGetAgentInsightsJobArgs = {
  jobId: Scalars['ID']['input'];
  virtualAgentID: Scalars['ID']['input'];
};


export type QueryGetAgentKbMappingArgs = {
  agent_id: Scalars['String']['input'];
  agent_type?: InputMaybe<AgentType>;
  client_type: Scalars['String']['input'];
};


export type QueryGetAgentRecentTagsArgs = {
  input: AgentRecentTagsInput;
};


export type QueryGetAgentV2Args = {
  agentID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetAgentsForDocumentInKbArgs = {
  doc_id: Scalars['ID']['input'];
  kb_id: Scalars['ID']['input'];
};


export type QueryGetAiActionsEnabledCompaniesArgs = {
  hubApplicationId: Scalars['String']['input'];
};


export type QueryGetAircallWorkspaceConversationArgs = {
  ID: Scalars['ID']['input'];
};


export type QueryGetAircallWorkspaceConversationsArgs = {
  filters?: InputMaybe<AircallWorkspaceConversationsFilters>;
  pageRequest?: InputMaybe<AircallWorkspaceConversationsPageRequest>;
};


export type QueryGetAivaAgentActionsArgs = {
  agentId: Scalars['ID']['input'];
  companyId: Scalars['Int']['input'];
};


export type QueryGetAivaAgentMigrationDraftArgs = {
  agentId: Scalars['ID']['input'];
  companyId: Scalars['Int']['input'];
  hubApplicationId: Scalars['String']['input'];
};


export type QueryGetAllAgentUsersOfKbArgs = {
  kb_id: Scalars['ID']['input'];
};


export type QueryGetAnalyticsDashboardUrlArgs = {
  input: AnalyticsDashboardUrlInput;
};


export type QueryGetApplicationInstallUriArgs = {
  applicationID: Scalars['ID']['input'];
  hubOldIntegrationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetApplicationsArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAudioArgs = {
  callId: Scalars['ID']['input'];
  callType: AudioType;
};


export type QueryGetAuthorizedApplicationArgs = {
  clientId: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  responseType: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  v2?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetAutocompleteTopicsArgs = {
  limit: Scalars['Int']['input'];
  searchText: Scalars['String']['input'];
};


export type QueryGetAutomationsArgs = {
  filters: GetAutomationsFilter;
};


export type QueryGetBestMatchArgs = {
  input: GetBestMatchInput;
};


export type QueryGetBetasArgs = {
  input?: InputMaybe<GetBetasInput>;
};


export type QueryGetBrandArgs = {
  brandId: Scalars['ID']['input'];
};


export type QueryGetBrandDocumentDownloadUrlArgs = {
  documentUuid: Scalars['ID']['input'];
};


export type QueryGetBrandDraftArgs = {
  draftId: Scalars['ID']['input'];
};


export type QueryGetBrandDraftLogoArgs = {
  logoUuid: Scalars['ID']['input'];
};


export type QueryGetBulkCallTimelinesByCallSidsArgs = {
  callSids: Array<Scalars['String']['input']>;
};


export type QueryGetBulkCallTimelinesByCallSidsV2Args = {
  callSids: Array<Scalars['String']['input']>;
};


export type QueryGetBusinessRegistrationMetricsArgs = {
  businessId: Scalars['ID']['input'];
};


export type QueryGetCallArgs = {
  callId: Scalars['ID']['input'];
};


export type QueryGetCallConversationsArgs = {
  agentIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  aggregations?: InputMaybe<CallConversationAggregationsScope>;
  callIds?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  exclude?: InputMaybe<Array<InputMaybe<ExcludeFilter>>>;
  fromTs?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  hasTranscription?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  lineIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  maxDurationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  minDurationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  predictedCsatScope?: InputMaybe<PredictedCsatScopeFilter>;
  sentimentScope?: InputMaybe<SentimentScopeFilter>;
  sort?: InputMaybe<CallConversationSort>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  toTs?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  topics?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  trackerIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  transcriptionScope?: InputMaybe<TranscriptionScopeFilter>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  virtualAgentIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetCallTaggingSettingsArgs = {
  input: GetCallTaggingSettingsInput;
};


export type QueryGetCallTimelineByCallSidArgs = {
  callSid: Scalars['String']['input'];
};


export type QueryGetCallTimelineByCallSidV2Args = {
  callSid: Scalars['String']['input'];
};


export type QueryGetCertificationsArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryGetChatSessionArgs = {
  sessionId: Scalars['ID']['input'];
  virtualAgentID: Scalars['ID']['input'];
};


export type QueryGetCoachingSessionArgs = {
  sessionId: Scalars['String']['input'];
};


export type QueryGetCollectionDetailsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetCompanyAcknowledgmentArgs = {
  alpha2: Scalars['String']['input'];
};


export type QueryGetCompanyNumbersCountArgs = {
  input: GetCompanyNumbersCountInput;
};


export type QueryGetCompanyQuestionnairesArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryGetCompanyRiskScoreArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryGetCompanyUsersCountArgs = {
  input: GetCompanyUsersCountInput;
};


export type QueryGetConfigEvaluationArgs = {
  evaluationId: Scalars['ID']['input'];
  virtualAgentID: Scalars['ID']['input'];
};


export type QueryGetConnectPlaneApplicationAuthHeaderArgs = {
  hubApplicationId: Scalars['String']['input'];
};


export type QueryGetConnectPlaneCapabilitiesArgs = {
  agentType: AgentType;
};


export type QueryGetConnectPlaneCapabilitiesV2Args = {
  agentType: AgentType;
};


export type QueryGetConnectPlaneCapabilityToolArgs = {
  agentType: AgentType;
  qualifiedName: Scalars['String']['input'];
};


export type QueryGetConnectPlaneMcpConfigArgs = {
  agentTypes: Array<AgentType>;
  applicationId: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
};


export type QueryGetConnectPlaneMcpToolArgs = {
  agentType: AgentType;
  applicationId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
};


export type QueryGetConnectPlaneToolAvailabilityArgs = {
  hubApplicationId: Scalars['String']['input'];
  toolName: Scalars['String']['input'];
};


export type QueryGetConversationArgs = {
  ID: Scalars['ID']['input'];
};


export type QueryGetConversationByLineAndExternalArgs = {
  externalNumber: Scalars['String']['input'];
  lineID: Scalars['ID']['input'];
};


export type QueryGetCoreKbContradictionsArgs = {
  kb_id: Scalars['ID']['input'];
};


export type QueryGetCoreKbDetailsArgs = {
  kb_id: Scalars['ID']['input'];
};


export type QueryGetCoreKbDocumentDetailsArgs = {
  doc_id: Scalars['ID']['input'];
  kb_id: Scalars['ID']['input'];
};


export type QueryGetCoreKbDocumentsUsageArgs = {
  kb_id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetCoreKbIntegrationArgs = {
  company_integration_id: Scalars['ID']['input'];
};


export type QueryGetCoreKbIntegrationSubscriptionArgs = {
  crawl_document_id: Scalars['ID']['input'];
  kb_id: Scalars['ID']['input'];
};


export type QueryGetCoreKbragProgressArgs = {
  kb_id: Scalars['ID']['input'];
};


export type QueryGetCoreKbragStatusArgs = {
  kb_id: Scalars['ID']['input'];
};


export type QueryGetCoreKbRawArgs = {
  kb_id: Scalars['ID']['input'];
  max_chars?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetCoreKbSummaryArgs = {
  kb_id: Scalars['ID']['input'];
  max_chars?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetCoreKbUsageArgs = {
  kb_id: Scalars['ID']['input'];
};


export type QueryGetCountCallConversationsArgs = {
  agentIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  callIds?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  fromTs?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  hasTranscription?: InputMaybe<Scalars['Boolean']['input']>;
  lineIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  maxDurationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  minDurationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  predictedCsatScope?: InputMaybe<PredictedCsatScopeFilter>;
  sentimentScope?: InputMaybe<SentimentScopeFilter>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  toTs?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  topics?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  trackerIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  transcriptionScope?: InputMaybe<TranscriptionScopeFilter>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  virtualAgentIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetCrawlDocumentArgs = {
  documentId: Scalars['Int']['input'];
};


export type QueryGetCustomSummariesArgs = {
  input?: InputMaybe<GetCustomSummariesInput>;
};


export type QueryGetCustomSummaryConfigurationsArgs = {
  input?: InputMaybe<GetCustomSummaryConfigurationsInput>;
};


export type QueryGetCustomSummaryResultsArgs = {
  input?: InputMaybe<GetCustomSummaryResultsInput>;
};


export type QueryGetDiagnosticsTokenArgs = {
  isMobile?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDialerCampaignArgs = {
  campaignID: Scalars['ID']['input'];
};


export type QueryGetDialerCampaignNumbersArgs = {
  campaignID: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetDocumentDownloadUrlArgs = {
  documentUuid: Scalars['ID']['input'];
  feature: Scalars['String']['input'];
};


export type QueryGetEmailNotificationsArgs = {
  agentID: Scalars['ID']['input'];
};


export type QueryGetEmergencyAddressArgs = {
  agentID: Scalars['ID']['input'];
};


export type QueryGetEmergencyNumbersArgs = {
  countryCode?: InputMaybe<EmergencyCountryCode>;
};


export type QueryGetEvalPersonasArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryGetEvalRunArgs = {
  applicationId: Scalars['String']['input'];
  runId: Scalars['String']['input'];
};


export type QueryGetEvaluationCallsCountArgs = {
  filters: AggregatedScorecardEvaluationsFilter;
};


export type QueryGetEvaluationCategoriesNormalizedScoreAvgArgs = {
  filters: AggregatedCategoriesFilter;
};


export type QueryGetEvaluationNormalizedScoreAvgArgs = {
  filters: AggregatedScorecardEvaluationsFilter;
};


export type QueryGetEvaluationQuestionAnswerCountsArgs = {
  filters: AggregatedQuestionFilter;
};


export type QueryGetEvaluationUsersCountArgs = {
  filters: AggregatedScorecardEvaluationsFilter;
};


export type QueryGetEvaluationsArgs = {
  filters: GetEvaluationsFilter;
};


export type QueryGetFeatureFlagsArgs = {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGetFirstPaymentStatusArgs = {
  status?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetFlowByLineIdArgs = {
  lineID: Scalars['ID']['input'];
};


export type QueryGetHsHelpdeskLinesArgs = {
  integrationId: Scalars['Int']['input'];
};


export type QueryGetHubApplicationInstallDataArgs = {
  applicationId: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetHubIntegrationInstallInformationArgs = {
  companyId: Scalars['Int']['input'];
  integrationId: Scalars['Int']['input'];
  language: Scalars['String']['input'];
};


export type QueryGetHubspotCallDataArgs = {
  action: Scalars['String']['input'];
  callId: Scalars['ID']['input'];
};


export type QueryGetHubspotCallOptionsArgs = {
  callId?: InputMaybe<Scalars['ID']['input']>;
  portalId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetHubspotCallPropertiesArgs = {
  callId: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
};


export type QueryGetHubspotIntegrationsSmsLinesArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  portalId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetHubspotSearchContextArgs = {
  actionType?: InputMaybe<Scalars['String']['input']>;
  actionValue?: InputMaybe<Scalars['String']['input']>;
  callId: Scalars['ID']['input'];
  portalId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetHubspotSequencesArgs = {
  callID: Scalars['ID']['input'];
};


export type QueryGetHubspotSequencesEligibilityArgs = {
  callID: Scalars['ID']['input'];
};


export type QueryGetInsightCardsArgs = {
  callId: Scalars['ID']['input'];
};


export type QueryGetIntegrationArgs = {
  id: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};


export type QueryGetIntegrationAllConnectedLinesArgs = {
  integrationID: Scalars['ID']['input'];
  integrationType: IntegrationType;
};


export type QueryGetIntegrationConnectedLinesArgs = {
  integrationID: Scalars['ID']['input'];
  integrationType: IntegrationType;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page: Scalars['Int']['input'];
};


export type QueryGetIntegrationSettingsArgs = {
  applicationName?: InputMaybe<Scalars['String']['input']>;
  integrationID: Scalars['ID']['input'];
  integrationType: Scalars['String']['input'];
  sections?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetIntegrationsArgs = {
  numberID?: InputMaybe<Scalars['Int']['input']>;
  requireUpdate?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetInvoiceArgs = {
  invoiceID: Scalars['ID']['input'];
};


export type QueryGetInvoiceUsageReportArgs = {
  endDate: Scalars['String']['input'];
  invoiceID?: InputMaybe<Scalars['ID']['input']>;
  invoiceName?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
};


export type QueryGetInvoicesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  transactionType?: InputMaybe<TransactionType>;
};


export type QueryGetIvrSettingsByNumberIdArgs = {
  numberID: Scalars['ID']['input'];
};


export type QueryGetKbDetailsArgs = {
  kbId: Scalars['Int']['input'];
};


export type QueryGetKbForAgentArgs = {
  agent_id: Scalars['String']['input'];
  agent_type?: InputMaybe<AgentType>;
  client_type: Scalars['String']['input'];
};


export type QueryGetKeywordsArgs = {
  input: GetKeywordsInput;
};


export type QueryGetKnowledgeBaseByClientTypeArgs = {
  input: KnowledgeClientInput;
};


export type QueryGetKnowledgeStatsArgs = {
  region?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetKycStatusArgs = {
  companyId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryGetLatestAppDownloadUrlsArgs = {
  appType?: InputMaybe<AppType>;
};


export type QueryGetLatestLongTailProposalArgs = {
  hubApplicationId: Scalars['String']['input'];
};


export type QueryGetLatestLongTailSourceInputArgs = {
  hubApplicationId: Scalars['String']['input'];
};


export type QueryGetLineArgs = {
  lineID: Scalars['ID']['input'];
};


export type QueryGetLineBusinessHoursArgs = {
  lineID: Scalars['ID']['input'];
};


export type QueryGetLineByUuidArgs = {
  numberUUID: Scalars['String']['input'];
};


export type QueryGetLineSettingsArgs = {
  lineID: Scalars['ID']['input'];
};


export type QueryGetLineTranscriptionsSettingsArgs = {
  lineId: Scalars['Int']['input'];
};


export type QueryGetLinesBrandedCallingStatusArgs = {
  lineIds: Array<Scalars['ID']['input']>;
};


export type QueryGetLinesByEntityArgs = {
  input: GetLineByEntityInput;
};


export type QueryGetLoaEnvelopeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetLocalisedContractsArgs = {
  country: Scalars['String']['input'];
  groupKeys: Array<Scalars['String']['input']>;
};


export type QueryGetLongTailGenerationJobArgs = {
  generationJobId: Scalars['ID']['input'];
};


export type QueryGetLongTailProposalArgs = {
  proposalId: Scalars['ID']['input'];
};


export type QueryGetLongTailRegistrationSessionArgs = {
  registrationSessionId: Scalars['ID']['input'];
};


export type QueryGetLongTailSourceInputArgs = {
  sourceInputId: Scalars['ID']['input'];
};


export type QueryGetMcpConfigArgs = {
  applicationId: Scalars['ID']['input'];
  companyId: Scalars['Int']['input'];
  integrationId?: InputMaybe<Scalars['ID']['input']>;
  reauthRedirectUri?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetNotificationsArgs = {
  input: GetNotificationsInput;
};


export type QueryGetNumberByUuidArgs = {
  input: GetNumberByUuidInput;
};


export type QueryGetNumberRegistrationStatusArgs = {
  lineID: Scalars['ID']['input'];
};


export type QueryGetOnboardingArgs = {
  input?: InputMaybe<GetOnboardingInput>;
};


export type QueryGetOutboundAgentInsightsArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  virtualAgentID: Scalars['ID']['input'];
};


export type QueryGetPlaybookResultsArgs = {
  input?: InputMaybe<GetPlaybookResultsInput>;
};


export type QueryGetPlaybookSettingsArgs = {
  input?: InputMaybe<GetPlaybookSettingsInput>;
};


export type QueryGetPlaybooksArgs = {
  input?: InputMaybe<GetCustomPlaybooksInput>;
};


export type QueryGetPortingDocumentDownloadUrlArgs = {
  input: GetPortingDocumentDownloadUrlInput;
};


export type QueryGetPortingFieldsArgs = {
  input: GetPortingFieldsInput;
};


export type QueryGetPortingRequestArgs = {
  input: GetPortingRequestInput;
};


export type QueryGetPredefinedAiQuestionsArgs = {
  filters: GetPredefinedAiQuestionsFilter;
};


export type QueryGetPredefinedSummaryTemplatesArgs = {
  input?: InputMaybe<GetPredefinedSummaryTemplatesInput>;
};


export type QueryGetPresignedMediaUrlArgs = {
  input: GetPresignedMediaUrlInput;
};


export type QueryGetRegionArgs = {
  countryId: Scalars['String']['input'];
  regionId: Scalars['String']['input'];
};


export type QueryGetRegionFromE164Args = {
  e164: Scalars['String']['input'];
};


export type QueryGetRequirementArgs = {
  includeIdentity?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  numberUUID: Scalars['String']['input'];
};


export type QueryGetRestAuthorizedApplicationArgs = {
  clientId: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  responseType: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  skipWithState: Scalars['Boolean']['input'];
  skipWithoutState: Scalars['Boolean']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSfOmnichannelApiKeyArgs = {
  integrationID: Scalars['ID']['input'];
};


export type QueryGetScenarioArgs = {
  scenarioId: Scalars['ID']['input'];
  virtualAgentID: Scalars['ID']['input'];
};


export type QueryGetScenariosArgs = {
  applicationId: Scalars['String']['input'];
  personaId: Scalars['String']['input'];
};


export type QueryGetScorecardTemplatesArgs = {
  filters: GetScorecardTemplatesFilter;
};


export type QueryGetScorecardsArgs = {
  filters: GetScoreCardsFilter;
};


export type QueryGetScvIntegrationSettingsArgs = {
  integrationIds: Array<Scalars['Int']['input']>;
};


export type QueryGetSettingsSchemaValuesArgs = {
  applicationName?: InputMaybe<Scalars['String']['input']>;
  integrationID: Scalars['ID']['input'];
  integrationType?: InputMaybe<Scalars['String']['input']>;
  sectionKey: Scalars['String']['input'];
  settingKey: Scalars['String']['input'];
};


export type QueryGetSimulationRunArgs = {
  runId: Scalars['ID']['input'];
  virtualAgentID: Scalars['ID']['input'];
};


export type QueryGetStudioConversationArgs = {
  applicationId: Scalars['String']['input'];
};


export type QueryGetStudioTurnArgs = {
  turnId: Scalars['String']['input'];
};


export type QueryGetSupervisionArgs = {
  ID: Scalars['ID']['input'];
  numberId: Scalars['ID']['input'];
};


export type QueryGetTagsAndNotesArgs = {
  callId: Scalars['ID']['input'];
};


export type QueryGetTeamArgs = {
  ID: Scalars['ID']['input'];
};


export type QueryGetTeamsArgs = {
  filter?: InputMaybe<GetTeamsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetTemplateByIdArgs = {
  templateID: Scalars['ID']['input'];
};


export type QueryGetTimezoneByPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type QueryGetTopicsArgs = {
  input?: InputMaybe<GetTopicsInput>;
};


export type QueryGetTrackArgs = {
  ID: Scalars['ID']['input'];
};


export type QueryGetTrackerBackfillStatusArgs = {
  trackerId: Scalars['Int']['input'];
};


export type QueryGetTranscriptionsArgs = {
  callIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  callUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  newestFirst?: InputMaybe<Scalars['Boolean']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTrendEvaluationCallsCountArgs = {
  filters: AggregatedScorecardEvaluationsFilter;
};


export type QueryGetTrendEvaluationNormalizedScoreAvgArgs = {
  filters: AggregatedScorecardEvaluationsFilter;
};


export type QueryGetTrendEvaluationUsersCountArgs = {
  filters: AggregatedScorecardEvaluationsFilter;
};


export type QueryGetUnreadAircallWorkspaceConversationsCountArgs = {
  filters?: InputMaybe<UnreadAircallWorkspaceConversationsCountFilters>;
};


export type QueryGetUsersEvaluationsMatrixArgs = {
  filter: MatrixUsersEvaluationsFilter;
};


export type QueryGetVoiceVirtualAgentAuthMethodArgs = {
  authMethodId: Scalars['ID']['input'];
};


export type QueryGetWebDispatchGroupsByNumberIdArgs = {
  numberID: Scalars['ID']['input'];
};


export type QueryGetWebhookArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetWhatsappRegistrationStatusArgs = {
  numberUUID: Scalars['String']['input'];
};


export type QueryHubApplicationsArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryInstallApplicationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};


export type QueryIntegrationInstallUriArgs = {
  applicationId: Scalars['String']['input'];
  hubOldIntegrationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIsFeatureFlagEnabledArgs = {
  featureFlag: Scalars['String']['input'];
};


export type QueryListAgentActionsArgs = {
  agentId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListAgentOverviewInsightsArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  virtualAgentIDs: Array<Scalars['ID']['input']>;
};


export type QueryListAgentTemplatesArgs = {
  callDirection?: InputMaybe<CallDirection>;
};


export type QueryListAgentTemplatesV2Args = {
  input: ListAgentTemplatesInput;
};


export type QueryListAllCompanyDocumentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListAvailableCoreKbIntegrationArticlesArgs = {
  application_id: Scalars['String']['input'];
  integration_id: Scalars['String']['input'];
};


export type QueryListBlacklistedPhonesArgs = {
  order?: InputMaybe<SortDirection>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListBrandsArgs = {
  input?: InputMaybe<ListBrandsInput>;
};


export type QueryListBusinessRegistrationNumbersArgs = {
  businessId: Scalars['ID']['input'];
  filter?: InputMaybe<MonitoredNumbersFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListCalendarsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCalendarsV2Args = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCampaignUseCasesArgs = {
  input: ListCampaignUseCasesInput;
};


export type QueryListCoachingSessionsArgs = {
  input?: InputMaybe<ListCoachingSessionsInput>;
};


export type QueryListCompanyKbMappingsArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryListCompanyKnowledgeSourcesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCompanyOutboundCampaignOutcomesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListConversationsArgs = {
  filter?: InputMaybe<SearchableConversationsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['ID']['input']>;
  sort?: InputMaybe<SortDirection>;
};


export type QueryListCoreKbDocumentsArgs = {
  kb_id: Scalars['ID']['input'];
};


export type QueryListCoreKbIntegrationSubscriptionsArgs = {
  kb_id: Scalars['ID']['input'];
};


export type QueryListCountriesArgs = {
  filter?: InputMaybe<ModelCountryFilterInput>;
};


export type QueryListCrawlDocumentsArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  crawlRootId?: InputMaybe<Scalars['Int']['input']>;
  documentStatus?: InputMaybe<DocumentStatus>;
  isLatest?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<DocumentSource>;
};


export type QueryListCrawlRootsArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  documentStatus?: InputMaybe<DocumentStatus>;
  isLatest?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<CrawlDocumentSortField>;
  source?: InputMaybe<DocumentSource>;
};


export type QueryListCrmContactListsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  integrationID: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListEvalRunsArgs = {
  applicationId: Scalars['String']['input'];
  personaId: Scalars['String']['input'];
};


export type QueryListGeneratedRealtimeQuestionAnsweringCardsArgs = {
  input: RealtimeQuestionAnsweringGeneratedCardListInput;
};


export type QueryListKbCrawlRootsArgs = {
  kb_id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListLoaEnvelopesArgs = {
  input?: InputMaybe<ListLoaEnvelopesInput>;
};


export type QueryListLongTailProposalsArgs = {
  registrationSessionId: Scalars['ID']['input'];
};


export type QueryListOutboundCampaignCallOutcomesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  campaignID: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListOutboundCampaignContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  campaignID: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListOutboundCampaignLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  campaignID: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListOutboundCampaignQueueItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  campaignID: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListOutboundCampaignUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  campaignID: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListOutboundCampaignsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OutboundCampaignsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<OutboundCampaignsScope>;
};


export type QueryListPortingRequestsArgs = {
  input?: InputMaybe<ListPortingRequestsInput>;
};


export type QueryListRealtimeQuestionAnsweringCardsArgs = {
  filter?: InputMaybe<RealtimeQuestionAnsweringCardFilterInput>;
};


export type QueryListRegionsArgs = {
  countryId: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  numberType: Scalars['String']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  previousRegionId?: InputMaybe<Scalars['String']['input']>;
  withStock?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryListRootChildrenArgs = {
  kb_id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  root_id: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListScenariosArgs = {
  virtualAgentID: Scalars['ID']['input'];
};


export type QueryListSessionMessagesArgs = {
  sessionId: Scalars['String']['input'];
};


export type QueryListSimulationRunsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  virtualAgentID: Scalars['ID']['input'];
};


export type QueryListSupervisionsArgs = {
  numberId: Scalars['ID']['input'];
};


export type QueryListTemplatesArgs = {
  input: ListTemplatesInput;
};


export type QueryListVirtualAgentsArgs = {
  callDirection?: InputMaybe<CallDirection>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListVoiceVirtualAgentActionsByAuthMethodArgs = {
  authMethodId: Scalars['ID']['input'];
};


export type QueryListVoiceVirtualAgentAuthMethodsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListVoicesArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListWhatsAppTemplatesArgs = {
  input: ListWhatsAppTemplatesInput;
};


export type QueryLiveMonitoringCallsArgs = {
  input: LiveMonitoringListInput;
};


export type QueryLiveMonitoringCampaignsArgs = {
  input?: InputMaybe<LiveMonitoringCampaignsInput>;
};


export type QueryLiveMonitoringCurrentUserKpIsArgs = {
  input?: InputMaybe<LiveMonitoringTimeFilterInput>;
};


export type QueryLiveMonitoringLinesArgs = {
  input: LiveMonitoringListInput;
};


export type QueryLiveMonitoringTopKpIsArgs = {
  input: LiveMonitoringMetricInput;
};


export type QueryLiveMonitoringTopMetricsArgs = {
  input: LiveMonitoringMetricInput;
};


export type QueryLiveMonitoringUserAvailabilitiesArgs = {
  input: LiveMonitoringMetricInput;
};


export type QueryLiveMonitoringUsersArgs = {
  input: LiveMonitoringListInput;
};


export type QueryLookupContactsArgs = {
  input: LookupContactsInput;
};


export type QueryLookupEnrolledNumbersArgs = {
  e164s: Array<Scalars['String']['input']>;
};


export type QueryLookupTeammatesArgs = {
  input: LookupTeammatesInput;
};


export type QueryMapUrlArgs = {
  input: MapUrlInput;
};


export type QueryMessageConversationsCountPerCategoryArgs = {
  filters?: InputMaybe<AircallWorkspaceConversationsCountPerCategoryFilters>;
};


export type QueryMessagingAiAgentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMessagingAiAgentUsedLinesArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryMessagingAiAgentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<MessagingAiSortOrder>;
  orderBy?: InputMaybe<MessagingAiAgentOrderBy>;
  searchCompanyId?: InputMaybe<Scalars['Int']['input']>;
  searchName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMessagingAiConversationStopStatusArgs = {
  companyId: Scalars['Int']['input'];
  externalId: Scalars['String']['input'];
  lineId: Scalars['Int']['input'];
};


export type QueryMessagingAiIsConversationEscalatedArgs = {
  companyId: Scalars['Int']['input'];
  externalId: Scalars['String']['input'];
  lineId: Scalars['Int']['input'];
};


export type QueryMessagingAiLineAllocatedHoursArgs = {
  lineId: Scalars['Int']['input'];
};


export type QueryMessagingAiPlaygroundMessagesArgs = {
  sessionId: Scalars['ID']['input'];
};


export type QueryMessagingAiSessionCountArgs = {
  yearMonth?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNumberDetailArgs = {
  id: Scalars['String']['input'];
};


export type QueryNumberIntegrationsArgs = {
  numberId: Scalars['Int']['input'];
};


export type QueryNumberSupervisionArgs = {
  id: Scalars['String']['input'];
};


export type QueryOauthCodeArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  responseType?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOauthCodeV2Args = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  responseType?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOutboundCampaignArgs = {
  ID: Scalars['ID']['input'];
};


export type QueryOutboundCampaignAvailabilityEstimateArgs = {
  campaignID: Scalars['ID']['input'];
};


export type QueryOutboundCampaignBackgroundJobArgs = {
  ID: Scalars['ID']['input'];
};


export type QueryOutboundCampaignContactArgs = {
  campaignID: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type QueryOutboundCampaignContactImportArgs = {
  ID: Scalars['ID']['input'];
};


export type QueryOutboundCampaignDuplicationPreviewArgs = {
  campaignID: Scalars['ID']['input'];
};


export type QueryOutboundCampaignOutcomeArgs = {
  ID: Scalars['ID']['input'];
};


export type QueryOutboundCampaignsFieldMappingArgs = {
  integrationID: Scalars['ID']['input'];
};


export type QueryOutboundEventByCallSidArgs = {
  callSid: Scalars['String']['input'];
};


export type QueryOutboundEventsArgs = {
  agentId: Scalars['ID']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPhoneCallArgs = {
  ID: Scalars['ID']['input'];
};


export type QueryPlaybookResultsArgs = {
  input: PlaybookResultsInput;
};


export type QueryPrerecordedMessageByCallSidArgs = {
  callSid: Scalars['String']['input'];
};


export type QueryPreviewActionArgs = {
  actionId: Scalars['ID']['input'];
};


export type QueryRealtimeQuestionAnsweringConfigurationArgs = {
  input?: InputMaybe<RealtimeQuestionAnsweringConfigurationInput>;
};


export type QueryRequestedFeaturesArgs = {
  featureName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryResendUserInvitationEmailArgs = {
  bodyBuilder?: InputMaybe<FunctionType>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchAgentsArgs = {
  filter?: InputMaybe<SearchableAgentsFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort?: InputMaybe<Array<InputMaybe<SearchableAgentsSortInput>>>;
};


export type QuerySearchAircallWorkspaceGroupConversationsArgs = {
  filters: SearchAircallWorkspaceGroupConversationsFilters;
  pageRequest?: InputMaybe<AircallWorkspaceConversationsPageRequest>;
};


export type QuerySearchAuthorizedLinesArgs = {
  filter?: InputMaybe<SearchableLinesFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort?: InputMaybe<Array<InputMaybe<SearchableLinesSortInput>>>;
};


export type QuerySearchAuthorizedTeamsArgs = {
  filter?: InputMaybe<SearchableTeamsFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort?: InputMaybe<Array<InputMaybe<SearchableTeamsSortInput>>>;
};


export type QuerySearchAuthorizedUsersArgs = {
  filter?: InputMaybe<SearchableAgentsFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort?: InputMaybe<Array<InputMaybe<SearchableAgentsSortInput>>>;
};


export type QuerySearchCallEngagementsArgs = {
  filters?: InputMaybe<CallEngagementsFilters>;
  pageRequest?: InputMaybe<AircallWorkspaceConversationsPageRequest>;
};


export type QuerySearchDefaultOwnersArgs = {
  integrationID: Scalars['ID']['input'];
  searchTerms: Scalars['String']['input'];
};


export type QuerySearchLinesArgs = {
  filter?: InputMaybe<SearchableLinesFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort?: InputMaybe<Array<InputMaybe<SearchableLinesSortInput>>>;
};


export type QuerySearchNumbersArgs = {
  filter?: InputMaybe<SearchableNumbersFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort?: InputMaybe<Array<InputMaybe<SearchableLinesSortInput>>>;
};


export type QuerySearchTeamsArgs = {
  filter?: InputMaybe<SearchableTeamsFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort?: InputMaybe<Array<InputMaybe<SearchableTeamsSortInput>>>;
};


export type QuerySearchUsersArgs = {
  filter?: InputMaybe<SearchableUsersFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort?: InputMaybe<Array<InputMaybe<SearchableUsersSortInput>>>;
};


export type QueryTasksArgs = {
  category?: InputMaybe<TaskCategory>;
  contexts?: InputMaybe<ClientContext>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTeammateByIdArgs = {
  input: TeammateByIdInput;
};


export type QueryTeammatesByIdsArgs = {
  input: TeammatesByIdsInput;
};


export type QueryTextToSpeechOptionsArgs = {
  locale: Scalars['String']['input'];
};


export type QueryTtsMessagesVoicesArgs = {
  input: TtsMessagesVoicesInput;
};


export type QueryUploadAudioFileArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  numberId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserLicensesArgs = {
  userId: Scalars['String']['input'];
};


export type QueryUserNumbersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};

export type QueryGetLocalisedContractArgs = {
  __typename?: 'QueryGetLocalisedContractArgs';
  country: Scalars['String']['output'];
  groupKeys: Array<Scalars['String']['output']>;
};

export type QueryGetRequirementsArgs = {
  __typename?: 'QueryGetRequirementsArgs';
  includeIdentity?: Maybe<Scalars['Boolean']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  numberUUID: Scalars['String']['output'];
};

export type QuestionBinaryAnswer = {
  answerGuide?: InputMaybe<Scalars['String']['input']>;
  points: Scalars['Float']['input'];
  value: BinaryAnswerValue;
};

export type QuestionBranch = {
  __typename?: 'QuestionBranch';
  nextQuestions?: Maybe<Array<NextQuestion>>;
  value: Scalars['String']['output'];
};

export type QuestionBranchInput = {
  nextQuestions?: InputMaybe<Array<NextQuestionInput>>;
  value: Scalars['String']['input'];
};

export type QuestionExtraction = {
  __typename?: 'QuestionExtraction';
  branches?: Maybe<Array<QuestionBranch>>;
  presetType?: Maybe<IntakePresetType>;
  question: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
};

export type QuestionExtractionInput = {
  branches?: InputMaybe<Array<QuestionBranchInput>>;
  presetType?: InputMaybe<IntakePresetType>;
  question: Scalars['String']['input'];
  required?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionQualityHelperGeneratedError = {
  __typename?: 'QuestionQualityHelperGeneratedError';
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QuestionQualityHelperGeneratedOutput = {
  __typename?: 'QuestionQualityHelperGeneratedOutput';
  data?: Maybe<QuestionQualityHelperGeneratedOutputData>;
  error?: Maybe<QuestionQualityHelperGeneratedError>;
  id: Scalars['ID']['output'];
};

export type QuestionQualityHelperGeneratedOutputData = {
  __typename?: 'QuestionQualityHelperGeneratedOutputData';
  isAcceptable: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  question: Scalars['String']['output'];
  rephrasedQuestion: Scalars['String']['output'];
};

export type QuestionQualityHelperInput = {
  id: Scalars['ID']['input'];
  language: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type QuestionRatingAnswer = {
  answerGuide?: InputMaybe<Scalars['String']['input']>;
  points: Scalars['Float']['input'];
  value: RatingAnswerValue;
};

export enum QuestionType {
  BINARY = 'BINARY',
  RATING = 'RATING'
}

export type QuestionValues = {
  createNumber?: InputMaybe<Scalars['Boolean']['input']>;
  integrationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  portNumber?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Questionnaire = {
  __typename?: 'Questionnaire';
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  status: QuestionnaireStatus;
  submittedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  submittedBy?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export enum QuestionnaireStatus {
  PENDING = 'PENDING',
  SUBMITTED = 'SUBMITTED'
}

export type RateLimitExceededException = Exception & {
  __typename?: 'RateLimitExceededException';
  code: Scalars['String']['output'];
  limit: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  resource: Scalars['String']['output'];
};

export type RatingAnswer = {
  __typename?: 'RatingAnswer';
  answerGuide?: Maybe<Scalars['String']['output']>;
  points: Scalars['Float']['output'];
  ratingValue: RatingAnswerValue;
};

export type RatingAnswerCount = {
  __typename?: 'RatingAnswerCount';
  count: Scalars['Int']['output'];
  ratingAnswer: RatingAnswerValue;
};

export enum RatingAnswerValue {
  EXCELLENT = 'EXCELLENT',
  FAIR = 'FAIR',
  GOOD = 'GOOD',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  POOR = 'POOR',
  VERY_POOR = 'VERY_POOR'
}

export type RatingEvaluationQuestion = {
  __typename?: 'RatingEvaluationQuestion';
  ID: Scalars['ID']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  predefinedAIQuestionId?: Maybe<Scalars['ID']['output']>;
  questionAiEnabled: Scalars['Boolean']['output'];
  questionOrder: Scalars['Int']['output'];
  questionPossibleAnswers: Array<RatingAnswer>;
  questionStrictness?: Maybe<Scalars['Int']['output']>;
  questionText: Scalars['String']['output'];
  ratingAnswer?: Maybe<RatingAnswerValue>;
  score: Score;
  scoreCardQuestionId?: Maybe<Scalars['ID']['output']>;
};

export type ReactivateWebhookOutput = {
  __typename?: 'ReactivateWebhookOutput';
  id: Scalars['String']['output'];
};

export type ReadConversationInput = {
  conversationID: Scalars['ID']['input'];
  messageID: Scalars['ID']['input'];
};

export type ReadConversationOutput = {
  __typename?: 'ReadConversationOutput';
  conversationID: Scalars['ID']['output'];
  error?: Maybe<Error>;
};

export type ReadCurrentUserConversationsByIdsInput = {
  conversationIDs: Array<Scalars['String']['input']>;
};

export type ReadCurrentUserConversationsByIdsResult = {
  __typename?: 'ReadCurrentUserConversationsByIdsResult';
  success: Scalars['Boolean']['output'];
};

export type ReadCurrentUserConversationsResult = {
  __typename?: 'ReadCurrentUserConversationsResult';
  success: Scalars['Boolean']['output'];
};

export type RealtimeQuestionAnsweringAssignmentInput = {
  cardIds: Array<Scalars['ID']['input']>;
  lineId: Scalars['ID']['input'];
};

export type RealtimeQuestionAnsweringCard = {
  __typename?: 'RealtimeQuestionAnsweringCard';
  aiGenerated: Scalars['Boolean']['output'];
  answer: Scalars['String']['output'];
  associatedConfigurations: Array<RealtimeQuestionAnsweringCardAssignmentLink>;
  category: RealtimeQuestionAnsweringCategory;
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  language: RealtimeQuestionAnsweringLanguage;
  metadata?: Maybe<RealtimeQuestionAnsweringCardMetadata>;
  question: Scalars['String']['output'];
  title: Scalars['String']['output'];
  triggeredBy?: Maybe<RealtimeQuestionAnsweringCardTrigger>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type RealtimeQuestionAnsweringCardAssignment = {
  __typename?: 'RealtimeQuestionAnsweringCardAssignment';
  items: Array<RealtimeQuestionAnsweringCard>;
};

export type RealtimeQuestionAnsweringCardAssignmentLink = {
  __typename?: 'RealtimeQuestionAnsweringCardAssignmentLink';
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  line: LineResolver;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type RealtimeQuestionAnsweringCardDeleteOutput = GenericException | InsufficientLicenseException | RealtimeQuestionAnsweringCardId | UserInputException;

export type RealtimeQuestionAnsweringCardFilterInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<RealtimeQuestionAnsweringLanguage>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  lineId?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['ID']['input']>;
};

export type RealtimeQuestionAnsweringCardId = {
  __typename?: 'RealtimeQuestionAnsweringCardId';
  id: Scalars['ID']['output'];
};

export type RealtimeQuestionAnsweringCardInput = {
  answer: Scalars['String']['input'];
  categoryId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  language: RealtimeQuestionAnsweringLanguage;
  metadata?: InputMaybe<RealtimeQuestionAnsweringCardMetadataInput>;
  question: Scalars['String']['input'];
  title: Scalars['String']['input'];
  triggeredBy?: InputMaybe<RealtimeQuestionAnsweringCardTrigger>;
};

export type RealtimeQuestionAnsweringCardLink = {
  __typename?: 'RealtimeQuestionAnsweringCardLink';
  text?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type RealtimeQuestionAnsweringCardLinkInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type RealtimeQuestionAnsweringCardList = {
  __typename?: 'RealtimeQuestionAnsweringCardList';
  items: Array<RealtimeQuestionAnsweringCard>;
  pageInfo: PagingInfo;
};

export type RealtimeQuestionAnsweringCardListOutput = GenericException | RealtimeQuestionAnsweringCardList | UserInputException;

export type RealtimeQuestionAnsweringCardMetadata = {
  __typename?: 'RealtimeQuestionAnsweringCardMetadata';
  links?: Maybe<Array<RealtimeQuestionAnsweringCardLink>>;
};

export type RealtimeQuestionAnsweringCardMetadataInput = {
  links?: InputMaybe<Array<RealtimeQuestionAnsweringCardLinkInput>>;
};

export type RealtimeQuestionAnsweringCardOutput = GenericException | InsufficientLicenseException | RealtimeQuestionAnsweringCard | UserInputException;

export enum RealtimeQuestionAnsweringCardTrigger {
  AGENT = 'AGENT',
  BOTH = 'BOTH',
  CONTACT = 'CONTACT'
}

export type RealtimeQuestionAnsweringCategory = {
  __typename?: 'RealtimeQuestionAnsweringCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type RealtimeQuestionAnsweringCategoryList = {
  __typename?: 'RealtimeQuestionAnsweringCategoryList';
  items: Array<RealtimeQuestionAnsweringCategory>;
};

export type RealtimeQuestionAnsweringCategoryListOutput = GenericException | RealtimeQuestionAnsweringCategoryList;

export type RealtimeQuestionAnsweringConfiguration = {
  __typename?: 'RealtimeQuestionAnsweringConfiguration';
  enabled: Scalars['Boolean']['output'];
};

export type RealtimeQuestionAnsweringConfigurationInput = {
  lineId: Scalars['ID']['input'];
};

export type RealtimeQuestionAnsweringConfigurationOutput = GenericException | RealtimeQuestionAnsweringConfiguration | UserInputException;

export type RealtimeQuestionAnsweringGeneratedCard = {
  __typename?: 'RealtimeQuestionAnsweringGeneratedCard';
  callUuid: Scalars['ID']['output'];
  card: RealtimeQuestionAnsweringCard;
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
};

export type RealtimeQuestionAnsweringGeneratedCardList = {
  __typename?: 'RealtimeQuestionAnsweringGeneratedCardList';
  items: Array<RealtimeQuestionAnsweringGeneratedCard>;
};

export type RealtimeQuestionAnsweringGeneratedCardListInput = {
  callUuid: Scalars['ID']['input'];
};

export type RealtimeQuestionAnsweringGeneratedCardListOutput = GenericException | RealtimeQuestionAnsweringGeneratedCardList | UserInputException;

export enum RealtimeQuestionAnsweringLanguage {
  BG = 'BG',
  CA = 'CA',
  CS = 'CS',
  DA = 'DA',
  DE = 'DE',
  EL = 'EL',
  EN = 'EN',
  ES = 'ES',
  FI = 'FI',
  FR = 'FR',
  HE = 'HE',
  HI = 'HI',
  HR = 'HR',
  HU = 'HU',
  IT = 'IT',
  JA = 'JA',
  KO = 'KO',
  MS = 'MS',
  NL = 'NL',
  NO = 'NO',
  PL = 'PL',
  PT = 'PT',
  RO = 'RO',
  RU = 'RU',
  SK = 'SK',
  SV = 'SV',
  TA = 'TA',
  TH = 'TH',
  TL = 'TL',
  TR = 'TR',
  UK = 'UK',
  VI = 'VI',
  ZH = 'ZH'
}

export type RealtimeQuestionAnsweringSetAssignmentInput = {
  assignments: Array<RealtimeQuestionAnsweringAssignmentInput>;
};

export type RealtimeQuestionAnsweringSetAssignmentOutput = GenericException | InsufficientLicenseException | RealtimeQuestionAnsweringCardAssignment | UserInputException;

export type ReconcileEsimInput = {
  agentId?: InputMaybe<Scalars['Int']['input']>;
  numberUUID: Scalars['String']['input'];
};

export type ReconcileEsimResponse = {
  __typename?: 'ReconcileEsimResponse';
  numberUUID: Scalars['String']['output'];
  outcome: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type RecordActionResourceInput = {
  action: Scalars['String']['input'];
  actionValue: Scalars['String']['input'];
  externalAccountId: Scalars['String']['input'];
  recordId: Scalars['String']['input'];
  recordType: Scalars['String']['input'];
};

export type RecordActionResourceOutput = {
  __typename?: 'RecordActionResourceOutput';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RecordSync = {
  __typename?: 'RecordSync';
  enabled: Scalars['Boolean']['output'];
  recordType: Scalars['String']['output'];
};

export type RecoverPasswordInput = {
  email: Scalars['String']['input'];
};

export type RecoverPasswordOutput = Forbidden | RecoverPasswordOutputResponse | Unauthorized;

export type RecoverPasswordOutputResponse = {
  __typename?: 'RecoverPasswordOutputResponse';
  isEmailToRecoverPasswordSent: Scalars['Boolean']['output'];
};

export enum RedactionCategory {
  pci = 'pci',
  phi = 'phi',
  pii = 'pii'
}

export type RedactionSettings = {
  __typename?: 'RedactionSettings';
  categories: Array<RedactionCategory>;
  enabledAt?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
};

export type RedactionSettingsInput = {
  categories: Array<RedactionCategory>;
  isEnabled: Scalars['Boolean']['input'];
};

export type RegenerateSfOmnichannelApiKeyOutput = {
  __typename?: 'RegenerateSFOmnichannelApiKeyOutput';
  apiKey: Scalars['String']['output'];
};

export type Region = {
  __typename?: 'Region';
  areaCode?: Maybe<Scalars['String']['output']>;
  capabilities?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  identityAlreadyExists?: Maybe<Scalars['Boolean']['output']>;
  isIdentityRequired: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  supportRequired: Scalars['Boolean']['output'];
};

export type RegionAttribute = {
  __typename?: 'RegionAttribute';
  areaCode?: Maybe<Scalars['String']['output']>;
  buyable: Scalars['Boolean']['output'];
  hasStock?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameTranslations?: Maybe<NameTranslations>;
  provider?: Maybe<Scalars['String']['output']>;
  state: Scalars['Boolean']['output'];
  stock?: Maybe<Array<RegionStock>>;
  supportRequired: Scalars['Boolean']['output'];
};

export type RegionOption = {
  __typename?: 'RegionOption';
  attributes: RegionAttribute;
  value: Scalars['String']['output'];
};

export type RegionStock = {
  __typename?: 'RegionStock';
  carrierUUID: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type Regions = {
  __typename?: 'Regions';
  isFinalStep: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  options: Array<RegionOption>;
};

export type RegisterLongTailApplicationInput = {
  proposalId: Scalars['ID']['input'];
  requestKey: Scalars['String']['input'];
};

export type RegisterLongTailApplicationOutput = GenericException | LongTailInvalidProposalStateException | LongTailProposalNotFoundException | LongTailRegistration | RegistrationSessionNotFoundException | ToolDefLintRejectedException | UserInputException;

export type RegisterPushDeviceInput = {
  devicePlatform: DevicePlatform;
  deviceUniqueToken: Scalars['String']['input'];
};

export type RegisterPushDeviceOutput = {
  __typename?: 'RegisterPushDeviceOutput';
  error?: Maybe<Error>;
};

export type RegisterWhatsAppNumberInput = {
  companyName: Scalars['String']['input'];
  companyPhoneNumberId: Scalars['String']['input'];
  companyWabaId: Scalars['String']['input'];
  numberUUID: Scalars['String']['input'];
};

export type RegisterWhatsAppNumberResponse = {
  __typename?: 'RegisterWhatsAppNumberResponse';
  numberUUID: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type RegistrationSessionNotFoundException = Exception & {
  __typename?: 'RegistrationSessionNotFoundException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  registrationSessionId: Scalars['ID']['output'];
};

export type RegularPhoneCall = PhoneCall & {
  __typename?: 'RegularPhoneCall';
  ID: Scalars['ID']['output'];
  archivedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  assigned?: Maybe<PhoneCallAssigned>;
  callUuid: Scalars['String']['output'];
  callee: PhoneCallCallee;
  caller: PhoneCallCaller;
  createdAt: Scalars['AWSDateTime']['output'];
  direction: PhoneCallDirection;
  duration: Scalars['Int']['output'];
  external: PhoneContactResolver;
  internalTags: Array<PhoneCallTag>;
  line: LineResolver;
  notes: Array<PhoneCallNote>;
  outboundCampaignAttempt?: Maybe<OutboundCampaignAttemptResolver>;
  proxiedAudioUrl?: Maybe<Scalars['String']['output']>;
  proxiedRecordingUrl?: Maybe<Scalars['String']['output']>;
  recordingDurationMs?: Maybe<Scalars['Int']['output']>;
  status: PhoneCallStatus;
  tags: Array<PhoneCallTag>;
  teammate?: Maybe<PhoneTeammateResolver>;
  timeline?: Maybe<PhoneCallTimelineResolver>;
  transcription?: Maybe<TranscriptionResolver>;
  type: PhoneCallType;
  voiceAgents?: Maybe<Array<VoiceAgentParticipant>>;
};

export type RejectDispatchOutput = {
  __typename?: 'RejectDispatchOutput';
  success: Scalars['Boolean']['output'];
};

export type RelayPageInfo = {
  __typename?: 'RelayPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ReleaseActivationWizardOutput = ActivationCapabilityDisabled | ActivationForbidden | ActivationRequestException | ActivationUnauthenticated | ActivationWizardLockConflict | ActivationWizardState | GenericException;

export type RelinkCoreKbDocumentInput = {
  new_knowledge_base_id: Scalars['ID']['input'];
};

export type RelinkCoreKbDocumentResult = {
  __typename?: 'RelinkCoreKBDocumentResult';
  document_id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  new_kb_mapping_id: Scalars['ID']['output'];
  new_knowledge_base_id: Scalars['ID']['output'];
  old_kb_mapping_id: Scalars['ID']['output'];
};

export type RelinkCoreKbDocumentUnionResult = GenericException | RelinkCoreKbDocumentResult;

export type RemoveBrandLogoResult = BrandedCallingException | GenericException | RemoveBrandLogoSuccess;

export type RemoveBrandLogoSuccess = {
  __typename?: 'RemoveBrandLogoSuccess';
  success: Scalars['Boolean']['output'];
};

export type RemoveConnectedIntegrationInput = {
  integrationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RemoveErrorDocumentsResult = {
  __typename?: 'RemoveErrorDocumentsResult';
  documents_deleted: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RemoveErrorDocumentsUnionResult = GenericException | RemoveErrorDocumentsResult;

export type RemoveLicensesInput = {
  licenseName: Scalars['String']['input'];
  numberOfLicenses: Scalars['Int']['input'];
  usersToUnassign?: InputMaybe<Array<LicenseUserInput>>;
};

export type RemoveLicensesOutput = {
  __typename?: 'RemoveLicensesOutput';
  error?: Maybe<Error>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveMonitoredNumbersInput = {
  numbers: Array<BusinessDraftNumberInput>;
};

export type RemoveMonitoredNumbersResult = GenericException | NumberReputationException | RemoveMonitoredNumbersSuccess;

export type RemoveMonitoredNumbersSuccess = {
  __typename?: 'RemoveMonitoredNumbersSuccess';
  success: Scalars['Boolean']['output'];
};

export type RemoveNumberFromIntegrationInput = {
  integrationIds: Array<Scalars['String']['input']>;
};

export type RemoveNumberFromIntegrationOutput = {
  __typename?: 'RemoveNumberFromIntegrationOutput';
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveOutboundCampaignContactImportRowsOutput = GenericException | OutboundCampaignContactImportRowsRemoved | ResourceNotFoundException;

export type RemoveOutboundCampaignQueueItemOutput = GenericException | OutboundCampaignQueueItemDeletePayload | ResourceNotFoundException | UnprocessableResourceException | UserInputException;

export type RemoveOutboundCampaignTeamOutput = GenericException | OutboundCampaign | OutboundCampaignTeamDeletePayload | ResourceNotFoundException | UserInputException;

export type RemoveOutboundCampaignTeamsInput = {
  teamIDs: Array<Scalars['ID']['input']>;
};

export type RemoveOutboundCampaignUserOutput = GenericException | OutboundCampaign | OutboundCampaignUserDeletePayload | ResourceNotFoundException | UserInputException;

export type RemoveOutboundCampaignUsersInput = {
  userIDs: Array<Scalars['ID']['input']>;
};

export type RenameDocumentInput = {
  title: Scalars['String']['input'];
};

export type RenameKbInput = {
  name: Scalars['String']['input'];
};

export type ReorderOutboundCampaignQueueItemInput = {
  direction: OutboundCampaignQueueItemMoveDirection;
  queueItemID: Scalars['ID']['input'];
};

export type ReorderOutboundCampaignQueueItemOutput = GenericException | OutboundCampaignQueueItem | ResourceNotFoundException | UserInputException;

export type ReputationNotificationStatus = {
  __typename?: 'ReputationNotificationStatus';
  muted: Scalars['Boolean']['output'];
};

export type ReputationNotificationStatusResult = GenericException | NumberReputationException | ReputationNotificationStatus;

export type RequestFeatureInput = {
  actionType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  totalAdminsSupervisorsCount?: InputMaybe<Scalars['Int']['input']>;
};

export type RequestFeatureOutput = {
  __typename?: 'RequestFeatureOutput';
  error?: Maybe<Error>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RequestOutboundCampaignContactImportFromCrmInput = {
  campaignID: Scalars['ID']['input'];
  contactListID: Scalars['ID']['input'];
  countryCode: Scalars['String']['input'];
  integrationID: Scalars['ID']['input'];
};

export type RequestOutboundCampaignContactImportFromCrmOutput = GenericException | OutboundCampaignContactImportFromCrmRequested | ResourceNotFoundException | UnprocessableResourceException | UserInputException;

export type RequestOutboundCampaignContactImportUploadInput = {
  campaignID: Scalars['ID']['input'];
  countryCode: Scalars['String']['input'];
  fieldMapping: OutboundCampaignFieldMappingInput;
  fileName: Scalars['String']['input'];
};

export type RequestOutboundCampaignContactImportUploadOutput = GenericException | OutboundCampaignContactImportUploadUrl | ResourceNotFoundException | UnprocessableResourceException | UserInputException;

export type RequestTargetApiKeyAuth = {
  header?: InputMaybe<RequestTargetApiKeyAuthOption>;
  query?: InputMaybe<RequestTargetApiKeyAuthOption>;
};

export type RequestTargetApiKeyAuthOption = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type RequestTargetAuth = {
  apiKey?: InputMaybe<RequestTargetApiKeyAuth>;
  basic?: InputMaybe<RequestTargetBasicAuth>;
  bearerToken?: InputMaybe<RequestTargetBearerTokenAuth>;
  oauth?: InputMaybe<RequestTargetOAuth>;
};

export type RequestTargetBasicAuth = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type RequestTargetBearerTokenAuth = {
  token: Scalars['String']['input'];
};

export type RequestTargetHeader = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type RequestTargetInput = {
  requestConfiguration: RequestTargetRequestConfiguration;
  responseConfiguration: RequestTargetResponseConfiguration;
};

export type RequestTargetOAuth = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  loginURL: Scalars['String']['input'];
  scope?: InputMaybe<Scalars['String']['input']>;
};

export type RequestTargetOutput = {
  __typename?: 'RequestTargetOutput';
  isValid: Scalars['Boolean']['output'];
  requestResponse: Scalars['String']['output'];
  statusCode: Scalars['Int']['output'];
  targetResponse?: Maybe<TargetResponse>;
};

export type RequestTargetRequestConfiguration = {
  GET?: InputMaybe<GetRequestTargetRequestConfiguration>;
  POST?: InputMaybe<PostRequestTargetRequestConfiguration>;
};

export type RequestTargetResponseConfiguration = {
  agent?: InputMaybe<RequestTargetResponseConfigurationItem>;
  dynamic?: InputMaybe<RequestTargetResponseConfigurationDynamicItem>;
  external?: InputMaybe<RequestTargetResponseConfigurationItem>;
  internal?: InputMaybe<RequestTargetResponseConfigurationItem>;
  team?: InputMaybe<RequestTargetResponseConfigurationItem>;
};

export type RequestTargetResponseConfigurationDynamicItem = {
  path: Scalars['String']['input'];
  typePath: Scalars['String']['input'];
};

export type RequestTargetResponseConfigurationItem = {
  path: Scalars['String']['input'];
};

export type RequestVerificationGsmDeviceInput = {
  channel?: InputMaybe<GsmVerificationChannel>;
  deviceId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type RequestVerificationGsmDeviceRequested = {
  __typename?: 'RequestVerificationGSMDeviceRequested';
  deviceId: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type RequestVerificationGsmDeviceResult = GenericException | RequestVerificationGsmDeviceRequested | UserInputException;

export type RequestedFeaturesOutput = {
  __typename?: 'RequestedFeaturesOutput';
  featureRequests: Array<FeatureRequestDetails>;
  id: Scalars['ID']['output'];
};

export type RequirementEntity = {
  __typename?: 'RequirementEntity';
  addressType: Scalars['String']['output'];
  carrierRequirementUUID?: Maybe<Scalars['String']['output']>;
  countryAlpha2?: Maybe<Scalars['String']['output']>;
  countryAlpha3?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  identityExists?: Maybe<Scalars['Boolean']['output']>;
  phoneType: Scalars['String']['output'];
  regionId?: Maybe<Scalars['Int']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
  subSections: Array<SubSection>;
  type: Scalars['String']['output'];
};

export type RequirementInput = {
  fields: Array<FieldInput>;
  subsectionId: Scalars['Int']['input'];
};

export type Requirements = {
  __typename?: 'Requirements';
  isIdentityRequired: Scalars['Boolean']['output'];
};

export type Reseller = {
  __typename?: 'Reseller';
  ID?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ResellerData = {
  __typename?: 'ResellerData';
  id: Scalars['String']['output'];
  relationships?: Maybe<CompanyRelationships>;
  type: Scalars['String']['output'];
};

export type ResellerResponse = {
  __typename?: 'ResellerResponse';
  data: ResellerData;
};

export type ResendCriticalActionInput = {
  action: Scalars['String']['input'];
  agentID: Scalars['ID']['input'];
  email: Scalars['String']['input'];
};

export type ResendEmailInvitationInput = {
  userId: Scalars['ID']['input'];
};

export type ResendEmailInvitationOutput = Forbidden | ResendEmailInvitationOutputResponse | Unauthorized;

export type ResendEmailInvitationOutputResponse = {
  __typename?: 'ResendEmailInvitationOutputResponse';
  isEmailInvitationSent: Scalars['Boolean']['output'];
};

export type ResendEventInput = {
  companyId: Scalars['String']['input'];
  dataFlow: Scalars['String']['input'];
  origin: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ResendEventOutput = {
  __typename?: 'ResendEventOutput';
  error?: Maybe<Error>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ResetPasswordMutationInput = {
  confirmationCode: Scalars['String']['input'];
  confirmationPassword: Scalars['String']['input'];
  email: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type ResetPasswordMutationResponse = {
  __typename?: 'ResetPasswordMutationResponse';
  message?: Maybe<Scalars['String']['output']>;
};

export type ResourceNotFoundException = Exception & {
  __typename?: 'ResourceNotFoundException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  resource?: Maybe<Scalars['String']['output']>;
};

export type ResourceOwnerPasswordConfig = {
  __typename?: 'ResourceOwnerPasswordConfig';
  credentialsConfigured: Scalars['Boolean']['output'];
  headerName: Scalars['String']['output'];
  prefix: Scalars['String']['output'];
  requestBodyTemplate: Scalars['String']['output'];
  tokenEndpoint: Scalars['String']['output'];
  tokenExpiresAt?: Maybe<Scalars['String']['output']>;
  tokenFieldPath: Scalars['String']['output'];
  tokenTtl: Scalars['Int']['output'];
};

export type ResourceOwnerPasswordConfigInput = {
  credentialFields: Scalars['String']['input'];
  headerName?: InputMaybe<Scalars['String']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  requestBodyTemplate: Scalars['String']['input'];
  tokenEndpoint: Scalars['String']['input'];
  tokenFieldPath: Scalars['String']['input'];
  tokenTtl: Scalars['Int']['input'];
};

export type ResourceRequested = {
  __typename?: 'ResourceRequested';
  ID?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ResponseOptions = OptionsResponse | ValidationResponse;

export type RestAuthorizedApplication = {
  __typename?: 'RestAuthorizedApplication';
  clientId: Scalars['String']['output'];
  logo: Scalars['String']['output'];
  name: Scalars['String']['output'];
  redirectUri: Scalars['String']['output'];
  responseType: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  source: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type RestCompanyAddress = {
  __typename?: 'RestCompanyAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type RestCompanyBilling = {
  __typename?: 'RestCompanyBilling';
  address?: Maybe<RestCompanyAddress>;
  billingPeriod: Scalars['String']['output'];
};

export type RestCurrencies = {
  __typename?: 'RestCurrencies';
  aud: Scalars['Int']['output'];
  eur: Scalars['Int']['output'];
  gbp: Scalars['Int']['output'];
  usd: Scalars['Int']['output'];
};

export type RestIntegration = {
  __typename?: 'RestIntegration';
  active: Scalars['Boolean']['output'];
  applicationId?: Maybe<Scalars['Int']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  configurations?: Maybe<BridgeIntegrationConfigurations>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customName?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  expiresAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nameUnderscored: Scalars['String']['output'];
  numberIds?: Maybe<Array<Scalars['Int']['output']>>;
  numbers?: Maybe<Array<UserNumber>>;
  numbersConnected?: Maybe<Scalars['Int']['output']>;
  service: Scalars['String']['output'];
  serviceName: Scalars['String']['output'];
  serviceNameUnderscored?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type RestSlackIntegrationCallbackData = {
  events: RestSlackIntegrationCallbackDataEvents;
  type: Scalars['String']['input'];
};

export type RestSlackIntegrationCallbackDataEvent = {
  isSelected: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type RestSlackIntegrationCallbackDataEvents = {
  events: Array<RestSlackIntegrationCallbackDataEvent>;
  section: Scalars['String']['input'];
};

export type RestSlackIntegrationInstallParams = {
  callback_data: RestSlackIntegrationCallbackData;
  callback_name: Scalars['String']['input'];
};

export type RestTtsVoiceRest = {
  __typename?: 'RestTtsVoiceRest';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RestWebhook = {
  __typename?: 'RestWebhook';
  allowedRetries: Scalars['Int']['output'];
  clientSecret?: Maybe<Scalars['String']['output']>;
  customName?: Maybe<Scalars['String']['output']>;
  events: Array<Scalars['String']['output']>;
  friendlyName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type RestoreLicensesInput = {
  licenseName: Scalars['String']['input'];
  numberOfLicenses: Scalars['Int']['input'];
  usersToRestore?: InputMaybe<Array<LicenseUserInput>>;
};

export type RestoreLicensesOutput = {
  __typename?: 'RestoreLicensesOutput';
  error?: Maybe<Error>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ResubmitBrandDocumentInput = {
  replacement: BrandDocumentInput;
};

export type ResubmitBrandDocumentResult = Brand | BrandedCallingException | GenericException;

export type ResumeOutboundCampaignOutput = GenericException | OutboundCampaign | ResourceNotFoundException;

export type RetryableException = Exception & {
  __typename?: 'RetryableException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ReverificationCampaign = {
  __typename?: 'ReverificationCampaign';
  carrierRequirementUUID: Scalars['String']['output'];
  countryAlpha2: Scalars['String']['output'];
  i18nKey: Scalars['String']['output'];
  numberUUID?: Maybe<Scalars['String']['output']>;
  regionName: Scalars['String']['output'];
  regionUUID?: Maybe<Scalars['String']['output']>;
  reverificationCampaignUUID: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type RevokeAdminMcpOauthGrantOutput = GenericException | ResourceNotFoundException | RevokeAdminMcpOauthGrantResult;

export type RevokeAdminMcpOauthGrantResult = {
  __typename?: 'RevokeAdminMcpOauthGrantResult';
  success: Scalars['Boolean']['output'];
};

export type Ringtone = {
  __typename?: 'Ringtone';
  friendlyName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Role = {
  __typename?: 'Role';
  ID: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RoleInput = {
  ID: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type SipSettingInput = {
  domain?: InputMaybe<Scalars['String']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  type: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export enum StsType {
  AIRCALL = 'AIRCALL',
  DEEPGRAM = 'DEEPGRAM',
  OPENAI = 'OPENAI',
  VOGENT = 'VOGENT'
}

export enum SttModel {
  FLUX_GENERAL_EN = 'FLUX_GENERAL_EN',
  INK_2 = 'INK_2',
  NOVA_2 = 'NOVA_2',
  NOVA_3 = 'NOVA_3',
  WHISPER_1 = 'WHISPER_1'
}

export enum SttProvider {
  CARTESIA = 'CARTESIA',
  DEEPGRAM = 'DEEPGRAM',
  OPENAI = 'OPENAI'
}

export type SalesforceVoiceEligibilityResult = SfvEligible | SfvIneligible;

export type SamlConfiguration = {
  __typename?: 'SamlConfiguration';
  jitEnabled: Scalars['Boolean']['output'];
  metadataFile?: Maybe<Scalars['String']['output']>;
  metadataUrl?: Maybe<Scalars['String']['output']>;
  providerName: Scalars['String']['output'];
  signoutEnabled: Scalars['Boolean']['output'];
  timestamp: Scalars['String']['output'];
};

export type SaveActivationCompanyContextInput = {
  context: ActivationCompanyContextInput;
};

export type SaveActivationCompanyContextOutput = ActivationCapabilityDisabled | ActivationCompanyContext | ActivationCompanyContextNotReady | ActivationForbidden | ActivationRequestException | ActivationUnauthenticated | GenericException | UserInputException;

export type SaveBinaryAnswer = {
  answerGuide?: InputMaybe<Scalars['String']['input']>;
  value: BinaryAnswerValue;
};

export type SaveCallConfigurationInput = {
  bitrate?: InputMaybe<Scalars['String']['input']>;
};

export type SaveCallConfigurationOutput = {
  __typename?: 'SaveCallConfigurationOutput';
  success: Scalars['Boolean']['output'];
};

export type SaveCompanyContextInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CompanyContextStatus>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type SaveCompanyContextOutput = CompanyContext | GenericException | UserInputException;

export type SaveCustomPlaybookInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  language: PlaybookLanguage;
  name: Scalars['String']['input'];
  topics: Array<TopicInput>;
};

export type SaveCustomPlaybookOutput = CustomPlaybook | GenericException | InsufficientLicenseException | PlaybookException | UserInputException;

export type SaveCustomSummaryInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  language: CustomSummaryLanguage;
  name: Scalars['String']['input'];
  templates: Array<SummaryTemplateInput>;
};

export type SaveCustomSummaryOutput = CustomSummary | CustomSummaryException | GenericException | InsufficientLicenseException | UserInputException;

export type SaveCustomSummaryResultInput = {
  id: Scalars['ID']['input'];
  templateResults: Array<SaveSummaryTemplateResultInput>;
};

export type SaveCustomSummaryResultOutput = CustomSummaryException | CustomSummaryResult | GenericException | InsufficientLicenseException | UserInputException;

export type SaveNetworkDiagnosticInput = {
  bandwidth?: InputMaybe<Scalars['Float']['input']>;
  device?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  isTurnRequired?: InputMaybe<Scalars['Boolean']['input']>;
  jitter?: InputMaybe<Scalars['Float']['input']>;
  mosScore?: InputMaybe<Scalars['Float']['input']>;
  networkType?: InputMaybe<NetworkType>;
  percentagePacketLoss?: InputMaybe<Scalars['Float']['input']>;
  percentageVolumeIn?: InputMaybe<Scalars['Float']['input']>;
  percentageVolumeOut?: InputMaybe<Scalars['Float']['input']>;
  protocol?: InputMaybe<NetworkProtocolType>;
  rtt?: InputMaybe<Scalars['Float']['input']>;
};

export type SaveNetworkDiagnosticOutput = {
  __typename?: 'SaveNetworkDiagnosticOutput';
  success: Scalars['Boolean']['output'];
};

export type SavePlaybookResultInput = {
  id: Scalars['ID']['input'];
  topicResults: Array<SaveTopicResultInput>;
};

export type SavePlaybookResultOutput = GenericException | InsufficientLicenseException | PlaybookException | PlaybookResult | UserInputException;

export type SavePortingFieldInput = {
  fieldRefId: Scalars['Int']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type SavePortingFieldsInput = {
  fields: Array<SavePortingFieldInput>;
  portingRequestUUID: Scalars['String']['input'];
};

export type SavePortingFieldsResponse = {
  __typename?: 'SavePortingFieldsResponse';
  savedFields: Array<SavedPortingField>;
  success: Scalars['Boolean']['output'];
};

export type SaveRatingAnswer = {
  answerGuide?: InputMaybe<Scalars['String']['input']>;
  value: RatingAnswerValue;
};

export type SaveResponseOptionBooleanInput = {
  value: Scalars['Boolean']['input'];
};

export type SaveResponseOptionStringInput = {
  value: Scalars['String']['input'];
};

export type SaveResponseOptionStringListInput = {
  value: Array<Scalars['String']['input']>;
};

export type SaveScoreCardCategory = {
  ID?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  questions?: InputMaybe<Array<SaveScoreCardQuestion>>;
};

export type SaveScoreCardInput = {
  ID?: InputMaybe<Scalars['ID']['input']>;
  categories?: InputMaybe<Array<SaveScoreCardCategory>>;
  description: Scalars['String']['input'];
  language: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sourceTemplateId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveScoreCardQuestion = {
  ID?: InputMaybe<Scalars['ID']['input']>;
  isAIEnabled: Scalars['Boolean']['input'];
  order: Scalars['Int']['input'];
  possibleBinaryAnswers?: InputMaybe<Array<SaveBinaryAnswer>>;
  possibleRatingAnswers?: InputMaybe<Array<SaveRatingAnswer>>;
  predefinedAIQuestionId?: InputMaybe<Scalars['ID']['input']>;
  strictness?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
  totalPoints: Scalars['Int']['input'];
};

export type SaveSummaryDiscoveryTemplateInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
};

export type SaveSummaryDiscoveryTemplateOutput = CustomSummaryException | GenericException | InsufficientLicenseException | SummaryTemplate | UserInputException;

export type SaveSummaryOptionsTemplateInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  options: Array<OptionsItemInput>;
  prompt: Scalars['String']['input'];
};

export type SaveSummaryOptionsTemplateOutput = CustomSummaryException | GenericException | InsufficientLicenseException | SummaryTemplate | UserInputException;

export type SaveSummaryTemplateResultInput = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type SaveSummaryValidationTemplateInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  options: Array<ValidationItemInput>;
  prompt: Scalars['String']['input'];
};

export type SaveSummaryValidationTemplateOutput = CustomSummaryException | GenericException | InsufficientLicenseException | SummaryTemplate | UserInputException;

export type SaveTopicInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  guidance: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  language: PlaybookLanguage;
  name: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
  responseOptionsBoolean?: InputMaybe<SaveResponseOptionBooleanInput>;
  responseOptionsString?: InputMaybe<SaveResponseOptionStringInput>;
  responseOptionsStringList?: InputMaybe<SaveResponseOptionStringListInput>;
  responseType: CustomPlaybookResponseType;
};

export type SaveTopicOutput = GenericException | InsufficientLicenseException | PlaybookException | Topic | UserInputException;

export type SaveTopicResultInput = {
  id: Scalars['ID']['input'];
  responseBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  responseList?: InputMaybe<Array<Scalars['String']['input']>>;
  responseString?: InputMaybe<Scalars['String']['input']>;
};

export type SaveVirtualAgentDraftInput = {
  agentId: Scalars['ID']['input'];
  aiActions?: InputMaybe<Array<AiActionInput>>;
  baseVersion?: InputMaybe<Scalars['Int']['input']>;
  callDirection?: InputMaybe<CallDirection>;
  capabilities?: InputMaybe<VirtualAgentCapabilitiesInput>;
  configOverride?: InputMaybe<ConfigOverrideInput>;
  customPrompt?: InputMaybe<Scalars['String']['input']>;
  customVoiceId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabledFlags?: InputMaybe<Array<AgentFlag>>;
  extractionTask: ExtractionTaskInput;
  farewellMessage?: InputMaybe<Scalars['String']['input']>;
  flowConfig?: InputMaybe<Scalars['String']['input']>;
  greetingMessage?: InputMaybe<Scalars['String']['input']>;
  knowledgeBase: VirtualAgentKnowledgeInput;
  outboundConfig?: InputMaybe<OutboundConfigInput>;
  personality: VirtualAgentPersonalityInput;
  retiredActionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  version?: InputMaybe<Scalars['Int']['input']>;
  vogentAgentId?: InputMaybe<Scalars['String']['input']>;
};

export type SaveVirtualAgentDraftOutput = ConflictException | GenericException | ResourceNotFoundException | UserInputException | VirtualAgentDraft;

export type SavedPortingField = {
  __typename?: 'SavedPortingField';
  fieldRefId: Scalars['Int']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type SavedScenario = {
  __typename?: 'SavedScenario';
  agentId: Scalars['ID']['output'];
  configJson: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type SavedScenarioList = {
  __typename?: 'SavedScenarioList';
  items: Array<SavedScenario>;
};

export type SavedScenarioListOutput = GenericException | ResourceNotFoundException | SavedScenarioList;

export type SavedScenarioOutput = GenericException | ResourceNotFoundException | SavedScenario;

export type SayCallbackRequestMessageLanguage = {
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type SayCallbackRequestMessageLanguageOutput = {
  __typename?: 'SayCallbackRequestMessageLanguageOutput';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SayCallbackRequestMessageVoice = {
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type SayCallbackRequestMessageVoiceOutput = {
  __typename?: 'SayCallbackRequestMessageVoiceOutput';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SayOutboundComplianceMessageLanguage = {
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type SayOutboundComplianceMessageLanguageOutput = {
  __typename?: 'SayOutboundComplianceMessageLanguageOutput';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SayOutboundComplianceMessageVoice = {
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type SayOutboundComplianceMessageVoiceOutput = {
  __typename?: 'SayOutboundComplianceMessageVoiceOutput';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Scenario = {
  __typename?: 'Scenario';
  agentType: EvalAgentType;
  applicationId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  expectedAction?: Maybe<Scalars['String']['output']>;
  personaId: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
  scenarioId: Scalars['ID']['output'];
  source: ScenarioSource;
  status: ScenarioStatus;
  updatedAt: Scalars['String']['output'];
};

export type ScenarioAttempt = {
  __typename?: 'ScenarioAttempt';
  attemptId: Scalars['ID']['output'];
  attemptNo: Scalars['Int']['output'];
  capturedOutcome?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  deterministicMetrics?: Maybe<Scalars['String']['output']>;
  diagnosis?: Maybe<Scalars['String']['output']>;
  fixApplied?: Maybe<Scalars['String']['output']>;
  llmVerdict?: Maybe<Scalars['String']['output']>;
  reply?: Maybe<Scalars['String']['output']>;
  studioTurnId?: Maybe<Scalars['String']['output']>;
  toolCallGrades?: Maybe<Scalars['String']['output']>;
  toolCalls?: Maybe<Scalars['String']['output']>;
};

export type ScenarioList = {
  __typename?: 'ScenarioList';
  scenarios: Array<Scenario>;
};

export type ScenarioResult = {
  __typename?: 'ScenarioResult';
  agentType: EvalAgentType;
  attempts: Array<ScenarioAttempt>;
  createdAt: Scalars['String']['output'];
  evidenceRef?: Maybe<Scalars['String']['output']>;
  finalOutcome?: Maybe<Scalars['String']['output']>;
  finalReply?: Maybe<Scalars['String']['output']>;
  finalToolCalls?: Maybe<Scalars['String']['output']>;
  fixCategories?: Maybe<Scalars['String']['output']>;
  llmVerdict?: Maybe<Scalars['String']['output']>;
  operatorVerdict?: Maybe<Scalars['String']['output']>;
  resultId: Scalars['ID']['output'];
  scenarioId: Scalars['String']['output'];
  status: ScenarioResultStatus;
  updatedAt: Scalars['String']['output'];
};

export enum ScenarioResultStatus {
  FAILED = 'FAILED',
  INCOMPLETE = 'INCOMPLETE',
  PASSED = 'PASSED',
  UNVERIFIED = 'UNVERIFIED'
}

export enum ScenarioSource {
  LLM = 'LLM',
  USER = 'USER'
}

export enum ScenarioStatus {
  ACCEPTED = 'ACCEPTED',
  PROPOSED = 'PROPOSED'
}

export type ScheduleGsmCallInput = {
  deviceId: Scalars['String']['input'];
  fromPhoneNumber: Scalars['String']['input'];
  toPhoneNumber: Scalars['String']['input'];
};

export type ScheduleGsmCallOutput = GenericException | ResourceNotFoundException | ScheduledGsmCall | UserInputException;

export type ScheduleOutboundCampaignQueueItemInput = {
  queueItemID: Scalars['ID']['input'];
  scheduledAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type ScheduleOutboundCampaignQueueItemOutput = GenericException | OutboundCampaignQueueItem | ResourceNotFoundException | UserInputException;

export type ScheduledContract = {
  __typename?: 'ScheduledContract';
  billingPeriodEndsAt?: Maybe<Scalars['String']['output']>;
  billingPeriodStartsAt: Scalars['String']['output'];
  cancellationCondition?: Maybe<Scalars['String']['output']>;
  cancellationDate?: Maybe<Scalars['String']['output']>;
  cancellationRequestDate?: Maybe<Scalars['String']['output']>;
  cancellationStatus?: Maybe<Scalars['String']['output']>;
  churnRequestDate?: Maybe<Scalars['String']['output']>;
  contractId: Scalars['String']['output'];
};

export type ScheduledGsmCall = {
  __typename?: 'ScheduledGsmCall';
  callSid: Scalars['String']['output'];
  dispatchId: Scalars['String']['output'];
};

export type Score = {
  __typename?: 'Score';
  normalizedScore: Scalars['Float']['output'];
  scorePoints: Scalars['Float']['output'];
  totalPoints: Scalars['Int']['output'];
};

export type ScoreCard = {
  __typename?: 'ScoreCard';
  ID: Scalars['ID']['output'];
  categories: Array<ScoreCardCategory>;
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  isPublished: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  name: Scalars['String']['output'];
  scoreCardAggregates?: Maybe<ScoreCardAggregates>;
  sourceTemplateId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
};

export type ScoreCardAggregates = {
  __typename?: 'ScoreCardAggregates';
  automationsCount?: Maybe<Scalars['Int']['output']>;
  currentMonthEvaluationsAvgScore?: Maybe<Scalars['Float']['output']>;
  reviewedEvaluationsCount?: Maybe<Scalars['Int']['output']>;
  totalEvaluationsCount?: Maybe<Scalars['Int']['output']>;
};

export type ScoreCardBinaryQuestion = {
  __typename?: 'ScoreCardBinaryQuestion';
  ID: Scalars['ID']['output'];
  isAIEnabled: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  possibleAnswers: Array<BinaryAnswer>;
  predefinedAIQuestionId?: Maybe<Scalars['ID']['output']>;
  strictness?: Maybe<Scalars['Int']['output']>;
  text: Scalars['String']['output'];
  totalPoints: Scalars['Int']['output'];
};

export type ScoreCardCategory = {
  __typename?: 'ScoreCardCategory';
  ID: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  questions: Array<ScoreCardQuestion>;
};

export type ScoreCardId = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type ScoreCardOutput = GenericException | InsufficientLicenseException | InvalidScoreCardName | ResourceNotFoundException | ScoreCard | UserInputException;

export type ScoreCardQuestion = ScoreCardBinaryQuestion | ScoreCardRatingQuestion;

export type ScoreCardRatingQuestion = {
  __typename?: 'ScoreCardRatingQuestion';
  ID: Scalars['ID']['output'];
  isAIEnabled: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  possibleAnswers: Array<RatingAnswer>;
  predefinedAIQuestionId?: Maybe<Scalars['ID']['output']>;
  strictness?: Maybe<Scalars['Int']['output']>;
  text: Scalars['String']['output'];
  totalPoints: Scalars['Int']['output'];
};

export type ScorecardTemplate = {
  __typename?: 'ScorecardTemplate';
  categories: Array<ScorecardTemplateCategory>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  language: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ScorecardTemplateCategory = {
  __typename?: 'ScorecardTemplateCategory';
  name: Scalars['String']['output'];
  questions: Array<ScorecardTemplateQuestion>;
};

export type ScorecardTemplateQuestion = {
  __typename?: 'ScorecardTemplateQuestion';
  order: Scalars['Int']['output'];
  question: PredefinedAiQuestion;
  totalPoints: Scalars['Int']['output'];
};

export type ScorecardTemplates = {
  __typename?: 'ScorecardTemplates';
  items: Array<ScorecardTemplate>;
};

export type ScvIntegrationSettings = {
  __typename?: 'ScvIntegrationSettings';
  instanceUrl: Scalars['String']['output'];
  integrationId: Scalars['ID']['output'];
  sections: Scalars['String']['output'];
};

export type SearchAgent = {
  __typename?: 'SearchAgent';
  ID: Scalars['ID']['output'];
  businessHours: Array<Maybe<SearchBusinessHour>>;
  companyID: Scalars['Int']['output'];
  confirmationSentAt?: Maybe<Scalars['String']['output']>;
  confirmedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currentSignInAt?: Maybe<Scalars['String']['output']>;
  currentSignInIp?: Maybe<Scalars['String']['output']>;
  customPrice?: Maybe<Scalars['Int']['output']>;
  customTwilioEdge?: Maybe<Scalars['String']['output']>;
  customTwilioJitterBufferSize?: Maybe<Scalars['String']['output']>;
  customTwilioRegion?: Maybe<Scalars['String']['output']>;
  defaultOutNumberID?: Maybe<Scalars['Int']['output']>;
  defaultPrefix?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  failedAttempts?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  invitationAcceptedAt?: Maybe<Scalars['String']['output']>;
  invitationCreatedAt?: Maybe<Scalars['String']['output']>;
  invitationLimit?: Maybe<Scalars['String']['output']>;
  invitationSentAt?: Maybe<Scalars['String']['output']>;
  invitedByID?: Maybe<Scalars['String']['output']>;
  invitedByType?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  isAvailable?: Maybe<Scalars['Boolean']['output']>;
  isOnboardedForTeamsInNumbers?: Maybe<Scalars['Boolean']['output']>;
  isOnboardedOnApp?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastSignInAt?: Maybe<Scalars['String']['output']>;
  lastSignInIp?: Maybe<Scalars['String']['output']>;
  linesIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  lockedAt?: Maybe<Scalars['String']['output']>;
  markedForDeletion?: Maybe<Scalars['Boolean']['output']>;
  migratedOnAuthenticationManager?: Maybe<Scalars['Boolean']['output']>;
  onboardingStep?: Maybe<Scalars['Int']['output']>;
  phoneNumbersCount?: Maybe<Scalars['Int']['output']>;
  pictureURL?: Maybe<Scalars['String']['output']>;
  rememberCreatedAt?: Maybe<Scalars['String']['output']>;
  resetPasswordSentAt?: Maybe<Scalars['String']['output']>;
  ringTimeout?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  signInCount?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  teamsIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  timeZone?: Maybe<Scalars['String']['output']>;
  unavailableUntil?: Maybe<Scalars['String']['output']>;
  unconfirmedEmail?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  useAircallPhonenumberAsCallerid?: Maybe<Scalars['Boolean']['output']>;
  useMobileIncomingCalls?: Maybe<Scalars['Boolean']['output']>;
  wrapUpTime?: Maybe<Scalars['Int']['output']>;
};

export type SearchAircallWorkspaceGroupConversationsFilters = {
  fromDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  lineIDs?: InputMaybe<IdFilter>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type SearchBusinessHour = {
  __typename?: 'SearchBusinessHour';
  available_id: Scalars['Int']['output'];
  closing: Scalars['Int']['output'];
  end_day: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  opening: Scalars['Int']['output'];
  start_day: Scalars['Int']['output'];
};

export type SearchLine = {
  __typename?: 'SearchLine';
  ID: Scalars['ID']['output'];
  activationState?: Maybe<Scalars['Int']['output']>;
  activationStatus?: Maybe<Scalars['String']['output']>;
  afterHoursMessage?: Maybe<Scalars['String']['output']>;
  afterHoursVoicemail?: Maybe<Scalars['Boolean']['output']>;
  agentsCounter?: Maybe<Scalars['Int']['output']>;
  allowInboundRecordingActions?: Maybe<Scalars['Boolean']['output']>;
  allowOutboundRecordingActions?: Maybe<Scalars['Boolean']['output']>;
  allowRealtimeTranscription?: Maybe<Scalars['Boolean']['output']>;
  businessHours?: Maybe<Array<Maybe<SearchBusinessHour>>>;
  callBackLaterMessage?: Maybe<Scalars['String']['output']>;
  capabilities?: Maybe<Scalars['String']['output']>;
  closeMessageEnabled?: Maybe<Scalars['Boolean']['output']>;
  closedMessage?: Maybe<Scalars['String']['output']>;
  closedStrategy?: Maybe<Scalars['String']['output']>;
  companyID?: Maybe<Scalars['Int']['output']>;
  concurrentRedirections?: Maybe<Scalars['Boolean']['output']>;
  countryISOCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customPrice?: Maybe<Scalars['Int']['output']>;
  customQueuingTimeout?: Maybe<Scalars['Int']['output']>;
  flowEditorEnabled?: Maybe<Scalars['Boolean']['output']>;
  hasAddress?: Maybe<Scalars['Boolean']['output']>;
  hasRedirectionsToTeams?: Maybe<Scalars['Boolean']['output']>;
  inboundRecordingActivatedAt?: Maybe<Scalars['String']['output']>;
  isIVR?: Maybe<Scalars['Boolean']['output']>;
  isIVRChild?: Maybe<Scalars['Boolean']['output']>;
  ivrMessage?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  liveRecordingActivatedAt?: Maybe<Scalars['String']['output']>;
  mandatoryTaggingActivatedAt?: Maybe<Scalars['String']['output']>;
  missedCallMessage?: Maybe<Scalars['String']['output']>;
  missedCallVoicemail?: Maybe<Scalars['Boolean']['output']>;
  musicOnHold?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberUUID?: Maybe<Scalars['String']['output']>;
  openedStrategy?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  outboundRecordingActivatedAt?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  providerID?: Maybe<Scalars['String']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  queueCallbackActivatedAt?: Maybe<Scalars['String']['output']>;
  queuingActivatedAt?: Maybe<Scalars['String']['output']>;
  redirectionStrategy?: Maybe<Scalars['String']['output']>;
  respectQueueingTime?: Maybe<Scalars['Boolean']['output']>;
  ringingTone?: Maybe<Scalars['String']['output']>;
  smsEnabled?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  timeout?: Maybe<Scalars['Int']['output']>;
  timeoutStrategy?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  useMainIVRNumberOnCallback?: Maybe<Scalars['Boolean']['output']>;
  verificationState?: Maybe<Scalars['Int']['output']>;
  voicemailMessage?: Maybe<Scalars['String']['output']>;
  waitingMusic?: Maybe<Scalars['String']['output']>;
  waitingMusicEnabled?: Maybe<Scalars['Boolean']['output']>;
  welcomeMessage?: Maybe<Scalars['String']['output']>;
  welcomeMessageContent?: Maybe<Scalars['String']['output']>;
  welcomeMessageEnabled?: Maybe<Scalars['Boolean']['output']>;
  welcomeMessageLocked?: Maybe<Scalars['Boolean']['output']>;
};

export type SearchTeam = {
  __typename?: 'SearchTeam';
  ID: Scalars['ID']['output'];
  agentsCounter?: Maybe<Scalars['Int']['output']>;
  agentsIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  companyID?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  imageName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type SearchableAgentsConnection = {
  __typename?: 'SearchableAgentsConnection';
  items?: Maybe<Array<AgentV2>>;
  nextToken?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  previousToken?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  total: Scalars['Int']['output'];
};

export type SearchableAgentsFilterInput = {
  ID?: InputMaybe<SearchableIntInput>;
  and?: InputMaybe<Array<InputMaybe<SearchableAgentsFilterInput>>>;
  assignedLicenses?: InputMaybe<SearchableUserLicensesInput>;
  availability?: InputMaybe<SearchableStringInput>;
  createdAt?: InputMaybe<SearchableStringInput>;
  email?: InputMaybe<SearchableStringInput>;
  extension?: InputMaybe<SearchableStringInput>;
  firstName?: InputMaybe<SearchableStringInput>;
  fullName?: InputMaybe<SearchableStringInput>;
  isActive?: InputMaybe<SearchableBooleanInput>;
  isAvailable?: InputMaybe<SearchableBooleanInput>;
  lastName?: InputMaybe<SearchableStringInput>;
  not?: InputMaybe<SearchableAgentsFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableAgentsFilterInput>>>;
  pictureURL?: InputMaybe<SearchableStringInput>;
  role?: InputMaybe<SearchableAgentsRoleInput>;
  roles?: InputMaybe<SearchableStringInput>;
  state?: InputMaybe<SearchableAgentsStateInput>;
  teamsIds?: InputMaybe<SearchableStringInput>;
  timeZone?: InputMaybe<SearchableStringInput>;
};

export type SearchableAgentsRoleInput = {
  eq?: InputMaybe<AgentRole>;
  ne?: InputMaybe<AgentRole>;
};

export type SearchableAgentsSortInput = {
  direction: SearchableSortDirection;
  field: SearchableAgentsSortableFields;
};

export enum SearchableAgentsSortableFields {
  ID = 'ID',
  availability = 'availability',
  createdAt = 'createdAt',
  email = 'email',
  extension = 'extension',
  firstName = 'firstName',
  isActive = 'isActive',
  isAvailable = 'isAvailable',
  lastName = 'lastName',
  pictureURL = 'pictureURL',
  role = 'role',
  state = 'state',
  timeZone = 'timeZone'
}

export type SearchableAgentsStateInput = {
  eq?: InputMaybe<AgentState>;
  ne?: InputMaybe<AgentState>;
};

export type SearchableAircallWorkspaceConversationLabelsInput = {
  eq?: InputMaybe<AircallWorkspaceConversationLabels>;
  in?: InputMaybe<Array<AircallWorkspaceConversationLabels>>;
};

export type SearchableAircallWorkspaceConversationStatusInput = {
  eq?: InputMaybe<AircallWorkspaceConversationStatus>;
  in?: InputMaybe<Array<AircallWorkspaceConversationStatus>>;
};

export type SearchableBooleanInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchableConversationsFilterInput = {
  and?: InputMaybe<Array<InputMaybe<SearchableConversationsFilterInput>>>;
  externalLine?: InputMaybe<SearchableExternalLinesFilterInput>;
  line?: InputMaybe<SearchableLinesFilterInput>;
  markAsDone?: InputMaybe<SearchableBooleanInput>;
  unread?: InputMaybe<SearchableBooleanInput>;
  updatedAt?: InputMaybe<SearchableStringInput>;
};

export type SearchableExternalLinesFilterInput = {
  and?: InputMaybe<Array<InputMaybe<SearchableExternalLinesFilterInput>>>;
  phoneNumber?: InputMaybe<SearchableStringInput>;
};

export type SearchableIntInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type SearchableLinesConnection = {
  __typename?: 'SearchableLinesConnection';
  items?: Maybe<Array<Line>>;
  nextToken?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  previousToken?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  total: Scalars['Int']['output'];
};

export type SearchableLinesFilterInput = {
  ID?: InputMaybe<SearchableIntInput>;
  activationState?: InputMaybe<SearchableStringInput>;
  agentsCounter?: InputMaybe<SearchableIntInput>;
  and?: InputMaybe<Array<InputMaybe<SearchableLinesFilterInput>>>;
  capabilities?: InputMaybe<SearchableStringInput>;
  countryISOCode?: InputMaybe<SearchableStringInput>;
  createdAt?: InputMaybe<SearchableStringInput>;
  flowEditorEnabled?: InputMaybe<SearchableBooleanInput>;
  isIVR?: InputMaybe<SearchableBooleanInput>;
  isOpen?: InputMaybe<SearchableBooleanInput>;
  language?: InputMaybe<SearchableStringInput>;
  name?: InputMaybe<SearchableStringInput>;
  not?: InputMaybe<SearchableLinesFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableLinesFilterInput>>>;
  phoneNumber?: InputMaybe<SearchableStringInput>;
  provider?: InputMaybe<SearchableStringInput>;
  state?: InputMaybe<SearchableLinesStateInput>;
  status?: InputMaybe<Array<LineStatus>>;
  types?: InputMaybe<SearchableStringInput>;
  verificationState?: InputMaybe<SearchableLinesVerificationStateInput>;
};

export type SearchableLinesSortInput = {
  direction: SearchableSortDirection;
  field: SearchableLinesSortableFields;
};

export enum SearchableLinesSortableFields {
  ID = 'ID',
  activationState = 'activationState',
  agentsCounter = 'agentsCounter',
  capabilities = 'capabilities',
  countryISOCode = 'countryISOCode',
  createdAt = 'createdAt',
  flowEditorEnabled = 'flowEditorEnabled',
  isIVR = 'isIVR',
  isOpen = 'isOpen',
  language = 'language',
  name = 'name',
  phoneNumber = 'phoneNumber',
  provider = 'provider',
  state = 'state',
  status = 'status',
  verificationState = 'verificationState'
}

export type SearchableLinesStateInput = {
  eq?: InputMaybe<LineState>;
  ne?: InputMaybe<LineState>;
};

export type SearchableLinesVerificationStateInput = {
  eq?: InputMaybe<LineVerificationState>;
  ne?: InputMaybe<LineVerificationState>;
};

export type SearchableNumbersConnection = {
  __typename?: 'SearchableNumbersConnection';
  items?: Maybe<Array<Line>>;
  nextToken?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  previousToken?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  total: Scalars['Int']['output'];
};

export type SearchableNumbersFilterInput = {
  ID?: InputMaybe<SearchableIntInput>;
  activationState?: InputMaybe<SearchableStringInput>;
  agentsCounter?: InputMaybe<SearchableIntInput>;
  and?: InputMaybe<Array<InputMaybe<SearchableNumbersFilterInput>>>;
  capabilities?: InputMaybe<SearchableStringInput>;
  companyID?: InputMaybe<SearchableIntInput>;
  countryISOCode?: InputMaybe<SearchableStringInput>;
  createdAt?: InputMaybe<SearchableStringInput>;
  flowEditorEnabled?: InputMaybe<SearchableBooleanInput>;
  isIVR?: InputMaybe<SearchableBooleanInput>;
  isOpen?: InputMaybe<SearchableBooleanInput>;
  language?: InputMaybe<SearchableStringInput>;
  name?: InputMaybe<SearchableStringInput>;
  not?: InputMaybe<SearchableNumbersFilterInput>;
  numberUUID?: InputMaybe<SearchableStringInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableNumbersFilterInput>>>;
  phoneNumber?: InputMaybe<SearchableStringInput>;
  provider?: InputMaybe<SearchableStringInput>;
  state?: InputMaybe<SearchableLinesStateInput>;
  status?: InputMaybe<Array<LineStatus>>;
  types?: InputMaybe<SearchableStringInput>;
  verificationState?: InputMaybe<SearchableLinesVerificationStateInput>;
};

export enum SearchableSortDirection {
  asc = 'asc',
  desc = 'desc'
}

export type SearchableStringInput = {
  eq?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  match?: InputMaybe<Scalars['String']['input']>;
  matchPhrase?: InputMaybe<Scalars['String']['input']>;
  matchPhrasePrefix?: InputMaybe<Scalars['String']['input']>;
  multiMatch?: InputMaybe<MutiMatchQueryInput>;
  ne?: InputMaybe<Scalars['String']['input']>;
  range?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regexp?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  wildcard?: InputMaybe<Scalars['String']['input']>;
};

export type SearchableTeamsConnection = {
  __typename?: 'SearchableTeamsConnection';
  items?: Maybe<Array<Team>>;
  nextToken?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  previousToken?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  total: Scalars['Int']['output'];
};

export type SearchableTeamsFilterInput = {
  ID?: InputMaybe<SearchableIntInput>;
  agentsCounter?: InputMaybe<SearchableIntInput>;
  and?: InputMaybe<Array<InputMaybe<SearchableTeamsFilterInput>>>;
  createdAt?: InputMaybe<SearchableStringInput>;
  imageName?: InputMaybe<SearchableStringInput>;
  name?: InputMaybe<SearchableStringInput>;
  not?: InputMaybe<SearchableTeamsFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableTeamsFilterInput>>>;
  updatedAt?: InputMaybe<SearchableStringInput>;
};

export type SearchableTeamsSortInput = {
  direction: SearchableSortDirection;
  field: SearchableTeamsSortableFields;
};

export enum SearchableTeamsSortableFields {
  ID = 'ID',
  agentsCounter = 'agentsCounter',
  createdAt = 'createdAt',
  imageName = 'imageName',
  name = 'name',
  updatedAt = 'updatedAt'
}

export type SearchableUser = {
  __typename?: 'SearchableUser';
  ID: Scalars['ID']['output'];
  companyID: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  invitedByID?: Maybe<Scalars['Int']['output']>;
  isActive: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  lastSignInAt?: Maybe<Scalars['String']['output']>;
  role: AgentRole;
  roles?: Maybe<Scalars['String']['output']>;
};

export type SearchableUserLicensesInput = {
  match?: InputMaybe<Scalars['String']['input']>;
  matchPhrase?: InputMaybe<Scalars['String']['input']>;
};

export type SearchableUsersConnection = {
  __typename?: 'SearchableUsersConnection';
  items: Array<SearchableUser>;
  nextToken?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  previousToken?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  total: Scalars['Int']['output'];
};

export type SearchableUsersFilterInput = {
  ID?: InputMaybe<SearchableIntInput>;
  and?: InputMaybe<Array<InputMaybe<SearchableUsersFilterInput>>>;
  companyID?: InputMaybe<SearchableIntInput>;
  createdAt?: InputMaybe<SearchableStringInput>;
  firstName?: InputMaybe<SearchableStringInput>;
  fullName?: InputMaybe<SearchableStringInput>;
  isActive?: InputMaybe<SearchableBooleanInput>;
  lastName?: InputMaybe<SearchableStringInput>;
  lastSignInAt?: InputMaybe<SearchableStringInput>;
  not?: InputMaybe<SearchableUsersFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableUsersFilterInput>>>;
  role?: InputMaybe<SearchableAgentsRoleInput>;
  roles?: InputMaybe<SearchableStringInput>;
};

export type SearchableUsersSortInput = {
  direction: SearchableSortDirection;
  field: SearchableUsersSortableFields;
};

export enum SearchableUsersSortableFields {
  ID = 'ID',
  createdAt = 'createdAt',
  firstName = 'firstName',
  fullName = 'fullName',
  isActive = 'isActive',
  lastName = 'lastName',
  lastSignInAt = 'lastSignInAt'
}

export type SecretApiOutput = {
  __typename?: 'SecretAPIOutput';
  companyId: Scalars['ID']['output'];
  lineID: Scalars['ID']['output'];
  secrets?: Maybe<Scalars['String']['output']>;
};

export type SecretDetectedException = Exception & {
  __typename?: 'SecretDetectedException';
  code: Scalars['String']['output'];
  findingsCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

export type Section = {
  __typename?: 'Section';
  banner?: Maybe<Banner>;
  computedOn?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<SectionCustomFields>;
  customOutcome?: Maybe<IntegrationSettingsCustomOutcomeEntity>;
  customSentiment?: Maybe<IntegrationSettingsCustomOutcomeEntity>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  missedCallTicketOwner?: Maybe<MissedCallTicketOwner>;
  settingSchema?: Maybe<SettingsField>;
  settings: Array<SettingsField>;
  subtitle?: Maybe<Scalars['String']['output']>;
  subtitleIcon?: Maybe<Scalars['String']['output']>;
  tipBar?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type SectionCustomField = {
  __typename?: 'SectionCustomField';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  values: Array<Maybe<SectionCustomFieldValue>>;
};

export type SectionCustomFieldValue = {
  __typename?: 'SectionCustomFieldValue';
  dataType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  selected?: Maybe<Scalars['Boolean']['output']>;
  translatedLabel: Scalars['String']['output'];
};

export type SectionCustomFields = {
  __typename?: 'SectionCustomFields';
  fields: Array<Maybe<SectionCustomField>>;
  key: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type SectionEvents = {
  __typename?: 'SectionEvents';
  aiVoiceAgent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  analytics?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  call?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  contact?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  conversationIntelligence?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  message?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  number?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  user?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SectionInput = {
  banner?: InputMaybe<BannerInput>;
  computedOn?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  settingSchema?: InputMaybe<SettingsFieldInput>;
  settings: Array<SettingsFieldInput>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  subtitleIcon?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type SelectValue = {
  __typename?: 'SelectValue';
  default?: Maybe<Scalars['Boolean']['output']>;
  dependsOn?: Maybe<Array<Maybe<SettingsDependency>>>;
  fields?: Maybe<Array<SettingsField>>;
  label?: Maybe<Scalars['String']['output']>;
  selected?: Maybe<Scalars['Boolean']['output']>;
  selectionOrder?: Maybe<Scalars['Int']['output']>;
  translatedLabel?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<SelectValue>>;
};

export type SelectValueInput = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  dependsOn?: InputMaybe<Array<InputMaybe<SettingsDependencyInput>>>;
  fields?: InputMaybe<Array<SettingsFieldInput>>;
  label?: InputMaybe<Scalars['String']['input']>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  translatedLabel?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<SelectValueInput>>;
};

export type SendChatMessageOutput = ChatMessageReply | ConflictException | GenericException | ResourceNotFoundException;

export type SendCoachingMessageInput = {
  message: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};

export type SendCoachingMessageResult = CoachingResponse | GenericException | ResourceNotFoundException;

export type SendGroupMessageInput = {
  groupConversationId: Scalars['String']['input'];
  lineID: Scalars['Int']['input'];
  mediaKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  text: Scalars['String']['input'];
};

export type SendGroupMessageResult = GenericException | GroupMessageId;

export type SendMessageInput = {
  channel?: InputMaybe<Channel>;
  externalNumber: Scalars['String']['input'];
  lineID: Scalars['ID']['input'];
  location?: InputMaybe<WhatsAppLocationObject>;
  mediaKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  templateParams?: InputMaybe<WhatsAppTemplateParamsInput>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SendMessageOutput = {
  __typename?: 'SendMessageOutput';
  agent?: Maybe<MessagingAgent>;
  channel?: Maybe<Channel>;
  conversationID?: Maybe<Scalars['ID']['output']>;
  direction?: Maybe<MessageDirection>;
  error?: Maybe<Error>;
  externalNumber?: Maybe<Scalars['String']['output']>;
  lineID?: Maybe<Scalars['ID']['output']>;
  mediaDetails?: Maybe<Array<MediaDetails>>;
  messageID?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<MessageStatus>;
  text?: Maybe<Scalars['String']['output']>;
};

export enum SendMessageStatus {
  AVAILABLE = 'AVAILABLE',
  BLOCKED = 'BLOCKED',
  LIMITED = 'LIMITED'
}

export type SendMessageV2Error = Exception & {
  __typename?: 'SendMessageV2Error';
  code: Scalars['String']['output'];
  limitType: LimitTypeError;
  message: Scalars['String']['output'];
};

export type SendMessageV2Input = {
  channel?: InputMaybe<Channel>;
  externalNumber: Scalars['String']['input'];
  lineID: Scalars['ID']['input'];
  location?: InputMaybe<WhatsAppLocationObject>;
  mediaKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  templateParams?: InputMaybe<WhatsAppTemplateParamsInput>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SendMessageV2Output = {
  __typename?: 'SendMessageV2Output';
  agent?: Maybe<MessagingAgent>;
  channel?: Maybe<Channel>;
  conversationID?: Maybe<Scalars['ID']['output']>;
  direction?: Maybe<MessageDirection>;
  externalNumber?: Maybe<Scalars['String']['output']>;
  lineID?: Maybe<Scalars['ID']['output']>;
  mediaDetails?: Maybe<Array<MediaDetails>>;
  messageID?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<MessageStatus>;
  text?: Maybe<Scalars['String']['output']>;
};

export type SendMessageV2Result = GenericException | SendMessageV2Error | SendMessageV2Output;

export type SendPauseResumeVoiceCallTransInput = {
  callSid: Scalars['String']['input'];
  callUuid: Scalars['String']['input'];
  companyId: Scalars['Int']['input'];
  phoneNumber: Scalars['String']['input'];
  state: Scalars['String']['input'];
  timestamp: Scalars['Int']['input'];
};

export type SendPauseResumeVoiceCallTransOutput = {
  __typename?: 'SendPauseResumeVoiceCallTransOutput';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SentimentAggregation = {
  __typename?: 'SentimentAggregation';
  count: Scalars['Int']['output'];
  sentiment: SentimentAggregationValue;
};

export type SentimentAggregationScope = {
  includeMissing?: InputMaybe<Scalars['Boolean']['input']>;
  size: Scalars['Int']['input'];
};

export enum SentimentAggregationValue {
  MISSING_VALUE = 'MISSING_VALUE',
  NEGATIVE = 'NEGATIVE',
  NEUTRAL = 'NEUTRAL',
  POSITIVE = 'POSITIVE'
}

export type SentimentInsights = {
  __typename?: 'SentimentInsights';
  callId: Scalars['Float']['output'];
  customers?: Maybe<CustomersUtterances>;
  overall?: Maybe<Array<Maybe<OverallSentiment>>>;
};

export type SentimentOverallFilter = {
  customer?: InputMaybe<Array<InputMaybe<SentimentValue>>>;
};

export type SentimentScope = {
  __typename?: 'SentimentScope';
  overall?: Maybe<SentimentScopeOverall>;
};

export type SentimentScopeFilter = {
  overall?: InputMaybe<SentimentOverallFilter>;
};

export type SentimentScopeOverall = {
  __typename?: 'SentimentScopeOverall';
  customer?: Maybe<SentimentValue>;
};

export enum SentimentType {
  AGENT = 'AGENT',
  EXTERNAL = 'EXTERNAL'
}

export enum SentimentValue {
  NEGATIVE = 'NEGATIVE',
  NEUTRAL = 'NEUTRAL',
  POSITIVE = 'POSITIVE'
}

export type SentimentsAggregation = {
  __typename?: 'SentimentsAggregation';
  aggregations: Array<SentimentAggregation>;
  otherCount: Scalars['Int']['output'];
};

export type SessionMessage = {
  __typename?: 'SessionMessage';
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  messageId: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

export type SetActivePlaybookInput = {
  callUuid: Scalars['String']['input'];
  playbookId?: InputMaybe<Scalars['ID']['input']>;
};

export type SetActivePlaybookOutput = CustomPlaybook | GenericException | InsufficientLicenseException | PlaybookException | UserInputException;

export type SetConnectPlaneApplicationAuthHeaderInput = {
  hubApplicationId: Scalars['String']['input'];
  inheritedCredentialHeader?: InputMaybe<Scalars['String']['input']>;
};

export type SetConnectPlaneApplicationAuthHeaderOutput = GenericException | ResourceNotFoundException | SetConnectPlaneApplicationAuthHeaderResponse | UserInputException;

export type SetConnectPlaneApplicationAuthHeaderResponse = {
  __typename?: 'SetConnectPlaneApplicationAuthHeaderResponse';
  hubApplicationId: Scalars['String']['output'];
  inheritedCredentialHeader?: Maybe<Scalars['String']['output']>;
};

export type SetConnectPlaneToolAvailabilityInput = {
  hubApplicationId: Scalars['String']['input'];
  scope: ToolAvailabilityScope;
  toolName: Scalars['String']['input'];
};

export type SetConnectPlaneToolAvailabilityOutput = GenericException | ResourceNotFoundException | SetConnectPlaneToolAvailabilityResponse | UserInputException;

export type SetConnectPlaneToolAvailabilityResponse = {
  __typename?: 'SetConnectPlaneToolAvailabilityResponse';
  hubApplicationId: Scalars['String']['output'];
  scope: ToolAvailabilityScope;
  toolName: Scalars['String']['output'];
};

export type SetConnectPlaneToolCompaniesInput = {
  companyIds: Array<Scalars['Int']['input']>;
  hubApplicationId: Scalars['String']['input'];
  toolName: Scalars['String']['input'];
};

export type SetConnectPlaneToolCompaniesOutput = GenericException | ResourceNotFoundException | SetConnectPlaneToolCompaniesResponse | UserInputException;

export type SetConnectPlaneToolCompaniesResponse = {
  __typename?: 'SetConnectPlaneToolCompaniesResponse';
  companyIds: Array<Scalars['Int']['output']>;
  hubApplicationId: Scalars['String']['output'];
  toolName: Scalars['String']['output'];
};

export type SetDesktopStateInput = {
  state: DesktopState;
};

export type SetDesktopStateOutput = {
  __typename?: 'SetDesktopStateOutput';
  success: Scalars['Boolean']['output'];
};

export type SetIntegrationStaticCredentialOutput = GenericException | ResourceNotFoundException | SetIntegrationStaticCredentialResponse | UserInputException;

export type SetIntegrationStaticCredentialResponse = {
  __typename?: 'SetIntegrationStaticCredentialResponse';
  credentialStatus: CredentialStatus;
};

export type SetMessagingAiAgentEscalationModeResult = GenericException | MessagingAiAgent | ResourceNotFoundException | UserInputException;

export type SetMessagingAiAgentIntakesUpfrontResult = GenericException | MessagingAiAgent | ResourceNotFoundException | UserInputException;

export type SetMetaDataInput = {
  key: MetadataTypeBoolean;
  value: Scalars['Boolean']['input'];
};

export type SetMetadataOutput = GenericException | Onboarding | UserInputException;

export type SetNotificationsConfigurationInput = {
  appKey: Scalars['String']['input'];
  cluster: Scalars['String']['input'];
};

export type SettingsDependency = {
  __typename?: 'SettingsDependency';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SettingsDependencyInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type SettingsField = {
  __typename?: 'SettingsField';
  customFields?: Maybe<Array<Maybe<IntegrationSettingsCustomFields>>>;
  customValues?: Maybe<Array<Maybe<IntegrationSettingsCustomValues>>>;
  dependsOn?: Maybe<Array<Maybe<SettingsDependency>>>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  dynamic?: Maybe<Scalars['Boolean']['output']>;
  fields?: Maybe<Array<SettingsField>>;
  group?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  infoLink?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  maxItems?: Maybe<Scalars['Int']['output']>;
  multi?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  translatedLabel?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<SelectValue>>;
};

export type SettingsFieldInput = {
  dependsOn?: InputMaybe<Array<InputMaybe<SettingsDependencyInput>>>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  dynamic?: InputMaybe<Scalars['Boolean']['input']>;
  fields?: InputMaybe<Array<SettingsFieldInput>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  info?: InputMaybe<Scalars['String']['input']>;
  infoLink?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  readonly?: InputMaybe<Scalars['Boolean']['input']>;
  translatedLabel?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<SelectValueInput>>;
};

export type SfvEligible = {
  __typename?: 'SfvEligible';
  criteria: SfvEligibleReason;
};

export enum SfvEligibleReason {
  plan = 'plan',
  trial = 'trial',
  whitelist = 'whitelist'
}

export type SfvIneligible = {
  __typename?: 'SfvIneligible';
  reason: SfvIneligibleReason;
};

export enum SfvIneligibleReason {
  ineligible_plan = 'ineligible_plan',
  no_licenses = 'no_licenses'
}

export type ShareCoreKbDocumentInput = {
  target_knowledge_base_id: Scalars['ID']['input'];
};

export type ShareCoreKbDocumentResult = {
  __typename?: 'ShareCoreKBDocumentResult';
  document_id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  target_kb_mapping_id: Scalars['ID']['output'];
  target_knowledge_base_id: Scalars['ID']['output'];
};

export type ShareCoreKbDocumentUnionResult = GenericException | ShareCoreKbDocumentResult;

export type SignInStrategy = {
  __typename?: 'SignInStrategy';
  privilegedUserIds: Array<Maybe<Scalars['Int']['output']>>;
  strategies: Array<Scalars['String']['output']>;
};

export type SignupInformation = {
  __typename?: 'SignupInformation';
  country?: Maybe<Scalars['String']['output']>;
  crm?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type SignupInformationOutput = SignupInformation | UnavailableInformation;

export type SimulationJob = {
  __typename?: 'SimulationJob';
  runId: Scalars['ID']['output'];
  status: SimulationStatus;
};

export type SimulationJobOutput = GenericException | RateLimitExceededException | ResourceNotFoundException | SimulationJob;

export type SimulationRun = {
  __typename?: 'SimulationRun';
  agentId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  draftId?: Maybe<Scalars['ID']['output']>;
  durationMs?: Maybe<Scalars['Int']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  failCount?: Maybe<Scalars['Int']['output']>;
  passCount?: Maybe<Scalars['Int']['output']>;
  runId: Scalars['ID']['output'];
  scenarios: Array<SimulationScenarioResult>;
  status: SimulationStatus;
  totalScenarios: Scalars['Int']['output'];
};

export type SimulationRunList = {
  __typename?: 'SimulationRunList';
  cursor?: Maybe<Scalars['String']['output']>;
  runs: Array<SimulationRunSummary>;
};

export type SimulationRunListOutput = GenericException | ResourceNotFoundException | SimulationRunList;

export type SimulationRunOutput = GenericException | ResourceNotFoundException | SimulationRun;

export type SimulationRunSummary = {
  __typename?: 'SimulationRunSummary';
  createdAt: Scalars['String']['output'];
  draftId?: Maybe<Scalars['ID']['output']>;
  durationMs?: Maybe<Scalars['Int']['output']>;
  failCount?: Maybe<Scalars['Int']['output']>;
  passCount?: Maybe<Scalars['Int']['output']>;
  runId: Scalars['ID']['output'];
  status: SimulationStatus;
  totalScenarios: Scalars['Int']['output'];
};

export type SimulationScenarioInput = {
  aircallNumber?: InputMaybe<Scalars['String']['input']>;
  callId?: InputMaybe<Scalars['String']['input']>;
  goal: Scalars['String']['input'];
  name: Scalars['String']['input'];
  openingLine?: InputMaybe<Scalars['String']['input']>;
  persona: CallerPersonaInput;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  scenarioId: Scalars['String']['input'];
  successCriteria: Array<Scalars['String']['input']>;
};

export type SimulationScenarioResult = {
  __typename?: 'SimulationScenarioResult';
  error?: Maybe<Scalars['String']['output']>;
  goalReason: Scalars['String']['output'];
  passed: Scalars['Boolean']['output'];
  scenarioId: Scalars['String']['output'];
  scenarioName: Scalars['String']['output'];
  turnCount: Scalars['Int']['output'];
  turns: Array<SimulationTurn>;
};

export enum SimulationStatus {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING'
}

export type SimulationTurn = {
  __typename?: 'SimulationTurn';
  durationMs?: Maybe<Scalars['Int']['output']>;
  functionArgs?: Maybe<Scalars['String']['output']>;
  functionCalled?: Maybe<Scalars['String']['output']>;
  functionCategories?: Maybe<Scalars['String']['output']>;
  functionResult?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  step?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  timestamp?: Maybe<Scalars['String']['output']>;
};

export enum SipSettingType {
  CustomSipSetting = 'CustomSipSetting',
  TwilioSipSetting = 'TwilioSipSetting'
}

export type SitemapLink = {
  __typename?: 'SitemapLink';
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type SkipWrapUpInput = {
  agentID: Scalars['ID']['input'];
};

export type SkipWrapUpOutput = {
  __typename?: 'SkipWrapUpOutput';
  agentID: Scalars['ID']['output'];
};

export type SmartflowsPageInfo = {
  __typename?: 'SmartflowsPageInfo';
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type SmsMmsMessage = BaseMessage & {
  __typename?: 'SmsMmsMessage';
  ID: Scalars['ID']['output'];
  agent?: Maybe<PhoneTeammateResolver>;
  agentId?: Maybe<Scalars['String']['output']>;
  channel: MessageChannel;
  createdAt: Scalars['AWSDateTime']['output'];
  deliveryMethod?: Maybe<Scalars['String']['output']>;
  direction: BaseMessageDirection;
  dlrAvailable?: Maybe<Scalars['Boolean']['output']>;
  externalConversationID: Scalars['ID']['output'];
  hasUnsupportedContent: Scalars['Boolean']['output'];
  mediaDetails: Array<BaseMessageMediaDetails>;
  parent?: Maybe<MessageResolver>;
  status: BaseMessageStatus;
  text: Scalars['String']['output'];
  undeliveredReason?: Maybe<BaseMessageUndeliveredReason>;
};

export enum SortDirection {
  asc = 'asc',
  desc = 'desc'
}

export type SourceAppLogoObject = {
  __typename?: 'SourceAppLogoObject';
  png?: Maybe<Scalars['String']['output']>;
  svg?: Maybe<Scalars['String']['output']>;
};

export type Speaker = AgentSpeaker | ExternalSpeaker | VirtualAgentSpeaker;

export enum SpeakerTrackerType {
  AGENT = 'AGENT',
  EXTERNAL = 'EXTERNAL'
}

export type StartActivationWizardOutput = ActivationCapabilityDisabled | ActivationForbidden | ActivationRequestException | ActivationUnauthenticated | ActivationWizardLockConflict | ActivationWizardState | GenericException;

export type StartCarrierNumberVerificationInput = {
  channel?: InputMaybe<Scalars['String']['input']>;
  e164: Scalars['String']['input'];
  metadata: Scalars['AWSJSON']['input'];
};

export type StartCarrierNumberVerificationResponse = {
  __typename?: 'StartCarrierNumberVerificationResponse';
  status: Scalars['String']['output'];
};

export type StartChatSessionOutput = ChatSession | GenericException | ResourceNotFoundException;

export type StartCoachingSessionInput = {
  forceNew?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StartCoachingSessionOutput = {
  __typename?: 'StartCoachingSessionOutput';
  context: ActiveSessionContext;
  initialMessages: Array<InitialMessage>;
  insights: ActiveSessionInsights;
  resumeMessages: Array<SessionMessage>;
  session: CoachingSession;
};

export type StartCoachingSessionResult = GenericException | StartCoachingSessionOutput;

export type StartEvalRunOutput = GenericException | ResourceNotFoundException | StartEvalRunResult | UserInputException;

export type StartEvalRunResult = {
  __typename?: 'StartEvalRunResult';
  runId: Scalars['ID']['output'];
};

export type StartLongTailGenerationJobInput = {
  generationMode?: InputMaybe<LongTailGenerationMode>;
  registrationSessionId: Scalars['ID']['input'];
};

export type StartLongTailGenerationJobOutput = GenerationFailedException | GenericException | InvalidSessionStateException | LlmUnavailableException | LongTailGenerationJob | NoSourceInputsAttachedException | RegistrationSessionNotFoundException | UserInputException;

export type StartOutboundCampaignSessionOutput = GenericException | OutboundCampaignAgentNotAvailableException | OutboundCampaignNotReadyException | OutboundCampaignUser | ResourceNotFoundException;

export type StartSimulationInput = {
  concurrency?: InputMaybe<Scalars['Int']['input']>;
  draftId?: InputMaybe<Scalars['ID']['input']>;
  iterations?: InputMaybe<Scalars['Int']['input']>;
  maxTurns?: InputMaybe<Scalars['Int']['input']>;
  scenarios: Array<SimulationScenarioInput>;
  useRealActions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StartStudioConversationInput = {
  applicationId: Scalars['String']['input'];
};

export type StartStudioConversationOutput = GenericException | StudioConversation | UserInputException;

export type StartStudioTurnInput = {
  actionsSinceLastTurn?: InputMaybe<Scalars['String']['input']>;
  applicationId: Scalars['String']['input'];
  message: Scalars['String']['input'];
  requestKey?: InputMaybe<Scalars['String']['input']>;
  workspace?: InputMaybe<Scalars['String']['input']>;
};

export type StartStudioTurnOutput = GenericException | StudioTurn | UserInputException;

export type StartTimeAggregation = {
  __typename?: 'StartTimeAggregation';
  count: Scalars['Int']['output'];
  date: Scalars['AWSDateTime']['output'];
  sentiments?: Maybe<SentimentsAggregation>;
  trackers?: Maybe<TrackersAggregation>;
};

export type StartTimesAggregation = {
  __typename?: 'StartTimesAggregation';
  aggregations: Array<StartTimeAggregation>;
};

export type Step = {
  __typename?: 'Step';
  completionType?: Maybe<CompletionType>;
  content: Scalars['String']['output'];
  redirectUrl: Scalars['String']['output'];
  stepStatus: StepStatus;
  stepTitle: Scalars['String']['output'];
  stepType: StepType;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type StepInput = {
  stepStatus: StepStatus;
  stepType: StepType;
};

export enum StepStatus {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS'
}

export enum StepType {
  ADD_ANOTHER_USER = 'ADD_ANOTHER_USER',
  CREATE_TEAM = 'CREATE_TEAM',
  LAUNCH_DASHBOARD = 'LAUNCH_DASHBOARD',
  LAUNCH_PHONE = 'LAUNCH_PHONE',
  MAKE_CALL = 'MAKE_CALL',
  SEND_MESSAGE = 'SEND_MESSAGE',
  TEST_INTEGRATION = 'TEST_INTEGRATION',
  TOUR_THE_INBOX = 'TOUR_THE_INBOX'
}

export type StopWarmTransferCallOutput = GenericException | NoTransferInProgressException | TransferAlreadyInProgressException | TransferCallHasEndedException | TransferCallNotFoundException | TransferFailedException | WarmTransferCall;

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type StringListValue = {
  __typename?: 'StringListValue';
  value: Array<Scalars['String']['output']>;
};

export type StringValue = {
  __typename?: 'StringValue';
  value: Scalars['String']['output'];
};

export type StripeDirectDebitSetupOutput = {
  __typename?: 'StripeDirectDebitSetupOutput';
  clientSecret: Scalars['String']['output'];
  paymentMethodType: Scalars['String']['output'];
  publishableKey: Scalars['String']['output'];
};

export type StripeNextAction = {
  __typename?: 'StripeNextAction';
  type?: Maybe<Scalars['String']['output']>;
  verifyWithMicrodeposits?: Maybe<StripeVerifyWithMicrodeposits>;
};

export enum StripePlanFeatureLevel {
  custom = 'custom',
  essentials = 'essentials',
  friend = 'friend',
  professional = 'professional',
  trial = 'trial'
}

export type StripeVerifyWithMicrodeposits = {
  __typename?: 'StripeVerifyWithMicrodeposits';
  arrivalDate?: Maybe<Scalars['Int']['output']>;
  bankAccountLastDigits?: Maybe<Scalars['String']['output']>;
  hostedVerificationUrl?: Maybe<Scalars['String']['output']>;
  microdepositType?: Maybe<Scalars['String']['output']>;
};

export type StudioConversation = {
  __typename?: 'StudioConversation';
  applicationId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  messages: Array<StudioMessage>;
  status: StudioConversationStatus;
  threadId: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum StudioConversationStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED'
}

export type StudioMessage = {
  __typename?: 'StudioMessage';
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  messageId: Scalars['ID']['output'];
  role: StudioMessageRole;
};

export enum StudioMessageRole {
  ASSISTANT = 'ASSISTANT',
  TOOL = 'TOOL',
  USER = 'USER'
}

export type StudioTurn = {
  __typename?: 'StudioTurn';
  createdAt: Scalars['String']['output'];
  directive?: Maybe<StudioTurnDirective>;
  errorPayload?: Maybe<Scalars['String']['output']>;
  jobRef?: Maybe<Scalars['String']['output']>;
  proposalRef?: Maybe<Scalars['String']['output']>;
  status: StudioTurnStatus;
  turnId: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum StudioTurnDirective {
  DISCARD = 'DISCARD',
  REPLACE = 'REPLACE'
}

export enum StudioTurnStatus {
  DONE = 'DONE',
  FAILED = 'FAILED',
  RUNNING = 'RUNNING'
}

export type SubSection = {
  __typename?: 'SubSection';
  fields: Array<Maybe<SubSectionField>>;
  labelLocaliseKey: Scalars['String']['output'];
  subsectionId: Scalars['Int']['output'];
};

export type SubSectionField = {
  __typename?: 'SubSectionField';
  active: Scalars['Boolean']['output'];
  descriptionLocaliseKey?: Maybe<Scalars['String']['output']>;
  fieldId: Scalars['Int']['output'];
  fieldName?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  hidden: Scalars['Boolean']['output'];
  labelLocaliseKey: Scalars['String']['output'];
  mandatory: Scalars['Boolean']['output'];
  options?: Maybe<Array<Option>>;
  placeholderLocaliseKey?: Maybe<Scalars['String']['output']>;
  readOnly: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type SubmitAgentChatFeedbackInput = {
  ID: Scalars['String']['input'];
  feedback: FeedbackType;
};

export type SubmitAgentChatFeedbackOutput = FeedbackResult | GenericException | ResourceNotFoundException | UserInputException;

export type SubmitBrandInput = {
  business: BrandBusinessInput;
  callingProfiles: Array<CallingProfileInput>;
  country: Scalars['String']['input'];
  documents?: InputMaybe<Array<BrandDocumentInput>>;
  loaEnvelopeId?: InputMaybe<Scalars['ID']['input']>;
  logo?: InputMaybe<BrandLogoInput>;
};

export type SubmitBrandResult = BrandSubmission | BrandedCallingException | GenericException;

export type SubmitQuestionnaireInput = {
  questionValues?: InputMaybe<QuestionValues>;
};

export type SubmitQuestionnaireOutput = GenericException | SubmitQuestionnaireResponse | UserInputException;

export type SubmitQuestionnaireResponse = {
  __typename?: 'SubmitQuestionnaireResponse';
  questionnaire: Questionnaire;
};

export type SubmitSuggestionFeedbackInput = {
  agentId: Scalars['ID']['input'];
  feedbackText?: InputMaybe<Scalars['String']['input']>;
  negativeReason?: InputMaybe<NegativeFeedbackReason>;
  positiveReason?: InputMaybe<PositiveFeedbackReason>;
  suggestionId: Scalars['String']['input'];
  vote: SuggestionVote;
};

export type SubmitSuggestionFeedbackOutput = {
  __typename?: 'SubmitSuggestionFeedbackOutput';
  success: Scalars['Boolean']['output'];
};

export type SubmitSuggestionFeedbackResult = GenericException | ResourceNotFoundException | SubmitSuggestionFeedbackOutput;

export type SubmitTrialWelcomeWizardInput = {
  answers: Scalars['AWSJSON']['input'];
  schemaVersion: Scalars['Int']['input'];
};

export type SubmitTrialWelcomeWizardOutput = GenericException | SubmitTrialWelcomeWizardResponse | UserInputException;

export type SubmitTrialWelcomeWizardResponse = {
  __typename?: 'SubmitTrialWelcomeWizardResponse';
  trialWelcomeWizard: TrialWelcomeWizard;
};

export type SubscribeFeatureInput = {
  name: Scalars['String']['input'];
  numberOfLicenses?: InputMaybe<Scalars['Int']['input']>;
};

export type SubscribeFeatureOutput = {
  __typename?: 'SubscribeFeatureOutput';
  error?: Maybe<Error>;
  id: Scalars['ID']['output'];
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  onAIAnswersGenerated?: Maybe<AiAnswersGeneratedOutput>;
  onAddMessage?: Maybe<AddMessageOutput>;
  onAgentAddedToLine?: Maybe<AgentAddedToLineNotificationOutput>;
  onAgentRemovedFromLine?: Maybe<AgentRemovedFromLineNotificationOutput>;
  onAircallWorkspaceConversationDeleted?: Maybe<AircallWorkspaceConversationDeletedNotificationOutput>;
  onAircallWorkspaceConversationUpdated?: Maybe<AircallWorkspaceConversationUpdatedNotificationOutput>;
  onAircallWorkspaceEngagementCreated?: Maybe<AircallWorkspaceEngagementCreatedNotificationOutput>;
  onAircallWorkspaceEngagementUpdated?: Maybe<AircallWorkspaceEngagementUpdatedNotificationOutput>;
  onAircallWorkspaceInboxUpdated?: Maybe<AircallWorkspaceInboxUpdatedNotificationOutput>;
  onAircallWorkspaceUnreadConversationsCountUpdated?: Maybe<UnreadConversationsCounterUpdatedOutput>;
  onAnalyticsExportUpdated?: Maybe<AnalyticsExportUpdatedResult>;
  onBulkCloseAircallWorkspaceConversations?: Maybe<BulkCloseAircallWorkspaceConversationsNotificationOutput>;
  onBulkReopenAircallWorkspaceConversations?: Maybe<BulkReopenAircallWorkspaceConversationsNotificationOutput>;
  onLineUpdated?: Maybe<LineUpdatedNotificationOutput>;
  onMessagingAIAgentUpdated?: Maybe<MessagingAiAgent>;
  onNotificationsConfigurationChange?: Maybe<NotificationsConfiguration>;
  onNotifyAgentConversationStatusAllUpdated?: Maybe<NotifyAgentConversationStatusAllUpdatedResult>;
  onNotifyAgentConversationsStatusUpdated?: Maybe<NotifyAgentConversationsStatusUpdatedResult>;
  onNotifyConversationCreated?: Maybe<NotifyConversationCreatedOutput>;
  onNotifyConversationsAllRead?: Maybe<NotifyConversationsAllReadResult>;
  onNotifyMessageAdded?: Maybe<NotifyMessageAddedOutput>;
  onNotifyMessageStatusUpdated?: Maybe<NotifyMessageStatusUpdatedOutput>;
  onOutboundCampaignAgentSessionQueueIdle?: Maybe<OutboundCampaignAgentSessionQueueIdleNotification>;
  onOutboundCampaignCallDispatched?: Maybe<OutboundCampaignCallDispatchedNotification>;
  onOutboundCampaignCallOutcomeAdded?: Maybe<OutboundCampaignCallOutcomeNotification>;
  onOutboundCampaignChanged?: Maybe<OutboundCampaignNotification>;
  onOutboundCampaignCompanyUnavailable?: Maybe<OutboundCampaignCompanyUnavailableNotification>;
  onOutboundCampaignNextCallQueued?: Maybe<OutboundCampaignNextCallQueuedNotification>;
  onOutboundCampaignQueueItemChanged?: Maybe<OutboundCampaignQueueItemNotification>;
  onOutboundCampaignUserDispatchFailed?: Maybe<OutboundCampaignUserDispatchFailedNotification>;
  onOutboundCampaignUserReadyChanged?: Maybe<OutboundCampaignUserReadyNotification>;
  onOutboundCampaignUserStatusChanged?: Maybe<OutboundCampaignUserStatusNotification>;
  onQuestionQualityHelperGenerated?: Maybe<QuestionQualityHelperGeneratedOutput>;
  onUpdateUnreadMessages?: Maybe<UpdateUnreadMessagesOutput>;
};


export type SubscriptionOnAiAnswersGeneratedArgs = {
  transcriptionId: Scalars['ID']['input'];
};


export type SubscriptionOnAddMessageArgs = {
  lineID: Scalars['ID']['input'];
};


export type SubscriptionOnAircallWorkspaceConversationUpdatedArgs = {
  filters: ConversationUpdatedSubscriptionFilterInput;
};


export type SubscriptionOnAircallWorkspaceEngagementCreatedArgs = {
  filters: EngagementCreatedSubscriptionFilterInput;
};


export type SubscriptionOnAircallWorkspaceEngagementUpdatedArgs = {
  filters: EngagementUpdatedSubscriptionFilterInput;
};


export type SubscriptionOnAircallWorkspaceInboxUpdatedArgs = {
  filters: AircallWorkspaceInboxUpdatedSubscriptionFilterInput;
};


export type SubscriptionOnNotifyAgentConversationStatusAllUpdatedArgs = {
  agentID?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionOnNotifyAgentConversationsStatusUpdatedArgs = {
  agentID?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionOnNotifyConversationCreatedArgs = {
  agentID?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionOnNotifyConversationsAllReadArgs = {
  agentID?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionOnNotifyMessageAddedArgs = {
  agentID?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionOnNotifyMessageStatusUpdatedArgs = {
  agentID?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionOnOutboundCampaignAgentSessionQueueIdleArgs = {
  campaignID?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionOnOutboundCampaignCallOutcomeAddedArgs = {
  campaignID?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionOnOutboundCampaignChangedArgs = {
  campaignID?: InputMaybe<Scalars['ID']['input']>;
  scope?: InputMaybe<OutboundCampaignsScope>;
};


export type SubscriptionOnOutboundCampaignCompanyUnavailableArgs = {
  campaignID?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionOnOutboundCampaignQueueItemChangedArgs = {
  campaignID?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionOnOutboundCampaignUserDispatchFailedArgs = {
  campaignID?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionOnOutboundCampaignUserReadyChangedArgs = {
  campaignID?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionOnOutboundCampaignUserStatusChangedArgs = {
  campaignID?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionOnQuestionQualityHelperGeneratedArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionOnUpdateUnreadMessagesArgs = {
  agentID?: InputMaybe<Scalars['ID']['input']>;
};

export type SubscriptionDiscountInput = {
  discountType: Scalars['Int']['input'];
};

export type SubscriptionDiscountOutput = {
  __typename?: 'SubscriptionDiscountOutput';
  discountPercentage?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type: Scalars['Int']['output'];
};

export type SubscriptionInfo = {
  __typename?: 'SubscriptionInfo';
  advMessagingLicensesIncluded?: Maybe<Scalars['Int']['output']>;
  advMessagingPlusLicensesIncluded?: Maybe<Scalars['Int']['output']>;
  advMessagingProLicensesIncluded?: Maybe<Scalars['Int']['output']>;
  advMessagingSfdcLicensesIncluded?: Maybe<Scalars['Int']['output']>;
  advMessagingStandardLicensesIncluded?: Maybe<Scalars['Int']['output']>;
  africaOutboundCallPriceLevel?: Maybe<Scalars['String']['output']>;
  aiStarterLicensesIncluded?: Maybe<Scalars['Int']['output']>;
  analyticsLicensesIncluded?: Maybe<Scalars['Int']['output']>;
  asiaRegionMinutes?: Maybe<Scalars['String']['output']>;
  billingFrequencyAddUserNumber?: Maybe<Scalars['String']['output']>;
  billingPeriodEndsAt?: Maybe<Scalars['String']['output']>;
  billingPeriodStartsAt: Scalars['String']['output'];
  cancellationCondition?: Maybe<Scalars['String']['output']>;
  cancellationDate?: Maybe<Scalars['String']['output']>;
  cancellationRequestDate?: Maybe<Scalars['String']['output']>;
  cancellationStatus?: Maybe<Scalars['String']['output']>;
  carribbeanRegionMinutes?: Maybe<Scalars['String']['output']>;
  churnRequestDate?: Maybe<Scalars['String']['output']>;
  commitmentPeriod?: Maybe<Scalars['String']['output']>;
  contractId?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  discounts?: Maybe<Array<Maybe<SubscriptionDiscountOutput>>>;
  domesticRegionMinutes?: Maybe<Scalars['String']['output']>;
  eeaRegionMinutes?: Maybe<Scalars['String']['output']>;
  fairUsePolicyByUser?: Maybe<Scalars['String']['output']>;
  featureLevel: Scalars['String']['output'];
  freePhoneNumberLicensesIncluded?: Maybe<Scalars['Int']['output']>;
  freeUserLicensesIncluded?: Maybe<Scalars['Int']['output']>;
  inboundTfCallPriceLevel?: Maybe<Scalars['String']['output']>;
  isAutoRenewal: Scalars['Boolean']['output'];
  latamRegionMinutes?: Maybe<Scalars['String']['output']>;
  lightUserLicensesIncluded?: Maybe<Scalars['Int']['output']>;
  maxAdditionalNumbers?: Maybe<Scalars['Int']['output']>;
  maxAdditionalUsers?: Maybe<Scalars['Int']['output']>;
  middleEastRegionMinutes?: Maybe<Scalars['String']['output']>;
  naRegionMinutes?: Maybe<Scalars['String']['output']>;
  netsuiteSubscriptionId?: Maybe<Scalars['String']['output']>;
  nextInvoiceAt: Scalars['String']['output'];
  noticePeriodEnd?: Maybe<Scalars['String']['output']>;
  numberOutboundBundle?: Maybe<Scalars['Float']['output']>;
  oceaniaRegionMinutes?: Maybe<Scalars['String']['output']>;
  optOutDate?: Maybe<Scalars['String']['output']>;
  otherEuropeRegionMinutes?: Maybe<Scalars['String']['output']>;
  outboundBundleName?: Maybe<Scalars['String']['output']>;
  paidPhoneNumberLicensesIncluded?: Maybe<Scalars['Int']['output']>;
  plan: Scalars['String']['output'];
  planEdition?: Maybe<Scalars['String']['output']>;
  priceAiStarter?: Maybe<Scalars['Float']['output']>;
  priceAircallAdvMessaging?: Maybe<Scalars['Float']['output']>;
  priceAircallAdvMessagingPlus?: Maybe<Scalars['Float']['output']>;
  priceAircallAdvMessagingPro?: Maybe<Scalars['Float']['output']>;
  priceAircallAdvMessagingStandard?: Maybe<Scalars['Float']['output']>;
  priceAircallSurvey?: Maybe<Scalars['Float']['output']>;
  priceAircallWebChat?: Maybe<Scalars['Float']['output']>;
  priceAnalytics?: Maybe<Scalars['Float']['output']>;
  priceOutboundBundle?: Maybe<Scalars['Float']['output']>;
  pricePerAdditionalNumber?: Maybe<Scalars['Float']['output']>;
  pricePerAdditionalUser?: Maybe<Scalars['Float']['output']>;
  pricePerLightUserIncluded?: Maybe<Scalars['Float']['output']>;
  pricePerPaidPhoneNumberIncluded?: Maybe<Scalars['Float']['output']>;
  pricePerStandardUserIncluded?: Maybe<Scalars['Float']['output']>;
  recurrence: SubscriptionRecurrenceTypes;
  scheduledContract?: Maybe<ScheduledContract>;
  smsWorldPriceLevel?: Maybe<Scalars['String']['output']>;
  specialFeatures: SubscriptionSpecialFeatures;
  standardUserLicensesIncluded?: Maybe<Scalars['Int']['output']>;
  subscriptionItemPrices?: Maybe<Array<Maybe<SubscriptionItemPrice>>>;
  surveyLicensesIncluded?: Maybe<Scalars['Int']['output']>;
  totalActiveNumbers?: Maybe<Scalars['Int']['output']>;
  totalActiveUsers?: Maybe<Scalars['Int']['output']>;
  totalSubscriptionCost?: Maybe<Scalars['Float']['output']>;
  transactionStatus?: Maybe<Scalars['String']['output']>;
  unlimitedOutboundCountries?: Maybe<Scalars['String']['output']>;
  webChatLicensesIncluded?: Maybe<Scalars['Int']['output']>;
};

export type SubscriptionItemPrice = {
  __typename?: 'SubscriptionItemPrice';
  additionalPrice?: Maybe<Scalars['Float']['output']>;
  additionalQuantity?: Maybe<Scalars['Int']['output']>;
  billingType?: Maybe<Scalars['String']['output']>;
  includedInPlan?: Maybe<Scalars['Boolean']['output']>;
  licensePrice?: Maybe<Scalars['Float']['output']>;
  licenseQuantity?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  renewalQuantity?: Maybe<Scalars['Int']['output']>;
  scheduledQuantity?: Maybe<Scalars['Int']['output']>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
};

export type SubscriptionOnNotificationsConfigurationChangeInput = {
  appId: Scalars['String']['input'];
  cluster: Scalars['String']['input'];
};

export enum SubscriptionRecurrenceTypes {
  annually = 'annually',
  biennial = 'biennial',
  monthly = 'monthly',
  quarterly = 'quarterly',
  semiannual = 'semiannual',
  triennial = 'triennial'
}

export type SubscriptionSpecialFeatures = {
  __typename?: 'SubscriptionSpecialFeatures';
  advMessaging: Scalars['Boolean']['output'];
  aiStarter: Scalars['Boolean']['output'];
  analyticsPlus: Scalars['Boolean']['output'];
  survey: Scalars['Boolean']['output'];
  webChat: Scalars['Boolean']['output'];
};

export type Subtitle = {
  __typename?: 'Subtitle';
  en?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
};

export enum SuggestionVote {
  THUMBS_DOWN = 'THUMBS_DOWN',
  THUMBS_UP = 'THUMBS_UP'
}

export type SummaryContent = {
  __typename?: 'SummaryContent';
  summary: Scalars['String']['output'];
};

export type SummaryInsight = {
  __typename?: 'SummaryInsight';
  content?: Maybe<SummaryContent>;
  createdAt: Scalars['String']['output'];
};

export type SummaryTemplate = {
  __typename?: 'SummaryTemplate';
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy?: Maybe<PhoneTeammateResolver>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
  response?: Maybe<ResponseOptions>;
  type: SummaryTemplateType;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<PhoneTeammateResolver>;
};

export type SummaryTemplateEntry = {
  __typename?: 'SummaryTemplateEntry';
  orderPosition: Scalars['Int']['output'];
  template: SummaryTemplate;
};

export type SummaryTemplateInput = {
  id: Scalars['ID']['input'];
  orderPosition: Scalars['Int']['input'];
};

export type SummaryTemplateResult = {
  __typename?: 'SummaryTemplateResult';
  aiGenerated: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  summaryTemplateId: Scalars['ID']['output'];
  summaryTemplateName: Scalars['String']['output'];
  type: SummaryTemplateType;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<PhoneTeammateResolver>;
};

export enum SummaryTemplateType {
  DISCOVERY = 'DISCOVERY',
  OPTIONS = 'OPTIONS',
  VALIDATION = 'VALIDATION'
}

export type Supervision = {
  __typename?: 'Supervision';
  ID: Scalars['ID']['output'];
  numberId: Scalars['ID']['output'];
  user?: Maybe<UserResolver>;
};

export type SupervisionItem = {
  __typename?: 'SupervisionItem';
  id?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type SupportedLanguage = {
  __typename?: 'SupportedLanguage';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SyncPortingLoaStatusInput = {
  portingRequestUUID: Scalars['String']['input'];
};

export type SyncPortingLoaStatusResponse = {
  __typename?: 'SyncPortingLoaStatusResponse';
  currentStatus: Scalars['String']['output'];
  docuSignStatus: Scalars['String']['output'];
  envelopeId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  previousStatus: Scalars['String']['output'];
  updated: Scalars['Boolean']['output'];
};

export enum SystemEntities {
  SYSTEM = 'SYSTEM'
}

export type SystemEntity = {
  __typename?: 'SystemEntity';
  type: SystemEntities;
};

export enum TtsModel {
  ELEVEN_FLASH_V2_5 = 'ELEVEN_FLASH_V2_5',
  SONIC_3_5 = 'SONIC_3_5'
}

export enum TtsProvider {
  CARTESIA = 'CARTESIA',
  ELEVEN_LABS = 'ELEVEN_LABS'
}

export type Tag = {
  __typename?: 'Tag';
  color: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type TagsAndNotes = {
  __typename?: 'TagsAndNotes';
  notes: Array<Maybe<NoteAgentDetail>>;
  tags: Array<Maybe<Tag>>;
};

export enum TagsLogic {
  ALL = 'ALL',
  ANY = 'ANY'
}

export type Target = {
  id: Scalars['ID']['output'];
  type: TargetType;
};

export enum TargetAgentOption {
  ALL = 'ALL',
  FIRST = 'FIRST',
  LAST = 'LAST'
}

export type TargetResponse = {
  __typename?: 'TargetResponse';
  agent?: Maybe<AgentTargetResponse>;
  external?: Maybe<PhoneNumberTargetResponse>;
  internal?: Maybe<LineTargetResponse>;
  team?: Maybe<TeamTargetResponse>;
};

export enum TargetType {
  agent = 'agent',
  team = 'team'
}

export enum TaskCategory {
  ONBOARDING = 'ONBOARDING',
  TRIAL = 'TRIAL'
}

export enum TaskRequirement {
  ADDITIONAL = 'ADDITIONAL',
  ESSENTIAL = 'ESSENTIAL'
}

export enum TaskScopeType {
  COMPANY = 'COMPANY',
  ROLE = 'ROLE',
  USER = 'USER'
}

export type TaskState = {
  __typename?: 'TaskState';
  availableAt: Scalars['AWSDateTime']['output'];
  companyId: Scalars['ID']['output'];
  completedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  displayOrder: Scalars['Int']['output'];
  expiredAt?: Maybe<Scalars['AWSDateTime']['output']>;
  expiresAt?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['AWSJSON']['output']>;
  relationId?: Maybe<Scalars['String']['output']>;
  revokedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  skippedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  status: TaskStatus;
  taskTemplate: TaskTemplate;
  taskTemplateSlug: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  updatedBy: Scalars['String']['output'];
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum TaskStatus {
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
  PENDING = 'PENDING',
  REVOKED = 'REVOKED',
  SKIPPED = 'SKIPPED'
}

export type TaskTemplate = {
  __typename?: 'TaskTemplate';
  category: TaskCategory;
  createdAt: Scalars['AWSDateTime']['output'];
  deletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  dependsOn?: Maybe<Array<Scalars['String']['output']>>;
  displayOrder: Scalars['Int']['output'];
  expiryInDays?: Maybe<Scalars['Int']['output']>;
  parentSlug?: Maybe<Scalars['String']['output']>;
  requirement: TaskRequirement;
  retiredAt?: Maybe<Scalars['AWSDateTime']['output']>;
  scopeType: TaskScopeType;
  skippable: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  status: TaskTemplateStatus;
  targetModules?: Maybe<Array<ClientContext>>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export enum TaskTemplateStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  DRAFT = 'DRAFT',
  RETIRED = 'RETIRED'
}

export type Team = {
  __typename?: 'Team';
  ID: Scalars['ID']['output'];
  agentsCounter?: Maybe<Scalars['Int']['output']>;
  agentsIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  companyID: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  imageName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type TeamExtractOutput = {
  __typename?: 'TeamExtractOutput';
  extractFileUrl?: Maybe<Scalars['String']['output']>;
};

export type TeamResolver = {
  __typename?: 'TeamResolver';
  entity: Team;
};

export type TeamResolverInput = {
  __typename?: 'TeamResolverInput';
  companyID: Scalars['ID']['output'];
  teamID: Scalars['ID']['output'];
};

export type TeamTargetResponse = {
  __typename?: 'TeamTargetResponse';
  agentIDs?: Maybe<Array<Scalars['ID']['output']>>;
  teamID: Scalars['ID']['output'];
};

export type TeamUser = {
  __typename?: 'TeamUser';
  id: Scalars['String']['output'];
};

export type TeamUsers = {
  __typename?: 'TeamUsers';
  data: Array<TeamUser>;
};

export type TeammateByIdInput = {
  ID: Scalars['ID']['input'];
};

export type TeammateByIdOutput = GenericException | PhoneTeammate | ResourceNotFoundException;

export type TeammatesByIdsInput = {
  IDs: Array<Scalars['ID']['input']>;
};

export type TeammatesByIdsOutput = GenericException | ResourceNotFoundException | TeammatesByIdsResult | UserInputException;

export type TeammatesByIdsResult = {
  __typename?: 'TeammatesByIdsResult';
  teammates: Array<PhoneTeammate>;
};

export type Template = {
  __typename?: 'Template';
  ID: Scalars['ID']['output'];
  category: TemplateCategory;
  companyID: Scalars['ID']['output'];
  components: Array<TemplateComponent>;
  createdAtTimestamp: Scalars['String']['output'];
  isFavourite?: Maybe<Scalars['Boolean']['output']>;
  language: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rejectedReason?: Maybe<Scalars['String']['output']>;
  status: TemplateStatus;
  type?: Maybe<TemplateType>;
  updatedAtTimestamp: Scalars['String']['output'];
  wabaID: Scalars['String']['output'];
};

export type TemplateBodyComponent = {
  __typename?: 'TemplateBodyComponent';
  addSecurityRecommendation?: Maybe<Scalars['Boolean']['output']>;
  bodyExample?: Maybe<TemplateBodyExample>;
  text: Scalars['String']['output'];
  type: TemplateComponentType;
};

export type TemplateBodyExample = {
  __typename?: 'TemplateBodyExample';
  bodyText: Array<Array<Scalars['String']['output']>>;
};

export type TemplateButton = {
  __typename?: 'TemplateButton';
  example?: Maybe<Scalars['String']['output']>;
  flowAction?: Maybe<Scalars['String']['output']>;
  flowId?: Maybe<Scalars['Int']['output']>;
  navigateScreen?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  type: TemplateButtonType;
  url?: Maybe<Scalars['String']['output']>;
};

export type TemplateButtonComponent = {
  __typename?: 'TemplateButtonComponent';
  buttons: Array<TemplateButton>;
};

export type TemplateButtonInput = {
  example?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  flowAction?: InputMaybe<Scalars['String']['input']>;
  flowId?: InputMaybe<Scalars['Int']['input']>;
  navigateScreen?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  type: TemplateButtonType;
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum TemplateButtonType {
  CATALOG = 'CATALOG',
  COPY_CODE = 'COPY_CODE',
  FLOW = 'FLOW',
  PHONE_NUMBER = 'PHONE_NUMBER',
  QUICK_REPLY = 'QUICK_REPLY',
  URL = 'URL',
  VOICE_CALL = 'VOICE_CALL'
}

export type TemplateButtonsComponent = {
  __typename?: 'TemplateButtonsComponent';
  buttons: Array<TemplateButton>;
  type: TemplateComponentType;
};

export type TemplateCard = {
  __typename?: 'TemplateCard';
  components?: Maybe<Array<TemplateCardComponent>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type TemplateCardComponent = {
  __typename?: 'TemplateCardComponent';
  buttons?: Maybe<Array<TemplateButton>>;
  example?: Maybe<TemplateComponentExample>;
  format?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum TemplateCardComponentFormat {
  DOCUMENT = 'DOCUMENT',
  IMAGE = 'IMAGE',
  LOCATION = 'LOCATION',
  TEXT = 'TEXT',
  VIDEO = 'VIDEO'
}

export enum TemplateCardComponentType {
  BODY = 'BODY',
  BUTTONS = 'BUTTONS',
  FOOTER = 'FOOTER',
  HEADER = 'HEADER'
}

export type TemplateCardInput = {
  components?: InputMaybe<Array<TemplateComponentInput>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum TemplateCategory {
  AUTHENTICATION = 'AUTHENTICATION',
  MARKETING = 'MARKETING',
  UTILITY = 'UTILITY'
}

export type TemplateComponent = TemplateBodyComponent | TemplateButtonComponent | TemplateButtonsComponent | TemplateFooterComponent | TemplateHeaderMediaComponent | TemplateHeaderTextComponent;

export type TemplateComponentExample = {
  __typename?: 'TemplateComponentExample';
  bodyText?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
  headerHandle?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  headerText?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TemplateComponentExampleInput = {
  bodyText?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  headerHandle?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerText?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum TemplateComponentFormat {
  DOCUMENT = 'DOCUMENT',
  IMAGE = 'IMAGE',
  LOCATION = 'LOCATION',
  TEXT = 'TEXT',
  VIDEO = 'VIDEO'
}

export type TemplateComponentInput = {
  addSecurityRecommendation?: InputMaybe<Scalars['Boolean']['input']>;
  buttons?: InputMaybe<Array<TemplateButtonInput>>;
  cards?: InputMaybe<Array<TemplateCardInput>>;
  codeExpirationMinutes?: InputMaybe<Scalars['Int']['input']>;
  example?: InputMaybe<TemplateComponentExampleInput>;
  format?: InputMaybe<TemplateComponentFormat>;
  text?: InputMaybe<Scalars['String']['input']>;
  type: TemplateComponentType;
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum TemplateComponentType {
  BODY = 'BODY',
  BUTTONS = 'BUTTONS',
  CARDS = 'CARDS',
  FOOTER = 'FOOTER',
  HEADER = 'HEADER'
}

export type TemplateFooterComponent = {
  __typename?: 'TemplateFooterComponent';
  codeExpirationMinutes?: Maybe<Scalars['Int']['output']>;
  text: Scalars['String']['output'];
  type: TemplateComponentType;
};

export type TemplateHeaderMediaComponent = {
  __typename?: 'TemplateHeaderMediaComponent';
  format: TemplateComponentFormat;
  headerMediaExample?: Maybe<TemplateHeaderMediaExample>;
  type: TemplateComponentType;
  url: Scalars['String']['output'];
};

export type TemplateHeaderMediaExample = {
  __typename?: 'TemplateHeaderMediaExample';
  headerHandle: Array<Scalars['String']['output']>;
};

export type TemplateHeaderTextComponent = {
  __typename?: 'TemplateHeaderTextComponent';
  format: TemplateComponentFormat;
  headerTextExample?: Maybe<TemplateHeaderTextExample>;
  text: Scalars['String']['output'];
  type: TemplateComponentType;
};

export type TemplateHeaderTextExample = {
  __typename?: 'TemplateHeaderTextExample';
  headerText: Array<Scalars['String']['output']>;
};

export type TemplateRequest = {
  category: TemplateCategory;
  components: Array<TemplateComponentInput>;
  language: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type TemplateResponsePageInfo = {
  __typename?: 'TemplateResponsePageInfo';
  currentToken?: Maybe<Scalars['ID']['output']>;
  nextToken?: Maybe<Scalars['ID']['output']>;
  totalCount: Scalars['Int']['output'];
};

export enum TemplateStatus {
  APPROVED = 'APPROVED',
  DISABLED = 'DISABLED',
  PAUSED = 'PAUSED',
  PENDING = 'PENDING',
  RECEIVED = 'RECEIVED',
  REJECTED = 'REJECTED'
}

export enum TemplateSubCategory {
  CUSTOM = 'CUSTOM',
  FORM = 'FORM'
}

export type TemplateTextNamedComponentInput = {
  example?: InputMaybe<Scalars['String']['input']>;
  paramName?: InputMaybe<Scalars['String']['input']>;
};

export enum TemplateType {
  CALL_TO_ACTION = 'CALL_TO_ACTION',
  CARD = 'CARD',
  CAROUSEL = 'CAROUSEL',
  MEDIA = 'MEDIA',
  QUICK_REPLY = 'QUICK_REPLY',
  TEXT = 'TEXT',
  WHATSAPP_AUTHENTICATION = 'WHATSAPP_AUTHENTICATION',
  WHATSAPP_CARD = 'WHATSAPP_CARD'
}

export type TestActionOutput = GenericException | ResourceNotFoundException | TestActionResult;

export type TestActionResult = {
  __typename?: 'TestActionResult';
  error?: Maybe<Scalars['String']['output']>;
  executionTime?: Maybe<Scalars['Int']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  statusCode: Scalars['Int']['output'];
};

export type TestAuthMethodOutput = GenericException | ResourceNotFoundException | TestAuthMethodResult;

export type TestAuthMethodResult = {
  __typename?: 'TestAuthMethodResult';
  message: Scalars['String']['output'];
  responseTimeMs?: Maybe<Scalars['Float']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TestConnectPlaneToolInput = {
  arguments: Scalars['String']['input'];
  toolName: Scalars['String']['input'];
};

export type TestConnectPlaneToolOutput = GenericException | InsufficientPermissionException | ResourceNotFoundException | TestConnectPlaneToolResponse | UserInputException;

export type TestConnectPlaneToolResponse = {
  __typename?: 'TestConnectPlaneToolResponse';
  content: Scalars['String']['output'];
  executionTimeMs?: Maybe<Scalars['Int']['output']>;
  isError: Scalars['Boolean']['output'];
  toolName: Scalars['String']['output'];
};

export type TextToSpeechPreview = {
  __typename?: 'TextToSpeechPreview';
  data: TextToSpeechPreviewData;
};

export type TextToSpeechPreviewData = {
  __typename?: 'TextToSpeechPreviewData';
  attributes: TextToSpeechPreviewDataAttributes;
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TextToSpeechPreviewDataAttributes = {
  __typename?: 'TextToSpeechPreviewDataAttributes';
  category: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  defaultUrl: Scalars['String']['output'];
  language: Scalars['String']['output'];
  message: Scalars['String']['output'];
  track: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  url: Scalars['String']['output'];
  voice: Scalars['String']['output'];
};

export type TextToSpeechPreviewDataAttributesInput = {
  category: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['String']['input']>;
  defaultUrl?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  message: Scalars['String']['input'];
  track?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
  voice: Scalars['String']['input'];
};

export type TextToSpeechPreviewInput = {
  data?: InputMaybe<TextToSpeechPreviewInputData>;
};

export type TextToSpeechPreviewInputData = {
  attributes: TextToSpeechPreviewInputDataAttributes;
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type TextToSpeechPreviewInputDataAttributes = {
  language: Scalars['String']['input'];
  message: Scalars['String']['input'];
  voice: Scalars['String']['input'];
};

export type Throughput = {
  __typename?: 'Throughput';
  level?: Maybe<Scalars['String']['output']>;
};

export type TimestampFilter = {
  gt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  gte?: InputMaybe<Scalars['AWSDateTime']['input']>;
  lt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  lte?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type TimestampSubscriptionFilter = {
  eq?: InputMaybe<Scalars['AWSDateTime']['input']>;
  ge?: InputMaybe<Scalars['AWSDateTime']['input']>;
  gt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  le?: InputMaybe<Scalars['AWSDateTime']['input']>;
  lt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type ToggleSipDeviceActivationStateInput = {
  id: Scalars['Int']['input'];
  sipSetting: ToggleSipSetting;
  userId: Scalars['Int']['input'];
};

export type ToggleSipSetting = {
  isEnabled: Scalars['Boolean']['input'];
};

export type ToggleSipSettingInput = {
  ID: Scalars['ID']['input'];
  agentID: Scalars['ID']['input'];
  isEnabled: Scalars['Boolean']['input'];
};

export type ToggleVirtualAgentActivationInput = {
  enable: Scalars['Boolean']['input'];
};

export type TooBigException = Exception & {
  __typename?: 'TooBigException';
  code: Scalars['String']['output'];
  maximum: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  path: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TooManyRequestsException = Exception & {
  __typename?: 'TooManyRequestsException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type TooSmallException = Exception & {
  __typename?: 'TooSmallException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  minimum: Scalars['Int']['output'];
  path: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ToolAvailabilityDetails = {
  __typename?: 'ToolAvailabilityDetails';
  companyIds: Array<Scalars['Int']['output']>;
  hubApplicationId: Scalars['String']['output'];
  scope: ToolAvailabilityScope;
  toolName: Scalars['String']['output'];
};

export enum ToolAvailabilityScope {
  ALL = 'ALL',
  RESTRICTED = 'RESTRICTED'
}

export type ToolCertStatus = {
  __typename?: 'ToolCertStatus';
  agent: EvalAgentType;
  certifiedAt?: Maybe<Scalars['String']['output']>;
  status: ToolCertStatusValue;
  toolId: Scalars['ID']['output'];
  toolName: Scalars['String']['output'];
  versionHash?: Maybe<Scalars['String']['output']>;
};

export type ToolCertStatusList = {
  __typename?: 'ToolCertStatusList';
  certifications: Array<ToolCertStatus>;
  kbToolNames: Array<Scalars['String']['output']>;
};

export enum ToolCertStatusValue {
  CERTIFIED = 'CERTIFIED',
  NONE = 'NONE',
  PASSED_PENDING = 'PASSED_PENDING',
  STALE = 'STALE'
}

export type ToolDefLintFinding = {
  __typename?: 'ToolDefLintFinding';
  excerpt: Scalars['String']['output'];
  field: Scalars['String']['output'];
  kind: Scalars['String']['output'];
};

export type ToolDefLintRejectedException = Exception & {
  __typename?: 'ToolDefLintRejectedException';
  code: Scalars['String']['output'];
  findings: Array<ToolDefLintFinding>;
  message: Scalars['String']['output'];
};

export type ToolGrade = {
  __typename?: 'ToolGrade';
  description?: Maybe<Scalars['String']['output']>;
  hardening: Array<ToolQualityAxis>;
  inputSchemaJson?: Maybe<Scalars['String']['output']>;
  overallScore: Scalars['Float']['output'];
  overallVerdict: Scalars['String']['output'];
  quality: Array<ToolQualityAxis>;
  toolName: Scalars['String']['output'];
};

export type ToolQualityAxis = {
  __typename?: 'ToolQualityAxis';
  axis: Scalars['String']['output'];
  evidence: Array<Scalars['String']['output']>;
  feedback: Scalars['String']['output'];
  layer: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  verdict: Scalars['String']['output'];
};

export type Topic = {
  __typename?: 'Topic';
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy?: Maybe<PhoneTeammateResolver>;
  description?: Maybe<Scalars['String']['output']>;
  guidance: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isEditable: Scalars['Boolean']['output'];
  language: PlaybookLanguage;
  name: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
  responseOptions?: Maybe<Array<TopicResponseOption>>;
  responseType: CustomPlaybookResponseType;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<PhoneTeammateResolver>;
};

export type TopicAggregation = {
  __typename?: 'TopicAggregation';
  count: Scalars['Int']['output'];
  topic: Scalars['String']['output'];
};

export type TopicEntry = {
  __typename?: 'TopicEntry';
  order: Scalars['Int']['output'];
  scope: TopicScope;
  topic: Topic;
};

export type TopicInput = {
  id: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
  scope: TopicScope;
};

export type TopicResponse = BooleanValue | StringListValue | StringValue;

export type TopicResponseOption = {
  __typename?: 'TopicResponseOption';
  id: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type TopicResult = {
  __typename?: 'TopicResult';
  aiGenerated: Scalars['Boolean']['output'];
  content: TopicResultContent;
  createdAt: Scalars['AWSDateTime']['output'];
  discussed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  language: PlaybookLanguage;
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<PhoneTeammateResolver>;
};

export type TopicResultContent = {
  __typename?: 'TopicResultContent';
  id: Scalars['ID']['output'];
  response: TopicResponse;
  responseOptions?: Maybe<TopicResponseOption>;
  responseType: CustomPlaybookResponseType;
};

export enum TopicScope {
  ALL = 'ALL',
  INSIGHT = 'INSIGHT',
  REALTIME = 'REALTIME'
}

export type TopicsAggregation = {
  __typename?: 'TopicsAggregation';
  aggregations: Array<TopicAggregation>;
  otherCount: Scalars['Int']['output'];
};

export type TopicsAggregationScope = {
  includeMissing?: InputMaybe<Scalars['Boolean']['input']>;
  size: Scalars['Int']['input'];
};

export type TopicsContent = {
  __typename?: 'TopicsContent';
  topics?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TopicsInsight = {
  __typename?: 'TopicsInsight';
  content?: Maybe<TopicsContent>;
  createdAt: Scalars['String']['output'];
};

export type Track = {
  __typename?: 'Track';
  ID: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  readUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type TrackAttributes = {
  __typename?: 'TrackAttributes';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type TrackData = {
  __typename?: 'TrackData';
  attributes: TrackAttributes;
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TrackUploadField = {
  __typename?: 'TrackUploadField';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TrackUploadUrl = {
  __typename?: 'TrackUploadUrl';
  fields: Array<TrackUploadField>;
  key: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  readUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Tracker = {
  __typename?: 'Tracker';
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy: Scalars['Int']['output'];
  filters?: Maybe<TrackerFilter>;
  title: Scalars['String']['output'];
  trackerId: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type TrackerAggregation = ExistingTrackerAggregation | MissingTrackerAggregation;

export type TrackerBackfillStatus = {
  __typename?: 'TrackerBackfillStatus';
  status?: Maybe<TrackerBackfillValue>;
  trackerId: Scalars['Int']['output'];
};

export enum TrackerBackfillValue {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_FOUND = 'NOT_FOUND'
}

export type TrackerFilter = KeywordTrackerFilter;

export type TrackerKeywordLimitExceeded = Exception & {
  __typename?: 'TrackerKeywordLimitExceeded';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  positions: Array<Scalars['Int']['output']>;
};

export type TrackerLimitExceeded = Exception & {
  __typename?: 'TrackerLimitExceeded';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type TrackersAggregation = {
  __typename?: 'TrackersAggregation';
  aggregations: Array<TrackerAggregation>;
  otherCount: Scalars['Int']['output'];
};

export type TrackersAggregationScope = {
  includeMissing?: InputMaybe<Scalars['Boolean']['input']>;
  size: Scalars['Int']['input'];
};

export type Tracks = {
  __typename?: 'Tracks';
  data: Array<TrackData>;
};

export type Transaction = {
  __typename?: 'Transaction';
  status?: Maybe<Scalars['Int']['output']>;
  transactionId: Scalars['String']['output'];
  type?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export enum TransactionType {
  CREDIT_MEMO = 'CREDIT_MEMO',
  INVOICE = 'INVOICE'
}

export type Transcription = CallTranscription | VoicemailTranscription;

export type TranscriptionAgentsFilter = {
  any: Scalars['Boolean']['input'];
  filterBy?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type TranscriptionContent = {
  __typename?: 'TranscriptionContent';
  speakers?: Maybe<Array<Maybe<Speaker>>>;
  utterances?: Maybe<Array<Maybe<Utterance>>>;
};

export type TranscriptionInsights = {
  __typename?: 'TranscriptionInsights';
  callId: Scalars['Float']['output'];
  callUuid: Scalars['String']['output'];
  nextActions?: Maybe<NextActionsInsights>;
  predictedCsat?: Maybe<PredictedCsat>;
  sentiments?: Maybe<SentimentInsights>;
  summary?: Maybe<SummaryInsight>;
  topics?: Maybe<TopicsInsight>;
  transcriptionId: Scalars['ID']['output'];
};

export enum TranscriptionMode {
  ASYNC = 'ASYNC',
  REALTIME = 'REALTIME'
}

export type TranscriptionPhoneNumbersFilter = {
  any: Scalars['Boolean']['input'];
  filterBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TranscriptionResolver = {
  __typename?: 'TranscriptionResolver';
  entity?: Maybe<Transcription>;
};

export type TranscriptionResolverInput = {
  __typename?: 'TranscriptionResolverInput';
  callId: Scalars['ID']['output'];
};

export type TranscriptionScope = {
  __typename?: 'TranscriptionScope';
  items: Array<Maybe<TranscriptionScopeItem>>;
  totalItems: Scalars['Int']['output'];
};

export type TranscriptionScopeFilter = {
  agents?: InputMaybe<TranscriptionAgentsFilter>;
  endTime?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  phoneNumbers?: InputMaybe<TranscriptionPhoneNumbersFilter>;
  queryType?: InputMaybe<TranscriptionScopeQueryTypeFilter>;
  searchContent: Scalars['String']['input'];
  startTime?: InputMaybe<Scalars['Int']['input']>;
};

export type TranscriptionScopeHighlight = {
  __typename?: 'TranscriptionScopeHighlight';
  content: Scalars['String']['output'];
  terms: Array<Maybe<Scalars['String']['output']>>;
};

export type TranscriptionScopeItem = {
  __typename?: 'TranscriptionScopeItem';
  highlight: TranscriptionScopeHighlight;
  utterance: TranscriptionScopeUtterance;
};

export enum TranscriptionScopeQueryType {
  MATCH = 'MATCH',
  QUERYSTRING = 'QUERYSTRING'
}

export type TranscriptionScopeQueryTypeFilter = {
  type: TranscriptionScopeQueryType;
};

export type TranscriptionScopeUtterance = {
  __typename?: 'TranscriptionScopeUtterance';
  agentId?: Maybe<Scalars['Int']['output']>;
  endTime: Scalars['Float']['output'];
  index: Scalars['Int']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['Float']['output'];
};

export type TranscriptionSettings = {
  __typename?: 'TranscriptionSettings';
  availableLanguages: Array<Maybe<LanguageSettings>>;
  csat?: Maybe<CsatSettings>;
  redaction?: Maybe<RedactionSettings>;
  supportedLanguages: Array<Maybe<Scalars['String']['output']>>;
};

export enum TranscriptionSettingsReason {
  companyRestricted = 'companyRestricted',
  languageNotSupported = 'languageNotSupported',
  manual = 'manual'
}

export type TransferAlreadyInProgressException = Exception & {
  __typename?: 'TransferAlreadyInProgressException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type TransferCallHasEndedException = Exception & {
  __typename?: 'TransferCallHasEndedException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type TransferCallNotFoundException = Exception & {
  __typename?: 'TransferCallNotFoundException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type TransferFailedException = Exception & {
  __typename?: 'TransferFailedException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type TransferTeamNotFoundException = Exception & {
  __typename?: 'TransferTeamNotFoundException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type TransferUserNotFoundException = Exception & {
  __typename?: 'TransferUserNotFoundException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type Transferee = PhoneContactResolver | PhoneTeammateResolver;

export type TransferredPhoneCall = PhoneCall & {
  __typename?: 'TransferredPhoneCall';
  ID: Scalars['ID']['output'];
  archivedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  assigned?: Maybe<PhoneCallAssigned>;
  callUuid: Scalars['String']['output'];
  callee: PhoneCallCallee;
  caller: PhoneCallCaller;
  createdAt: Scalars['AWSDateTime']['output'];
  direction: PhoneCallDirection;
  duration: Scalars['Int']['output'];
  external: PhoneContactResolver;
  internalTags: Array<PhoneCallTag>;
  line: LineResolver;
  notes: Array<PhoneCallNote>;
  outboundCampaignAttempt?: Maybe<OutboundCampaignAttemptResolver>;
  proxiedAudioUrl?: Maybe<Scalars['String']['output']>;
  proxiedRecordingUrl?: Maybe<Scalars['String']['output']>;
  recordingDurationMs?: Maybe<Scalars['Int']['output']>;
  status: PhoneCallStatus;
  tags: Array<PhoneCallTag>;
  timeline?: Maybe<PhoneCallTimelineResolver>;
  transcription?: Maybe<TranscriptionResolver>;
  transferred: PhoneCallTransferred;
  type: PhoneCallType;
  voiceAgents?: Maybe<Array<VoiceAgentParticipant>>;
};

export type Trend = {
  __typename?: 'Trend';
  periods: Array<TrendPeriod>;
};

export enum TrendDirection {
  DOWN = 'DOWN',
  FLAT = 'FLAT',
  UP = 'UP'
}

export enum TrendIntervalType {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK'
}

export type TrendPeriod = {
  __typename?: 'TrendPeriod';
  delta?: Maybe<Scalars['Float']['output']>;
  fromCallStartedAt: Scalars['AWSTimestamp']['output'];
  percentChange?: Maybe<Scalars['Float']['output']>;
  toCallStartedAt: Scalars['AWSTimestamp']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type TrendResult = GenericException | Trend | UserInputException;

export type TrialWelcomeWizard = {
  __typename?: 'TrialWelcomeWizard';
  answers: Scalars['AWSJSON']['output'];
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  schemaVersion: Scalars['Int']['output'];
  submittedAt: Scalars['AWSDateTime']['output'];
  submittedBy: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type TriggerAgentDeclinedWebhook = {
  callId?: InputMaybe<Scalars['Float']['input']>;
  callUuid?: InputMaybe<Scalars['String']['input']>;
};

export type TriggerAgentDeclinedWebhookOutput = {
  __typename?: 'TriggerAgentDeclinedWebhookOutput';
  callId?: Maybe<Scalars['Float']['output']>;
  callUuid?: Maybe<Scalars['String']['output']>;
};

export type TriggerSource = AgentId | SystemEntity;

export type TtsGenerationInProgressException = Exception & {
  __typename?: 'TtsGenerationInProgressException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type TtsLanguage = {
  __typename?: 'TtsLanguage';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  voices: Array<RestTtsVoiceRest>;
};

export type TtsMessage = {
  __typename?: 'TtsMessage';
  category: Scalars['String']['output'];
  defaultUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  language: Scalars['String']['output'];
  message: Scalars['String']['output'];
  track?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  voice: Scalars['String']['output'];
};

export type TtsMessageCreateOutput = {
  __typename?: 'TtsMessageCreateOutput';
  expiresAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type TtsMessagesVoicesInput = {
  locale: Scalars['String']['input'];
};

export type TtsMessagesVoicesOutput = GenericException | ResourceNotFoundException | TtsVoicesSuccessOutput;

export type TtsOptions = {
  __typename?: 'TtsOptions';
  languages: Array<TtsLanguage>;
};

export type TtsVoice = {
  __typename?: 'TtsVoice';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type TtsVoicesLanguage = {
  __typename?: 'TtsVoicesLanguage';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  voices: Array<TtsVoice>;
};

export type TtsVoicesSuccessOutput = {
  __typename?: 'TtsVoicesSuccessOutput';
  languages: Array<TtsVoicesLanguage>;
};

export type UnassignCustomSummaryConfigurationInput = {
  configurations: Array<CustomSummaryConfigurationInput>;
};

export type UnassignCustomSummaryConfigurationOutput = GenericException | InsufficientLicenseException | UnassignCustomSummaryConfigurationResult | UserInputException;

export type UnassignCustomSummaryConfigurationResult = {
  __typename?: 'UnassignCustomSummaryConfigurationResult';
  isSuccess: Scalars['Boolean']['output'];
};

export type UnassignEngagement = Engagement & {
  __typename?: 'UnassignEngagement';
  ID: Scalars['ID']['output'];
  author: PhoneTeammateResolver;
  createdAt: Scalars['AWSDateTime']['output'];
  unassignedFrom: PhoneTeammateResolver;
};

export type UnassignEsimInput = {
  agentId?: InputMaybe<Scalars['Int']['input']>;
  numberUUID: Scalars['String']['input'];
};

export type UnassignEsimResponse = {
  __typename?: 'UnassignEsimResponse';
  numberUUID: Scalars['String']['output'];
};

export type UnassignLicensesInput = {
  licenseName: Scalars['String']['input'];
  users: Array<LicenseUserInput>;
};

export type UnassignLicensesOutput = {
  __typename?: 'UnassignLicensesOutput';
  error?: Maybe<Error>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UnassignPlaybookSettingsInput = {
  lineId: Scalars['ID']['input'];
};

export type UnassignPlaybookSettingsOutput = GenericException | InsufficientLicenseException | UnassignPlaybookSettingsResult | UserInputException;

export type UnassignPlaybookSettingsResult = {
  __typename?: 'UnassignPlaybookSettingsResult';
  isSuccess: Scalars['Boolean']['output'];
};

export type Unauthorized = {
  __typename?: 'Unauthorized';
  message: Scalars['String']['output'];
};

export type UnauthorizedException = Exception & {
  __typename?: 'UnauthorizedException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type UnavailableInformation = {
  __typename?: 'UnavailableInformation';
  message?: Maybe<Scalars['String']['output']>;
};

export type UnenrollNumbersInput = {
  numbers: Array<Scalars['String']['input']>;
};

export type UnenrollNumbersResult = BrandedCallingException | GenericException | UnenrollNumbersSuccess;

export type UnenrollNumbersSuccess = {
  __typename?: 'UnenrollNumbersSuccess';
  success: Scalars['Boolean']['output'];
};

export type UnprocessableResourceException = Exception & {
  __typename?: 'UnprocessableResourceException';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  resource: Scalars['String']['output'];
};

export type UnreadAircallWorkspaceConversationsCountFilters = {
  externalType?: InputMaybe<AircallWorkspaceConversationExternalTypesInput>;
};

export type UnreadAircallWorkspaceConversationsCountOutput = GenericException | UnreadConversationsCountResult;

export type UnreadConversationCountResult = {
  __typename?: 'UnreadConversationCountResult';
  conversationID: Scalars['ID']['output'];
  unreadEngagementCount: Scalars['Int']['output'];
};

export type UnreadConversationInput = {
  conversationID: Scalars['ID']['input'];
};

export type UnreadConversationOutput = {
  __typename?: 'UnreadConversationOutput';
  conversationID: Scalars['ID']['output'];
  error?: Maybe<Error>;
};

export type UnreadConversationsCountResult = {
  __typename?: 'UnreadConversationsCountResult';
  totalUnreadConversationsCount: Scalars['Int']['output'];
  userID: Scalars['ID']['output'];
};

export type UnreadConversationsCounter = {
  __typename?: 'UnreadConversationsCounter';
  unreadConversationsCount: Scalars['Int']['output'];
};

export type UnreadConversationsCounterNotificationResult = {
  __typename?: 'UnreadConversationsCounterNotificationResult';
  totalUnreadConversationsCount: Scalars['Int']['output'];
  triggeredByConversationID: Scalars['ID']['output'];
  triggeredByConversationUnreadEngagementsCount: Scalars['Int']['output'];
  userID: Scalars['ID']['output'];
};

export type UnreadConversationsCounterUpdatedInput = {
  recipients: Array<Scalars['ID']['input']>;
  unreadEngagementCounters: Scalars['String']['input'];
};

export type UnreadConversationsCounterUpdatedOutput = {
  __typename?: 'UnreadConversationsCounterUpdatedOutput';
  recipients: Array<Scalars['ID']['output']>;
  unreadEngagementCounters: Array<UnreadConversationsCounterNotificationResult>;
};

export type UnreadCurrentUserConversationsByIdsInput = {
  conversationIDs: Array<Scalars['ID']['input']>;
};

export type UnreadCurrentUserConversationsByIdsOutput = {
  __typename?: 'UnreadCurrentUserConversationsByIdsOutput';
  success: Scalars['Boolean']['output'];
};

export type UnreadCurrentUserConversationsByIdsResult = GenericException | UnreadCurrentUserConversationsByIdsOutput;

export type UnresolvedQuestion = {
  __typename?: 'UnresolvedQuestion';
  frequency: Scalars['Int']['output'];
  question: Scalars['String']['output'];
};

export type UnsupportedSourceKindException = Exception & {
  __typename?: 'UnsupportedSourceKindException';
  attemptedSourceKind: Scalars['String']['output'];
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type UpdateActionInput = {
  ID: Scalars['ID']['input'];
  authMethodId?: InputMaybe<Scalars['ID']['input']>;
  bodyTemplate?: InputMaybe<Scalars['String']['input']>;
  dataInputs?: InputMaybe<Array<DataInputInput>>;
  dataOutputs?: InputMaybe<Array<DataOutputInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  headers?: InputMaybe<Array<ActionHeaderInput>>;
  method: ActionMethod;
  name: Scalars['String']['input'];
  noOp?: InputMaybe<Scalars['Boolean']['input']>;
  onFailureInstruction?: InputMaybe<Scalars['String']['input']>;
  onSuccessInstruction?: InputMaybe<Scalars['String']['input']>;
  prerequisiteAction?: InputMaybe<Scalars['ID']['input']>;
  runOnConnect?: InputMaybe<Scalars['Boolean']['input']>;
  staticResponse?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
  urlTemplate?: InputMaybe<Scalars['String']['input']>;
  useRawBody?: InputMaybe<Scalars['Boolean']['input']>;
  waitForAudioDrain?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateActivationWizardStepInput = {
  step: ActivationWizardStep;
};

export type UpdateActivationWizardStepOutput = ActivationCapabilityDisabled | ActivationForbidden | ActivationRequestException | ActivationUnauthenticated | ActivationWizardInvalidTransition | ActivationWizardLockConflict | ActivationWizardState | GenericException | UserInputException;

export type UpdateAgentInput = {
  ID: Scalars['ID']['input'];
  availability?: InputMaybe<AvailabilityInput>;
  businessHours?: InputMaybe<BusinessHoursInput>;
  currentRingtone?: InputMaybe<Scalars['String']['input']>;
  customTwilioEdge?: InputMaybe<Scalars['String']['input']>;
  defaultOutPhoneNumberID?: InputMaybe<Scalars['String']['input']>;
  defaultPrefix?: InputMaybe<Scalars['String']['input']>;
  extension?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isOnboardedForTeamsInPhoneNumbers?: InputMaybe<Scalars['Boolean']['input']>;
  isOnboardedOnApp?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers?: InputMaybe<Array<AgentPhoneNumberInput>>;
  pictureURL?: InputMaybe<Scalars['String']['input']>;
  ringTimeout?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<AgentRole>;
  state?: InputMaybe<AgentState>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  useAircallPhoneNumberAsCallerID?: InputMaybe<Scalars['Boolean']['input']>;
  useBestMatchCallerID?: InputMaybe<Scalars['Boolean']['input']>;
  wrapUpTime?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAgentTemplateInput = {
  ID: Scalars['ID']['input'];
  isFavourite?: InputMaybe<Scalars['Boolean']['input']>;
  mediaKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAgentTemplateResult = AgentTemplate | GenericException;

export type UpdateAircallExtractInput = {
  ID: Scalars['ID']['input'];
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  emails: Array<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  mainPhoneNumber: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  secondaryPhoneNumbers: Array<Scalars['String']['input']>;
};

export type UpdateAircallExtractOutput = GenericException | PhoneAircallExtract | UserInputException;

export type UpdateApiKeyOutput = {
  __typename?: 'UpdateApiKeyOutput';
  apiId: Scalars['String']['output'];
  companyId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type UpdateAuthMethodInput = {
  ID: Scalars['ID']['input'];
  apiKey?: InputMaybe<ApiKeyConfigInput>;
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  basicAuth?: InputMaybe<BasicAuthConfigInput>;
  bearerToken?: InputMaybe<BearerTokenConfigInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oauth?: InputMaybe<OAuthConfigInput>;
  resourceOwnerPassword?: InputMaybe<ResourceOwnerPasswordConfigInput>;
  serviceName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AuthMethodStatus>;
};

export type UpdateAutomationInput = {
  config?: InputMaybe<AutomationConfigInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<AutomationFiltersInput>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  scoreCardId?: InputMaybe<ScoreCardId>;
};

export type UpdateAutomationOutput = Automation | GenericException | InsufficientLicenseException | ResourceNotFoundException | UserInputException;

export type UpdateBillingDetailsInput = {
  address?: InputMaybe<Address>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  invoiceEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  origin?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBillingDetailsOutput = {
  __typename?: 'UpdateBillingDetailsOutput';
  company?: Maybe<CompanyBillingDetailsOutput>;
  error?: Maybe<Error>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateBrandDraftInput = {
  business?: InputMaybe<BrandBusinessInput>;
  callingProfiles?: InputMaybe<Array<CallingProfileInput>>;
  country: Scalars['String']['input'];
  documents?: InputMaybe<Array<BrandDocumentInput>>;
  logo?: InputMaybe<BrandDraftLogoInput>;
};

export type UpdateBusinessDraftInput = {
  business?: InputMaybe<BusinessDraftBusinessInput>;
  numbers?: InputMaybe<Array<BusinessDraftNumberInput>>;
};

export type UpdateBusinessRegistrationInput = {
  address?: InputMaybe<BusinessDraftAddressInput>;
  businessVerificationDocument?: InputMaybe<BusinessDraftDocumentInput>;
  contact?: InputMaybe<CreateBusinessRegistrationContactInput>;
  dunsNumber?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<NumberReputationIndustry>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<NumberReputationEmployeeCount>;
  primaryName?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBusinessRegistrationResult = GenericException | NumberReputationException | UpdateBusinessRegistrationSuccess;

export type UpdateBusinessRegistrationSuccess = {
  __typename?: 'UpdateBusinessRegistrationSuccess';
  businessId: Scalars['ID']['output'];
  status: BusinessRegistrationStatus;
  updatedAt: Scalars['String']['output'];
};

export type UpdateCallScoringSettingsInput = {
  agentEvaluationVisible: Scalars['Boolean']['input'];
};

export type UpdateCallScoringSettingsResult = CallScoringSettings | GenericException | InsufficientLicenseException | UserInputException;

export type UpdateCallTaggingSettingsInput = {
  enabled: Scalars['Boolean']['input'];
  guidance: Scalars['String']['input'];
  lineId: Scalars['ID']['input'];
};

export type UpdateCallTaggingSettingsOutput = CallTaggingSettings | GenericException | InsufficientLicenseException | UserInputException;

export type UpdateCallingProfileInput = {
  callPurposeCode?: InputMaybe<CallPurposeCode>;
  expectedCallVolume?: InputMaybe<ExpectedCallVolume>;
  name?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCallingProfileResult = BrandedCallingException | CallingProfileDetails | GenericException;

export type UpdateCompanyInput = {
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  optOutAiSafety?: InputMaybe<Scalars['Boolean']['input']>;
  optOutTroubleshootingInProduct?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanyTranscriptionSettingsInput = {
  csat?: InputMaybe<CsatSettingsData>;
  redaction?: InputMaybe<RedactionSettingsInput>;
};

export type UpdateCompanyTranscriptionSettingsOutput = {
  __typename?: 'UpdateCompanyTranscriptionSettingsOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateConnectPlaneMcpToolSchemaInput = {
  agentType: AgentType;
  applicationId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  inputSchema?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['ID']['input'];
  outputSchema?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['Int']['input'];
};

export type UpdateCoreKbIntegrationInput = {
  auto_refresh_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  provider_account_label?: InputMaybe<Scalars['String']['input']>;
  refresh_period_hours?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateDispatchGroupInput = {
  data?: InputMaybe<UpdateDispatchGroupInputData>;
};

export type UpdateDispatchGroupInputAttributes = {
  priority?: InputMaybe<Scalars['Int']['input']>;
  queuing_timeout?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateDispatchGroupInputData = {
  attributes?: InputMaybe<UpdateDispatchGroupInputAttributes>;
  id?: InputMaybe<Scalars['String']['input']>;
  relationships?: InputMaybe<UpdateDispatchGroupInputRelationships>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDispatchGroupInputRelationships = {
  dispatchable?: InputMaybe<UpdateDispatchGroupInputRelationshipsDispatchable>;
};

export type UpdateDispatchGroupInputRelationshipsDispatchable = {
  data?: InputMaybe<UpdateDispatchGroupInputRelationshipsDispatchableData>;
};

export type UpdateDispatchGroupInputRelationshipsDispatchableData = {
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDynamicClientConfigurationOutput = DynamicClientConfig | GenericException | InsufficientPermissionException | ResourceNotFoundException | UserInputException;

export type UpdateEmailInput = {
  ID: Scalars['ID']['input'];
  newEmail: Scalars['String']['input'];
};

export type UpdateEmergencyAddressInput = {
  address: EmergencyAddressInput;
  agentID: Scalars['ID']['input'];
  callbackNumber: Scalars['String']['input'];
  callerName: Scalars['String']['input'];
  emergencyAddressID: Scalars['ID']['input'];
  preferredLanguage: Scalars['String']['input'];
};

export type UpdateEvalScenarioInput = {
  expectedTool?: InputMaybe<Scalars['String']['input']>;
  expectedTools?: InputMaybe<Array<ExpectedToolInput>>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ScenarioStatus>;
};

export type UpdateEvaluationCategory = {
  ID: Scalars['ID']['input'];
  questions: Array<UpdateEvaluationQuestion>;
  scoreCardCategoryId: Scalars['ID']['input'];
};

export type UpdateEvaluationInput = {
  ID: Scalars['ID']['input'];
  categories: Array<UpdateEvaluationCategory>;
  feedback: Scalars['String']['input'];
  revieweeUserId: Scalars['ID']['input'];
};

export type UpdateEvaluationQuestion = {
  ID: Scalars['ID']['input'];
  binaryAnswer?: InputMaybe<BinaryAnswerValue>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  ratingAnswer?: InputMaybe<RatingAnswerValue>;
  scoreCardQuestionId: Scalars['ID']['input'];
};

export type UpdateGsmDeviceInput = {
  cellularModeActive: Scalars['Boolean']['input'];
  deviceId: Scalars['String']['input'];
};

export type UpdateGsmDeviceOutput = GsmDevice | GenericException | ResourceNotFoundException | UserInputException;

export type UpdateHubspotCallPropertiesInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  agentOverrideActivityType?: InputMaybe<Scalars['String']['input']>;
  agentOverrideDisposition?: InputMaybe<Scalars['String']['input']>;
  callId: Scalars['ID']['input'];
  data?: InputMaybe<Scalars['AWSJSON']['input']>;
  portalId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateHubspotCallPropertiesOutput = {
  __typename?: 'UpdateHubspotCallPropertiesOutput';
  engagementUpdated: Scalars['Boolean']['output'];
};

export type UpdateHubspotEngagementAssociationsInput = {
  associations: Array<HubspotEngagementAssociationChange>;
  callId: Scalars['ID']['input'];
  engagementId: Scalars['String']['input'];
  portalId: Scalars['String']['input'];
};

export type UpdateHubspotEngagementAssociationsOutput = {
  __typename?: 'UpdateHubspotEngagementAssociationsOutput';
  engagementId: Scalars['String']['output'];
  results: Array<HubspotEngagementAssociationResult>;
  success: Scalars['Boolean']['output'];
};

export type UpdateIntegrationPayload = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  customName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateIntegrationScopeOutput = {
  __typename?: 'UpdateIntegrationScopeOutput';
  redirectUri: Scalars['String']['output'];
};

export type UpdateIvrSettingInput = {
  ivrSettingId: Scalars['String']['input'];
  ivrSettingkey: Scalars['String']['input'];
  numberId: Scalars['String']['input'];
  redirectingExternalNumber: Scalars['String']['input'];
  redirectingNumberId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateKbClientTypeInput = {
  client_type: Scalars['String']['input'];
};

export type UpdateKbClientTypeResult = {
  __typename?: 'UpdateKBClientTypeResult';
  client_type: Scalars['String']['output'];
  kb_id: Scalars['ID']['output'];
  updated_at: Scalars['AWSDateTime']['output'];
};

export type UpdateKbClientTypeResultUnion = GenericException | UpdateKbClientTypeResult;

export type UpdateLineInput = {
  allowInboundRecordingActions?: InputMaybe<Scalars['Boolean']['input']>;
  allowOutboundRecordingActions?: InputMaybe<Scalars['Boolean']['input']>;
  allowRealtimeTranscription?: InputMaybe<Scalars['Boolean']['input']>;
  inboundRecordingActivated?: InputMaybe<Scalars['Boolean']['input']>;
  ivr?: InputMaybe<Scalars['Boolean']['input']>;
  lineID: Scalars['ID']['input'];
  mandatoryTaggingActivated?: InputMaybe<Scalars['Boolean']['input']>;
  musicOnHold?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  outboundRecordingActivated?: InputMaybe<Scalars['Boolean']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLineTranscriptionSettingsInput = {
  calls?: InputMaybe<CallTranscriptionSettingsData>;
  csat?: InputMaybe<CsatSettingsData>;
  lineId: Scalars['Int']['input'];
  lineLanguage: Scalars['String']['input'];
  redaction?: InputMaybe<RedactionSettingsInput>;
  secondaryLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  voicemails?: InputMaybe<VoicemailTranscriptionSettingsData>;
};

export type UpdateLineTranscriptionSettingsOutput = {
  __typename?: 'UpdateLineTranscriptionSettingsOutput';
  settings: LineTranscriptionSettings;
};

export type UpdateLoaEnvelopeStatusInput = {
  embeddedSigningUrl?: InputMaybe<Scalars['String']['input']>;
  envelopeId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  signerEmail?: InputMaybe<Scalars['String']['input']>;
  signerName?: InputMaybe<Scalars['String']['input']>;
  status: LoaEnvelopeStatus;
};

export type UpdateLoaEnvelopeStatusResult = BrandedCallingException | GenericException | LoaEnvelope;

export type UpdateMessageStatusInput = {
  channel?: InputMaybe<Scalars['String']['input']>;
  companyID: Scalars['ID']['input'];
  groupConversationId?: InputMaybe<Scalars['ID']['input']>;
  lineID: Scalars['ID']['input'];
  messageID: Scalars['ID']['input'];
  status: MessageStatus;
  undeliveredReason?: InputMaybe<MessageUndeliveredReason>;
};

export type UpdateMessageStatusOutput = {
  __typename?: 'UpdateMessageStatusOutput';
  error?: Maybe<Error>;
  lineID: Scalars['ID']['output'];
  message?: Maybe<Message>;
};

export type UpdateMessagingAiAgentResult = GenericException | MessagingAiAgent | ResourceNotFoundException | UserInputException;

export type UpdateNextActionInput = {
  ID: Scalars['ID']['input'];
  content: Scalars['String']['input'];
};

export type UpdateNumberInput = {
  data?: InputMaybe<UpdateNumberInputData>;
};

export type UpdateNumberInputData = {
  attributes: UpdateNumberInputDataAttributes;
  id: Scalars['Int']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNumberInputDataAttributes = {
  activationState?: InputMaybe<Scalars['String']['input']>;
  afterHoursVoicemail?: InputMaybe<Scalars['Boolean']['input']>;
  allowInboundRecordingActions?: InputMaybe<Scalars['Boolean']['input']>;
  allowOutboundRecordingActions?: InputMaybe<Scalars['Boolean']['input']>;
  inboundRecordingActivated?: InputMaybe<Scalars['Boolean']['input']>;
  iso3166Alpha2?: InputMaybe<Scalars['String']['input']>;
  ivr?: InputMaybe<Scalars['Boolean']['input']>;
  mandatoryTaggingActivated?: InputMaybe<Scalars['Boolean']['input']>;
  missedCallVoicemail?: InputMaybe<Scalars['Boolean']['input']>;
  musicOnHold?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  numberFormatted?: InputMaybe<Scalars['String']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  outboundRecordingActivated?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  queueCallbackActivated?: InputMaybe<Scalars['Boolean']['input']>;
  replayIvrMessage?: InputMaybe<Scalars['Boolean']['input']>;
  respectQueueingTime?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  verificationState?: InputMaybe<Scalars['String']['input']>;
  welcomeMessageEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOnboardingStepInput = {
  completionType?: InputMaybe<CompletionType>;
  stepStatus: StepStatus;
  stepType: StepType;
};

export type UpdateOnboardingStepOutput = GenericException | Onboarding | UserInputException;

export type UpdateOutboundCampaignContactImportRowOutput = GenericException | OutboundCampaignContactImportRow | ResourceNotFoundException | UserInputException;

export type UpdateOutboundCampaignInput = {
  assignedTeamIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  assignedUserIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  callAttempts?: InputMaybe<Scalars['Int']['input']>;
  callerIdNumbers?: InputMaybe<Array<OutboundCampaignCallerIdNumberInput>>;
  callerIdStrategy?: InputMaybe<OutboundCampaignCallerIdStrategy>;
  campaignOutcomeTime?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalRingingTimeout?: InputMaybe<Scalars['Int']['input']>;
  localPresence?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  outcomeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  retryInterval?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOutboundCampaignOutcomeInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateOutboundCampaignOutcomeOutput = GenericException | OutboundCampaignOutcome | OutboundCampaignOutcomeAlreadyExistsException | OutboundCampaignReservedOutcomeNameException | ResourceNotFoundException | UserInputException;

export type UpdateOutboundCampaignOutput = GenericException | OutboundCampaign | ResourceNotFoundException | UnprocessableResourceException | UserInputException;

export type UpdatePrerecordedMessageInput = {
  ID: Scalars['String']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePrerecordedMessageOutput = GenericException | PrerecordedMessage | ResourceNotFoundException | UserInputException;

export type UpdatePrivilegedUsersInput = {
  add?: InputMaybe<Array<Scalars['Int']['input']>>;
  remove?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateProfileInput = {
  coachingLanguage: Scalars['String']['input'];
};

export type UpdateProfileResult = GenericException | ProfileResponse | ResourceNotFoundException;

export type UpdateScenarioInput = {
  configJson: Scalars['String']['input'];
  name: Scalars['String']['input'];
  successCriteria?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateScenarioOutput = GenericException | ResourceNotFoundException | Scenario | UserInputException;

export type UpdateSignInStrategyInput = {
  strategies: Array<Scalars['String']['input']>;
};

export type UpdateTagInput = {
  color: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateTeamInput = {
  ID: Scalars['ID']['input'];
  agentsIdsToAdd?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  agentsIdsToRemove?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  imageName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTextToSpeechInput = {
  data: UpdateTextToSpeechInputData;
};

export type UpdateTextToSpeechInputData = {
  attributes?: InputMaybe<TextToSpeechPreviewDataAttributesInput>;
  id: Scalars['String']['input'];
  relationships: UpdateTextToSpeechInputRelationshipInput;
  type: Scalars['String']['input'];
};

export type UpdateTextToSpeechInputRelationshipInput = {
  number: UpdateTextToSpeechInputRelationshipNumberInput;
};

export type UpdateTextToSpeechInputRelationshipNumberDataInput = {
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type UpdateTextToSpeechInputRelationshipNumberInput = {
  data: UpdateTextToSpeechInputRelationshipNumberDataInput;
};

export type UpdateTrackerFiltersInput = {
  agentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  direction?: InputMaybe<CallDirection>;
  excludeQueryTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  lineIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  queryTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  speakerType?: InputMaybe<SpeakerTrackerType>;
};

export type UpdateTrackerInput = {
  filters?: InputMaybe<UpdateTrackerFiltersInput>;
  title: Scalars['String']['input'];
  trackerId: Scalars['Int']['input'];
};

export type UpdateUnreadMessagesInput = {
  agentID: Scalars['ID']['input'];
  conversationID: Scalars['ID']['input'];
  unreadConversationsCount: Scalars['Int']['input'];
  unreadMessagesCount: Scalars['Int']['input'];
};

export type UpdateUnreadMessagesOutput = {
  __typename?: 'UpdateUnreadMessagesOutput';
  agentID?: Maybe<Scalars['ID']['output']>;
  conversationID?: Maybe<Scalars['ID']['output']>;
  error?: Maybe<Error>;
  unreadConversationsCount?: Maybe<Scalars['Int']['output']>;
  unreadMessagesCount?: Maybe<Scalars['Int']['output']>;
};

export type UpdateUserPasswordMutationInput = {
  confirmationPassword: Scalars['String']['input'];
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type UpdateVirtualAgentInput = {
  ID: Scalars['ID']['input'];
  aiActions?: InputMaybe<Array<AiActionInput>>;
  callDirection?: InputMaybe<CallDirection>;
  capabilities?: InputMaybe<VirtualAgentCapabilitiesInput>;
  configOverride?: InputMaybe<ConfigOverrideInput>;
  customPrompt?: InputMaybe<Scalars['String']['input']>;
  customVoiceId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabledFlags?: InputMaybe<Array<AgentFlag>>;
  extractionTask: ExtractionTaskInput;
  farewellMessage?: InputMaybe<Scalars['String']['input']>;
  greetingMessage?: InputMaybe<Scalars['String']['input']>;
  knowledgeBase: VirtualAgentKnowledgeInput;
  outboundConfig?: InputMaybe<OutboundConfigInput>;
  personality: VirtualAgentPersonalityInput;
  version: Scalars['Int']['input'];
  vogentAgentId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVirtualAgentUsageAlertInput = {
  ID: Scalars['ID']['input'];
  billingEmailEnabled: Scalars['Boolean']['input'];
  thresholdPercentages: Array<Scalars['Int']['input']>;
  usageLimitMinutes: Scalars['Int']['input'];
  userEmailEnabled: Scalars['Boolean']['input'];
};

export type UpdateWebhookInput = {
  customName?: InputMaybe<Scalars['String']['input']>;
  events: Array<Scalars['String']['input']>;
  eventsAction?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type UpdateWhatsAppTemplateFavouritesInput = {
  isFavourite: Scalars['Boolean']['input'];
  templateID: Scalars['Int']['input'];
};

export type UpdateWhatsAppTemplateFavouritesOutput = {
  __typename?: 'UpdateWhatsAppTemplateFavouritesOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateWhatsAppTemplateFavouritesResult = GenericException | UpdateWhatsAppTemplateFavouritesOutput;

export type UpdatedTracker = {
  __typename?: 'UpdatedTracker';
  tracker: Tracker;
};

export type UpdatedTrackerOutput = GenericException | InsufficientLicenseException | InvalidTrackerName | UpdatedTracker;

export type UpgradePlanInput = {
  currency: PlanCurrency;
  numberOfLinceses?: InputMaybe<Scalars['Int']['input']>;
  numberOfLines?: InputMaybe<Scalars['Int']['input']>;
  plan: Scalars['String']['input'];
  planEdition?: InputMaybe<Scalars['String']['input']>;
  recurrence: PlanRecurrence;
  stripeRadarSessionId?: InputMaybe<Scalars['String']['input']>;
};

export type UpgradePlanOutput = {
  __typename?: 'UpgradePlanOutput';
  error?: Maybe<Error>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UploadAudioFilePayload = {
  __typename?: 'UploadAudioFilePayload';
  fields: UploadFileField;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  readUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type UploadBrandDraftLogoInput = {
  draftId: Scalars['ID']['input'];
  fileContent: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
};

export type UploadBrandDraftLogoResult = BrandDraftLogoResponse | BrandedCallingException | GenericException;

export type UploadBrandLogoInput = {
  fileContent: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
};

export type UploadBrandLogoResult = BrandLogoResponse | BrandedCallingException | GenericException;

export type UploadBulkUsersInput = {
  roles: Array<RoleInput>;
  urlData: Scalars['String']['input'];
};

export type UploadBulkUsersResult = {
  __typename?: 'UploadBulkUsersResult';
  createdCount?: Maybe<Scalars['Int']['output']>;
  createdUsers?: Maybe<Array<AgentV2>>;
  error?: Maybe<BulkUserError>;
  errorsList?: Maybe<Array<Scalars['String']['output']>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UploadContactImageInput = {
  base64: Scalars['String']['input'];
  contactId: Scalars['ID']['input'];
};

export type UploadFileField = {
  __typename?: 'UploadFileField';
  acl: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  expires: Scalars['String']['output'];
  key: Scalars['String']['output'];
  policy: Scalars['String']['output'];
  successActionStatus: Scalars['String']['output'];
  xAmzAlgorithm: Scalars['String']['output'];
  xAmzCredential: Scalars['String']['output'];
  xAmzDate: Scalars['String']['output'];
  xAmzSecurityToken: Scalars['String']['output'];
  xAmzSignature: Scalars['String']['output'];
};

export type UploadPortingDocumentData = {
  __typename?: 'UploadPortingDocumentData';
  fieldRefId: Scalars['Int']['output'];
  requirementFieldId: Scalars['Int']['output'];
  s3Url: Scalars['String']['output'];
  uploadedAt: Scalars['String']['output'];
};

export type UploadPortingDocumentInput = {
  fieldRefId: Scalars['Int']['input'];
  fileContent: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  portingRequestUUID: Scalars['String']['input'];
};

export type UploadPortingDocumentResponse = {
  __typename?: 'UploadPortingDocumentResponse';
  data?: Maybe<UploadPortingDocumentData>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UploadProfileImageInput = {
  base64: Scalars['String']['input'];
  entity: ProfileImageEntity;
};

export type UpsertEvalPersonaInput = {
  name: Scalars['String']['input'];
  persona: Scalars['String']['input'];
  personaId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertEvalPersonaOutput = EvalPersona | GenericException | UserInputException;

export type UpsertPortingRequestInput = {
  countryId: Scalars['Int']['input'];
  draftBatches?: InputMaybe<Array<DraftBatchInput>>;
  isRange: Scalars['Boolean']['input'];
  losingCarrier: Scalars['String']['input'];
  numbers: Array<PortingNumberInput>;
  phoneType: Scalars['String']['input'];
  portingRequestUUID?: InputMaybe<Scalars['String']['input']>;
  preferredPortingDate?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  winningCarrierId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertPortingRequestResponse = {
  __typename?: 'UpsertPortingRequestResponse';
  created: Scalars['Boolean']['output'];
  draftRequests?: Maybe<Array<UpsertPortingRequestResponse>>;
  numbers: Array<PortingNumber>;
  portingRequestUUID: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  companyId: Scalars['Int']['output'];
  currentRingtone: Scalars['String']['output'];
  defaultOutNumberId?: Maybe<Scalars['Int']['output']>;
  defaultPrefix: Scalars['String']['output'];
  email: Scalars['String']['output'];
  extension: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  intercomHash?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isAdmin: Scalars['Boolean']['output'];
  isAvailable: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  migratedOnAuthenticationManager: Scalars['Boolean']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  ringTimeout: Scalars['Int']['output'];
  sipSettings: Array<UserSipSettings>;
  state: Scalars['String']['output'];
  teams?: Maybe<Array<Team>>;
  timeZone: Scalars['String']['output'];
  unconfirmedEmail?: Maybe<Scalars['String']['output']>;
  useAircallPhonenumberAsCallerid: Scalars['Boolean']['output'];
  wrapUpTime?: Maybe<Scalars['Int']['output']>;
};

export type UserAppActivityReportOutput = {
  __typename?: 'UserAppActivityReportOutput';
  url: Scalars['String']['output'];
};

export type UserCriticalAction = {
  __typename?: 'UserCriticalAction';
  action: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  agentID: Scalars['ID']['output'];
};

export type UserEvaluated = {
  __typename?: 'UserEvaluated';
  categoryScores: Array<CategoryScore>;
  evaluations: Scalars['Int']['output'];
  normalizedScore?: Maybe<Scalars['Float']['output']>;
  reviewed: Scalars['Int']['output'];
  user: PhoneTeammateResolver;
};

export type UserInputException = Exception & {
  __typename?: 'UserInputException';
  code: Scalars['String']['output'];
  issues: Array<FieldException>;
  message: Scalars['String']['output'];
};

export type UserLicense = {
  __typename?: 'UserLicense';
  active: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  expireAt?: Maybe<Scalars['String']['output']>;
  isAssigned?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  trialRemainingDays?: Maybe<Scalars['Int']['output']>;
};

export type UserLicensesOutput = {
  __typename?: 'UserLicensesOutput';
  licenses: Array<UserLicense>;
  userId: Scalars['String']['output'];
};

export type UserNumber = {
  __typename?: 'UserNumber';
  countryIso: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  normalized?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
};

export type UserNumbers = {
  __typename?: 'UserNumbers';
  meta: MetaV3;
  numbers: Array<UserNumber>;
};

export type UserResolver = {
  __typename?: 'UserResolver';
  entity?: Maybe<AgentV2OutputResolver>;
};

export type UserResolverInput = {
  __typename?: 'UserResolverInput';
  ID: Scalars['ID']['output'];
};

export type UserSipSettings = {
  __typename?: 'UserSipSettings';
  domain: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isEnabled: Scalars['Boolean']['output'];
  password?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type Utterance = {
  __typename?: 'Utterance';
  channel: Scalars['Int']['output'];
  confidence: Scalars['Float']['output'];
  endTime: Scalars['Float']['output'];
  entries: Array<Entry>;
  rawText: Scalars['String']['output'];
  startTime: Scalars['Float']['output'];
};

export type UtteranceSentiment = {
  __typename?: 'UtteranceSentiment';
  createdAt: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  type: SentimentType;
  value: SentimentValue;
};

export type ValidateA2PFormInput = {
  checkUrls?: InputMaybe<Scalars['Boolean']['input']>;
  companyId: Scalars['Int']['input'];
  formFields: Scalars['String']['input'];
};

export type ValidateA2PFormOutput = {
  __typename?: 'ValidateA2PFormOutput';
  issues: Array<A2PValidationIssue>;
  urlEvidenceRunId?: Maybe<Scalars['String']['output']>;
};

export type ValidateA2PFormResult = GenericException | ValidateA2PFormOutput;

export type ValidateNumbersPortabilityInput = {
  country: Scalars['String']['input'];
  numbers: Array<Scalars['String']['input']>;
};

export type ValidateNumbersPortabilityResponse = {
  __typename?: 'ValidateNumbersPortabilityResponse';
  manualReview: Array<PortabilityException>;
  nonPortable: Array<PortabilityException>;
  portableBatches: Array<PortabilityBatch>;
};

export type ValidationItem = {
  __typename?: 'ValidationItem';
  description?: Maybe<Scalars['String']['output']>;
  value: ItemValidationValue;
};

export type ValidationItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value: ItemValidationValue;
};

export type ValidationResponse = {
  __typename?: 'ValidationResponse';
  options: Array<ValidationItem>;
};

export type ValidationRule = {
  __typename?: 'ValidationRule';
  field: Scalars['String']['output'];
  matchType: MatchType;
  onFailure: Scalars['String']['output'];
};

export type ValidationRuleInput = {
  field: Scalars['String']['input'];
  matchType: MatchType;
  onFailure: Scalars['String']['input'];
};

export type VerifyGsmDeviceInput = {
  code: Scalars['String']['input'];
  deviceId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};

export type VerifyGsmDeviceOutput = GsmDeviceVerified | GenericException | UserInputException;

export type VirtualAgent = {
  __typename?: 'VirtualAgent';
  ID: Scalars['ID']['output'];
  aiActions?: Maybe<Array<AiAction>>;
  buildStatus: VirtualAgentBuildStatus;
  builderPrompt?: Maybe<Scalars['String']['output']>;
  callDirection?: Maybe<CallDirection>;
  capabilities?: Maybe<VirtualAgentCapabilities>;
  configOverride?: Maybe<ConfigOverride>;
  contextVariables?: Maybe<AgentContextVariables>;
  createdAt: Scalars['String']['output'];
  customPrompt?: Maybe<Scalars['String']['output']>;
  customVoiceId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabledFlags?: Maybe<Array<AgentFlag>>;
  extractionTask: ExtractionTask;
  farewellMessage?: Maybe<Scalars['String']['output']>;
  greetingMessage?: Maybe<Scalars['String']['output']>;
  isAgentBuilderBuilt: Scalars['Boolean']['output'];
  knowledgeBase: VirtualAgentKnowledge;
  lines?: Maybe<LinesInfoResolver>;
  outboundConfig?: Maybe<OutboundConfig>;
  personality: VirtualAgentPersonality;
  updatedAt: Scalars['String']['output'];
  version: Scalars['Int']['output'];
  vogentAgentId?: Maybe<Scalars['String']['output']>;
  vogentConfig?: Maybe<VogentConfig>;
};

export type VirtualAgentActivationStatusOutput = GenericException | VirtualAgentActivationStatusResponse;

export type VirtualAgentActivationStatusResponse = {
  __typename?: 'VirtualAgentActivationStatusResponse';
  enabled: Scalars['Boolean']['output'];
};

export enum VirtualAgentBuildStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  READY = 'READY'
}

export type VirtualAgentCapabilities = {
  __typename?: 'VirtualAgentCapabilities';
  enableEscalation?: Maybe<Scalars['Boolean']['output']>;
  escalationProtocol?: Maybe<VirtualAgentEscalationProtocol>;
  outboundEscalationTarget?: Maybe<OutboundEscalationTarget>;
  outboundEscalationTrigger?: Maybe<Scalars['String']['output']>;
  transferBranches?: Maybe<Array<VirtualAgentTransferBranch>>;
  transferMessage?: Maybe<Scalars['String']['output']>;
};

export type VirtualAgentCapabilitiesInput = {
  enableEscalation?: InputMaybe<Scalars['Boolean']['input']>;
  escalationProtocol?: InputMaybe<VirtualAgentEscalationProtocol>;
  outboundEscalationTarget?: InputMaybe<OutboundEscalationTargetInput>;
  outboundEscalationTrigger?: InputMaybe<Scalars['String']['input']>;
  transferBranches?: InputMaybe<Array<VirtualAgentTransferBranchInput>>;
  transferMessage?: InputMaybe<Scalars['String']['input']>;
};

export type VirtualAgentCompanyInfoInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type VirtualAgentCompanyInfoOutput = {
  __typename?: 'VirtualAgentCompanyInfoOutput';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type VirtualAgentDraft = {
  __typename?: 'VirtualAgentDraft';
  agentId: Scalars['ID']['output'];
  aiActions?: Maybe<Array<AiAction>>;
  baseVersion?: Maybe<Scalars['Int']['output']>;
  callDirection?: Maybe<CallDirection>;
  capabilities?: Maybe<VirtualAgentCapabilities>;
  companyId: Scalars['Int']['output'];
  configOverride?: Maybe<ConfigOverride>;
  createdAt: Scalars['String']['output'];
  customPrompt?: Maybe<Scalars['String']['output']>;
  customVoiceId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  draftId: Scalars['ID']['output'];
  enabledFlags?: Maybe<Array<AgentFlag>>;
  extractionTask: ExtractionTask;
  farewellMessage?: Maybe<Scalars['String']['output']>;
  flowConfig?: Maybe<Scalars['String']['output']>;
  greetingMessage?: Maybe<Scalars['String']['output']>;
  knowledgeBase: VirtualAgentKnowledge;
  language: Scalars['String']['output'];
  lastEditedBy?: Maybe<Scalars['String']['output']>;
  lines?: Maybe<LinesInfoResolver>;
  outboundConfig?: Maybe<OutboundConfig>;
  personality: VirtualAgentPersonality;
  publishedAt?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  version: Scalars['Int']['output'];
  vogentAgentId?: Maybe<Scalars['String']['output']>;
};

export enum VirtualAgentEscalationProtocol {
  AFTER_INTAKE = 'AFTER_INTAKE',
  HELP_FIRST = 'HELP_FIRST',
  IMMEDIATE = 'IMMEDIATE'
}

export type VirtualAgentExport = {
  __typename?: 'VirtualAgentExport';
  agentData: Scalars['String']['output'];
};

export type VirtualAgentKnowledge = {
  __typename?: 'VirtualAgentKnowledge';
  companyInfo: VirtualAgentCompanyInfoOutput;
  faq: Scalars['String']['output'];
};

export type VirtualAgentKnowledgeInput = {
  companyInfo?: InputMaybe<VirtualAgentCompanyInfoInput>;
  faq?: InputMaybe<Scalars['String']['input']>;
};

export type VirtualAgentOutput = ConflictException | GenericException | UserInputException | VirtualAgent;

export type VirtualAgentPaginatedOutput = {
  __typename?: 'VirtualAgentPaginatedOutput';
  items: Array<VirtualAgent>;
  pageInfo?: Maybe<SmartflowsPageInfo>;
};

export type VirtualAgentPersonality = {
  __typename?: 'VirtualAgentPersonality';
  name: Scalars['String']['output'];
  tone: VirtualAgentTone;
  voice: VirtualAgentVoiceType;
};

export type VirtualAgentPersonalityInput = {
  name: Scalars['String']['input'];
  tone: VirtualAgentTone;
  voice: VirtualAgentVoiceType;
};

export type VirtualAgentPromotion = {
  __typename?: 'VirtualAgentPromotion';
  expiresAt?: Maybe<Scalars['String']['output']>;
  freeMinutes: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type VirtualAgentResolver = {
  __typename?: 'VirtualAgentResolver';
  entity?: Maybe<VirtualAgentOutput>;
};

export type VirtualAgentResolverInput = {
  __typename?: 'VirtualAgentResolverInput';
  virtualAgentID: Scalars['ID']['output'];
};

export type VirtualAgentSpeaker = {
  __typename?: 'VirtualAgentSpeaker';
  channel: Scalars['Int']['output'];
  virtualAgent: VirtualAgentResolver;
};

export type VirtualAgentTemplate = {
  __typename?: 'VirtualAgentTemplate';
  callDirection: CallDirection;
  capabilityTools: Array<VirtualAgentTemplateCapabilityTool>;
  customPrompt: Scalars['String']['output'];
  demoAgentId?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  enableEscalation: Scalars['Boolean']['output'];
  farewellMessage: Scalars['String']['output'];
  greetingMessage: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  intakeQuestions: Array<VirtualAgentTemplateIntakeQuestion>;
  language: Scalars['String']['output'];
  name: Scalars['String']['output'];
  personalityName: Scalars['String']['output'];
  requiredIntegrations: Array<Scalars['String']['output']>;
  steps: Array<VirtualAgentTemplateWizardStep>;
  tone: VirtualAgentTone;
  version: Scalars['Int']['output'];
  voice: VirtualAgentVoiceType;
};

export type VirtualAgentTemplateCapabilityTool = {
  __typename?: 'VirtualAgentTemplateCapabilityTool';
  integrationName: Scalars['String']['output'];
  runOnConnectTitles: Array<Scalars['String']['output']>;
  titles: Array<Scalars['String']['output']>;
};

export type VirtualAgentTemplateIntakeQuestion = {
  __typename?: 'VirtualAgentTemplateIntakeQuestion';
  id: Scalars['ID']['output'];
  mappedParam: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type VirtualAgentTemplateList = {
  __typename?: 'VirtualAgentTemplateList';
  items: Array<VirtualAgentTemplate>;
};

export enum VirtualAgentTemplateWizardStep {
  CAPABILITIES = 'CAPABILITIES',
  INTAKE_QUESTIONS = 'INTAKE_QUESTIONS',
  OVERVIEW = 'OVERVIEW',
  ROLE_AND_TASKS = 'ROLE_AND_TASKS',
  VOICE_AND_SPEECH = 'VOICE_AND_SPEECH'
}

export enum VirtualAgentTone {
  CASUAL_AND_FRIENDLY = 'CASUAL_AND_FRIENDLY',
  SERIOUS_AND_PROFESSIONAL = 'SERIOUS_AND_PROFESSIONAL'
}

export type VirtualAgentTransferBranch = {
  __typename?: 'VirtualAgentTransferBranch';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  transferMessage: Scalars['String']['output'];
  triggerCondition: Scalars['String']['output'];
};

export type VirtualAgentTransferBranchInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  transferMessage: Scalars['String']['input'];
  triggerCondition: Scalars['String']['input'];
};

export type VirtualAgentTrialSession = {
  __typename?: 'VirtualAgentTrialSession';
  ID: Scalars['ID']['output'];
  expiresAt: Scalars['String']['output'];
};

export type VirtualAgentUsage = {
  __typename?: 'VirtualAgentUsage';
  billedUsage?: Maybe<BilledUsage>;
  companyId: Scalars['Int']['output'];
  promotion?: Maybe<VirtualAgentPromotion>;
  promotionEndedAt?: Maybe<Scalars['String']['output']>;
  promotionalMinutesUsed: Scalars['Int']['output'];
  totalMinutesUsed: Scalars['Int']['output'];
  trialMinutesUsed: Scalars['Int']['output'];
};

export type VirtualAgentUsageAlert = {
  __typename?: 'VirtualAgentUsageAlert';
  ID: Scalars['ID']['output'];
  billingEmailEnabled: Scalars['Boolean']['output'];
  companyId: Scalars['Int']['output'];
  thresholdPercentages: Array<Scalars['Int']['output']>;
  usageLimitMinutes: Scalars['Int']['output'];
  userEmailEnabled: Scalars['Boolean']['output'];
  userRecipients: Array<Scalars['String']['output']>;
};

export type VirtualAgentUsageAlertOutput = GenericException | ResourceNotFoundException | UserInputException | VirtualAgentUsageAlert;

export type VirtualAgentUsageOutput = GenericException | VirtualAgentUsage;

export enum VirtualAgentVoiceType {
  FEMALE_AU = 'FEMALE_AU',
  FEMALE_AU_CARTESIA = 'FEMALE_AU_CARTESIA',
  FEMALE_BG = 'FEMALE_BG',
  FEMALE_CS = 'FEMALE_CS',
  FEMALE_DA = 'FEMALE_DA',
  FEMALE_DE = 'FEMALE_DE',
  FEMALE_DE_CARTESIA = 'FEMALE_DE_CARTESIA',
  FEMALE_DE_CARTESIA_2 = 'FEMALE_DE_CARTESIA_2',
  FEMALE_DE_GRADIUM = 'FEMALE_DE_GRADIUM',
  FEMALE_EL = 'FEMALE_EL',
  FEMALE_EL_CARTESIA = 'FEMALE_EL_CARTESIA',
  FEMALE_ES_ES = 'FEMALE_ES_ES',
  FEMALE_ES_ES_CARTESIA = 'FEMALE_ES_ES_CARTESIA',
  FEMALE_ES_ES_CARTESIA_2 = 'FEMALE_ES_ES_CARTESIA_2',
  FEMALE_ES_LA = 'FEMALE_ES_LA',
  FEMALE_ES_LA_CARTESIA = 'FEMALE_ES_LA_CARTESIA',
  FEMALE_ES_LA_CARTESIA_2 = 'FEMALE_ES_LA_CARTESIA_2',
  FEMALE_FI = 'FEMALE_FI',
  FEMALE_FIL = 'FEMALE_FIL',
  FEMALE_FR = 'FEMALE_FR',
  FEMALE_FR_CARTESIA = 'FEMALE_FR_CARTESIA',
  FEMALE_HR = 'FEMALE_HR',
  FEMALE_HU = 'FEMALE_HU',
  FEMALE_IT = 'FEMALE_IT',
  FEMALE_NL = 'FEMALE_NL',
  FEMALE_NO = 'FEMALE_NO',
  FEMALE_PL = 'FEMALE_PL',
  FEMALE_PT_PT = 'FEMALE_PT_PT',
  FEMALE_RO = 'FEMALE_RO',
  FEMALE_RU = 'FEMALE_RU',
  FEMALE_SK = 'FEMALE_SK',
  FEMALE_SV = 'FEMALE_SV',
  FEMALE_TR = 'FEMALE_TR',
  FEMALE_UA = 'FEMALE_UA',
  FEMALE_UK = 'FEMALE_UK',
  FEMALE_UK_CARTESIA = 'FEMALE_UK_CARTESIA',
  FEMALE_US = 'FEMALE_US',
  FEMALE_US_CARTESIA = 'FEMALE_US_CARTESIA',
  FEMALE_US_VOGENT = 'FEMALE_US_VOGENT',
  FEMALE_ZH = 'FEMALE_ZH',
  MALE_AU = 'MALE_AU',
  MALE_AU_CARTESIA = 'MALE_AU_CARTESIA',
  MALE_BG = 'MALE_BG',
  MALE_CS = 'MALE_CS',
  MALE_DA = 'MALE_DA',
  MALE_DE = 'MALE_DE',
  MALE_DE_CARTESIA = 'MALE_DE_CARTESIA',
  MALE_DE_CARTESIA_2 = 'MALE_DE_CARTESIA_2',
  MALE_DE_GRADIUM = 'MALE_DE_GRADIUM',
  MALE_EL = 'MALE_EL',
  MALE_EL_CARTESIA = 'MALE_EL_CARTESIA',
  MALE_ES_ES = 'MALE_ES_ES',
  MALE_ES_ES_CARTESIA = 'MALE_ES_ES_CARTESIA',
  MALE_ES_ES_CARTESIA_2 = 'MALE_ES_ES_CARTESIA_2',
  MALE_ES_LA = 'MALE_ES_LA',
  MALE_ES_LA_CARTESIA = 'MALE_ES_LA_CARTESIA',
  MALE_ES_LA_CARTESIA_2 = 'MALE_ES_LA_CARTESIA_2',
  MALE_FI = 'MALE_FI',
  MALE_FIL = 'MALE_FIL',
  MALE_FR = 'MALE_FR',
  MALE_FR_CARTESIA = 'MALE_FR_CARTESIA',
  MALE_HR = 'MALE_HR',
  MALE_HU = 'MALE_HU',
  MALE_IT = 'MALE_IT',
  MALE_NL = 'MALE_NL',
  MALE_NO = 'MALE_NO',
  MALE_PL = 'MALE_PL',
  MALE_PT_PT = 'MALE_PT_PT',
  MALE_RO = 'MALE_RO',
  MALE_RU = 'MALE_RU',
  MALE_SK = 'MALE_SK',
  MALE_SV = 'MALE_SV',
  MALE_TR = 'MALE_TR',
  MALE_UA = 'MALE_UA',
  MALE_UK = 'MALE_UK',
  MALE_UK_CARTESIA = 'MALE_UK_CARTESIA',
  MALE_US = 'MALE_US',
  MALE_US_CARTESIA = 'MALE_US_CARTESIA',
  MALE_US_VOGENT = 'MALE_US_VOGENT'
}

export type Vocabulary = {
  __typename?: 'Vocabulary';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type VogentConfig = {
  __typename?: 'VogentConfig';
  linkedAt?: Maybe<Scalars['String']['output']>;
  numberId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  sipUri?: Maybe<Scalars['String']['output']>;
};

export type Voice = {
  __typename?: 'Voice';
  displayName: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  id: Scalars['String']['output'];
  languages: Array<VoiceLanguage>;
  provider: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type VoiceAgentParticipant = {
  __typename?: 'VoiceAgentParticipant';
  connectEnd?: Maybe<Scalars['AWSDateTime']['output']>;
  connectStart?: Maybe<Scalars['AWSDateTime']['output']>;
  endReason?: Maybe<Scalars['String']['output']>;
  sessionID?: Maybe<Scalars['String']['output']>;
  voiceAgentID: Scalars['String']['output'];
};

export type VoiceAgents = {
  __typename?: 'VoiceAgents';
  data: Array<VirtualAgentResolver>;
  innerError?: Maybe<VoiceAgentsCounterInnerError>;
  total: Scalars['Int']['output'];
};

export type VoiceAgentsCounterInnerError = {
  __typename?: 'VoiceAgentsCounterInnerError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type VoiceLanguage = {
  __typename?: 'VoiceLanguage';
  language: Scalars['String']['output'];
  locale?: Maybe<Scalars['String']['output']>;
};

export type VoiceList = {
  __typename?: 'VoiceList';
  items: Array<Voice>;
};

export type VoiceVirtualAgentAiActionEvent = IncomingCallEvent & {
  __typename?: 'VoiceVirtualAgentAIActionEvent';
  actionId: Scalars['String']['output'];
  actionName: Scalars['String']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  errorCategory?: Maybe<AiActionErrorCategory>;
  inputParams?: Maybe<Scalars['AWSJSON']['output']>;
  kind: Scalars['String']['output'];
  lineId: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
  outputParams?: Maybe<Scalars['AWSJSON']['output']>;
  sessionId: Scalars['String']['output'];
  status: AiActionStatus;
  voiceVirtualAgent?: Maybe<VirtualAgentResolver>;
  voiceVirtualAgentId: Scalars['String']['output'];
};

export type VoiceVirtualAgentEndedEvent = IncomingCallEvent & {
  __typename?: 'VoiceVirtualAgentEndedEvent';
  connectEnd: Scalars['String']['output'];
  connectStart: Scalars['String']['output'];
  endReason: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  lineId: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  voiceVirtualAgent?: Maybe<VirtualAgentResolver>;
  voiceVirtualAgentId: Scalars['String']['output'];
};

export type VoiceVirtualAgentEscalatedBranch = {
  __typename?: 'VoiceVirtualAgentEscalatedBranch';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type VoiceVirtualAgentEscalatedEvent = IncomingCallEvent & {
  __typename?: 'VoiceVirtualAgentEscalatedEvent';
  aircallNumberId: Scalars['ID']['output'];
  branch: VoiceVirtualAgentEscalatedBranch;
  handoffContext: Scalars['String']['output'];
  id: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  lineId: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  voiceVirtualAgent?: Maybe<VirtualAgentResolver>;
  voiceVirtualAgentId: Scalars['String']['output'];
};

export type VoiceVirtualAgentStartedEvent = IncomingCallEvent & {
  __typename?: 'VoiceVirtualAgentStartedEvent';
  connectStart: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  lineId: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  voiceVirtualAgent?: Maybe<VirtualAgentResolver>;
  voiceVirtualAgentId: Scalars['String']['output'];
};

export type VoiceVirtualAgentSummaryEvent = IncomingCallEvent & {
  __typename?: 'VoiceVirtualAgentSummaryEvent';
  aircallNumberId: Scalars['ID']['output'];
  id: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  lineId: Scalars['ID']['output'];
  notes: Array<Scalars['String']['output']>;
  occurredAt: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  voiceVirtualAgent?: Maybe<VirtualAgentResolver>;
  voiceVirtualAgentId: Scalars['String']['output'];
};

export enum VoicemailAction {
  HANGUP = 'HANGUP',
  LEAVE_MESSAGE = 'LEAVE_MESSAGE'
}

export type VoicemailTranscription = {
  __typename?: 'VoicemailTranscription';
  callId: Scalars['Float']['output'];
  callUuid: Scalars['String']['output'];
  content?: Maybe<TranscriptionContent>;
  createdAt?: Maybe<Scalars['String']['output']>;
  durationInSeconds: Scalars['Int']['output'];
  fullText?: Maybe<Scalars['String']['output']>;
  mode: TranscriptionMode;
  status: Scalars['String']['output'];
  transcriptionId: Scalars['ID']['output'];
  type: Scalars['String']['output'];
  wordsCount?: Maybe<Scalars['Int']['output']>;
};

export type VoicemailTranscriptionSettings = {
  __typename?: 'VoicemailTranscriptionSettings';
  isEnabled: Scalars['Boolean']['output'];
  reason?: Maybe<TranscriptionSettingsReason>;
};

export type VoicemailTranscriptionSettingsData = {
  isEnabled: Scalars['Boolean']['input'];
};

export type Void = {
  __typename?: 'Void';
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type WarmTransferCall = {
  __typename?: 'WarmTransferCall';
  success: Scalars['Boolean']['output'];
};

export type WarmTransferCallOutput = GenericException | TransferAlreadyInProgressException | TransferCallHasEndedException | TransferCallNotFoundException | TransferFailedException | TransferTeamNotFoundException | TransferUserNotFoundException | WarmTransferCall;

export type WarmTransferInput = {
  agentId?: InputMaybe<Scalars['Int']['input']>;
  dispatchingStrategy?: InputMaybe<DispatchingStrategy>;
  kind: WarmTransferKind;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export enum WarmTransferKind {
  AGENT = 'AGENT',
  PHONE_NUMBER = 'PHONE_NUMBER',
  TEAM = 'TEAM'
}

export type WeakSkill = {
  __typename?: 'WeakSkill';
  evaluatedCallCount: Scalars['Int']['output'];
  evaluationPeriodDays: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  skill: Scalars['String']['output'];
  suggestedPrompts: Array<Scalars['String']['output']>;
};

export type WebDispatchGroup = {
  __typename?: 'WebDispatchGroup';
  attributes: WebDispatchGroupAttributes;
  id: Scalars['String']['output'];
  relationships: WebDispatchGroupRelationships;
  type: Scalars['String']['output'];
};

export type WebDispatchGroupAttributes = {
  __typename?: 'WebDispatchGroupAttributes';
  priority: Scalars['Int']['output'];
  queuingTimeout: Scalars['Int']['output'];
  redirectionStrategy: Scalars['String']['output'];
};

export type WebDispatchGroupDispatchable = {
  __typename?: 'WebDispatchGroupDispatchable';
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum WebDispatchGroupDispatchableType {
  team = 'team',
  user = 'user'
}

export type WebDispatchGroupRelationships = {
  __typename?: 'WebDispatchGroupRelationships';
  dispatchable?: Maybe<WebDispatchGroupRelationshipsDispatchable>;
};

export type WebDispatchGroupRelationshipsDispatchable = {
  __typename?: 'WebDispatchGroupRelationshipsDispatchable';
  data?: Maybe<WebDispatchGroupDispatchable>;
};

export type WebDispatchGroupsOutput = {
  __typename?: 'WebDispatchGroupsOutput';
  webDispatchGroups: Array<WebDispatchGroup>;
};

export type Webhook = {
  __typename?: 'Webhook';
  allowedRetries?: Maybe<Scalars['Int']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  customName?: Maybe<Scalars['String']['output']>;
  enabledEvents?: Maybe<Array<Scalars['String']['output']>>;
  events: Array<Scalars['String']['output']>;
  fields?: Maybe<Array<Scalars['String']['output']>>;
  helpLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  sectionEvents?: Maybe<SectionEvents>;
  shortName: Scalars['String']['output'];
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
  urlFormat?: Maybe<Scalars['String']['output']>;
};

export type WebhookConfiguration = {
  __typename?: 'WebhookConfiguration';
  events: Array<Scalars['String']['output']>;
  fields?: Maybe<Array<Scalars['String']['output']>>;
  helpLink: Scalars['String']['output'];
  logo: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sectionEvents?: Maybe<SectionEvents>;
  shortName: Scalars['String']['output'];
  urlFormat: Scalars['String']['output'];
};

export type WhatsAppCardsInput = {
  body: Array<WhatsAppCustomInput>;
  buttons?: InputMaybe<Array<InputMaybe<WhatsAppCustomInput>>>;
  header?: InputMaybe<WhatsAppHeaderInput>;
};

export type WhatsAppConfiguration = {
  __typename?: 'WhatsAppConfiguration';
  maxNumberOfFiles: Scalars['Int']['output'];
  mediaTypes: Array<MediaTypeConfiguration>;
  totalSizeLimit: Scalars['Int']['output'];
};

export type WhatsAppCustomInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type WhatsAppHeaderInput = {
  document?: InputMaybe<WhatsAppCustomInput>;
  image?: InputMaybe<WhatsAppCustomInput>;
  location?: InputMaybe<WhatsAppLocationObject>;
  text?: InputMaybe<WhatsAppCustomInput>;
  video?: InputMaybe<WhatsAppCustomInput>;
};

export type WhatsAppLocationObject = {
  address: Scalars['String']['input'];
  latitude: Scalars['String']['input'];
  longitude: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type WhatsAppMediaObject = {
  link: Scalars['String']['input'];
};

export type WhatsAppTemplateParamsInput = {
  body?: InputMaybe<Array<InputMaybe<WhatsAppCustomInput>>>;
  buttons?: InputMaybe<Array<InputMaybe<WhatsAppCustomInput>>>;
  cards?: InputMaybe<WhatsAppCardsInput>;
  header?: InputMaybe<WhatsAppHeaderInput>;
  id: Scalars['String']['input'];
};

export type WhatsappButtonDetails = {
  __typename?: 'WhatsappButtonDetails';
  button: Scalars['String']['output'];
  payload?: Maybe<Scalars['String']['output']>;
};

export type WhatsappButtonMessage = BaseMessage & {
  __typename?: 'WhatsappButtonMessage';
  ID: Scalars['ID']['output'];
  agent?: Maybe<PhoneTeammateResolver>;
  agentId?: Maybe<Scalars['String']['output']>;
  buttonDetails: WhatsappButtonDetails;
  channel: MessageChannel;
  createdAt: Scalars['AWSDateTime']['output'];
  direction: BaseMessageDirection;
  externalConversationID: Scalars['ID']['output'];
  hasUnsupportedContent: Scalars['Boolean']['output'];
  mediaDetails: Array<BaseMessageMediaDetails>;
  parent?: Maybe<MessageResolver>;
  status: BaseMessageStatus;
  text: Scalars['String']['output'];
  undeliveredReason?: Maybe<BaseMessageUndeliveredReason>;
};

export type WhatsappContactDetails = {
  __typename?: 'WhatsappContactDetails';
  fileName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type WhatsappContactsMessage = BaseMessage & {
  __typename?: 'WhatsappContactsMessage';
  ID: Scalars['ID']['output'];
  agent?: Maybe<PhoneTeammateResolver>;
  agentId?: Maybe<Scalars['String']['output']>;
  channel: MessageChannel;
  contactDetails: Array<WhatsappContactDetails>;
  createdAt: Scalars['AWSDateTime']['output'];
  direction: BaseMessageDirection;
  externalConversationID: Scalars['ID']['output'];
  hasUnsupportedContent: Scalars['Boolean']['output'];
  mediaDetails: Array<BaseMessageMediaDetails>;
  parent?: Maybe<MessageResolver>;
  status: BaseMessageStatus;
  text: Scalars['String']['output'];
  undeliveredReason?: Maybe<BaseMessageUndeliveredReason>;
};

export type WhatsappLicenseStatus = {
  __typename?: 'WhatsappLicenseStatus';
  active?: Maybe<Scalars['Boolean']['output']>;
  is_assigned?: Maybe<Scalars['Boolean']['output']>;
  license_name?: Maybe<Scalars['String']['output']>;
  license_status?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type WhatsappLicenseStatusResponse = {
  __typename?: 'WhatsappLicenseStatusResponse';
  whatsappLicenseStatus?: Maybe<WhatsappLicenseStatus>;
};

export type WhatsappLocationDetails = {
  __typename?: 'WhatsappLocationDetails';
  address?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type WhatsappLocationMessage = BaseMessage & {
  __typename?: 'WhatsappLocationMessage';
  ID: Scalars['ID']['output'];
  agent?: Maybe<PhoneTeammateResolver>;
  agentId?: Maybe<Scalars['String']['output']>;
  channel: MessageChannel;
  createdAt: Scalars['AWSDateTime']['output'];
  direction: BaseMessageDirection;
  externalConversationID: Scalars['ID']['output'];
  hasUnsupportedContent: Scalars['Boolean']['output'];
  locationDetails: WhatsappLocationDetails;
  mediaDetails: Array<BaseMessageMediaDetails>;
  parent?: Maybe<MessageResolver>;
  status: BaseMessageStatus;
  text: Scalars['String']['output'];
  undeliveredReason?: Maybe<BaseMessageUndeliveredReason>;
};

export type WhatsappMediaMessage = BaseMessage & {
  __typename?: 'WhatsappMediaMessage';
  ID: Scalars['ID']['output'];
  agent?: Maybe<PhoneTeammateResolver>;
  agentId?: Maybe<Scalars['String']['output']>;
  channel: MessageChannel;
  createdAt: Scalars['AWSDateTime']['output'];
  direction: BaseMessageDirection;
  externalConversationID: Scalars['ID']['output'];
  hasUnsupportedContent: Scalars['Boolean']['output'];
  mediaDetails: Array<BaseMessageMediaDetails>;
  parent?: Maybe<MessageResolver>;
  status: BaseMessageStatus;
  text: Scalars['String']['output'];
  undeliveredReason?: Maybe<BaseMessageUndeliveredReason>;
};

export type WhatsappMetadata = {
  __typename?: 'WhatsappMetadata';
  customerServiceWindowClosingTime?: Maybe<Scalars['AWSDateTime']['output']>;
};

export enum WhatsappRegistrationState {
  CREATING = 'CREATING',
  DISABLED = 'DISABLED',
  NOT_REGISTERED = 'NOT_REGISTERED',
  OFFLINE = 'OFFLINE',
  ONLINE = 'ONLINE'
}

export type WhatsappRegistrationStatus = {
  __typename?: 'WhatsappRegistrationStatus';
  businessInfo?: Maybe<BusinessInfo>;
  businessVerificationStatus?: Maybe<BusinessVerificationStatus>;
  createdAt?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<PhoneNumberData>;
  status: WhatsappRegistrationState;
  updatedAt?: Maybe<Scalars['String']['output']>;
  wabaId?: Maybe<Scalars['String']['output']>;
  wabaName?: Maybe<Scalars['String']['output']>;
  wabaStatus?: Maybe<Scalars['String']['output']>;
};

export type WhatsappTemplateDetails = {
  __typename?: 'WhatsappTemplateDetails';
  components: Array<TemplateComponent>;
};

export type WhatsappTemplateMessage = BaseMessage & {
  __typename?: 'WhatsappTemplateMessage';
  ID: Scalars['ID']['output'];
  agent?: Maybe<PhoneTeammateResolver>;
  agentId?: Maybe<Scalars['String']['output']>;
  channel: MessageChannel;
  createdAt: Scalars['AWSDateTime']['output'];
  direction: BaseMessageDirection;
  externalConversationID: Scalars['ID']['output'];
  hasUnsupportedContent: Scalars['Boolean']['output'];
  mediaDetails: Array<BaseMessageMediaDetails>;
  parent?: Maybe<MessageResolver>;
  status: BaseMessageStatus;
  templateDetails: WhatsappTemplateDetails;
  text: Scalars['String']['output'];
  undeliveredReason?: Maybe<BaseMessageUndeliveredReason>;
};

export type WhatsappTextMessage = BaseMessage & {
  __typename?: 'WhatsappTextMessage';
  ID: Scalars['ID']['output'];
  agent?: Maybe<PhoneTeammateResolver>;
  agentId?: Maybe<Scalars['String']['output']>;
  channel: MessageChannel;
  createdAt: Scalars['AWSDateTime']['output'];
  direction: BaseMessageDirection;
  externalConversationID: Scalars['ID']['output'];
  hasUnsupportedContent: Scalars['Boolean']['output'];
  mediaDetails: Array<BaseMessageMediaDetails>;
  parent?: Maybe<MessageResolver>;
  status: BaseMessageStatus;
  text: Scalars['String']['output'];
  undeliveredReason?: Maybe<BaseMessageUndeliveredReason>;
};

export type WhatsappUnsupportedMessage = BaseMessage & {
  __typename?: 'WhatsappUnsupportedMessage';
  ID: Scalars['ID']['output'];
  agent?: Maybe<PhoneTeammateResolver>;
  agentId?: Maybe<Scalars['String']['output']>;
  channel: MessageChannel;
  createdAt: Scalars['AWSDateTime']['output'];
  direction: BaseMessageDirection;
  externalConversationID: Scalars['ID']['output'];
  hasUnsupportedContent: Scalars['Boolean']['output'];
  mediaDetails: Array<BaseMessageMediaDetails>;
  parent?: Maybe<MessageResolver>;
  status: BaseMessageStatus;
  text: Scalars['String']['output'];
  undeliveredReason?: Maybe<BaseMessageUndeliveredReason>;
};

export type WhatsappUser = {
  __typename?: 'WhatsappUser';
  displayName?: Maybe<Scalars['String']['output']>;
  primaryPhoneNumber?: Maybe<Scalars['String']['output']>;
  userID: Scalars['ID']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type WhatsappUserResolver = {
  __typename?: 'WhatsappUserResolver';
  entity: WhatsappUser;
  input: WhatsappUserResolverInput;
};

export type WhatsappUserResolverInput = {
  __typename?: 'WhatsappUserResolverInput';
  companyID: Scalars['ID']['output'];
  userID: Scalars['ID']['output'];
};

export type WizardStatusOutput = ActivationCapabilityDisabled | ActivationForbidden | ActivationRequestException | ActivationUnauthenticated | GenericException | WizardStatusResult;

export type WizardStatusResult = {
  __typename?: 'WizardStatusResult';
  addonStatus: ActivationAddonStatus;
  companyId: Scalars['ID']['output'];
  completion: Array<ActivationTopicCompletion>;
  id: Scalars['ID']['output'];
  state?: Maybe<ActivationWizardState>;
};

export type ZendeskUser = {
  __typename?: 'ZendeskUser';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type A2pBandwidthCampaignNumberAssociation = {
  __typename?: 'a2pBandwidthCampaignNumberAssociation';
  success: Scalars['Boolean']['output'];
};

export type A2pBandwidthCampaignNumberAssociationResult = GenericException | A2pBandwidthCampaignNumberAssociation;

export type A2pBandwidthCampaignNumberDeletion = {
  __typename?: 'a2pBandwidthCampaignNumberDeletion';
  success: Scalars['Boolean']['output'];
};

export type A2pBandwidthCampaignNumberDeletionResult = GenericException | A2pBandwidthCampaignNumberDeletion;

export type A2pBulkCampaignCreation = {
  __typename?: 'a2pBulkCampaignCreation';
  success: Scalars['Boolean']['output'];
};

export type A2pBulkCampaignCreationResult = GenericException | A2pBulkCampaignCreation;

export type SettingSchema = {
  __typename?: 'settingSchema';
  value: SettingSchemaValue;
};

export type SettingSchemaValue = {
  __typename?: 'settingSchemaValue';
  dataType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  translatedLabel: Scalars['String']['output'];
};

export type UpdateConversationsStatusInput = {
  conversationIds: Array<Scalars['String']['input']>;
  markAsDone: Scalars['Boolean']['input'];
};

export type UpdateConversationsStatusResult = GenericException | UpdateMarkAsDoneStatus;

export type UpdateCurrentUserConversationsStatusInput = {
  filter?: InputMaybe<SearchableConversationsFilterInput>;
  markAsDone: Scalars['Boolean']['input'];
};

export type UpdateCurrentUserConversationsStatusResult = GenericException | UpdateMarkAsDoneStatus;

export type UpdateMarkAsDoneStatus = {
  __typename?: 'updateMarkAsDoneStatus';
  success: Scalars['Boolean']['output'];
};

export type AgentParticipantFragment = { __typename: 'AgentParticipant', number: string, teammate: { __typename?: 'PhoneTeammateResolver', entity: { __typename?: 'PhoneTeammate', ID: string, fullName: string, email: string } | { __typename: 'ResourceNotFoundException', code: string, message: string } } };

export type BinaryAnswerFragment = { __typename: 'BinaryAnswer', binaryValue: BinaryAnswerValue, answerGuide?: string | null, points: number };

export type CallAudioFragment = { __typename?: 'CallAudio', url?: string | null };

export type CallDetailsFragment = { __typename?: 'BasicCall', automaticCallbackCallId?: string | null, callbackRequestTimestamp?: string | null, callUuid: string, callId: string, answeredAt?: string | null, createdAt: string, durationInSecond?: number | null, direction?: CallDirection | null, type?: CallType | null, from?: { __typename: 'AgentParticipant', number: string, teammate: { __typename?: 'PhoneTeammateResolver', entity: { __typename?: 'PhoneTeammate', ID: string, fullName: string, email: string } | { __typename: 'ResourceNotFoundException', code: string, message: string } } } | { __typename: 'ExternalParticipant', number: string, external: { __typename?: 'PhoneContactResolver', entity: { __typename?: 'ExternalNumber', phoneNumber: string } | { __typename?: 'PhoneContact', fullName: string, mainPhoneNumber: string, companyName?: string | null } } } | null, to?: { __typename: 'AgentParticipant', number: string, teammate: { __typename?: 'PhoneTeammateResolver', entity: { __typename?: 'PhoneTeammate', ID: string, fullName: string, email: string } | { __typename: 'ResourceNotFoundException', code: string, message: string } } } | { __typename: 'ExternalParticipant', number: string, external: { __typename?: 'PhoneContactResolver', entity: { __typename?: 'ExternalNumber', phoneNumber: string } | { __typename?: 'PhoneContact', fullName: string, mainPhoneNumber: string, companyName?: string | null } } } | null, transcription?: { __typename: 'CallTranscription', status: string, transcriptionId: string, mode: TranscriptionMode, wordsCount?: number | null, content?: { __typename?: 'TranscriptionContent', speakers?: Array<{ __typename?: 'AgentSpeaker', channel: number, agentID: number, teammate: { __typename?: 'PhoneTeammateResolver', entity: { __typename: 'PhoneTeammate', fullName: string, ID: string } | { __typename: 'ResourceNotFoundException', code: string, message: string } } } | { __typename?: 'ExternalSpeaker', number: string, channel: number, external: { __typename?: 'PhoneContactResolver', entity: { __typename?: 'ExternalNumber' } | { __typename?: 'PhoneContact', companyName?: string | null, mainPhoneNumber: string, fullName: string } } } | { __typename: 'VirtualAgentSpeaker', channel: number, virtualAgent: { __typename?: 'VirtualAgentResolver', entity?: { __typename?: 'ConflictException' } | { __typename?: 'GenericException' } | { __typename?: 'UserInputException' } | { __typename: 'VirtualAgent', ID: string, personality: { __typename?: 'VirtualAgentPersonality', name: string } } | null } } | null> | null, utterances?: Array<{ __typename?: 'Utterance', channel: number, startTime: number, endTime: number, entries: Array<{ __typename?: 'Entry', W: string, S: number }> } | null> | null } | null, insights?: { __typename?: 'TranscriptionInsights', nextActions?: { __typename?: 'NextActionsInsights', actions: Array<{ __typename?: 'NextAction', ID: string, content: string } | null> } | null, summary?: { __typename?: 'SummaryInsight', createdAt: string, content?: { __typename?: 'SummaryContent', summary: string } | null } | null, topics?: { __typename?: 'TopicsInsight', createdAt: string, content?: { __typename?: 'TopicsContent', topics?: Array<string | null> | null } | null } | null, sentiments?: { __typename?: 'SentimentInsights', overall?: Array<{ __typename?: 'OverallSentiment', type: SentimentType, value: SentimentValue } | null> | null, customers?: { __typename?: 'CustomersUtterances', utterances?: Array<{ __typename?: 'UtteranceSentiment', value: SentimentValue, index: number } | null> | null } | null } | null, predictedCsat?: { __typename?: 'PredictedCsat', score: number, computedAt: string, drivers: Array<{ __typename?: 'PredictedCsatDriver', label: string, polarity: PredictedCsatDriverPolarity }> } | null } | null } | { __typename: 'VoicemailTranscription', status: string, transcriptionId: string, wordsCount?: number | null, content?: { __typename?: 'TranscriptionContent', utterances?: Array<{ __typename?: 'Utterance', channel: number, startTime: number, endTime: number, entries: Array<{ __typename?: 'Entry', W: string, S: number }> } | null> | null } | null } | null };

export type CallTranscriptionFragment = { __typename: 'CallTranscription', status: string, transcriptionId: string, mode: TranscriptionMode, wordsCount?: number | null, content?: { __typename?: 'TranscriptionContent', speakers?: Array<{ __typename?: 'AgentSpeaker', channel: number, agentID: number, teammate: { __typename?: 'PhoneTeammateResolver', entity: { __typename: 'PhoneTeammate', fullName: string, ID: string } | { __typename: 'ResourceNotFoundException', code: string, message: string } } } | { __typename?: 'ExternalSpeaker', number: string, channel: number, external: { __typename?: 'PhoneContactResolver', entity: { __typename?: 'ExternalNumber' } | { __typename?: 'PhoneContact', companyName?: string | null, mainPhoneNumber: string, fullName: string } } } | { __typename: 'VirtualAgentSpeaker', channel: number, virtualAgent: { __typename?: 'VirtualAgentResolver', entity?: { __typename?: 'ConflictException' } | { __typename?: 'GenericException' } | { __typename?: 'UserInputException' } | { __typename: 'VirtualAgent', ID: string, personality: { __typename?: 'VirtualAgentPersonality', name: string } } | null } } | null> | null, utterances?: Array<{ __typename?: 'Utterance', channel: number, startTime: number, endTime: number, entries: Array<{ __typename?: 'Entry', W: string, S: number }> } | null> | null } | null, insights?: { __typename?: 'TranscriptionInsights', nextActions?: { __typename?: 'NextActionsInsights', actions: Array<{ __typename?: 'NextAction', ID: string, content: string } | null> } | null, summary?: { __typename?: 'SummaryInsight', createdAt: string, content?: { __typename?: 'SummaryContent', summary: string } | null } | null, topics?: { __typename?: 'TopicsInsight', createdAt: string, content?: { __typename?: 'TopicsContent', topics?: Array<string | null> | null } | null } | null, sentiments?: { __typename?: 'SentimentInsights', overall?: Array<{ __typename?: 'OverallSentiment', type: SentimentType, value: SentimentValue } | null> | null, customers?: { __typename?: 'CustomersUtterances', utterances?: Array<{ __typename?: 'UtteranceSentiment', value: SentimentValue, index: number } | null> | null } | null } | null, predictedCsat?: { __typename?: 'PredictedCsat', score: number, computedAt: string, drivers: Array<{ __typename?: 'PredictedCsatDriver', label: string, polarity: PredictedCsatDriverPolarity }> } | null } | null };

export type OptionsResponseFragmentFragment = { __typename?: 'OptionsResponse', options: Array<{ __typename?: 'OptionItem', description?: string | null, value: string }> };

export type ValidationResponseFragmentFragment = { __typename?: 'ValidationResponse', validationOptions: Array<{ __typename?: 'ValidationItem', description?: string | null, value: ItemValidationValue }> };

export type CustomSummaryResultFragment = { __typename: 'CustomSummaryResult', id: string, callId: string, callUuid: string, createdAt: string, customSummaryName: string, language: CustomSummaryLanguage, customSummary: { __typename?: 'CustomSummary', id: string, name: string, language: CustomSummaryLanguage, createdAt: string, updatedAt?: string | null, templates: Array<{ __typename?: 'SummaryTemplateEntry', orderPosition: number, template: { __typename?: 'SummaryTemplate', id: string, name: string, prompt: string, type: SummaryTemplateType, response?: { __typename?: 'OptionsResponse', options: Array<{ __typename?: 'OptionItem', description?: string | null, value: string }> } | { __typename?: 'ValidationResponse', validationOptions: Array<{ __typename?: 'ValidationItem', description?: string | null, value: ItemValidationValue }> } | null } }> }, templateResults: Array<{ __typename?: 'SummaryTemplateResult', id: string, aiGenerated: boolean, content: string, createdAt: string, summaryTemplateId: string, summaryTemplateName: string, type: SummaryTemplateType, updatedAt?: string | null }> };

export type EntryFragment = { __typename?: 'Entry', W: string, S: number };

export type EvaluationFragment = { __typename?: 'Evaluation', ID: string, callId: string, feedback?: string | null, createdAt: string, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null, scoreCardId: string, scoreCardName: string, scoreCardLanguage: string, scoreCardDescription: string, isGeneratedByAI: boolean, revieweeUserId: string, reviewerUserId: string, score: { __typename?: 'Score', scorePoints: number, totalPoints: number, normalizedScore: number }, reviewerTeammate?: { __typename?: 'PhoneTeammateResolver', entity: { __typename?: 'PhoneTeammate', fullName: string } | { __typename?: 'ResourceNotFoundException' } } | null, categories: Array<{ __typename?: 'EvaluationCategory', ID: string, categoryName: string, categoryOrder: number, scoreCardCategoryId: string, questions: Array<{ __typename: 'BinaryEvaluationQuestion', ID: string, feedback?: string | null, binaryAnswer?: BinaryAnswerValue | null, questionText: string, questionOrder: number, questionAiEnabled: boolean, scoreCardQuestionId?: string | null, score: { __typename?: 'Score', scorePoints: number, totalPoints: number, normalizedScore: number }, questionPossibleAnswers: Array<{ __typename: 'BinaryAnswer', binaryValue: BinaryAnswerValue, answerGuide?: string | null, points: number }> } | { __typename: 'RatingEvaluationQuestion', ID: string, feedback?: string | null, ratingAnswer?: RatingAnswerValue | null, questionText: string, questionOrder: number, questionAiEnabled: boolean, scoreCardQuestionId?: string | null, score: { __typename?: 'Score', scorePoints: number, totalPoints: number, normalizedScore: number }, questionPossibleAnswers: Array<{ __typename: 'RatingAnswer', ratingValue: RatingAnswerValue, answerGuide?: string | null, points: number }> }> }> };

export type ExternalParticipantFragment = { __typename: 'ExternalParticipant', number: string, external: { __typename?: 'PhoneContactResolver', entity: { __typename?: 'ExternalNumber', phoneNumber: string } | { __typename?: 'PhoneContact', fullName: string, mainPhoneNumber: string, companyName?: string | null } } };

export type ApplicationFragment = { __typename?: 'Application', id?: string | null, name: string };

export type IntegrationFragment = { __typename?: 'Integration', id: string, name: string, application?: { __typename?: 'Application', id?: string | null, name: string } | null };

export type LineDetailsFragment = { __typename?: 'Line', ID: string, name: string, countryISOCode: string, language?: string | null, phoneNumber: string };

export type LineTranscriptionSettingsFragment = { __typename?: 'LineTranscriptionSettings', lineId: number, lineLanguage: string, voicemails?: { __typename?: 'VoicemailTranscriptionSettings', isEnabled: boolean, reason?: TranscriptionSettingsReason | null } | null, calls?: { __typename?: 'CallTranscriptionSettings', isEnabled: boolean, reason?: TranscriptionSettingsReason | null } | null };

export type NextActionItemFragment = { __typename?: 'NextAction', ID: string, content: string };

export type OverallSentimentFragment = { __typename?: 'OverallSentiment', type: SentimentType, value: SentimentValue, createdAt: string };

export type TopicResultFragment = { __typename?: 'TopicResult', id: string, aiGenerated: boolean, name: string, language: PlaybookLanguage, createdAt: string, updatedAt?: string | null, content: { __typename?: 'TopicResultContent', id: string, responseType: CustomPlaybookResponseType, response: { __typename?: 'BooleanValue', booleanValue: boolean } | { __typename?: 'StringListValue' } | { __typename?: 'StringValue', stringValue: string }, responseOptions?: { __typename?: 'TopicResponseOption', id: string, value: string } | null } };

export type PlaybookResultFragment = { __typename?: 'PlaybookResult', callId: string, callUuid: string, id: string, language: PlaybookLanguage, name: string, adherenceScore?: number | null, topicResults: Array<{ __typename?: 'TopicResult', id: string, aiGenerated: boolean, name: string, language: PlaybookLanguage, createdAt: string, updatedAt?: string | null, content: { __typename?: 'TopicResultContent', id: string, responseType: CustomPlaybookResponseType, response: { __typename?: 'BooleanValue', booleanValue: boolean } | { __typename?: 'StringListValue' } | { __typename?: 'StringValue', stringValue: string }, responseOptions?: { __typename?: 'TopicResponseOption', id: string, value: string } | null } }> };

export type RatingAnswerFragment = { __typename: 'RatingAnswer', ratingValue: RatingAnswerValue, answerGuide?: string | null, points: number };

export type ScoreCardFragment = { __typename?: 'ScoreCard', ID: string, createdAt: string, createdBy: string, description: string, isPublished: boolean, language: string, name: string, updatedAt?: string | null, updatedBy?: string | null, categories: Array<{ __typename?: 'ScoreCardCategory', ID: string, name: string, order: number, questions: Array<{ __typename: 'ScoreCardBinaryQuestion', ID: string, order: number, text: string, isAIEnabled: boolean, totalPoints: number, predefinedAIQuestionId?: string | null, strictness?: number | null, possibleBinaryAnswers: Array<{ __typename: 'BinaryAnswer', binaryValue: BinaryAnswerValue, answerGuide?: string | null, points: number }> } | { __typename: 'ScoreCardRatingQuestion', ID: string, isAIEnabled: boolean, order: number, text: string, totalPoints: number, predefinedAIQuestionId?: string | null, strictness?: number | null, possibleRatingAnswers: Array<{ __typename: 'RatingAnswer', ratingValue: RatingAnswerValue, answerGuide?: string | null, points: number }> }> }> };

export type SearchLineDetailsFragment = { __typename?: 'Line', ID: string, language?: string | null, countryISOCode: string };

export type SummaryTemplateResultFragment = { __typename?: 'SummaryTemplateResult', id: string, aiGenerated: boolean, content: string, createdAt: string, summaryTemplateId: string, summaryTemplateName: string, type: SummaryTemplateType, updatedAt?: string | null };

export type TagFragment = { __typename?: 'Tag', id: string, name: string, description?: string | null, color: string };

export type TranscriptionContentFragment = { __typename?: 'TranscriptionContent', speakers?: Array<{ __typename?: 'AgentSpeaker', channel: number, agentID: number, teammate: { __typename?: 'PhoneTeammateResolver', entity: { __typename: 'PhoneTeammate', fullName: string, ID: string } | { __typename: 'ResourceNotFoundException', code: string, message: string } } } | { __typename?: 'ExternalSpeaker', number: string, channel: number, external: { __typename?: 'PhoneContactResolver', entity: { __typename?: 'ExternalNumber' } | { __typename?: 'PhoneContact', companyName?: string | null, mainPhoneNumber: string, fullName: string } } } | { __typename: 'VirtualAgentSpeaker', channel: number, virtualAgent: { __typename?: 'VirtualAgentResolver', entity?: { __typename?: 'ConflictException' } | { __typename?: 'GenericException' } | { __typename?: 'UserInputException' } | { __typename: 'VirtualAgent', ID: string, personality: { __typename?: 'VirtualAgentPersonality', name: string } } | null } } | null> | null, utterances?: Array<{ __typename?: 'Utterance', channel: number, startTime: number, endTime: number, entries: Array<{ __typename?: 'Entry', W: string, S: number }> } | null> | null };

export type TranscriptionScopeDetailFragment = { __typename?: 'CallConversation', transcriptionScope?: { __typename?: 'TranscriptionScope', totalItems: number, items: Array<{ __typename?: 'TranscriptionScopeItem', highlight: { __typename?: 'TranscriptionScopeHighlight', content: string, terms: Array<string | null> }, utterance: { __typename?: 'TranscriptionScopeUtterance', agentId?: number | null, startTime: number, phoneNumber?: string | null, index: number } } | null> } | null };

export type TranscriptionScopeItemFragment = { __typename?: 'TranscriptionScopeItem', highlight: { __typename?: 'TranscriptionScopeHighlight', content: string, terms: Array<string | null> }, utterance: { __typename?: 'TranscriptionScopeUtterance', agentId?: number | null, startTime: number, phoneNumber?: string | null, index: number } };

export type UtteranceFragment = { __typename?: 'Utterance', channel: number, startTime: number, endTime: number, entries: Array<{ __typename?: 'Entry', W: string, S: number }> };

export type UtteranceSentimentItemFragment = { __typename?: 'UtteranceSentiment', value: SentimentValue, index: number };

export type VoicemailTranscriptionFragment = { __typename: 'VoicemailTranscription', status: string, transcriptionId: string, wordsCount?: number | null, content?: { __typename?: 'TranscriptionContent', utterances?: Array<{ __typename?: 'Utterance', channel: number, startTime: number, endTime: number, entries: Array<{ __typename?: 'Entry', W: string, S: number }> } | null> | null } | null };

type BaseException_ActivationCapabilityDisabled_Fragment = { __typename: 'ActivationCapabilityDisabled', code: string, message: string };

type BaseException_ActivationForbidden_Fragment = { __typename: 'ActivationForbidden', code: string, message: string };

type BaseException_ActivationRequestException_Fragment = { __typename: 'ActivationRequestException', code: string, message: string };

type BaseException_ActivationUnauthenticated_Fragment = { __typename: 'ActivationUnauthenticated', code: string, message: string };

type BaseException_ActivationWizardInvalidTransition_Fragment = { __typename: 'ActivationWizardInvalidTransition', code: string, message: string };

type BaseException_ActivationWizardLockConflict_Fragment = { __typename: 'ActivationWizardLockConflict', code: string, message: string };

type BaseException_AgentDraftConflictException_Fragment = { __typename: 'AgentDraftConflictException', code: string, message: string };

type BaseException_BrandedCallingException_Fragment = { __typename: 'BrandedCallingException', code: string, message: string };

type BaseException_CalendarTitleAlreadyExistsException_Fragment = { __typename: 'CalendarTitleAlreadyExistsException', code: string, message: string };

type BaseException_ConflictException_Fragment = { __typename: 'ConflictException', code: string, message: string };

type BaseException_CrmNotSupportedException_Fragment = { __typename: 'CrmNotSupportedException', code: string, message: string };

type BaseException_CustomSummaryException_Fragment = { __typename: 'CustomSummaryException', code: string, message: string };

type BaseException_FlowConcurrentModificationException_Fragment = { __typename: 'FlowConcurrentModificationException', code: string, message: string };

type BaseException_GenerationFailedException_Fragment = { __typename: 'GenerationFailedException', code: string, message: string };

type BaseException_GenericException_Fragment = { __typename: 'GenericException', code: string, message: string };

type BaseException_HubApplicationNotFoundException_Fragment = { __typename: 'HubApplicationNotFoundException', code: string, message: string };

type BaseException_InsufficientLicenseException_Fragment = { __typename: 'InsufficientLicenseException', code: string, message: string };

type BaseException_InsufficientPermissionException_Fragment = { __typename: 'InsufficientPermissionException', code: string, message: string };

type BaseException_InvalidEnumException_Fragment = { __typename: 'InvalidEnumException', code: string, message: string };

type BaseException_InvalidFlowDefinitionException_Fragment = { __typename: 'InvalidFlowDefinitionException', code: string, message: string };

type BaseException_InvalidPropertyMappingException_Fragment = { __typename: 'InvalidPropertyMappingException', code: string, message: string };

type BaseException_InvalidScoreCardName_Fragment = { __typename: 'InvalidScoreCardName', code: string, message: string };

type BaseException_InvalidSessionStateException_Fragment = { __typename: 'InvalidSessionStateException', code: string, message: string };

type BaseException_InvalidStringException_Fragment = { __typename: 'InvalidStringException', code: string, message: string };

type BaseException_InvalidTrackerName_Fragment = { __typename: 'InvalidTrackerName', code: string, message: string };

type BaseException_InvalidTypeException_Fragment = { __typename: 'InvalidTypeException', code: string, message: string };

type BaseException_LlmUnavailableException_Fragment = { __typename: 'LLMUnavailableException', code: string, message: string };

type BaseException_LongTailApplicationNotFoundException_Fragment = { __typename: 'LongTailApplicationNotFoundException', code: string, message: string };

type BaseException_LongTailInvalidProposalStateException_Fragment = { __typename: 'LongTailInvalidProposalStateException', code: string, message: string };

type BaseException_LongTailProposalNotFoundException_Fragment = { __typename: 'LongTailProposalNotFoundException', code: string, message: string };

type BaseException_LongTailSessionAlreadyRegisteredException_Fragment = { __typename: 'LongTailSessionAlreadyRegisteredException', code: string, message: string };

type BaseException_MaxFlowSizeReachedException_Fragment = { __typename: 'MaxFlowSizeReachedException', code: string, message: string };

type BaseException_MaxTeamsAssignedException_Fragment = { __typename: 'MaxTeamsAssignedException', code: string, message: string };

type BaseException_MaximumConfirmedPrerecordedMessagesReachedException_Fragment = { __typename: 'MaximumConfirmedPrerecordedMessagesReachedException', code: string, message: string };

type BaseException_NoSourceInputsAttachedException_Fragment = { __typename: 'NoSourceInputsAttachedException', code: string, message: string };

type BaseException_NoTransferInProgressException_Fragment = { __typename: 'NoTransferInProgressException', code: string, message: string };

type BaseException_NumberReputationException_Fragment = { __typename: 'NumberReputationException', code: string, message: string };

type BaseException_OutboundCampaignAgentNotAvailableException_Fragment = { __typename: 'OutboundCampaignAgentNotAvailableException', code: string, message: string };

type BaseException_OutboundCampaignNotReadyException_Fragment = { __typename: 'OutboundCampaignNotReadyException', code: string, message: string };

type BaseException_OutboundCampaignOutcomeAlreadyExistsException_Fragment = { __typename: 'OutboundCampaignOutcomeAlreadyExistsException', code: string, message: string };

type BaseException_OutboundCampaignReservedOutcomeNameException_Fragment = { __typename: 'OutboundCampaignReservedOutcomeNameException', code: string, message: string };

type BaseException_PersonalLineRevertException_Fragment = { __typename: 'PersonalLineRevertException', code: string, message: string };

type BaseException_PlaybookException_Fragment = { __typename: 'PlaybookException', code: string, message: string };

type BaseException_RateLimitExceededException_Fragment = { __typename: 'RateLimitExceededException', code: string, message: string };

type BaseException_RegistrationSessionNotFoundException_Fragment = { __typename: 'RegistrationSessionNotFoundException', code: string, message: string };

type BaseException_ResourceNotFoundException_Fragment = { __typename: 'ResourceNotFoundException', code: string, message: string };

type BaseException_RetryableException_Fragment = { __typename: 'RetryableException', code: string, message: string };

type BaseException_SecretDetectedException_Fragment = { __typename: 'SecretDetectedException', code: string, message: string };

type BaseException_SendMessageV2Error_Fragment = { __typename: 'SendMessageV2Error', code: string, message: string };

type BaseException_TooBigException_Fragment = { __typename: 'TooBigException', code: string, message: string };

type BaseException_TooManyRequestsException_Fragment = { __typename: 'TooManyRequestsException', code: string, message: string };

type BaseException_TooSmallException_Fragment = { __typename: 'TooSmallException', code: string, message: string };

type BaseException_ToolDefLintRejectedException_Fragment = { __typename: 'ToolDefLintRejectedException', code: string, message: string };

type BaseException_TrackerKeywordLimitExceeded_Fragment = { __typename: 'TrackerKeywordLimitExceeded', code: string, message: string };

type BaseException_TrackerLimitExceeded_Fragment = { __typename: 'TrackerLimitExceeded', code: string, message: string };

type BaseException_TransferAlreadyInProgressException_Fragment = { __typename: 'TransferAlreadyInProgressException', code: string, message: string };

type BaseException_TransferCallHasEndedException_Fragment = { __typename: 'TransferCallHasEndedException', code: string, message: string };

type BaseException_TransferCallNotFoundException_Fragment = { __typename: 'TransferCallNotFoundException', code: string, message: string };

type BaseException_TransferFailedException_Fragment = { __typename: 'TransferFailedException', code: string, message: string };

type BaseException_TransferTeamNotFoundException_Fragment = { __typename: 'TransferTeamNotFoundException', code: string, message: string };

type BaseException_TransferUserNotFoundException_Fragment = { __typename: 'TransferUserNotFoundException', code: string, message: string };

type BaseException_TtsGenerationInProgressException_Fragment = { __typename: 'TtsGenerationInProgressException', code: string, message: string };

type BaseException_UnauthorizedException_Fragment = { __typename: 'UnauthorizedException', code: string, message: string };

type BaseException_UnprocessableResourceException_Fragment = { __typename: 'UnprocessableResourceException', code: string, message: string };

type BaseException_UnsupportedSourceKindException_Fragment = { __typename: 'UnsupportedSourceKindException', code: string, message: string };

type BaseException_UserInputException_Fragment = { __typename: 'UserInputException', code: string, message: string };

export type BaseExceptionFragment = BaseException_ActivationCapabilityDisabled_Fragment | BaseException_ActivationForbidden_Fragment | BaseException_ActivationRequestException_Fragment | BaseException_ActivationUnauthenticated_Fragment | BaseException_ActivationWizardInvalidTransition_Fragment | BaseException_ActivationWizardLockConflict_Fragment | BaseException_AgentDraftConflictException_Fragment | BaseException_BrandedCallingException_Fragment | BaseException_CalendarTitleAlreadyExistsException_Fragment | BaseException_ConflictException_Fragment | BaseException_CrmNotSupportedException_Fragment | BaseException_CustomSummaryException_Fragment | BaseException_FlowConcurrentModificationException_Fragment | BaseException_GenerationFailedException_Fragment | BaseException_GenericException_Fragment | BaseException_HubApplicationNotFoundException_Fragment | BaseException_InsufficientLicenseException_Fragment | BaseException_InsufficientPermissionException_Fragment | BaseException_InvalidEnumException_Fragment | BaseException_InvalidFlowDefinitionException_Fragment | BaseException_InvalidPropertyMappingException_Fragment | BaseException_InvalidScoreCardName_Fragment | BaseException_InvalidSessionStateException_Fragment | BaseException_InvalidStringException_Fragment | BaseException_InvalidTrackerName_Fragment | BaseException_InvalidTypeException_Fragment | BaseException_LlmUnavailableException_Fragment | BaseException_LongTailApplicationNotFoundException_Fragment | BaseException_LongTailInvalidProposalStateException_Fragment | BaseException_LongTailProposalNotFoundException_Fragment | BaseException_LongTailSessionAlreadyRegisteredException_Fragment | BaseException_MaxFlowSizeReachedException_Fragment | BaseException_MaxTeamsAssignedException_Fragment | BaseException_MaximumConfirmedPrerecordedMessagesReachedException_Fragment | BaseException_NoSourceInputsAttachedException_Fragment | BaseException_NoTransferInProgressException_Fragment | BaseException_NumberReputationException_Fragment | BaseException_OutboundCampaignAgentNotAvailableException_Fragment | BaseException_OutboundCampaignNotReadyException_Fragment | BaseException_OutboundCampaignOutcomeAlreadyExistsException_Fragment | BaseException_OutboundCampaignReservedOutcomeNameException_Fragment | BaseException_PersonalLineRevertException_Fragment | BaseException_PlaybookException_Fragment | BaseException_RateLimitExceededException_Fragment | BaseException_RegistrationSessionNotFoundException_Fragment | BaseException_ResourceNotFoundException_Fragment | BaseException_RetryableException_Fragment | BaseException_SecretDetectedException_Fragment | BaseException_SendMessageV2Error_Fragment | BaseException_TooBigException_Fragment | BaseException_TooManyRequestsException_Fragment | BaseException_TooSmallException_Fragment | BaseException_ToolDefLintRejectedException_Fragment | BaseException_TrackerKeywordLimitExceeded_Fragment | BaseException_TrackerLimitExceeded_Fragment | BaseException_TransferAlreadyInProgressException_Fragment | BaseException_TransferCallHasEndedException_Fragment | BaseException_TransferCallNotFoundException_Fragment | BaseException_TransferFailedException_Fragment | BaseException_TransferTeamNotFoundException_Fragment | BaseException_TransferUserNotFoundException_Fragment | BaseException_TtsGenerationInProgressException_Fragment | BaseException_UnauthorizedException_Fragment | BaseException_UnprocessableResourceException_Fragment | BaseException_UnsupportedSourceKindException_Fragment | BaseException_UserInputException_Fragment;

export type InsufficientLicenseExceptionFragment = { __typename?: 'InsufficientLicenseException', code: string, licenseName: string, message: string };

export type InsufficientPermissionExceptionFragment = { __typename?: 'InsufficientPermissionException', access: PermissionAccess, code: string, message: string };

export type InvalidEnumExceptionFragment = { __typename?: 'InvalidEnumException', code: string, message: string, options: Array<string>, path: string };

export type InvalidStringExceptionFragment = { __typename?: 'InvalidStringException', code: string, message: string, path: string, validation: string };

export type InvalidTypeExceptionFragment = { __typename?: 'InvalidTypeException', code: string, expected: string, message: string, path: string, received: string };

export type RateLimitExceededExceptionFragment = { __typename?: 'RateLimitExceededException', code: string, limit: number, message: string };

export type TooBigExceptionFragment = { __typename?: 'TooBigException', code: string, maximum: number, message: string, path: string, type: string };

export type TooSmallExceptionFragment = { __typename?: 'TooSmallException', code: string, message: string, minimum: number, path: string, type: string };

export type TrackerKeywordLimitExceededFragment = { __typename?: 'TrackerKeywordLimitExceeded', code: string, message: string, positions: Array<number> };

export type UserInputExceptionFragment = { __typename: 'UserInputException', code: string, message: string, issues: Array<{ __typename?: 'InvalidEnumException', code: string, message: string, options: Array<string>, path: string } | { __typename?: 'InvalidStringException', code: string, message: string, path: string, validation: string } | { __typename?: 'InvalidTypeException', code: string, expected: string, message: string, path: string, received: string } | { __typename?: 'TooBigException', code: string, maximum: number, message: string, path: string, type: string } | { __typename?: 'TooSmallException', code: string, message: string, minimum: number, path: string, type: string }> };

export type CreateEvaluationMutationVariables = Exact<{
  input: CreateEvaluationInput;
}>;


export type CreateEvaluationMutation = { __typename?: 'Mutation', createEvaluation: { __typename: 'Evaluation', ID: string, scoreCardId: string, scoreCardDescription: string, scoreCardName: string, scoreCardLanguage: string, feedback?: string | null, revieweeUserId: string, reviewerUserId: string, callId: string, createdBy?: string | null, createdAt: string, updatedBy?: string | null, updatedAt?: string | null, categories: Array<{ __typename?: 'EvaluationCategory', ID: string, scoreCardCategoryId: string, categoryOrder: number, categoryName: string, questions: Array<{ __typename?: 'BinaryEvaluationQuestion', ID: string, questionOrder: number, questionText: string, questionAiEnabled: boolean, scoreCardQuestionId?: string | null, feedback?: string | null, binaryAnswer?: BinaryAnswerValue | null, questionPossibleAnswers: Array<{ __typename?: 'BinaryAnswer', binaryValue: BinaryAnswerValue, answerGuide?: string | null, points: number }>, score: { __typename?: 'Score', scorePoints: number, totalPoints: number, normalizedScore: number } } | { __typename?: 'RatingEvaluationQuestion', ID: string, feedback?: string | null, ratingAnswer?: RatingAnswerValue | null, score: { __typename?: 'Score', scorePoints: number, totalPoints: number, normalizedScore: number }, questionPossibleAnswers: Array<{ __typename?: 'RatingAnswer', ratingValue: RatingAnswerValue, answerGuide?: string | null, points: number }> }> }>, score: { __typename?: 'Score', scorePoints: number, totalPoints: number, normalizedScore: number } } | { __typename: 'GenericException', code: string, message: string } | { __typename: 'ResourceNotFoundException', code: string, message: string } | { __typename: 'UserInputException', code: string, message: string, issues: Array<{ __typename?: 'InvalidEnumException', code: string, message: string, options: Array<string>, path: string } | { __typename?: 'InvalidStringException', code: string, message: string, path: string, validation: string } | { __typename?: 'InvalidTypeException', code: string, expected: string, message: string, path: string, received: string } | { __typename?: 'TooBigException', code: string, maximum: number, message: string, path: string, type: string } | { __typename?: 'TooSmallException', code: string, message: string, minimum: number, path: string, type: string }> } };

export type CreateKeywordTrackerMutationVariables = Exact<{
  input: CreateKeywordTrackerInput;
}>;


export type CreateKeywordTrackerMutation = { __typename?: 'Mutation', createKeywordTracker: { __typename: 'CreatedKeywordTracker', tracker: { __typename?: 'Tracker', trackerId: number, title: string, filters?: { __typename?: 'KeywordTrackerFilter', direction?: CallDirection | null, queryTerms?: Array<string> | null, speakerType?: SpeakerTrackerType | null, lines?: Array<{ __typename?: 'LineTracker', lineId: number }> | null, agents?: Array<{ __typename?: 'AgentTracker', agentId: number }> | null } | null } } | { __typename: 'GenericException', code: string, message: string } | { __typename: 'InsufficientLicenseException' } | { __typename: 'InvalidTrackerName', code: string, message: string } | { __typename: 'TrackerKeywordLimitExceeded', code: string, message: string, positions: Array<number> } | { __typename: 'TrackerLimitExceeded', code: string, message: string } };

export type CreateNoteMutationVariables = Exact<{
  callId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
}>;


export type CreateNoteMutation = { __typename?: 'Mutation', createNote: { __typename?: 'NoteBase', id: string, callId: number, content: string, createdAt: string, userId: number } };

export type DeleteEvaluationMutationVariables = Exact<{
  callID: Scalars['ID']['input'];
}>;


export type DeleteEvaluationMutation = { __typename?: 'Mutation', deleteEvaluation: { __typename?: 'DeleteEvaluation', ID: string } | { __typename?: 'GenericException' } | { __typename?: 'ResourceNotFoundException' } | { __typename?: 'UserInputException' } };

export type DeleteNoteMutationVariables = Exact<{
  noteId: Scalars['ID']['input'];
}>;


export type DeleteNoteMutation = { __typename?: 'Mutation', deleteNote: { __typename?: 'NoteDeleted', id: string } };

export type GenerateAiAnswersMutationVariables = Exact<{
  input: GenerateAiAnswersInput;
}>;


export type GenerateAiAnswersMutation = { __typename?: 'Mutation', generateAIAnswers: boolean };

export type LinkTagsToCallMutationVariables = Exact<{
  input: LinkTagsToCallInput;
}>;


export type LinkTagsToCallMutation = { __typename?: 'Mutation', linkTagsToCall?: Array<{ __typename?: 'Tag', id: string } | null> | null };

export type SaveCustomSummaryResultMutationVariables = Exact<{
  input: SaveCustomSummaryResultInput;
}>;


export type SaveCustomSummaryResultMutation = { __typename?: 'Mutation', saveCustomSummaryResult: { __typename: 'CustomSummaryException', code: string, message: string } | { __typename: 'CustomSummaryResult', id: string, callId: string, callUuid: string, createdAt: string, customSummaryName: string, language: CustomSummaryLanguage, customSummary: { __typename?: 'CustomSummary', id: string, name: string, language: CustomSummaryLanguage, createdAt: string, updatedAt?: string | null, templates: Array<{ __typename?: 'SummaryTemplateEntry', orderPosition: number, template: { __typename?: 'SummaryTemplate', id: string, name: string, prompt: string, type: SummaryTemplateType, response?: { __typename?: 'OptionsResponse', options: Array<{ __typename?: 'OptionItem', description?: string | null, value: string }> } | { __typename?: 'ValidationResponse', validationOptions: Array<{ __typename?: 'ValidationItem', description?: string | null, value: ItemValidationValue }> } | null } }> }, templateResults: Array<{ __typename?: 'SummaryTemplateResult', id: string, aiGenerated: boolean, content: string, createdAt: string, summaryTemplateId: string, summaryTemplateName: string, type: SummaryTemplateType, updatedAt?: string | null }> } | { __typename: 'GenericException', code: string, message: string } | { __typename: 'InsufficientLicenseException', code: string, licenseName: string, message: string } | { __typename: 'UserInputException', code: string, message: string, issues: Array<{ __typename?: 'InvalidEnumException', code: string, message: string, options: Array<string>, path: string } | { __typename?: 'InvalidStringException', code: string, message: string, path: string, validation: string } | { __typename?: 'InvalidTypeException', code: string, expected: string, message: string, path: string, received: string } | { __typename?: 'TooBigException', code: string, maximum: number, message: string, path: string, type: string } | { __typename?: 'TooSmallException', code: string, message: string, minimum: number, path: string, type: string }> } };

export type SavePlaybookResultMutationVariables = Exact<{
  input: SavePlaybookResultInput;
}>;


export type SavePlaybookResultMutation = { __typename?: 'Mutation', savePlaybookResult: { __typename: 'GenericException', code: string, message: string } | { __typename: 'InsufficientLicenseException', code: string, licenseName: string, message: string } | { __typename: 'PlaybookException', code: string, message: string } | { __typename: 'PlaybookResult', callId: string, callUuid: string, id: string, language: PlaybookLanguage, name: string, adherenceScore?: number | null, topicResults: Array<{ __typename?: 'TopicResult', id: string, aiGenerated: boolean, name: string, language: PlaybookLanguage, createdAt: string, updatedAt?: string | null, content: { __typename?: 'TopicResultContent', id: string, responseType: CustomPlaybookResponseType, response: { __typename?: 'BooleanValue', booleanValue: boolean } | { __typename?: 'StringListValue' } | { __typename?: 'StringValue', stringValue: string }, responseOptions?: { __typename?: 'TopicResponseOption', id: string, value: string } | null } }> } | { __typename: 'UserInputException', code: string, message: string, issues: Array<{ __typename?: 'InvalidEnumException', code: string, message: string, options: Array<string>, path: string } | { __typename?: 'InvalidStringException', code: string, message: string, path: string, validation: string } | { __typename?: 'InvalidTypeException', code: string, expected: string, message: string, path: string, received: string } | { __typename?: 'TooBigException', code: string, maximum: number, message: string, path: string, type: string } | { __typename?: 'TooSmallException', code: string, message: string, minimum: number, path: string, type: string }> } };

export type UpdateEvaluationMutationVariables = Exact<{
  input: UpdateEvaluationInput;
}>;


export type UpdateEvaluationMutation = { __typename?: 'Mutation', updateEvaluation: { __typename: 'Evaluation', ID: string, feedback?: string | null, revieweeUserId: string, reviewerUserId: string, createdBy?: string | null, createdAt: string, updatedBy?: string | null, updatedAt?: string | null, categories: Array<{ __typename?: 'EvaluationCategory', ID: string, questions: Array<{ __typename?: 'BinaryEvaluationQuestion', ID: string, feedback?: string | null, binaryAnswer?: BinaryAnswerValue | null, score: { __typename?: 'Score', scorePoints: number, totalPoints: number, normalizedScore: number } } | { __typename?: 'RatingEvaluationQuestion', ID: string, feedback?: string | null, ratingAnswer?: RatingAnswerValue | null, score: { __typename?: 'Score', scorePoints: number, totalPoints: number, normalizedScore: number } }> }>, score: { __typename?: 'Score', scorePoints: number, totalPoints: number, normalizedScore: number } } | { __typename: 'GenericException', code: string, message: string } | { __typename: 'ResourceNotFoundException', code: string, message: string } | { __typename: 'UserInputException', code: string, message: string, issues: Array<{ __typename?: 'InvalidEnumException', code: string, message: string, options: Array<string>, path: string } | { __typename?: 'InvalidStringException', code: string, message: string, path: string, validation: string } | { __typename?: 'InvalidTypeException', code: string, expected: string, message: string, path: string, received: string } | { __typename?: 'TooBigException', code: string, maximum: number, message: string, path: string, type: string } | { __typename?: 'TooSmallException', code: string, message: string, minimum: number, path: string, type: string }> } };

export type UpdateNoteMutationVariables = Exact<{
  content: Scalars['String']['input'];
  noteId: Scalars['ID']['input'];
}>;


export type UpdateNoteMutation = { __typename?: 'Mutation', updateNote: { __typename?: 'NoteBase', id: string, content: string } };

export type DevCallConversationsQueryVariables = Exact<{
  token: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DevCallConversationsQuery = { __typename?: 'Query', getCallConversations?: { __typename?: 'PaginatedCallConversations', items: Array<{ __typename?: 'CallConversation', callId: number, type: string, startTime: string, durationInSeconds: number, predictedCsatScore?: number | null, line?: { __typename?: 'Line', ID: string, name: string, countryISOCode: string, phoneNumber: string, language?: string | null } | null, agents: Array<{ __typename?: 'ConversationAgent', agentDetails?: { __typename?: 'AgentDetails', agentId: string } | null, teammate: { __typename?: 'PhoneTeammateResolver', entity: { __typename: 'PhoneTeammate', ID: string, fullName: string } | { __typename: 'ResourceNotFoundException' } } } | null>, virtualAgents: Array<{ __typename?: 'ConversationVirtualAgent', virtualAgent?: { __typename?: 'VirtualAgentResolver', entity?: { __typename: 'ConflictException' } | { __typename: 'GenericException' } | { __typename: 'UserInputException' } | { __typename: 'VirtualAgent', ID: string, personality: { __typename?: 'VirtualAgentPersonality', name: string } } | null } | null } | null>, contacts: Array<{ __typename?: 'ConversationContact', phoneNumber: string, external: { __typename?: 'PhoneContactResolver', entity: { __typename: 'ExternalNumber', phoneNumber: string } | { __typename: 'PhoneContact', fullName: string, mainPhoneNumber: string, companyName?: string | null } } } | null>, sentiment?: { __typename?: 'SentimentScope', overall?: { __typename?: 'SentimentScopeOverall', customer?: SentimentValue | null } | null } | null, transcription?: { __typename?: 'CallTranscription', status: string } | { __typename?: 'VoicemailTranscription', status: string } | null, transcriptionScope?: { __typename?: 'TranscriptionScope', totalItems: number } | null }>, pageInfo: { __typename?: 'PagingInfo', total: number, nextToken?: string | null } } | null };

export type FeaturesFlagsQueryVariables = Exact<{
  names?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type FeaturesFlagsQuery = { __typename?: 'Query', getFeatureFlags: Array<{ __typename?: 'FeatureFlag', name: string, isEnabled: boolean }> };

export type GetAudioQueryVariables = Exact<{
  callId: Scalars['ID']['input'];
  callType: AudioType;
}>;


export type GetAudioQuery = { __typename?: 'Query', getAudio?: { __typename?: 'CallAudio', url?: string | null } | { __typename: 'GenericException', code: string, message: string } | { __typename?: 'InsufficientPermissionException', access: PermissionAccess, code: string, message: string } | null };

export type GetCallQueryVariables = Exact<{
  callId: Scalars['ID']['input'];
  skipSentiments: Scalars['Boolean']['input'];
  skipPredictedCsat: Scalars['Boolean']['input'];
}>;


export type GetCallQuery = { __typename?: 'Query', getCall?: { __typename?: 'BasicCall', automaticCallbackCallId?: string | null, callbackRequestTimestamp?: string | null, callUuid: string, callId: string, answeredAt?: string | null, createdAt: string, durationInSecond?: number | null, direction?: CallDirection | null, type?: CallType | null, from?: { __typename: 'AgentParticipant', number: string, teammate: { __typename?: 'PhoneTeammateResolver', entity: { __typename?: 'PhoneTeammate', ID: string, fullName: string, email: string } | { __typename: 'ResourceNotFoundException', code: string, message: string } } } | { __typename: 'ExternalParticipant', number: string, external: { __typename?: 'PhoneContactResolver', entity: { __typename?: 'ExternalNumber', phoneNumber: string } | { __typename?: 'PhoneContact', fullName: string, mainPhoneNumber: string, companyName?: string | null } } } | null, to?: { __typename: 'AgentParticipant', number: string, teammate: { __typename?: 'PhoneTeammateResolver', entity: { __typename?: 'PhoneTeammate', ID: string, fullName: string, email: string } | { __typename: 'ResourceNotFoundException', code: string, message: string } } } | { __typename: 'ExternalParticipant', number: string, external: { __typename?: 'PhoneContactResolver', entity: { __typename?: 'ExternalNumber', phoneNumber: string } | { __typename?: 'PhoneContact', fullName: string, mainPhoneNumber: string, companyName?: string | null } } } | null, transcription?: { __typename: 'CallTranscription', status: string, transcriptionId: string, mode: TranscriptionMode, wordsCount?: number | null, content?: { __typename?: 'TranscriptionContent', speakers?: Array<{ __typename?: 'AgentSpeaker', channel: number, agentID: number, teammate: { __typename?: 'PhoneTeammateResolver', entity: { __typename: 'PhoneTeammate', fullName: string, ID: string } | { __typename: 'ResourceNotFoundException', code: string, message: string } } } | { __typename?: 'ExternalSpeaker', number: string, channel: number, external: { __typename?: 'PhoneContactResolver', entity: { __typename?: 'ExternalNumber' } | { __typename?: 'PhoneContact', companyName?: string | null, mainPhoneNumber: string, fullName: string } } } | { __typename: 'VirtualAgentSpeaker', channel: number, virtualAgent: { __typename?: 'VirtualAgentResolver', entity?: { __typename?: 'ConflictException' } | { __typename?: 'GenericException' } | { __typename?: 'UserInputException' } | { __typename: 'VirtualAgent', ID: string, personality: { __typename?: 'VirtualAgentPersonality', name: string } } | null } } | null> | null, utterances?: Array<{ __typename?: 'Utterance', channel: number, startTime: number, endTime: number, entries: Array<{ __typename?: 'Entry', W: string, S: number }> } | null> | null } | null, insights?: { __typename?: 'TranscriptionInsights', nextActions?: { __typename?: 'NextActionsInsights', actions: Array<{ __typename?: 'NextAction', ID: string, content: string } | null> } | null, summary?: { __typename?: 'SummaryInsight', createdAt: string, content?: { __typename?: 'SummaryContent', summary: string } | null } | null, topics?: { __typename?: 'TopicsInsight', createdAt: string, content?: { __typename?: 'TopicsContent', topics?: Array<string | null> | null } | null } | null, sentiments?: { __typename?: 'SentimentInsights', overall?: Array<{ __typename?: 'OverallSentiment', type: SentimentType, value: SentimentValue } | null> | null, customers?: { __typename?: 'CustomersUtterances', utterances?: Array<{ __typename?: 'UtteranceSentiment', value: SentimentValue, index: number } | null> | null } | null } | null, predictedCsat?: { __typename?: 'PredictedCsat', score: number, computedAt: string, drivers: Array<{ __typename?: 'PredictedCsatDriver', label: string, polarity: PredictedCsatDriverPolarity }> } | null } | null } | { __typename: 'VoicemailTranscription', status: string, transcriptionId: string, wordsCount?: number | null, content?: { __typename?: 'TranscriptionContent', utterances?: Array<{ __typename?: 'Utterance', channel: number, startTime: number, endTime: number, entries: Array<{ __typename?: 'Entry', W: string, S: number }> } | null> | null } | null } | null } | null };

export type GetCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyQuery = { __typename?: 'Query', getCompany: { __typename?: 'Company', ID: string, tags?: Array<{ __typename?: 'Tag', color: string, description?: string | null, id: string, name: string } | null> | null } };

export type GetCurrentCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentCompanyQuery = { __typename?: 'Query', getCompany: { __typename?: 'Company', ID: string, plan: string, name: string, createdAt: string, lastTimePlanChanged?: string | null, provider: string, tierLevel: string, trial?: { __typename?: 'CompanyTrial', callTotalSeconds?: number | null, hasTrialCallLimits: boolean, trialEnd: string } | null } };

export type GetCurrentCompanyBillingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentCompanyBillingQuery = { __typename?: 'Query', currentCompanyBilling: { __typename?: 'RestCompanyBilling', billingPeriod: string, address?: { __typename?: 'RestCompanyAddress', line?: string | null, zip?: string | null, city?: string | null, state?: string | null, country?: string | null } | null } };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', getAgentV2: { __typename?: 'AgentV2', ID: string, firstName: string, lastName: string, companyID: number, language?: string | null, fullName: string, email: string, role: AgentRole, createdAt?: string | null, roles: Array<{ __typename?: 'Role', name: string }> } };

export type GetCustomSummaryResultsQueryVariables = Exact<{
  input?: InputMaybe<GetCustomSummaryResultsInput>;
}>;


export type GetCustomSummaryResultsQuery = { __typename?: 'Query', getCustomSummaryResults: { __typename: 'GenericException', code: string, message: string } | { __typename: 'GetCustomSummaryResultsResult', items: Array<{ __typename: 'CustomSummaryResult', id: string, callId: string, callUuid: string, createdAt: string, customSummaryName: string, language: CustomSummaryLanguage, customSummary: { __typename?: 'CustomSummary', id: string, name: string, language: CustomSummaryLanguage, createdAt: string, updatedAt?: string | null, templates: Array<{ __typename?: 'SummaryTemplateEntry', orderPosition: number, template: { __typename?: 'SummaryTemplate', id: string, name: string, prompt: string, type: SummaryTemplateType, response?: { __typename?: 'OptionsResponse', options: Array<{ __typename?: 'OptionItem', description?: string | null, value: string }> } | { __typename?: 'ValidationResponse', validationOptions: Array<{ __typename?: 'ValidationItem', description?: string | null, value: ItemValidationValue }> } | null } }> }, templateResults: Array<{ __typename?: 'SummaryTemplateResult', id: string, aiGenerated: boolean, content: string, createdAt: string, summaryTemplateId: string, summaryTemplateName: string, type: SummaryTemplateType, updatedAt?: string | null }> }>, pageInfo: { __typename?: 'PagingInfo', currentToken: string, limit: number, nextToken?: string | null, previousToken?: string | null, total: number } } | { __typename: 'UserInputException', code: string, message: string, issues: Array<{ __typename?: 'InvalidEnumException', code: string, message: string, options: Array<string>, path: string } | { __typename?: 'InvalidStringException', code: string, message: string, path: string, validation: string } | { __typename?: 'InvalidTypeException', code: string, expected: string, message: string, path: string, received: string } | { __typename?: 'TooBigException', code: string, maximum: number, message: string, path: string, type: string } | { __typename?: 'TooSmallException', code: string, message: string, minimum: number, path: string, type: string }> } };

export type GetEvaluationsQueryVariables = Exact<{
  filters: GetEvaluationsFilter;
}>;


export type GetEvaluationsQuery = { __typename?: 'Query', getEvaluations: { __typename: 'GenericException', code: string, message: string } | { __typename: 'PaginatedEvaluations', items: Array<{ __typename?: 'Evaluation', ID: string, callId: string, feedback?: string | null, createdAt: string, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null, scoreCardId: string, scoreCardName: string, scoreCardLanguage: string, scoreCardDescription: string, isGeneratedByAI: boolean, revieweeUserId: string, reviewerUserId: string, score: { __typename?: 'Score', scorePoints: number, totalPoints: number, normalizedScore: number }, reviewerTeammate?: { __typename?: 'PhoneTeammateResolver', entity: { __typename?: 'PhoneTeammate', fullName: string } | { __typename?: 'ResourceNotFoundException' } } | null, categories: Array<{ __typename?: 'EvaluationCategory', ID: string, categoryName: string, categoryOrder: number, scoreCardCategoryId: string, questions: Array<{ __typename: 'BinaryEvaluationQuestion', ID: string, feedback?: string | null, binaryAnswer?: BinaryAnswerValue | null, questionText: string, questionOrder: number, questionAiEnabled: boolean, scoreCardQuestionId?: string | null, score: { __typename?: 'Score', scorePoints: number, totalPoints: number, normalizedScore: number }, questionPossibleAnswers: Array<{ __typename: 'BinaryAnswer', binaryValue: BinaryAnswerValue, answerGuide?: string | null, points: number }> } | { __typename: 'RatingEvaluationQuestion', ID: string, feedback?: string | null, ratingAnswer?: RatingAnswerValue | null, questionText: string, questionOrder: number, questionAiEnabled: boolean, scoreCardQuestionId?: string | null, score: { __typename?: 'Score', scorePoints: number, totalPoints: number, normalizedScore: number }, questionPossibleAnswers: Array<{ __typename: 'RatingAnswer', ratingValue: RatingAnswerValue, answerGuide?: string | null, points: number }> }> }> }>, pageInfo: { __typename?: 'PagingInfo', total: number } } | { __typename: 'UserInputException', code: string, message: string, issues: Array<{ __typename?: 'InvalidEnumException', code: string, message: string, options: Array<string>, path: string } | { __typename?: 'InvalidStringException', code: string, message: string, path: string, validation: string } | { __typename?: 'InvalidTypeException', code: string, expected: string, message: string, path: string, received: string } | { __typename?: 'TooBigException', code: string, maximum: number, message: string, path: string, type: string } | { __typename?: 'TooSmallException', code: string, message: string, minimum: number, path: string, type: string }> } };

export type GetIntegrationsQueryVariables = Exact<{
  numberID?: InputMaybe<Scalars['Int']['input']>;
  requireUpdate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetIntegrationsQuery = { __typename?: 'Query', getIntegrations: Array<{ __typename?: 'Integration', id: string, name: string, application?: { __typename?: 'Application', id?: string | null, name: string } | null }> };

export type GetLineQueryVariables = Exact<{
  filter: SearchableLinesFilterInput;
}>;


export type GetLineQuery = { __typename?: 'Query', searchAuthorizedLines?: { __typename?: 'SearchableLinesConnection', items?: Array<{ __typename?: 'Line', ID: string, name: string, countryISOCode: string, language?: string | null, phoneNumber: string }> | null } | null };

export type GetLineTranscriptionsSettingsQueryVariables = Exact<{
  lineId: Scalars['Int']['input'];
}>;


export type GetLineTranscriptionsSettingsQuery = { __typename?: 'Query', getLineTranscriptionsSettings?: { __typename?: 'LineTranscriptionSettings', lineId: number, lineLanguage: string, calls?: { __typename?: 'CallTranscriptionSettings', isEnabled: boolean, reason?: TranscriptionSettingsReason | null } | null, voicemails?: { __typename?: 'VoicemailTranscriptionSettings', isEnabled: boolean, reason?: TranscriptionSettingsReason | null } | null } | null };

export type GetPlaybookResultsQueryVariables = Exact<{
  input: GetPlaybookResultsInput;
}>;


export type GetPlaybookResultsQuery = { __typename?: 'Query', getPlaybookResults: { __typename: 'GenericException', code: string, message: string } | { __typename?: 'GetPlaybookResultsResult', items: Array<{ __typename?: 'PlaybookResult', callId: string, callUuid: string, id: string, language: PlaybookLanguage, name: string, adherenceScore?: number | null, topicResults: Array<{ __typename?: 'TopicResult', id: string, aiGenerated: boolean, name: string, language: PlaybookLanguage, createdAt: string, updatedAt?: string | null, content: { __typename?: 'TopicResultContent', id: string, responseType: CustomPlaybookResponseType, response: { __typename?: 'BooleanValue', booleanValue: boolean } | { __typename?: 'StringListValue' } | { __typename?: 'StringValue', stringValue: string }, responseOptions?: { __typename?: 'TopicResponseOption', id: string, value: string } | null } }> }> } | { __typename: 'UserInputException', code: string, message: string, issues: Array<{ __typename?: 'InvalidEnumException', code: string, message: string, options: Array<string>, path: string } | { __typename?: 'InvalidStringException', code: string, message: string, path: string, validation: string } | { __typename?: 'InvalidTypeException', code: string, expected: string, message: string, path: string, received: string } | { __typename?: 'TooBigException', code: string, maximum: number, message: string, path: string, type: string } | { __typename?: 'TooSmallException', code: string, message: string, minimum: number, path: string, type: string }> } };

export type GetTagsAndNotesQueryVariables = Exact<{
  callId: Scalars['ID']['input'];
}>;


export type GetTagsAndNotesQuery = { __typename?: 'Query', getTagsAndNotes?: { __typename: 'TagsAndNotes', notes: Array<{ __typename?: 'NoteAgentDetail', callId: number, companyId: number, content: string, createdAt: string, firstName?: string | null, id: string, lastName?: string | null, userId?: number | null } | null>, tags: Array<{ __typename?: 'Tag', id: string, name: string, description?: string | null, color: string } | null> } | null };

export type LineIdQueryVariables = Exact<{
  callId: Scalars['ID']['input'];
}>;


export type LineIdQuery = { __typename?: 'Query', getCall?: { __typename: 'BasicCall', callId: string, lineId?: number | null } | null };

export type GetScorecardsQueryVariables = Exact<{
  filter: GetScoreCardsFilter;
}>;


export type GetScorecardsQuery = { __typename?: 'Query', getScorecards: { __typename: 'GenericException', code: string, message: string } | { __typename?: 'InsufficientLicenseException' } | { __typename: 'PaginatedScoreCards', items: Array<{ __typename?: 'ScoreCard', ID: string, createdAt: string, createdBy: string, description: string, isPublished: boolean, language: string, name: string, updatedAt?: string | null, updatedBy?: string | null, categories: Array<{ __typename?: 'ScoreCardCategory', ID: string, name: string, order: number, questions: Array<{ __typename: 'ScoreCardBinaryQuestion', ID: string, order: number, text: string, isAIEnabled: boolean, totalPoints: number, predefinedAIQuestionId?: string | null, strictness?: number | null, possibleBinaryAnswers: Array<{ __typename: 'BinaryAnswer', binaryValue: BinaryAnswerValue, answerGuide?: string | null, points: number }> } | { __typename: 'ScoreCardRatingQuestion', ID: string, isAIEnabled: boolean, order: number, text: string, totalPoints: number, predefinedAIQuestionId?: string | null, strictness?: number | null, possibleRatingAnswers: Array<{ __typename: 'RatingAnswer', ratingValue: RatingAnswerValue, answerGuide?: string | null, points: number }> }> }> }>, pageInfo: { __typename?: 'PagingInfo', total: number } } | { __typename: 'UserInputException', code: string, message: string, issues: Array<{ __typename?: 'InvalidEnumException', code: string, message: string, options: Array<string>, path: string } | { __typename?: 'InvalidStringException', code: string, message: string, path: string, validation: string } | { __typename?: 'InvalidTypeException', code: string, expected: string, message: string, path: string, received: string } | { __typename?: 'TooBigException', code: string, maximum: number, message: string, path: string, type: string } | { __typename?: 'TooSmallException', code: string, message: string, minimum: number, path: string, type: string }> } };

export type SearchConversationContentQueryVariables = Exact<{
  callIds?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>> | InputMaybe<Scalars['Float']['input']>>;
  transcriptionScope?: InputMaybe<TranscriptionScopeFilter>;
}>;


export type SearchConversationContentQuery = { __typename?: 'Query', getCallConversations?: { __typename?: 'PaginatedCallConversations', items: Array<{ __typename?: 'CallConversation', callId: number, transcriptionScope?: { __typename?: 'TranscriptionScope', totalItems: number, items: Array<{ __typename?: 'TranscriptionScopeItem', highlight: { __typename?: 'TranscriptionScopeHighlight', content: string, terms: Array<string | null> }, utterance: { __typename?: 'TranscriptionScopeUtterance', agentId?: number | null, startTime: number, phoneNumber?: string | null, index: number } } | null> } | null }> } | null };

export type SearchLineWithLanguageQueryVariables = Exact<{
  filter: SearchableLinesFilterInput;
  limit: Scalars['Int']['input'];
}>;


export type SearchLineWithLanguageQuery = { __typename?: 'Query', searchAuthorizedLines?: { __typename?: 'SearchableLinesConnection', items?: Array<{ __typename?: 'Line', ID: string, language?: string | null, countryISOCode: string }> | null } | null };

export type UserLicensesQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type UserLicensesQuery = { __typename?: 'Query', userLicenses?: { __typename?: 'UserLicensesOutput', licenses: Array<{ __typename?: 'UserLicense', active: boolean, name: string }> } | null };

export type OnAiAnswersGeneratedSubscriptionVariables = Exact<{
  transcriptionId: Scalars['ID']['input'];
}>;


export type OnAiAnswersGeneratedSubscription = { __typename?: 'Subscription', onAIAnswersGenerated?: { __typename?: 'AIAnswersGeneratedOutput', transcriptionId: string, data?: { __typename?: 'AIAnswersGeneratedOutputData', callId: string, categories: Array<{ __typename?: 'AIAnswerGeneratedCategoryOutput', categoryId: string, questions: Array<{ __typename?: 'AIAnswerGeneratedQuestionOutput', questionId: string, feedback: string, questionType: QuestionType, binaryAnswer?: BinaryAnswerValue | null, ratingAnswer?: RatingAnswerValue | null }> }> } | null, error?: { __typename?: 'AIAnswerGeneratedError', name: string } | null } | null };

export const CallAudioFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallAudio"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallAudio"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<CallAudioFragment, unknown>;
export const BaseExceptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exception"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<BaseExceptionFragment, unknown>;
export const AgentParticipantFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgentParticipant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AgentParticipant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"teammate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exception"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceNotFoundException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PhoneTeammate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exception"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<AgentParticipantFragment, unknown>;
export const ExternalParticipantFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalParticipant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalParticipant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"external"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PhoneContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"mainPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalNumber"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ExternalParticipantFragment, unknown>;
export const EntryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Entry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"W"}},{"kind":"Field","name":{"kind":"Name","value":"S"}}]}}]} as unknown as DocumentNode<EntryFragment, unknown>;
export const UtteranceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Utterance"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Utterance"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Entry"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Entry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"W"}},{"kind":"Field","name":{"kind":"Name","value":"S"}}]}}]} as unknown as DocumentNode<UtteranceFragment, unknown>;
export const VoicemailTranscriptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoicemailTranscription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VoicemailTranscription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"transcriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"utterances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Utterance"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"wordsCount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Entry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"W"}},{"kind":"Field","name":{"kind":"Name","value":"S"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Utterance"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Utterance"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Entry"}}]}}]}}]} as unknown as DocumentNode<VoicemailTranscriptionFragment, unknown>;
export const TranscriptionContentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranscriptionContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptionContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"speakers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AgentSpeaker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"agentID"}},{"kind":"Field","name":{"kind":"Name","value":"teammate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exception"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceNotFoundException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PhoneTeammate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"ID"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalSpeaker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"external"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PhoneContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"mainPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VirtualAgentSpeaker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"virtualAgent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VirtualAgent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"personality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"utterances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Utterance"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Entry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"W"}},{"kind":"Field","name":{"kind":"Name","value":"S"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exception"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Utterance"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Utterance"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Entry"}}]}}]}}]} as unknown as DocumentNode<TranscriptionContentFragment, unknown>;
export const NextActionItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NextActionItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NextAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]} as unknown as DocumentNode<NextActionItemFragment, unknown>;
export const UtteranceSentimentItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UtteranceSentimentItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UtteranceSentiment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"index"}}]}}]} as unknown as DocumentNode<UtteranceSentimentItemFragment, unknown>;
export const CallTranscriptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallTranscription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallTranscription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"transcriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranscriptionContent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wordsCount"}},{"kind":"Field","name":{"kind":"Name","value":"insights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nextActions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NextActionItem"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"topics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"topics"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sentiments"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipSentiments"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"overall"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"utterances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UtteranceSentimentItem"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"predictedCsat"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipPredictedCsat"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"drivers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"polarity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"computedAt"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exception"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Entry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"W"}},{"kind":"Field","name":{"kind":"Name","value":"S"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Utterance"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Utterance"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Entry"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranscriptionContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptionContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"speakers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AgentSpeaker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"agentID"}},{"kind":"Field","name":{"kind":"Name","value":"teammate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exception"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceNotFoundException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PhoneTeammate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"ID"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalSpeaker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"external"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PhoneContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"mainPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VirtualAgentSpeaker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"virtualAgent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VirtualAgent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"personality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"utterances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Utterance"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NextActionItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NextAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UtteranceSentimentItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UtteranceSentiment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"index"}}]}}]} as unknown as DocumentNode<CallTranscriptionFragment, unknown>;
export const CallDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BasicCall"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"automaticCallbackCallId"}},{"kind":"Field","name":{"kind":"Name","value":"callbackRequestTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"callUuid"}},{"kind":"Field","name":{"kind":"Name","value":"callId"}},{"kind":"Field","name":{"kind":"Name","value":"answeredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"durationInSecond"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgentParticipant"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalParticipant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgentParticipant"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalParticipant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transcription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoicemailTranscription"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallTranscription"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exception"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Entry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"W"}},{"kind":"Field","name":{"kind":"Name","value":"S"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Utterance"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Utterance"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Entry"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranscriptionContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptionContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"speakers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AgentSpeaker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"agentID"}},{"kind":"Field","name":{"kind":"Name","value":"teammate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exception"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceNotFoundException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PhoneTeammate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"ID"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalSpeaker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"external"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PhoneContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"mainPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VirtualAgentSpeaker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"virtualAgent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VirtualAgent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"personality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"utterances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Utterance"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NextActionItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NextAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UtteranceSentimentItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UtteranceSentiment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"index"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgentParticipant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AgentParticipant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"teammate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exception"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceNotFoundException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PhoneTeammate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalParticipant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalParticipant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"external"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PhoneContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"mainPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalNumber"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoicemailTranscription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VoicemailTranscription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"transcriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"utterances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Utterance"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"wordsCount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallTranscription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallTranscription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"transcriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranscriptionContent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wordsCount"}},{"kind":"Field","name":{"kind":"Name","value":"insights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nextActions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NextActionItem"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"topics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"topics"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sentiments"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipSentiments"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"overall"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"utterances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UtteranceSentimentItem"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"predictedCsat"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipPredictedCsat"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"drivers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"polarity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"computedAt"}}]}}]}}]}}]} as unknown as DocumentNode<CallDetailsFragment, unknown>;
export const OptionsResponseFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OptionsResponseFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OptionsResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<OptionsResponseFragmentFragment, unknown>;
export const ValidationResponseFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ValidationResponseFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"validationOptions"},"name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<ValidationResponseFragmentFragment, unknown>;
export const SummaryTemplateResultFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SummaryTemplateResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SummaryTemplateResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"aiGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"summaryTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"summaryTemplateName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<SummaryTemplateResultFragment, unknown>;
export const CustomSummaryResultFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomSummaryResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomSummaryResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"callId"}},{"kind":"Field","name":{"kind":"Name","value":"callUuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"customSummaryName"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"customSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"templates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderPosition"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"response"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OptionsResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"validationOptions"},"name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"templateResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SummaryTemplateResult"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SummaryTemplateResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SummaryTemplateResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"aiGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"summaryTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"summaryTemplateName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<CustomSummaryResultFragment, unknown>;
export const BinaryAnswerFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BinaryAnswer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BinaryAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"binaryValue"}},{"kind":"Field","name":{"kind":"Name","value":"answerGuide"}},{"kind":"Field","name":{"kind":"Name","value":"points"}}]}}]} as unknown as DocumentNode<BinaryAnswerFragment, unknown>;
export const RatingAnswerFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RatingAnswer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RatingAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"ratingValue"}},{"kind":"Field","name":{"kind":"Name","value":"answerGuide"}},{"kind":"Field","name":{"kind":"Name","value":"points"}}]}}]} as unknown as DocumentNode<RatingAnswerFragment, unknown>;
export const EvaluationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Evaluation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Evaluation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"callId"}},{"kind":"Field","name":{"kind":"Name","value":"score"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scorePoints"}},{"kind":"Field","name":{"kind":"Name","value":"totalPoints"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feedback"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"scoreCardId"}},{"kind":"Field","name":{"kind":"Name","value":"scoreCardName"}},{"kind":"Field","name":{"kind":"Name","value":"scoreCardLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"scoreCardDescription"}},{"kind":"Field","name":{"kind":"Name","value":"isGeneratedByAI"}},{"kind":"Field","name":{"kind":"Name","value":"revieweeUserId"}},{"kind":"Field","name":{"kind":"Name","value":"reviewerUserId"}},{"kind":"Field","name":{"kind":"Name","value":"reviewerTeammate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PhoneTeammate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"categoryName"}},{"kind":"Field","name":{"kind":"Name","value":"categoryOrder"}},{"kind":"Field","name":{"kind":"Name","value":"scoreCardCategoryId"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BinaryEvaluationQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"}},{"kind":"Field","name":{"kind":"Name","value":"binaryAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"questionText"}},{"kind":"Field","name":{"kind":"Name","value":"questionOrder"}},{"kind":"Field","name":{"kind":"Name","value":"questionAiEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"scoreCardQuestionId"}},{"kind":"Field","name":{"kind":"Name","value":"score"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scorePoints"}},{"kind":"Field","name":{"kind":"Name","value":"totalPoints"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionPossibleAnswers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BinaryAnswer"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RatingEvaluationQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"}},{"kind":"Field","name":{"kind":"Name","value":"ratingAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"questionText"}},{"kind":"Field","name":{"kind":"Name","value":"questionOrder"}},{"kind":"Field","name":{"kind":"Name","value":"questionAiEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"scoreCardQuestionId"}},{"kind":"Field","name":{"kind":"Name","value":"score"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scorePoints"}},{"kind":"Field","name":{"kind":"Name","value":"totalPoints"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionPossibleAnswers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RatingAnswer"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BinaryAnswer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BinaryAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"binaryValue"}},{"kind":"Field","name":{"kind":"Name","value":"answerGuide"}},{"kind":"Field","name":{"kind":"Name","value":"points"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RatingAnswer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RatingAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"ratingValue"}},{"kind":"Field","name":{"kind":"Name","value":"answerGuide"}},{"kind":"Field","name":{"kind":"Name","value":"points"}}]}}]} as unknown as DocumentNode<EvaluationFragment, unknown>;
export const ApplicationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Application"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Application"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<ApplicationFragment, unknown>;
export const IntegrationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Integration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Integration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"application"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<IntegrationFragment, unknown>;
export const LineDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Line"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"countryISOCode"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]} as unknown as DocumentNode<LineDetailsFragment, unknown>;
export const LineTranscriptionSettingsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineTranscriptionSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LineTranscriptionSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"lineLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"voicemails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}}]} as unknown as DocumentNode<LineTranscriptionSettingsFragment, unknown>;
export const OverallSentimentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OverallSentiment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OverallSentiment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<OverallSentimentFragment, unknown>;
export const TopicResultFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TopicResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TopicResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"aiGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"responseType"}},{"kind":"Field","name":{"kind":"Name","value":"response"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BooleanValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"booleanValue"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StringValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"stringValue"},"name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"responseOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<TopicResultFragment, unknown>;
export const PlaybookResultFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlaybookResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PlaybookResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callId"}},{"kind":"Field","name":{"kind":"Name","value":"callUuid"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adherenceScore"}},{"kind":"Field","name":{"kind":"Name","value":"topicResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TopicResult"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TopicResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TopicResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"aiGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"responseType"}},{"kind":"Field","name":{"kind":"Name","value":"response"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BooleanValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"booleanValue"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StringValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"stringValue"},"name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"responseOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<PlaybookResultFragment, unknown>;
export const ScoreCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScoreCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScoreCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScoreCardBinaryQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"isAIEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"totalPoints"}},{"kind":"Field","name":{"kind":"Name","value":"predefinedAIQuestionId"}},{"kind":"Field","alias":{"kind":"Name","value":"possibleBinaryAnswers"},"name":{"kind":"Name","value":"possibleAnswers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BinaryAnswer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"strictness"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScoreCardRatingQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"isAIEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"totalPoints"}},{"kind":"Field","name":{"kind":"Name","value":"predefinedAIQuestionId"}},{"kind":"Field","alias":{"kind":"Name","value":"possibleRatingAnswers"},"name":{"kind":"Name","value":"possibleAnswers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RatingAnswer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"strictness"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BinaryAnswer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BinaryAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"binaryValue"}},{"kind":"Field","name":{"kind":"Name","value":"answerGuide"}},{"kind":"Field","name":{"kind":"Name","value":"points"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RatingAnswer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RatingAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"ratingValue"}},{"kind":"Field","name":{"kind":"Name","value":"answerGuide"}},{"kind":"Field","name":{"kind":"Name","value":"points"}}]}}]} as unknown as DocumentNode<ScoreCardFragment, unknown>;
export const SearchLineDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchLineDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Line"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"countryISOCode"}}]}}]} as unknown as DocumentNode<SearchLineDetailsFragment, unknown>;
export const TagFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Tag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<TagFragment, unknown>;
export const TranscriptionScopeItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranscriptionScopeItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptionScopeItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"highlight"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"terms"}}]}},{"kind":"Field","name":{"kind":"Name","value":"utterance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agentId"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"index"}}]}}]}}]} as unknown as DocumentNode<TranscriptionScopeItemFragment, unknown>;
export const TranscriptionScopeDetailFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranscriptionScopeDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallConversation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transcriptionScope"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranscriptionScopeItem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalItems"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranscriptionScopeItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptionScopeItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"highlight"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"terms"}}]}},{"kind":"Field","name":{"kind":"Name","value":"utterance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agentId"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"index"}}]}}]}}]} as unknown as DocumentNode<TranscriptionScopeDetailFragment, unknown>;
export const InsufficientLicenseExceptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InsufficientLicenseException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InsufficientLicenseException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"licenseName"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<InsufficientLicenseExceptionFragment, unknown>;
export const InsufficientPermissionExceptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InsufficientPermissionException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InsufficientPermissionException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"access"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<InsufficientPermissionExceptionFragment, unknown>;
export const RateLimitExceededExceptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RateLimitExceededException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RateLimitExceededException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<RateLimitExceededExceptionFragment, unknown>;
export const TrackerKeywordLimitExceededFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TrackerKeywordLimitExceeded"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TrackerKeywordLimitExceeded"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"positions"}}]}}]} as unknown as DocumentNode<TrackerKeywordLimitExceededFragment, unknown>;
export const InvalidEnumExceptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidEnumException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidEnumException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"options"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]} as unknown as DocumentNode<InvalidEnumExceptionFragment, unknown>;
export const InvalidStringExceptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidStringException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidStringException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"validation"}}]}}]} as unknown as DocumentNode<InvalidStringExceptionFragment, unknown>;
export const InvalidTypeExceptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidTypeException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidTypeException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"expected"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"received"}}]}}]} as unknown as DocumentNode<InvalidTypeExceptionFragment, unknown>;
export const TooBigExceptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TooBigException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooBigException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"maximum"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<TooBigExceptionFragment, unknown>;
export const TooSmallExceptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TooSmallException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooSmallException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"minimum"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<TooSmallExceptionFragment, unknown>;
export const UserInputExceptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInputException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserInputException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidEnumException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidEnumException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidStringException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidStringException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidTypeException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidTypeException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooBigException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TooBigException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooSmallException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TooSmallException"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidEnumException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidEnumException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"options"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidStringException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidStringException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"validation"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidTypeException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidTypeException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"expected"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"received"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TooBigException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooBigException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"maximum"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TooSmallException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooSmallException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"minimum"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<UserInputExceptionFragment, unknown>;
export const CreateEvaluationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateEvaluation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateEvaluationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createEvaluation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceNotFoundException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserInputException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInputException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Evaluation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"scoreCardId"}},{"kind":"Field","name":{"kind":"Name","value":"scoreCardDescription"}},{"kind":"Field","name":{"kind":"Name","value":"scoreCardName"}},{"kind":"Field","name":{"kind":"Name","value":"scoreCardLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"}},{"kind":"Field","name":{"kind":"Name","value":"revieweeUserId"}},{"kind":"Field","name":{"kind":"Name","value":"reviewerUserId"}},{"kind":"Field","name":{"kind":"Name","value":"callId"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"scoreCardCategoryId"}},{"kind":"Field","name":{"kind":"Name","value":"categoryOrder"}},{"kind":"Field","name":{"kind":"Name","value":"categoryName"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BinaryEvaluationQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"questionOrder"}},{"kind":"Field","name":{"kind":"Name","value":"questionText"}},{"kind":"Field","name":{"kind":"Name","value":"questionAiEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"questionPossibleAnswers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"binaryValue"}},{"kind":"Field","name":{"kind":"Name","value":"answerGuide"}},{"kind":"Field","name":{"kind":"Name","value":"points"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scoreCardQuestionId"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"}},{"kind":"Field","name":{"kind":"Name","value":"binaryAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"score"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scorePoints"}},{"kind":"Field","name":{"kind":"Name","value":"totalPoints"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedScore"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RatingEvaluationQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"}},{"kind":"Field","name":{"kind":"Name","value":"ratingAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"score"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scorePoints"}},{"kind":"Field","name":{"kind":"Name","value":"totalPoints"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionPossibleAnswers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ratingValue"}},{"kind":"Field","name":{"kind":"Name","value":"answerGuide"}},{"kind":"Field","name":{"kind":"Name","value":"points"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"score"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scorePoints"}},{"kind":"Field","name":{"kind":"Name","value":"totalPoints"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidEnumException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidEnumException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"options"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidStringException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidStringException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"validation"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidTypeException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidTypeException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"expected"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"received"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TooBigException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooBigException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"maximum"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TooSmallException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooSmallException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"minimum"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exception"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInputException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserInputException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidEnumException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidEnumException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidStringException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidStringException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidTypeException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidTypeException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooBigException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TooBigException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooSmallException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TooSmallException"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<CreateEvaluationMutation, CreateEvaluationMutationVariables>;
export const CreateKeywordTrackerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateKeywordTracker"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateKeywordTrackerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createKeywordTracker"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidTrackerName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TrackerKeywordLimitExceeded"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrackerKeywordLimitExceeded"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TrackerLimitExceeded"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreatedKeywordTracker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tracker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trackerId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"filters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"KeywordTrackerFilter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agentId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"queryTerms"}},{"kind":"Field","name":{"kind":"Name","value":"speakerType"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exception"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TrackerKeywordLimitExceeded"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TrackerKeywordLimitExceeded"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"positions"}}]}}]} as unknown as DocumentNode<CreateKeywordTrackerMutation, CreateKeywordTrackerMutationVariables>;
export const CreateNoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateNote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"callId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"content"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createNote"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"callId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"callId"}}},{"kind":"Argument","name":{"kind":"Name","value":"content"},"value":{"kind":"Variable","name":{"kind":"Name","value":"content"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"callId"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<CreateNoteMutation, CreateNoteMutationVariables>;
export const DeleteEvaluationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteEvaluation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"callID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteEvaluation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"callID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"callID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteEvaluation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteEvaluationMutation, DeleteEvaluationMutationVariables>;
export const DeleteNoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteNote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"noteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteNote"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"noteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"noteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteNoteMutation, DeleteNoteMutationVariables>;
export const GenerateAiAnswersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateAIAnswers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GenerateAIAnswersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateAIAnswers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<GenerateAiAnswersMutation, GenerateAiAnswersMutationVariables>;
export const LinkTagsToCallDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LinkTagsToCall"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LinkTagsToCallInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkTagsToCall"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<LinkTagsToCallMutation, LinkTagsToCallMutationVariables>;
export const SaveCustomSummaryResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveCustomSummaryResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SaveCustomSummaryResultInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveCustomSummaryResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomSummaryResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomSummaryResult"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomSummaryException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserInputException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInputException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InsufficientLicenseException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InsufficientLicenseException"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SummaryTemplateResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SummaryTemplateResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"aiGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"summaryTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"summaryTemplateName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidEnumException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidEnumException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"options"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidStringException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidStringException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"validation"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidTypeException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidTypeException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"expected"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"received"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TooBigException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooBigException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"maximum"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TooSmallException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooSmallException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"minimum"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomSummaryResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomSummaryResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"callId"}},{"kind":"Field","name":{"kind":"Name","value":"callUuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"customSummaryName"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"customSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"templates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderPosition"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"response"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OptionsResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"validationOptions"},"name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"templateResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SummaryTemplateResult"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exception"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInputException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserInputException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidEnumException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidEnumException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidStringException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidStringException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidTypeException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidTypeException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooBigException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TooBigException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooSmallException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TooSmallException"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InsufficientLicenseException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InsufficientLicenseException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"licenseName"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<SaveCustomSummaryResultMutation, SaveCustomSummaryResultMutationVariables>;
export const SavePlaybookResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SavePlaybookResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SavePlaybookResultInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savePlaybookResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PlaybookResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlaybookResult"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PlaybookException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserInputException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInputException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InsufficientLicenseException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InsufficientLicenseException"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TopicResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TopicResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"aiGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"responseType"}},{"kind":"Field","name":{"kind":"Name","value":"response"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BooleanValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"booleanValue"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StringValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"stringValue"},"name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"responseOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidEnumException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidEnumException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"options"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidStringException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidStringException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"validation"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidTypeException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidTypeException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"expected"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"received"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TooBigException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooBigException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"maximum"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TooSmallException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooSmallException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"minimum"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlaybookResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PlaybookResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callId"}},{"kind":"Field","name":{"kind":"Name","value":"callUuid"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adherenceScore"}},{"kind":"Field","name":{"kind":"Name","value":"topicResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TopicResult"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exception"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInputException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserInputException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidEnumException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidEnumException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidStringException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidStringException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidTypeException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidTypeException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooBigException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TooBigException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooSmallException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TooSmallException"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InsufficientLicenseException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InsufficientLicenseException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"licenseName"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<SavePlaybookResultMutation, SavePlaybookResultMutationVariables>;
export const UpdateEvaluationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEvaluation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateEvaluationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEvaluation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceNotFoundException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserInputException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInputException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Evaluation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"}},{"kind":"Field","name":{"kind":"Name","value":"revieweeUserId"}},{"kind":"Field","name":{"kind":"Name","value":"reviewerUserId"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BinaryEvaluationQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"}},{"kind":"Field","name":{"kind":"Name","value":"binaryAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"score"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scorePoints"}},{"kind":"Field","name":{"kind":"Name","value":"totalPoints"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedScore"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RatingEvaluationQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"}},{"kind":"Field","name":{"kind":"Name","value":"ratingAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"score"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scorePoints"}},{"kind":"Field","name":{"kind":"Name","value":"totalPoints"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedScore"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"score"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scorePoints"}},{"kind":"Field","name":{"kind":"Name","value":"totalPoints"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidEnumException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidEnumException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"options"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidStringException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidStringException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"validation"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidTypeException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidTypeException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"expected"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"received"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TooBigException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooBigException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"maximum"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TooSmallException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooSmallException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"minimum"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exception"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInputException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserInputException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidEnumException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidEnumException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidStringException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidStringException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidTypeException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidTypeException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooBigException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TooBigException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooSmallException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TooSmallException"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<UpdateEvaluationMutation, UpdateEvaluationMutationVariables>;
export const UpdateNoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateNote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"content"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"noteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateNote"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"content"},"value":{"kind":"Variable","name":{"kind":"Name","value":"content"}}},{"kind":"Argument","name":{"kind":"Name","value":"noteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"noteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]} as unknown as DocumentNode<UpdateNoteMutation, UpdateNoteMutationVariables>;
export const DevCallConversationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DevCallConversations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCallConversations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"durationInSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"predictedCsatScore"}},{"kind":"Field","name":{"kind":"Name","value":"line"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"countryISOCode"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agentDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agentId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teammate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PhoneTeammate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"virtualAgents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"virtualAgent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VirtualAgent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"personality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"external"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PhoneContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"mainPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalNumber"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sentiment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"overall"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customer"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"transcription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallTranscription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VoicemailTranscription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"transcriptionScope"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalItems"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"nextToken"}}]}}]}}]}}]} as unknown as DocumentNode<DevCallConversationsQuery, DevCallConversationsQueryVariables>;
export const FeaturesFlagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FeaturesFlags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"names"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getFeatureFlags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"names"},"value":{"kind":"Variable","name":{"kind":"Name","value":"names"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}}]}}]}}]} as unknown as DocumentNode<FeaturesFlagsQuery, FeaturesFlagsQueryVariables>;
export const GetAudioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAudio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"callId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"callType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AudioType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAudio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"callId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"callId"}}},{"kind":"Argument","name":{"kind":"Name","value":"callType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"callType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallAudio"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseException"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InsufficientPermissionException"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallAudio"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallAudio"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exception"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InsufficientPermissionException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InsufficientPermissionException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"access"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<GetAudioQuery, GetAudioQueryVariables>;
export const GetCallDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCall"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"callId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipSentiments"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipPredictedCsat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCall"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"callId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"callId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exception"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgentParticipant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AgentParticipant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"teammate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exception"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceNotFoundException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PhoneTeammate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalParticipant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalParticipant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"external"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PhoneContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"mainPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalNumber"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Entry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"W"}},{"kind":"Field","name":{"kind":"Name","value":"S"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Utterance"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Utterance"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Entry"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoicemailTranscription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VoicemailTranscription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"transcriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"utterances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Utterance"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"wordsCount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranscriptionContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptionContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"speakers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AgentSpeaker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"agentID"}},{"kind":"Field","name":{"kind":"Name","value":"teammate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exception"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceNotFoundException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PhoneTeammate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"ID"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalSpeaker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"external"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PhoneContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"mainPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VirtualAgentSpeaker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"virtualAgent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VirtualAgent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"personality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"utterances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Utterance"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NextActionItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NextAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UtteranceSentimentItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UtteranceSentiment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"index"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallTranscription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallTranscription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"transcriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranscriptionContent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wordsCount"}},{"kind":"Field","name":{"kind":"Name","value":"insights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nextActions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NextActionItem"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"topics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"topics"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sentiments"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipSentiments"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"overall"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"utterances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UtteranceSentimentItem"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"predictedCsat"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipPredictedCsat"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"drivers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"polarity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"computedAt"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BasicCall"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"automaticCallbackCallId"}},{"kind":"Field","name":{"kind":"Name","value":"callbackRequestTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"callUuid"}},{"kind":"Field","name":{"kind":"Name","value":"callId"}},{"kind":"Field","name":{"kind":"Name","value":"answeredAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"durationInSecond"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgentParticipant"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalParticipant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgentParticipant"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalParticipant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transcription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoicemailTranscription"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallTranscription"}}]}}]}}]} as unknown as DocumentNode<GetCallQuery, GetCallQueryVariables>;
export const GetCompanyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompany"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCompany"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetCompanyQuery, GetCompanyQueryVariables>;
export const GetCurrentCompanyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentCompany"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCompany"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"plan"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastTimePlanChanged"}},{"kind":"Field","name":{"kind":"Name","value":"trial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callTotalSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"hasTrialCallLimits"}},{"kind":"Field","name":{"kind":"Name","value":"trialEnd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"tierLevel"}}]}}]}}]} as unknown as DocumentNode<GetCurrentCompanyQuery, GetCurrentCompanyQueryVariables>;
export const GetCurrentCompanyBillingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentCompanyBilling"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentCompanyBilling"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"rest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"RestCompanyBilling","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"company","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"endpoint"},"value":{"kind":"StringValue","value":"v3","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]} as unknown as DocumentNode<GetCurrentCompanyBillingQuery, GetCurrentCompanyBillingQueryVariables>;
export const GetCurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAgentV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"companyID"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const GetCustomSummaryResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCustomSummaryResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GetCustomSummaryResultsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCustomSummaryResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GetCustomSummaryResultsResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomSummaryResult"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentToken"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"nextToken"}},{"kind":"Field","name":{"kind":"Name","value":"previousToken"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserInputException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInputException"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SummaryTemplateResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SummaryTemplateResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"aiGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"summaryTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"summaryTemplateName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidEnumException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidEnumException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"options"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidStringException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidStringException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"validation"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidTypeException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidTypeException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"expected"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"received"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TooBigException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooBigException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"maximum"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TooSmallException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooSmallException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"minimum"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomSummaryResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomSummaryResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"callId"}},{"kind":"Field","name":{"kind":"Name","value":"callUuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"customSummaryName"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"customSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"templates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderPosition"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"response"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OptionsResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"validationOptions"},"name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"templateResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SummaryTemplateResult"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exception"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInputException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserInputException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidEnumException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidEnumException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidStringException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidStringException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidTypeException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidTypeException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooBigException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TooBigException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooSmallException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TooSmallException"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<GetCustomSummaryResultsQuery, GetCustomSummaryResultsQueryVariables>;
export const GetEvaluationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEvaluations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetEvaluationsFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEvaluations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserInputException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInputException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaginatedEvaluations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Evaluation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidEnumException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidEnumException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"options"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidStringException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidStringException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"validation"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidTypeException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidTypeException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"expected"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"received"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TooBigException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooBigException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"maximum"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TooSmallException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooSmallException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"minimum"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BinaryAnswer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BinaryAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"binaryValue"}},{"kind":"Field","name":{"kind":"Name","value":"answerGuide"}},{"kind":"Field","name":{"kind":"Name","value":"points"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RatingAnswer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RatingAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"ratingValue"}},{"kind":"Field","name":{"kind":"Name","value":"answerGuide"}},{"kind":"Field","name":{"kind":"Name","value":"points"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exception"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInputException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserInputException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidEnumException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidEnumException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidStringException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidStringException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidTypeException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidTypeException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooBigException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TooBigException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooSmallException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TooSmallException"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Evaluation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Evaluation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"callId"}},{"kind":"Field","name":{"kind":"Name","value":"score"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scorePoints"}},{"kind":"Field","name":{"kind":"Name","value":"totalPoints"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feedback"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"scoreCardId"}},{"kind":"Field","name":{"kind":"Name","value":"scoreCardName"}},{"kind":"Field","name":{"kind":"Name","value":"scoreCardLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"scoreCardDescription"}},{"kind":"Field","name":{"kind":"Name","value":"isGeneratedByAI"}},{"kind":"Field","name":{"kind":"Name","value":"revieweeUserId"}},{"kind":"Field","name":{"kind":"Name","value":"reviewerUserId"}},{"kind":"Field","name":{"kind":"Name","value":"reviewerTeammate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PhoneTeammate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"categoryName"}},{"kind":"Field","name":{"kind":"Name","value":"categoryOrder"}},{"kind":"Field","name":{"kind":"Name","value":"scoreCardCategoryId"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BinaryEvaluationQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"}},{"kind":"Field","name":{"kind":"Name","value":"binaryAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"questionText"}},{"kind":"Field","name":{"kind":"Name","value":"questionOrder"}},{"kind":"Field","name":{"kind":"Name","value":"questionAiEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"scoreCardQuestionId"}},{"kind":"Field","name":{"kind":"Name","value":"score"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scorePoints"}},{"kind":"Field","name":{"kind":"Name","value":"totalPoints"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionPossibleAnswers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BinaryAnswer"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RatingEvaluationQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"}},{"kind":"Field","name":{"kind":"Name","value":"ratingAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"questionText"}},{"kind":"Field","name":{"kind":"Name","value":"questionOrder"}},{"kind":"Field","name":{"kind":"Name","value":"questionAiEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"scoreCardQuestionId"}},{"kind":"Field","name":{"kind":"Name","value":"score"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scorePoints"}},{"kind":"Field","name":{"kind":"Name","value":"totalPoints"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedScore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"questionPossibleAnswers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RatingAnswer"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetEvaluationsQuery, GetEvaluationsQueryVariables>;
export const GetIntegrationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetIntegrations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"numberID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requireUpdate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getIntegrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"numberID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"numberID"}}},{"kind":"Argument","name":{"kind":"Name","value":"requireUpdate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requireUpdate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Integration"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Integration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Integration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"application"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetIntegrationsQuery, GetIntegrationsQueryVariables>;
export const GetLineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLine"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchableLinesFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchAuthorizedLines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LineDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Line"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"countryISOCode"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]} as unknown as DocumentNode<GetLineQuery, GetLineQueryVariables>;
export const GetLineTranscriptionsSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLineTranscriptionsSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLineTranscriptionsSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lineId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"lineLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voicemails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}}]}}]} as unknown as DocumentNode<GetLineTranscriptionsSettingsQuery, GetLineTranscriptionsSettingsQueryVariables>;
export const GetPlaybookResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlaybookResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetPlaybookResultsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPlaybookResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GetPlaybookResultsResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlaybookResult"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserInputException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInputException"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TopicResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TopicResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"aiGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"responseType"}},{"kind":"Field","name":{"kind":"Name","value":"response"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BooleanValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"booleanValue"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StringValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"stringValue"},"name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"responseOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidEnumException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidEnumException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"options"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidStringException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidStringException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"validation"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidTypeException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidTypeException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"expected"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"received"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TooBigException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooBigException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"maximum"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TooSmallException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooSmallException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"minimum"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlaybookResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PlaybookResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callId"}},{"kind":"Field","name":{"kind":"Name","value":"callUuid"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"adherenceScore"}},{"kind":"Field","name":{"kind":"Name","value":"topicResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TopicResult"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exception"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInputException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserInputException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidEnumException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidEnumException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidStringException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidStringException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidTypeException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidTypeException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooBigException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TooBigException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooSmallException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TooSmallException"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<GetPlaybookResultsQuery, GetPlaybookResultsQueryVariables>;
export const GetTagsAndNotesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTagsAndNotes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"callId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTagsAndNotes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"callId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"callId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Tag"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Tag"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]} as unknown as DocumentNode<GetTagsAndNotesQuery, GetTagsAndNotesQueryVariables>;
export const LineIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LineId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"callId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCall"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"callId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"callId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BasicCall"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callId"}},{"kind":"Field","name":{"kind":"Name","value":"lineId"}}]}}]}}]}}]} as unknown as DocumentNode<LineIdQuery, LineIdQueryVariables>;
export const GetScorecardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetScorecards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetScoreCardsFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getScorecards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaginatedScoreCards"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScoreCard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GenericException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserInputException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInputException"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BinaryAnswer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BinaryAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"binaryValue"}},{"kind":"Field","name":{"kind":"Name","value":"answerGuide"}},{"kind":"Field","name":{"kind":"Name","value":"points"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RatingAnswer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RatingAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"ratingValue"}},{"kind":"Field","name":{"kind":"Name","value":"answerGuide"}},{"kind":"Field","name":{"kind":"Name","value":"points"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidEnumException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidEnumException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"options"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidStringException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidStringException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"validation"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidTypeException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidTypeException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"expected"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"received"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TooBigException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooBigException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"maximum"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TooSmallException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooSmallException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"minimum"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScoreCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScoreCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScoreCardBinaryQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"isAIEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"totalPoints"}},{"kind":"Field","name":{"kind":"Name","value":"predefinedAIQuestionId"}},{"kind":"Field","alias":{"kind":"Name","value":"possibleBinaryAnswers"},"name":{"kind":"Name","value":"possibleAnswers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BinaryAnswer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"strictness"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScoreCardRatingQuestion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"isAIEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"totalPoints"}},{"kind":"Field","name":{"kind":"Name","value":"predefinedAIQuestionId"}},{"kind":"Field","alias":{"kind":"Name","value":"possibleRatingAnswers"},"name":{"kind":"Name","value":"possibleAnswers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RatingAnswer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"strictness"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Exception"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInputException"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserInputException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidEnumException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidEnumException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidStringException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidStringException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidTypeException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidTypeException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooBigException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TooBigException"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TooSmallException"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TooSmallException"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]} as unknown as DocumentNode<GetScorecardsQuery, GetScorecardsQueryVariables>;
export const SearchConversationContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchConversationContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"callIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transcriptionScope"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptionScopeFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCallConversations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"callIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"callIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"transcriptionScope"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transcriptionScope"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranscriptionScopeDetail"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranscriptionScopeItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TranscriptionScopeItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"highlight"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"terms"}}]}},{"kind":"Field","name":{"kind":"Name","value":"utterance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agentId"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"index"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TranscriptionScopeDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallConversation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transcriptionScope"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TranscriptionScopeItem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalItems"}}]}}]}}]} as unknown as DocumentNode<SearchConversationContentQuery, SearchConversationContentQueryVariables>;
export const SearchLineWithLanguageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchLineWithLanguage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchableLinesFilterInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchAuthorizedLines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SearchLineDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchLineDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Line"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"countryISOCode"}}]}}]} as unknown as DocumentNode<SearchLineWithLanguageQuery, SearchLineWithLanguageQueryVariables>;
export const UserLicensesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserLicenses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userLicenses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"licenses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UserLicensesQuery, UserLicensesQueryVariables>;
export const OnAiAnswersGeneratedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OnAIAnswersGenerated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transcriptionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onAIAnswersGenerated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"transcriptionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transcriptionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transcriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callId"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"questionId"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"}},{"kind":"Field","name":{"kind":"Name","value":"questionType"}},{"kind":"Field","name":{"kind":"Name","value":"binaryAnswer"}},{"kind":"Field","name":{"kind":"Name","value":"ratingAnswer"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<OnAiAnswersGeneratedSubscription, OnAiAnswersGeneratedSubscriptionVariables>;